
var Module = (function() {
  var _scriptDir = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : undefined;
  
  return (
function(Module) {
  Module = Module || {};



// The Module object: Our interface to the outside world. We import
// and export values on it. There are various ways Module can be used:
// 1. Not defined. We create it here
// 2. A function parameter, function(Module) { ..generated code.. }
// 3. pre-run appended it, var Module = {}; ..generated code..
// 4. External script tag defines var Module.
// We need to check if Module already exists (e.g. case 3 above).
// Substitution will be replaced with actual code on later stage of the build,
// this way Closure Compiler will not mangle it (e.g. case 4. above).
// Note that if you want to run closure, and also to use Module
// after the generated code, you will need to define   var Module = {};
// before the code. Then that object will be used in the code, and you
// can continue to use Module afterwards as well.
var Module = typeof Module !== 'undefined' ? Module : {};


// Set up the promise that indicates the Module is initialized
var readyPromiseResolve, readyPromiseReject;
Module['ready'] = new Promise(function(resolve, reject) {
  readyPromiseResolve = resolve;
  readyPromiseReject = reject;
});

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '_main')) {
        Object.defineProperty(Module['ready'], '_main', { configurable: true, get: function() { abort('You are getting _main on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '_main', { configurable: true, set: function() { abort('You are setting _main on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '_malloc')) {
        Object.defineProperty(Module['ready'], '_malloc', { configurable: true, get: function() { abort('You are getting _malloc on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '_malloc', { configurable: true, set: function() { abort('You are setting _malloc on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '_free')) {
        Object.defineProperty(Module['ready'], '_free', { configurable: true, get: function() { abort('You are getting _free on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '_free', { configurable: true, set: function() { abort('You are setting _free on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '_stackSave')) {
        Object.defineProperty(Module['ready'], '_stackSave', { configurable: true, get: function() { abort('You are getting _stackSave on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '_stackSave', { configurable: true, set: function() { abort('You are setting _stackSave on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '_stackRestore')) {
        Object.defineProperty(Module['ready'], '_stackRestore', { configurable: true, get: function() { abort('You are getting _stackRestore on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '_stackRestore', { configurable: true, set: function() { abort('You are setting _stackRestore on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '_stackAlloc')) {
        Object.defineProperty(Module['ready'], '_stackAlloc', { configurable: true, get: function() { abort('You are getting _stackAlloc on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '_stackAlloc', { configurable: true, set: function() { abort('You are setting _stackAlloc on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '___data_end')) {
        Object.defineProperty(Module['ready'], '___data_end', { configurable: true, get: function() { abort('You are getting ___data_end on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '___data_end', { configurable: true, set: function() { abort('You are setting ___data_end on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '___wasm_call_ctors')) {
        Object.defineProperty(Module['ready'], '___wasm_call_ctors', { configurable: true, get: function() { abort('You are getting ___wasm_call_ctors on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '___wasm_call_ctors', { configurable: true, set: function() { abort('You are setting ___wasm_call_ctors on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '_fflush')) {
        Object.defineProperty(Module['ready'], '_fflush', { configurable: true, get: function() { abort('You are getting _fflush on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '_fflush', { configurable: true, set: function() { abort('You are setting _fflush on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '___errno_location')) {
        Object.defineProperty(Module['ready'], '___errno_location', { configurable: true, get: function() { abort('You are getting ___errno_location on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '___errno_location', { configurable: true, set: function() { abort('You are setting ___errno_location on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '_htons')) {
        Object.defineProperty(Module['ready'], '_htons', { configurable: true, get: function() { abort('You are getting _htons on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '_htons', { configurable: true, set: function() { abort('You are setting _htons on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], '_ntohs')) {
        Object.defineProperty(Module['ready'], '_ntohs', { configurable: true, get: function() { abort('You are getting _ntohs on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], '_ntohs', { configurable: true, set: function() { abort('You are setting _ntohs on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

      if (!Object.getOwnPropertyDescriptor(Module['ready'], 'onRuntimeInitialized')) {
        Object.defineProperty(Module['ready'], 'onRuntimeInitialized', { configurable: true, get: function() { abort('You are getting onRuntimeInitialized on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
        Object.defineProperty(Module['ready'], 'onRuntimeInitialized', { configurable: true, set: function() { abort('You are setting onRuntimeInitialized on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js') } });
      }
    

// --pre-jses are emitted after the Module integration code, so that they can
// refer to Module (if they choose; they can also define Module)
// {{PRE_JSES}}

// Sometimes an existing Module object exists with properties
// meant to overwrite the default module functionality. Here
// we collect those properties and reapply _after_ we configure
// the current environment's defaults to avoid having to be so
// defensive during initialization.
var moduleOverrides = {};
var key;
for (key in Module) {
  if (Module.hasOwnProperty(key)) {
    moduleOverrides[key] = Module[key];
  }
}

var arguments_ = [];
var thisProgram = './this.program';
var quit_ = function(status, toThrow) {
  throw toThrow;
};

// Determine the runtime environment we are in. You can customize this by
// setting the ENVIRONMENT setting at compile time (see settings.js).

var ENVIRONMENT_IS_WEB = true;
var ENVIRONMENT_IS_WORKER = false;
var ENVIRONMENT_IS_NODE = false;
var ENVIRONMENT_IS_SHELL = false;

if (Module['ENVIRONMENT']) {
  throw new Error('Module.ENVIRONMENT has been deprecated. To force the environment, use the ENVIRONMENT compile-time option (for example, -s ENVIRONMENT=web or -s ENVIRONMENT=node)');
}



// `/` should be present at the end if `scriptDirectory` is not empty
var scriptDirectory = '';
function locateFile(path) {
  if (Module['locateFile']) {
    return Module['locateFile'](path, scriptDirectory);
  }
  return scriptDirectory + path;
}

// Hooks that are implemented differently in different runtime environments.
var read_,
    readAsync,
    readBinary,
    setWindowTitle;


// Note that this includes Node.js workers when relevant (pthreads is enabled).
// Node.js workers are detected as a combination of ENVIRONMENT_IS_WORKER and
// ENVIRONMENT_IS_NODE.
if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
  if (ENVIRONMENT_IS_WORKER) { // Check worker, not web, since window could be polyfilled
    scriptDirectory = self.location.href;
  } else if (document.currentScript) { // web
    scriptDirectory = document.currentScript.src;
  }
  // When MODULARIZE, this JS may be executed later, after document.currentScript
  // is gone, so we saved it, and we use it here instead of any other info.
  if (_scriptDir) {
    scriptDirectory = _scriptDir;
  }
  // blob urls look like blob:http://site.com/etc/etc and we cannot infer anything from them.
  // otherwise, slice off the final part of the url to find the script directory.
  // if scriptDirectory does not contain a slash, lastIndexOf will return -1,
  // and scriptDirectory will correctly be replaced with an empty string.
  if (scriptDirectory.indexOf('blob:') !== 0) {
    scriptDirectory = scriptDirectory.substr(0, scriptDirectory.lastIndexOf('/')+1);
  } else {
    scriptDirectory = '';
  }

  if (!(typeof window === 'object' || typeof importScripts === 'function')) throw new Error('not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)');

  // Differentiate the Web Worker from the Node Worker case, as reading must
  // be done differently.
  {




  read_ = function shell_read(url) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, false);
      xhr.send(null);
      return xhr.responseText;
  };

  if (ENVIRONMENT_IS_WORKER) {
    readBinary = function readBinary(url) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, false);
        xhr.responseType = 'arraybuffer';
        xhr.send(null);
        return new Uint8Array(/** @type{!ArrayBuffer} */(xhr.response));
    };
  }

  readAsync = function readAsync(url, onload, onerror) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'arraybuffer';
    xhr.onload = function xhr_onload() {
      if (xhr.status == 200 || (xhr.status == 0 && xhr.response)) { // file URLs can return 0
        onload(xhr.response);
        return;
      }
      onerror();
    };
    xhr.onerror = onerror;
    xhr.send(null);
  };




  }

  setWindowTitle = function(title) { document.title = title };
} else
{
  throw new Error('environment detection error');
}


// Set up the out() and err() hooks, which are how we can print to stdout or
// stderr, respectively.
var out = Module['print'] || console.log.bind(console);
var err = Module['printErr'] || console.warn.bind(console);

// Merge back in the overrides
for (key in moduleOverrides) {
  if (moduleOverrides.hasOwnProperty(key)) {
    Module[key] = moduleOverrides[key];
  }
}
// Free the object hierarchy contained in the overrides, this lets the GC
// reclaim data used e.g. in memoryInitializerRequest, which is a large typed array.
moduleOverrides = null;

// Emit code to handle expected values on the Module object. This applies Module.x
// to the proper local x. This has two benefits: first, we only emit it if it is
// expected to arrive, and second, by using a local everywhere else that can be
// minified.
if (Module['arguments']) arguments_ = Module['arguments'];if (!Object.getOwnPropertyDescriptor(Module, 'arguments')) Object.defineProperty(Module, 'arguments', { configurable: true, get: function() { abort('Module.arguments has been replaced with plain arguments_ (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)') } });
if (Module['thisProgram']) thisProgram = Module['thisProgram'];if (!Object.getOwnPropertyDescriptor(Module, 'thisProgram')) Object.defineProperty(Module, 'thisProgram', { configurable: true, get: function() { abort('Module.thisProgram has been replaced with plain thisProgram (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)') } });
if (Module['quit']) quit_ = Module['quit'];if (!Object.getOwnPropertyDescriptor(Module, 'quit')) Object.defineProperty(Module, 'quit', { configurable: true, get: function() { abort('Module.quit has been replaced with plain quit_ (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)') } });

// perform assertions in shell.js after we set up out() and err(), as otherwise if an assertion fails it cannot print the message
// Assertions on removed incoming Module JS APIs.
assert(typeof Module['memoryInitializerPrefixURL'] === 'undefined', 'Module.memoryInitializerPrefixURL option was removed, use Module.locateFile instead');
assert(typeof Module['pthreadMainPrefixURL'] === 'undefined', 'Module.pthreadMainPrefixURL option was removed, use Module.locateFile instead');
assert(typeof Module['cdInitializerPrefixURL'] === 'undefined', 'Module.cdInitializerPrefixURL option was removed, use Module.locateFile instead');
assert(typeof Module['filePackagePrefixURL'] === 'undefined', 'Module.filePackagePrefixURL option was removed, use Module.locateFile instead');
assert(typeof Module['read'] === 'undefined', 'Module.read option was removed (modify read_ in JS)');
assert(typeof Module['readAsync'] === 'undefined', 'Module.readAsync option was removed (modify readAsync in JS)');
assert(typeof Module['readBinary'] === 'undefined', 'Module.readBinary option was removed (modify readBinary in JS)');
assert(typeof Module['setWindowTitle'] === 'undefined', 'Module.setWindowTitle option was removed (modify setWindowTitle in JS)');
assert(typeof Module['TOTAL_MEMORY'] === 'undefined', 'Module.TOTAL_MEMORY has been renamed Module.INITIAL_MEMORY');
if (!Object.getOwnPropertyDescriptor(Module, 'read')) Object.defineProperty(Module, 'read', { configurable: true, get: function() { abort('Module.read has been replaced with plain read_ (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)') } });
if (!Object.getOwnPropertyDescriptor(Module, 'readAsync')) Object.defineProperty(Module, 'readAsync', { configurable: true, get: function() { abort('Module.readAsync has been replaced with plain readAsync (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)') } });
if (!Object.getOwnPropertyDescriptor(Module, 'readBinary')) Object.defineProperty(Module, 'readBinary', { configurable: true, get: function() { abort('Module.readBinary has been replaced with plain readBinary (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)') } });
if (!Object.getOwnPropertyDescriptor(Module, 'setWindowTitle')) Object.defineProperty(Module, 'setWindowTitle', { configurable: true, get: function() { abort('Module.setWindowTitle has been replaced with plain setWindowTitle (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)') } });
var IDBFS = 'IDBFS is no longer included by default; build with -lidbfs.js';
var PROXYFS = 'PROXYFS is no longer included by default; build with -lproxyfs.js';
var WORKERFS = 'WORKERFS is no longer included by default; build with -lworkerfs.js';
var NODEFS = 'NODEFS is no longer included by default; build with -lnodefs.js';






// {{PREAMBLE_ADDITIONS}}

var STACK_ALIGN = 16;

function dynamicAlloc(size) {
  assert(DYNAMICTOP_PTR);
  var ret = HEAP32[DYNAMICTOP_PTR>>2];
  var end = (ret + size + 15) & -16;
  assert(end <= HEAP8.length, 'failure to dynamicAlloc - memory growth etc. is not supported there, call malloc/sbrk directly');
  HEAP32[DYNAMICTOP_PTR>>2] = end;
  return ret;
}

function alignMemory(size, factor) {
  if (!factor) factor = STACK_ALIGN; // stack alignment (16-byte) by default
  return Math.ceil(size / factor) * factor;
}

function getNativeTypeSize(type) {
  switch (type) {
    case 'i1': case 'i8': return 1;
    case 'i16': return 2;
    case 'i32': return 4;
    case 'i64': return 8;
    case 'float': return 4;
    case 'double': return 8;
    default: {
      if (type[type.length-1] === '*') {
        return 4; // A pointer
      } else if (type[0] === 'i') {
        var bits = Number(type.substr(1));
        assert(bits % 8 === 0, 'getNativeTypeSize invalid bits ' + bits + ', type ' + type);
        return bits / 8;
      } else {
        return 0;
      }
    }
  }
}

function warnOnce(text) {
  if (!warnOnce.shown) warnOnce.shown = {};
  if (!warnOnce.shown[text]) {
    warnOnce.shown[text] = 1;
    err(text);
  }
}








// Wraps a JS function as a wasm function with a given signature.
function convertJsFunctionToWasm(func, sig) {

  // If the type reflection proposal is available, use the new
  // "WebAssembly.Function" constructor.
  // Otherwise, construct a minimal wasm module importing the JS function and
  // re-exporting it.
  if (typeof WebAssembly.Function === "function") {
    var typeNames = {
      'i': 'i32',
      'j': 'i64',
      'f': 'f32',
      'd': 'f64'
    };
    var type = {
      parameters: [],
      results: sig[0] == 'v' ? [] : [typeNames[sig[0]]]
    };
    for (var i = 1; i < sig.length; ++i) {
      type.parameters.push(typeNames[sig[i]]);
    }
    return new WebAssembly.Function(type, func);
  }

  // The module is static, with the exception of the type section, which is
  // generated based on the signature passed in.
  var typeSection = [
    0x01, // id: section,
    0x00, // length: 0 (placeholder)
    0x01, // count: 1
    0x60, // form: func
  ];
  var sigRet = sig.slice(0, 1);
  var sigParam = sig.slice(1);
  var typeCodes = {
    'i': 0x7f, // i32
    'j': 0x7e, // i64
    'f': 0x7d, // f32
    'd': 0x7c, // f64
  };

  // Parameters, length + signatures
  typeSection.push(sigParam.length);
  for (var i = 0; i < sigParam.length; ++i) {
    typeSection.push(typeCodes[sigParam[i]]);
  }

  // Return values, length + signatures
  // With no multi-return in MVP, either 0 (void) or 1 (anything else)
  if (sigRet == 'v') {
    typeSection.push(0x00);
  } else {
    typeSection = typeSection.concat([0x01, typeCodes[sigRet]]);
  }

  // Write the overall length of the type section back into the section header
  // (excepting the 2 bytes for the section id and length)
  typeSection[1] = typeSection.length - 2;

  // Rest of the module is static
  var bytes = new Uint8Array([
    0x00, 0x61, 0x73, 0x6d, // magic ("\0asm")
    0x01, 0x00, 0x00, 0x00, // version: 1
  ].concat(typeSection, [
    0x02, 0x07, // import section
      // (import "e" "f" (func 0 (type 0)))
      0x01, 0x01, 0x65, 0x01, 0x66, 0x00, 0x00,
    0x07, 0x05, // export section
      // (export "f" (func 0 (type 0)))
      0x01, 0x01, 0x66, 0x00, 0x00,
  ]));

   // We can compile this wasm module synchronously because it is very small.
  // This accepts an import (at "e.f"), that it reroutes to an export (at "f")
  var module = new WebAssembly.Module(bytes);
  var instance = new WebAssembly.Instance(module, {
    'e': {
      'f': func
    }
  });
  var wrappedFunc = instance.exports['f'];
  return wrappedFunc;
}

var freeTableIndexes = [];

// Weak map of functions in the table to their indexes, created on first use.
var functionsInTableMap;

// Add a wasm function to the table.
function addFunctionWasm(func, sig) {
  var table = wasmTable;

  // Check if the function is already in the table, to ensure each function
  // gets a unique index. First, create the map if this is the first use.
  if (!functionsInTableMap) {
    functionsInTableMap = new WeakMap();
    for (var i = 0; i < table.length; i++) {
      var item = table.get(i);
      // Ignore null values.
      if (item) {
        functionsInTableMap.set(item, i);
      }
    }
  }
  if (functionsInTableMap.has(func)) {
    return functionsInTableMap.get(func);
  }

  // It's not in the table, add it now.


  var ret;
  // Reuse a free index if there is one, otherwise grow.
  if (freeTableIndexes.length) {
    ret = freeTableIndexes.pop();
  } else {
    ret = table.length;
    // Grow the table
    try {
      table.grow(1);
    } catch (err) {
      if (!(err instanceof RangeError)) {
        throw err;
      }
      throw 'Unable to grow wasm table. Set ALLOW_TABLE_GROWTH.';
    }
  }

  // Set the new value.
  try {
    // Attempting to call this with JS function will cause of table.set() to fail
    table.set(ret, func);
  } catch (err) {
    if (!(err instanceof TypeError)) {
      throw err;
    }
    assert(typeof sig !== 'undefined', 'Missing signature argument to addFunction');
    var wrapped = convertJsFunctionToWasm(func, sig);
    table.set(ret, wrapped);
  }

  functionsInTableMap.set(func, ret);

  return ret;
}

function removeFunctionWasm(index) {
  functionsInTableMap.delete(wasmTable.get(index));
  freeTableIndexes.push(index);
}

// 'sig' parameter is required for the llvm backend but only when func is not
// already a WebAssembly function.
function addFunction(func, sig) {
  assert(typeof func !== 'undefined');

  return addFunctionWasm(func, sig);
}

function removeFunction(index) {
  removeFunctionWasm(index);
}



var funcWrappers = {};

function getFuncWrapper(func, sig) {
  if (!func) return; // on null pointer, return undefined
  assert(sig);
  if (!funcWrappers[sig]) {
    funcWrappers[sig] = {};
  }
  var sigCache = funcWrappers[sig];
  if (!sigCache[func]) {
    // optimize away arguments usage in common cases
    if (sig.length === 1) {
      sigCache[func] = function dynCall_wrapper() {
        return dynCall(sig, func);
      };
    } else if (sig.length === 2) {
      sigCache[func] = function dynCall_wrapper(arg) {
        return dynCall(sig, func, [arg]);
      };
    } else {
      // general case
      sigCache[func] = function dynCall_wrapper() {
        return dynCall(sig, func, Array.prototype.slice.call(arguments));
      };
    }
  }
  return sigCache[func];
}







function makeBigInt(low, high, unsigned) {
  return unsigned ? ((+((low>>>0)))+((+((high>>>0)))*4294967296.0)) : ((+((low>>>0)))+((+((high|0)))*4294967296.0));
}

/** @param {Array=} args */
function dynCall(sig, ptr, args) {
  if (args && args.length) {
    // j (64-bit integer) must be passed in as two numbers [low 32, high 32].
    assert(args.length === sig.substring(1).replace(/j/g, '--').length);
    assert(('dynCall_' + sig) in Module, 'bad function pointer type - no table for sig \'' + sig + '\'');
    return Module['dynCall_' + sig].apply(null, [ptr].concat(args));
  } else {
    assert(sig.length == 1);
    assert(('dynCall_' + sig) in Module, 'bad function pointer type - no table for sig \'' + sig + '\'');
    return Module['dynCall_' + sig].call(null, ptr);
  }
}

var tempRet0 = 0;

var setTempRet0 = function(value) {
  tempRet0 = value;
};

var getTempRet0 = function() {
  return tempRet0;
};

function getCompilerSetting(name) {
  throw 'You must build with -s RETAIN_COMPILER_SETTINGS=1 for getCompilerSetting or emscripten_get_compiler_setting to work';
}

// The address globals begin at. Very low in memory, for code size and optimization opportunities.
// Above 0 is static memory, starting with globals.
// Then the stack.
// Then 'dynamic' memory for sbrk.
var GLOBAL_BASE = 1024;





// === Preamble library stuff ===

// Documentation for the public APIs defined in this file must be updated in:
//    site/source/docs/api_reference/preamble.js.rst
// A prebuilt local version of the documentation is available at:
//    site/build/text/docs/api_reference/preamble.js.txt
// You can also build docs locally as HTML or other formats in site/
// An online HTML version (which may be of a different version of Emscripten)
//    is up at http://kripken.github.io/emscripten-site/docs/api_reference/preamble.js.html


var wasmBinary;if (Module['wasmBinary']) wasmBinary = Module['wasmBinary'];if (!Object.getOwnPropertyDescriptor(Module, 'wasmBinary')) Object.defineProperty(Module, 'wasmBinary', { configurable: true, get: function() { abort('Module.wasmBinary has been replaced with plain wasmBinary (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)') } });
var noExitRuntime;if (Module['noExitRuntime']) noExitRuntime = Module['noExitRuntime'];if (!Object.getOwnPropertyDescriptor(Module, 'noExitRuntime')) Object.defineProperty(Module, 'noExitRuntime', { configurable: true, get: function() { abort('Module.noExitRuntime has been replaced with plain noExitRuntime (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)') } });


if (typeof WebAssembly !== 'object') {
  abort('no native wasm support detected');
}




// In MINIMAL_RUNTIME, setValue() and getValue() are only available when building with safe heap enabled, for heap safety checking.
// In traditional runtime, setValue() and getValue() are always available (although their use is highly discouraged due to perf penalties)

/** @param {number} ptr
    @param {number} value
    @param {string} type
    @param {number|boolean=} noSafe */
function setValue(ptr, value, type, noSafe) {
  type = type || 'i8';
  if (type.charAt(type.length-1) === '*') type = 'i32'; // pointers are 32-bit
    switch(type) {
      case 'i1': HEAP8[((ptr)>>0)]=value; break;
      case 'i8': HEAP8[((ptr)>>0)]=value; break;
      case 'i16': HEAP16[((ptr)>>1)]=value; break;
      case 'i32': HEAP32[((ptr)>>2)]=value; break;
      case 'i64': (tempI64 = [value>>>0,(tempDouble=value,(+(Math_abs(tempDouble))) >= 1.0 ? (tempDouble > 0.0 ? ((Math_min((+(Math_floor((tempDouble)/4294967296.0))), 4294967295.0))|0)>>>0 : (~~((+(Math_ceil((tempDouble - +(((~~(tempDouble)))>>>0))/4294967296.0)))))>>>0) : 0)],HEAP32[((ptr)>>2)]=tempI64[0],HEAP32[(((ptr)+(4))>>2)]=tempI64[1]); break;
      case 'float': HEAPF32[((ptr)>>2)]=value; break;
      case 'double': HEAPF64[((ptr)>>3)]=value; break;
      default: abort('invalid type for setValue: ' + type);
    }
}

/** @param {number} ptr
    @param {string} type
    @param {number|boolean=} noSafe */
function getValue(ptr, type, noSafe) {
  type = type || 'i8';
  if (type.charAt(type.length-1) === '*') type = 'i32'; // pointers are 32-bit
    switch(type) {
      case 'i1': return HEAP8[((ptr)>>0)];
      case 'i8': return HEAP8[((ptr)>>0)];
      case 'i16': return HEAP16[((ptr)>>1)];
      case 'i32': return HEAP32[((ptr)>>2)];
      case 'i64': return HEAP32[((ptr)>>2)];
      case 'float': return HEAPF32[((ptr)>>2)];
      case 'double': return HEAPF64[((ptr)>>3)];
      default: abort('invalid type for getValue: ' + type);
    }
  return null;
}






// Wasm globals

var wasmMemory;

// In fastcomp asm.js, we don't need a wasm Table at all.
// In the wasm backend, we polyfill the WebAssembly object,
// so this creates a (non-native-wasm) table for us.
var wasmTable = new WebAssembly.Table({
  'initial': 1201,
  'maximum': 1201 + 0,
  'element': 'anyfunc'
});


//========================================
// Runtime essentials
//========================================

// whether we are quitting the application. no code should run after this.
// set in exit() and abort()
var ABORT = false;

// set by exit() and abort().  Passed to 'onExit' handler.
// NOTE: This is also used as the process return code code in shell environments
// but only when noExitRuntime is false.
var EXITSTATUS = 0;

/** @type {function(*, string=)} */
function assert(condition, text) {
  if (!condition) {
    abort('Assertion failed: ' + text);
  }
}

// Returns the C function with a specified identifier (for C++, you need to do manual name mangling)
function getCFunc(ident) {
  var func = Module['_' + ident]; // closure exported function
  assert(func, 'Cannot call unknown function ' + ident + ', make sure it is exported');
  return func;
}

// C calling interface.
/** @param {string|null=} returnType
    @param {Array=} argTypes
    @param {Arguments|Array=} args
    @param {Object=} opts */
function ccall(ident, returnType, argTypes, args, opts) {
  // For fast lookup of conversion functions
  var toC = {
    'string': function(str) {
      var ret = 0;
      if (str !== null && str !== undefined && str !== 0) { // null string
        // at most 4 bytes per UTF-8 code point, +1 for the trailing '\0'
        var len = (str.length << 2) + 1;
        ret = stackAlloc(len);
        stringToUTF8(str, ret, len);
      }
      return ret;
    },
    'array': function(arr) {
      var ret = stackAlloc(arr.length);
      writeArrayToMemory(arr, ret);
      return ret;
    }
  };

  function convertReturnValue(ret) {
    if (returnType === 'string') return UTF8ToString(ret);
    if (returnType === 'boolean') return Boolean(ret);
    return ret;
  }

  var func = getCFunc(ident);
  var cArgs = [];
  var stack = 0;
  assert(returnType !== 'array', 'Return type should not be "array".');
  if (args) {
    for (var i = 0; i < args.length; i++) {
      var converter = toC[argTypes[i]];
      if (converter) {
        if (stack === 0) stack = stackSave();
        cArgs[i] = converter(args[i]);
      } else {
        cArgs[i] = args[i];
      }
    }
  }
  var ret = func.apply(null, cArgs);

  ret = convertReturnValue(ret);
  if (stack !== 0) stackRestore(stack);
  return ret;
}

/** @param {string=} returnType
    @param {Array=} argTypes
    @param {Object=} opts */
function cwrap(ident, returnType, argTypes, opts) {
  return function() {
    return ccall(ident, returnType, argTypes, arguments, opts);
  }
}

var ALLOC_NORMAL = 0; // Tries to use _malloc()
var ALLOC_STACK = 1; // Lives for the duration of the current function call
var ALLOC_DYNAMIC = 2; // Cannot be freed except through sbrk
var ALLOC_NONE = 3; // Do not allocate

// allocate(): This is for internal use. You can use it yourself as well, but the interface
//             is a little tricky (see docs right below). The reason is that it is optimized
//             for multiple syntaxes to save space in generated code. So you should
//             normally not use allocate(), and instead allocate memory using _malloc(),
//             initialize it with setValue(), and so forth.
// @slab: An array of data, or a number. If a number, then the size of the block to allocate,
//        in *bytes* (note that this is sometimes confusing: the next parameter does not
//        affect this!)
// @types: Either an array of types, one for each byte (or 0 if no type at that position),
//         or a single type which is used for the entire block. This only matters if there
//         is initial data - if @slab is a number, then this does not matter at all and is
//         ignored.
// @allocator: How to allocate memory, see ALLOC_*
/** @type {function((TypedArray|Array<number>|number), string, number, number=)} */
function allocate(slab, types, allocator, ptr) {
  var zeroinit, size;
  if (typeof slab === 'number') {
    zeroinit = true;
    size = slab;
  } else {
    zeroinit = false;
    size = slab.length;
  }

  var singleType = typeof types === 'string' ? types : null;

  var ret;
  if (allocator == ALLOC_NONE) {
    ret = ptr;
  } else {
    ret = [_malloc,
    stackAlloc,
    dynamicAlloc][allocator](Math.max(size, singleType ? 1 : types.length));
  }

  if (zeroinit) {
    var stop;
    ptr = ret;
    assert((ret & 3) == 0);
    stop = ret + (size & ~3);
    for (; ptr < stop; ptr += 4) {
      HEAP32[((ptr)>>2)]=0;
    }
    stop = ret + size;
    while (ptr < stop) {
      HEAP8[((ptr++)>>0)]=0;
    }
    return ret;
  }

  if (singleType === 'i8') {
    if (slab.subarray || slab.slice) {
      HEAPU8.set(/** @type {!Uint8Array} */ (slab), ret);
    } else {
      HEAPU8.set(new Uint8Array(slab), ret);
    }
    return ret;
  }

  var i = 0, type, typeSize, previousType;
  while (i < size) {
    var curr = slab[i];

    type = singleType || types[i];
    if (type === 0) {
      i++;
      continue;
    }
    assert(type, 'Must know what type to store in allocate!');

    if (type == 'i64') type = 'i32'; // special case: we have one i32 here, and one i32 later

    setValue(ret+i, curr, type);

    // no need to look up size unless type changes, so cache it
    if (previousType !== type) {
      typeSize = getNativeTypeSize(type);
      previousType = type;
    }
    i += typeSize;
  }

  return ret;
}

// Allocate memory during any stage of startup - static memory early on, dynamic memory later, malloc when ready
function getMemory(size) {
  if (!runtimeInitialized) return dynamicAlloc(size);
  return _malloc(size);
}




// runtime_strings.js: Strings related runtime functions that are part of both MINIMAL_RUNTIME and regular runtime.

// Given a pointer 'ptr' to a null-terminated UTF8-encoded string in the given array that contains uint8 values, returns
// a copy of that string as a Javascript String object.

var UTF8Decoder = typeof TextDecoder !== 'undefined' ? new TextDecoder('utf8') : undefined;

/**
 * @param {number} idx
 * @param {number=} maxBytesToRead
 * @return {string}
 */
function UTF8ArrayToString(heap, idx, maxBytesToRead) {
  var endIdx = idx + maxBytesToRead;
  var endPtr = idx;
  // TextDecoder needs to know the byte length in advance, it doesn't stop on null terminator by itself.
  // Also, use the length info to avoid running tiny strings through TextDecoder, since .subarray() allocates garbage.
  // (As a tiny code save trick, compare endPtr against endIdx using a negation, so that undefined means Infinity)
  while (heap[endPtr] && !(endPtr >= endIdx)) ++endPtr;

  if (endPtr - idx > 16 && heap.subarray && UTF8Decoder) {
    return UTF8Decoder.decode(heap.subarray(idx, endPtr));
  } else {
    var str = '';
    // If building with TextDecoder, we have already computed the string length above, so test loop end condition against that
    while (idx < endPtr) {
      // For UTF8 byte structure, see:
      // http://en.wikipedia.org/wiki/UTF-8#Description
      // https://www.ietf.org/rfc/rfc2279.txt
      // https://tools.ietf.org/html/rfc3629
      var u0 = heap[idx++];
      if (!(u0 & 0x80)) { str += String.fromCharCode(u0); continue; }
      var u1 = heap[idx++] & 63;
      if ((u0 & 0xE0) == 0xC0) { str += String.fromCharCode(((u0 & 31) << 6) | u1); continue; }
      var u2 = heap[idx++] & 63;
      if ((u0 & 0xF0) == 0xE0) {
        u0 = ((u0 & 15) << 12) | (u1 << 6) | u2;
      } else {
        if ((u0 & 0xF8) != 0xF0) warnOnce('Invalid UTF-8 leading byte 0x' + u0.toString(16) + ' encountered when deserializing a UTF-8 string on the asm.js/wasm heap to a JS string!');
        u0 = ((u0 & 7) << 18) | (u1 << 12) | (u2 << 6) | (heap[idx++] & 63);
      }

      if (u0 < 0x10000) {
        str += String.fromCharCode(u0);
      } else {
        var ch = u0 - 0x10000;
        str += String.fromCharCode(0xD800 | (ch >> 10), 0xDC00 | (ch & 0x3FF));
      }
    }
  }
  return str;
}

// Given a pointer 'ptr' to a null-terminated UTF8-encoded string in the emscripten HEAP, returns a
// copy of that string as a Javascript String object.
// maxBytesToRead: an optional length that specifies the maximum number of bytes to read. You can omit
//                 this parameter to scan the string until the first \0 byte. If maxBytesToRead is
//                 passed, and the string at [ptr, ptr+maxBytesToReadr[ contains a null byte in the
//                 middle, then the string will cut short at that byte index (i.e. maxBytesToRead will
//                 not produce a string of exact length [ptr, ptr+maxBytesToRead[)
//                 N.B. mixing frequent uses of UTF8ToString() with and without maxBytesToRead may
//                 throw JS JIT optimizations off, so it is worth to consider consistently using one
//                 style or the other.
/**
 * @param {number} ptr
 * @param {number=} maxBytesToRead
 * @return {string}
 */
function UTF8ToString(ptr, maxBytesToRead) {
  return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : '';
}

// Copies the given Javascript String object 'str' to the given byte array at address 'outIdx',
// encoded in UTF8 form and null-terminated. The copy will require at most str.length*4+1 bytes of space in the HEAP.
// Use the function lengthBytesUTF8 to compute the exact number of bytes (excluding null terminator) that this function will write.
// Parameters:
//   str: the Javascript string to copy.
//   heap: the array to copy to. Each index in this array is assumed to be one 8-byte element.
//   outIdx: The starting offset in the array to begin the copying.
//   maxBytesToWrite: The maximum number of bytes this function can write to the array.
//                    This count should include the null terminator,
//                    i.e. if maxBytesToWrite=1, only the null terminator will be written and nothing else.
//                    maxBytesToWrite=0 does not write any bytes to the output, not even the null terminator.
// Returns the number of bytes written, EXCLUDING the null terminator.

function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
  if (!(maxBytesToWrite > 0)) // Parameter maxBytesToWrite is not optional. Negative values, 0, null, undefined and false each don't write out any bytes.
    return 0;

  var startIdx = outIdx;
  var endIdx = outIdx + maxBytesToWrite - 1; // -1 for string null terminator.
  for (var i = 0; i < str.length; ++i) {
    // Gotcha: charCodeAt returns a 16-bit word that is a UTF-16 encoded code unit, not a Unicode code point of the character! So decode UTF16->UTF32->UTF8.
    // See http://unicode.org/faq/utf_bom.html#utf16-3
    // For UTF8 byte structure, see http://en.wikipedia.org/wiki/UTF-8#Description and https://www.ietf.org/rfc/rfc2279.txt and https://tools.ietf.org/html/rfc3629
    var u = str.charCodeAt(i); // possibly a lead surrogate
    if (u >= 0xD800 && u <= 0xDFFF) {
      var u1 = str.charCodeAt(++i);
      u = 0x10000 + ((u & 0x3FF) << 10) | (u1 & 0x3FF);
    }
    if (u <= 0x7F) {
      if (outIdx >= endIdx) break;
      heap[outIdx++] = u;
    } else if (u <= 0x7FF) {
      if (outIdx + 1 >= endIdx) break;
      heap[outIdx++] = 0xC0 | (u >> 6);
      heap[outIdx++] = 0x80 | (u & 63);
    } else if (u <= 0xFFFF) {
      if (outIdx + 2 >= endIdx) break;
      heap[outIdx++] = 0xE0 | (u >> 12);
      heap[outIdx++] = 0x80 | ((u >> 6) & 63);
      heap[outIdx++] = 0x80 | (u & 63);
    } else {
      if (outIdx + 3 >= endIdx) break;
      if (u >= 0x200000) warnOnce('Invalid Unicode code point 0x' + u.toString(16) + ' encountered when serializing a JS string to an UTF-8 string on the asm.js/wasm heap! (Valid unicode code points should be in range 0-0x1FFFFF).');
      heap[outIdx++] = 0xF0 | (u >> 18);
      heap[outIdx++] = 0x80 | ((u >> 12) & 63);
      heap[outIdx++] = 0x80 | ((u >> 6) & 63);
      heap[outIdx++] = 0x80 | (u & 63);
    }
  }
  // Null-terminate the pointer to the buffer.
  heap[outIdx] = 0;
  return outIdx - startIdx;
}

// Copies the given Javascript String object 'str' to the emscripten HEAP at address 'outPtr',
// null-terminated and encoded in UTF8 form. The copy will require at most str.length*4+1 bytes of space in the HEAP.
// Use the function lengthBytesUTF8 to compute the exact number of bytes (excluding null terminator) that this function will write.
// Returns the number of bytes written, EXCLUDING the null terminator.

function stringToUTF8(str, outPtr, maxBytesToWrite) {
  assert(typeof maxBytesToWrite == 'number', 'stringToUTF8(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!');
  return stringToUTF8Array(str, HEAPU8,outPtr, maxBytesToWrite);
}

// Returns the number of bytes the given Javascript string takes if encoded as a UTF8 byte array, EXCLUDING the null terminator byte.
function lengthBytesUTF8(str) {
  var len = 0;
  for (var i = 0; i < str.length; ++i) {
    // Gotcha: charCodeAt returns a 16-bit word that is a UTF-16 encoded code unit, not a Unicode code point of the character! So decode UTF16->UTF32->UTF8.
    // See http://unicode.org/faq/utf_bom.html#utf16-3
    var u = str.charCodeAt(i); // possibly a lead surrogate
    if (u >= 0xD800 && u <= 0xDFFF) u = 0x10000 + ((u & 0x3FF) << 10) | (str.charCodeAt(++i) & 0x3FF);
    if (u <= 0x7F) ++len;
    else if (u <= 0x7FF) len += 2;
    else if (u <= 0xFFFF) len += 3;
    else len += 4;
  }
  return len;
}





// runtime_strings_extra.js: Strings related runtime functions that are available only in regular runtime.

// Given a pointer 'ptr' to a null-terminated ASCII-encoded string in the emscripten HEAP, returns
// a copy of that string as a Javascript String object.

function AsciiToString(ptr) {
  var str = '';
  while (1) {
    var ch = HEAPU8[((ptr++)>>0)];
    if (!ch) return str;
    str += String.fromCharCode(ch);
  }
}

// Copies the given Javascript String object 'str' to the emscripten HEAP at address 'outPtr',
// null-terminated and encoded in ASCII form. The copy will require at most str.length+1 bytes of space in the HEAP.

function stringToAscii(str, outPtr) {
  return writeAsciiToMemory(str, outPtr, false);
}

// Given a pointer 'ptr' to a null-terminated UTF16LE-encoded string in the emscripten HEAP, returns
// a copy of that string as a Javascript String object.

var UTF16Decoder = typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-16le') : undefined;

function UTF16ToString(ptr, maxBytesToRead) {
  assert(ptr % 2 == 0, 'Pointer passed to UTF16ToString must be aligned to two bytes!');
  var endPtr = ptr;
  // TextDecoder needs to know the byte length in advance, it doesn't stop on null terminator by itself.
  // Also, use the length info to avoid running tiny strings through TextDecoder, since .subarray() allocates garbage.
  var idx = endPtr >> 1;
  var maxIdx = idx + maxBytesToRead / 2;
  // If maxBytesToRead is not passed explicitly, it will be undefined, and this
  // will always evaluate to true. This saves on code size.
  while (!(idx >= maxIdx) && HEAPU16[idx]) ++idx;
  endPtr = idx << 1;

  if (endPtr - ptr > 32 && UTF16Decoder) {
    return UTF16Decoder.decode(HEAPU8.subarray(ptr, endPtr));
  } else {
    var i = 0;

    var str = '';
    while (1) {
      var codeUnit = HEAP16[(((ptr)+(i*2))>>1)];
      if (codeUnit == 0 || i == maxBytesToRead / 2) return str;
      ++i;
      // fromCharCode constructs a character from a UTF-16 code unit, so we can pass the UTF16 string right through.
      str += String.fromCharCode(codeUnit);
    }
  }
}

// Copies the given Javascript String object 'str' to the emscripten HEAP at address 'outPtr',
// null-terminated and encoded in UTF16 form. The copy will require at most str.length*4+2 bytes of space in the HEAP.
// Use the function lengthBytesUTF16() to compute the exact number of bytes (excluding null terminator) that this function will write.
// Parameters:
//   str: the Javascript string to copy.
//   outPtr: Byte address in Emscripten HEAP where to write the string to.
//   maxBytesToWrite: The maximum number of bytes this function can write to the array. This count should include the null
//                    terminator, i.e. if maxBytesToWrite=2, only the null terminator will be written and nothing else.
//                    maxBytesToWrite<2 does not write any bytes to the output, not even the null terminator.
// Returns the number of bytes written, EXCLUDING the null terminator.

function stringToUTF16(str, outPtr, maxBytesToWrite) {
  assert(outPtr % 2 == 0, 'Pointer passed to stringToUTF16 must be aligned to two bytes!');
  assert(typeof maxBytesToWrite == 'number', 'stringToUTF16(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!');
  // Backwards compatibility: if max bytes is not specified, assume unsafe unbounded write is allowed.
  if (maxBytesToWrite === undefined) {
    maxBytesToWrite = 0x7FFFFFFF;
  }
  if (maxBytesToWrite < 2) return 0;
  maxBytesToWrite -= 2; // Null terminator.
  var startPtr = outPtr;
  var numCharsToWrite = (maxBytesToWrite < str.length*2) ? (maxBytesToWrite / 2) : str.length;
  for (var i = 0; i < numCharsToWrite; ++i) {
    // charCodeAt returns a UTF-16 encoded code unit, so it can be directly written to the HEAP.
    var codeUnit = str.charCodeAt(i); // possibly a lead surrogate
    HEAP16[((outPtr)>>1)]=codeUnit;
    outPtr += 2;
  }
  // Null-terminate the pointer to the HEAP.
  HEAP16[((outPtr)>>1)]=0;
  return outPtr - startPtr;
}

// Returns the number of bytes the given Javascript string takes if encoded as a UTF16 byte array, EXCLUDING the null terminator byte.

function lengthBytesUTF16(str) {
  return str.length*2;
}

function UTF32ToString(ptr, maxBytesToRead) {
  assert(ptr % 4 == 0, 'Pointer passed to UTF32ToString must be aligned to four bytes!');
  var i = 0;

  var str = '';
  // If maxBytesToRead is not passed explicitly, it will be undefined, and this
  // will always evaluate to true. This saves on code size.
  while (!(i >= maxBytesToRead / 4)) {
    var utf32 = HEAP32[(((ptr)+(i*4))>>2)];
    if (utf32 == 0) break;
    ++i;
    // Gotcha: fromCharCode constructs a character from a UTF-16 encoded code (pair), not from a Unicode code point! So encode the code point to UTF-16 for constructing.
    // See http://unicode.org/faq/utf_bom.html#utf16-3
    if (utf32 >= 0x10000) {
      var ch = utf32 - 0x10000;
      str += String.fromCharCode(0xD800 | (ch >> 10), 0xDC00 | (ch & 0x3FF));
    } else {
      str += String.fromCharCode(utf32);
    }
  }
  return str;
}

// Copies the given Javascript String object 'str' to the emscripten HEAP at address 'outPtr',
// null-terminated and encoded in UTF32 form. The copy will require at most str.length*4+4 bytes of space in the HEAP.
// Use the function lengthBytesUTF32() to compute the exact number of bytes (excluding null terminator) that this function will write.
// Parameters:
//   str: the Javascript string to copy.
//   outPtr: Byte address in Emscripten HEAP where to write the string to.
//   maxBytesToWrite: The maximum number of bytes this function can write to the array. This count should include the null
//                    terminator, i.e. if maxBytesToWrite=4, only the null terminator will be written and nothing else.
//                    maxBytesToWrite<4 does not write any bytes to the output, not even the null terminator.
// Returns the number of bytes written, EXCLUDING the null terminator.

function stringToUTF32(str, outPtr, maxBytesToWrite) {
  assert(outPtr % 4 == 0, 'Pointer passed to stringToUTF32 must be aligned to four bytes!');
  assert(typeof maxBytesToWrite == 'number', 'stringToUTF32(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!');
  // Backwards compatibility: if max bytes is not specified, assume unsafe unbounded write is allowed.
  if (maxBytesToWrite === undefined) {
    maxBytesToWrite = 0x7FFFFFFF;
  }
  if (maxBytesToWrite < 4) return 0;
  var startPtr = outPtr;
  var endPtr = startPtr + maxBytesToWrite - 4;
  for (var i = 0; i < str.length; ++i) {
    // Gotcha: charCodeAt returns a 16-bit word that is a UTF-16 encoded code unit, not a Unicode code point of the character! We must decode the string to UTF-32 to the heap.
    // See http://unicode.org/faq/utf_bom.html#utf16-3
    var codeUnit = str.charCodeAt(i); // possibly a lead surrogate
    if (codeUnit >= 0xD800 && codeUnit <= 0xDFFF) {
      var trailSurrogate = str.charCodeAt(++i);
      codeUnit = 0x10000 + ((codeUnit & 0x3FF) << 10) | (trailSurrogate & 0x3FF);
    }
    HEAP32[((outPtr)>>2)]=codeUnit;
    outPtr += 4;
    if (outPtr + 4 > endPtr) break;
  }
  // Null-terminate the pointer to the HEAP.
  HEAP32[((outPtr)>>2)]=0;
  return outPtr - startPtr;
}

// Returns the number of bytes the given Javascript string takes if encoded as a UTF16 byte array, EXCLUDING the null terminator byte.

function lengthBytesUTF32(str) {
  var len = 0;
  for (var i = 0; i < str.length; ++i) {
    // Gotcha: charCodeAt returns a 16-bit word that is a UTF-16 encoded code unit, not a Unicode code point of the character! We must decode the string to UTF-32 to the heap.
    // See http://unicode.org/faq/utf_bom.html#utf16-3
    var codeUnit = str.charCodeAt(i);
    if (codeUnit >= 0xD800 && codeUnit <= 0xDFFF) ++i; // possibly a lead surrogate, so skip over the tail surrogate.
    len += 4;
  }

  return len;
}

// Allocate heap space for a JS string, and write it there.
// It is the responsibility of the caller to free() that memory.
function allocateUTF8(str) {
  var size = lengthBytesUTF8(str) + 1;
  var ret = _malloc(size);
  if (ret) stringToUTF8Array(str, HEAP8, ret, size);
  return ret;
}

// Allocate stack space for a JS string, and write it there.
function allocateUTF8OnStack(str) {
  var size = lengthBytesUTF8(str) + 1;
  var ret = stackAlloc(size);
  stringToUTF8Array(str, HEAP8, ret, size);
  return ret;
}

// Deprecated: This function should not be called because it is unsafe and does not provide
// a maximum length limit of how many bytes it is allowed to write. Prefer calling the
// function stringToUTF8Array() instead, which takes in a maximum length that can be used
// to be secure from out of bounds writes.
/** @deprecated
    @param {boolean=} dontAddNull */
function writeStringToMemory(string, buffer, dontAddNull) {
  warnOnce('writeStringToMemory is deprecated and should not be called! Use stringToUTF8() instead!');

  var /** @type {number} */ lastChar, /** @type {number} */ end;
  if (dontAddNull) {
    // stringToUTF8Array always appends null. If we don't want to do that, remember the
    // character that existed at the location where the null will be placed, and restore
    // that after the write (below).
    end = buffer + lengthBytesUTF8(string);
    lastChar = HEAP8[end];
  }
  stringToUTF8(string, buffer, Infinity);
  if (dontAddNull) HEAP8[end] = lastChar; // Restore the value under the null character.
}

function writeArrayToMemory(array, buffer) {
  assert(array.length >= 0, 'writeArrayToMemory array must have a length (should be an array or typed array)')
  HEAP8.set(array, buffer);
}

/** @param {boolean=} dontAddNull */
function writeAsciiToMemory(str, buffer, dontAddNull) {
  for (var i = 0; i < str.length; ++i) {
    assert(str.charCodeAt(i) === str.charCodeAt(i)&0xff);
    HEAP8[((buffer++)>>0)]=str.charCodeAt(i);
  }
  // Null-terminate the pointer to the HEAP.
  if (!dontAddNull) HEAP8[((buffer)>>0)]=0;
}



// Memory management

var PAGE_SIZE = 16384;
var WASM_PAGE_SIZE = 65536;
var ASMJS_PAGE_SIZE = 16777216;

function alignUp(x, multiple) {
  if (x % multiple > 0) {
    x += multiple - (x % multiple);
  }
  return x;
}

var HEAP,
/** @type {ArrayBuffer} */
  buffer,
/** @type {Int8Array} */
  HEAP8,
/** @type {Uint8Array} */
  HEAPU8,
/** @type {Int16Array} */
  HEAP16,
/** @type {Uint16Array} */
  HEAPU16,
/** @type {Int32Array} */
  HEAP32,
/** @type {Uint32Array} */
  HEAPU32,
/** @type {Float32Array} */
  HEAPF32,
/** @type {Float64Array} */
  HEAPF64;

function updateGlobalBufferAndViews(buf) {
  buffer = buf;
  Module['HEAP8'] = HEAP8 = new Int8Array(buf);
  Module['HEAP16'] = HEAP16 = new Int16Array(buf);
  Module['HEAP32'] = HEAP32 = new Int32Array(buf);
  Module['HEAPU8'] = HEAPU8 = new Uint8Array(buf);
  Module['HEAPU16'] = HEAPU16 = new Uint16Array(buf);
  Module['HEAPU32'] = HEAPU32 = new Uint32Array(buf);
  Module['HEAPF32'] = HEAPF32 = new Float32Array(buf);
  Module['HEAPF64'] = HEAPF64 = new Float64Array(buf);
}

var STATIC_BASE = 1024,
    STACK_BASE = 5528192,
    STACKTOP = STACK_BASE,
    STACK_MAX = 285312,
    DYNAMIC_BASE = 5528192,
    DYNAMICTOP_PTR = 285152;

assert(STACK_BASE % 16 === 0, 'stack must start aligned');
assert(DYNAMIC_BASE % 16 === 0, 'heap must start aligned');


var TOTAL_STACK = 5242880;
if (Module['TOTAL_STACK']) assert(TOTAL_STACK === Module['TOTAL_STACK'], 'the stack size can no longer be determined at runtime')

var INITIAL_INITIAL_MEMORY = Module['INITIAL_MEMORY'] || 16777216;if (!Object.getOwnPropertyDescriptor(Module, 'INITIAL_MEMORY')) Object.defineProperty(Module, 'INITIAL_MEMORY', { configurable: true, get: function() { abort('Module.INITIAL_MEMORY has been replaced with plain INITIAL_INITIAL_MEMORY (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)') } });

assert(INITIAL_INITIAL_MEMORY >= TOTAL_STACK, 'INITIAL_MEMORY should be larger than TOTAL_STACK, was ' + INITIAL_INITIAL_MEMORY + '! (TOTAL_STACK=' + TOTAL_STACK + ')');

// check for full engine support (use string 'subarray' to avoid closure compiler confusion)
assert(typeof Int32Array !== 'undefined' && typeof Float64Array !== 'undefined' && Int32Array.prototype.subarray !== undefined && Int32Array.prototype.set !== undefined,
       'JS engine does not provide full typed array support');








// In non-standalone/normal mode, we create the memory here.



// Create the main memory. (Note: this isn't used in STANDALONE_WASM mode since the wasm
// memory is created in the wasm, not in JS.)

  if (Module['wasmMemory']) {
    wasmMemory = Module['wasmMemory'];
  } else
  {
    wasmMemory = new WebAssembly.Memory({
      'initial': INITIAL_INITIAL_MEMORY / WASM_PAGE_SIZE
      ,
      'maximum': 2147483648 / WASM_PAGE_SIZE
    });
  }


if (wasmMemory) {
  buffer = wasmMemory.buffer;
}

// If the user provides an incorrect length, just use that length instead rather than providing the user to
// specifically provide the memory length with Module['INITIAL_MEMORY'].
INITIAL_INITIAL_MEMORY = buffer.byteLength;
assert(INITIAL_INITIAL_MEMORY % WASM_PAGE_SIZE === 0);
assert(65536 % WASM_PAGE_SIZE === 0);
updateGlobalBufferAndViews(buffer);

HEAP32[DYNAMICTOP_PTR>>2] = DYNAMIC_BASE;






// Initializes the stack cookie. Called at the startup of main and at the startup of each thread in pthreads mode.
function writeStackCookie() {
  assert((STACK_MAX & 3) == 0);
  // The stack grows downwards
  HEAPU32[(STACK_MAX >> 2)+1] = 0x2135467;
  HEAPU32[(STACK_MAX >> 2)+2] = 0x89BACDFE;
  // Also test the global address 0 for integrity.
  // We don't do this with ASan because ASan does its own checks for this.
  HEAP32[0] = 0x63736d65; /* 'emsc' */
}

function checkStackCookie() {
  var cookie1 = HEAPU32[(STACK_MAX >> 2)+1];
  var cookie2 = HEAPU32[(STACK_MAX >> 2)+2];
  if (cookie1 != 0x2135467 || cookie2 != 0x89BACDFE) {
    abort('Stack overflow! Stack cookie has been overwritten, expected hex dwords 0x89BACDFE and 0x2135467, but received 0x' + cookie2.toString(16) + ' ' + cookie1.toString(16));
  }
  // Also test the global address 0 for integrity.
  // We don't do this with ASan because ASan does its own checks for this.
  if (HEAP32[0] !== 0x63736d65 /* 'emsc' */) abort('Runtime error: The application has corrupted its heap memory area (address zero)!');
}





// Endianness check (note: assumes compiler arch was little-endian)
(function() {
  var h16 = new Int16Array(1);
  var h8 = new Int8Array(h16.buffer);
  h16[0] = 0x6373;
  if (h8[0] !== 0x73 || h8[1] !== 0x63) throw 'Runtime error: expected the system to be little-endian!';
})();

function abortFnPtrError(ptr, sig) {
	abort("Invalid function pointer " + ptr + " called with signature '" + sig + "'. Perhaps this is an invalid value (e.g. caused by calling a virtual method on a NULL pointer)? Or calling a function with an incorrect type, which will fail? (it is worth building your source files with -Werror (warnings are errors), as warnings can indicate undefined behavior which can cause this). Build with ASSERTIONS=2 for more info.");
}



function callRuntimeCallbacks(callbacks) {
  while(callbacks.length > 0) {
    var callback = callbacks.shift();
    if (typeof callback == 'function') {
      callback(Module); // Pass the module as the first argument.
      continue;
    }
    var func = callback.func;
    if (typeof func === 'number') {
      if (callback.arg === undefined) {
        Module['dynCall_v'](func);
      } else {
        Module['dynCall_vi'](func, callback.arg);
      }
    } else {
      func(callback.arg === undefined ? null : callback.arg);
    }
  }
}

var __ATPRERUN__  = []; // functions called before the runtime is initialized
var __ATINIT__    = []; // functions called during startup
var __ATMAIN__    = []; // functions called when main() is to be run
var __ATEXIT__    = []; // functions called during shutdown
var __ATPOSTRUN__ = []; // functions called after the main() is called

var runtimeInitialized = false;
var runtimeExited = false;


function preRun() {

  if (Module['preRun']) {
    if (typeof Module['preRun'] == 'function') Module['preRun'] = [Module['preRun']];
    while (Module['preRun'].length) {
      addOnPreRun(Module['preRun'].shift());
    }
  }

  callRuntimeCallbacks(__ATPRERUN__);
}

function initRuntime() {
  checkStackCookie();
  assert(!runtimeInitialized);
  runtimeInitialized = true;
  if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
TTY.init();
PIPEFS.root = FS.mount(PIPEFS, {}, null);
SOCKFS.root = FS.mount(SOCKFS, {}, null);
  callRuntimeCallbacks(__ATINIT__);
}

function preMain() {
  checkStackCookie();
  FS.ignorePermissions = false;
  callRuntimeCallbacks(__ATMAIN__);
}

function exitRuntime() {
  checkStackCookie();
  runtimeExited = true;
}

function postRun() {
  checkStackCookie();

  if (Module['postRun']) {
    if (typeof Module['postRun'] == 'function') Module['postRun'] = [Module['postRun']];
    while (Module['postRun'].length) {
      addOnPostRun(Module['postRun'].shift());
    }
  }

  callRuntimeCallbacks(__ATPOSTRUN__);
}

function addOnPreRun(cb) {
  __ATPRERUN__.unshift(cb);
}

function addOnInit(cb) {
  __ATINIT__.unshift(cb);
}

function addOnPreMain(cb) {
  __ATMAIN__.unshift(cb);
}

function addOnExit(cb) {
}

function addOnPostRun(cb) {
  __ATPOSTRUN__.unshift(cb);
}

/** @param {number|boolean=} ignore */
function unSign(value, bits, ignore) {
  if (value >= 0) {
    return value;
  }
  return bits <= 32 ? 2*Math.abs(1 << (bits-1)) + value // Need some trickery, since if bits == 32, we are right at the limit of the bits JS uses in bitshifts
                    : Math.pow(2, bits)         + value;
}
/** @param {number|boolean=} ignore */
function reSign(value, bits, ignore) {
  if (value <= 0) {
    return value;
  }
  var half = bits <= 32 ? Math.abs(1 << (bits-1)) // abs is needed if bits == 32
                        : Math.pow(2, bits-1);
  if (value >= half && (bits <= 32 || value > half)) { // for huge values, we can hit the precision limit and always get true here. so don't do that
                                                       // but, in general there is no perfect solution here. With 64-bit ints, we get rounding and errors
                                                       // TODO: In i64 mode 1, resign the two parts separately and safely
    value = -2*half + value; // Cannot bitshift half, as it may be at the limit of the bits JS uses in bitshifts
  }
  return value;
}




// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/fround

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/trunc

assert(Math.imul, 'This browser does not support Math.imul(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill');
assert(Math.fround, 'This browser does not support Math.fround(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill');
assert(Math.clz32, 'This browser does not support Math.clz32(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill');
assert(Math.trunc, 'This browser does not support Math.trunc(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill');

var Math_abs = Math.abs;
var Math_cos = Math.cos;
var Math_sin = Math.sin;
var Math_tan = Math.tan;
var Math_acos = Math.acos;
var Math_asin = Math.asin;
var Math_atan = Math.atan;
var Math_atan2 = Math.atan2;
var Math_exp = Math.exp;
var Math_log = Math.log;
var Math_sqrt = Math.sqrt;
var Math_ceil = Math.ceil;
var Math_floor = Math.floor;
var Math_pow = Math.pow;
var Math_imul = Math.imul;
var Math_fround = Math.fround;
var Math_round = Math.round;
var Math_min = Math.min;
var Math_max = Math.max;
var Math_clz32 = Math.clz32;
var Math_trunc = Math.trunc;



// A counter of dependencies for calling run(). If we need to
// do asynchronous work before running, increment this and
// decrement it. Incrementing must happen in a place like
// Module.preRun (used by emcc to add file preloading).
// Note that you can add dependencies in preRun, even though
// it happens right before run - run will be postponed until
// the dependencies are met.
var runDependencies = 0;
var runDependencyWatcher = null;
var dependenciesFulfilled = null; // overridden to take different actions when all run dependencies are fulfilled
var runDependencyTracking = {};

function getUniqueRunDependency(id) {
  var orig = id;
  while (1) {
    if (!runDependencyTracking[id]) return id;
    id = orig + Math.random();
  }
}

function addRunDependency(id) {
  runDependencies++;

  if (Module['monitorRunDependencies']) {
    Module['monitorRunDependencies'](runDependencies);
  }

  if (id) {
    assert(!runDependencyTracking[id]);
    runDependencyTracking[id] = 1;
    if (runDependencyWatcher === null && typeof setInterval !== 'undefined') {
      // Check for missing dependencies every few seconds
      runDependencyWatcher = setInterval(function() {
        if (ABORT) {
          clearInterval(runDependencyWatcher);
          runDependencyWatcher = null;
          return;
        }
        var shown = false;
        for (var dep in runDependencyTracking) {
          if (!shown) {
            shown = true;
            err('still waiting on run dependencies:');
          }
          err('dependency: ' + dep);
        }
        if (shown) {
          err('(end of list)');
        }
      }, 10000);
    }
  } else {
    err('warning: run dependency added without ID');
  }
}

function removeRunDependency(id) {
  runDependencies--;

  if (Module['monitorRunDependencies']) {
    Module['monitorRunDependencies'](runDependencies);
  }

  if (id) {
    assert(runDependencyTracking[id]);
    delete runDependencyTracking[id];
  } else {
    err('warning: run dependency removed without ID');
  }
  if (runDependencies == 0) {
    if (runDependencyWatcher !== null) {
      clearInterval(runDependencyWatcher);
      runDependencyWatcher = null;
    }
    if (dependenciesFulfilled) {
      var callback = dependenciesFulfilled;
      dependenciesFulfilled = null;
      callback(); // can add another dependenciesFulfilled
    }
  }
}

Module["preloadedImages"] = {}; // maps url to image data
Module["preloadedAudios"] = {}; // maps url to audio data

/** @param {string|number=} what */
function abort(what) {
  if (Module['onAbort']) {
    Module['onAbort'](what);
  }

  what += '';
  out(what);
  err(what);

  ABORT = true;
  EXITSTATUS = 1;

  var output = 'abort(' + what + ') at ' + stackTrace();
  what = output;

  // Throw a wasm runtime error, because a JS error might be seen as a foreign
  // exception, which means we'd run destructors on it. We need the error to
  // simply make the program stop.
  throw new WebAssembly.RuntimeError(what);
}


var memoryInitializer = null;












function hasPrefix(str, prefix) {
  return String.prototype.startsWith ?
      str.startsWith(prefix) :
      str.indexOf(prefix) === 0;
}

// Prefix of data URIs emitted by SINGLE_FILE and related options.
var dataURIPrefix = 'data:application/octet-stream;base64,';

// Indicates whether filename is a base64 data URI.
function isDataURI(filename) {
  return hasPrefix(filename, dataURIPrefix);
}

var fileURIPrefix = "file://";

// Indicates whether filename is delivered via file protocol (as opposed to http/https)
function isFileURI(filename) {
  return hasPrefix(filename, fileURIPrefix);
}



function createExportWrapper(name, fixedasm) {
  return function() {
    var displayName = name;
    var asm = fixedasm;
    if (!fixedasm) {
      asm = Module['asm'];
    }
    assert(runtimeInitialized, 'native function `' + displayName + '` called before runtime initialization');
    assert(!runtimeExited, 'native function `' + displayName + '` called after runtime exit (use NO_EXIT_RUNTIME to keep it alive after main() exits)');
    if (!asm[name]) {
      assert(asm[name], 'exported native function `' + displayName + '` not found');
    }
    return asm[name].apply(null, arguments);
  };
}

var wasmBinaryFile = 'webpxmux-web.wasm';
if (!isDataURI(wasmBinaryFile)) {
  wasmBinaryFile = locateFile(wasmBinaryFile);
}

function getBinary() {
  try {
    if (wasmBinary) {
      return new Uint8Array(wasmBinary);
    }

    if (readBinary) {
      return readBinary(wasmBinaryFile);
    } else {
      throw "both async and sync fetching of the wasm failed";
    }
  }
  catch (err) {
    abort(err);
  }
}

function getBinaryPromise() {
  // If we don't have the binary yet, and have the Fetch api, use that;
  // in some environments, like Electron's render process, Fetch api may be present, but have a different context than expected, let's only use it on the Web
  if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) && typeof fetch === 'function'
      ) {
    return fetch(wasmBinaryFile, { credentials: 'same-origin' }).then(function(response) {
      if (!response['ok']) {
        throw "failed to load wasm binary file at '" + wasmBinaryFile + "'";
      }
      return response['arrayBuffer']();
    }).catch(function () {
      return getBinary();
    });
  }
  // Otherwise, getBinary should be able to get it synchronously
  return new Promise(function(resolve, reject) {
    resolve(getBinary());
  });
}



// Create the wasm instance.
// Receives the wasm imports, returns the exports.
function createWasm() {
  // prepare imports
  var info = {
    'env': asmLibraryArg,
    'wasi_snapshot_preview1': asmLibraryArg
  };
  // Load the wasm module and create an instance of using native support in the JS engine.
  // handle a generated wasm instance, receiving its exports and
  // performing other necessary setup
  /** @param {WebAssembly.Module=} module*/
  function receiveInstance(instance, module) {
    var exports = instance.exports;
    Module['asm'] = exports;
    removeRunDependency('wasm-instantiate');
  }
  // we can't run yet (except in a pthread, where we have a custom sync instantiator)
  addRunDependency('wasm-instantiate');


  // Async compilation can be confusing when an error on the page overwrites Module
  // (for example, if the order of elements is wrong, and the one defining Module is
  // later), so we save Module and check it later.
  var trueModule = Module;
  function receiveInstantiatedSource(output) {
    // 'output' is a WebAssemblyInstantiatedSource object which has both the module and instance.
    // receiveInstance() will swap in the exports (to Module.asm) so they can be called
    assert(Module === trueModule, 'the Module object should not be replaced during async compilation - perhaps the order of HTML elements is wrong?');
    trueModule = null;
    // TODO: Due to Closure regression https://github.com/google/closure-compiler/issues/3193, the above line no longer optimizes out down to the following line.
    // When the regression is fixed, can restore the above USE_PTHREADS-enabled path.
    receiveInstance(output['instance']);
  }


  function instantiateArrayBuffer(receiver) {
    return getBinaryPromise().then(function(binary) {
      return WebAssembly.instantiate(binary, info);
    }).then(receiver, function(reason) {
      err('failed to asynchronously prepare wasm: ' + reason);


      abort(reason);
    });
  }

  // Prefer streaming instantiation if available.
  function instantiateAsync() {
    if (!wasmBinary &&
        typeof WebAssembly.instantiateStreaming === 'function' &&
        !isDataURI(wasmBinaryFile) &&
        typeof fetch === 'function') {
      fetch(wasmBinaryFile, { credentials: 'same-origin' }).then(function (response) {
        var result = WebAssembly.instantiateStreaming(response, info);
        return result.then(receiveInstantiatedSource, function(reason) {
            // We expect the most common failure cause to be a bad MIME type for the binary,
            // in which case falling back to ArrayBuffer instantiation should work.
            err('wasm streaming compile failed: ' + reason);
            err('falling back to ArrayBuffer instantiation');
            return instantiateArrayBuffer(receiveInstantiatedSource);
          });
      });
    } else {
      return instantiateArrayBuffer(receiveInstantiatedSource);
    }
  }
  // User shell pages can write their own Module.instantiateWasm = function(imports, successCallback) callback
  // to manually instantiate the Wasm module themselves. This allows pages to run the instantiation parallel
  // to any other async startup actions they are performing.
  if (Module['instantiateWasm']) {
    try {
      var exports = Module['instantiateWasm'](info, receiveInstance);
      return exports;
    } catch(e) {
      err('Module.instantiateWasm callback failed with error: ' + e);
      return false;
    }
  }

  instantiateAsync();
  return {}; // no exports yet; we'll fill them in later
}


// Globals used by JS i64 conversions
var tempDouble;
var tempI64;

// === Body ===

var ASM_CONSTS = {
  
};




// STATICTOP = STATIC_BASE + 284288;
/* global initializers */  __ATINIT__.push({ func: function() { ___wasm_call_ctors() } });




/* no memory initializer */
// {{PRE_LIBRARY}}


  function abortStackOverflow(allocSize) {
      abort('Stack overflow! Attempted to allocate ' + allocSize + ' bytes on the stack, but stack has only ' + (STACK_MAX - stackSave() + allocSize) + ' bytes available!');
    }

  function demangle(func) {
      warnOnce('warning: build with  -s DEMANGLE_SUPPORT=1  to link in libcxxabi demangling');
      return func;
    }

  function demangleAll(text) {
      var regex =
        /\b_Z[\w\d_]+/g;
      return text.replace(regex,
        function(x) {
          var y = demangle(x);
          return x === y ? x : (y + ' [' + x + ']');
        });
    }

  function jsStackTrace() {
      var err = new Error();
      if (!err.stack) {
        // IE10+ special cases: It does have callstack info, but it is only populated if an Error object is thrown,
        // so try that as a special-case.
        try {
          throw new Error();
        } catch(e) {
          err = e;
        }
        if (!err.stack) {
          return '(no stack trace available)';
        }
      }
      return err.stack.toString();
    }

  function stackTrace() {
      var js = jsStackTrace();
      if (Module['extraStackTrace']) js += '\n' + Module['extraStackTrace']();
      return demangleAll(js);
    }

  function ___assert_fail(condition, filename, line, func) {
      abort('Assertion failed: ' + UTF8ToString(condition) + ', at: ' + [filename ? UTF8ToString(filename) : 'unknown filename', line, func ? UTF8ToString(func) : 'unknown function']);
    }

  
  
  var _emscripten_get_now;_emscripten_get_now = function() { return performance.now(); }
  ;
  
  var _emscripten_get_now_is_monotonic=true;;
  
  function setErrNo(value) {
      HEAP32[((___errno_location())>>2)]=value;
      return value;
    }function _clock_gettime(clk_id, tp) {
      // int clock_gettime(clockid_t clk_id, struct timespec *tp);
      var now;
      if (clk_id === 0) {
        now = Date.now();
      } else if ((clk_id === 1 || clk_id === 4) && _emscripten_get_now_is_monotonic) {
        now = _emscripten_get_now();
      } else {
        setErrNo(28);
        return -1;
      }
      HEAP32[((tp)>>2)]=(now/1000)|0; // seconds
      HEAP32[(((tp)+(4))>>2)]=((now % 1000)*1000*1000)|0; // nanoseconds
      return 0;
    }function ___clock_gettime(a0,a1
  ) {
  return _clock_gettime(a0,a1);
  }

  
  function _atexit(func, arg) {
      warnOnce('atexit() called, but EXIT_RUNTIME is not set, so atexits() will not be called. set EXIT_RUNTIME to 1 (see the FAQ)');
  
    }function ___cxa_atexit(a0,a1
  ) {
  return _atexit(a0,a1);
  }

  function ___handle_stack_overflow() {
      abort('stack overflow')
    }

  function ___map_file(pathname, size) {
      setErrNo(63);
      return -1;
    }

  
  
  var PATH={splitPath:function(filename) {
        var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
        return splitPathRe.exec(filename).slice(1);
      },normalizeArray:function(parts, allowAboveRoot) {
        // if the path tries to go above the root, `up` ends up > 0
        var up = 0;
        for (var i = parts.length - 1; i >= 0; i--) {
          var last = parts[i];
          if (last === '.') {
            parts.splice(i, 1);
          } else if (last === '..') {
            parts.splice(i, 1);
            up++;
          } else if (up) {
            parts.splice(i, 1);
            up--;
          }
        }
        // if the path is allowed to go above the root, restore leading ..s
        if (allowAboveRoot) {
          for (; up; up--) {
            parts.unshift('..');
          }
        }
        return parts;
      },normalize:function(path) {
        var isAbsolute = path.charAt(0) === '/',
            trailingSlash = path.substr(-1) === '/';
        // Normalize the path
        path = PATH.normalizeArray(path.split('/').filter(function(p) {
          return !!p;
        }), !isAbsolute).join('/');
        if (!path && !isAbsolute) {
          path = '.';
        }
        if (path && trailingSlash) {
          path += '/';
        }
        return (isAbsolute ? '/' : '') + path;
      },dirname:function(path) {
        var result = PATH.splitPath(path),
            root = result[0],
            dir = result[1];
        if (!root && !dir) {
          // No dirname whatsoever
          return '.';
        }
        if (dir) {
          // It has a dirname, strip trailing slash
          dir = dir.substr(0, dir.length - 1);
        }
        return root + dir;
      },basename:function(path) {
        // EMSCRIPTEN return '/'' for '/', not an empty string
        if (path === '/') return '/';
        var lastSlash = path.lastIndexOf('/');
        if (lastSlash === -1) return path;
        return path.substr(lastSlash+1);
      },extname:function(path) {
        return PATH.splitPath(path)[3];
      },join:function() {
        var paths = Array.prototype.slice.call(arguments, 0);
        return PATH.normalize(paths.join('/'));
      },join2:function(l, r) {
        return PATH.normalize(l + '/' + r);
      }};
  
  
  var PATH_FS={resolve:function() {
        var resolvedPath = '',
          resolvedAbsolute = false;
        for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
          var path = (i >= 0) ? arguments[i] : FS.cwd();
          // Skip empty and invalid entries
          if (typeof path !== 'string') {
            throw new TypeError('Arguments to path.resolve must be strings');
          } else if (!path) {
            return ''; // an invalid portion invalidates the whole thing
          }
          resolvedPath = path + '/' + resolvedPath;
          resolvedAbsolute = path.charAt(0) === '/';
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        resolvedPath = PATH.normalizeArray(resolvedPath.split('/').filter(function(p) {
          return !!p;
        }), !resolvedAbsolute).join('/');
        return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
      },relative:function(from, to) {
        from = PATH_FS.resolve(from).substr(1);
        to = PATH_FS.resolve(to).substr(1);
        function trim(arr) {
          var start = 0;
          for (; start < arr.length; start++) {
            if (arr[start] !== '') break;
          }
          var end = arr.length - 1;
          for (; end >= 0; end--) {
            if (arr[end] !== '') break;
          }
          if (start > end) return [];
          return arr.slice(start, end - start + 1);
        }
        var fromParts = trim(from.split('/'));
        var toParts = trim(to.split('/'));
        var length = Math.min(fromParts.length, toParts.length);
        var samePartsLength = length;
        for (var i = 0; i < length; i++) {
          if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
          }
        }
        var outputParts = [];
        for (var i = samePartsLength; i < fromParts.length; i++) {
          outputParts.push('..');
        }
        outputParts = outputParts.concat(toParts.slice(samePartsLength));
        return outputParts.join('/');
      }};
  
  var TTY={ttys:[],init:function () {
        // https://github.com/emscripten-core/emscripten/pull/1555
        // if (ENVIRONMENT_IS_NODE) {
        //   // currently, FS.init does not distinguish if process.stdin is a file or TTY
        //   // device, it always assumes it's a TTY device. because of this, we're forcing
        //   // process.stdin to UTF8 encoding to at least make stdin reading compatible
        //   // with text files until FS.init can be refactored.
        //   process['stdin']['setEncoding']('utf8');
        // }
      },shutdown:function() {
        // https://github.com/emscripten-core/emscripten/pull/1555
        // if (ENVIRONMENT_IS_NODE) {
        //   // inolen: any idea as to why node -e 'process.stdin.read()' wouldn't exit immediately (with process.stdin being a tty)?
        //   // isaacs: because now it's reading from the stream, you've expressed interest in it, so that read() kicks off a _read() which creates a ReadReq operation
        //   // inolen: I thought read() in that case was a synchronous operation that just grabbed some amount of buffered data if it exists?
        //   // isaacs: it is. but it also triggers a _read() call, which calls readStart() on the handle
        //   // isaacs: do process.stdin.pause() and i'd think it'd probably close the pending call
        //   process['stdin']['pause']();
        // }
      },register:function(dev, ops) {
        TTY.ttys[dev] = { input: [], output: [], ops: ops };
        FS.registerDevice(dev, TTY.stream_ops);
      },stream_ops:{open:function(stream) {
          var tty = TTY.ttys[stream.node.rdev];
          if (!tty) {
            throw new FS.ErrnoError(43);
          }
          stream.tty = tty;
          stream.seekable = false;
        },close:function(stream) {
          // flush any pending line data
          stream.tty.ops.flush(stream.tty);
        },flush:function(stream) {
          stream.tty.ops.flush(stream.tty);
        },read:function(stream, buffer, offset, length, pos /* ignored */) {
          if (!stream.tty || !stream.tty.ops.get_char) {
            throw new FS.ErrnoError(60);
          }
          var bytesRead = 0;
          for (var i = 0; i < length; i++) {
            var result;
            try {
              result = stream.tty.ops.get_char(stream.tty);
            } catch (e) {
              throw new FS.ErrnoError(29);
            }
            if (result === undefined && bytesRead === 0) {
              throw new FS.ErrnoError(6);
            }
            if (result === null || result === undefined) break;
            bytesRead++;
            buffer[offset+i] = result;
          }
          if (bytesRead) {
            stream.node.timestamp = Date.now();
          }
          return bytesRead;
        },write:function(stream, buffer, offset, length, pos) {
          if (!stream.tty || !stream.tty.ops.put_char) {
            throw new FS.ErrnoError(60);
          }
          try {
            for (var i = 0; i < length; i++) {
              stream.tty.ops.put_char(stream.tty, buffer[offset+i]);
            }
          } catch (e) {
            throw new FS.ErrnoError(29);
          }
          if (length) {
            stream.node.timestamp = Date.now();
          }
          return i;
        }},default_tty_ops:{get_char:function(tty) {
          if (!tty.input.length) {
            var result = null;
            if (typeof window != 'undefined' &&
              typeof window.prompt == 'function') {
              // Browser.
              result = window.prompt('Input: ');  // returns null on cancel
              if (result !== null) {
                result += '\n';
              }
            } else if (typeof readline == 'function') {
              // Command line.
              result = readline();
              if (result !== null) {
                result += '\n';
              }
            }
            if (!result) {
              return null;
            }
            tty.input = intArrayFromString(result, true);
          }
          return tty.input.shift();
        },put_char:function(tty, val) {
          if (val === null || val === 10) {
            out(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          } else {
            if (val != 0) tty.output.push(val); // val == 0 would cut text output off in the middle.
          }
        },flush:function(tty) {
          if (tty.output && tty.output.length > 0) {
            out(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          }
        }},default_tty1_ops:{put_char:function(tty, val) {
          if (val === null || val === 10) {
            err(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          } else {
            if (val != 0) tty.output.push(val);
          }
        },flush:function(tty) {
          if (tty.output && tty.output.length > 0) {
            err(UTF8ArrayToString(tty.output, 0));
            tty.output = [];
          }
        }}};
  
  var MEMFS={ops_table:null,mount:function(mount) {
        return MEMFS.createNode(null, '/', 16384 | 511 /* 0777 */, 0);
      },createNode:function(parent, name, mode, dev) {
        if (FS.isBlkdev(mode) || FS.isFIFO(mode)) {
          // no supported
          throw new FS.ErrnoError(63);
        }
        if (!MEMFS.ops_table) {
          MEMFS.ops_table = {
            dir: {
              node: {
                getattr: MEMFS.node_ops.getattr,
                setattr: MEMFS.node_ops.setattr,
                lookup: MEMFS.node_ops.lookup,
                mknod: MEMFS.node_ops.mknod,
                rename: MEMFS.node_ops.rename,
                unlink: MEMFS.node_ops.unlink,
                rmdir: MEMFS.node_ops.rmdir,
                readdir: MEMFS.node_ops.readdir,
                symlink: MEMFS.node_ops.symlink
              },
              stream: {
                llseek: MEMFS.stream_ops.llseek
              }
            },
            file: {
              node: {
                getattr: MEMFS.node_ops.getattr,
                setattr: MEMFS.node_ops.setattr
              },
              stream: {
                llseek: MEMFS.stream_ops.llseek,
                read: MEMFS.stream_ops.read,
                write: MEMFS.stream_ops.write,
                allocate: MEMFS.stream_ops.allocate,
                mmap: MEMFS.stream_ops.mmap,
                msync: MEMFS.stream_ops.msync
              }
            },
            link: {
              node: {
                getattr: MEMFS.node_ops.getattr,
                setattr: MEMFS.node_ops.setattr,
                readlink: MEMFS.node_ops.readlink
              },
              stream: {}
            },
            chrdev: {
              node: {
                getattr: MEMFS.node_ops.getattr,
                setattr: MEMFS.node_ops.setattr
              },
              stream: FS.chrdev_stream_ops
            }
          };
        }
        var node = FS.createNode(parent, name, mode, dev);
        if (FS.isDir(node.mode)) {
          node.node_ops = MEMFS.ops_table.dir.node;
          node.stream_ops = MEMFS.ops_table.dir.stream;
          node.contents = {};
        } else if (FS.isFile(node.mode)) {
          node.node_ops = MEMFS.ops_table.file.node;
          node.stream_ops = MEMFS.ops_table.file.stream;
          node.usedBytes = 0; // The actual number of bytes used in the typed array, as opposed to contents.length which gives the whole capacity.
          // When the byte data of the file is populated, this will point to either a typed array, or a normal JS array. Typed arrays are preferred
          // for performance, and used by default. However, typed arrays are not resizable like normal JS arrays are, so there is a small disk size
          // penalty involved for appending file writes that continuously grow a file similar to std::vector capacity vs used -scheme.
          node.contents = null; 
        } else if (FS.isLink(node.mode)) {
          node.node_ops = MEMFS.ops_table.link.node;
          node.stream_ops = MEMFS.ops_table.link.stream;
        } else if (FS.isChrdev(node.mode)) {
          node.node_ops = MEMFS.ops_table.chrdev.node;
          node.stream_ops = MEMFS.ops_table.chrdev.stream;
        }
        node.timestamp = Date.now();
        // add the new node to the parent
        if (parent) {
          parent.contents[name] = node;
        }
        return node;
      },getFileDataAsRegularArray:function(node) {
        if (node.contents && node.contents.subarray) {
          var arr = [];
          for (var i = 0; i < node.usedBytes; ++i) arr.push(node.contents[i]);
          return arr; // Returns a copy of the original data.
        }
        return node.contents; // No-op, the file contents are already in a JS array. Return as-is.
      },getFileDataAsTypedArray:function(node) {
        if (!node.contents) return new Uint8Array(0);
        if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes); // Make sure to not return excess unused bytes.
        return new Uint8Array(node.contents);
      },expandFileStorage:function(node, newCapacity) {
        var prevCapacity = node.contents ? node.contents.length : 0;
        if (prevCapacity >= newCapacity) return; // No need to expand, the storage was already large enough.
        // Don't expand strictly to the given requested limit if it's only a very small increase, but instead geometrically grow capacity.
        // For small filesizes (<1MB), perform size*2 geometric increase, but for large sizes, do a much more conservative size*1.125 increase to
        // avoid overshooting the allocation cap by a very large margin.
        var CAPACITY_DOUBLING_MAX = 1024 * 1024;
        newCapacity = Math.max(newCapacity, (prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2.0 : 1.125)) >>> 0);
        if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256); // At minimum allocate 256b for each file when expanding.
        var oldContents = node.contents;
        node.contents = new Uint8Array(newCapacity); // Allocate new storage.
        if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0); // Copy old data over to the new storage.
        return;
      },resizeFileStorage:function(node, newSize) {
        if (node.usedBytes == newSize) return;
        if (newSize == 0) {
          node.contents = null; // Fully decommit when requesting a resize to zero.
          node.usedBytes = 0;
          return;
        }
        if (!node.contents || node.contents.subarray) { // Resize a typed array if that is being used as the backing store.
          var oldContents = node.contents;
          node.contents = new Uint8Array(newSize); // Allocate new storage.
          if (oldContents) {
            node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes))); // Copy old data over to the new storage.
          }
          node.usedBytes = newSize;
          return;
        }
        // Backing with a JS array.
        if (!node.contents) node.contents = [];
        if (node.contents.length > newSize) node.contents.length = newSize;
        else while (node.contents.length < newSize) node.contents.push(0);
        node.usedBytes = newSize;
      },node_ops:{getattr:function(node) {
          var attr = {};
          // device numbers reuse inode numbers.
          attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
          attr.ino = node.id;
          attr.mode = node.mode;
          attr.nlink = 1;
          attr.uid = 0;
          attr.gid = 0;
          attr.rdev = node.rdev;
          if (FS.isDir(node.mode)) {
            attr.size = 4096;
          } else if (FS.isFile(node.mode)) {
            attr.size = node.usedBytes;
          } else if (FS.isLink(node.mode)) {
            attr.size = node.link.length;
          } else {
            attr.size = 0;
          }
          attr.atime = new Date(node.timestamp);
          attr.mtime = new Date(node.timestamp);
          attr.ctime = new Date(node.timestamp);
          // NOTE: In our implementation, st_blocks = Math.ceil(st_size/st_blksize),
          //       but this is not required by the standard.
          attr.blksize = 4096;
          attr.blocks = Math.ceil(attr.size / attr.blksize);
          return attr;
        },setattr:function(node, attr) {
          if (attr.mode !== undefined) {
            node.mode = attr.mode;
          }
          if (attr.timestamp !== undefined) {
            node.timestamp = attr.timestamp;
          }
          if (attr.size !== undefined) {
            MEMFS.resizeFileStorage(node, attr.size);
          }
        },lookup:function(parent, name) {
          throw FS.genericErrors[44];
        },mknod:function(parent, name, mode, dev) {
          return MEMFS.createNode(parent, name, mode, dev);
        },rename:function(old_node, new_dir, new_name) {
          // if we're overwriting a directory at new_name, make sure it's empty.
          if (FS.isDir(old_node.mode)) {
            var new_node;
            try {
              new_node = FS.lookupNode(new_dir, new_name);
            } catch (e) {
            }
            if (new_node) {
              for (var i in new_node.contents) {
                throw new FS.ErrnoError(55);
              }
            }
          }
          // do the internal rewiring
          delete old_node.parent.contents[old_node.name];
          old_node.name = new_name;
          new_dir.contents[new_name] = old_node;
          old_node.parent = new_dir;
        },unlink:function(parent, name) {
          delete parent.contents[name];
        },rmdir:function(parent, name) {
          var node = FS.lookupNode(parent, name);
          for (var i in node.contents) {
            throw new FS.ErrnoError(55);
          }
          delete parent.contents[name];
        },readdir:function(node) {
          var entries = ['.', '..'];
          for (var key in node.contents) {
            if (!node.contents.hasOwnProperty(key)) {
              continue;
            }
            entries.push(key);
          }
          return entries;
        },symlink:function(parent, newname, oldpath) {
          var node = MEMFS.createNode(parent, newname, 511 /* 0777 */ | 40960, 0);
          node.link = oldpath;
          return node;
        },readlink:function(node) {
          if (!FS.isLink(node.mode)) {
            throw new FS.ErrnoError(28);
          }
          return node.link;
        }},stream_ops:{read:function(stream, buffer, offset, length, position) {
          var contents = stream.node.contents;
          if (position >= stream.node.usedBytes) return 0;
          var size = Math.min(stream.node.usedBytes - position, length);
          assert(size >= 0);
          if (size > 8 && contents.subarray) { // non-trivial, and typed array
            buffer.set(contents.subarray(position, position + size), offset);
          } else {
            for (var i = 0; i < size; i++) buffer[offset + i] = contents[position + i];
          }
          return size;
        },write:function(stream, buffer, offset, length, position, canOwn) {
          // The data buffer should be a typed array view
          assert(!(buffer instanceof ArrayBuffer));
          // If the buffer is located in main memory (HEAP), and if
          // memory can grow, we can't hold on to references of the
          // memory buffer, as they may get invalidated. That means we
          // need to do copy its contents.
          if (buffer.buffer === HEAP8.buffer) {
            // FIXME: this is inefficient as the file packager may have
            //        copied the data into memory already - we may want to
            //        integrate more there and let the file packager loading
            //        code be able to query if memory growth is on or off.
            if (canOwn) {
              warnOnce('file packager has copied file data into memory, but in memory growth we are forced to copy it again (see --no-heap-copy)');
            }
            canOwn = false;
          }
  
          if (!length) return 0;
          var node = stream.node;
          node.timestamp = Date.now();
  
          if (buffer.subarray && (!node.contents || node.contents.subarray)) { // This write is from a typed array to a typed array?
            if (canOwn) {
              assert(position === 0, 'canOwn must imply no weird position inside the file');
              node.contents = buffer.subarray(offset, offset + length);
              node.usedBytes = length;
              return length;
            } else if (node.usedBytes === 0 && position === 0) { // If this is a simple first write to an empty file, do a fast set since we don't need to care about old data.
              node.contents = buffer.slice(offset, offset + length);
              node.usedBytes = length;
              return length;
            } else if (position + length <= node.usedBytes) { // Writing to an already allocated and used subrange of the file?
              node.contents.set(buffer.subarray(offset, offset + length), position);
              return length;
            }
          }
  
          // Appending to an existing file and we need to reallocate, or source data did not come as a typed array.
          MEMFS.expandFileStorage(node, position+length);
          if (node.contents.subarray && buffer.subarray) node.contents.set(buffer.subarray(offset, offset + length), position); // Use typed array write if available.
          else {
            for (var i = 0; i < length; i++) {
             node.contents[position + i] = buffer[offset + i]; // Or fall back to manual write if not.
            }
          }
          node.usedBytes = Math.max(node.usedBytes, position + length);
          return length;
        },llseek:function(stream, offset, whence) {
          var position = offset;
          if (whence === 1) {
            position += stream.position;
          } else if (whence === 2) {
            if (FS.isFile(stream.node.mode)) {
              position += stream.node.usedBytes;
            }
          }
          if (position < 0) {
            throw new FS.ErrnoError(28);
          }
          return position;
        },allocate:function(stream, offset, length) {
          MEMFS.expandFileStorage(stream.node, offset + length);
          stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
        },mmap:function(stream, address, length, position, prot, flags) {
          // We don't currently support location hints for the address of the mapping
          assert(address === 0);
  
          if (!FS.isFile(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          var ptr;
          var allocated;
          var contents = stream.node.contents;
          // Only make a new copy when MAP_PRIVATE is specified.
          if (!(flags & 2) && contents.buffer === buffer) {
            // We can't emulate MAP_SHARED when the file is not backed by the buffer
            // we're mapping to (e.g. the HEAP buffer).
            allocated = false;
            ptr = contents.byteOffset;
          } else {
            // Try to avoid unnecessary slices.
            if (position > 0 || position + length < contents.length) {
              if (contents.subarray) {
                contents = contents.subarray(position, position + length);
              } else {
                contents = Array.prototype.slice.call(contents, position, position + length);
              }
            }
            allocated = true;
            ptr = _malloc(length);
            if (!ptr) {
              throw new FS.ErrnoError(48);
            }
            HEAP8.set(contents, ptr);
          }
          return { ptr: ptr, allocated: allocated };
        },msync:function(stream, buffer, offset, length, mmapFlags) {
          if (!FS.isFile(stream.node.mode)) {
            throw new FS.ErrnoError(43);
          }
          if (mmapFlags & 2) {
            // MAP_PRIVATE calls need not to be synced back to underlying fs
            return 0;
          }
  
          var bytesWritten = MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
          // should we check if bytesWritten and length are the same?
          return 0;
        }}};
  
  var ERRNO_MESSAGES={0:"Success",1:"Arg list too long",2:"Permission denied",3:"Address already in use",4:"Address not available",5:"Address family not supported by protocol family",6:"No more processes",7:"Socket already connected",8:"Bad file number",9:"Trying to read unreadable message",10:"Mount device busy",11:"Operation canceled",12:"No children",13:"Connection aborted",14:"Connection refused",15:"Connection reset by peer",16:"File locking deadlock error",17:"Destination address required",18:"Math arg out of domain of func",19:"Quota exceeded",20:"File exists",21:"Bad address",22:"File too large",23:"Host is unreachable",24:"Identifier removed",25:"Illegal byte sequence",26:"Connection already in progress",27:"Interrupted system call",28:"Invalid argument",29:"I/O error",30:"Socket is already connected",31:"Is a directory",32:"Too many symbolic links",33:"Too many open files",34:"Too many links",35:"Message too long",36:"Multihop attempted",37:"File or path name too long",38:"Network interface is not configured",39:"Connection reset by network",40:"Network is unreachable",41:"Too many open files in system",42:"No buffer space available",43:"No such device",44:"No such file or directory",45:"Exec format error",46:"No record locks available",47:"The link has been severed",48:"Not enough core",49:"No message of desired type",50:"Protocol not available",51:"No space left on device",52:"Function not implemented",53:"Socket is not connected",54:"Not a directory",55:"Directory not empty",56:"State not recoverable",57:"Socket operation on non-socket",59:"Not a typewriter",60:"No such device or address",61:"Value too large for defined data type",62:"Previous owner died",63:"Not super-user",64:"Broken pipe",65:"Protocol error",66:"Unknown protocol",67:"Protocol wrong type for socket",68:"Math result not representable",69:"Read only file system",70:"Illegal seek",71:"No such process",72:"Stale file handle",73:"Connection timed out",74:"Text file busy",75:"Cross-device link",100:"Device not a stream",101:"Bad font file fmt",102:"Invalid slot",103:"Invalid request code",104:"No anode",105:"Block device required",106:"Channel number out of range",107:"Level 3 halted",108:"Level 3 reset",109:"Link number out of range",110:"Protocol driver not attached",111:"No CSI structure available",112:"Level 2 halted",113:"Invalid exchange",114:"Invalid request descriptor",115:"Exchange full",116:"No data (for no delay io)",117:"Timer expired",118:"Out of streams resources",119:"Machine is not on the network",120:"Package not installed",121:"The object is remote",122:"Advertise error",123:"Srmount error",124:"Communication error on send",125:"Cross mount point (not really error)",126:"Given log. name not unique",127:"f.d. invalid for this operation",128:"Remote address changed",129:"Can   access a needed shared lib",130:"Accessing a corrupted shared lib",131:".lib section in a.out corrupted",132:"Attempting to link in too many libs",133:"Attempting to exec a shared library",135:"Streams pipe error",136:"Too many users",137:"Socket type not supported",138:"Not supported",139:"Protocol family not supported",140:"Can't send after socket shutdown",141:"Too many references",142:"Host is down",148:"No medium (in tape drive)",156:"Level 2 not synchronized"};
  
  var ERRNO_CODES={EPERM:63,ENOENT:44,ESRCH:71,EINTR:27,EIO:29,ENXIO:60,E2BIG:1,ENOEXEC:45,EBADF:8,ECHILD:12,EAGAIN:6,EWOULDBLOCK:6,ENOMEM:48,EACCES:2,EFAULT:21,ENOTBLK:105,EBUSY:10,EEXIST:20,EXDEV:75,ENODEV:43,ENOTDIR:54,EISDIR:31,EINVAL:28,ENFILE:41,EMFILE:33,ENOTTY:59,ETXTBSY:74,EFBIG:22,ENOSPC:51,ESPIPE:70,EROFS:69,EMLINK:34,EPIPE:64,EDOM:18,ERANGE:68,ENOMSG:49,EIDRM:24,ECHRNG:106,EL2NSYNC:156,EL3HLT:107,EL3RST:108,ELNRNG:109,EUNATCH:110,ENOCSI:111,EL2HLT:112,EDEADLK:16,ENOLCK:46,EBADE:113,EBADR:114,EXFULL:115,ENOANO:104,EBADRQC:103,EBADSLT:102,EDEADLOCK:16,EBFONT:101,ENOSTR:100,ENODATA:116,ETIME:117,ENOSR:118,ENONET:119,ENOPKG:120,EREMOTE:121,ENOLINK:47,EADV:122,ESRMNT:123,ECOMM:124,EPROTO:65,EMULTIHOP:36,EDOTDOT:125,EBADMSG:9,ENOTUNIQ:126,EBADFD:127,EREMCHG:128,ELIBACC:129,ELIBBAD:130,ELIBSCN:131,ELIBMAX:132,ELIBEXEC:133,ENOSYS:52,ENOTEMPTY:55,ENAMETOOLONG:37,ELOOP:32,EOPNOTSUPP:138,EPFNOSUPPORT:139,ECONNRESET:15,ENOBUFS:42,EAFNOSUPPORT:5,EPROTOTYPE:67,ENOTSOCK:57,ENOPROTOOPT:50,ESHUTDOWN:140,ECONNREFUSED:14,EADDRINUSE:3,ECONNABORTED:13,ENETUNREACH:40,ENETDOWN:38,ETIMEDOUT:73,EHOSTDOWN:142,EHOSTUNREACH:23,EINPROGRESS:26,EALREADY:7,EDESTADDRREQ:17,EMSGSIZE:35,EPROTONOSUPPORT:66,ESOCKTNOSUPPORT:137,EADDRNOTAVAIL:4,ENETRESET:39,EISCONN:30,ENOTCONN:53,ETOOMANYREFS:141,EUSERS:136,EDQUOT:19,ESTALE:72,ENOTSUP:138,ENOMEDIUM:148,EILSEQ:25,EOVERFLOW:61,ECANCELED:11,ENOTRECOVERABLE:56,EOWNERDEAD:62,ESTRPIPE:135};var FS={root:null,mounts:[],devices:{},streams:[],nextInode:1,nameTable:null,currentPath:"/",initialized:false,ignorePermissions:true,trackingDelegate:{},tracking:{openFlags:{READ:1,WRITE:2}},ErrnoError:null,genericErrors:{},filesystems:null,syncFSRequests:0,handleFSError:function(e) {
        if (!(e instanceof FS.ErrnoError)) throw e + ' : ' + stackTrace();
        return setErrNo(e.errno);
      },lookupPath:function(path, opts) {
        path = PATH_FS.resolve(FS.cwd(), path);
        opts = opts || {};
  
        if (!path) return { path: '', node: null };
  
        var defaults = {
          follow_mount: true,
          recurse_count: 0
        };
        for (var key in defaults) {
          if (opts[key] === undefined) {
            opts[key] = defaults[key];
          }
        }
  
        if (opts.recurse_count > 8) {  // max recursive lookup of 8
          throw new FS.ErrnoError(32);
        }
  
        // split the path
        var parts = PATH.normalizeArray(path.split('/').filter(function(p) {
          return !!p;
        }), false);
  
        // start at the root
        var current = FS.root;
        var current_path = '/';
  
        for (var i = 0; i < parts.length; i++) {
          var islast = (i === parts.length-1);
          if (islast && opts.parent) {
            // stop resolving
            break;
          }
  
          current = FS.lookupNode(current, parts[i]);
          current_path = PATH.join2(current_path, parts[i]);
  
          // jump to the mount's root node if this is a mountpoint
          if (FS.isMountpoint(current)) {
            if (!islast || (islast && opts.follow_mount)) {
              current = current.mounted.root;
            }
          }
  
          // by default, lookupPath will not follow a symlink if it is the final path component.
          // setting opts.follow = true will override this behavior.
          if (!islast || opts.follow) {
            var count = 0;
            while (FS.isLink(current.mode)) {
              var link = FS.readlink(current_path);
              current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
  
              var lookup = FS.lookupPath(current_path, { recurse_count: opts.recurse_count });
              current = lookup.node;
  
              if (count++ > 40) {  // limit max consecutive symlinks to 40 (SYMLOOP_MAX).
                throw new FS.ErrnoError(32);
              }
            }
          }
        }
  
        return { path: current_path, node: current };
      },getPath:function(node) {
        var path;
        while (true) {
          if (FS.isRoot(node)) {
            var mount = node.mount.mountpoint;
            if (!path) return mount;
            return mount[mount.length-1] !== '/' ? mount + '/' + path : mount + path;
          }
          path = path ? node.name + '/' + path : node.name;
          node = node.parent;
        }
      },hashName:function(parentid, name) {
        var hash = 0;
  
  
        for (var i = 0; i < name.length; i++) {
          hash = ((hash << 5) - hash + name.charCodeAt(i)) | 0;
        }
        return ((parentid + hash) >>> 0) % FS.nameTable.length;
      },hashAddNode:function(node) {
        var hash = FS.hashName(node.parent.id, node.name);
        node.name_next = FS.nameTable[hash];
        FS.nameTable[hash] = node;
      },hashRemoveNode:function(node) {
        var hash = FS.hashName(node.parent.id, node.name);
        if (FS.nameTable[hash] === node) {
          FS.nameTable[hash] = node.name_next;
        } else {
          var current = FS.nameTable[hash];
          while (current) {
            if (current.name_next === node) {
              current.name_next = node.name_next;
              break;
            }
            current = current.name_next;
          }
        }
      },lookupNode:function(parent, name) {
        var errCode = FS.mayLookup(parent);
        if (errCode) {
          throw new FS.ErrnoError(errCode, parent);
        }
        var hash = FS.hashName(parent.id, name);
        for (var node = FS.nameTable[hash]; node; node = node.name_next) {
          var nodeName = node.name;
          if (node.parent.id === parent.id && nodeName === name) {
            return node;
          }
        }
        // if we failed to find it in the cache, call into the VFS
        return FS.lookup(parent, name);
      },createNode:function(parent, name, mode, rdev) {
        var node = new FS.FSNode(parent, name, mode, rdev);
  
        FS.hashAddNode(node);
  
        return node;
      },destroyNode:function(node) {
        FS.hashRemoveNode(node);
      },isRoot:function(node) {
        return node === node.parent;
      },isMountpoint:function(node) {
        return !!node.mounted;
      },isFile:function(mode) {
        return (mode & 61440) === 32768;
      },isDir:function(mode) {
        return (mode & 61440) === 16384;
      },isLink:function(mode) {
        return (mode & 61440) === 40960;
      },isChrdev:function(mode) {
        return (mode & 61440) === 8192;
      },isBlkdev:function(mode) {
        return (mode & 61440) === 24576;
      },isFIFO:function(mode) {
        return (mode & 61440) === 4096;
      },isSocket:function(mode) {
        return (mode & 49152) === 49152;
      },flagModes:{"r":0,"rs":1052672,"r+":2,"w":577,"wx":705,"xw":705,"w+":578,"wx+":706,"xw+":706,"a":1089,"ax":1217,"xa":1217,"a+":1090,"ax+":1218,"xa+":1218},modeStringToFlags:function(str) {
        var flags = FS.flagModes[str];
        if (typeof flags === 'undefined') {
          throw new Error('Unknown file open mode: ' + str);
        }
        return flags;
      },flagsToPermissionString:function(flag) {
        var perms = ['r', 'w', 'rw'][flag & 3];
        if ((flag & 512)) {
          perms += 'w';
        }
        return perms;
      },nodePermissions:function(node, perms) {
        if (FS.ignorePermissions) {
          return 0;
        }
        // return 0 if any user, group or owner bits are set.
        if (perms.indexOf('r') !== -1 && !(node.mode & 292)) {
          return 2;
        } else if (perms.indexOf('w') !== -1 && !(node.mode & 146)) {
          return 2;
        } else if (perms.indexOf('x') !== -1 && !(node.mode & 73)) {
          return 2;
        }
        return 0;
      },mayLookup:function(dir) {
        var errCode = FS.nodePermissions(dir, 'x');
        if (errCode) return errCode;
        if (!dir.node_ops.lookup) return 2;
        return 0;
      },mayCreate:function(dir, name) {
        try {
          var node = FS.lookupNode(dir, name);
          return 20;
        } catch (e) {
        }
        return FS.nodePermissions(dir, 'wx');
      },mayDelete:function(dir, name, isdir) {
        var node;
        try {
          node = FS.lookupNode(dir, name);
        } catch (e) {
          return e.errno;
        }
        var errCode = FS.nodePermissions(dir, 'wx');
        if (errCode) {
          return errCode;
        }
        if (isdir) {
          if (!FS.isDir(node.mode)) {
            return 54;
          }
          if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) {
            return 10;
          }
        } else {
          if (FS.isDir(node.mode)) {
            return 31;
          }
        }
        return 0;
      },mayOpen:function(node, flags) {
        if (!node) {
          return 44;
        }
        if (FS.isLink(node.mode)) {
          return 32;
        } else if (FS.isDir(node.mode)) {
          if (FS.flagsToPermissionString(flags) !== 'r' || // opening for write
              (flags & 512)) { // TODO: check for O_SEARCH? (== search for dir only)
            return 31;
          }
        }
        return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
      },MAX_OPEN_FDS:4096,nextfd:function(fd_start, fd_end) {
        fd_start = fd_start || 0;
        fd_end = fd_end || FS.MAX_OPEN_FDS;
        for (var fd = fd_start; fd <= fd_end; fd++) {
          if (!FS.streams[fd]) {
            return fd;
          }
        }
        throw new FS.ErrnoError(33);
      },getStream:function(fd) {
        return FS.streams[fd];
      },createStream:function(stream, fd_start, fd_end) {
        if (!FS.FSStream) {
          FS.FSStream = /** @constructor */ function(){};
          FS.FSStream.prototype = {
            object: {
              get: function() { return this.node; },
              set: function(val) { this.node = val; }
            },
            isRead: {
              get: function() { return (this.flags & 2097155) !== 1; }
            },
            isWrite: {
              get: function() { return (this.flags & 2097155) !== 0; }
            },
            isAppend: {
              get: function() { return (this.flags & 1024); }
            }
          };
        }
        // clone it, so we can return an instance of FSStream
        var newStream = new FS.FSStream();
        for (var p in stream) {
          newStream[p] = stream[p];
        }
        stream = newStream;
        var fd = FS.nextfd(fd_start, fd_end);
        stream.fd = fd;
        FS.streams[fd] = stream;
        return stream;
      },closeStream:function(fd) {
        FS.streams[fd] = null;
      },chrdev_stream_ops:{open:function(stream) {
          var device = FS.getDevice(stream.node.rdev);
          // override node's stream ops with the device's
          stream.stream_ops = device.stream_ops;
          // forward the open call
          if (stream.stream_ops.open) {
            stream.stream_ops.open(stream);
          }
        },llseek:function() {
          throw new FS.ErrnoError(70);
        }},major:function(dev) {
        return ((dev) >> 8);
      },minor:function(dev) {
        return ((dev) & 0xff);
      },makedev:function(ma, mi) {
        return ((ma) << 8 | (mi));
      },registerDevice:function(dev, ops) {
        FS.devices[dev] = { stream_ops: ops };
      },getDevice:function(dev) {
        return FS.devices[dev];
      },getMounts:function(mount) {
        var mounts = [];
        var check = [mount];
  
        while (check.length) {
          var m = check.pop();
  
          mounts.push(m);
  
          check.push.apply(check, m.mounts);
        }
  
        return mounts;
      },syncfs:function(populate, callback) {
        if (typeof(populate) === 'function') {
          callback = populate;
          populate = false;
        }
  
        FS.syncFSRequests++;
  
        if (FS.syncFSRequests > 1) {
          err('warning: ' + FS.syncFSRequests + ' FS.syncfs operations in flight at once, probably just doing extra work');
        }
  
        var mounts = FS.getMounts(FS.root.mount);
        var completed = 0;
  
        function doCallback(errCode) {
          assert(FS.syncFSRequests > 0);
          FS.syncFSRequests--;
          return callback(errCode);
        }
  
        function done(errCode) {
          if (errCode) {
            if (!done.errored) {
              done.errored = true;
              return doCallback(errCode);
            }
            return;
          }
          if (++completed >= mounts.length) {
            doCallback(null);
          }
        };
  
        // sync all mounts
        mounts.forEach(function (mount) {
          if (!mount.type.syncfs) {
            return done(null);
          }
          mount.type.syncfs(mount, populate, done);
        });
      },mount:function(type, opts, mountpoint) {
        if (typeof type === 'string') {
          // The filesystem was not included, and instead we have an error
          // message stored in the variable.
          throw type;
        }
        var root = mountpoint === '/';
        var pseudo = !mountpoint;
        var node;
  
        if (root && FS.root) {
          throw new FS.ErrnoError(10);
        } else if (!root && !pseudo) {
          var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
  
          mountpoint = lookup.path;  // use the absolute path
          node = lookup.node;
  
          if (FS.isMountpoint(node)) {
            throw new FS.ErrnoError(10);
          }
  
          if (!FS.isDir(node.mode)) {
            throw new FS.ErrnoError(54);
          }
        }
  
        var mount = {
          type: type,
          opts: opts,
          mountpoint: mountpoint,
          mounts: []
        };
  
        // create a root node for the fs
        var mountRoot = type.mount(mount);
        mountRoot.mount = mount;
        mount.root = mountRoot;
  
        if (root) {
          FS.root = mountRoot;
        } else if (node) {
          // set as a mountpoint
          node.mounted = mount;
  
          // add the new mount to the current mount's children
          if (node.mount) {
            node.mount.mounts.push(mount);
          }
        }
  
        return mountRoot;
      },unmount:function (mountpoint) {
        var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
  
        if (!FS.isMountpoint(lookup.node)) {
          throw new FS.ErrnoError(28);
        }
  
        // destroy the nodes for this mount, and all its child mounts
        var node = lookup.node;
        var mount = node.mounted;
        var mounts = FS.getMounts(mount);
  
        Object.keys(FS.nameTable).forEach(function (hash) {
          var current = FS.nameTable[hash];
  
          while (current) {
            var next = current.name_next;
  
            if (mounts.indexOf(current.mount) !== -1) {
              FS.destroyNode(current);
            }
  
            current = next;
          }
        });
  
        // no longer a mountpoint
        node.mounted = null;
  
        // remove this mount from the child mounts
        var idx = node.mount.mounts.indexOf(mount);
        assert(idx !== -1);
        node.mount.mounts.splice(idx, 1);
      },lookup:function(parent, name) {
        return parent.node_ops.lookup(parent, name);
      },mknod:function(path, mode, dev) {
        var lookup = FS.lookupPath(path, { parent: true });
        var parent = lookup.node;
        var name = PATH.basename(path);
        if (!name || name === '.' || name === '..') {
          throw new FS.ErrnoError(28);
        }
        var errCode = FS.mayCreate(parent, name);
        if (errCode) {
          throw new FS.ErrnoError(errCode);
        }
        if (!parent.node_ops.mknod) {
          throw new FS.ErrnoError(63);
        }
        return parent.node_ops.mknod(parent, name, mode, dev);
      },create:function(path, mode) {
        mode = mode !== undefined ? mode : 438 /* 0666 */;
        mode &= 4095;
        mode |= 32768;
        return FS.mknod(path, mode, 0);
      },mkdir:function(path, mode) {
        mode = mode !== undefined ? mode : 511 /* 0777 */;
        mode &= 511 | 512;
        mode |= 16384;
        return FS.mknod(path, mode, 0);
      },mkdirTree:function(path, mode) {
        var dirs = path.split('/');
        var d = '';
        for (var i = 0; i < dirs.length; ++i) {
          if (!dirs[i]) continue;
          d += '/' + dirs[i];
          try {
            FS.mkdir(d, mode);
          } catch(e) {
            if (e.errno != 20) throw e;
          }
        }
      },mkdev:function(path, mode, dev) {
        if (typeof(dev) === 'undefined') {
          dev = mode;
          mode = 438 /* 0666 */;
        }
        mode |= 8192;
        return FS.mknod(path, mode, dev);
      },symlink:function(oldpath, newpath) {
        if (!PATH_FS.resolve(oldpath)) {
          throw new FS.ErrnoError(44);
        }
        var lookup = FS.lookupPath(newpath, { parent: true });
        var parent = lookup.node;
        if (!parent) {
          throw new FS.ErrnoError(44);
        }
        var newname = PATH.basename(newpath);
        var errCode = FS.mayCreate(parent, newname);
        if (errCode) {
          throw new FS.ErrnoError(errCode);
        }
        if (!parent.node_ops.symlink) {
          throw new FS.ErrnoError(63);
        }
        return parent.node_ops.symlink(parent, newname, oldpath);
      },rename:function(old_path, new_path) {
        var old_dirname = PATH.dirname(old_path);
        var new_dirname = PATH.dirname(new_path);
        var old_name = PATH.basename(old_path);
        var new_name = PATH.basename(new_path);
        // parents must exist
        var lookup, old_dir, new_dir;
        try {
          lookup = FS.lookupPath(old_path, { parent: true });
          old_dir = lookup.node;
          lookup = FS.lookupPath(new_path, { parent: true });
          new_dir = lookup.node;
        } catch (e) {
          throw new FS.ErrnoError(10);
        }
        if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
        // need to be part of the same mount
        if (old_dir.mount !== new_dir.mount) {
          throw new FS.ErrnoError(75);
        }
        // source must exist
        var old_node = FS.lookupNode(old_dir, old_name);
        // old path should not be an ancestor of the new path
        var relative = PATH_FS.relative(old_path, new_dirname);
        if (relative.charAt(0) !== '.') {
          throw new FS.ErrnoError(28);
        }
        // new path should not be an ancestor of the old path
        relative = PATH_FS.relative(new_path, old_dirname);
        if (relative.charAt(0) !== '.') {
          throw new FS.ErrnoError(55);
        }
        // see if the new path already exists
        var new_node;
        try {
          new_node = FS.lookupNode(new_dir, new_name);
        } catch (e) {
          // not fatal
        }
        // early out if nothing needs to change
        if (old_node === new_node) {
          return;
        }
        // we'll need to delete the old entry
        var isdir = FS.isDir(old_node.mode);
        var errCode = FS.mayDelete(old_dir, old_name, isdir);
        if (errCode) {
          throw new FS.ErrnoError(errCode);
        }
        // need delete permissions if we'll be overwriting.
        // need create permissions if new doesn't already exist.
        errCode = new_node ?
          FS.mayDelete(new_dir, new_name, isdir) :
          FS.mayCreate(new_dir, new_name);
        if (errCode) {
          throw new FS.ErrnoError(errCode);
        }
        if (!old_dir.node_ops.rename) {
          throw new FS.ErrnoError(63);
        }
        if (FS.isMountpoint(old_node) || (new_node && FS.isMountpoint(new_node))) {
          throw new FS.ErrnoError(10);
        }
        // if we are going to change the parent, check write permissions
        if (new_dir !== old_dir) {
          errCode = FS.nodePermissions(old_dir, 'w');
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
        }
        try {
          if (FS.trackingDelegate['willMovePath']) {
            FS.trackingDelegate['willMovePath'](old_path, new_path);
          }
        } catch(e) {
          err("FS.trackingDelegate['willMovePath']('"+old_path+"', '"+new_path+"') threw an exception: " + e.message);
        }
        // remove the node from the lookup hash
        FS.hashRemoveNode(old_node);
        // do the underlying fs rename
        try {
          old_dir.node_ops.rename(old_node, new_dir, new_name);
        } catch (e) {
          throw e;
        } finally {
          // add the node back to the hash (in case node_ops.rename
          // changed its name)
          FS.hashAddNode(old_node);
        }
        try {
          if (FS.trackingDelegate['onMovePath']) FS.trackingDelegate['onMovePath'](old_path, new_path);
        } catch(e) {
          err("FS.trackingDelegate['onMovePath']('"+old_path+"', '"+new_path+"') threw an exception: " + e.message);
        }
      },rmdir:function(path) {
        var lookup = FS.lookupPath(path, { parent: true });
        var parent = lookup.node;
        var name = PATH.basename(path);
        var node = FS.lookupNode(parent, name);
        var errCode = FS.mayDelete(parent, name, true);
        if (errCode) {
          throw new FS.ErrnoError(errCode);
        }
        if (!parent.node_ops.rmdir) {
          throw new FS.ErrnoError(63);
        }
        if (FS.isMountpoint(node)) {
          throw new FS.ErrnoError(10);
        }
        try {
          if (FS.trackingDelegate['willDeletePath']) {
            FS.trackingDelegate['willDeletePath'](path);
          }
        } catch(e) {
          err("FS.trackingDelegate['willDeletePath']('"+path+"') threw an exception: " + e.message);
        }
        parent.node_ops.rmdir(parent, name);
        FS.destroyNode(node);
        try {
          if (FS.trackingDelegate['onDeletePath']) FS.trackingDelegate['onDeletePath'](path);
        } catch(e) {
          err("FS.trackingDelegate['onDeletePath']('"+path+"') threw an exception: " + e.message);
        }
      },readdir:function(path) {
        var lookup = FS.lookupPath(path, { follow: true });
        var node = lookup.node;
        if (!node.node_ops.readdir) {
          throw new FS.ErrnoError(54);
        }
        return node.node_ops.readdir(node);
      },unlink:function(path) {
        var lookup = FS.lookupPath(path, { parent: true });
        var parent = lookup.node;
        var name = PATH.basename(path);
        var node = FS.lookupNode(parent, name);
        var errCode = FS.mayDelete(parent, name, false);
        if (errCode) {
          // According to POSIX, we should map EISDIR to EPERM, but
          // we instead do what Linux does (and we must, as we use
          // the musl linux libc).
          throw new FS.ErrnoError(errCode);
        }
        if (!parent.node_ops.unlink) {
          throw new FS.ErrnoError(63);
        }
        if (FS.isMountpoint(node)) {
          throw new FS.ErrnoError(10);
        }
        try {
          if (FS.trackingDelegate['willDeletePath']) {
            FS.trackingDelegate['willDeletePath'](path);
          }
        } catch(e) {
          err("FS.trackingDelegate['willDeletePath']('"+path+"') threw an exception: " + e.message);
        }
        parent.node_ops.unlink(parent, name);
        FS.destroyNode(node);
        try {
          if (FS.trackingDelegate['onDeletePath']) FS.trackingDelegate['onDeletePath'](path);
        } catch(e) {
          err("FS.trackingDelegate['onDeletePath']('"+path+"') threw an exception: " + e.message);
        }
      },readlink:function(path) {
        var lookup = FS.lookupPath(path);
        var link = lookup.node;
        if (!link) {
          throw new FS.ErrnoError(44);
        }
        if (!link.node_ops.readlink) {
          throw new FS.ErrnoError(28);
        }
        return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
      },stat:function(path, dontFollow) {
        var lookup = FS.lookupPath(path, { follow: !dontFollow });
        var node = lookup.node;
        if (!node) {
          throw new FS.ErrnoError(44);
        }
        if (!node.node_ops.getattr) {
          throw new FS.ErrnoError(63);
        }
        return node.node_ops.getattr(node);
      },lstat:function(path) {
        return FS.stat(path, true);
      },chmod:function(path, mode, dontFollow) {
        var node;
        if (typeof path === 'string') {
          var lookup = FS.lookupPath(path, { follow: !dontFollow });
          node = lookup.node;
        } else {
          node = path;
        }
        if (!node.node_ops.setattr) {
          throw new FS.ErrnoError(63);
        }
        node.node_ops.setattr(node, {
          mode: (mode & 4095) | (node.mode & ~4095),
          timestamp: Date.now()
        });
      },lchmod:function(path, mode) {
        FS.chmod(path, mode, true);
      },fchmod:function(fd, mode) {
        var stream = FS.getStream(fd);
        if (!stream) {
          throw new FS.ErrnoError(8);
        }
        FS.chmod(stream.node, mode);
      },chown:function(path, uid, gid, dontFollow) {
        var node;
        if (typeof path === 'string') {
          var lookup = FS.lookupPath(path, { follow: !dontFollow });
          node = lookup.node;
        } else {
          node = path;
        }
        if (!node.node_ops.setattr) {
          throw new FS.ErrnoError(63);
        }
        node.node_ops.setattr(node, {
          timestamp: Date.now()
          // we ignore the uid / gid for now
        });
      },lchown:function(path, uid, gid) {
        FS.chown(path, uid, gid, true);
      },fchown:function(fd, uid, gid) {
        var stream = FS.getStream(fd);
        if (!stream) {
          throw new FS.ErrnoError(8);
        }
        FS.chown(stream.node, uid, gid);
      },truncate:function(path, len) {
        if (len < 0) {
          throw new FS.ErrnoError(28);
        }
        var node;
        if (typeof path === 'string') {
          var lookup = FS.lookupPath(path, { follow: true });
          node = lookup.node;
        } else {
          node = path;
        }
        if (!node.node_ops.setattr) {
          throw new FS.ErrnoError(63);
        }
        if (FS.isDir(node.mode)) {
          throw new FS.ErrnoError(31);
        }
        if (!FS.isFile(node.mode)) {
          throw new FS.ErrnoError(28);
        }
        var errCode = FS.nodePermissions(node, 'w');
        if (errCode) {
          throw new FS.ErrnoError(errCode);
        }
        node.node_ops.setattr(node, {
          size: len,
          timestamp: Date.now()
        });
      },ftruncate:function(fd, len) {
        var stream = FS.getStream(fd);
        if (!stream) {
          throw new FS.ErrnoError(8);
        }
        if ((stream.flags & 2097155) === 0) {
          throw new FS.ErrnoError(28);
        }
        FS.truncate(stream.node, len);
      },utime:function(path, atime, mtime) {
        var lookup = FS.lookupPath(path, { follow: true });
        var node = lookup.node;
        node.node_ops.setattr(node, {
          timestamp: Math.max(atime, mtime)
        });
      },open:function(path, flags, mode, fd_start, fd_end) {
        if (path === "") {
          throw new FS.ErrnoError(44);
        }
        flags = typeof flags === 'string' ? FS.modeStringToFlags(flags) : flags;
        mode = typeof mode === 'undefined' ? 438 /* 0666 */ : mode;
        if ((flags & 64)) {
          mode = (mode & 4095) | 32768;
        } else {
          mode = 0;
        }
        var node;
        if (typeof path === 'object') {
          node = path;
        } else {
          path = PATH.normalize(path);
          try {
            var lookup = FS.lookupPath(path, {
              follow: !(flags & 131072)
            });
            node = lookup.node;
          } catch (e) {
            // ignore
          }
        }
        // perhaps we need to create the node
        var created = false;
        if ((flags & 64)) {
          if (node) {
            // if O_CREAT and O_EXCL are set, error out if the node already exists
            if ((flags & 128)) {
              throw new FS.ErrnoError(20);
            }
          } else {
            // node doesn't exist, try to create it
            node = FS.mknod(path, mode, 0);
            created = true;
          }
        }
        if (!node) {
          throw new FS.ErrnoError(44);
        }
        // can't truncate a device
        if (FS.isChrdev(node.mode)) {
          flags &= ~512;
        }
        // if asked only for a directory, then this must be one
        if ((flags & 65536) && !FS.isDir(node.mode)) {
          throw new FS.ErrnoError(54);
        }
        // check permissions, if this is not a file we just created now (it is ok to
        // create and write to a file with read-only permissions; it is read-only
        // for later use)
        if (!created) {
          var errCode = FS.mayOpen(node, flags);
          if (errCode) {
            throw new FS.ErrnoError(errCode);
          }
        }
        // do truncation if necessary
        if ((flags & 512)) {
          FS.truncate(node, 0);
        }
        // we've already handled these, don't pass down to the underlying vfs
        flags &= ~(128 | 512 | 131072);
  
        // register the stream with the filesystem
        var stream = FS.createStream({
          node: node,
          path: FS.getPath(node),  // we want the absolute path to the node
          flags: flags,
          seekable: true,
          position: 0,
          stream_ops: node.stream_ops,
          // used by the file family libc calls (fopen, fwrite, ferror, etc.)
          ungotten: [],
          error: false
        }, fd_start, fd_end);
        // call the new stream's open function
        if (stream.stream_ops.open) {
          stream.stream_ops.open(stream);
        }
        if (Module['logReadFiles'] && !(flags & 1)) {
          if (!FS.readFiles) FS.readFiles = {};
          if (!(path in FS.readFiles)) {
            FS.readFiles[path] = 1;
            err("FS.trackingDelegate error on read file: " + path);
          }
        }
        try {
          if (FS.trackingDelegate['onOpenFile']) {
            var trackingFlags = 0;
            if ((flags & 2097155) !== 1) {
              trackingFlags |= FS.tracking.openFlags.READ;
            }
            if ((flags & 2097155) !== 0) {
              trackingFlags |= FS.tracking.openFlags.WRITE;
            }
            FS.trackingDelegate['onOpenFile'](path, trackingFlags);
          }
        } catch(e) {
          err("FS.trackingDelegate['onOpenFile']('"+path+"', flags) threw an exception: " + e.message);
        }
        return stream;
      },close:function(stream) {
        if (FS.isClosed(stream)) {
          throw new FS.ErrnoError(8);
        }
        if (stream.getdents) stream.getdents = null; // free readdir state
        try {
          if (stream.stream_ops.close) {
            stream.stream_ops.close(stream);
          }
        } catch (e) {
          throw e;
        } finally {
          FS.closeStream(stream.fd);
        }
        stream.fd = null;
      },isClosed:function(stream) {
        return stream.fd === null;
      },llseek:function(stream, offset, whence) {
        if (FS.isClosed(stream)) {
          throw new FS.ErrnoError(8);
        }
        if (!stream.seekable || !stream.stream_ops.llseek) {
          throw new FS.ErrnoError(70);
        }
        if (whence != 0 && whence != 1 && whence != 2) {
          throw new FS.ErrnoError(28);
        }
        stream.position = stream.stream_ops.llseek(stream, offset, whence);
        stream.ungotten = [];
        return stream.position;
      },read:function(stream, buffer, offset, length, position) {
        if (length < 0 || position < 0) {
          throw new FS.ErrnoError(28);
        }
        if (FS.isClosed(stream)) {
          throw new FS.ErrnoError(8);
        }
        if ((stream.flags & 2097155) === 1) {
          throw new FS.ErrnoError(8);
        }
        if (FS.isDir(stream.node.mode)) {
          throw new FS.ErrnoError(31);
        }
        if (!stream.stream_ops.read) {
          throw new FS.ErrnoError(28);
        }
        var seeking = typeof position !== 'undefined';
        if (!seeking) {
          position = stream.position;
        } else if (!stream.seekable) {
          throw new FS.ErrnoError(70);
        }
        var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
        if (!seeking) stream.position += bytesRead;
        return bytesRead;
      },write:function(stream, buffer, offset, length, position, canOwn) {
        if (length < 0 || position < 0) {
          throw new FS.ErrnoError(28);
        }
        if (FS.isClosed(stream)) {
          throw new FS.ErrnoError(8);
        }
        if ((stream.flags & 2097155) === 0) {
          throw new FS.ErrnoError(8);
        }
        if (FS.isDir(stream.node.mode)) {
          throw new FS.ErrnoError(31);
        }
        if (!stream.stream_ops.write) {
          throw new FS.ErrnoError(28);
        }
        if (stream.seekable && stream.flags & 1024) {
          // seek to the end before writing in append mode
          FS.llseek(stream, 0, 2);
        }
        var seeking = typeof position !== 'undefined';
        if (!seeking) {
          position = stream.position;
        } else if (!stream.seekable) {
          throw new FS.ErrnoError(70);
        }
        var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
        if (!seeking) stream.position += bytesWritten;
        try {
          if (stream.path && FS.trackingDelegate['onWriteToFile']) FS.trackingDelegate['onWriteToFile'](stream.path);
        } catch(e) {
          err("FS.trackingDelegate['onWriteToFile']('"+stream.path+"') threw an exception: " + e.message);
        }
        return bytesWritten;
      },allocate:function(stream, offset, length) {
        if (FS.isClosed(stream)) {
          throw new FS.ErrnoError(8);
        }
        if (offset < 0 || length <= 0) {
          throw new FS.ErrnoError(28);
        }
        if ((stream.flags & 2097155) === 0) {
          throw new FS.ErrnoError(8);
        }
        if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) {
          throw new FS.ErrnoError(43);
        }
        if (!stream.stream_ops.allocate) {
          throw new FS.ErrnoError(138);
        }
        stream.stream_ops.allocate(stream, offset, length);
      },mmap:function(stream, address, length, position, prot, flags) {
        // User requests writing to file (prot & PROT_WRITE != 0).
        // Checking if we have permissions to write to the file unless
        // MAP_PRIVATE flag is set. According to POSIX spec it is possible
        // to write to file opened in read-only mode with MAP_PRIVATE flag,
        // as all modifications will be visible only in the memory of
        // the current process.
        if ((prot & 2) !== 0
            && (flags & 2) === 0
            && (stream.flags & 2097155) !== 2) {
          throw new FS.ErrnoError(2);
        }
        if ((stream.flags & 2097155) === 1) {
          throw new FS.ErrnoError(2);
        }
        if (!stream.stream_ops.mmap) {
          throw new FS.ErrnoError(43);
        }
        return stream.stream_ops.mmap(stream, address, length, position, prot, flags);
      },msync:function(stream, buffer, offset, length, mmapFlags) {
        if (!stream || !stream.stream_ops.msync) {
          return 0;
        }
        return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
      },munmap:function(stream) {
        return 0;
      },ioctl:function(stream, cmd, arg) {
        if (!stream.stream_ops.ioctl) {
          throw new FS.ErrnoError(59);
        }
        return stream.stream_ops.ioctl(stream, cmd, arg);
      },readFile:function(path, opts) {
        opts = opts || {};
        opts.flags = opts.flags || 'r';
        opts.encoding = opts.encoding || 'binary';
        if (opts.encoding !== 'utf8' && opts.encoding !== 'binary') {
          throw new Error('Invalid encoding type "' + opts.encoding + '"');
        }
        var ret;
        var stream = FS.open(path, opts.flags);
        var stat = FS.stat(path);
        var length = stat.size;
        var buf = new Uint8Array(length);
        FS.read(stream, buf, 0, length, 0);
        if (opts.encoding === 'utf8') {
          ret = UTF8ArrayToString(buf, 0);
        } else if (opts.encoding === 'binary') {
          ret = buf;
        }
        FS.close(stream);
        return ret;
      },writeFile:function(path, data, opts) {
        opts = opts || {};
        opts.flags = opts.flags || 'w';
        var stream = FS.open(path, opts.flags, opts.mode);
        if (typeof data === 'string') {
          var buf = new Uint8Array(lengthBytesUTF8(data)+1);
          var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
          FS.write(stream, buf, 0, actualNumBytes, undefined, opts.canOwn);
        } else if (ArrayBuffer.isView(data)) {
          FS.write(stream, data, 0, data.byteLength, undefined, opts.canOwn);
        } else {
          throw new Error('Unsupported data type');
        }
        FS.close(stream);
      },cwd:function() {
        return FS.currentPath;
      },chdir:function(path) {
        var lookup = FS.lookupPath(path, { follow: true });
        if (lookup.node === null) {
          throw new FS.ErrnoError(44);
        }
        if (!FS.isDir(lookup.node.mode)) {
          throw new FS.ErrnoError(54);
        }
        var errCode = FS.nodePermissions(lookup.node, 'x');
        if (errCode) {
          throw new FS.ErrnoError(errCode);
        }
        FS.currentPath = lookup.path;
      },createDefaultDirectories:function() {
        FS.mkdir('/tmp');
        FS.mkdir('/home');
        FS.mkdir('/home/web_user');
      },createDefaultDevices:function() {
        // create /dev
        FS.mkdir('/dev');
        // setup /dev/null
        FS.registerDevice(FS.makedev(1, 3), {
          read: function() { return 0; },
          write: function(stream, buffer, offset, length, pos) { return length; }
        });
        FS.mkdev('/dev/null', FS.makedev(1, 3));
        // setup /dev/tty and /dev/tty1
        // stderr needs to print output using Module['printErr']
        // so we register a second tty just for it.
        TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
        TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
        FS.mkdev('/dev/tty', FS.makedev(5, 0));
        FS.mkdev('/dev/tty1', FS.makedev(6, 0));
        // setup /dev/[u]random
        var random_device;
        if (typeof crypto === 'object' && typeof crypto['getRandomValues'] === 'function') {
          // for modern web browsers
          var randomBuffer = new Uint8Array(1);
          random_device = function() { crypto.getRandomValues(randomBuffer); return randomBuffer[0]; };
        } else
        {}
        if (!random_device) {
          // we couldn't find a proper implementation, as Math.random() is not suitable for /dev/random, see emscripten-core/emscripten/pull/7096
          random_device = function() { abort("no cryptographic support found for random_device. consider polyfilling it if you want to use something insecure like Math.random(), e.g. put this in a --pre-js: var crypto = { getRandomValues: function(array) { for (var i = 0; i < array.length; i++) array[i] = (Math.random()*256)|0 } };"); };
        }
        FS.createDevice('/dev', 'random', random_device);
        FS.createDevice('/dev', 'urandom', random_device);
        // we're not going to emulate the actual shm device,
        // just create the tmp dirs that reside in it commonly
        FS.mkdir('/dev/shm');
        FS.mkdir('/dev/shm/tmp');
      },createSpecialDirectories:function() {
        // create /proc/self/fd which allows /proc/self/fd/6 => readlink gives the name of the stream for fd 6 (see test_unistd_ttyname)
        FS.mkdir('/proc');
        FS.mkdir('/proc/self');
        FS.mkdir('/proc/self/fd');
        FS.mount({
          mount: function() {
            var node = FS.createNode('/proc/self', 'fd', 16384 | 511 /* 0777 */, 73);
            node.node_ops = {
              lookup: function(parent, name) {
                var fd = +name;
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                var ret = {
                  parent: null,
                  mount: { mountpoint: 'fake' },
                  node_ops: { readlink: function() { return stream.path } }
                };
                ret.parent = ret; // make it look like a simple root node
                return ret;
              }
            };
            return node;
          }
        }, {}, '/proc/self/fd');
      },createStandardStreams:function() {
        // TODO deprecate the old functionality of a single
        // input / output callback and that utilizes FS.createDevice
        // and instead require a unique set of stream ops
  
        // by default, we symlink the standard streams to the
        // default tty devices. however, if the standard streams
        // have been overwritten we create a unique device for
        // them instead.
        if (Module['stdin']) {
          FS.createDevice('/dev', 'stdin', Module['stdin']);
        } else {
          FS.symlink('/dev/tty', '/dev/stdin');
        }
        if (Module['stdout']) {
          FS.createDevice('/dev', 'stdout', null, Module['stdout']);
        } else {
          FS.symlink('/dev/tty', '/dev/stdout');
        }
        if (Module['stderr']) {
          FS.createDevice('/dev', 'stderr', null, Module['stderr']);
        } else {
          FS.symlink('/dev/tty1', '/dev/stderr');
        }
  
        // open default streams for the stdin, stdout and stderr devices
        var stdin = FS.open('/dev/stdin', 'r');
        var stdout = FS.open('/dev/stdout', 'w');
        var stderr = FS.open('/dev/stderr', 'w');
        assert(stdin.fd === 0, 'invalid handle for stdin (' + stdin.fd + ')');
        assert(stdout.fd === 1, 'invalid handle for stdout (' + stdout.fd + ')');
        assert(stderr.fd === 2, 'invalid handle for stderr (' + stderr.fd + ')');
      },ensureErrnoError:function() {
        if (FS.ErrnoError) return;
        FS.ErrnoError = /** @this{Object} */ function ErrnoError(errno, node) {
          this.node = node;
          this.setErrno = /** @this{Object} */ function(errno) {
            this.errno = errno;
            for (var key in ERRNO_CODES) {
              if (ERRNO_CODES[key] === errno) {
                this.code = key;
                break;
              }
            }
          };
          this.setErrno(errno);
          this.message = ERRNO_MESSAGES[errno];
  
          // Try to get a maximally helpful stack trace. On Node.js, getting Error.stack
          // now ensures it shows what we want.
          if (this.stack) {
            // Define the stack property for Node.js 4, which otherwise errors on the next line.
            Object.defineProperty(this, "stack", { value: (new Error).stack, writable: true });
            this.stack = demangleAll(this.stack);
          }
        };
        FS.ErrnoError.prototype = new Error();
        FS.ErrnoError.prototype.constructor = FS.ErrnoError;
        // Some errors may happen quite a bit, to avoid overhead we reuse them (and suffer a lack of stack info)
        [44].forEach(function(code) {
          FS.genericErrors[code] = new FS.ErrnoError(code);
          FS.genericErrors[code].stack = '<generic error, no stack>';
        });
      },staticInit:function() {
        FS.ensureErrnoError();
  
        FS.nameTable = new Array(4096);
  
        FS.mount(MEMFS, {}, '/');
  
        FS.createDefaultDirectories();
        FS.createDefaultDevices();
        FS.createSpecialDirectories();
  
        FS.filesystems = {
          'MEMFS': MEMFS,
        };
      },init:function(input, output, error) {
        assert(!FS.init.initialized, 'FS.init was previously called. If you want to initialize later with custom parameters, remove any earlier calls (note that one is automatically added to the generated code)');
        FS.init.initialized = true;
  
        FS.ensureErrnoError();
  
        // Allow Module.stdin etc. to provide defaults, if none explicitly passed to us here
        Module['stdin'] = input || Module['stdin'];
        Module['stdout'] = output || Module['stdout'];
        Module['stderr'] = error || Module['stderr'];
  
        FS.createStandardStreams();
      },quit:function() {
        FS.init.initialized = false;
        // force-flush all streams, so we get musl std streams printed out
        var fflush = Module['_fflush'];
        if (fflush) fflush(0);
        // close all of our streams
        for (var i = 0; i < FS.streams.length; i++) {
          var stream = FS.streams[i];
          if (!stream) {
            continue;
          }
          FS.close(stream);
        }
      },getMode:function(canRead, canWrite) {
        var mode = 0;
        if (canRead) mode |= 292 | 73;
        if (canWrite) mode |= 146;
        return mode;
      },joinPath:function(parts, forceRelative) {
        var path = PATH.join.apply(null, parts);
        if (forceRelative && path[0] == '/') path = path.substr(1);
        return path;
      },absolutePath:function(relative, base) {
        return PATH_FS.resolve(base, relative);
      },standardizePath:function(path) {
        return PATH.normalize(path);
      },findObject:function(path, dontResolveLastLink) {
        var ret = FS.analyzePath(path, dontResolveLastLink);
        if (ret.exists) {
          return ret.object;
        } else {
          setErrNo(ret.error);
          return null;
        }
      },analyzePath:function(path, dontResolveLastLink) {
        // operate from within the context of the symlink's target
        try {
          var lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
          path = lookup.path;
        } catch (e) {
        }
        var ret = {
          isRoot: false, exists: false, error: 0, name: null, path: null, object: null,
          parentExists: false, parentPath: null, parentObject: null
        };
        try {
          var lookup = FS.lookupPath(path, { parent: true });
          ret.parentExists = true;
          ret.parentPath = lookup.path;
          ret.parentObject = lookup.node;
          ret.name = PATH.basename(path);
          lookup = FS.lookupPath(path, { follow: !dontResolveLastLink });
          ret.exists = true;
          ret.path = lookup.path;
          ret.object = lookup.node;
          ret.name = lookup.node.name;
          ret.isRoot = lookup.path === '/';
        } catch (e) {
          ret.error = e.errno;
        };
        return ret;
      },createFolder:function(parent, name, canRead, canWrite) {
        var path = PATH.join2(typeof parent === 'string' ? parent : FS.getPath(parent), name);
        var mode = FS.getMode(canRead, canWrite);
        return FS.mkdir(path, mode);
      },createPath:function(parent, path, canRead, canWrite) {
        parent = typeof parent === 'string' ? parent : FS.getPath(parent);
        var parts = path.split('/').reverse();
        while (parts.length) {
          var part = parts.pop();
          if (!part) continue;
          var current = PATH.join2(parent, part);
          try {
            FS.mkdir(current);
          } catch (e) {
            // ignore EEXIST
          }
          parent = current;
        }
        return current;
      },createFile:function(parent, name, properties, canRead, canWrite) {
        var path = PATH.join2(typeof parent === 'string' ? parent : FS.getPath(parent), name);
        var mode = FS.getMode(canRead, canWrite);
        return FS.create(path, mode);
      },createDataFile:function(parent, name, data, canRead, canWrite, canOwn) {
        var path = name ? PATH.join2(typeof parent === 'string' ? parent : FS.getPath(parent), name) : parent;
        var mode = FS.getMode(canRead, canWrite);
        var node = FS.create(path, mode);
        if (data) {
          if (typeof data === 'string') {
            var arr = new Array(data.length);
            for (var i = 0, len = data.length; i < len; ++i) arr[i] = data.charCodeAt(i);
            data = arr;
          }
          // make sure we can write to the file
          FS.chmod(node, mode | 146);
          var stream = FS.open(node, 'w');
          FS.write(stream, data, 0, data.length, 0, canOwn);
          FS.close(stream);
          FS.chmod(node, mode);
        }
        return node;
      },createDevice:function(parent, name, input, output) {
        var path = PATH.join2(typeof parent === 'string' ? parent : FS.getPath(parent), name);
        var mode = FS.getMode(!!input, !!output);
        if (!FS.createDevice.major) FS.createDevice.major = 64;
        var dev = FS.makedev(FS.createDevice.major++, 0);
        // Create a fake device that a set of stream ops to emulate
        // the old behavior.
        FS.registerDevice(dev, {
          open: function(stream) {
            stream.seekable = false;
          },
          close: function(stream) {
            // flush any pending line data
            if (output && output.buffer && output.buffer.length) {
              output(10);
            }
          },
          read: function(stream, buffer, offset, length, pos /* ignored */) {
            var bytesRead = 0;
            for (var i = 0; i < length; i++) {
              var result;
              try {
                result = input();
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
              if (result === undefined && bytesRead === 0) {
                throw new FS.ErrnoError(6);
              }
              if (result === null || result === undefined) break;
              bytesRead++;
              buffer[offset+i] = result;
            }
            if (bytesRead) {
              stream.node.timestamp = Date.now();
            }
            return bytesRead;
          },
          write: function(stream, buffer, offset, length, pos) {
            for (var i = 0; i < length; i++) {
              try {
                output(buffer[offset+i]);
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
            }
            if (length) {
              stream.node.timestamp = Date.now();
            }
            return i;
          }
        });
        return FS.mkdev(path, mode, dev);
      },createLink:function(parent, name, target, canRead, canWrite) {
        var path = PATH.join2(typeof parent === 'string' ? parent : FS.getPath(parent), name);
        return FS.symlink(target, path);
      },forceLoadFile:function(obj) {
        if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
        var success = true;
        if (typeof XMLHttpRequest !== 'undefined') {
          throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
        } else if (read_) {
          // Command-line.
          try {
            // WARNING: Can't read binary files in V8's d8 or tracemonkey's js, as
            //          read() will try to parse UTF8.
            obj.contents = intArrayFromString(read_(obj.url), true);
            obj.usedBytes = obj.contents.length;
          } catch (e) {
            success = false;
          }
        } else {
          throw new Error('Cannot load without read() or XMLHttpRequest.');
        }
        if (!success) setErrNo(29);
        return success;
      },createLazyFile:function(parent, name, url, canRead, canWrite) {
        // Lazy chunked Uint8Array (implements get and length from Uint8Array). Actual getting is abstracted away for eventual reuse.
        /** @constructor */
        function LazyUint8Array() {
          this.lengthKnown = false;
          this.chunks = []; // Loaded chunks. Index is the chunk number
        }
        LazyUint8Array.prototype.get = /** @this{Object} */ function LazyUint8Array_get(idx) {
          if (idx > this.length-1 || idx < 0) {
            return undefined;
          }
          var chunkOffset = idx % this.chunkSize;
          var chunkNum = (idx / this.chunkSize)|0;
          return this.getter(chunkNum)[chunkOffset];
        };
        LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
          this.getter = getter;
        };
        LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
          // Find length
          var xhr = new XMLHttpRequest();
          xhr.open('HEAD', url, false);
          xhr.send(null);
          if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
          var datalength = Number(xhr.getResponseHeader("Content-length"));
          var header;
          var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
          var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
  
          var chunkSize = 1024*1024; // Chunk size in bytes
  
          if (!hasByteServing) chunkSize = datalength;
  
          // Function to get a range from the remote URL.
          var doXHR = (function(from, to) {
            if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
            if (to > datalength-1) throw new Error("only " + datalength + " bytes available! programmer error!");
  
            // TODO: Use mozResponseArrayBuffer, responseStream, etc. if available.
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, false);
            if (datalength !== chunkSize) xhr.setRequestHeader("Range", "bytes=" + from + "-" + to);
  
            // Some hints to the browser that we want binary data.
            if (typeof Uint8Array != 'undefined') xhr.responseType = 'arraybuffer';
            if (xhr.overrideMimeType) {
              xhr.overrideMimeType('text/plain; charset=x-user-defined');
            }
  
            xhr.send(null);
            if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
            if (xhr.response !== undefined) {
              return new Uint8Array(/** @type{Array<number>} */(xhr.response || []));
            } else {
              return intArrayFromString(xhr.responseText || '', true);
            }
          });
          var lazyArray = this;
          lazyArray.setDataGetter(function(chunkNum) {
            var start = chunkNum * chunkSize;
            var end = (chunkNum+1) * chunkSize - 1; // including this byte
            end = Math.min(end, datalength-1); // if datalength-1 is selected, this is the last block
            if (typeof(lazyArray.chunks[chunkNum]) === "undefined") {
              lazyArray.chunks[chunkNum] = doXHR(start, end);
            }
            if (typeof(lazyArray.chunks[chunkNum]) === "undefined") throw new Error("doXHR failed!");
            return lazyArray.chunks[chunkNum];
          });
  
          if (usesGzip || !datalength) {
            // if the server uses gzip or doesn't supply the length, we have to download the whole file to get the (uncompressed) length
            chunkSize = datalength = 1; // this will force getter(0)/doXHR do download the whole file
            datalength = this.getter(0).length;
            chunkSize = datalength;
            out("LazyFiles on gzip forces download of the whole file when length is accessed");
          }
  
          this._length = datalength;
          this._chunkSize = chunkSize;
          this.lengthKnown = true;
        };
        if (typeof XMLHttpRequest !== 'undefined') {
          if (!ENVIRONMENT_IS_WORKER) throw 'Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc';
          var lazyArray = new LazyUint8Array();
          Object.defineProperties(lazyArray, {
            length: {
              get: /** @this{Object} */ function() {
                if(!this.lengthKnown) {
                  this.cacheLength();
                }
                return this._length;
              }
            },
            chunkSize: {
              get: /** @this{Object} */ function() {
                if(!this.lengthKnown) {
                  this.cacheLength();
                }
                return this._chunkSize;
              }
            }
          });
  
          var properties = { isDevice: false, contents: lazyArray };
        } else {
          var properties = { isDevice: false, url: url };
        }
  
        var node = FS.createFile(parent, name, properties, canRead, canWrite);
        // This is a total hack, but I want to get this lazy file code out of the
        // core of MEMFS. If we want to keep this lazy file concept I feel it should
        // be its own thin LAZYFS proxying calls to MEMFS.
        if (properties.contents) {
          node.contents = properties.contents;
        } else if (properties.url) {
          node.contents = null;
          node.url = properties.url;
        }
        // Add a function that defers querying the file size until it is asked the first time.
        Object.defineProperties(node, {
          usedBytes: {
            get: /** @this {FSNode} */ function() { return this.contents.length; }
          }
        });
        // override each stream op with one that tries to force load the lazy file first
        var stream_ops = {};
        var keys = Object.keys(node.stream_ops);
        keys.forEach(function(key) {
          var fn = node.stream_ops[key];
          stream_ops[key] = function forceLoadLazyFile() {
            if (!FS.forceLoadFile(node)) {
              throw new FS.ErrnoError(29);
            }
            return fn.apply(null, arguments);
          };
        });
        // use a custom read function
        stream_ops.read = function stream_ops_read(stream, buffer, offset, length, position) {
          if (!FS.forceLoadFile(node)) {
            throw new FS.ErrnoError(29);
          }
          var contents = stream.node.contents;
          if (position >= contents.length)
            return 0;
          var size = Math.min(contents.length - position, length);
          assert(size >= 0);
          if (contents.slice) { // normal array
            for (var i = 0; i < size; i++) {
              buffer[offset + i] = contents[position + i];
            }
          } else {
            for (var i = 0; i < size; i++) { // LazyUint8Array from sync binary XHR
              buffer[offset + i] = contents.get(position + i);
            }
          }
          return size;
        };
        node.stream_ops = stream_ops;
        return node;
      },createPreloadedFile:function(parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) {
        Browser.init(); // XXX perhaps this method should move onto Browser?
        // TODO we should allow people to just pass in a complete filename instead
        // of parent and name being that we just join them anyways
        var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
        var dep = getUniqueRunDependency('cp ' + fullname); // might have several active requests for the same fullname
        function processData(byteArray) {
          function finish(byteArray) {
            if (preFinish) preFinish();
            if (!dontCreateFile) {
              FS.createDataFile(parent, name, byteArray, canRead, canWrite, canOwn);
            }
            if (onload) onload();
            removeRunDependency(dep);
          }
          var handled = false;
          Module['preloadPlugins'].forEach(function(plugin) {
            if (handled) return;
            if (plugin['canHandle'](fullname)) {
              plugin['handle'](byteArray, fullname, finish, function() {
                if (onerror) onerror();
                removeRunDependency(dep);
              });
              handled = true;
            }
          });
          if (!handled) finish(byteArray);
        }
        addRunDependency(dep);
        if (typeof url == 'string') {
          Browser.asyncLoad(url, function(byteArray) {
            processData(byteArray);
          }, onerror);
        } else {
          processData(url);
        }
      },indexedDB:function() {
        return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
      },DB_NAME:function() {
        return 'EM_FS_' + window.location.pathname;
      },DB_VERSION:20,DB_STORE_NAME:"FILE_DATA",saveFilesToDB:function(paths, onload, onerror) {
        onload = onload || function(){};
        onerror = onerror || function(){};
        var indexedDB = FS.indexedDB();
        try {
          var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
        } catch (e) {
          return onerror(e);
        }
        openRequest.onupgradeneeded = function openRequest_onupgradeneeded() {
          out('creating db');
          var db = openRequest.result;
          db.createObjectStore(FS.DB_STORE_NAME);
        };
        openRequest.onsuccess = function openRequest_onsuccess() {
          var db = openRequest.result;
          var transaction = db.transaction([FS.DB_STORE_NAME], 'readwrite');
          var files = transaction.objectStore(FS.DB_STORE_NAME);
          var ok = 0, fail = 0, total = paths.length;
          function finish() {
            if (fail == 0) onload(); else onerror();
          }
          paths.forEach(function(path) {
            var putRequest = files.put(FS.analyzePath(path).object.contents, path);
            putRequest.onsuccess = function putRequest_onsuccess() { ok++; if (ok + fail == total) finish() };
            putRequest.onerror = function putRequest_onerror() { fail++; if (ok + fail == total) finish() };
          });
          transaction.onerror = onerror;
        };
        openRequest.onerror = onerror;
      },loadFilesFromDB:function(paths, onload, onerror) {
        onload = onload || function(){};
        onerror = onerror || function(){};
        var indexedDB = FS.indexedDB();
        try {
          var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
        } catch (e) {
          return onerror(e);
        }
        openRequest.onupgradeneeded = onerror; // no database to load from
        openRequest.onsuccess = function openRequest_onsuccess() {
          var db = openRequest.result;
          try {
            var transaction = db.transaction([FS.DB_STORE_NAME], 'readonly');
          } catch(e) {
            onerror(e);
            return;
          }
          var files = transaction.objectStore(FS.DB_STORE_NAME);
          var ok = 0, fail = 0, total = paths.length;
          function finish() {
            if (fail == 0) onload(); else onerror();
          }
          paths.forEach(function(path) {
            var getRequest = files.get(path);
            getRequest.onsuccess = function getRequest_onsuccess() {
              if (FS.analyzePath(path).exists) {
                FS.unlink(path);
              }
              FS.createDataFile(PATH.dirname(path), PATH.basename(path), getRequest.result, true, true, true);
              ok++;
              if (ok + fail == total) finish();
            };
            getRequest.onerror = function getRequest_onerror() { fail++; if (ok + fail == total) finish() };
          });
          transaction.onerror = onerror;
        };
        openRequest.onerror = onerror;
      }};var SYSCALLS={mappings:{},DEFAULT_POLLMASK:5,umask:511,calculateAt:function(dirfd, path) {
        if (path[0] !== '/') {
          // relative path
          var dir;
          if (dirfd === -100) {
            dir = FS.cwd();
          } else {
            var dirstream = FS.getStream(dirfd);
            if (!dirstream) throw new FS.ErrnoError(8);
            dir = dirstream.path;
          }
          path = PATH.join2(dir, path);
        }
        return path;
      },doStat:function(func, path, buf) {
        try {
          var stat = func(path);
        } catch (e) {
          if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) {
            // an error occurred while trying to look up the path; we should just report ENOTDIR
            return -54;
          }
          throw e;
        }
        HEAP32[((buf)>>2)]=stat.dev;
        HEAP32[(((buf)+(4))>>2)]=0;
        HEAP32[(((buf)+(8))>>2)]=stat.ino;
        HEAP32[(((buf)+(12))>>2)]=stat.mode;
        HEAP32[(((buf)+(16))>>2)]=stat.nlink;
        HEAP32[(((buf)+(20))>>2)]=stat.uid;
        HEAP32[(((buf)+(24))>>2)]=stat.gid;
        HEAP32[(((buf)+(28))>>2)]=stat.rdev;
        HEAP32[(((buf)+(32))>>2)]=0;
        (tempI64 = [stat.size>>>0,(tempDouble=stat.size,(+(Math_abs(tempDouble))) >= 1.0 ? (tempDouble > 0.0 ? ((Math_min((+(Math_floor((tempDouble)/4294967296.0))), 4294967295.0))|0)>>>0 : (~~((+(Math_ceil((tempDouble - +(((~~(tempDouble)))>>>0))/4294967296.0)))))>>>0) : 0)],HEAP32[(((buf)+(40))>>2)]=tempI64[0],HEAP32[(((buf)+(44))>>2)]=tempI64[1]);
        HEAP32[(((buf)+(48))>>2)]=4096;
        HEAP32[(((buf)+(52))>>2)]=stat.blocks;
        HEAP32[(((buf)+(56))>>2)]=(stat.atime.getTime() / 1000)|0;
        HEAP32[(((buf)+(60))>>2)]=0;
        HEAP32[(((buf)+(64))>>2)]=(stat.mtime.getTime() / 1000)|0;
        HEAP32[(((buf)+(68))>>2)]=0;
        HEAP32[(((buf)+(72))>>2)]=(stat.ctime.getTime() / 1000)|0;
        HEAP32[(((buf)+(76))>>2)]=0;
        (tempI64 = [stat.ino>>>0,(tempDouble=stat.ino,(+(Math_abs(tempDouble))) >= 1.0 ? (tempDouble > 0.0 ? ((Math_min((+(Math_floor((tempDouble)/4294967296.0))), 4294967295.0))|0)>>>0 : (~~((+(Math_ceil((tempDouble - +(((~~(tempDouble)))>>>0))/4294967296.0)))))>>>0) : 0)],HEAP32[(((buf)+(80))>>2)]=tempI64[0],HEAP32[(((buf)+(84))>>2)]=tempI64[1]);
        return 0;
      },doMsync:function(addr, stream, len, flags, offset) {
        var buffer = HEAPU8.slice(addr, addr + len);
        FS.msync(stream, buffer, offset, len, flags);
      },doMkdir:function(path, mode) {
        // remove a trailing slash, if one - /a/b/ has basename of '', but
        // we want to create b in the context of this function
        path = PATH.normalize(path);
        if (path[path.length-1] === '/') path = path.substr(0, path.length-1);
        FS.mkdir(path, mode, 0);
        return 0;
      },doMknod:function(path, mode, dev) {
        // we don't want this in the JS API as it uses mknod to create all nodes.
        switch (mode & 61440) {
          case 32768:
          case 8192:
          case 24576:
          case 4096:
          case 49152:
            break;
          default: return -28;
        }
        FS.mknod(path, mode, dev);
        return 0;
      },doReadlink:function(path, buf, bufsize) {
        if (bufsize <= 0) return -28;
        var ret = FS.readlink(path);
  
        var len = Math.min(bufsize, lengthBytesUTF8(ret));
        var endChar = HEAP8[buf+len];
        stringToUTF8(ret, buf, bufsize+1);
        // readlink is one of the rare functions that write out a C string, but does never append a null to the output buffer(!)
        // stringToUTF8() always appends a null byte, so restore the character under the null byte after the write.
        HEAP8[buf+len] = endChar;
  
        return len;
      },doAccess:function(path, amode) {
        if (amode & ~7) {
          // need a valid mode
          return -28;
        }
        var node;
        var lookup = FS.lookupPath(path, { follow: true });
        node = lookup.node;
        if (!node) {
          return -44;
        }
        var perms = '';
        if (amode & 4) perms += 'r';
        if (amode & 2) perms += 'w';
        if (amode & 1) perms += 'x';
        if (perms /* otherwise, they've just passed F_OK */ && FS.nodePermissions(node, perms)) {
          return -2;
        }
        return 0;
      },doDup:function(path, flags, suggestFD) {
        var suggest = FS.getStream(suggestFD);
        if (suggest) FS.close(suggest);
        return FS.open(path, flags, 0, suggestFD, suggestFD).fd;
      },doReadv:function(stream, iov, iovcnt, offset) {
        var ret = 0;
        for (var i = 0; i < iovcnt; i++) {
          var ptr = HEAP32[(((iov)+(i*8))>>2)];
          var len = HEAP32[(((iov)+(i*8 + 4))>>2)];
          var curr = FS.read(stream, HEAP8,ptr, len, offset);
          if (curr < 0) return -1;
          ret += curr;
          if (curr < len) break; // nothing more to read
        }
        return ret;
      },doWritev:function(stream, iov, iovcnt, offset) {
        var ret = 0;
        for (var i = 0; i < iovcnt; i++) {
          var ptr = HEAP32[(((iov)+(i*8))>>2)];
          var len = HEAP32[(((iov)+(i*8 + 4))>>2)];
          var curr = FS.write(stream, HEAP8,ptr, len, offset);
          if (curr < 0) return -1;
          ret += curr;
        }
        return ret;
      },varargs:undefined,get:function() {
        assert(SYSCALLS.varargs != undefined);
        SYSCALLS.varargs += 4;
        var ret = HEAP32[(((SYSCALLS.varargs)-(4))>>2)];
        return ret;
      },getStr:function(ptr) {
        var ret = UTF8ToString(ptr);
        return ret;
      },getStreamFromFD:function(fd) {
        var stream = FS.getStream(fd);
        if (!stream) throw new FS.ErrnoError(8);
        return stream;
      },get64:function(low, high) {
        if (low >= 0) assert(high === 0);
        else assert(high === -1);
        return low;
      }};function ___sys__newselect(nfds, readfds, writefds, exceptfds, timeout) {try {
  
      // readfds are supported,
      // writefds checks socket open status
      // exceptfds not supported
      // timeout is always 0 - fully async
      assert(nfds <= 64, 'nfds must be less than or equal to 64');  // fd sets have 64 bits // TODO: this could be 1024 based on current musl headers
      assert(!exceptfds, 'exceptfds not supported');
  
      var total = 0;
      
      var srcReadLow = (readfds ? HEAP32[((readfds)>>2)] : 0),
          srcReadHigh = (readfds ? HEAP32[(((readfds)+(4))>>2)] : 0);
      var srcWriteLow = (writefds ? HEAP32[((writefds)>>2)] : 0),
          srcWriteHigh = (writefds ? HEAP32[(((writefds)+(4))>>2)] : 0);
      var srcExceptLow = (exceptfds ? HEAP32[((exceptfds)>>2)] : 0),
          srcExceptHigh = (exceptfds ? HEAP32[(((exceptfds)+(4))>>2)] : 0);
  
      var dstReadLow = 0,
          dstReadHigh = 0;
      var dstWriteLow = 0,
          dstWriteHigh = 0;
      var dstExceptLow = 0,
          dstExceptHigh = 0;
  
      var allLow = (readfds ? HEAP32[((readfds)>>2)] : 0) |
                   (writefds ? HEAP32[((writefds)>>2)] : 0) |
                   (exceptfds ? HEAP32[((exceptfds)>>2)] : 0);
      var allHigh = (readfds ? HEAP32[(((readfds)+(4))>>2)] : 0) |
                    (writefds ? HEAP32[(((writefds)+(4))>>2)] : 0) |
                    (exceptfds ? HEAP32[(((exceptfds)+(4))>>2)] : 0);
  
      var check = function(fd, low, high, val) {
        return (fd < 32 ? (low & val) : (high & val));
      };
  
      for (var fd = 0; fd < nfds; fd++) {
        var mask = 1 << (fd % 32);
        if (!(check(fd, allLow, allHigh, mask))) {
          continue;  // index isn't in the set
        }
  
        var stream = FS.getStream(fd);
        if (!stream) throw new FS.ErrnoError(8);
  
        var flags = SYSCALLS.DEFAULT_POLLMASK;
  
        if (stream.stream_ops.poll) {
          flags = stream.stream_ops.poll(stream);
        }
  
        if ((flags & 1) && check(fd, srcReadLow, srcReadHigh, mask)) {
          fd < 32 ? (dstReadLow = dstReadLow | mask) : (dstReadHigh = dstReadHigh | mask);
          total++;
        }
        if ((flags & 4) && check(fd, srcWriteLow, srcWriteHigh, mask)) {
          fd < 32 ? (dstWriteLow = dstWriteLow | mask) : (dstWriteHigh = dstWriteHigh | mask);
          total++;
        }
        if ((flags & 2) && check(fd, srcExceptLow, srcExceptHigh, mask)) {
          fd < 32 ? (dstExceptLow = dstExceptLow | mask) : (dstExceptHigh = dstExceptHigh | mask);
          total++;
        }
      }
  
      if (readfds) {
        HEAP32[((readfds)>>2)]=dstReadLow;
        HEAP32[(((readfds)+(4))>>2)]=dstReadHigh;
      }
      if (writefds) {
        HEAP32[((writefds)>>2)]=dstWriteLow;
        HEAP32[(((writefds)+(4))>>2)]=dstWriteHigh;
      }
      if (exceptfds) {
        HEAP32[((exceptfds)>>2)]=dstExceptLow;
        HEAP32[(((exceptfds)+(4))>>2)]=dstExceptHigh;
      }
      
      return total;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_access(path, amode) {try {
  
      path = SYSCALLS.getStr(path);
      return SYSCALLS.doAccess(path, amode);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_acct(filename) {
      return -52; // unsupported features
    }

  function ___sys_chdir(path) {try {
  
      path = SYSCALLS.getStr(path);
      FS.chdir(path);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_chmod(path, mode) {try {
  
      path = SYSCALLS.getStr(path);
      FS.chmod(path, mode);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_chown32(path, owner, group) {try {
  
      path = SYSCALLS.getStr(path);
      FS.chown(path, owner, group);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_dup(fd) {try {
  
      var old = SYSCALLS.getStreamFromFD(fd);
      return FS.open(old.path, old.flags, 0).fd;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_dup2(oldfd, suggestFD) {try {
  
      var old = SYSCALLS.getStreamFromFD(oldfd);
      if (old.fd === suggestFD) return suggestFD;
      return SYSCALLS.doDup(old.path, old.flags, suggestFD);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_dup3(fd, suggestFD, flags) {try {
  
      var old = SYSCALLS.getStreamFromFD(fd);
      assert(!flags);
      if (old.fd === suggestFD) return -28;
      return SYSCALLS.doDup(old.path, old.flags, suggestFD);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_fadvise64_64(fd, offset, len, advice) {
      return 0; // your advice is important to us (but we can't use it)
    }

  function ___sys_fallocate(fd, mode, off_low, off_high, len_low, len_high) {try {
  
      
      
      var stream = SYSCALLS.getStreamFromFD(fd)
      var offset = SYSCALLS.get64(off_low, off_high);
      var len = SYSCALLS.get64(len_low, len_high);
      assert(mode === 0);
      FS.allocate(stream, offset, len);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_fchdir(fd) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      FS.chdir(stream.path);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_fchmod(fd, mode) {try {
  
      FS.fchmod(fd, mode);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_fchmodat(dirfd, path, mode, varargs) {SYSCALLS.varargs = varargs;
  try {
  
      path = SYSCALLS.getStr(path);
      path = SYSCALLS.calculateAt(dirfd, path);
      mode = SYSCALLS.get();
      FS.chmod(path, mode);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_fchown32(fd, owner, group) {try {
  
      FS.fchown(fd, owner, group);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_fchownat(dirfd, path, owner, group, flags) {try {
  
      path = SYSCALLS.getStr(path);
      assert(flags === 0);
      path = SYSCALLS.calculateAt(dirfd, path);
      FS.chown(path, owner, group);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_fcntl64(fd, cmd, varargs) {SYSCALLS.varargs = varargs;
  try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      switch (cmd) {
        case 0: {
          var arg = SYSCALLS.get();
          if (arg < 0) {
            return -28;
          }
          var newStream;
          newStream = FS.open(stream.path, stream.flags, 0, arg);
          return newStream.fd;
        }
        case 1:
        case 2:
          return 0;  // FD_CLOEXEC makes no sense for a single process.
        case 3:
          return stream.flags;
        case 4: {
          var arg = SYSCALLS.get();
          stream.flags |= arg;
          return 0;
        }
        case 12:
        /* case 12: Currently in musl F_GETLK64 has same value as F_GETLK, so omitted to avoid duplicate case blocks. If that changes, uncomment this */ {
          
          var arg = SYSCALLS.get();
          var offset = 0;
          // We're always unlocked.
          HEAP16[(((arg)+(offset))>>1)]=2;
          return 0;
        }
        case 13:
        case 14:
        /* case 13: Currently in musl F_SETLK64 has same value as F_SETLK, so omitted to avoid duplicate case blocks. If that changes, uncomment this */
        /* case 14: Currently in musl F_SETLKW64 has same value as F_SETLKW, so omitted to avoid duplicate case blocks. If that changes, uncomment this */
          
          
          return 0; // Pretend that the locking is successful.
        case 16:
        case 8:
          return -28; // These are for sockets. We don't have them fully implemented yet.
        case 9:
          // musl trusts getown return values, due to a bug where they must be, as they overlap with errors. just return -1 here, so fnctl() returns that, and we set errno ourselves.
          setErrNo(28);
          return -1;
        default: {
          return -28;
        }
      }
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_fdatasync(fd) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      return 0; // we can't do anything synchronously; the in-memory FS is already synced to
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_fstat64(fd, buf) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      return SYSCALLS.doStat(FS.stat, stream.path, buf);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_fstatat64(dirfd, path, buf, flags) {try {
  
      path = SYSCALLS.getStr(path);
      var nofollow = flags & 256;
      flags = flags & (~256);
      assert(!flags, flags);
      path = SYSCALLS.calculateAt(dirfd, path);
      return SYSCALLS.doStat(nofollow ? FS.lstat : FS.stat, path, buf);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_fstatfs64(fd, size, buf) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      return ___sys_statfs64(0, size, buf);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_ftruncate64(fd, zero, low, high) {try {
  
      var length = SYSCALLS.get64(low, high);
      FS.ftruncate(fd, length);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_getcwd(buf, size) {try {
  
      if (size === 0) return -28;
      var cwd = FS.cwd();
      var cwdLengthInBytes = lengthBytesUTF8(cwd);
      if (size < cwdLengthInBytes + 1) return -68;
      stringToUTF8(cwd, buf, size);
      return buf;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_getdents64(fd, dirp, count) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd)
      if (!stream.getdents) {
        stream.getdents = FS.readdir(stream.path);
      }
  
      var struct_size = 280;
      var pos = 0;
      var off = FS.llseek(stream, 0, 1);
  
      var idx = Math.floor(off / struct_size);
  
      while (idx < stream.getdents.length && pos + struct_size <= count) {
        var id;
        var type;
        var name = stream.getdents[idx];
        if (name[0] === '.') {
          id = 1;
          type = 4; // DT_DIR
        } else {
          var child = FS.lookupNode(stream.node, name);
          id = child.id;
          type = FS.isChrdev(child.mode) ? 2 :  // DT_CHR, character device.
                 FS.isDir(child.mode) ? 4 :     // DT_DIR, directory.
                 FS.isLink(child.mode) ? 10 :   // DT_LNK, symbolic link.
                 8;                             // DT_REG, regular file.
        }
        (tempI64 = [id>>>0,(tempDouble=id,(+(Math_abs(tempDouble))) >= 1.0 ? (tempDouble > 0.0 ? ((Math_min((+(Math_floor((tempDouble)/4294967296.0))), 4294967295.0))|0)>>>0 : (~~((+(Math_ceil((tempDouble - +(((~~(tempDouble)))>>>0))/4294967296.0)))))>>>0) : 0)],HEAP32[((dirp + pos)>>2)]=tempI64[0],HEAP32[(((dirp + pos)+(4))>>2)]=tempI64[1]);
        (tempI64 = [(idx + 1) * struct_size>>>0,(tempDouble=(idx + 1) * struct_size,(+(Math_abs(tempDouble))) >= 1.0 ? (tempDouble > 0.0 ? ((Math_min((+(Math_floor((tempDouble)/4294967296.0))), 4294967295.0))|0)>>>0 : (~~((+(Math_ceil((tempDouble - +(((~~(tempDouble)))>>>0))/4294967296.0)))))>>>0) : 0)],HEAP32[(((dirp + pos)+(8))>>2)]=tempI64[0],HEAP32[(((dirp + pos)+(12))>>2)]=tempI64[1]);
        HEAP16[(((dirp + pos)+(16))>>1)]=280;
        HEAP8[(((dirp + pos)+(18))>>0)]=type;
        stringToUTF8(name, dirp + pos + 19, 256);
        pos += struct_size;
        idx += 1;
      }
      FS.llseek(stream, idx * struct_size, 0);
      return pos;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_getegid32() {
      return 0;
    }

  function ___sys_geteuid32(
  ) {
  return ___sys_getegid32();
  }

  function ___sys_getgid32(
  ) {
  return ___sys_getegid32();
  }

  function ___sys_getgroups32(size, list) {
      if (size < 1) return -28;
      HEAP32[((list)>>2)]=0;
      return 1;
    }

  function ___sys_getpgid(pid) {
      if (pid && pid !== 42) return -71;
      return 42;
    }

  function ___sys_getpid() {
      return 42;
    }

  function ___sys_getppid() {
      return 1;
    }

  function ___sys_getpriority() {
      return 0;
    }

  function ___sys_getresgid32(ruid, euid, suid) {
      HEAP32[((ruid)>>2)]=0;
      HEAP32[((euid)>>2)]=0;
      HEAP32[((suid)>>2)]=0;
      return 0;
    }

  function ___sys_getresuid32(a0,a1,a2
  ) {
  return ___sys_getresgid32(a0,a1,a2);
  }

  function ___sys_getrusage(who, usage) {try {
  
      _memset(usage, 0, 136);
      HEAP32[((usage)>>2)]=1; // fake some values
      HEAP32[(((usage)+(4))>>2)]=2;
      HEAP32[(((usage)+(8))>>2)]=3;
      HEAP32[(((usage)+(12))>>2)]=4;
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_getsid(pid) {
      if (pid && pid !== 42) return -71;
      return 42;
    }

  function ___sys_getuid32(
  ) {
  return ___sys_getegid32();
  }

  function ___sys_ioctl(fd, op, varargs) {SYSCALLS.varargs = varargs;
  try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      switch (op) {
        case 21509:
        case 21505: {
          if (!stream.tty) return -59;
          return 0;
        }
        case 21510:
        case 21511:
        case 21512:
        case 21506:
        case 21507:
        case 21508: {
          if (!stream.tty) return -59;
          return 0; // no-op, not actually adjusting terminal settings
        }
        case 21519: {
          if (!stream.tty) return -59;
          var argp = SYSCALLS.get();
          HEAP32[((argp)>>2)]=0;
          return 0;
        }
        case 21520: {
          if (!stream.tty) return -59;
          return -28; // not supported
        }
        case 21531: {
          var argp = SYSCALLS.get();
          return FS.ioctl(stream, op, argp);
        }
        case 21523: {
          // TODO: in theory we should write to the winsize struct that gets
          // passed in, but for now musl doesn't read anything on it
          if (!stream.tty) return -59;
          return 0;
        }
        case 21524: {
          // TODO: technically, this ioctl call should change the window size.
          // but, since emscripten doesn't have any concept of a terminal window
          // yet, we'll just silently throw it away as we do TIOCGWINSZ
          if (!stream.tty) return -59;
          return 0;
        }
        default: abort('bad ioctl syscall ' + op);
      }
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_lchown32(path, owner, group) {try {
  
      path = SYSCALLS.getStr(path);
      FS.chown(path, owner, group); // XXX we ignore the 'l' aspect, and do the same as chown
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_link(oldpath, newpath) {
      return -34; // no hardlinks for us
    }

  function ___sys_linkat(olddirfd, oldpath, newdirfd, newpath, flags) {
      return -34; // no hardlinks for us
    }

  function ___sys_lstat64(path, buf) {try {
  
      path = SYSCALLS.getStr(path);
      return SYSCALLS.doStat(FS.lstat, path, buf);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_madvise1(addr, length, advice) {
      return 0; // advice is welcome, but ignored
    }

  function ___sys_mincore(addr, length, vec) {
      return -52; // unsupported feature
    }

  function ___sys_mkdir(path, mode) {try {
  
      path = SYSCALLS.getStr(path);
      return SYSCALLS.doMkdir(path, mode);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_mkdirat(dirfd, path, mode) {try {
  
      path = SYSCALLS.getStr(path);
      path = SYSCALLS.calculateAt(dirfd, path);
      return SYSCALLS.doMkdir(path, mode);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_mknod(path, mode, dev) {try {
  
      path = SYSCALLS.getStr(path);
      return SYSCALLS.doMknod(path, mode, dev);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_mknodat(dirfd, path, mode, dev) {try {
  
      path = SYSCALLS.getStr(path);
      path = SYSCALLS.calculateAt(dirfd, path);
      return SYSCALLS.doMknod(path, mode, dev);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_mlock(addr, len) {
      return 0;
    }

  function ___sys_mlockall(flags) {
      return 0;
    }

  
  function syscallMmap2(addr, len, prot, flags, fd, off) {
      off <<= 12; // undo pgoffset
      var ptr;
      var allocated = false;
  
      // addr argument must be page aligned if MAP_FIXED flag is set.
      if ((flags & 16) !== 0 && (addr % 16384) !== 0) {
        return -28;
      }
  
      // MAP_ANONYMOUS (aka MAP_ANON) isn't actually defined by POSIX spec,
      // but it is widely used way to allocate memory pages on Linux, BSD and Mac.
      // In this case fd argument is ignored.
      if ((flags & 32) !== 0) {
        ptr = _memalign(16384, len);
        if (!ptr) return -48;
        _memset(ptr, 0, len);
        allocated = true;
      } else {
        var info = FS.getStream(fd);
        if (!info) return -8;
        var res = FS.mmap(info, addr, len, off, prot, flags);
        ptr = res.ptr;
        allocated = res.allocated;
      }
      SYSCALLS.mappings[ptr] = { malloc: ptr, len: len, allocated: allocated, fd: fd, prot: prot, flags: flags, offset: off };
      return ptr;
    }function ___sys_mmap2(addr, len, prot, flags, fd, off) {try {
  
      return syscallMmap2(addr, len, prot, flags, fd, off);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_mprotect(addr, len, size) {
      return 0; // let's not and say we did
    }

  function ___sys_mremap(old_addr, old_size, new_size, flags) {
      return -48; // never succeed
    }

  function ___sys_msync(addr, len, flags) {try {
  
      var info = SYSCALLS.mappings[addr];
      if (!info) return 0;
      SYSCALLS.doMsync(addr, FS.getStream(info.fd), len, info.flags, 0);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_munlock(addr, len) {
      return 0;
    }

  function ___sys_munlockall() {
      return 0;
    }

  
  function syscallMunmap(addr, len) {
      if ((addr | 0) === -1 || len === 0) {
        return -28;
      }
      // TODO: support unmmap'ing parts of allocations
      var info = SYSCALLS.mappings[addr];
      if (!info) return 0;
      if (len === info.len) {
        var stream = FS.getStream(info.fd);
        if (info.prot & 2) {
          SYSCALLS.doMsync(addr, stream, len, info.flags, info.offset);
        }
        FS.munmap(stream);
        SYSCALLS.mappings[addr] = null;
        if (info.allocated) {
          _free(info.malloc);
        }
      }
      return 0;
    }function ___sys_munmap(addr, len) {try {
  
      return syscallMunmap(addr, len);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_nice(inc) {
      return -63; // no meaning to nice for our single-process environment
    }

  function ___sys_open(path, flags, varargs) {SYSCALLS.varargs = varargs;
  try {
  
      var pathname = SYSCALLS.getStr(path);
      var mode = SYSCALLS.get();
      var stream = FS.open(pathname, flags, mode);
      return stream.fd;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_openat(dirfd, path, flags, varargs) {SYSCALLS.varargs = varargs;
  try {
  
      path = SYSCALLS.getStr(path);
      path = SYSCALLS.calculateAt(dirfd, path);
      var mode = SYSCALLS.get();
      return FS.open(path, flags, mode).fd;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_pause() {
      return -27; // we can't pause
    }

  
  var PIPEFS={BUCKET_BUFFER_SIZE:8192,mount:function (mount) {
        // Do not pollute the real root directory or its child nodes with pipes
        // Looks like it is OK to create another pseudo-root node not linked to the FS.root hierarchy this way
        return FS.createNode(null, '/', 16384 | 511 /* 0777 */, 0);
      },createPipe:function () {
        var pipe = {
          buckets: []
        };
  
        pipe.buckets.push({
          buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
          offset: 0,
          roffset: 0
        });
  
        var rName = PIPEFS.nextname();
        var wName = PIPEFS.nextname();
        var rNode = FS.createNode(PIPEFS.root, rName, 4096, 0);
        var wNode = FS.createNode(PIPEFS.root, wName, 4096, 0);
  
        rNode.pipe = pipe;
        wNode.pipe = pipe;
  
        var readableStream = FS.createStream({
          path: rName,
          node: rNode,
          flags: FS.modeStringToFlags('r'),
          seekable: false,
          stream_ops: PIPEFS.stream_ops
        });
        rNode.stream = readableStream;
  
        var writableStream = FS.createStream({
          path: wName,
          node: wNode,
          flags: FS.modeStringToFlags('w'),
          seekable: false,
          stream_ops: PIPEFS.stream_ops
        });
        wNode.stream = writableStream;
  
        return {
          readable_fd: readableStream.fd,
          writable_fd: writableStream.fd
        };
      },stream_ops:{poll:function (stream) {
          var pipe = stream.node.pipe;
  
          if ((stream.flags & 2097155) === 1) {
            return (256 | 4);
          } else {
            if (pipe.buckets.length > 0) {
              for (var i = 0; i < pipe.buckets.length; i++) {
                var bucket = pipe.buckets[i];
                if (bucket.offset - bucket.roffset > 0) {
                  return (64 | 1);
                }
              }
            }
          }
  
          return 0;
        },ioctl:function (stream, request, varargs) {
          return ERRNO_CODES.EINVAL;
        },fsync:function (stream) {
          return ERRNO_CODES.EINVAL;
        },read:function (stream, buffer, offset, length, position /* ignored */) {
          var pipe = stream.node.pipe;
          var currentLength = 0;
  
          for (var i = 0; i < pipe.buckets.length; i++) {
            var bucket = pipe.buckets[i];
            currentLength += bucket.offset - bucket.roffset;
          }
  
          assert(buffer instanceof ArrayBuffer || ArrayBuffer.isView(buffer));
          var data = buffer.subarray(offset, offset + length);
  
          if (length <= 0) {
            return 0;
          }
          if (currentLength == 0) {
            // Behave as if the read end is always non-blocking
            throw new FS.ErrnoError(ERRNO_CODES.EAGAIN);
          }
          var toRead = Math.min(currentLength, length);
  
          var totalRead = toRead;
          var toRemove = 0;
  
          for (var i = 0; i < pipe.buckets.length; i++) {
            var currBucket = pipe.buckets[i];
            var bucketSize = currBucket.offset - currBucket.roffset;
  
            if (toRead <= bucketSize) {
              var tmpSlice = currBucket.buffer.subarray(currBucket.roffset, currBucket.offset);
              if (toRead < bucketSize) {
                tmpSlice = tmpSlice.subarray(0, toRead);
                currBucket.roffset += toRead;
              } else {
                toRemove++;
              }
              data.set(tmpSlice);
              break;
            } else {
              var tmpSlice = currBucket.buffer.subarray(currBucket.roffset, currBucket.offset);
              data.set(tmpSlice);
              data = data.subarray(tmpSlice.byteLength);
              toRead -= tmpSlice.byteLength;
              toRemove++;
            }
          }
  
          if (toRemove && toRemove == pipe.buckets.length) {
            // Do not generate excessive garbage in use cases such as
            // write several bytes, read everything, write several bytes, read everything...
            toRemove--;
            pipe.buckets[toRemove].offset = 0;
            pipe.buckets[toRemove].roffset = 0;
          }
  
          pipe.buckets.splice(0, toRemove);
  
          return totalRead;
        },write:function (stream, buffer, offset, length, position /* ignored */) {
          var pipe = stream.node.pipe;
  
          assert(buffer instanceof ArrayBuffer || ArrayBuffer.isView(buffer));
          var data = buffer.subarray(offset, offset + length);
  
          var dataLen = data.byteLength;
          if (dataLen <= 0) {
            return 0;
          }
  
          var currBucket = null;
  
          if (pipe.buckets.length == 0) {
            currBucket = {
              buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
              offset: 0,
              roffset: 0
            };
            pipe.buckets.push(currBucket);
          } else {
            currBucket = pipe.buckets[pipe.buckets.length - 1];
          }
  
          assert(currBucket.offset <= PIPEFS.BUCKET_BUFFER_SIZE);
  
          var freeBytesInCurrBuffer = PIPEFS.BUCKET_BUFFER_SIZE - currBucket.offset;
          if (freeBytesInCurrBuffer >= dataLen) {
            currBucket.buffer.set(data, currBucket.offset);
            currBucket.offset += dataLen;
            return dataLen;
          } else if (freeBytesInCurrBuffer > 0) {
            currBucket.buffer.set(data.subarray(0, freeBytesInCurrBuffer), currBucket.offset);
            currBucket.offset += freeBytesInCurrBuffer;
            data = data.subarray(freeBytesInCurrBuffer, data.byteLength);
          }
  
          var numBuckets = (data.byteLength / PIPEFS.BUCKET_BUFFER_SIZE) | 0;
          var remElements = data.byteLength % PIPEFS.BUCKET_BUFFER_SIZE;
  
          for (var i = 0; i < numBuckets; i++) {
            var newBucket = {
              buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
              offset: PIPEFS.BUCKET_BUFFER_SIZE,
              roffset: 0
            };
            pipe.buckets.push(newBucket);
            newBucket.buffer.set(data.subarray(0, PIPEFS.BUCKET_BUFFER_SIZE));
            data = data.subarray(PIPEFS.BUCKET_BUFFER_SIZE, data.byteLength);
          }
  
          if (remElements > 0) {
            var newBucket = {
              buffer: new Uint8Array(PIPEFS.BUCKET_BUFFER_SIZE),
              offset: data.byteLength,
              roffset: 0
            };
            pipe.buckets.push(newBucket);
            newBucket.buffer.set(data);
          }
  
          return dataLen;
        },close:function (stream) {
          var pipe = stream.node.pipe;
          pipe.buckets = null;
        }},nextname:function () {
        if (!PIPEFS.nextname.current) {
          PIPEFS.nextname.current = 0;
        }
        return 'pipe[' + (PIPEFS.nextname.current++) + ']';
      }};function ___sys_pipe(fdPtr) {try {
  
      if (fdPtr == 0) {
        throw new FS.ErrnoError(21);
      }
  
      var res = PIPEFS.createPipe();
  
      HEAP32[((fdPtr)>>2)]=res.readable_fd;
      HEAP32[(((fdPtr)+(4))>>2)]=res.writable_fd;
  
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_pipe2(fds, flags) {
      return -52; // unsupported feature
    }

  function ___sys_poll(fds, nfds, timeout) {try {
  
      var nonzero = 0;
      for (var i = 0; i < nfds; i++) {
        var pollfd = fds + 8 * i;
        var fd = HEAP32[((pollfd)>>2)];
        var events = HEAP16[(((pollfd)+(4))>>1)];
        var mask = 32;
        var stream = FS.getStream(fd);
        if (stream) {
          mask = SYSCALLS.DEFAULT_POLLMASK;
          if (stream.stream_ops.poll) {
            mask = stream.stream_ops.poll(stream);
          }
        }
        mask &= events | 8 | 16;
        if (mask) nonzero++;
        HEAP16[(((pollfd)+(6))>>1)]=mask;
      }
      return nonzero;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_pread64(fd, buf, count, zero, low, high) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd)
      var offset = SYSCALLS.get64(low, high);
      return FS.read(stream, HEAP8,buf, count, offset);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_preadv(fd, iov, iovcnt, low, high) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      return SYSCALLS.doReadv(stream, iov, iovcnt, offset);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_prlimit64(pid, resource, new_limit, old_limit) {try {
  
      if (old_limit) { // just report no limits
        HEAP32[((old_limit)>>2)]=-1;  // RLIM_INFINITY
        HEAP32[(((old_limit)+(4))>>2)]=-1;  // RLIM_INFINITY
        HEAP32[(((old_limit)+(8))>>2)]=-1;  // RLIM_INFINITY
        HEAP32[(((old_limit)+(12))>>2)]=-1;  // RLIM_INFINITY
      }
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_pselect6() {
      return -52; // unsupported feature
    }

  function ___sys_pwrite64(fd, buf, count, zero, low, high) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd)
      var offset = SYSCALLS.get64(low, high);
      return FS.write(stream, HEAP8,buf, count, offset);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_pwritev(fd, iov, iovcnt, low, high) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      var offset = SYSCALLS.get64(low, high);
      return SYSCALLS.doWritev(stream, iov, iovcnt, offset);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_read(fd, buf, count) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      return FS.read(stream, HEAP8,buf, count);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_readlink(path, buf, bufsize) {try {
  
      path = SYSCALLS.getStr(path);
      return SYSCALLS.doReadlink(path, buf, bufsize);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_readlinkat(dirfd, path, buf, bufsize) {try {
  
      path = SYSCALLS.getStr(path);
      path = SYSCALLS.calculateAt(dirfd, path);
      return SYSCALLS.doReadlink(path, buf, bufsize);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_recvmmsg(sockfd, msgvec, vlen, flags) {
      return 0;
    }

  function ___sys_rename(old_path, new_path) {try {
  
      old_path = SYSCALLS.getStr(old_path);
      new_path = SYSCALLS.getStr(new_path);
      FS.rename(old_path, new_path);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_renameat(olddirfd, oldpath, newdirfd, newpath) {try {
  
      oldpath = SYSCALLS.getStr(oldpath);
      newpath = SYSCALLS.getStr(newpath);
      oldpath = SYSCALLS.calculateAt(olddirfd, oldpath);
      newpath = SYSCALLS.calculateAt(newdirfd, newpath);
      FS.rename(oldpath, newpath);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_rmdir(path) {try {
  
      path = SYSCALLS.getStr(path);
      FS.rmdir(path);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_sendmmsg(sockfd, msg, flags) {
      return 0;
    }

  function ___sys_setdomainname(name, size) {
      return -63;
    }

  function ___sys_setpgid(pid, pgid) {
      if (pid && pid !== 42) return -71;
      if (pgid && pgid !== 42) return -63;
      return 0;
    }

  function ___sys_setpriority() {
      return -63;
    }

  function ___sys_setrlimit(varargs) {
      return 0; // no-op
    }

  function ___sys_setsid() {
      return 0; // no-op
    }

  
  var SOCKFS={mount:function(mount) {
        // If Module['websocket'] has already been defined (e.g. for configuring
        // the subprotocol/url) use that, if not initialise it to a new object.
        Module['websocket'] = (Module['websocket'] && 
                               ('object' === typeof Module['websocket'])) ? Module['websocket'] : {};
  
        // Add the Event registration mechanism to the exported websocket configuration
        // object so we can register network callbacks from native JavaScript too.
        // For more documentation see system/include/emscripten/emscripten.h
        Module['websocket']._callbacks = {};
        Module['websocket']['on'] = /** @this{Object} */ function(event, callback) {
  	    if ('function' === typeof callback) {
  		  this._callbacks[event] = callback;
          }
  	    return this;
        };
  
        Module['websocket'].emit = /** @this{Object} */ function(event, param) {
  	    if ('function' === typeof this._callbacks[event]) {
  		  this._callbacks[event].call(this, param);
          }
        };
  
        // If debug is enabled register simple default logging callbacks for each Event.
  
        return FS.createNode(null, '/', 16384 | 511 /* 0777 */, 0);
      },createSocket:function(family, type, protocol) {
        type &= ~526336; // Some applications may pass it; it makes no sense for a single process.
        var streaming = type == 1;
        if (protocol) {
          assert(streaming == (protocol == 6)); // if SOCK_STREAM, must be tcp
        }
  
        // create our internal socket structure
        var sock = {
          family: family,
          type: type,
          protocol: protocol,
          server: null,
          error: null, // Used in getsockopt for SOL_SOCKET/SO_ERROR test
          peers: {},
          pending: [],
          recv_queue: [],
          sock_ops: SOCKFS.websocket_sock_ops
        };
  
        // create the filesystem node to store the socket structure
        var name = SOCKFS.nextname();
        var node = FS.createNode(SOCKFS.root, name, 49152, 0);
        node.sock = sock;
  
        // and the wrapping stream that enables library functions such
        // as read and write to indirectly interact with the socket
        var stream = FS.createStream({
          path: name,
          node: node,
          flags: FS.modeStringToFlags('r+'),
          seekable: false,
          stream_ops: SOCKFS.stream_ops
        });
  
        // map the new stream to the socket structure (sockets have a 1:1
        // relationship with a stream)
        sock.stream = stream;
  
        return sock;
      },getSocket:function(fd) {
        var stream = FS.getStream(fd);
        if (!stream || !FS.isSocket(stream.node.mode)) {
          return null;
        }
        return stream.node.sock;
      },stream_ops:{poll:function(stream) {
          var sock = stream.node.sock;
          return sock.sock_ops.poll(sock);
        },ioctl:function(stream, request, varargs) {
          var sock = stream.node.sock;
          return sock.sock_ops.ioctl(sock, request, varargs);
        },read:function(stream, buffer, offset, length, position /* ignored */) {
          var sock = stream.node.sock;
          var msg = sock.sock_ops.recvmsg(sock, length);
          if (!msg) {
            // socket is closed
            return 0;
          }
          buffer.set(msg.buffer, offset);
          return msg.buffer.length;
        },write:function(stream, buffer, offset, length, position /* ignored */) {
          var sock = stream.node.sock;
          return sock.sock_ops.sendmsg(sock, buffer, offset, length);
        },close:function(stream) {
          var sock = stream.node.sock;
          sock.sock_ops.close(sock);
        }},nextname:function() {
        if (!SOCKFS.nextname.current) {
          SOCKFS.nextname.current = 0;
        }
        return 'socket[' + (SOCKFS.nextname.current++) + ']';
      },websocket_sock_ops:{createPeer:function(sock, addr, port) {
          var ws;
  
          if (typeof addr === 'object') {
            ws = addr;
            addr = null;
            port = null;
          }
  
          if (ws) {
            // for sockets that've already connected (e.g. we're the server)
            // we can inspect the _socket property for the address
            if (ws._socket) {
              addr = ws._socket.remoteAddress;
              port = ws._socket.remotePort;
            }
            // if we're just now initializing a connection to the remote,
            // inspect the url property
            else {
              var result = /ws[s]?:\/\/([^:]+):(\d+)/.exec(ws.url);
              if (!result) {
                throw new Error('WebSocket URL must be in the format ws(s)://address:port');
              }
              addr = result[1];
              port = parseInt(result[2], 10);
            }
          } else {
            // create the actual websocket object and connect
            try {
              // runtimeConfig gets set to true if WebSocket runtime configuration is available.
              var runtimeConfig = (Module['websocket'] && ('object' === typeof Module['websocket']));
  
              // The default value is 'ws://' the replace is needed because the compiler replaces '//' comments with '#'
              // comments without checking context, so we'd end up with ws:#, the replace swaps the '#' for '//' again.
              var url = 'ws:#'.replace('#', '//');
  
              if (runtimeConfig) {
                if ('string' === typeof Module['websocket']['url']) {
                  url = Module['websocket']['url']; // Fetch runtime WebSocket URL config.
                }
              }
  
              if (url === 'ws://' || url === 'wss://') { // Is the supplied URL config just a prefix, if so complete it.
                var parts = addr.split('/');
                url = url + parts[0] + ":" + port + "/" + parts.slice(1).join('/');
              }
  
              // Make the WebSocket subprotocol (Sec-WebSocket-Protocol) default to binary if no configuration is set.
              var subProtocols = 'binary'; // The default value is 'binary'
  
              if (runtimeConfig) {
                if ('string' === typeof Module['websocket']['subprotocol']) {
                  subProtocols = Module['websocket']['subprotocol']; // Fetch runtime WebSocket subprotocol config.
                }
              }
  
              // The default WebSocket options
              var opts = undefined;
  
              if (subProtocols !== 'null') {
                // The regex trims the string (removes spaces at the beginning and end, then splits the string by
                // <any space>,<any space> into an Array. Whitespace removal is important for Websockify and ws.
                subProtocols = subProtocols.replace(/^ +| +$/g,"").split(/ *, */);
  
                // The node ws library API for specifying optional subprotocol is slightly different than the browser's.
                opts = ENVIRONMENT_IS_NODE ? {'protocol': subProtocols.toString()} : subProtocols;
              }
  
              // some webservers (azure) does not support subprotocol header
              if (runtimeConfig && null === Module['websocket']['subprotocol']) {
                subProtocols = 'null';
                opts = undefined;
              }
  
              // If node we use the ws library.
              var WebSocketConstructor;
              {
                WebSocketConstructor = WebSocket;
              }
              ws = new WebSocketConstructor(url, opts);
              ws.binaryType = 'arraybuffer';
            } catch (e) {
              throw new FS.ErrnoError(ERRNO_CODES.EHOSTUNREACH);
            }
          }
  
  
          var peer = {
            addr: addr,
            port: port,
            socket: ws,
            dgram_send_queue: []
          };
  
          SOCKFS.websocket_sock_ops.addPeer(sock, peer);
          SOCKFS.websocket_sock_ops.handlePeerEvents(sock, peer);
  
          // if this is a bound dgram socket, send the port number first to allow
          // us to override the ephemeral port reported to us by remotePort on the
          // remote end.
          if (sock.type === 2 && typeof sock.sport !== 'undefined') {
            peer.dgram_send_queue.push(new Uint8Array([
                255, 255, 255, 255,
                'p'.charCodeAt(0), 'o'.charCodeAt(0), 'r'.charCodeAt(0), 't'.charCodeAt(0),
                ((sock.sport & 0xff00) >> 8) , (sock.sport & 0xff)
            ]));
          }
  
          return peer;
        },getPeer:function(sock, addr, port) {
          return sock.peers[addr + ':' + port];
        },addPeer:function(sock, peer) {
          sock.peers[peer.addr + ':' + peer.port] = peer;
        },removePeer:function(sock, peer) {
          delete sock.peers[peer.addr + ':' + peer.port];
        },handlePeerEvents:function(sock, peer) {
          var first = true;
  
          var handleOpen = function () {
  
            Module['websocket'].emit('open', sock.stream.fd);
  
            try {
              var queued = peer.dgram_send_queue.shift();
              while (queued) {
                peer.socket.send(queued);
                queued = peer.dgram_send_queue.shift();
              }
            } catch (e) {
              // not much we can do here in the way of proper error handling as we've already
              // lied and said this data was sent. shut it down.
              peer.socket.close();
            }
          };
  
          function handleMessage(data) {
            if (typeof data === 'string') {
              var encoder = new TextEncoder(); // should be utf-8
              data = encoder.encode(data); // make a typed array from the string
            } else {
              assert(data.byteLength !== undefined); // must receive an ArrayBuffer
              if (data.byteLength == 0) {
                // An empty ArrayBuffer will emit a pseudo disconnect event
                // as recv/recvmsg will return zero which indicates that a socket
                // has performed a shutdown although the connection has not been disconnected yet.
                return;
              } else {
                data = new Uint8Array(data); // make a typed array view on the array buffer
              }
            }
  
  
            // if this is the port message, override the peer's port with it
            var wasfirst = first;
            first = false;
            if (wasfirst &&
                data.length === 10 &&
                data[0] === 255 && data[1] === 255 && data[2] === 255 && data[3] === 255 &&
                data[4] === 'p'.charCodeAt(0) && data[5] === 'o'.charCodeAt(0) && data[6] === 'r'.charCodeAt(0) && data[7] === 't'.charCodeAt(0)) {
              // update the peer's port and it's key in the peer map
              var newport = ((data[8] << 8) | data[9]);
              SOCKFS.websocket_sock_ops.removePeer(sock, peer);
              peer.port = newport;
              SOCKFS.websocket_sock_ops.addPeer(sock, peer);
              return;
            }
  
            sock.recv_queue.push({ addr: peer.addr, port: peer.port, data: data });
            Module['websocket'].emit('message', sock.stream.fd);
          };
  
          if (ENVIRONMENT_IS_NODE) {
            peer.socket.on('open', handleOpen);
            peer.socket.on('message', function(data, flags) {
              if (!flags.binary) {
                return;
              }
              handleMessage((new Uint8Array(data)).buffer);  // copy from node Buffer -> ArrayBuffer
            });
            peer.socket.on('close', function() {
              Module['websocket'].emit('close', sock.stream.fd);
            });
            peer.socket.on('error', function(error) {
              // Although the ws library may pass errors that may be more descriptive than
              // ECONNREFUSED they are not necessarily the expected error code e.g. 
              // ENOTFOUND on getaddrinfo seems to be node.js specific, so using ECONNREFUSED
              // is still probably the most useful thing to do.
              sock.error = ERRNO_CODES.ECONNREFUSED; // Used in getsockopt for SOL_SOCKET/SO_ERROR test.
              Module['websocket'].emit('error', [sock.stream.fd, sock.error, 'ECONNREFUSED: Connection refused']);
              // don't throw
            });
          } else {
            peer.socket.onopen = handleOpen;
            peer.socket.onclose = function() {
              Module['websocket'].emit('close', sock.stream.fd);
            };
            peer.socket.onmessage = function peer_socket_onmessage(event) {
              handleMessage(event.data);
            };
            peer.socket.onerror = function(error) {
              // The WebSocket spec only allows a 'simple event' to be thrown on error,
              // so we only really know as much as ECONNREFUSED.
              sock.error = ERRNO_CODES.ECONNREFUSED; // Used in getsockopt for SOL_SOCKET/SO_ERROR test.
              Module['websocket'].emit('error', [sock.stream.fd, sock.error, 'ECONNREFUSED: Connection refused']);
            };
          }
        },poll:function(sock) {
          if (sock.type === 1 && sock.server) {
            // listen sockets should only say they're available for reading
            // if there are pending clients.
            return sock.pending.length ? (64 | 1) : 0;
          }
  
          var mask = 0;
          var dest = sock.type === 1 ?  // we only care about the socket state for connection-based sockets
            SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport) :
            null;
  
          if (sock.recv_queue.length ||
              !dest ||  // connection-less sockets are always ready to read
              (dest && dest.socket.readyState === dest.socket.CLOSING) ||
              (dest && dest.socket.readyState === dest.socket.CLOSED)) {  // let recv return 0 once closed
            mask |= (64 | 1);
          }
  
          if (!dest ||  // connection-less sockets are always ready to write
              (dest && dest.socket.readyState === dest.socket.OPEN)) {
            mask |= 4;
          }
  
          if ((dest && dest.socket.readyState === dest.socket.CLOSING) ||
              (dest && dest.socket.readyState === dest.socket.CLOSED)) {
            mask |= 16;
          }
  
          return mask;
        },ioctl:function(sock, request, arg) {
          switch (request) {
            case 21531:
              var bytes = 0;
              if (sock.recv_queue.length) {
                bytes = sock.recv_queue[0].data.length;
              }
              HEAP32[((arg)>>2)]=bytes;
              return 0;
            default:
              return ERRNO_CODES.EINVAL;
          }
        },close:function(sock) {
          // if we've spawned a listen server, close it
          if (sock.server) {
            try {
              sock.server.close();
            } catch (e) {
            }
            sock.server = null;
          }
          // close any peer connections
          var peers = Object.keys(sock.peers);
          for (var i = 0; i < peers.length; i++) {
            var peer = sock.peers[peers[i]];
            try {
              peer.socket.close();
            } catch (e) {
            }
            SOCKFS.websocket_sock_ops.removePeer(sock, peer);
          }
          return 0;
        },bind:function(sock, addr, port) {
          if (typeof sock.saddr !== 'undefined' || typeof sock.sport !== 'undefined') {
            throw new FS.ErrnoError(ERRNO_CODES.EINVAL);  // already bound
          }
          sock.saddr = addr;
          sock.sport = port;
          // in order to emulate dgram sockets, we need to launch a listen server when
          // binding on a connection-less socket
          // note: this is only required on the server side
          if (sock.type === 2) {
            // close the existing server if it exists
            if (sock.server) {
              sock.server.close();
              sock.server = null;
            }
            // swallow error operation not supported error that occurs when binding in the
            // browser where this isn't supported
            try {
              sock.sock_ops.listen(sock, 0);
            } catch (e) {
              if (!(e instanceof FS.ErrnoError)) throw e;
              if (e.errno !== ERRNO_CODES.EOPNOTSUPP) throw e;
            }
          }
        },connect:function(sock, addr, port) {
          if (sock.server) {
            throw new FS.ErrnoError(ERRNO_CODES.EOPNOTSUPP);
          }
  
          // TODO autobind
          // if (!sock.addr && sock.type == 2) {
          // }
  
          // early out if we're already connected / in the middle of connecting
          if (typeof sock.daddr !== 'undefined' && typeof sock.dport !== 'undefined') {
            var dest = SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport);
            if (dest) {
              if (dest.socket.readyState === dest.socket.CONNECTING) {
                throw new FS.ErrnoError(ERRNO_CODES.EALREADY);
              } else {
                throw new FS.ErrnoError(ERRNO_CODES.EISCONN);
              }
            }
          }
  
          // add the socket to our peer list and set our
          // destination address / port to match
          var peer = SOCKFS.websocket_sock_ops.createPeer(sock, addr, port);
          sock.daddr = peer.addr;
          sock.dport = peer.port;
  
          // always "fail" in non-blocking mode
          throw new FS.ErrnoError(ERRNO_CODES.EINPROGRESS);
        },listen:function(sock, backlog) {
          if (!ENVIRONMENT_IS_NODE) {
            throw new FS.ErrnoError(ERRNO_CODES.EOPNOTSUPP);
          }
        },accept:function(listensock) {
          if (!listensock.server) {
            throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
          }
          var newsock = listensock.pending.shift();
          newsock.stream.flags = listensock.stream.flags;
          return newsock;
        },getname:function(sock, peer) {
          var addr, port;
          if (peer) {
            if (sock.daddr === undefined || sock.dport === undefined) {
              throw new FS.ErrnoError(ERRNO_CODES.ENOTCONN);
            }
            addr = sock.daddr;
            port = sock.dport;
          } else {
            // TODO saddr and sport will be set for bind()'d UDP sockets, but what
            // should we be returning for TCP sockets that've been connect()'d?
            addr = sock.saddr || 0;
            port = sock.sport || 0;
          }
          return { addr: addr, port: port };
        },sendmsg:function(sock, buffer, offset, length, addr, port) {
          if (sock.type === 2) {
            // connection-less sockets will honor the message address,
            // and otherwise fall back to the bound destination address
            if (addr === undefined || port === undefined) {
              addr = sock.daddr;
              port = sock.dport;
            }
            // if there was no address to fall back to, error out
            if (addr === undefined || port === undefined) {
              throw new FS.ErrnoError(ERRNO_CODES.EDESTADDRREQ);
            }
          } else {
            // connection-based sockets will only use the bound
            addr = sock.daddr;
            port = sock.dport;
          }
  
          // find the peer for the destination address
          var dest = SOCKFS.websocket_sock_ops.getPeer(sock, addr, port);
  
          // early out if not connected with a connection-based socket
          if (sock.type === 1) {
            if (!dest || dest.socket.readyState === dest.socket.CLOSING || dest.socket.readyState === dest.socket.CLOSED) {
              throw new FS.ErrnoError(ERRNO_CODES.ENOTCONN);
            } else if (dest.socket.readyState === dest.socket.CONNECTING) {
              throw new FS.ErrnoError(ERRNO_CODES.EAGAIN);
            }
          }
  
          // create a copy of the incoming data to send, as the WebSocket API
          // doesn't work entirely with an ArrayBufferView, it'll just send
          // the entire underlying buffer
          if (ArrayBuffer.isView(buffer)) {
            offset += buffer.byteOffset;
            buffer = buffer.buffer;
          }
  
          var data;
            data = buffer.slice(offset, offset + length);
  
          // if we're emulating a connection-less dgram socket and don't have
          // a cached connection, queue the buffer to send upon connect and
          // lie, saying the data was sent now.
          if (sock.type === 2) {
            if (!dest || dest.socket.readyState !== dest.socket.OPEN) {
              // if we're not connected, open a new connection
              if (!dest || dest.socket.readyState === dest.socket.CLOSING || dest.socket.readyState === dest.socket.CLOSED) {
                dest = SOCKFS.websocket_sock_ops.createPeer(sock, addr, port);
              }
              dest.dgram_send_queue.push(data);
              return length;
            }
          }
  
          try {
            // send the actual data
            dest.socket.send(data);
            return length;
          } catch (e) {
            throw new FS.ErrnoError(ERRNO_CODES.EINVAL);
          }
        },recvmsg:function(sock, length) {
          // http://pubs.opengroup.org/onlinepubs/7908799/xns/recvmsg.html
          if (sock.type === 1 && sock.server) {
            // tcp servers should not be recv()'ing on the listen socket
            throw new FS.ErrnoError(ERRNO_CODES.ENOTCONN);
          }
  
          var queued = sock.recv_queue.shift();
          if (!queued) {
            if (sock.type === 1) {
              var dest = SOCKFS.websocket_sock_ops.getPeer(sock, sock.daddr, sock.dport);
  
              if (!dest) {
                // if we have a destination address but are not connected, error out
                throw new FS.ErrnoError(ERRNO_CODES.ENOTCONN);
              }
              else if (dest.socket.readyState === dest.socket.CLOSING || dest.socket.readyState === dest.socket.CLOSED) {
                // return null if the socket has closed
                return null;
              }
              else {
                // else, our socket is in a valid state but truly has nothing available
                throw new FS.ErrnoError(ERRNO_CODES.EAGAIN);
              }
            } else {
              throw new FS.ErrnoError(ERRNO_CODES.EAGAIN);
            }
          }
  
          // queued.data will be an ArrayBuffer if it's unadulterated, but if it's
          // requeued TCP data it'll be an ArrayBufferView
          var queuedLength = queued.data.byteLength || queued.data.length;
          var queuedOffset = queued.data.byteOffset || 0;
          var queuedBuffer = queued.data.buffer || queued.data;
          var bytesRead = Math.min(length, queuedLength);
          var res = {
            buffer: new Uint8Array(queuedBuffer, queuedOffset, bytesRead),
            addr: queued.addr,
            port: queued.port
          };
  
  
          // push back any unread data for TCP connections
          if (sock.type === 1 && bytesRead < queuedLength) {
            var bytesRemaining = queuedLength - bytesRead;
            queued.data = new Uint8Array(queuedBuffer, queuedOffset + bytesRead, bytesRemaining);
            sock.recv_queue.unshift(queued);
          }
  
          return res;
        }}};
  
  
  function __inet_pton4_raw(str) {
      var b = str.split('.');
      for (var i = 0; i < 4; i++) {
        var tmp = Number(b[i]);
        if (isNaN(tmp)) return null;
        b[i] = tmp;
      }
      return (b[0] | (b[1] << 8) | (b[2] << 16) | (b[3] << 24)) >>> 0;
    }
  
  
  /** @suppress {checkTypes} */
  function jstoi_q(str) {
      return parseInt(str);
    }function __inet_pton6_raw(str) {
      var words;
      var w, offset, z, i;
      /* http://home.deds.nl/~aeron/regex/ */
      var valid6regx = /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i
      var parts = [];
      if (!valid6regx.test(str)) {
        return null;
      }
      if (str === "::") {
        return [0, 0, 0, 0, 0, 0, 0, 0];
      }
      // Z placeholder to keep track of zeros when splitting the string on ":"
      if (str.indexOf("::") === 0) {
        str = str.replace("::", "Z:"); // leading zeros case
      } else {
        str = str.replace("::", ":Z:");
      }
  
      if (str.indexOf(".") > 0) {
        // parse IPv4 embedded stress
        str = str.replace(new RegExp('[.]', 'g'), ":");
        words = str.split(":");
        words[words.length-4] = jstoi_q(words[words.length-4]) + jstoi_q(words[words.length-3])*256;
        words[words.length-3] = jstoi_q(words[words.length-2]) + jstoi_q(words[words.length-1])*256;
        words = words.slice(0, words.length-2);
      } else {
        words = str.split(":");
      }
  
      offset = 0; z = 0;
      for (w=0; w < words.length; w++) {
        if (typeof words[w] === 'string') {
          if (words[w] === 'Z') {
            // compressed zeros - write appropriate number of zero words
            for (z = 0; z < (8 - words.length+1); z++) {
              parts[w+z] = 0;
            }
            offset = z-1;
          } else {
            // parse hex to field to 16-bit value and write it in network byte-order
            parts[w+offset] = _htons(parseInt(words[w],16));
          }
        } else {
          // parsed IPv4 words
          parts[w+offset] = words[w];
        }
      }
      return [
        (parts[1] << 16) | parts[0],
        (parts[3] << 16) | parts[2],
        (parts[5] << 16) | parts[4],
        (parts[7] << 16) | parts[6]
      ];
    }var DNS={address_map:{id:1,addrs:{},names:{}},lookup_name:function (name) {
        // If the name is already a valid ipv4 / ipv6 address, don't generate a fake one.
        var res = __inet_pton4_raw(name);
        if (res !== null) {
          return name;
        }
        res = __inet_pton6_raw(name);
        if (res !== null) {
          return name;
        }
  
        // See if this name is already mapped.
        var addr;
  
        if (DNS.address_map.addrs[name]) {
          addr = DNS.address_map.addrs[name];
        } else {
          var id = DNS.address_map.id++;
          assert(id < 65535, 'exceeded max address mappings of 65535');
  
          addr = '172.29.' + (id & 0xff) + '.' + (id & 0xff00);
  
          DNS.address_map.names[addr] = name;
          DNS.address_map.addrs[name] = addr;
        }
  
        return addr;
      },lookup_addr:function (addr) {
        if (DNS.address_map.names[addr]) {
          return DNS.address_map.names[addr];
        }
  
        return null;
      }};
  
  
  var Sockets={BUFFER_SIZE:10240,MAX_BUFFER_SIZE:10485760,nextFd:1,fds:{},nextport:1,maxport:65535,peer:null,connections:{},portmap:{},localAddr:4261412874,addrPool:[33554442,50331658,67108874,83886090,100663306,117440522,134217738,150994954,167772170,184549386,201326602,218103818,234881034]};
  
  function __inet_ntop4_raw(addr) {
      return (addr & 0xff) + '.' + ((addr >> 8) & 0xff) + '.' + ((addr >> 16) & 0xff) + '.' + ((addr >> 24) & 0xff)
    }
  
  function __inet_ntop6_raw(ints) {
      //  ref:  http://www.ietf.org/rfc/rfc2373.txt - section 2.5.4
      //  Format for IPv4 compatible and mapped  128-bit IPv6 Addresses
      //  128-bits are split into eight 16-bit words
      //  stored in network byte order (big-endian)
      //  |                80 bits               | 16 |      32 bits        |
      //  +-----------------------------------------------------------------+
      //  |               10 bytes               |  2 |      4 bytes        |
      //  +--------------------------------------+--------------------------+
      //  +               5 words                |  1 |      2 words        |
      //  +--------------------------------------+--------------------------+
      //  |0000..............................0000|0000|    IPv4 ADDRESS     | (compatible)
      //  +--------------------------------------+----+---------------------+
      //  |0000..............................0000|FFFF|    IPv4 ADDRESS     | (mapped)
      //  +--------------------------------------+----+---------------------+
      var str = "";
      var word = 0;
      var longest = 0;
      var lastzero = 0;
      var zstart = 0;
      var len = 0;
      var i = 0;
      var parts = [
        ints[0] & 0xffff,
        (ints[0] >> 16),
        ints[1] & 0xffff,
        (ints[1] >> 16),
        ints[2] & 0xffff,
        (ints[2] >> 16),
        ints[3] & 0xffff,
        (ints[3] >> 16)
      ];
  
      // Handle IPv4-compatible, IPv4-mapped, loopback and any/unspecified addresses
  
      var hasipv4 = true;
      var v4part = "";
      // check if the 10 high-order bytes are all zeros (first 5 words)
      for (i = 0; i < 5; i++) {
        if (parts[i] !== 0) { hasipv4 = false; break; }
      }
  
      if (hasipv4) {
        // low-order 32-bits store an IPv4 address (bytes 13 to 16) (last 2 words)
        v4part = __inet_ntop4_raw(parts[6] | (parts[7] << 16));
        // IPv4-mapped IPv6 address if 16-bit value (bytes 11 and 12) == 0xFFFF (6th word)
        if (parts[5] === -1) {
          str = "::ffff:";
          str += v4part;
          return str;
        }
        // IPv4-compatible IPv6 address if 16-bit value (bytes 11 and 12) == 0x0000 (6th word)
        if (parts[5] === 0) {
          str = "::";
          //special case IPv6 addresses
          if(v4part === "0.0.0.0") v4part = ""; // any/unspecified address
          if(v4part === "0.0.0.1") v4part = "1";// loopback address
          str += v4part;
          return str;
        }
      }
  
      // Handle all other IPv6 addresses
  
      // first run to find the longest contiguous zero words
      for (word = 0; word < 8; word++) {
        if (parts[word] === 0) {
          if (word - lastzero > 1) {
            len = 0;
          }
          lastzero = word;
          len++;
        }
        if (len > longest) {
          longest = len;
          zstart = word - longest + 1;
        }
      }
  
      for (word = 0; word < 8; word++) {
        if (longest > 1) {
          // compress contiguous zeros - to produce "::"
          if (parts[word] === 0 && word >= zstart && word < (zstart + longest) ) {
            if (word === zstart) {
              str += ":";
              if (zstart === 0) str += ":"; //leading zeros case
            }
            continue;
          }
        }
        // converts 16-bit words from big-endian to little-endian before converting to hex string
        str += Number(_ntohs(parts[word] & 0xffff)).toString(16);
        str += word < 7 ? ":" : "";
      }
      return str;
    }function __read_sockaddr(sa, salen) {
      // family / port offsets are common to both sockaddr_in and sockaddr_in6
      var family = HEAP16[((sa)>>1)];
      var port = _ntohs(HEAPU16[(((sa)+(2))>>1)]);
      var addr;
  
      switch (family) {
        case 2:
          if (salen !== 16) {
            return { errno: 28 };
          }
          addr = HEAP32[(((sa)+(4))>>2)];
          addr = __inet_ntop4_raw(addr);
          break;
        case 10:
          if (salen !== 28) {
            return { errno: 28 };
          }
          addr = [
            HEAP32[(((sa)+(8))>>2)],
            HEAP32[(((sa)+(12))>>2)],
            HEAP32[(((sa)+(16))>>2)],
            HEAP32[(((sa)+(20))>>2)]
          ];
          addr = __inet_ntop6_raw(addr);
          break;
        default:
          return { errno: 5 };
      }
  
      return { family: family, addr: addr, port: port };
    }
  
  function __write_sockaddr(sa, family, addr, port) {
      switch (family) {
        case 2:
          addr = __inet_pton4_raw(addr);
          HEAP16[((sa)>>1)]=family;
          HEAP32[(((sa)+(4))>>2)]=addr;
          HEAP16[(((sa)+(2))>>1)]=_htons(port);
          break;
        case 10:
          addr = __inet_pton6_raw(addr);
          HEAP32[((sa)>>2)]=family;
          HEAP32[(((sa)+(8))>>2)]=addr[0];
          HEAP32[(((sa)+(12))>>2)]=addr[1];
          HEAP32[(((sa)+(16))>>2)]=addr[2];
          HEAP32[(((sa)+(20))>>2)]=addr[3];
          HEAP16[(((sa)+(2))>>1)]=_htons(port);
          HEAP32[(((sa)+(4))>>2)]=0;
          HEAP32[(((sa)+(24))>>2)]=0;
          break;
        default:
          return { errno: 5 };
      }
      // kind of lame, but let's match _read_sockaddr's interface
      return {};
    }function ___sys_socketcall(call, socketvararg) {try {
  
      // socketcalls pass the rest of the arguments in a struct
      SYSCALLS.varargs = socketvararg;
  
      var getSocketFromFD = function() {
        var socket = SOCKFS.getSocket(SYSCALLS.get());
        if (!socket) throw new FS.ErrnoError(8);
        return socket;
      };
      /** @param {boolean=} allowNull */
      var getSocketAddress = function(allowNull) {
        var addrp = SYSCALLS.get(), addrlen = SYSCALLS.get();
        if (allowNull && addrp === 0) return null;
        var info = __read_sockaddr(addrp, addrlen);
        if (info.errno) throw new FS.ErrnoError(info.errno);
        info.addr = DNS.lookup_addr(info.addr) || info.addr;
        return info;
      };
  
      switch (call) {
        case 1: { // socket
          var domain = SYSCALLS.get(), type = SYSCALLS.get(), protocol = SYSCALLS.get();
          var sock = SOCKFS.createSocket(domain, type, protocol);
          assert(sock.stream.fd < 64); // XXX ? select() assumes socket fd values are in 0..63
          return sock.stream.fd;
        }
        case 2: { // bind
          var sock = getSocketFromFD(), info = getSocketAddress();
          sock.sock_ops.bind(sock, info.addr, info.port);
          return 0;
        }
        case 3: { // connect
          var sock = getSocketFromFD(), info = getSocketAddress();
          sock.sock_ops.connect(sock, info.addr, info.port);
          return 0;
        }
        case 4: { // listen
          var sock = getSocketFromFD(), backlog = SYSCALLS.get();
          sock.sock_ops.listen(sock, backlog);
          return 0;
        }
        case 5: { // accept
          var sock = getSocketFromFD(), addr = SYSCALLS.get(), addrlen = SYSCALLS.get();
          var newsock = sock.sock_ops.accept(sock);
          if (addr) {
            var res = __write_sockaddr(addr, newsock.family, DNS.lookup_name(newsock.daddr), newsock.dport);
            assert(!res.errno);
          }
          return newsock.stream.fd;
        }
        case 6: { // getsockname
          var sock = getSocketFromFD(), addr = SYSCALLS.get(), addrlen = SYSCALLS.get();
          // TODO: sock.saddr should never be undefined, see TODO in websocket_sock_ops.getname
          var res = __write_sockaddr(addr, sock.family, DNS.lookup_name(sock.saddr || '0.0.0.0'), sock.sport);
          assert(!res.errno);
          return 0;
        }
        case 7: { // getpeername
          var sock = getSocketFromFD(), addr = SYSCALLS.get(), addrlen = SYSCALLS.get();
          if (!sock.daddr) {
            return -53; // The socket is not connected.
          }
          var res = __write_sockaddr(addr, sock.family, DNS.lookup_name(sock.daddr), sock.dport);
          assert(!res.errno);
          return 0;
        }
        case 11: { // sendto
          var sock = getSocketFromFD(), message = SYSCALLS.get(), length = SYSCALLS.get(), flags = SYSCALLS.get(), dest = getSocketAddress(true);
          if (!dest) {
            // send, no address provided
            return FS.write(sock.stream, HEAP8,message, length);
          } else {
            // sendto an address
            return sock.sock_ops.sendmsg(sock, HEAP8,message, length, dest.addr, dest.port);
          }
        }
        case 12: { // recvfrom
          var sock = getSocketFromFD(), buf = SYSCALLS.get(), len = SYSCALLS.get(), flags = SYSCALLS.get(), addr = SYSCALLS.get(), addrlen = SYSCALLS.get();
          var msg = sock.sock_ops.recvmsg(sock, len);
          if (!msg) return 0; // socket is closed
          if (addr) {
            var res = __write_sockaddr(addr, sock.family, DNS.lookup_name(msg.addr), msg.port);
            assert(!res.errno);
          }
          HEAPU8.set(msg.buffer, buf);
          return msg.buffer.byteLength;
        }
        case 14: { // setsockopt
          return -50; // The option is unknown at the level indicated.
        }
        case 15: { // getsockopt
          var sock = getSocketFromFD(), level = SYSCALLS.get(), optname = SYSCALLS.get(), optval = SYSCALLS.get(), optlen = SYSCALLS.get();
          // Minimal getsockopt aimed at resolving https://github.com/emscripten-core/emscripten/issues/2211
          // so only supports SOL_SOCKET with SO_ERROR.
          if (level === 1) {
            if (optname === 4) {
              HEAP32[((optval)>>2)]=sock.error;
              HEAP32[((optlen)>>2)]=4;
              sock.error = null; // Clear the error (The SO_ERROR option obtains and then clears this field).
              return 0;
            }
          }
          return -50; // The option is unknown at the level indicated.
        }
        case 16: { // sendmsg
          var sock = getSocketFromFD(), message = SYSCALLS.get(), flags = SYSCALLS.get();
          var iov = HEAP32[(((message)+(8))>>2)];
          var num = HEAP32[(((message)+(12))>>2)];
          // read the address and port to send to
          var addr, port;
          var name = HEAP32[((message)>>2)];
          var namelen = HEAP32[(((message)+(4))>>2)];
          if (name) {
            var info = __read_sockaddr(name, namelen);
            if (info.errno) return -info.errno;
            port = info.port;
            addr = DNS.lookup_addr(info.addr) || info.addr;
          }
          // concatenate scatter-gather arrays into one message buffer
          var total = 0;
          for (var i = 0; i < num; i++) {
            total += HEAP32[(((iov)+((8 * i) + 4))>>2)];
          }
          var view = new Uint8Array(total);
          var offset = 0;
          for (var i = 0; i < num; i++) {
            var iovbase = HEAP32[(((iov)+((8 * i) + 0))>>2)];
            var iovlen = HEAP32[(((iov)+((8 * i) + 4))>>2)];
            for (var j = 0; j < iovlen; j++) {  
              view[offset++] = HEAP8[(((iovbase)+(j))>>0)];
            }
          }
          // write the buffer
          return sock.sock_ops.sendmsg(sock, view, 0, total, addr, port);
        }
        case 17: { // recvmsg
          var sock = getSocketFromFD(), message = SYSCALLS.get(), flags = SYSCALLS.get();
          var iov = HEAP32[(((message)+(8))>>2)];
          var num = HEAP32[(((message)+(12))>>2)];
          // get the total amount of data we can read across all arrays
          var total = 0;
          for (var i = 0; i < num; i++) {
            total += HEAP32[(((iov)+((8 * i) + 4))>>2)];
          }
          // try to read total data
          var msg = sock.sock_ops.recvmsg(sock, total);
          if (!msg) return 0; // socket is closed
  
          // TODO honor flags:
          // MSG_OOB
          // Requests out-of-band data. The significance and semantics of out-of-band data are protocol-specific.
          // MSG_PEEK
          // Peeks at the incoming message.
          // MSG_WAITALL
          // Requests that the function block until the full amount of data requested can be returned. The function may return a smaller amount of data if a signal is caught, if the connection is terminated, if MSG_PEEK was specified, or if an error is pending for the socket.
  
          // write the source address out
          var name = HEAP32[((message)>>2)];
          if (name) {
            var res = __write_sockaddr(name, sock.family, DNS.lookup_name(msg.addr), msg.port);
            assert(!res.errno);
          }
          // write the buffer out to the scatter-gather arrays
          var bytesRead = 0;
          var bytesRemaining = msg.buffer.byteLength;
          for (var i = 0; bytesRemaining > 0 && i < num; i++) {
            var iovbase = HEAP32[(((iov)+((8 * i) + 0))>>2)];
            var iovlen = HEAP32[(((iov)+((8 * i) + 4))>>2)];
            if (!iovlen) {
              continue;
            }
            var length = Math.min(iovlen, bytesRemaining);
            var buf = msg.buffer.subarray(bytesRead, bytesRead + length);
            HEAPU8.set(buf, iovbase + bytesRead);
            bytesRead += length;
            bytesRemaining -= length;
          }
  
          // TODO set msghdr.msg_flags
          // MSG_EOR
          // End of record was received (if supported by the protocol).
          // MSG_OOB
          // Out-of-band data was received.
          // MSG_TRUNC
          // Normal data was truncated.
          // MSG_CTRUNC
  
          return bytesRead;
        }
        default: {
          return -52; // unsupported feature
        }
      }
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_stat64(path, buf) {try {
  
      path = SYSCALLS.getStr(path);
      return SYSCALLS.doStat(FS.stat, path, buf);
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_statfs64(path, size, buf) {try {
  
      path = SYSCALLS.getStr(path);
      assert(size === 64);
      // NOTE: None of the constants here are true. We're just returning safe and
      //       sane values.
      HEAP32[(((buf)+(4))>>2)]=4096;
      HEAP32[(((buf)+(40))>>2)]=4096;
      HEAP32[(((buf)+(8))>>2)]=1000000;
      HEAP32[(((buf)+(12))>>2)]=500000;
      HEAP32[(((buf)+(16))>>2)]=500000;
      HEAP32[(((buf)+(20))>>2)]=FS.nextInode;
      HEAP32[(((buf)+(24))>>2)]=1000000;
      HEAP32[(((buf)+(28))>>2)]=42;
      HEAP32[(((buf)+(44))>>2)]=2;  // ST_NOSUID
      HEAP32[(((buf)+(36))>>2)]=255;
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_symlink(target, linkpath) {try {
  
      target = SYSCALLS.getStr(target);
      linkpath = SYSCALLS.getStr(linkpath);
      FS.symlink(target, linkpath);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_symlinkat(target, newdirfd, linkpath) {try {
  
      linkpath = SYSCALLS.calculateAt(newdirfd, linkpath);
      FS.symlink(target, linkpath);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_sync() {
      return 0;
    }

  function ___sys_truncate64(path, zero, low, high) {try {
  
      path = SYSCALLS.getStr(path);
      var length = SYSCALLS.get64(low, high);
      FS.truncate(path, length);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_ugetrlimit(resource, rlim) {try {
  
      HEAP32[((rlim)>>2)]=-1;  // RLIM_INFINITY
      HEAP32[(((rlim)+(4))>>2)]=-1;  // RLIM_INFINITY
      HEAP32[(((rlim)+(8))>>2)]=-1;  // RLIM_INFINITY
      HEAP32[(((rlim)+(12))>>2)]=-1;  // RLIM_INFINITY
      return 0; // just report no limits
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_umask(mask) {try {
  
      var old = SYSCALLS.umask;
      SYSCALLS.umask = mask;
      return old;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_uname(buf) {try {
  
      if (!buf) return -21
      var layout = {"__size__":390,"sysname":0,"nodename":65,"release":130,"version":195,"machine":260,"domainname":325};
      var copyString = function(element, value) {
        var offset = layout[element];
        writeAsciiToMemory(value, buf + offset);
      };
      copyString('sysname', 'Emscripten');
      copyString('nodename', 'emscripten');
      copyString('release', '1.0');
      copyString('version', '#1');
      copyString('machine', 'x86-JS');
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_unlink(path) {try {
  
      path = SYSCALLS.getStr(path);
      FS.unlink(path);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_unlinkat(dirfd, path, flags) {try {
  
      path = SYSCALLS.getStr(path);
      path = SYSCALLS.calculateAt(dirfd, path);
      if (flags === 0) {
        FS.unlink(path);
      } else if (flags === 512) {
        FS.rmdir(path);
      } else {
        abort('Invalid flags passed to unlinkat');
      }
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_utimensat(dirfd, path, times, flags) {try {
  
      path = SYSCALLS.getStr(path);
      assert(flags === 0);
      path = SYSCALLS.calculateAt(dirfd, path);
      var seconds = HEAP32[((times)>>2)];
      var nanoseconds = HEAP32[(((times)+(4))>>2)];
      var atime = (seconds*1000) + (nanoseconds/(1000*1000));
      times += 8;
      seconds = HEAP32[((times)>>2)];
      nanoseconds = HEAP32[(((times)+(4))>>2)];
      var mtime = (seconds*1000) + (nanoseconds/(1000*1000));
      FS.utime(path, atime, mtime);
      return 0;  
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___sys_wait4(pid, wstart, options, rusage) {try {
  
      abort('cannot wait on child processes');
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return -e.errno;
  }
  }

  function ___wait() {}

  
  function _exit(status) {
      // void _exit(int status);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/exit.html
      exit(status);
    }function __exit(a0
  ) {
  return _exit(a0);
  }

  function _abort() {
      abort();
    }


  function _emscripten_get_sbrk_ptr() {
      return 285152;
    }

  function _emscripten_memcpy_big(dest, src, num) {
      HEAPU8.copyWithin(dest, src, src + num);
    }

  
  function _emscripten_get_heap_size() {
      return HEAPU8.length;
    }
  
  function emscripten_realloc_buffer(size) {
      try {
        // round size grow request up to wasm page size (fixed 64KB per spec)
        wasmMemory.grow((size - buffer.byteLength + 65535) >>> 16); // .grow() takes a delta compared to the previous size
        updateGlobalBufferAndViews(wasmMemory.buffer);
        return 1 /*success*/;
      } catch(e) {
        console.error('emscripten_realloc_buffer: Attempted to grow heap from ' + buffer.byteLength  + ' bytes to ' + size + ' bytes, but got error: ' + e);
      }
    }function _emscripten_resize_heap(requestedSize) {
      requestedSize = requestedSize >>> 0;
      var oldSize = _emscripten_get_heap_size();
      // With pthreads, races can happen (another thread might increase the size in between), so return a failure, and let the caller retry.
      assert(requestedSize > oldSize);
  
  
      var PAGE_MULTIPLE = 65536;
  
      // Memory resize rules:
      // 1. When resizing, always produce a resized heap that is at least 16MB (to avoid tiny heap sizes receiving lots of repeated resizes at startup)
      // 2. Always increase heap size to at least the requested size, rounded up to next page multiple.
      // 3a. If MEMORY_GROWTH_LINEAR_STEP == -1, excessively resize the heap geometrically: increase the heap size according to 
      //                                         MEMORY_GROWTH_GEOMETRIC_STEP factor (default +20%),
      //                                         At most overreserve by MEMORY_GROWTH_GEOMETRIC_CAP bytes (default 96MB).
      // 3b. If MEMORY_GROWTH_LINEAR_STEP != -1, excessively resize the heap linearly: increase the heap size by at least MEMORY_GROWTH_LINEAR_STEP bytes.
      // 4. Max size for the heap is capped at 2048MB-PAGE_MULTIPLE, or by MAXIMUM_MEMORY, or by ASAN limit, depending on which is smallest
      // 5. If we were unable to allocate as much memory, it may be due to over-eager decision to excessively reserve due to (3) above.
      //    Hence if an allocation fails, cut down on the amount of excess growth, in an attempt to succeed to perform a smaller allocation.
  
      // A limit was set for how much we can grow. We should not exceed that
      // (the wasm binary specifies it, so if we tried, we'd fail anyhow).
      var maxHeapSize = 2147483648;
      if (requestedSize > maxHeapSize) {
        err('Cannot enlarge memory, asked to go up to ' + requestedSize + ' bytes, but the limit is ' + maxHeapSize + ' bytes!');
        return false;
      }
  
      var minHeapSize = 16777216;
  
      // Loop through potential heap size increases. If we attempt a too eager reservation that fails, cut down on the
      // attempted size and reserve a smaller bump instead. (max 3 times, chosen somewhat arbitrarily)
      for(var cutDown = 1; cutDown <= 4; cutDown *= 2) {
        var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown); // ensure geometric growth
        // but limit overreserving (default to capping at +96MB overgrowth at most)
        overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296 );
  
  
        var newSize = Math.min(maxHeapSize, alignUp(Math.max(minHeapSize, requestedSize, overGrownHeapSize), PAGE_MULTIPLE));
  
        var replacement = emscripten_realloc_buffer(newSize);
        if (replacement) {
  
          return true;
        }
      }
      err('Failed to grow the heap from ' + oldSize + ' bytes to ' + newSize + ' bytes, not enough memory!');
      return false;
    }

  function _emscripten_stack_get_end() {
      // TODO(sbc): rename STACK_MAX -> STACK_END?
      return STACK_MAX;
    }

  
  
  var ENV={};
  
  function __getExecutableName() {
      return thisProgram || './this.program';
    }function getEnvStrings() {
      if (!getEnvStrings.strings) {
        // Default values.
        var env = {
          'USER': 'web_user',
          'LOGNAME': 'web_user',
          'PATH': '/',
          'PWD': '/',
          'HOME': '/home/web_user',
          // Browser language detection #8751
          'LANG': ((typeof navigator === 'object' && navigator.languages && navigator.languages[0]) || 'C').replace('-', '_') + '.UTF-8',
          '_': __getExecutableName()
        };
        // Apply the user-provided values, if any.
        for (var x in ENV) {
          env[x] = ENV[x];
        }
        var strings = [];
        for (var x in env) {
          strings.push(x + '=' + env[x]);
        }
        getEnvStrings.strings = strings;
      }
      return getEnvStrings.strings;
    }function _environ_get(__environ, environ_buf) {
      var bufSize = 0;
      getEnvStrings().forEach(function(string, i) {
        var ptr = environ_buf + bufSize;
        HEAP32[(((__environ)+(i * 4))>>2)]=ptr;
        writeAsciiToMemory(string, ptr);
        bufSize += string.length + 1;
      });
      return 0;
    }

  function _environ_sizes_get(penviron_count, penviron_buf_size) {
      var strings = getEnvStrings();
      HEAP32[((penviron_count)>>2)]=strings.length;
      var bufSize = 0;
      strings.forEach(function(string) {
        bufSize += string.length + 1;
      });
      HEAP32[((penviron_buf_size)>>2)]=bufSize;
      return 0;
    }

  function _fd_close(fd) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      FS.close(stream);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return e.errno;
  }
  }

  function _fd_fdstat_get(fd, pbuf) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      // All character devices are terminals (other things a Linux system would
      // assume is a character device, like the mouse, we have special APIs for).
      var type = stream.tty ? 2 :
                 FS.isDir(stream.mode) ? 3 :
                 FS.isLink(stream.mode) ? 7 :
                 4;
      HEAP8[((pbuf)>>0)]=type;
      // TODO HEAP16[(((pbuf)+(2))>>1)]=?;
      // TODO (tempI64 = [?>>>0,(tempDouble=?,(+(Math_abs(tempDouble))) >= 1.0 ? (tempDouble > 0.0 ? ((Math_min((+(Math_floor((tempDouble)/4294967296.0))), 4294967295.0))|0)>>>0 : (~~((+(Math_ceil((tempDouble - +(((~~(tempDouble)))>>>0))/4294967296.0)))))>>>0) : 0)],HEAP32[(((pbuf)+(8))>>2)]=tempI64[0],HEAP32[(((pbuf)+(12))>>2)]=tempI64[1]);
      // TODO (tempI64 = [?>>>0,(tempDouble=?,(+(Math_abs(tempDouble))) >= 1.0 ? (tempDouble > 0.0 ? ((Math_min((+(Math_floor((tempDouble)/4294967296.0))), 4294967295.0))|0)>>>0 : (~~((+(Math_ceil((tempDouble - +(((~~(tempDouble)))>>>0))/4294967296.0)))))>>>0) : 0)],HEAP32[(((pbuf)+(16))>>2)]=tempI64[0],HEAP32[(((pbuf)+(20))>>2)]=tempI64[1]);
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return e.errno;
  }
  }

  function _fd_read(fd, iov, iovcnt, pnum) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      var num = SYSCALLS.doReadv(stream, iov, iovcnt);
      HEAP32[((pnum)>>2)]=num
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return e.errno;
  }
  }

  function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {try {
  
      
      var stream = SYSCALLS.getStreamFromFD(fd);
      var HIGH_OFFSET = 0x100000000; // 2^32
      // use an unsigned operator on low and shift high by 32-bits
      var offset = offset_high * HIGH_OFFSET + (offset_low >>> 0);
  
      var DOUBLE_LIMIT = 0x20000000000000; // 2^53
      // we also check for equality since DOUBLE_LIMIT + 1 == DOUBLE_LIMIT
      if (offset <= -DOUBLE_LIMIT || offset >= DOUBLE_LIMIT) {
        return -61;
      }
  
      FS.llseek(stream, offset, whence);
      (tempI64 = [stream.position>>>0,(tempDouble=stream.position,(+(Math_abs(tempDouble))) >= 1.0 ? (tempDouble > 0.0 ? ((Math_min((+(Math_floor((tempDouble)/4294967296.0))), 4294967295.0))|0)>>>0 : (~~((+(Math_ceil((tempDouble - +(((~~(tempDouble)))>>>0))/4294967296.0)))))>>>0) : 0)],HEAP32[((newOffset)>>2)]=tempI64[0],HEAP32[(((newOffset)+(4))>>2)]=tempI64[1]);
      if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null; // reset readdir state
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return e.errno;
  }
  }

  function _fd_sync(fd) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      if (stream.stream_ops && stream.stream_ops.fsync) {
        return -stream.stream_ops.fsync(stream);
      }
      return 0; // we can't do anything synchronously; the in-memory FS is already synced to
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return e.errno;
  }
  }

  function _fd_write(fd, iov, iovcnt, pnum) {try {
  
      var stream = SYSCALLS.getStreamFromFD(fd);
      var num = SYSCALLS.doWritev(stream, iov, iovcnt);
      HEAP32[((pnum)>>2)]=num
      return 0;
    } catch (e) {
    if (typeof FS === 'undefined' || !(e instanceof FS.ErrnoError)) abort(e);
    return e.errno;
  }
  }

  function _fork() {
      // pid_t fork(void);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fork.html
      // We don't support multiple processes.
      setErrNo(6);
      return -1;
    }

  function _getnameinfo(sa, salen, node, nodelen, serv, servlen, flags) {
      var info = __read_sockaddr(sa, salen);
      if (info.errno) {
        return -6;
      }
      var port = info.port;
      var addr = info.addr;
  
      var overflowed = false;
  
      if (node && nodelen) {
        var lookup;
        if ((flags & 1) || !(lookup = DNS.lookup_addr(addr))) {
          if (flags & 8) {
            return -2;
          }
        } else {
          addr = lookup;
        }
        var numBytesWrittenExclNull = stringToUTF8(addr, node, nodelen);
  
        if (numBytesWrittenExclNull+1 >= nodelen) {
          overflowed = true;
        }
      }
  
      if (serv && servlen) {
        port = '' + port;
        var numBytesWrittenExclNull = stringToUTF8(port, serv, servlen);
  
        if (numBytesWrittenExclNull+1 >= servlen) {
          overflowed = true;
        }
      }
  
      if (overflowed) {
        // Note: even when we overflow, getnameinfo() is specced to write out the truncated results.
        return -12;
      }
  
      return 0;
    }

  
  var ___tm_timezone=(stringToUTF8("GMT", 285216, 4), 285216);function _gmtime_r(time, tmPtr) {
      var date = new Date(HEAP32[((time)>>2)]*1000);
      HEAP32[((tmPtr)>>2)]=date.getUTCSeconds();
      HEAP32[(((tmPtr)+(4))>>2)]=date.getUTCMinutes();
      HEAP32[(((tmPtr)+(8))>>2)]=date.getUTCHours();
      HEAP32[(((tmPtr)+(12))>>2)]=date.getUTCDate();
      HEAP32[(((tmPtr)+(16))>>2)]=date.getUTCMonth();
      HEAP32[(((tmPtr)+(20))>>2)]=date.getUTCFullYear()-1900;
      HEAP32[(((tmPtr)+(24))>>2)]=date.getUTCDay();
      HEAP32[(((tmPtr)+(36))>>2)]=0;
      HEAP32[(((tmPtr)+(32))>>2)]=0;
      var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
      var yday = ((date.getTime() - start) / (1000 * 60 * 60 * 24))|0;
      HEAP32[(((tmPtr)+(28))>>2)]=yday;
      HEAP32[(((tmPtr)+(40))>>2)]=___tm_timezone;
  
      return tmPtr;
    }

  function _inet_addr(ptr) {
      var addr = __inet_pton4_raw(UTF8ToString(ptr));
      if (addr === null) {
        return -1;
      }
      return addr;
    }

  
  function _usleep(useconds) {
      // int usleep(useconds_t useconds);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/usleep.html
      // We're single-threaded, so use a busy loop. Super-ugly.
      var start = _emscripten_get_now();
      while (_emscripten_get_now() - start < useconds / 1000) {
        // Do nothing.
      }
    }function _nanosleep(rqtp, rmtp) {
      // int nanosleep(const struct timespec  *rqtp, struct timespec *rmtp);
      if (rqtp === 0) {
        setErrNo(28);
        return -1;
      }
      var seconds = HEAP32[((rqtp)>>2)];
      var nanoseconds = HEAP32[(((rqtp)+(4))>>2)];
      if (nanoseconds < 0 || nanoseconds > 999999999 || seconds < 0) {
        setErrNo(28);
        return -1;
      }
      if (rmtp !== 0) {
        HEAP32[((rmtp)>>2)]=0;
        HEAP32[(((rmtp)+(4))>>2)]=0;
      }
      return _usleep((seconds * 1e6) + (nanoseconds / 1000));
    }

  
  function _fpathconf(fildes, name) {
      // long fpathconf(int fildes, int name);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/encrypt.html
      // NOTE: The first parameter is ignored, so pathconf == fpathconf.
      // The constants here aren't real values. Just mimicking glibc.
      switch (name) {
        case 0:
          return 32000;
        case 1:
        case 2:
        case 3:
          return 255;
        case 4:
        case 5:
        case 16:
        case 17:
        case 18:
          return 4096;
        case 6:
        case 7:
        case 20:
          return 1;
        case 8:
          return 0;
        case 9:
        case 10:
        case 11:
        case 12:
        case 14:
        case 15:
        case 19:
          return -1;
        case 13:
          return 64;
      }
      setErrNo(28);
      return -1;
    }function _pathconf(a0,a1
  ) {
  return _fpathconf(a0,a1);
  }

  function _pthread_cleanup_pop() {
      assert(_pthread_cleanup_push.level == __ATEXIT__.length, 'cannot pop if something else added meanwhile!');
      __ATEXIT__.pop();
      _pthread_cleanup_push.level = __ATEXIT__.length;
    }

  function _pthread_cleanup_push(routine, arg) {
      __ATEXIT__.push(function() { dynCall_vi(routine, arg) })
      _pthread_cleanup_push.level = __ATEXIT__.length;
    }

  function _pthread_detach() {}

  function _pthread_join() {}

  function _pthread_mutexattr_destroy() {}

  function _pthread_mutexattr_init() {}

  function _pthread_mutexattr_settype() {}

  function _pthread_setcancelstate() { return 0; }

  function _pthread_sigmask(how, set, oldset) {
      err('pthread_sigmask() is not supported: this is a no-op.');
      return 0;
    }

  
  function _round(d) {
      d = +d;
      return d >= +0 ? +Math_floor(d + +0.5) : +Math_ceil(d - +0.5);
    }

  function _roundf(d) {
      d = +d;
      return d >= +0 ? +Math_floor(d + +0.5) : +Math_ceil(d - +0.5);
    }

  function _setTempRet0($i) {
      setTempRet0(($i) | 0);
    }

  function _setitimer() {
      throw 'setitimer() is not implemented yet';
    }

  function _sigfillset(set) {
      HEAP32[((set)>>2)]=-1>>>0;
      return 0;
    }

  
  function __isLeapYear(year) {
        return year%4 === 0 && (year%100 !== 0 || year%400 === 0);
    }
  
  function __arraySum(array, index) {
      var sum = 0;
      for (var i = 0; i <= index; sum += array[i++]) {
        // no-op
      }
      return sum;
    }
  
  
  var __MONTH_DAYS_LEAP=[31,29,31,30,31,30,31,31,30,31,30,31];
  
  var __MONTH_DAYS_REGULAR=[31,28,31,30,31,30,31,31,30,31,30,31];function __addDays(date, days) {
      var newDate = new Date(date.getTime());
      while(days > 0) {
        var leap = __isLeapYear(newDate.getFullYear());
        var currentMonth = newDate.getMonth();
        var daysInCurrentMonth = (leap ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[currentMonth];
  
        if (days > daysInCurrentMonth-newDate.getDate()) {
          // we spill over to next month
          days -= (daysInCurrentMonth-newDate.getDate()+1);
          newDate.setDate(1);
          if (currentMonth < 11) {
            newDate.setMonth(currentMonth+1)
          } else {
            newDate.setMonth(0);
            newDate.setFullYear(newDate.getFullYear()+1);
          }
        } else {
          // we stay in current month
          newDate.setDate(newDate.getDate()+days);
          return newDate;
        }
      }
  
      return newDate;
    }function _strftime(s, maxsize, format, tm) {
      // size_t strftime(char *restrict s, size_t maxsize, const char *restrict format, const struct tm *restrict timeptr);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/strftime.html
  
      var tm_zone = HEAP32[(((tm)+(40))>>2)];
  
      var date = {
        tm_sec: HEAP32[((tm)>>2)],
        tm_min: HEAP32[(((tm)+(4))>>2)],
        tm_hour: HEAP32[(((tm)+(8))>>2)],
        tm_mday: HEAP32[(((tm)+(12))>>2)],
        tm_mon: HEAP32[(((tm)+(16))>>2)],
        tm_year: HEAP32[(((tm)+(20))>>2)],
        tm_wday: HEAP32[(((tm)+(24))>>2)],
        tm_yday: HEAP32[(((tm)+(28))>>2)],
        tm_isdst: HEAP32[(((tm)+(32))>>2)],
        tm_gmtoff: HEAP32[(((tm)+(36))>>2)],
        tm_zone: tm_zone ? UTF8ToString(tm_zone) : ''
      };
  
      var pattern = UTF8ToString(format);
  
      // expand format
      var EXPANSION_RULES_1 = {
        '%c': '%a %b %d %H:%M:%S %Y',     // Replaced by the locale's appropriate date and time representation - e.g., Mon Aug  3 14:02:01 2013
        '%D': '%m/%d/%y',                 // Equivalent to %m / %d / %y
        '%F': '%Y-%m-%d',                 // Equivalent to %Y - %m - %d
        '%h': '%b',                       // Equivalent to %b
        '%r': '%I:%M:%S %p',              // Replaced by the time in a.m. and p.m. notation
        '%R': '%H:%M',                    // Replaced by the time in 24-hour notation
        '%T': '%H:%M:%S',                 // Replaced by the time
        '%x': '%m/%d/%y',                 // Replaced by the locale's appropriate date representation
        '%X': '%H:%M:%S',                 // Replaced by the locale's appropriate time representation
        // Modified Conversion Specifiers
        '%Ec': '%c',                      // Replaced by the locale's alternative appropriate date and time representation.
        '%EC': '%C',                      // Replaced by the name of the base year (period) in the locale's alternative representation.
        '%Ex': '%m/%d/%y',                // Replaced by the locale's alternative date representation.
        '%EX': '%H:%M:%S',                // Replaced by the locale's alternative time representation.
        '%Ey': '%y',                      // Replaced by the offset from %EC (year only) in the locale's alternative representation.
        '%EY': '%Y',                      // Replaced by the full alternative year representation.
        '%Od': '%d',                      // Replaced by the day of the month, using the locale's alternative numeric symbols, filled as needed with leading zeros if there is any alternative symbol for zero; otherwise, with leading <space> characters.
        '%Oe': '%e',                      // Replaced by the day of the month, using the locale's alternative numeric symbols, filled as needed with leading <space> characters.
        '%OH': '%H',                      // Replaced by the hour (24-hour clock) using the locale's alternative numeric symbols.
        '%OI': '%I',                      // Replaced by the hour (12-hour clock) using the locale's alternative numeric symbols.
        '%Om': '%m',                      // Replaced by the month using the locale's alternative numeric symbols.
        '%OM': '%M',                      // Replaced by the minutes using the locale's alternative numeric symbols.
        '%OS': '%S',                      // Replaced by the seconds using the locale's alternative numeric symbols.
        '%Ou': '%u',                      // Replaced by the weekday as a number in the locale's alternative representation (Monday=1).
        '%OU': '%U',                      // Replaced by the week number of the year (Sunday as the first day of the week, rules corresponding to %U ) using the locale's alternative numeric symbols.
        '%OV': '%V',                      // Replaced by the week number of the year (Monday as the first day of the week, rules corresponding to %V ) using the locale's alternative numeric symbols.
        '%Ow': '%w',                      // Replaced by the number of the weekday (Sunday=0) using the locale's alternative numeric symbols.
        '%OW': '%W',                      // Replaced by the week number of the year (Monday as the first day of the week) using the locale's alternative numeric symbols.
        '%Oy': '%y',                      // Replaced by the year (offset from %C ) using the locale's alternative numeric symbols.
      };
      for (var rule in EXPANSION_RULES_1) {
        pattern = pattern.replace(new RegExp(rule, 'g'), EXPANSION_RULES_1[rule]);
      }
  
      var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  
      function leadingSomething(value, digits, character) {
        var str = typeof value === 'number' ? value.toString() : (value || '');
        while (str.length < digits) {
          str = character[0]+str;
        }
        return str;
      }
  
      function leadingNulls(value, digits) {
        return leadingSomething(value, digits, '0');
      }
  
      function compareByDay(date1, date2) {
        function sgn(value) {
          return value < 0 ? -1 : (value > 0 ? 1 : 0);
        }
  
        var compare;
        if ((compare = sgn(date1.getFullYear()-date2.getFullYear())) === 0) {
          if ((compare = sgn(date1.getMonth()-date2.getMonth())) === 0) {
            compare = sgn(date1.getDate()-date2.getDate());
          }
        }
        return compare;
      }
  
      function getFirstWeekStartDate(janFourth) {
          switch (janFourth.getDay()) {
            case 0: // Sunday
              return new Date(janFourth.getFullYear()-1, 11, 29);
            case 1: // Monday
              return janFourth;
            case 2: // Tuesday
              return new Date(janFourth.getFullYear(), 0, 3);
            case 3: // Wednesday
              return new Date(janFourth.getFullYear(), 0, 2);
            case 4: // Thursday
              return new Date(janFourth.getFullYear(), 0, 1);
            case 5: // Friday
              return new Date(janFourth.getFullYear()-1, 11, 31);
            case 6: // Saturday
              return new Date(janFourth.getFullYear()-1, 11, 30);
          }
      }
  
      function getWeekBasedYear(date) {
          var thisDate = __addDays(new Date(date.tm_year+1900, 0, 1), date.tm_yday);
  
          var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
          var janFourthNextYear = new Date(thisDate.getFullYear()+1, 0, 4);
  
          var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
          var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
  
          if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
            // this date is after the start of the first week of this year
            if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {
              return thisDate.getFullYear()+1;
            } else {
              return thisDate.getFullYear();
            }
          } else {
            return thisDate.getFullYear()-1;
          }
      }
  
      var EXPANSION_RULES_2 = {
        '%a': function(date) {
          return WEEKDAYS[date.tm_wday].substring(0,3);
        },
        '%A': function(date) {
          return WEEKDAYS[date.tm_wday];
        },
        '%b': function(date) {
          return MONTHS[date.tm_mon].substring(0,3);
        },
        '%B': function(date) {
          return MONTHS[date.tm_mon];
        },
        '%C': function(date) {
          var year = date.tm_year+1900;
          return leadingNulls((year/100)|0,2);
        },
        '%d': function(date) {
          return leadingNulls(date.tm_mday, 2);
        },
        '%e': function(date) {
          return leadingSomething(date.tm_mday, 2, ' ');
        },
        '%g': function(date) {
          // %g, %G, and %V give values according to the ISO 8601:2000 standard week-based year.
          // In this system, weeks begin on a Monday and week 1 of the year is the week that includes
          // January 4th, which is also the week that includes the first Thursday of the year, and
          // is also the first week that contains at least four days in the year.
          // If the first Monday of January is the 2nd, 3rd, or 4th, the preceding days are part of
          // the last week of the preceding year; thus, for Saturday 2nd January 1999,
          // %G is replaced by 1998 and %V is replaced by 53. If December 29th, 30th,
          // or 31st is a Monday, it and any following days are part of week 1 of the following year.
          // Thus, for Tuesday 30th December 1997, %G is replaced by 1998 and %V is replaced by 01.
  
          return getWeekBasedYear(date).toString().substring(2);
        },
        '%G': function(date) {
          return getWeekBasedYear(date);
        },
        '%H': function(date) {
          return leadingNulls(date.tm_hour, 2);
        },
        '%I': function(date) {
          var twelveHour = date.tm_hour;
          if (twelveHour == 0) twelveHour = 12;
          else if (twelveHour > 12) twelveHour -= 12;
          return leadingNulls(twelveHour, 2);
        },
        '%j': function(date) {
          // Day of the year (001-366)
          return leadingNulls(date.tm_mday+__arraySum(__isLeapYear(date.tm_year+1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, date.tm_mon-1), 3);
        },
        '%m': function(date) {
          return leadingNulls(date.tm_mon+1, 2);
        },
        '%M': function(date) {
          return leadingNulls(date.tm_min, 2);
        },
        '%n': function() {
          return '\n';
        },
        '%p': function(date) {
          if (date.tm_hour >= 0 && date.tm_hour < 12) {
            return 'AM';
          } else {
            return 'PM';
          }
        },
        '%S': function(date) {
          return leadingNulls(date.tm_sec, 2);
        },
        '%t': function() {
          return '\t';
        },
        '%u': function(date) {
          return date.tm_wday || 7;
        },
        '%U': function(date) {
          // Replaced by the week number of the year as a decimal number [00,53].
          // The first Sunday of January is the first day of week 1;
          // days in the new year before this are in week 0. [ tm_year, tm_wday, tm_yday]
          var janFirst = new Date(date.tm_year+1900, 0, 1);
          var firstSunday = janFirst.getDay() === 0 ? janFirst : __addDays(janFirst, 7-janFirst.getDay());
          var endDate = new Date(date.tm_year+1900, date.tm_mon, date.tm_mday);
  
          // is target date after the first Sunday?
          if (compareByDay(firstSunday, endDate) < 0) {
            // calculate difference in days between first Sunday and endDate
            var februaryFirstUntilEndMonth = __arraySum(__isLeapYear(endDate.getFullYear()) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, endDate.getMonth()-1)-31;
            var firstSundayUntilEndJanuary = 31-firstSunday.getDate();
            var days = firstSundayUntilEndJanuary+februaryFirstUntilEndMonth+endDate.getDate();
            return leadingNulls(Math.ceil(days/7), 2);
          }
  
          return compareByDay(firstSunday, janFirst) === 0 ? '01': '00';
        },
        '%V': function(date) {
          // Replaced by the week number of the year (Monday as the first day of the week)
          // as a decimal number [01,53]. If the week containing 1 January has four
          // or more days in the new year, then it is considered week 1.
          // Otherwise, it is the last week of the previous year, and the next week is week 1.
          // Both January 4th and the first Thursday of January are always in week 1. [ tm_year, tm_wday, tm_yday]
          var janFourthThisYear = new Date(date.tm_year+1900, 0, 4);
          var janFourthNextYear = new Date(date.tm_year+1901, 0, 4);
  
          var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
          var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
  
          var endDate = __addDays(new Date(date.tm_year+1900, 0, 1), date.tm_yday);
  
          if (compareByDay(endDate, firstWeekStartThisYear) < 0) {
            // if given date is before this years first week, then it belongs to the 53rd week of last year
            return '53';
          }
  
          if (compareByDay(firstWeekStartNextYear, endDate) <= 0) {
            // if given date is after next years first week, then it belongs to the 01th week of next year
            return '01';
          }
  
          // given date is in between CW 01..53 of this calendar year
          var daysDifference;
          if (firstWeekStartThisYear.getFullYear() < date.tm_year+1900) {
            // first CW of this year starts last year
            daysDifference = date.tm_yday+32-firstWeekStartThisYear.getDate()
          } else {
            // first CW of this year starts this year
            daysDifference = date.tm_yday+1-firstWeekStartThisYear.getDate();
          }
          return leadingNulls(Math.ceil(daysDifference/7), 2);
        },
        '%w': function(date) {
          return date.tm_wday;
        },
        '%W': function(date) {
          // Replaced by the week number of the year as a decimal number [00,53].
          // The first Monday of January is the first day of week 1;
          // days in the new year before this are in week 0. [ tm_year, tm_wday, tm_yday]
          var janFirst = new Date(date.tm_year, 0, 1);
          var firstMonday = janFirst.getDay() === 1 ? janFirst : __addDays(janFirst, janFirst.getDay() === 0 ? 1 : 7-janFirst.getDay()+1);
          var endDate = new Date(date.tm_year+1900, date.tm_mon, date.tm_mday);
  
          // is target date after the first Monday?
          if (compareByDay(firstMonday, endDate) < 0) {
            var februaryFirstUntilEndMonth = __arraySum(__isLeapYear(endDate.getFullYear()) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, endDate.getMonth()-1)-31;
            var firstMondayUntilEndJanuary = 31-firstMonday.getDate();
            var days = firstMondayUntilEndJanuary+februaryFirstUntilEndMonth+endDate.getDate();
            return leadingNulls(Math.ceil(days/7), 2);
          }
          return compareByDay(firstMonday, janFirst) === 0 ? '01': '00';
        },
        '%y': function(date) {
          // Replaced by the last two digits of the year as a decimal number [00,99]. [ tm_year]
          return (date.tm_year+1900).toString().substring(2);
        },
        '%Y': function(date) {
          // Replaced by the year as a decimal number (for example, 1997). [ tm_year]
          return date.tm_year+1900;
        },
        '%z': function(date) {
          // Replaced by the offset from UTC in the ISO 8601:2000 standard format ( +hhmm or -hhmm ).
          // For example, "-0430" means 4 hours 30 minutes behind UTC (west of Greenwich).
          var off = date.tm_gmtoff;
          var ahead = off >= 0;
          off = Math.abs(off) / 60;
          // convert from minutes into hhmm format (which means 60 minutes = 100 units)
          off = (off / 60)*100 + (off % 60);
          return (ahead ? '+' : '-') + String("0000" + off).slice(-4);
        },
        '%Z': function(date) {
          return date.tm_zone;
        },
        '%%': function() {
          return '%';
        }
      };
      for (var rule in EXPANSION_RULES_2) {
        if (pattern.indexOf(rule) >= 0) {
          pattern = pattern.replace(new RegExp(rule, 'g'), EXPANSION_RULES_2[rule](date));
        }
      }
  
      var bytes = intArrayFromString(pattern, false);
      if (bytes.length > maxsize) {
        return 0;
      }
  
      writeArrayToMemory(bytes, s);
      return bytes.length-1;
    }

  function _strftime_l(s, maxsize, format, tm) {
      return _strftime(s, maxsize, format, tm); // no locale support yet
    }

  function _sysconf(name) {
      // long sysconf(int name);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/sysconf.html
      switch(name) {
        case 30: return 16384;
        case 85:
          var maxHeapSize = 2147483648;
          return maxHeapSize / 16384;
        case 132:
        case 133:
        case 12:
        case 137:
        case 138:
        case 15:
        case 235:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 149:
        case 13:
        case 10:
        case 236:
        case 153:
        case 9:
        case 21:
        case 22:
        case 159:
        case 154:
        case 14:
        case 77:
        case 78:
        case 139:
        case 80:
        case 81:
        case 82:
        case 68:
        case 67:
        case 164:
        case 11:
        case 29:
        case 47:
        case 48:
        case 95:
        case 52:
        case 51:
        case 46:
        case 79:
          return 200809;
        case 27:
        case 246:
        case 127:
        case 128:
        case 23:
        case 24:
        case 160:
        case 161:
        case 181:
        case 182:
        case 242:
        case 183:
        case 184:
        case 243:
        case 244:
        case 245:
        case 165:
        case 178:
        case 179:
        case 49:
        case 50:
        case 168:
        case 169:
        case 175:
        case 170:
        case 171:
        case 172:
        case 97:
        case 76:
        case 32:
        case 173:
        case 35:
          return -1;
        case 176:
        case 177:
        case 7:
        case 155:
        case 8:
        case 157:
        case 125:
        case 126:
        case 92:
        case 93:
        case 129:
        case 130:
        case 131:
        case 94:
        case 91:
          return 1;
        case 74:
        case 60:
        case 69:
        case 70:
        case 4:
          return 1024;
        case 31:
        case 42:
        case 72:
          return 32;
        case 87:
        case 26:
        case 33:
          return 2147483647;
        case 34:
        case 1:
          return 47839;
        case 38:
        case 36:
          return 99;
        case 43:
        case 37:
          return 2048;
        case 0: return 2097152;
        case 3: return 65536;
        case 28: return 32768;
        case 44: return 32767;
        case 75: return 16384;
        case 39: return 1000;
        case 89: return 700;
        case 71: return 256;
        case 40: return 255;
        case 2: return 100;
        case 180: return 64;
        case 25: return 20;
        case 5: return 16;
        case 6: return 6;
        case 73: return 4;
        case 84: {
          if (typeof navigator === 'object') return navigator['hardwareConcurrency'] || 1;
          return 1;
        }
      }
      setErrNo(28);
      return -1;
    }

  function _time(ptr) {
      var ret = (Date.now()/1000)|0;
      if (ptr) {
        HEAP32[((ptr)>>2)]=ret;
      }
      return ret;
    }

  
  function _wait(stat_loc) {
      // pid_t wait(int *stat_loc);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/wait.html
      // Makes no sense in a single-process environment.
      setErrNo(12);
      return -1;
    }function _waitpid(a0
  ) {
  return _wait(a0);
  }
var FSNode = /** @constructor */ function(parent, name, mode, rdev) {
    if (!parent) {
      parent = this;  // root node sets parent to itself
    }
    this.parent = parent;
    this.mount = parent.mount;
    this.mounted = null;
    this.id = FS.nextInode++;
    this.name = name;
    this.mode = mode;
    this.node_ops = {};
    this.stream_ops = {};
    this.rdev = rdev;
  };
  var readMode = 292/*292*/ | 73/*73*/;
  var writeMode = 146/*146*/;
  Object.defineProperties(FSNode.prototype, {
   read: {
    get: /** @this{FSNode} */function() {
     return (this.mode & readMode) === readMode;
    },
    set: /** @this{FSNode} */function(val) {
     val ? this.mode |= readMode : this.mode &= ~readMode;
    }
   },
   write: {
    get: /** @this{FSNode} */function() {
     return (this.mode & writeMode) === writeMode;
    },
    set: /** @this{FSNode} */function(val) {
     val ? this.mode |= writeMode : this.mode &= ~writeMode;
    }
   },
   isFolder: {
    get: /** @this{FSNode} */function() {
     return FS.isDir(this.mode);
    }
   },
   isDevice: {
    get: /** @this{FSNode} */function() {
     return FS.isChrdev(this.mode);
    }
   }
  });
  FS.FSNode = FSNode;
  FS.staticInit();;
var ASSERTIONS = true;



/** @type {function(string, boolean=, number=)} */
function intArrayFromString(stringy, dontAddNull, length) {
  var len = length > 0 ? length : lengthBytesUTF8(stringy)+1;
  var u8array = new Array(len);
  var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
  if (dontAddNull) u8array.length = numBytesWritten;
  return u8array;
}

function intArrayToString(array) {
  var ret = [];
  for (var i = 0; i < array.length; i++) {
    var chr = array[i];
    if (chr > 0xFF) {
      if (ASSERTIONS) {
        assert(false, 'Character code ' + chr + ' (' + String.fromCharCode(chr) + ')  at offset ' + i + ' not in 0x00-0xFF.');
      }
      chr &= 0xFF;
    }
    ret.push(String.fromCharCode(chr));
  }
  return ret.join('');
}


// ASM_LIBRARY EXTERN PRIMITIVES: Math_floor,Math_ceil

var asmGlobalArg = {};
var asmLibraryArg = { "__assert_fail": ___assert_fail, "__clock_gettime": ___clock_gettime, "__cxa_atexit": ___cxa_atexit, "__handle_stack_overflow": ___handle_stack_overflow, "__map_file": ___map_file, "__sys__newselect": ___sys__newselect, "__sys_access": ___sys_access, "__sys_acct": ___sys_acct, "__sys_chdir": ___sys_chdir, "__sys_chmod": ___sys_chmod, "__sys_chown32": ___sys_chown32, "__sys_dup": ___sys_dup, "__sys_dup2": ___sys_dup2, "__sys_dup3": ___sys_dup3, "__sys_fadvise64_64": ___sys_fadvise64_64, "__sys_fallocate": ___sys_fallocate, "__sys_fchdir": ___sys_fchdir, "__sys_fchmod": ___sys_fchmod, "__sys_fchmodat": ___sys_fchmodat, "__sys_fchown32": ___sys_fchown32, "__sys_fchownat": ___sys_fchownat, "__sys_fcntl64": ___sys_fcntl64, "__sys_fdatasync": ___sys_fdatasync, "__sys_fstat64": ___sys_fstat64, "__sys_fstatat64": ___sys_fstatat64, "__sys_fstatfs64": ___sys_fstatfs64, "__sys_ftruncate64": ___sys_ftruncate64, "__sys_getcwd": ___sys_getcwd, "__sys_getdents64": ___sys_getdents64, "__sys_getegid32": ___sys_getegid32, "__sys_geteuid32": ___sys_geteuid32, "__sys_getgid32": ___sys_getgid32, "__sys_getgroups32": ___sys_getgroups32, "__sys_getpgid": ___sys_getpgid, "__sys_getpid": ___sys_getpid, "__sys_getppid": ___sys_getppid, "__sys_getpriority": ___sys_getpriority, "__sys_getresgid32": ___sys_getresgid32, "__sys_getresuid32": ___sys_getresuid32, "__sys_getrusage": ___sys_getrusage, "__sys_getsid": ___sys_getsid, "__sys_getuid32": ___sys_getuid32, "__sys_ioctl": ___sys_ioctl, "__sys_lchown32": ___sys_lchown32, "__sys_link": ___sys_link, "__sys_linkat": ___sys_linkat, "__sys_lstat64": ___sys_lstat64, "__sys_madvise1": ___sys_madvise1, "__sys_mincore": ___sys_mincore, "__sys_mkdir": ___sys_mkdir, "__sys_mkdirat": ___sys_mkdirat, "__sys_mknod": ___sys_mknod, "__sys_mknodat": ___sys_mknodat, "__sys_mlock": ___sys_mlock, "__sys_mlockall": ___sys_mlockall, "__sys_mmap2": ___sys_mmap2, "__sys_mprotect": ___sys_mprotect, "__sys_mremap": ___sys_mremap, "__sys_msync": ___sys_msync, "__sys_munlock": ___sys_munlock, "__sys_munlockall": ___sys_munlockall, "__sys_munmap": ___sys_munmap, "__sys_nice": ___sys_nice, "__sys_open": ___sys_open, "__sys_openat": ___sys_openat, "__sys_pause": ___sys_pause, "__sys_pipe": ___sys_pipe, "__sys_pipe2": ___sys_pipe2, "__sys_poll": ___sys_poll, "__sys_pread64": ___sys_pread64, "__sys_preadv": ___sys_preadv, "__sys_prlimit64": ___sys_prlimit64, "__sys_pselect6": ___sys_pselect6, "__sys_pwrite64": ___sys_pwrite64, "__sys_pwritev": ___sys_pwritev, "__sys_read": ___sys_read, "__sys_readlink": ___sys_readlink, "__sys_readlinkat": ___sys_readlinkat, "__sys_recvmmsg": ___sys_recvmmsg, "__sys_rename": ___sys_rename, "__sys_renameat": ___sys_renameat, "__sys_rmdir": ___sys_rmdir, "__sys_sendmmsg": ___sys_sendmmsg, "__sys_setdomainname": ___sys_setdomainname, "__sys_setpgid": ___sys_setpgid, "__sys_setpriority": ___sys_setpriority, "__sys_setrlimit": ___sys_setrlimit, "__sys_setsid": ___sys_setsid, "__sys_socketcall": ___sys_socketcall, "__sys_stat64": ___sys_stat64, "__sys_statfs64": ___sys_statfs64, "__sys_symlink": ___sys_symlink, "__sys_symlinkat": ___sys_symlinkat, "__sys_sync": ___sys_sync, "__sys_truncate64": ___sys_truncate64, "__sys_ugetrlimit": ___sys_ugetrlimit, "__sys_umask": ___sys_umask, "__sys_uname": ___sys_uname, "__sys_unlink": ___sys_unlink, "__sys_unlinkat": ___sys_unlinkat, "__sys_utimensat": ___sys_utimensat, "__sys_wait4": ___sys_wait4, "__wait": ___wait, "_exit": __exit, "abort": _abort, "clock_gettime": _clock_gettime, "emscripten_get_sbrk_ptr": _emscripten_get_sbrk_ptr, "emscripten_memcpy_big": _emscripten_memcpy_big, "emscripten_resize_heap": _emscripten_resize_heap, "emscripten_stack_get_end": _emscripten_stack_get_end, "environ_get": _environ_get, "environ_sizes_get": _environ_sizes_get, "fd_close": _fd_close, "fd_fdstat_get": _fd_fdstat_get, "fd_read": _fd_read, "fd_seek": _fd_seek, "fd_sync": _fd_sync, "fd_write": _fd_write, "fork": _fork, "getTempRet0": getTempRet0, "getnameinfo": _getnameinfo, "gmtime_r": _gmtime_r, "inet_addr": _inet_addr, "memory": wasmMemory, "nanosleep": _nanosleep, "pathconf": _pathconf, "pthread_cleanup_pop": _pthread_cleanup_pop, "pthread_cleanup_push": _pthread_cleanup_push, "pthread_detach": _pthread_detach, "pthread_join": _pthread_join, "pthread_mutexattr_destroy": _pthread_mutexattr_destroy, "pthread_mutexattr_init": _pthread_mutexattr_init, "pthread_mutexattr_settype": _pthread_mutexattr_settype, "pthread_setcancelstate": _pthread_setcancelstate, "pthread_sigmask": _pthread_sigmask, "round": _round, "roundf": _roundf, "setTempRet0": setTempRet0, "setitimer": _setitimer, "sigfillset": _sigfillset, "strftime": _strftime, "strftime_l": _strftime_l, "sysconf": _sysconf, "table": wasmTable, "time": _time, "waitpid": _waitpid };
var asm = createWasm();
/** @type {function(...*):?} */
var ___wasm_call_ctors = Module["___wasm_call_ctors"] = createExportWrapper("__wasm_call_ctors");

/** @type {function(...*):?} */
var _bs_alloc = Module["_bs_alloc"] = createExportWrapper("bs_alloc");

/** @type {function(...*):?} */
var _calloc = Module["_calloc"] = createExportWrapper("calloc");

/** @type {function(...*):?} */
var _bs_append_frame = Module["_bs_append_frame"] = createExportWrapper("bs_append_frame");

/** @type {function(...*):?} */
var _memcpy = Module["_memcpy"] = createExportWrapper("memcpy");

/** @type {function(...*):?} */
var _bs_copy_frame = Module["_bs_copy_frame"] = createExportWrapper("bs_copy_frame");

/** @type {function(...*):?} */
var _WebPGuessImageType = Module["_WebPGuessImageType"] = createExportWrapper("WebPGuessImageType");

/** @type {function(...*):?} */
var _WebPGetImageReader = Module["_WebPGetImageReader"] = createExportWrapper("WebPGetImageReader");

/** @type {function(...*):?} */
var _WebPGuessImageReader = Module["_WebPGuessImageReader"] = createExportWrapper("WebPGuessImageReader");

/** @type {function(...*):?} */
var _ReadPNG = Module["_ReadPNG"] = createExportWrapper("ReadPNG");

/** @type {function(...*):?} */
var _ReadJPEG = Module["_ReadJPEG"] = createExportWrapper("ReadJPEG");

/** @type {function(...*):?} */
var _ReadTIFF = Module["_ReadTIFF"] = createExportWrapper("ReadTIFF");

/** @type {function(...*):?} */
var _ReadWebP = Module["_ReadWebP"] = createExportWrapper("ReadWebP");

/** @type {function(...*):?} */
var _ReadPNM = Module["_ReadPNM"] = createExportWrapper("ReadPNM");

/** @type {function(...*):?} */
var _WebPWritePNG = Module["_WebPWritePNG"] = createExportWrapper("WebPWritePNG");

/** @type {function(...*):?} */
var _fwrite = Module["_fwrite"] = createExportWrapper("fwrite");

/** @type {function(...*):?} */
var _WebPWritePPM = Module["_WebPWritePPM"] = createExportWrapper("WebPWritePPM");

/** @type {function(...*):?} */
var _fiprintf = Module["_fiprintf"] = createExportWrapper("fiprintf");

/** @type {function(...*):?} */
var _WebPWritePAM = Module["_WebPWritePAM"] = createExportWrapper("WebPWritePAM");

/** @type {function(...*):?} */
var _WebPWrite16bAsPGM = Module["_WebPWrite16bAsPGM"] = createExportWrapper("WebPWrite16bAsPGM");

/** @type {function(...*):?} */
var _WebPWriteBMP = Module["_WebPWriteBMP"] = createExportWrapper("WebPWriteBMP");

/** @type {function(...*):?} */
var _WebPWriteTIFF = Module["_WebPWriteTIFF"] = createExportWrapper("WebPWriteTIFF");

/** @type {function(...*):?} */
var _WebPWriteAlphaPlane = Module["_WebPWriteAlphaPlane"] = createExportWrapper("WebPWriteAlphaPlane");

/** @type {function(...*):?} */
var _WebPWritePGM = Module["_WebPWritePGM"] = createExportWrapper("WebPWritePGM");

/** @type {function(...*):?} */
var _fputc = Module["_fputc"] = createExportWrapper("fputc");

/** @type {function(...*):?} */
var _WebPWriteYUV = Module["_WebPWriteYUV"] = createExportWrapper("WebPWriteYUV");

/** @type {function(...*):?} */
var _WebPSaveImage = Module["_WebPSaveImage"] = createExportWrapper("WebPSaveImage");

/** @type {function(...*):?} */
var _strcmp = Module["_strcmp"] = createExportWrapper("strcmp");

/** @type {function(...*):?} */
var _ImgIoUtilSetBinaryMode = Module["_ImgIoUtilSetBinaryMode"] = createExportWrapper("ImgIoUtilSetBinaryMode");

/** @type {function(...*):?} */
var _fopen = Module["_fopen"] = createExportWrapper("fopen");

/** @type {function(...*):?} */
var _fclose = Module["_fclose"] = createExportWrapper("fclose");

/** @type {function(...*):?} */
var _ImgIoUtilReadFromStdin = Module["_ImgIoUtilReadFromStdin"] = createExportWrapper("ImgIoUtilReadFromStdin");

/** @type {function(...*):?} */
var _feof = Module["_feof"] = createExportWrapper("feof");

/** @type {function(...*):?} */
var _realloc = Module["_realloc"] = createExportWrapper("realloc");

/** @type {function(...*):?} */
var _fread = Module["_fread"] = createExportWrapper("fread");

/** @type {function(...*):?} */
var _ferror = Module["_ferror"] = createExportWrapper("ferror");

/** @type {function(...*):?} */
var _free = Module["_free"] = createExportWrapper("free");

/** @type {function(...*):?} */
var _ImgIoUtilReadFile = Module["_ImgIoUtilReadFile"] = createExportWrapper("ImgIoUtilReadFile");

/** @type {function(...*):?} */
var _fseek = Module["_fseek"] = createExportWrapper("fseek");

/** @type {function(...*):?} */
var _ftell = Module["_ftell"] = createExportWrapper("ftell");

/** @type {function(...*):?} */
var _malloc = Module["_malloc"] = createExportWrapper("malloc");

/** @type {function(...*):?} */
var _ImgIoUtilWriteFile = Module["_ImgIoUtilWriteFile"] = createExportWrapper("ImgIoUtilWriteFile");

/** @type {function(...*):?} */
var _ImgIoUtilCopyPlane = Module["_ImgIoUtilCopyPlane"] = createExportWrapper("ImgIoUtilCopyPlane");

/** @type {function(...*):?} */
var _ImgIoUtilCheckSizeArgumentsOverflow = Module["_ImgIoUtilCheckSizeArgumentsOverflow"] = createExportWrapper("ImgIoUtilCheckSizeArgumentsOverflow");

/** @type {function(...*):?} */
var _MetadataInit = Module["_MetadataInit"] = createExportWrapper("MetadataInit");

/** @type {function(...*):?} */
var _MetadataPayloadDelete = Module["_MetadataPayloadDelete"] = createExportWrapper("MetadataPayloadDelete");

/** @type {function(...*):?} */
var _MetadataFree = Module["_MetadataFree"] = createExportWrapper("MetadataFree");

/** @type {function(...*):?} */
var _MetadataCopy = Module["_MetadataCopy"] = createExportWrapper("MetadataCopy");

/** @type {function(...*):?} */
var _sscanf = Module["_sscanf"] = createExportWrapper("sscanf");

/** @type {function(...*):?} */
var _memcmp = Module["_memcmp"] = createExportWrapper("memcmp");

/** @type {function(...*):?} */
var _strlen = Module["_strlen"] = createExportWrapper("strlen");

/** @type {function(...*):?} */
var _isprint = Module["_isprint"] = createExportWrapper("isprint");

/** @type {function(...*):?} */
var _WebPPictureImportRGBA = Module["_WebPPictureImportRGBA"] = createExportWrapper("WebPPictureImportRGBA");

/** @type {function(...*):?} */
var _WebPPictureImportRGB = Module["_WebPPictureImportRGB"] = createExportWrapper("WebPPictureImportRGB");

/** @type {function(...*):?} */
var _PrintWebPError = Module["_PrintWebPError"] = createExportWrapper("PrintWebPError");

/** @type {function(...*):?} */
var _LoadWebP = Module["_LoadWebP"] = createExportWrapper("LoadWebP");

/** @type {function(...*):?} */
var _WebPGetFeaturesInternal = Module["_WebPGetFeaturesInternal"] = createExportWrapper("WebPGetFeaturesInternal");

/** @type {function(...*):?} */
var _DecodeWebP = Module["_DecodeWebP"] = createExportWrapper("DecodeWebP");

/** @type {function(...*):?} */
var _WebPDecode = Module["_WebPDecode"] = createExportWrapper("WebPDecode");

/** @type {function(...*):?} */
var _DecodeWebPIncremental = Module["_DecodeWebPIncremental"] = createExportWrapper("DecodeWebPIncremental");

/** @type {function(...*):?} */
var _WebPIDecode = Module["_WebPIDecode"] = createExportWrapper("WebPIDecode");

/** @type {function(...*):?} */
var _WebPIUpdate = Module["_WebPIUpdate"] = createExportWrapper("WebPIUpdate");

/** @type {function(...*):?} */
var _WebPIDelete = Module["_WebPIDelete"] = createExportWrapper("WebPIDelete");

/** @type {function(...*):?} */
var _WebPInitDecoderConfigInternal = Module["_WebPInitDecoderConfigInternal"] = createExportWrapper("WebPInitDecoderConfigInternal");

/** @type {function(...*):?} */
var _WebPPictureAlloc = Module["_WebPPictureAlloc"] = createExportWrapper("WebPPictureAlloc");

/** @type {function(...*):?} */
var _WebPFreeDecBuffer = Module["_WebPFreeDecBuffer"] = createExportWrapper("WebPFreeDecBuffer");

/** @type {function(...*):?} */
var _WebPDemuxInternal = Module["_WebPDemuxInternal"] = createExportWrapper("WebPDemuxInternal");

/** @type {function(...*):?} */
var _WebPDemuxGetI = Module["_WebPDemuxGetI"] = createExportWrapper("WebPDemuxGetI");

/** @type {function(...*):?} */
var _WebPDemuxGetChunk = Module["_WebPDemuxGetChunk"] = createExportWrapper("WebPDemuxGetChunk");

/** @type {function(...*):?} */
var _WebPDemuxReleaseChunkIterator = Module["_WebPDemuxReleaseChunkIterator"] = createExportWrapper("WebPDemuxReleaseChunkIterator");

/** @type {function(...*):?} */
var _WebPDemuxDelete = Module["_WebPDemuxDelete"] = createExportWrapper("WebPDemuxDelete");

/** @type {function(...*):?} */
var _WebPPictureFree = Module["_WebPPictureFree"] = createExportWrapper("WebPPictureFree");

/** @type {function(...*):?} */
var _ReadPictureWithWIC = Module["_ReadPictureWithWIC"] = createExportWrapper("ReadPictureWithWIC");

/** @type {function(...*):?} */
var _WebPDeallocateAlphaMemory = Module["_WebPDeallocateAlphaMemory"] = createExportWrapper("WebPDeallocateAlphaMemory");

/** @type {function(...*):?} */
var _WebPSafeFree = Module["_WebPSafeFree"] = createExportWrapper("WebPSafeFree");

/** @type {function(...*):?} */
var _VP8LDelete = Module["_VP8LDelete"] = createExportWrapper("VP8LDelete");

/** @type {function(...*):?} */
var _VP8DecompressAlphaRows = Module["_VP8DecompressAlphaRows"] = createExportWrapper("VP8DecompressAlphaRows");

/** @type {function(...*):?} */
var _WebPSafeCalloc = Module["_WebPSafeCalloc"] = createExportWrapper("WebPSafeCalloc");

/** @type {function(...*):?} */
var _WebPSafeMalloc = Module["_WebPSafeMalloc"] = createExportWrapper("WebPSafeMalloc");

/** @type {function(...*):?} */
var _VP8FiltersInit = Module["_VP8FiltersInit"] = createExportWrapper("VP8FiltersInit");

/** @type {function(...*):?} */
var _VP8InitIoInternal = Module["_VP8InitIoInternal"] = createExportWrapper("VP8InitIoInternal");

/** @type {function(...*):?} */
var _WebPInitCustomIo = Module["_WebPInitCustomIo"] = createExportWrapper("WebPInitCustomIo");

/** @type {function(...*):?} */
var _VP8LDecodeAlphaHeader = Module["_VP8LDecodeAlphaHeader"] = createExportWrapper("VP8LDecodeAlphaHeader");

/** @type {function(...*):?} */
var _VP8LDecodeAlphaImageStream = Module["_VP8LDecodeAlphaImageStream"] = createExportWrapper("VP8LDecodeAlphaImageStream");

/** @type {function(...*):?} */
var _WebPDequantizeLevels = Module["_WebPDequantizeLevels"] = createExportWrapper("WebPDequantizeLevels");

/** @type {function(...*):?} */
var _WebPFlipBuffer = Module["_WebPFlipBuffer"] = createExportWrapper("WebPFlipBuffer");

/** @type {function(...*):?} */
var _WebPAllocateDecBuffer = Module["_WebPAllocateDecBuffer"] = createExportWrapper("WebPAllocateDecBuffer");

/** @type {function(...*):?} */
var _WebPRescalerGetScaledDimensions = Module["_WebPRescalerGetScaledDimensions"] = createExportWrapper("WebPRescalerGetScaledDimensions");

/** @type {function(...*):?} */
var _WebPInitDecBufferInternal = Module["_WebPInitDecBufferInternal"] = createExportWrapper("WebPInitDecBufferInternal");

/** @type {function(...*):?} */
var _memset = Module["_memset"] = createExportWrapper("memset");

/** @type {function(...*):?} */
var _WebPCopyDecBuffer = Module["_WebPCopyDecBuffer"] = createExportWrapper("WebPCopyDecBuffer");

/** @type {function(...*):?} */
var _WebPGrabDecBuffer = Module["_WebPGrabDecBuffer"] = createExportWrapper("WebPGrabDecBuffer");

/** @type {function(...*):?} */
var _WebPCopyDecBufferPixels = Module["_WebPCopyDecBufferPixels"] = createExportWrapper("WebPCopyDecBufferPixels");

/** @type {function(...*):?} */
var _WebPCopyPlane = Module["_WebPCopyPlane"] = createExportWrapper("WebPCopyPlane");

/** @type {function(...*):?} */
var _WebPAvoidSlowMemory = Module["_WebPAvoidSlowMemory"] = createExportWrapper("WebPAvoidSlowMemory");

/** @type {function(...*):?} */
var _VP8InitDithering = Module["_VP8InitDithering"] = createExportWrapper("VP8InitDithering");

/** @type {function(...*):?} */
var _VP8InitRandom = Module["_VP8InitRandom"] = createExportWrapper("VP8InitRandom");

/** @type {function(...*):?} */
var _VP8ProcessRow = Module["_VP8ProcessRow"] = createExportWrapper("VP8ProcessRow");

/** @type {function(...*):?} */
var _WebPGetWorkerInterface = Module["_WebPGetWorkerInterface"] = createExportWrapper("WebPGetWorkerInterface");

/** @type {function(...*):?} */
var _VP8SetError = Module["_VP8SetError"] = createExportWrapper("VP8SetError");

/** @type {function(...*):?} */
var _VP8EnterCritical = Module["_VP8EnterCritical"] = createExportWrapper("VP8EnterCritical");

/** @type {function(...*):?} */
var _VP8ExitCritical = Module["_VP8ExitCritical"] = createExportWrapper("VP8ExitCritical");

/** @type {function(...*):?} */
var _VP8GetThreadMethod = Module["_VP8GetThreadMethod"] = createExportWrapper("VP8GetThreadMethod");

/** @type {function(...*):?} */
var _VP8InitFrame = Module["_VP8InitFrame"] = createExportWrapper("VP8InitFrame");

/** @type {function(...*):?} */
var _VP8InitScanline = Module["_VP8InitScanline"] = createExportWrapper("VP8InitScanline");

/** @type {function(...*):?} */
var _VP8DspInit = Module["_VP8DspInit"] = createExportWrapper("VP8DspInit");

/** @type {function(...*):?} */
var _WebPINewDecoder = Module["_WebPINewDecoder"] = createExportWrapper("WebPINewDecoder");

/** @type {function(...*):?} */
var _WebPResetDecParams = Module["_WebPResetDecParams"] = createExportWrapper("WebPResetDecParams");

/** @type {function(...*):?} */
var _VP8Delete = Module["_VP8Delete"] = createExportWrapper("VP8Delete");

/** @type {function(...*):?} */
var _WebPINewRGB = Module["_WebPINewRGB"] = createExportWrapper("WebPINewRGB");

/** @type {function(...*):?} */
var _WebPINewYUVA = Module["_WebPINewYUVA"] = createExportWrapper("WebPINewYUVA");

/** @type {function(...*):?} */
var _WebPINewYUV = Module["_WebPINewYUV"] = createExportWrapper("WebPINewYUV");

/** @type {function(...*):?} */
var _WebPIAppend = Module["_WebPIAppend"] = createExportWrapper("WebPIAppend");

/** @type {function(...*):?} */
var _WebPParseHeaders = Module["_WebPParseHeaders"] = createExportWrapper("WebPParseHeaders");

/** @type {function(...*):?} */
var _VP8New = Module["_VP8New"] = createExportWrapper("VP8New");

/** @type {function(...*):?} */
var _VP8LNew = Module["_VP8LNew"] = createExportWrapper("VP8LNew");

/** @type {function(...*):?} */
var _VP8GetInfo = Module["_VP8GetInfo"] = createExportWrapper("VP8GetInfo");

/** @type {function(...*):?} */
var _VP8GetHeaders = Module["_VP8GetHeaders"] = createExportWrapper("VP8GetHeaders");

/** @type {function(...*):?} */
var _VP8BitReaderSetBuffer = Module["_VP8BitReaderSetBuffer"] = createExportWrapper("VP8BitReaderSetBuffer");

/** @type {function(...*):?} */
var _VP8ParseIntraModeRow = Module["_VP8ParseIntraModeRow"] = createExportWrapper("VP8ParseIntraModeRow");

/** @type {function(...*):?} */
var _VP8DecodeMB = Module["_VP8DecodeMB"] = createExportWrapper("VP8DecodeMB");

/** @type {function(...*):?} */
var _VP8LDecodeHeader = Module["_VP8LDecodeHeader"] = createExportWrapper("VP8LDecodeHeader");

/** @type {function(...*):?} */
var _VP8LDecodeImage = Module["_VP8LDecodeImage"] = createExportWrapper("VP8LDecodeImage");

/** @type {function(...*):?} */
var _WebPIDecodedArea = Module["_WebPIDecodedArea"] = createExportWrapper("WebPIDecodedArea");

/** @type {function(...*):?} */
var _WebPIDecGetRGB = Module["_WebPIDecGetRGB"] = createExportWrapper("WebPIDecGetRGB");

/** @type {function(...*):?} */
var _WebPIDecGetYUVA = Module["_WebPIDecGetYUVA"] = createExportWrapper("WebPIDecGetYUVA");

/** @type {function(...*):?} */
var _WebPISetIOHooks = Module["_WebPISetIOHooks"] = createExportWrapper("WebPISetIOHooks");

/** @type {function(...*):?} */
var _VP8RemapBitReader = Module["_VP8RemapBitReader"] = createExportWrapper("VP8RemapBitReader");

/** @type {function(...*):?} */
var _VP8LBitReaderSetBuffer = Module["_VP8LBitReaderSetBuffer"] = createExportWrapper("VP8LBitReaderSetBuffer");

/** @type {function(...*):?} */
var _WebPIoInitFromOptions = Module["_WebPIoInitFromOptions"] = createExportWrapper("WebPIoInitFromOptions");

/** @type {function(...*):?} */
var _WebPInitUpsamplers = Module["_WebPInitUpsamplers"] = createExportWrapper("WebPInitUpsamplers");

/** @type {function(...*):?} */
var _WebPInitSamplers = Module["_WebPInitSamplers"] = createExportWrapper("WebPInitSamplers");

/** @type {function(...*):?} */
var _WebPRescalerInit = Module["_WebPRescalerInit"] = createExportWrapper("WebPRescalerInit");

/** @type {function(...*):?} */
var _WebPInitYUV444Converters = Module["_WebPInitYUV444Converters"] = createExportWrapper("WebPInitYUV444Converters");

/** @type {function(...*):?} */
var _WebPInitAlphaProcessing = Module["_WebPInitAlphaProcessing"] = createExportWrapper("WebPInitAlphaProcessing");

/** @type {function(...*):?} */
var _WebPSamplerProcessPlane = Module["_WebPSamplerProcessPlane"] = createExportWrapper("WebPSamplerProcessPlane");

/** @type {function(...*):?} */
var _WebPRescalerImport = Module["_WebPRescalerImport"] = createExportWrapper("WebPRescalerImport");

/** @type {function(...*):?} */
var _WebPRescaleNeededLines = Module["_WebPRescaleNeededLines"] = createExportWrapper("WebPRescaleNeededLines");

/** @type {function(...*):?} */
var _WebPRescalerExportRow = Module["_WebPRescalerExportRow"] = createExportWrapper("WebPRescalerExportRow");

/** @type {function(...*):?} */
var _WebPMultRows = Module["_WebPMultRows"] = createExportWrapper("WebPMultRows");

/** @type {function(...*):?} */
var _WebPRescalerExport = Module["_WebPRescalerExport"] = createExportWrapper("WebPRescalerExport");

/** @type {function(...*):?} */
var _VP8ParseQuant = Module["_VP8ParseQuant"] = createExportWrapper("VP8ParseQuant");

/** @type {function(...*):?} */
var _VP8GetValue = Module["_VP8GetValue"] = createExportWrapper("VP8GetValue");

/** @type {function(...*):?} */
var _VP8GetSignedValue = Module["_VP8GetSignedValue"] = createExportWrapper("VP8GetSignedValue");

/** @type {function(...*):?} */
var _VP8ResetProba = Module["_VP8ResetProba"] = createExportWrapper("VP8ResetProba");

/** @type {function(...*):?} */
var _VP8LoadFinalBytes = Module["_VP8LoadFinalBytes"] = createExportWrapper("VP8LoadFinalBytes");

/** @type {function(...*):?} */
var _VP8ParseProba = Module["_VP8ParseProba"] = createExportWrapper("VP8ParseProba");

/** @type {function(...*):?} */
var _WebPGetDecoderVersion = Module["_WebPGetDecoderVersion"] = createExportWrapper("WebPGetDecoderVersion");

/** @type {function(...*):?} */
var _VP8Status = Module["_VP8Status"] = createExportWrapper("VP8Status");

/** @type {function(...*):?} */
var _VP8StatusMessage = Module["_VP8StatusMessage"] = createExportWrapper("VP8StatusMessage");

/** @type {function(...*):?} */
var _VP8Clear = Module["_VP8Clear"] = createExportWrapper("VP8Clear");

/** @type {function(...*):?} */
var _VP8CheckSignature = Module["_VP8CheckSignature"] = createExportWrapper("VP8CheckSignature");

/** @type {function(...*):?} */
var _VP8InitBitReader = Module["_VP8InitBitReader"] = createExportWrapper("VP8InitBitReader");

/** @type {function(...*):?} */
var _VP8Decode = Module["_VP8Decode"] = createExportWrapper("VP8Decode");

/** @type {function(...*):?} */
var _VP8LCheckSignature = Module["_VP8LCheckSignature"] = createExportWrapper("VP8LCheckSignature");

/** @type {function(...*):?} */
var _VP8LGetInfo = Module["_VP8LGetInfo"] = createExportWrapper("VP8LGetInfo");

/** @type {function(...*):?} */
var _VP8LInitBitReader = Module["_VP8LInitBitReader"] = createExportWrapper("VP8LInitBitReader");

/** @type {function(...*):?} */
var _VP8LReadBits = Module["_VP8LReadBits"] = createExportWrapper("VP8LReadBits");

/** @type {function(...*):?} */
var _VP8LDspInit = Module["_VP8LDspInit"] = createExportWrapper("VP8LDspInit");

/** @type {function(...*):?} */
var _VP8LClear = Module["_VP8LClear"] = createExportWrapper("VP8LClear");

/** @type {function(...*):?} */
var _VP8LHtreeGroupsFree = Module["_VP8LHtreeGroupsFree"] = createExportWrapper("VP8LHtreeGroupsFree");

/** @type {function(...*):?} */
var _VP8LColorCacheClear = Module["_VP8LColorCacheClear"] = createExportWrapper("VP8LColorCacheClear");

/** @type {function(...*):?} */
var _VP8LHtreeGroupsNew = Module["_VP8LHtreeGroupsNew"] = createExportWrapper("VP8LHtreeGroupsNew");

/** @type {function(...*):?} */
var _VP8LColorCacheInit = Module["_VP8LColorCacheInit"] = createExportWrapper("VP8LColorCacheInit");

/** @type {function(...*):?} */
var _VP8LDoFillBitWindow = Module["_VP8LDoFillBitWindow"] = createExportWrapper("VP8LDoFillBitWindow");

/** @type {function(...*):?} */
var _VP8LColorCacheCopy = Module["_VP8LColorCacheCopy"] = createExportWrapper("VP8LColorCacheCopy");

/** @type {function(...*):?} */
var _VP8LInverseTransform = Module["_VP8LInverseTransform"] = createExportWrapper("VP8LInverseTransform");

/** @type {function(...*):?} */
var _WebPInitConvertARGBToYUV = Module["_WebPInitConvertARGBToYUV"] = createExportWrapper("WebPInitConvertARGBToYUV");

/** @type {function(...*):?} */
var _WebPMultARGBRows = Module["_WebPMultARGBRows"] = createExportWrapper("WebPMultARGBRows");

/** @type {function(...*):?} */
var _VP8LConvertFromBGRA = Module["_VP8LConvertFromBGRA"] = createExportWrapper("VP8LConvertFromBGRA");

/** @type {function(...*):?} */
var _VP8LBuildHuffmanTable = Module["_VP8LBuildHuffmanTable"] = createExportWrapper("VP8LBuildHuffmanTable");

/** @type {function(...*):?} */
var _VP8LColorIndexInverseTransformAlpha = Module["_VP8LColorIndexInverseTransformAlpha"] = createExportWrapper("VP8LColorIndexInverseTransformAlpha");

/** @type {function(...*):?} */
var _WebPDecodeRGBInto = Module["_WebPDecodeRGBInto"] = createExportWrapper("WebPDecodeRGBInto");

/** @type {function(...*):?} */
var _WebPDecodeRGBAInto = Module["_WebPDecodeRGBAInto"] = createExportWrapper("WebPDecodeRGBAInto");

/** @type {function(...*):?} */
var _WebPDecodeARGBInto = Module["_WebPDecodeARGBInto"] = createExportWrapper("WebPDecodeARGBInto");

/** @type {function(...*):?} */
var _WebPDecodeBGRInto = Module["_WebPDecodeBGRInto"] = createExportWrapper("WebPDecodeBGRInto");

/** @type {function(...*):?} */
var _WebPDecodeBGRAInto = Module["_WebPDecodeBGRAInto"] = createExportWrapper("WebPDecodeBGRAInto");

/** @type {function(...*):?} */
var _WebPDecodeYUVInto = Module["_WebPDecodeYUVInto"] = createExportWrapper("WebPDecodeYUVInto");

/** @type {function(...*):?} */
var _WebPDecodeRGB = Module["_WebPDecodeRGB"] = createExportWrapper("WebPDecodeRGB");

/** @type {function(...*):?} */
var _WebPDecodeRGBA = Module["_WebPDecodeRGBA"] = createExportWrapper("WebPDecodeRGBA");

/** @type {function(...*):?} */
var _WebPDecodeARGB = Module["_WebPDecodeARGB"] = createExportWrapper("WebPDecodeARGB");

/** @type {function(...*):?} */
var _WebPDecodeBGR = Module["_WebPDecodeBGR"] = createExportWrapper("WebPDecodeBGR");

/** @type {function(...*):?} */
var _WebPDecodeBGRA = Module["_WebPDecodeBGRA"] = createExportWrapper("WebPDecodeBGRA");

/** @type {function(...*):?} */
var _WebPDecodeYUV = Module["_WebPDecodeYUV"] = createExportWrapper("WebPDecodeYUV");

/** @type {function(...*):?} */
var _WebPGetInfo = Module["_WebPGetInfo"] = createExportWrapper("WebPGetInfo");

/** @type {function(...*):?} */
var _WebPAnimDecoderOptionsInitInternal = Module["_WebPAnimDecoderOptionsInitInternal"] = createExportWrapper("WebPAnimDecoderOptionsInitInternal");

/** @type {function(...*):?} */
var _WebPAnimDecoderNewInternal = Module["_WebPAnimDecoderNewInternal"] = createExportWrapper("WebPAnimDecoderNewInternal");

/** @type {function(...*):?} */
var _WebPDemuxReleaseIterator = Module["_WebPDemuxReleaseIterator"] = createExportWrapper("WebPDemuxReleaseIterator");

/** @type {function(...*):?} */
var _WebPAnimDecoderReset = Module["_WebPAnimDecoderReset"] = createExportWrapper("WebPAnimDecoderReset");

/** @type {function(...*):?} */
var _WebPAnimDecoderDelete = Module["_WebPAnimDecoderDelete"] = createExportWrapper("WebPAnimDecoderDelete");

/** @type {function(...*):?} */
var _WebPAnimDecoderGetInfo = Module["_WebPAnimDecoderGetInfo"] = createExportWrapper("WebPAnimDecoderGetInfo");

/** @type {function(...*):?} */
var _WebPAnimDecoderGetNext = Module["_WebPAnimDecoderGetNext"] = createExportWrapper("WebPAnimDecoderGetNext");

/** @type {function(...*):?} */
var _WebPDemuxGetFrame = Module["_WebPDemuxGetFrame"] = createExportWrapper("WebPDemuxGetFrame");

/** @type {function(...*):?} */
var _WebPAnimDecoderHasMoreFrames = Module["_WebPAnimDecoderHasMoreFrames"] = createExportWrapper("WebPAnimDecoderHasMoreFrames");

/** @type {function(...*):?} */
var _WebPAnimDecoderGetDemuxer = Module["_WebPAnimDecoderGetDemuxer"] = createExportWrapper("WebPAnimDecoderGetDemuxer");

/** @type {function(...*):?} */
var _WebPGetDemuxVersion = Module["_WebPGetDemuxVersion"] = createExportWrapper("WebPGetDemuxVersion");

/** @type {function(...*):?} */
var _WebPDemuxNextFrame = Module["_WebPDemuxNextFrame"] = createExportWrapper("WebPDemuxNextFrame");

/** @type {function(...*):?} */
var _WebPDemuxPrevFrame = Module["_WebPDemuxPrevFrame"] = createExportWrapper("WebPDemuxPrevFrame");

/** @type {function(...*):?} */
var _WebPDemuxNextChunk = Module["_WebPDemuxNextChunk"] = createExportWrapper("WebPDemuxNextChunk");

/** @type {function(...*):?} */
var _WebPDemuxPrevChunk = Module["_WebPDemuxPrevChunk"] = createExportWrapper("WebPDemuxPrevChunk");

/** @type {function(...*):?} */
var _WebPMultARGBRow_C = Module["_WebPMultARGBRow_C"] = createExportWrapper("WebPMultARGBRow_C");

/** @type {function(...*):?} */
var _WebPMultRow_C = Module["_WebPMultRow_C"] = createExportWrapper("WebPMultRow_C");

/** @type {function(...*):?} */
var _WebPInitAlphaProcessingMIPSdspR2 = Module["_WebPInitAlphaProcessingMIPSdspR2"] = createExportWrapper("WebPInitAlphaProcessingMIPSdspR2");

/** @type {function(...*):?} */
var _WebPInitAlphaProcessingNEON = Module["_WebPInitAlphaProcessingNEON"] = createExportWrapper("WebPInitAlphaProcessingNEON");

/** @type {function(...*):?} */
var _WebPInitAlphaProcessingSSE2 = Module["_WebPInitAlphaProcessingSSE2"] = createExportWrapper("WebPInitAlphaProcessingSSE2");

/** @type {function(...*):?} */
var _WebPInitAlphaProcessingSSE41 = Module["_WebPInitAlphaProcessingSSE41"] = createExportWrapper("WebPInitAlphaProcessingSSE41");

/** @type {function(...*):?} */
var _VP8EncDspCostInit = Module["_VP8EncDspCostInit"] = createExportWrapper("VP8EncDspCostInit");

/** @type {function(...*):?} */
var _VP8EncDspCostInitMIPS32 = Module["_VP8EncDspCostInitMIPS32"] = createExportWrapper("VP8EncDspCostInitMIPS32");

/** @type {function(...*):?} */
var _VP8EncDspCostInitMIPSdspR2 = Module["_VP8EncDspCostInitMIPSdspR2"] = createExportWrapper("VP8EncDspCostInitMIPSdspR2");

/** @type {function(...*):?} */
var _VP8EncDspCostInitNEON = Module["_VP8EncDspCostInitNEON"] = createExportWrapper("VP8EncDspCostInitNEON");

/** @type {function(...*):?} */
var _VP8EncDspCostInitSSE2 = Module["_VP8EncDspCostInitSSE2"] = createExportWrapper("VP8EncDspCostInitSSE2");

/** @type {function(...*):?} */
var _VP8InitClipTables = Module["_VP8InitClipTables"] = createExportWrapper("VP8InitClipTables");

/** @type {function(...*):?} */
var _VP8DspInitMIPS32 = Module["_VP8DspInitMIPS32"] = createExportWrapper("VP8DspInitMIPS32");

/** @type {function(...*):?} */
var _VP8DspInitMIPSdspR2 = Module["_VP8DspInitMIPSdspR2"] = createExportWrapper("VP8DspInitMIPSdspR2");

/** @type {function(...*):?} */
var _VP8DspInitMSA = Module["_VP8DspInitMSA"] = createExportWrapper("VP8DspInitMSA");

/** @type {function(...*):?} */
var _VP8DspInitNEON = Module["_VP8DspInitNEON"] = createExportWrapper("VP8DspInitNEON");

/** @type {function(...*):?} */
var _VP8DspInitSSE2 = Module["_VP8DspInitSSE2"] = createExportWrapper("VP8DspInitSSE2");

/** @type {function(...*):?} */
var _VP8DspInitSSE41 = Module["_VP8DspInitSSE41"] = createExportWrapper("VP8DspInitSSE41");

/** @type {function(...*):?} */
var _VP8SetHistogramData = Module["_VP8SetHistogramData"] = createExportWrapper("VP8SetHistogramData");

/** @type {function(...*):?} */
var _VP8EncDspInit = Module["_VP8EncDspInit"] = createExportWrapper("VP8EncDspInit");

/** @type {function(...*):?} */
var _VP8EncDspInitMIPS32 = Module["_VP8EncDspInitMIPS32"] = createExportWrapper("VP8EncDspInitMIPS32");

/** @type {function(...*):?} */
var _VP8EncDspInitMIPSdspR2 = Module["_VP8EncDspInitMIPSdspR2"] = createExportWrapper("VP8EncDspInitMIPSdspR2");

/** @type {function(...*):?} */
var _VP8EncDspInitMSA = Module["_VP8EncDspInitMSA"] = createExportWrapper("VP8EncDspInitMSA");

/** @type {function(...*):?} */
var _VP8EncDspInitNEON = Module["_VP8EncDspInitNEON"] = createExportWrapper("VP8EncDspInitNEON");

/** @type {function(...*):?} */
var _VP8EncDspInitSSE2 = Module["_VP8EncDspInitSSE2"] = createExportWrapper("VP8EncDspInitSSE2");

/** @type {function(...*):?} */
var _VP8EncDspInitSSE41 = Module["_VP8EncDspInitSSE41"] = createExportWrapper("VP8EncDspInitSSE41");

/** @type {function(...*):?} */
var _VP8FiltersInitMIPSdspR2 = Module["_VP8FiltersInitMIPSdspR2"] = createExportWrapper("VP8FiltersInitMIPSdspR2");

/** @type {function(...*):?} */
var _VP8FiltersInitMSA = Module["_VP8FiltersInitMSA"] = createExportWrapper("VP8FiltersInitMSA");

/** @type {function(...*):?} */
var _VP8FiltersInitNEON = Module["_VP8FiltersInitNEON"] = createExportWrapper("VP8FiltersInitNEON");

/** @type {function(...*):?} */
var _VP8FiltersInitSSE2 = Module["_VP8FiltersInitSSE2"] = createExportWrapper("VP8FiltersInitSSE2");

/** @type {function(...*):?} */
var _VP8LAddGreenToBlueAndRed_C = Module["_VP8LAddGreenToBlueAndRed_C"] = createExportWrapper("VP8LAddGreenToBlueAndRed_C");

/** @type {function(...*):?} */
var _VP8LTransformColorInverse_C = Module["_VP8LTransformColorInverse_C"] = createExportWrapper("VP8LTransformColorInverse_C");

/** @type {function(...*):?} */
var _memmove = Module["_memmove"] = createExportWrapper("memmove");

/** @type {function(...*):?} */
var _VP8LConvertBGRAToRGB_C = Module["_VP8LConvertBGRAToRGB_C"] = createExportWrapper("VP8LConvertBGRAToRGB_C");

/** @type {function(...*):?} */
var _VP8LConvertBGRAToRGBA_C = Module["_VP8LConvertBGRAToRGBA_C"] = createExportWrapper("VP8LConvertBGRAToRGBA_C");

/** @type {function(...*):?} */
var _VP8LConvertBGRAToRGBA4444_C = Module["_VP8LConvertBGRAToRGBA4444_C"] = createExportWrapper("VP8LConvertBGRAToRGBA4444_C");

/** @type {function(...*):?} */
var _VP8LConvertBGRAToRGB565_C = Module["_VP8LConvertBGRAToRGB565_C"] = createExportWrapper("VP8LConvertBGRAToRGB565_C");

/** @type {function(...*):?} */
var _VP8LConvertBGRAToBGR_C = Module["_VP8LConvertBGRAToBGR_C"] = createExportWrapper("VP8LConvertBGRAToBGR_C");

/** @type {function(...*):?} */
var _VP8LBitEntropyInit = Module["_VP8LBitEntropyInit"] = createExportWrapper("VP8LBitEntropyInit");

/** @type {function(...*):?} */
var _VP8LBitsEntropyUnrefined = Module["_VP8LBitsEntropyUnrefined"] = createExportWrapper("VP8LBitsEntropyUnrefined");

/** @type {function(...*):?} */
var _VP8LSubtractGreenFromBlueAndRed_C = Module["_VP8LSubtractGreenFromBlueAndRed_C"] = createExportWrapper("VP8LSubtractGreenFromBlueAndRed_C");

/** @type {function(...*):?} */
var _VP8LTransformColor_C = Module["_VP8LTransformColor_C"] = createExportWrapper("VP8LTransformColor_C");

/** @type {function(...*):?} */
var _VP8LCollectColorRedTransforms_C = Module["_VP8LCollectColorRedTransforms_C"] = createExportWrapper("VP8LCollectColorRedTransforms_C");

/** @type {function(...*):?} */
var _VP8LCollectColorBlueTransforms_C = Module["_VP8LCollectColorBlueTransforms_C"] = createExportWrapper("VP8LCollectColorBlueTransforms_C");

/** @type {function(...*):?} */
var _VP8LBundleColorMap_C = Module["_VP8LBundleColorMap_C"] = createExportWrapper("VP8LBundleColorMap_C");

/** @type {function(...*):?} */
var _VP8LHistogramAdd = Module["_VP8LHistogramAdd"] = createExportWrapper("VP8LHistogramAdd");

/** @type {function(...*):?} */
var _VP8LEncDspInit = Module["_VP8LEncDspInit"] = createExportWrapper("VP8LEncDspInit");

/** @type {function(...*):?} */
var _log = Module["_log"] = createExportWrapper("log");

/** @type {function(...*):?} */
var _VP8LEncDspInitMIPS32 = Module["_VP8LEncDspInitMIPS32"] = createExportWrapper("VP8LEncDspInitMIPS32");

/** @type {function(...*):?} */
var _VP8LEncDspInitMIPSdspR2 = Module["_VP8LEncDspInitMIPSdspR2"] = createExportWrapper("VP8LEncDspInitMIPSdspR2");

/** @type {function(...*):?} */
var _VP8LEncDspInitMSA = Module["_VP8LEncDspInitMSA"] = createExportWrapper("VP8LEncDspInitMSA");

/** @type {function(...*):?} */
var _VP8LEncDspInitNEON = Module["_VP8LEncDspInitNEON"] = createExportWrapper("VP8LEncDspInitNEON");

/** @type {function(...*):?} */
var _VP8LEncDspInitSSE2 = Module["_VP8LEncDspInitSSE2"] = createExportWrapper("VP8LEncDspInitSSE2");

/** @type {function(...*):?} */
var _VP8LEncDspInitSSE41 = Module["_VP8LEncDspInitSSE41"] = createExportWrapper("VP8LEncDspInitSSE41");

/** @type {function(...*):?} */
var _VP8LDspInitMIPSdspR2 = Module["_VP8LDspInitMIPSdspR2"] = createExportWrapper("VP8LDspInitMIPSdspR2");

/** @type {function(...*):?} */
var _VP8LDspInitMSA = Module["_VP8LDspInitMSA"] = createExportWrapper("VP8LDspInitMSA");

/** @type {function(...*):?} */
var _VP8LDspInitNEON = Module["_VP8LDspInitNEON"] = createExportWrapper("VP8LDspInitNEON");

/** @type {function(...*):?} */
var _VP8LDspInitSSE2 = Module["_VP8LDspInitSSE2"] = createExportWrapper("VP8LDspInitSSE2");

/** @type {function(...*):?} */
var _WebPRescalerImportRowExpand_C = Module["_WebPRescalerImportRowExpand_C"] = createExportWrapper("WebPRescalerImportRowExpand_C");

/** @type {function(...*):?} */
var _WebPRescalerImportRowShrink_C = Module["_WebPRescalerImportRowShrink_C"] = createExportWrapper("WebPRescalerImportRowShrink_C");

/** @type {function(...*):?} */
var _WebPRescalerExportRowExpand_C = Module["_WebPRescalerExportRowExpand_C"] = createExportWrapper("WebPRescalerExportRowExpand_C");

/** @type {function(...*):?} */
var _WebPRescalerExportRowShrink_C = Module["_WebPRescalerExportRowShrink_C"] = createExportWrapper("WebPRescalerExportRowShrink_C");

/** @type {function(...*):?} */
var _WebPRescalerImportRow = Module["_WebPRescalerImportRow"] = createExportWrapper("WebPRescalerImportRow");

/** @type {function(...*):?} */
var _WebPRescalerDspInit = Module["_WebPRescalerDspInit"] = createExportWrapper("WebPRescalerDspInit");

/** @type {function(...*):?} */
var _WebPRescalerDspInitMIPS32 = Module["_WebPRescalerDspInitMIPS32"] = createExportWrapper("WebPRescalerDspInitMIPS32");

/** @type {function(...*):?} */
var _WebPRescalerDspInitMIPSdspR2 = Module["_WebPRescalerDspInitMIPSdspR2"] = createExportWrapper("WebPRescalerDspInitMIPSdspR2");

/** @type {function(...*):?} */
var _WebPRescalerDspInitMSA = Module["_WebPRescalerDspInitMSA"] = createExportWrapper("WebPRescalerDspInitMSA");

/** @type {function(...*):?} */
var _WebPRescalerDspInitNEON = Module["_WebPRescalerDspInitNEON"] = createExportWrapper("WebPRescalerDspInitNEON");

/** @type {function(...*):?} */
var _WebPRescalerDspInitSSE2 = Module["_WebPRescalerDspInitSSE2"] = createExportWrapper("WebPRescalerDspInitSSE2");

/** @type {function(...*):?} */
var _VP8SSIMFromStats = Module["_VP8SSIMFromStats"] = createExportWrapper("VP8SSIMFromStats");

/** @type {function(...*):?} */
var _VP8SSIMFromStatsClipped = Module["_VP8SSIMFromStatsClipped"] = createExportWrapper("VP8SSIMFromStatsClipped");

/** @type {function(...*):?} */
var _VP8SSIMDspInit = Module["_VP8SSIMDspInit"] = createExportWrapper("VP8SSIMDspInit");

/** @type {function(...*):?} */
var _VP8SSIMDspInitSSE2 = Module["_VP8SSIMDspInitSSE2"] = createExportWrapper("VP8SSIMDspInitSSE2");

/** @type {function(...*):?} */
var _WebPGetLinePairConverter = Module["_WebPGetLinePairConverter"] = createExportWrapper("WebPGetLinePairConverter");

/** @type {function(...*):?} */
var _WebPYuv444ToRgba_C = Module["_WebPYuv444ToRgba_C"] = createExportWrapper("WebPYuv444ToRgba_C");

/** @type {function(...*):?} */
var _WebPYuv444ToBgra_C = Module["_WebPYuv444ToBgra_C"] = createExportWrapper("WebPYuv444ToBgra_C");

/** @type {function(...*):?} */
var _WebPYuv444ToRgb_C = Module["_WebPYuv444ToRgb_C"] = createExportWrapper("WebPYuv444ToRgb_C");

/** @type {function(...*):?} */
var _WebPYuv444ToBgr_C = Module["_WebPYuv444ToBgr_C"] = createExportWrapper("WebPYuv444ToBgr_C");

/** @type {function(...*):?} */
var _WebPYuv444ToArgb_C = Module["_WebPYuv444ToArgb_C"] = createExportWrapper("WebPYuv444ToArgb_C");

/** @type {function(...*):?} */
var _WebPYuv444ToRgba4444_C = Module["_WebPYuv444ToRgba4444_C"] = createExportWrapper("WebPYuv444ToRgba4444_C");

/** @type {function(...*):?} */
var _WebPYuv444ToRgb565_C = Module["_WebPYuv444ToRgb565_C"] = createExportWrapper("WebPYuv444ToRgb565_C");

/** @type {function(...*):?} */
var _WebPInitYUV444ConvertersMIPSdspR2 = Module["_WebPInitYUV444ConvertersMIPSdspR2"] = createExportWrapper("WebPInitYUV444ConvertersMIPSdspR2");

/** @type {function(...*):?} */
var _WebPInitUpsamplersMIPSdspR2 = Module["_WebPInitUpsamplersMIPSdspR2"] = createExportWrapper("WebPInitUpsamplersMIPSdspR2");

/** @type {function(...*):?} */
var _WebPInitUpsamplersMSA = Module["_WebPInitUpsamplersMSA"] = createExportWrapper("WebPInitUpsamplersMSA");

/** @type {function(...*):?} */
var _WebPInitUpsamplersNEON = Module["_WebPInitUpsamplersNEON"] = createExportWrapper("WebPInitUpsamplersNEON");

/** @type {function(...*):?} */
var _WebPInitYUV444ConvertersSSE2 = Module["_WebPInitYUV444ConvertersSSE2"] = createExportWrapper("WebPInitYUV444ConvertersSSE2");

/** @type {function(...*):?} */
var _WebPInitUpsamplersSSE2 = Module["_WebPInitUpsamplersSSE2"] = createExportWrapper("WebPInitUpsamplersSSE2");

/** @type {function(...*):?} */
var _WebPInitYUV444ConvertersSSE41 = Module["_WebPInitYUV444ConvertersSSE41"] = createExportWrapper("WebPInitYUV444ConvertersSSE41");

/** @type {function(...*):?} */
var _WebPInitUpsamplersSSE41 = Module["_WebPInitUpsamplersSSE41"] = createExportWrapper("WebPInitUpsamplersSSE41");

/** @type {function(...*):?} */
var _WebPConvertARGBToUV_C = Module["_WebPConvertARGBToUV_C"] = createExportWrapper("WebPConvertARGBToUV_C");

/** @type {function(...*):?} */
var _WebPConvertRGBA32ToUV_C = Module["_WebPConvertRGBA32ToUV_C"] = createExportWrapper("WebPConvertRGBA32ToUV_C");

/** @type {function(...*):?} */
var _WebPInitSamplersMIPS32 = Module["_WebPInitSamplersMIPS32"] = createExportWrapper("WebPInitSamplersMIPS32");

/** @type {function(...*):?} */
var _WebPInitSamplersMIPSdspR2 = Module["_WebPInitSamplersMIPSdspR2"] = createExportWrapper("WebPInitSamplersMIPSdspR2");

/** @type {function(...*):?} */
var _WebPInitConvertARGBToYUVNEON = Module["_WebPInitConvertARGBToYUVNEON"] = createExportWrapper("WebPInitConvertARGBToYUVNEON");

/** @type {function(...*):?} */
var _WebPInitSharpYUVNEON = Module["_WebPInitSharpYUVNEON"] = createExportWrapper("WebPInitSharpYUVNEON");

/** @type {function(...*):?} */
var _WebPInitSamplersSSE2 = Module["_WebPInitSamplersSSE2"] = createExportWrapper("WebPInitSamplersSSE2");

/** @type {function(...*):?} */
var _WebPInitConvertARGBToYUVSSE2 = Module["_WebPInitConvertARGBToYUVSSE2"] = createExportWrapper("WebPInitConvertARGBToYUVSSE2");

/** @type {function(...*):?} */
var _WebPInitSharpYUVSSE2 = Module["_WebPInitSharpYUVSSE2"] = createExportWrapper("WebPInitSharpYUVSSE2");

/** @type {function(...*):?} */
var _WebPInitSamplersSSE41 = Module["_WebPInitSamplersSSE41"] = createExportWrapper("WebPInitSamplersSSE41");

/** @type {function(...*):?} */
var _WebPInitConvertARGBToYUVSSE41 = Module["_WebPInitConvertARGBToYUVSSE41"] = createExportWrapper("WebPInitConvertARGBToYUVSSE41");

/** @type {function(...*):?} */
var _VP8EncInitAlpha = Module["_VP8EncInitAlpha"] = createExportWrapper("VP8EncInitAlpha");

/** @type {function(...*):?} */
var _WebPPictureHasTransparency = Module["_WebPPictureHasTransparency"] = createExportWrapper("WebPPictureHasTransparency");

/** @type {function(...*):?} */
var _QuantizeLevels = Module["_QuantizeLevels"] = createExportWrapper("QuantizeLevels");

/** @type {function(...*):?} */
var _WebPEstimateBestFilter = Module["_WebPEstimateBestFilter"] = createExportWrapper("WebPEstimateBestFilter");

/** @type {function(...*):?} */
var _VP8BitWriterInit = Module["_VP8BitWriterInit"] = createExportWrapper("VP8BitWriterInit");

/** @type {function(...*):?} */
var _VP8BitWriterWipeOut = Module["_VP8BitWriterWipeOut"] = createExportWrapper("VP8BitWriterWipeOut");

/** @type {function(...*):?} */
var _VP8EncStartAlpha = Module["_VP8EncStartAlpha"] = createExportWrapper("VP8EncStartAlpha");

/** @type {function(...*):?} */
var _VP8EncFinishAlpha = Module["_VP8EncFinishAlpha"] = createExportWrapper("VP8EncFinishAlpha");

/** @type {function(...*):?} */
var _WebPReportProgress = Module["_WebPReportProgress"] = createExportWrapper("WebPReportProgress");

/** @type {function(...*):?} */
var _VP8EncDeleteAlpha = Module["_VP8EncDeleteAlpha"] = createExportWrapper("VP8EncDeleteAlpha");

/** @type {function(...*):?} */
var _VP8LBitWriterInit = Module["_VP8LBitWriterInit"] = createExportWrapper("VP8LBitWriterInit");

/** @type {function(...*):?} */
var _WebPPictureInitInternal = Module["_WebPPictureInitInternal"] = createExportWrapper("WebPPictureInitInternal");

/** @type {function(...*):?} */
var _WebPConfigInitInternal = Module["_WebPConfigInitInternal"] = createExportWrapper("WebPConfigInitInternal");

/** @type {function(...*):?} */
var _VP8LEncodeStream = Module["_VP8LEncodeStream"] = createExportWrapper("VP8LEncodeStream");

/** @type {function(...*):?} */
var _VP8LBitWriterWipeOut = Module["_VP8LBitWriterWipeOut"] = createExportWrapper("VP8LBitWriterWipeOut");

/** @type {function(...*):?} */
var _VP8LBitWriterFinish = Module["_VP8LBitWriterFinish"] = createExportWrapper("VP8LBitWriterFinish");

/** @type {function(...*):?} */
var _VP8BitWriterAppend = Module["_VP8BitWriterAppend"] = createExportWrapper("VP8BitWriterAppend");

/** @type {function(...*):?} */
var _VP8EncAnalyze = Module["_VP8EncAnalyze"] = createExportWrapper("VP8EncAnalyze");

/** @type {function(...*):?} */
var _VP8IteratorInit = Module["_VP8IteratorInit"] = createExportWrapper("VP8IteratorInit");

/** @type {function(...*):?} */
var _VP8IteratorSetRow = Module["_VP8IteratorSetRow"] = createExportWrapper("VP8IteratorSetRow");

/** @type {function(...*):?} */
var _VP8IteratorSetCountDown = Module["_VP8IteratorSetCountDown"] = createExportWrapper("VP8IteratorSetCountDown");

/** @type {function(...*):?} */
var _VP8IteratorIsDone = Module["_VP8IteratorIsDone"] = createExportWrapper("VP8IteratorIsDone");

/** @type {function(...*):?} */
var _VP8IteratorImport = Module["_VP8IteratorImport"] = createExportWrapper("VP8IteratorImport");

/** @type {function(...*):?} */
var _VP8SetIntra16Mode = Module["_VP8SetIntra16Mode"] = createExportWrapper("VP8SetIntra16Mode");

/** @type {function(...*):?} */
var _VP8SetSkip = Module["_VP8SetSkip"] = createExportWrapper("VP8SetSkip");

/** @type {function(...*):?} */
var _VP8SetSegment = Module["_VP8SetSegment"] = createExportWrapper("VP8SetSegment");

/** @type {function(...*):?} */
var _VP8SetIntra4Mode = Module["_VP8SetIntra4Mode"] = createExportWrapper("VP8SetIntra4Mode");

/** @type {function(...*):?} */
var _VP8MakeLuma16Preds = Module["_VP8MakeLuma16Preds"] = createExportWrapper("VP8MakeLuma16Preds");

/** @type {function(...*):?} */
var _VP8MakeChroma8Preds = Module["_VP8MakeChroma8Preds"] = createExportWrapper("VP8MakeChroma8Preds");

/** @type {function(...*):?} */
var _VP8SetIntraUVMode = Module["_VP8SetIntraUVMode"] = createExportWrapper("VP8SetIntraUVMode");

/** @type {function(...*):?} */
var _VP8IteratorProgress = Module["_VP8IteratorProgress"] = createExportWrapper("VP8IteratorProgress");

/** @type {function(...*):?} */
var _VP8IteratorNext = Module["_VP8IteratorNext"] = createExportWrapper("VP8IteratorNext");

/** @type {function(...*):?} */
var _VP8LBackwardReferencesTraceBackwards = Module["_VP8LBackwardReferencesTraceBackwards"] = createExportWrapper("VP8LBackwardReferencesTraceBackwards");

/** @type {function(...*):?} */
var _VP8LRefsCursorInit = Module["_VP8LRefsCursorInit"] = createExportWrapper("VP8LRefsCursorInit");

/** @type {function(...*):?} */
var _VP8LAllocateHistogram = Module["_VP8LAllocateHistogram"] = createExportWrapper("VP8LAllocateHistogram");

/** @type {function(...*):?} */
var _VP8LHistogramInit = Module["_VP8LHistogramInit"] = createExportWrapper("VP8LHistogramInit");

/** @type {function(...*):?} */
var _VP8LDistanceToPlaneCode = Module["_VP8LDistanceToPlaneCode"] = createExportWrapper("VP8LDistanceToPlaneCode");

/** @type {function(...*):?} */
var _VP8LHistogramAddSinglePixOrCopy = Module["_VP8LHistogramAddSinglePixOrCopy"] = createExportWrapper("VP8LHistogramAddSinglePixOrCopy");

/** @type {function(...*):?} */
var _VP8LRefsCursorNextBlock = Module["_VP8LRefsCursorNextBlock"] = createExportWrapper("VP8LRefsCursorNextBlock");

/** @type {function(...*):?} */
var _VP8LFreeHistogram = Module["_VP8LFreeHistogram"] = createExportWrapper("VP8LFreeHistogram");

/** @type {function(...*):?} */
var _VP8LClearBackwardRefs = Module["_VP8LClearBackwardRefs"] = createExportWrapper("VP8LClearBackwardRefs");

/** @type {function(...*):?} */
var _VP8LBackwardRefsCursorAdd = Module["_VP8LBackwardRefsCursorAdd"] = createExportWrapper("VP8LBackwardRefsCursorAdd");

/** @type {function(...*):?} */
var _VP8LBackwardRefsClear = Module["_VP8LBackwardRefsClear"] = createExportWrapper("VP8LBackwardRefsClear");

/** @type {function(...*):?} */
var _VP8LBackwardRefsInit = Module["_VP8LBackwardRefsInit"] = createExportWrapper("VP8LBackwardRefsInit");

/** @type {function(...*):?} */
var _VP8LHashChainInit = Module["_VP8LHashChainInit"] = createExportWrapper("VP8LHashChainInit");

/** @type {function(...*):?} */
var _VP8LHashChainClear = Module["_VP8LHashChainClear"] = createExportWrapper("VP8LHashChainClear");

/** @type {function(...*):?} */
var _VP8LHashChainFill = Module["_VP8LHashChainFill"] = createExportWrapper("VP8LHashChainFill");

/** @type {function(...*):?} */
var _VP8LGetBackwardReferences = Module["_VP8LGetBackwardReferences"] = createExportWrapper("VP8LGetBackwardReferences");

/** @type {function(...*):?} */
var _VP8LHistogramEstimateBits = Module["_VP8LHistogramEstimateBits"] = createExportWrapper("VP8LHistogramEstimateBits");

/** @type {function(...*):?} */
var _VP8LHistogramCreate = Module["_VP8LHistogramCreate"] = createExportWrapper("VP8LHistogramCreate");

/** @type {function(...*):?} */
var _WebPValidateConfig = Module["_WebPValidateConfig"] = createExportWrapper("WebPValidateConfig");

/** @type {function(...*):?} */
var _WebPConfigLosslessPreset = Module["_WebPConfigLosslessPreset"] = createExportWrapper("WebPConfigLosslessPreset");

/** @type {function(...*):?} */
var _VP8CalculateLevelCosts = Module["_VP8CalculateLevelCosts"] = createExportWrapper("VP8CalculateLevelCosts");

/** @type {function(...*):?} */
var _VP8InitResidual = Module["_VP8InitResidual"] = createExportWrapper("VP8InitResidual");

/** @type {function(...*):?} */
var _VP8GetCostLuma4 = Module["_VP8GetCostLuma4"] = createExportWrapper("VP8GetCostLuma4");

/** @type {function(...*):?} */
var _VP8GetCostLuma16 = Module["_VP8GetCostLuma16"] = createExportWrapper("VP8GetCostLuma16");

/** @type {function(...*):?} */
var _VP8IteratorNzToBytes = Module["_VP8IteratorNzToBytes"] = createExportWrapper("VP8IteratorNzToBytes");

/** @type {function(...*):?} */
var _VP8GetCostUV = Module["_VP8GetCostUV"] = createExportWrapper("VP8GetCostUV");

/** @type {function(...*):?} */
var _VP8RecordCoeffs = Module["_VP8RecordCoeffs"] = createExportWrapper("VP8RecordCoeffs");

/** @type {function(...*):?} */
var _VP8FilterStrengthFromDelta = Module["_VP8FilterStrengthFromDelta"] = createExportWrapper("VP8FilterStrengthFromDelta");

/** @type {function(...*):?} */
var _VP8InitFilter = Module["_VP8InitFilter"] = createExportWrapper("VP8InitFilter");

/** @type {function(...*):?} */
var _VP8StoreFilterStats = Module["_VP8StoreFilterStats"] = createExportWrapper("VP8StoreFilterStats");

/** @type {function(...*):?} */
var _VP8AdjustFilterStrength = Module["_VP8AdjustFilterStrength"] = createExportWrapper("VP8AdjustFilterStrength");

/** @type {function(...*):?} */
var _VP8EncLoop = Module["_VP8EncLoop"] = createExportWrapper("VP8EncLoop");

/** @type {function(...*):?} */
var _VP8Decimate = Module["_VP8Decimate"] = createExportWrapper("VP8Decimate");

/** @type {function(...*):?} */
var _VP8IteratorBytesToNz = Module["_VP8IteratorBytesToNz"] = createExportWrapper("VP8IteratorBytesToNz");

/** @type {function(...*):?} */
var _VP8IteratorSaveBoundary = Module["_VP8IteratorSaveBoundary"] = createExportWrapper("VP8IteratorSaveBoundary");

/** @type {function(...*):?} */
var _log10 = Module["_log10"] = createExportWrapper("log10");

/** @type {function(...*):?} */
var _VP8IteratorExport = Module["_VP8IteratorExport"] = createExportWrapper("VP8IteratorExport");

/** @type {function(...*):?} */
var _VP8EncFreeBitWriters = Module["_VP8EncFreeBitWriters"] = createExportWrapper("VP8EncFreeBitWriters");

/** @type {function(...*):?} */
var _WebPEncodingSetError = Module["_WebPEncodingSetError"] = createExportWrapper("WebPEncodingSetError");

/** @type {function(...*):?} */
var _VP8BitWriterFinish = Module["_VP8BitWriterFinish"] = createExportWrapper("VP8BitWriterFinish");

/** @type {function(...*):?} */
var _VP8EncTokenLoop = Module["_VP8EncTokenLoop"] = createExportWrapper("VP8EncTokenLoop");

/** @type {function(...*):?} */
var _VP8TBufferClear = Module["_VP8TBufferClear"] = createExportWrapper("VP8TBufferClear");

/** @type {function(...*):?} */
var _VP8RecordCoeffTokens = Module["_VP8RecordCoeffTokens"] = createExportWrapper("VP8RecordCoeffTokens");

/** @type {function(...*):?} */
var _VP8EstimateTokenSize = Module["_VP8EstimateTokenSize"] = createExportWrapper("VP8EstimateTokenSize");

/** @type {function(...*):?} */
var _VP8EmitTokens = Module["_VP8EmitTokens"] = createExportWrapper("VP8EmitTokens");

/** @type {function(...*):?} */
var _VP8SetSegmentParams = Module["_VP8SetSegmentParams"] = createExportWrapper("VP8SetSegmentParams");

/** @type {function(...*):?} */
var _VP8PutBit = Module["_VP8PutBit"] = createExportWrapper("VP8PutBit");

/** @type {function(...*):?} */
var _VP8PutBitUniform = Module["_VP8PutBitUniform"] = createExportWrapper("VP8PutBitUniform");

/** @type {function(...*):?} */
var _VP8LGetHistogramSize = Module["_VP8LGetHistogramSize"] = createExportWrapper("VP8LGetHistogramSize");

/** @type {function(...*):?} */
var _VP8LFreeHistogramSet = Module["_VP8LFreeHistogramSet"] = createExportWrapper("VP8LFreeHistogramSet");

/** @type {function(...*):?} */
var _VP8LHistogramStoreRefs = Module["_VP8LHistogramStoreRefs"] = createExportWrapper("VP8LHistogramStoreRefs");

/** @type {function(...*):?} */
var _VP8LAllocateHistogramSet = Module["_VP8LAllocateHistogramSet"] = createExportWrapper("VP8LAllocateHistogramSet");

/** @type {function(...*):?} */
var _VP8LHistogramSetClear = Module["_VP8LHistogramSetClear"] = createExportWrapper("VP8LHistogramSetClear");

/** @type {function(...*):?} */
var _VP8LBitsEntropy = Module["_VP8LBitsEntropy"] = createExportWrapper("VP8LBitsEntropy");

/** @type {function(...*):?} */
var _VP8LGetHistoImageSymbols = Module["_VP8LGetHistoImageSymbols"] = createExportWrapper("VP8LGetHistoImageSymbols");

/** @type {function(...*):?} */
var _bsearch = Module["_bsearch"] = createExportWrapper("bsearch");

/** @type {function(...*):?} */
var _VP8IteratorReset = Module["_VP8IteratorReset"] = createExportWrapper("VP8IteratorReset");

/** @type {function(...*):?} */
var _VP8IteratorStartI4 = Module["_VP8IteratorStartI4"] = createExportWrapper("VP8IteratorStartI4");

/** @type {function(...*):?} */
var _VP8IteratorRotateI4 = Module["_VP8IteratorRotateI4"] = createExportWrapper("VP8IteratorRotateI4");

/** @type {function(...*):?} */
var _VP8ApplyNearLossless = Module["_VP8ApplyNearLossless"] = createExportWrapper("VP8ApplyNearLossless");

/** @type {function(...*):?} */
var _WebPPictureARGBToYUVADithered = Module["_WebPPictureARGBToYUVADithered"] = createExportWrapper("WebPPictureARGBToYUVADithered");

/** @type {function(...*):?} */
var _WebPPictureARGBToYUVA = Module["_WebPPictureARGBToYUVA"] = createExportWrapper("WebPPictureARGBToYUVA");

/** @type {function(...*):?} */
var _WebPPictureSharpARGBToYUVA = Module["_WebPPictureSharpARGBToYUVA"] = createExportWrapper("WebPPictureSharpARGBToYUVA");

/** @type {function(...*):?} */
var _WebPPictureSmartARGBToYUVA = Module["_WebPPictureSmartARGBToYUVA"] = createExportWrapper("WebPPictureSmartARGBToYUVA");

/** @type {function(...*):?} */
var _WebPPictureYUVAToARGB = Module["_WebPPictureYUVAToARGB"] = createExportWrapper("WebPPictureYUVAToARGB");

/** @type {function(...*):?} */
var _WebPPictureAllocARGB = Module["_WebPPictureAllocARGB"] = createExportWrapper("WebPPictureAllocARGB");

/** @type {function(...*):?} */
var _WebPPictureImportBGR = Module["_WebPPictureImportBGR"] = createExportWrapper("WebPPictureImportBGR");

/** @type {function(...*):?} */
var _WebPPictureImportBGRA = Module["_WebPPictureImportBGRA"] = createExportWrapper("WebPPictureImportBGRA");

/** @type {function(...*):?} */
var _WebPPictureImportBGRX = Module["_WebPPictureImportBGRX"] = createExportWrapper("WebPPictureImportBGRX");

/** @type {function(...*):?} */
var _WebPPictureImportRGBX = Module["_WebPPictureImportRGBX"] = createExportWrapper("WebPPictureImportRGBX");

/** @type {function(...*):?} */
var _WebPPictureAllocYUVA = Module["_WebPPictureAllocYUVA"] = createExportWrapper("WebPPictureAllocYUVA");

/** @type {function(...*):?} */
var _pow = Module["_pow"] = createExportWrapper("pow");

/** @type {function(...*):?} */
var _WebPPictureResetBuffers = Module["_WebPPictureResetBuffers"] = createExportWrapper("WebPPictureResetBuffers");

/** @type {function(...*):?} */
var _WebPMemoryWriterInit = Module["_WebPMemoryWriterInit"] = createExportWrapper("WebPMemoryWriterInit");

/** @type {function(...*):?} */
var _WebPMemoryWrite = Module["_WebPMemoryWrite"] = createExportWrapper("WebPMemoryWrite");

/** @type {function(...*):?} */
var _WebPMemoryWriterClear = Module["_WebPMemoryWriterClear"] = createExportWrapper("WebPMemoryWriterClear");

/** @type {function(...*):?} */
var _WebPEncodeRGB = Module["_WebPEncodeRGB"] = createExportWrapper("WebPEncodeRGB");

/** @type {function(...*):?} */
var _WebPEncode = Module["_WebPEncode"] = createExportWrapper("WebPEncode");

/** @type {function(...*):?} */
var _WebPEncodeRGBA = Module["_WebPEncodeRGBA"] = createExportWrapper("WebPEncodeRGBA");

/** @type {function(...*):?} */
var _WebPEncodeBGR = Module["_WebPEncodeBGR"] = createExportWrapper("WebPEncodeBGR");

/** @type {function(...*):?} */
var _WebPEncodeBGRA = Module["_WebPEncodeBGRA"] = createExportWrapper("WebPEncodeBGRA");

/** @type {function(...*):?} */
var _WebPEncodeLosslessRGB = Module["_WebPEncodeLosslessRGB"] = createExportWrapper("WebPEncodeLosslessRGB");

/** @type {function(...*):?} */
var _WebPEncodeLosslessRGBA = Module["_WebPEncodeLosslessRGBA"] = createExportWrapper("WebPEncodeLosslessRGBA");

/** @type {function(...*):?} */
var _WebPEncodeLosslessBGR = Module["_WebPEncodeLosslessBGR"] = createExportWrapper("WebPEncodeLosslessBGR");

/** @type {function(...*):?} */
var _WebPEncodeLosslessBGRA = Module["_WebPEncodeLosslessBGRA"] = createExportWrapper("WebPEncodeLosslessBGRA");

/** @type {function(...*):?} */
var _WebPPlaneDistortion = Module["_WebPPlaneDistortion"] = createExportWrapper("WebPPlaneDistortion");

/** @type {function(...*):?} */
var _WebPPictureDistortion = Module["_WebPPictureDistortion"] = createExportWrapper("WebPPictureDistortion");

/** @type {function(...*):?} */
var _WebPPictureView = Module["_WebPPictureView"] = createExportWrapper("WebPPictureView");

/** @type {function(...*):?} */
var _WebPPictureCopy = Module["_WebPPictureCopy"] = createExportWrapper("WebPPictureCopy");

/** @type {function(...*):?} */
var _WebPPictureIsView = Module["_WebPPictureIsView"] = createExportWrapper("WebPPictureIsView");

/** @type {function(...*):?} */
var _WebPPictureCrop = Module["_WebPPictureCrop"] = createExportWrapper("WebPPictureCrop");

/** @type {function(...*):?} */
var _WebPPictureRescale = Module["_WebPPictureRescale"] = createExportWrapper("WebPPictureRescale");

/** @type {function(...*):?} */
var _WebPCleanupTransparentArea = Module["_WebPCleanupTransparentArea"] = createExportWrapper("WebPCleanupTransparentArea");

/** @type {function(...*):?} */
var _WebPCleanupTransparentAreaLossless = Module["_WebPCleanupTransparentAreaLossless"] = createExportWrapper("WebPCleanupTransparentAreaLossless");

/** @type {function(...*):?} */
var _WebPBlendAlpha = Module["_WebPBlendAlpha"] = createExportWrapper("WebPBlendAlpha");

/** @type {function(...*):?} */
var _VP8LResidualImage = Module["_VP8LResidualImage"] = createExportWrapper("VP8LResidualImage");

/** @type {function(...*):?} */
var _VP8LColorSpaceTransform = Module["_VP8LColorSpaceTransform"] = createExportWrapper("VP8LColorSpaceTransform");

/** @type {function(...*):?} */
var _VP8MakeIntra4Preds = Module["_VP8MakeIntra4Preds"] = createExportWrapper("VP8MakeIntra4Preds");

/** @type {function(...*):?} */
var _VP8EncWrite = Module["_VP8EncWrite"] = createExportWrapper("VP8EncWrite");

/** @type {function(...*):?} */
var _VP8PutSignedBits = Module["_VP8PutSignedBits"] = createExportWrapper("VP8PutSignedBits");

/** @type {function(...*):?} */
var _VP8PutBits = Module["_VP8PutBits"] = createExportWrapper("VP8PutBits");

/** @type {function(...*):?} */
var _VP8WriteProbas = Module["_VP8WriteProbas"] = createExportWrapper("VP8WriteProbas");

/** @type {function(...*):?} */
var _VP8CodeIntraModes = Module["_VP8CodeIntraModes"] = createExportWrapper("VP8CodeIntraModes");

/** @type {function(...*):?} */
var _VP8TBufferInit = Module["_VP8TBufferInit"] = createExportWrapper("VP8TBufferInit");

/** @type {function(...*):?} */
var _VP8DefaultProbas = Module["_VP8DefaultProbas"] = createExportWrapper("VP8DefaultProbas");

/** @type {function(...*):?} */
var _WebPGetColorPalette = Module["_WebPGetColorPalette"] = createExportWrapper("WebPGetColorPalette");

/** @type {function(...*):?} */
var _qsort = Module["_qsort"] = createExportWrapper("qsort");

/** @type {function(...*):?} */
var _VP8LBitWriterClone = Module["_VP8LBitWriterClone"] = createExportWrapper("VP8LBitWriterClone");

/** @type {function(...*):?} */
var _VP8LBitWriterSwap = Module["_VP8LBitWriterSwap"] = createExportWrapper("VP8LBitWriterSwap");

/** @type {function(...*):?} */
var _VP8LPutBitsInternal = Module["_VP8LPutBitsInternal"] = createExportWrapper("VP8LPutBitsInternal");

/** @type {function(...*):?} */
var _VP8LBitWriterReset = Module["_VP8LBitWriterReset"] = createExportWrapper("VP8LBitWriterReset");

/** @type {function(...*):?} */
var _VP8LEncodeImage = Module["_VP8LEncodeImage"] = createExportWrapper("VP8LEncodeImage");

/** @type {function(...*):?} */
var _VP8LCreateHuffmanTree = Module["_VP8LCreateHuffmanTree"] = createExportWrapper("VP8LCreateHuffmanTree");

/** @type {function(...*):?} */
var _VP8LCreateCompressedHuffmanTree = Module["_VP8LCreateCompressedHuffmanTree"] = createExportWrapper("VP8LCreateCompressedHuffmanTree");

/** @type {function(...*):?} */
var _WebPGetEncoderVersion = Module["_WebPGetEncoderVersion"] = createExportWrapper("WebPGetEncoderVersion");

/** @type {function(...*):?} */
var _WebPAnimEncoderOptionsInitInternal = Module["_WebPAnimEncoderOptionsInitInternal"] = createExportWrapper("WebPAnimEncoderOptionsInitInternal");

/** @type {function(...*):?} */
var _WebPAnimEncoderNewInternal = Module["_WebPAnimEncoderNewInternal"] = createExportWrapper("WebPAnimEncoderNewInternal");

/** @type {function(...*):?} */
var _WebPNewInternal = Module["_WebPNewInternal"] = createExportWrapper("WebPNewInternal");

/** @type {function(...*):?} */
var _WebPAnimEncoderDelete = Module["_WebPAnimEncoderDelete"] = createExportWrapper("WebPAnimEncoderDelete");

/** @type {function(...*):?} */
var _WebPFree = Module["_WebPFree"] = createExportWrapper("WebPFree");

/** @type {function(...*):?} */
var _WebPMuxDelete = Module["_WebPMuxDelete"] = createExportWrapper("WebPMuxDelete");

/** @type {function(...*):?} */
var _WebPAnimEncoderRefineRect = Module["_WebPAnimEncoderRefineRect"] = createExportWrapper("WebPAnimEncoderRefineRect");

/** @type {function(...*):?} */
var _WebPAnimEncoderAdd = Module["_WebPAnimEncoderAdd"] = createExportWrapper("WebPAnimEncoderAdd");

/** @type {function(...*):?} */
var _snprintf = Module["_snprintf"] = createExportWrapper("snprintf");

/** @type {function(...*):?} */
var _WebPCopyPixels = Module["_WebPCopyPixels"] = createExportWrapper("WebPCopyPixels");

/** @type {function(...*):?} */
var _WebPMalloc = Module["_WebPMalloc"] = createExportWrapper("WebPMalloc");

/** @type {function(...*):?} */
var _WebPMuxPushFrame = Module["_WebPMuxPushFrame"] = createExportWrapper("WebPMuxPushFrame");

/** @type {function(...*):?} */
var _WebPAnimEncoderAssemble = Module["_WebPAnimEncoderAssemble"] = createExportWrapper("WebPAnimEncoderAssemble");

/** @type {function(...*):?} */
var _WebPMuxSetCanvasSize = Module["_WebPMuxSetCanvasSize"] = createExportWrapper("WebPMuxSetCanvasSize");

/** @type {function(...*):?} */
var _WebPMuxSetAnimationParams = Module["_WebPMuxSetAnimationParams"] = createExportWrapper("WebPMuxSetAnimationParams");

/** @type {function(...*):?} */
var _WebPMuxAssemble = Module["_WebPMuxAssemble"] = createExportWrapper("WebPMuxAssemble");

/** @type {function(...*):?} */
var _WebPMuxCreateInternal = Module["_WebPMuxCreateInternal"] = createExportWrapper("WebPMuxCreateInternal");

/** @type {function(...*):?} */
var _WebPMuxGetFrame = Module["_WebPMuxGetFrame"] = createExportWrapper("WebPMuxGetFrame");

/** @type {function(...*):?} */
var _WebPMuxGetCanvasSize = Module["_WebPMuxGetCanvasSize"] = createExportWrapper("WebPMuxGetCanvasSize");

/** @type {function(...*):?} */
var _WebPMuxSetImage = Module["_WebPMuxSetImage"] = createExportWrapper("WebPMuxSetImage");

/** @type {function(...*):?} */
var _WebPAnimEncoderGetError = Module["_WebPAnimEncoderGetError"] = createExportWrapper("WebPAnimEncoderGetError");

/** @type {function(...*):?} */
var _MuxImageDelete = Module["_MuxImageDelete"] = createExportWrapper("MuxImageDelete");

/** @type {function(...*):?} */
var _ChunkListDelete = Module["_ChunkListDelete"] = createExportWrapper("ChunkListDelete");

/** @type {function(...*):?} */
var _WebPMuxSetChunk = Module["_WebPMuxSetChunk"] = createExportWrapper("WebPMuxSetChunk");

/** @type {function(...*):?} */
var _ChunkGetTagFromFourCC = Module["_ChunkGetTagFromFourCC"] = createExportWrapper("ChunkGetTagFromFourCC");

/** @type {function(...*):?} */
var _ChunkGetIdFromTag = Module["_ChunkGetIdFromTag"] = createExportWrapper("ChunkGetIdFromTag");

/** @type {function(...*):?} */
var _MuxGetChunkListFromId = Module["_MuxGetChunkListFromId"] = createExportWrapper("MuxGetChunkListFromId");

/** @type {function(...*):?} */
var _ChunkDelete = Module["_ChunkDelete"] = createExportWrapper("ChunkDelete");

/** @type {function(...*):?} */
var _ChunkGetIndexFromTag = Module["_ChunkGetIndexFromTag"] = createExportWrapper("ChunkGetIndexFromTag");

/** @type {function(...*):?} */
var _ChunkInit = Module["_ChunkInit"] = createExportWrapper("ChunkInit");

/** @type {function(...*):?} */
var _ChunkAssignData = Module["_ChunkAssignData"] = createExportWrapper("ChunkAssignData");

/** @type {function(...*):?} */
var _ChunkSetHead = Module["_ChunkSetHead"] = createExportWrapper("ChunkSetHead");

/** @type {function(...*):?} */
var _MuxImageInit = Module["_MuxImageInit"] = createExportWrapper("MuxImageInit");

/** @type {function(...*):?} */
var _MuxImagePush = Module["_MuxImagePush"] = createExportWrapper("MuxImagePush");

/** @type {function(...*):?} */
var _MuxImageRelease = Module["_MuxImageRelease"] = createExportWrapper("MuxImageRelease");

/** @type {function(...*):?} */
var _ChunkRelease = Module["_ChunkRelease"] = createExportWrapper("ChunkRelease");

/** @type {function(...*):?} */
var _MuxImageFinalize = Module["_MuxImageFinalize"] = createExportWrapper("MuxImageFinalize");

/** @type {function(...*):?} */
var _WebPMuxDeleteChunk = Module["_WebPMuxDeleteChunk"] = createExportWrapper("WebPMuxDeleteChunk");

/** @type {function(...*):?} */
var _WebPMuxDeleteFrame = Module["_WebPMuxDeleteFrame"] = createExportWrapper("WebPMuxDeleteFrame");

/** @type {function(...*):?} */
var _MuxImageDeleteNth = Module["_MuxImageDeleteNth"] = createExportWrapper("MuxImageDeleteNth");

/** @type {function(...*):?} */
var _WebPMuxNumChunks = Module["_WebPMuxNumChunks"] = createExportWrapper("WebPMuxNumChunks");

/** @type {function(...*):?} */
var _MuxImageGetNth = Module["_MuxImageGetNth"] = createExportWrapper("MuxImageGetNth");

/** @type {function(...*):?} */
var _MuxImageCount = Module["_MuxImageCount"] = createExportWrapper("MuxImageCount");

/** @type {function(...*):?} */
var _MuxHasAlpha = Module["_MuxHasAlpha"] = createExportWrapper("MuxHasAlpha");

/** @type {function(...*):?} */
var _ChunkListDiskSize = Module["_ChunkListDiskSize"] = createExportWrapper("ChunkListDiskSize");

/** @type {function(...*):?} */
var _MuxImageDiskSize = Module["_MuxImageDiskSize"] = createExportWrapper("MuxImageDiskSize");

/** @type {function(...*):?} */
var _MuxEmitRiffHeader = Module["_MuxEmitRiffHeader"] = createExportWrapper("MuxEmitRiffHeader");

/** @type {function(...*):?} */
var _ChunkListEmit = Module["_ChunkListEmit"] = createExportWrapper("ChunkListEmit");

/** @type {function(...*):?} */
var _MuxImageEmit = Module["_MuxImageEmit"] = createExportWrapper("MuxImageEmit");

/** @type {function(...*):?} */
var _MuxValidate = Module["_MuxValidate"] = createExportWrapper("MuxValidate");

/** @type {function(...*):?} */
var _WebPGetMuxVersion = Module["_WebPGetMuxVersion"] = createExportWrapper("WebPGetMuxVersion");

/** @type {function(...*):?} */
var _ChunkGetIndexFromFourCC = Module["_ChunkGetIndexFromFourCC"] = createExportWrapper("ChunkGetIndexFromFourCC");

/** @type {function(...*):?} */
var _ChunkSearchList = Module["_ChunkSearchList"] = createExportWrapper("ChunkSearchList");

/** @type {function(...*):?} */
var _ChunkAppend = Module["_ChunkAppend"] = createExportWrapper("ChunkAppend");

/** @type {function(...*):?} */
var _WebPMuxGetFeatures = Module["_WebPMuxGetFeatures"] = createExportWrapper("WebPMuxGetFeatures");

/** @type {function(...*):?} */
var _WebPMuxGetChunk = Module["_WebPMuxGetChunk"] = createExportWrapper("WebPMuxGetChunk");

/** @type {function(...*):?} */
var _WebPMuxGetAnimationParams = Module["_WebPMuxGetAnimationParams"] = createExportWrapper("WebPMuxGetAnimationParams");

/** @type {function(...*):?} */
var _VP8LPutBitsFlushBits = Module["_VP8LPutBitsFlushBits"] = createExportWrapper("VP8LPutBitsFlushBits");

/** @type {function(...*):?} */
var _WebPSetWorkerInterface = Module["_WebPSetWorkerInterface"] = createExportWrapper("WebPSetWorkerInterface");

/** @type {function(...*):?} */
var _sizeof_size_t = Module["_sizeof_size_t"] = createExportWrapper("sizeof_size_t");

/** @type {function(...*):?} */
var _sizeof_int = Module["_sizeof_int"] = createExportWrapper("sizeof_int");

/** @type {function(...*):?} */
var _decodeWebP = Module["_decodeWebP"] = createExportWrapper("decodeWebP");

/** @type {function(...*):?} */
var _decodeFrames = Module["_decodeFrames"] = createExportWrapper("decodeFrames");

/** @type {function(...*):?} */
var _encodeWebP = Module["_encodeWebP"] = createExportWrapper("encodeWebP");

/** @type {function(...*):?} */
var _setFrameParam = Module["_setFrameParam"] = createExportWrapper("setFrameParam");

/** @type {function(...*):?} */
var _encodeFrames = Module["_encodeFrames"] = createExportWrapper("encodeFrames");

/** @type {function(...*):?} */
var ___synccall = Module["___synccall"] = createExportWrapper("__synccall");

/** @type {function(...*):?} */
var _aligned_alloc = Module["_aligned_alloc"] = createExportWrapper("aligned_alloc");

/** @type {function(...*):?} */
var _posix_memalign = Module["_posix_memalign"] = createExportWrapper("posix_memalign");

/** @type {function(...*):?} */
var _strlwr = Module["_strlwr"] = createExportWrapper("strlwr");

/** @type {function(...*):?} */
var _tolower = Module["_tolower"] = createExportWrapper("tolower");

/** @type {function(...*):?} */
var _strtoull_l = Module["_strtoull_l"] = createExportWrapper("strtoull_l");

/** @type {function(...*):?} */
var _strtoull = Module["_strtoull"] = createExportWrapper("strtoull");

/** @type {function(...*):?} */
var _strtoll_l = Module["_strtoll_l"] = createExportWrapper("strtoll_l");

/** @type {function(...*):?} */
var _strtoll = Module["_strtoll"] = createExportWrapper("strtoll");

/** @type {function(...*):?} */
var _strtoul_l = Module["_strtoul_l"] = createExportWrapper("strtoul_l");

/** @type {function(...*):?} */
var _strtoul = Module["_strtoul"] = createExportWrapper("strtoul");

/** @type {function(...*):?} */
var _strtol_l = Module["_strtol_l"] = createExportWrapper("strtol_l");

/** @type {function(...*):?} */
var _strtol = Module["_strtol"] = createExportWrapper("strtol");

/** @type {function(...*):?} */
var _strupr = Module["_strupr"] = createExportWrapper("strupr");

/** @type {function(...*):?} */
var _toupper = Module["_toupper"] = createExportWrapper("toupper");

/** @type {function(...*):?} */
var ___ldexp_cexp = Module["___ldexp_cexp"] = createExportWrapper("__ldexp_cexp");

/** @type {function(...*):?} */
var _cos = Module["_cos"] = createExportWrapper("cos");

/** @type {function(...*):?} */
var _sin = Module["_sin"] = createExportWrapper("sin");

/** @type {function(...*):?} */
var _exp = Module["_exp"] = createExportWrapper("exp");

/** @type {function(...*):?} */
var ___ldexp_cexpf = Module["___ldexp_cexpf"] = createExportWrapper("__ldexp_cexpf");

/** @type {function(...*):?} */
var _cosf = Module["_cosf"] = createExportWrapper("cosf");

/** @type {function(...*):?} */
var _sinf = Module["_sinf"] = createExportWrapper("sinf");

/** @type {function(...*):?} */
var _expf = Module["_expf"] = createExportWrapper("expf");

/** @type {function(...*):?} */
var _cabs = Module["_cabs"] = createExportWrapper("cabs");

/** @type {function(...*):?} */
var _hypot = Module["_hypot"] = createExportWrapper("hypot");

/** @type {function(...*):?} */
var _cabsf = Module["_cabsf"] = createExportWrapper("cabsf");

/** @type {function(...*):?} */
var _hypotf = Module["_hypotf"] = createExportWrapper("hypotf");

/** @type {function(...*):?} */
var _cabsl = Module["_cabsl"] = createExportWrapper("cabsl");

/** @type {function(...*):?} */
var _hypotl = Module["_hypotl"] = createExportWrapper("hypotl");

/** @type {function(...*):?} */
var _cacos = Module["_cacos"] = createExportWrapper("cacos");

/** @type {function(...*):?} */
var _casin = Module["_casin"] = createExportWrapper("casin");

/** @type {function(...*):?} */
var _cacosf = Module["_cacosf"] = createExportWrapper("cacosf");

/** @type {function(...*):?} */
var _casinf = Module["_casinf"] = createExportWrapper("casinf");

/** @type {function(...*):?} */
var _cacosh = Module["_cacosh"] = createExportWrapper("cacosh");

/** @type {function(...*):?} */
var _cacoshf = Module["_cacoshf"] = createExportWrapper("cacoshf");

/** @type {function(...*):?} */
var _cacoshl = Module["_cacoshl"] = createExportWrapper("cacoshl");

/** @type {function(...*):?} */
var _cacosl = Module["_cacosl"] = createExportWrapper("cacosl");

/** @type {function(...*):?} */
var _casinl = Module["_casinl"] = createExportWrapper("casinl");

/** @type {function(...*):?} */
var ___subtf3 = Module["___subtf3"] = createExportWrapper("__subtf3");

/** @type {function(...*):?} */
var _carg = Module["_carg"] = createExportWrapper("carg");

/** @type {function(...*):?} */
var _atan2 = Module["_atan2"] = createExportWrapper("atan2");

/** @type {function(...*):?} */
var _cargf = Module["_cargf"] = createExportWrapper("cargf");

/** @type {function(...*):?} */
var _atan2f = Module["_atan2f"] = createExportWrapper("atan2f");

/** @type {function(...*):?} */
var _cargl = Module["_cargl"] = createExportWrapper("cargl");

/** @type {function(...*):?} */
var _atan2l = Module["_atan2l"] = createExportWrapper("atan2l");

/** @type {function(...*):?} */
var _csqrt = Module["_csqrt"] = createExportWrapper("csqrt");

/** @type {function(...*):?} */
var _clog = Module["_clog"] = createExportWrapper("clog");

/** @type {function(...*):?} */
var _csqrtf = Module["_csqrtf"] = createExportWrapper("csqrtf");

/** @type {function(...*):?} */
var _clogf = Module["_clogf"] = createExportWrapper("clogf");

/** @type {function(...*):?} */
var _casinh = Module["_casinh"] = createExportWrapper("casinh");

/** @type {function(...*):?} */
var _casinhf = Module["_casinhf"] = createExportWrapper("casinhf");

/** @type {function(...*):?} */
var _casinhl = Module["_casinhl"] = createExportWrapper("casinhl");

/** @type {function(...*):?} */
var ___addtf3 = Module["___addtf3"] = createExportWrapper("__addtf3");

/** @type {function(...*):?} */
var ___multf3 = Module["___multf3"] = createExportWrapper("__multf3");

/** @type {function(...*):?} */
var _csqrtl = Module["_csqrtl"] = createExportWrapper("csqrtl");

/** @type {function(...*):?} */
var _clogl = Module["_clogl"] = createExportWrapper("clogl");

/** @type {function(...*):?} */
var _catan = Module["_catan"] = createExportWrapper("catan");

/** @type {function(...*):?} */
var _catanf = Module["_catanf"] = createExportWrapper("catanf");

/** @type {function(...*):?} */
var _logf = Module["_logf"] = createExportWrapper("logf");

/** @type {function(...*):?} */
var _catanh = Module["_catanh"] = createExportWrapper("catanh");

/** @type {function(...*):?} */
var _catanhf = Module["_catanhf"] = createExportWrapper("catanhf");

/** @type {function(...*):?} */
var _catanhl = Module["_catanhl"] = createExportWrapper("catanhl");

/** @type {function(...*):?} */
var _catanl = Module["_catanl"] = createExportWrapper("catanl");

/** @type {function(...*):?} */
var ___netf2 = Module["___netf2"] = createExportWrapper("__netf2");

/** @type {function(...*):?} */
var ___gttf2 = Module["___gttf2"] = createExportWrapper("__gttf2");

/** @type {function(...*):?} */
var ___eqtf2 = Module["___eqtf2"] = createExportWrapper("__eqtf2");

/** @type {function(...*):?} */
var ___divtf3 = Module["___divtf3"] = createExportWrapper("__divtf3");

/** @type {function(...*):?} */
var _logl = Module["_logl"] = createExportWrapper("logl");

/** @type {function(...*):?} */
var ___getf2 = Module["___getf2"] = createExportWrapper("__getf2");

/** @type {function(...*):?} */
var ___fixtfsi = Module["___fixtfsi"] = createExportWrapper("__fixtfsi");

/** @type {function(...*):?} */
var ___floatsitf = Module["___floatsitf"] = createExportWrapper("__floatsitf");

/** @type {function(...*):?} */
var _ccos = Module["_ccos"] = createExportWrapper("ccos");

/** @type {function(...*):?} */
var _ccosh = Module["_ccosh"] = createExportWrapper("ccosh");

/** @type {function(...*):?} */
var _ccosf = Module["_ccosf"] = createExportWrapper("ccosf");

/** @type {function(...*):?} */
var _ccoshf = Module["_ccoshf"] = createExportWrapper("ccoshf");

/** @type {function(...*):?} */
var _cosh = Module["_cosh"] = createExportWrapper("cosh");

/** @type {function(...*):?} */
var _sinh = Module["_sinh"] = createExportWrapper("sinh");

/** @type {function(...*):?} */
var _fabs = Module["_fabs"] = createExportWrapper("fabs");

/** @type {function(...*):?} */
var _copysign = Module["_copysign"] = createExportWrapper("copysign");

/** @type {function(...*):?} */
var _coshf = Module["_coshf"] = createExportWrapper("coshf");

/** @type {function(...*):?} */
var _sinhf = Module["_sinhf"] = createExportWrapper("sinhf");

/** @type {function(...*):?} */
var _fabsf = Module["_fabsf"] = createExportWrapper("fabsf");

/** @type {function(...*):?} */
var _copysignf = Module["_copysignf"] = createExportWrapper("copysignf");

/** @type {function(...*):?} */
var _ccoshl = Module["_ccoshl"] = createExportWrapper("ccoshl");

/** @type {function(...*):?} */
var ___trunctfdf2 = Module["___trunctfdf2"] = createExportWrapper("__trunctfdf2");

/** @type {function(...*):?} */
var ___extenddftf2 = Module["___extenddftf2"] = createExportWrapper("__extenddftf2");

/** @type {function(...*):?} */
var _ccosl = Module["_ccosl"] = createExportWrapper("ccosl");

/** @type {function(...*):?} */
var _cexp = Module["_cexp"] = createExportWrapper("cexp");

/** @type {function(...*):?} */
var _cexpf = Module["_cexpf"] = createExportWrapper("cexpf");

/** @type {function(...*):?} */
var _cexpl = Module["_cexpl"] = createExportWrapper("cexpl");

/** @type {function(...*):?} */
var _cimag = Module["_cimag"] = createExportWrapper("cimag");

/** @type {function(...*):?} */
var _cimagf = Module["_cimagf"] = createExportWrapper("cimagf");

/** @type {function(...*):?} */
var _cimagl = Module["_cimagl"] = createExportWrapper("cimagl");

/** @type {function(...*):?} */
var _conj = Module["_conj"] = createExportWrapper("conj");

/** @type {function(...*):?} */
var _conjf = Module["_conjf"] = createExportWrapper("conjf");

/** @type {function(...*):?} */
var _conjl = Module["_conjl"] = createExportWrapper("conjl");

/** @type {function(...*):?} */
var _cpow = Module["_cpow"] = createExportWrapper("cpow");

/** @type {function(...*):?} */
var ___muldc3 = Module["___muldc3"] = createExportWrapper("__muldc3");

/** @type {function(...*):?} */
var _cpowf = Module["_cpowf"] = createExportWrapper("cpowf");

/** @type {function(...*):?} */
var ___mulsc3 = Module["___mulsc3"] = createExportWrapper("__mulsc3");

/** @type {function(...*):?} */
var _cpowl = Module["_cpowl"] = createExportWrapper("cpowl");

/** @type {function(...*):?} */
var ___unordtf2 = Module["___unordtf2"] = createExportWrapper("__unordtf2");

/** @type {function(...*):?} */
var ___multc3 = Module["___multc3"] = createExportWrapper("__multc3");

/** @type {function(...*):?} */
var _cproj = Module["_cproj"] = createExportWrapper("cproj");

/** @type {function(...*):?} */
var _cprojf = Module["_cprojf"] = createExportWrapper("cprojf");

/** @type {function(...*):?} */
var _cprojl = Module["_cprojl"] = createExportWrapper("cprojl");

/** @type {function(...*):?} */
var ___fpclassifyl = Module["___fpclassifyl"] = createExportWrapper("__fpclassifyl");

/** @type {function(...*):?} */
var _copysignl = Module["_copysignl"] = createExportWrapper("copysignl");

/** @type {function(...*):?} */
var _creal = Module["_creal"] = createExportWrapper("creal");

/** @type {function(...*):?} */
var _crealf = Module["_crealf"] = createExportWrapper("crealf");

/** @type {function(...*):?} */
var _creall = Module["_creall"] = createExportWrapper("creall");

/** @type {function(...*):?} */
var _csin = Module["_csin"] = createExportWrapper("csin");

/** @type {function(...*):?} */
var _csinh = Module["_csinh"] = createExportWrapper("csinh");

/** @type {function(...*):?} */
var _csinf = Module["_csinf"] = createExportWrapper("csinf");

/** @type {function(...*):?} */
var _csinhf = Module["_csinhf"] = createExportWrapper("csinhf");

/** @type {function(...*):?} */
var _csinhl = Module["_csinhl"] = createExportWrapper("csinhl");

/** @type {function(...*):?} */
var _csinl = Module["_csinl"] = createExportWrapper("csinl");

/** @type {function(...*):?} */
var _sqrt = Module["_sqrt"] = createExportWrapper("sqrt");

/** @type {function(...*):?} */
var _ctan = Module["_ctan"] = createExportWrapper("ctan");

/** @type {function(...*):?} */
var _ctanh = Module["_ctanh"] = createExportWrapper("ctanh");

/** @type {function(...*):?} */
var _ctanf = Module["_ctanf"] = createExportWrapper("ctanf");

/** @type {function(...*):?} */
var _ctanhf = Module["_ctanhf"] = createExportWrapper("ctanhf");

/** @type {function(...*):?} */
var _tan = Module["_tan"] = createExportWrapper("tan");

/** @type {function(...*):?} */
var _tanf = Module["_tanf"] = createExportWrapper("tanf");

/** @type {function(...*):?} */
var _sqrtf = Module["_sqrtf"] = createExportWrapper("sqrtf");

/** @type {function(...*):?} */
var _ctanhl = Module["_ctanhl"] = createExportWrapper("ctanhl");

/** @type {function(...*):?} */
var _ctanl = Module["_ctanl"] = createExportWrapper("ctanl");

/** @type {function(...*):?} */
var _crypt = Module["_crypt"] = createExportWrapper("crypt");

/** @type {function(...*):?} */
var ___crypt_r = Module["___crypt_r"] = createExportWrapper("__crypt_r");

/** @type {function(...*):?} */
var ___crypt_blowfish = Module["___crypt_blowfish"] = createExportWrapper("__crypt_blowfish");

/** @type {function(...*):?} */
var ___des_setkey = Module["___des_setkey"] = createExportWrapper("__des_setkey");

/** @type {function(...*):?} */
var ___do_des = Module["___do_des"] = createExportWrapper("__do_des");

/** @type {function(...*):?} */
var ___crypt_des = Module["___crypt_des"] = createExportWrapper("__crypt_des");

/** @type {function(...*):?} */
var ___crypt_md5 = Module["___crypt_md5"] = createExportWrapper("__crypt_md5");

/** @type {function(...*):?} */
var _strnlen = Module["_strnlen"] = createExportWrapper("strnlen");

/** @type {function(...*):?} */
var _strncmp = Module["_strncmp"] = createExportWrapper("strncmp");

/** @type {function(...*):?} */
var ___crypt_sha256 = Module["___crypt_sha256"] = createExportWrapper("__crypt_sha256");

/** @type {function(...*):?} */
var ___crypt_sha512 = Module["___crypt_sha512"] = createExportWrapper("__crypt_sha512");

/** @type {function(...*):?} */
var _crypt_r = Module["_crypt_r"] = createExportWrapper("crypt_r");

/** @type {function(...*):?} */
var _isdigit = Module["_isdigit"] = createExportWrapper("isdigit");

/** @type {function(...*):?} */
var _sprintf = Module["_sprintf"] = createExportWrapper("sprintf");

/** @type {function(...*):?} */
var _setkey = Module["_setkey"] = createExportWrapper("setkey");

/** @type {function(...*):?} */
var _encrypt = Module["_encrypt"] = createExportWrapper("encrypt");

/** @type {function(...*):?} */
var ___ctype_b_loc = Module["___ctype_b_loc"] = createExportWrapper("__ctype_b_loc");

/** @type {function(...*):?} */
var ___ctype_get_mb_cur_max = Module["___ctype_get_mb_cur_max"] = createExportWrapper("__ctype_get_mb_cur_max");

/** @type {function(...*):?} */
var _pthread_self = Module["_pthread_self"] = createExportWrapper("pthread_self");

/** @type {function(...*):?} */
var ___ctype_tolower_loc = Module["___ctype_tolower_loc"] = createExportWrapper("__ctype_tolower_loc");

/** @type {function(...*):?} */
var ___ctype_toupper_loc = Module["___ctype_toupper_loc"] = createExportWrapper("__ctype_toupper_loc");

/** @type {function(...*):?} */
var _isalnum = Module["_isalnum"] = createExportWrapper("isalnum");

/** @type {function(...*):?} */
var _isalpha = Module["_isalpha"] = createExportWrapper("isalpha");

/** @type {function(...*):?} */
var ___isalnum_l = Module["___isalnum_l"] = createExportWrapper("__isalnum_l");

/** @type {function(...*):?} */
var _isalnum_l = Module["_isalnum_l"] = createExportWrapper("isalnum_l");

/** @type {function(...*):?} */
var ___isalpha_l = Module["___isalpha_l"] = createExportWrapper("__isalpha_l");

/** @type {function(...*):?} */
var _isalpha_l = Module["_isalpha_l"] = createExportWrapper("isalpha_l");

/** @type {function(...*):?} */
var _isascii = Module["_isascii"] = createExportWrapper("isascii");

/** @type {function(...*):?} */
var _isblank = Module["_isblank"] = createExportWrapper("isblank");

/** @type {function(...*):?} */
var ___isblank_l = Module["___isblank_l"] = createExportWrapper("__isblank_l");

/** @type {function(...*):?} */
var _isblank_l = Module["_isblank_l"] = createExportWrapper("isblank_l");

/** @type {function(...*):?} */
var _iscntrl = Module["_iscntrl"] = createExportWrapper("iscntrl");

/** @type {function(...*):?} */
var ___iscntrl_l = Module["___iscntrl_l"] = createExportWrapper("__iscntrl_l");

/** @type {function(...*):?} */
var _iscntrl_l = Module["_iscntrl_l"] = createExportWrapper("iscntrl_l");

/** @type {function(...*):?} */
var ___isdigit_l = Module["___isdigit_l"] = createExportWrapper("__isdigit_l");

/** @type {function(...*):?} */
var _isdigit_l = Module["_isdigit_l"] = createExportWrapper("isdigit_l");

/** @type {function(...*):?} */
var _isgraph = Module["_isgraph"] = createExportWrapper("isgraph");

/** @type {function(...*):?} */
var ___isgraph_l = Module["___isgraph_l"] = createExportWrapper("__isgraph_l");

/** @type {function(...*):?} */
var _isgraph_l = Module["_isgraph_l"] = createExportWrapper("isgraph_l");

/** @type {function(...*):?} */
var _islower = Module["_islower"] = createExportWrapper("islower");

/** @type {function(...*):?} */
var ___islower_l = Module["___islower_l"] = createExportWrapper("__islower_l");

/** @type {function(...*):?} */
var _islower_l = Module["_islower_l"] = createExportWrapper("islower_l");

/** @type {function(...*):?} */
var ___isprint_l = Module["___isprint_l"] = createExportWrapper("__isprint_l");

/** @type {function(...*):?} */
var _isprint_l = Module["_isprint_l"] = createExportWrapper("isprint_l");

/** @type {function(...*):?} */
var _ispunct = Module["_ispunct"] = createExportWrapper("ispunct");

/** @type {function(...*):?} */
var ___ispunct_l = Module["___ispunct_l"] = createExportWrapper("__ispunct_l");

/** @type {function(...*):?} */
var _ispunct_l = Module["_ispunct_l"] = createExportWrapper("ispunct_l");

/** @type {function(...*):?} */
var _isspace = Module["_isspace"] = createExportWrapper("isspace");

/** @type {function(...*):?} */
var ___isspace_l = Module["___isspace_l"] = createExportWrapper("__isspace_l");

/** @type {function(...*):?} */
var _isspace_l = Module["_isspace_l"] = createExportWrapper("isspace_l");

/** @type {function(...*):?} */
var _isupper = Module["_isupper"] = createExportWrapper("isupper");

/** @type {function(...*):?} */
var ___isupper_l = Module["___isupper_l"] = createExportWrapper("__isupper_l");

/** @type {function(...*):?} */
var _isupper_l = Module["_isupper_l"] = createExportWrapper("isupper_l");

/** @type {function(...*):?} */
var _iswalnum = Module["_iswalnum"] = createExportWrapper("iswalnum");

/** @type {function(...*):?} */
var _iswdigit = Module["_iswdigit"] = createExportWrapper("iswdigit");

/** @type {function(...*):?} */
var _iswalpha = Module["_iswalpha"] = createExportWrapper("iswalpha");

/** @type {function(...*):?} */
var ___iswalnum_l = Module["___iswalnum_l"] = createExportWrapper("__iswalnum_l");

/** @type {function(...*):?} */
var _iswalnum_l = Module["_iswalnum_l"] = createExportWrapper("iswalnum_l");

/** @type {function(...*):?} */
var ___iswalpha_l = Module["___iswalpha_l"] = createExportWrapper("__iswalpha_l");

/** @type {function(...*):?} */
var _iswalpha_l = Module["_iswalpha_l"] = createExportWrapper("iswalpha_l");

/** @type {function(...*):?} */
var _iswblank = Module["_iswblank"] = createExportWrapper("iswblank");

/** @type {function(...*):?} */
var ___iswblank_l = Module["___iswblank_l"] = createExportWrapper("__iswblank_l");

/** @type {function(...*):?} */
var _iswblank_l = Module["_iswblank_l"] = createExportWrapper("iswblank_l");

/** @type {function(...*):?} */
var _iswcntrl = Module["_iswcntrl"] = createExportWrapper("iswcntrl");

/** @type {function(...*):?} */
var ___iswcntrl_l = Module["___iswcntrl_l"] = createExportWrapper("__iswcntrl_l");

/** @type {function(...*):?} */
var _iswcntrl_l = Module["_iswcntrl_l"] = createExportWrapper("iswcntrl_l");

/** @type {function(...*):?} */
var _iswctype = Module["_iswctype"] = createExportWrapper("iswctype");

/** @type {function(...*):?} */
var _iswgraph = Module["_iswgraph"] = createExportWrapper("iswgraph");

/** @type {function(...*):?} */
var _iswlower = Module["_iswlower"] = createExportWrapper("iswlower");

/** @type {function(...*):?} */
var _iswprint = Module["_iswprint"] = createExportWrapper("iswprint");

/** @type {function(...*):?} */
var _iswpunct = Module["_iswpunct"] = createExportWrapper("iswpunct");

/** @type {function(...*):?} */
var _iswspace = Module["_iswspace"] = createExportWrapper("iswspace");

/** @type {function(...*):?} */
var _iswupper = Module["_iswupper"] = createExportWrapper("iswupper");

/** @type {function(...*):?} */
var _iswxdigit = Module["_iswxdigit"] = createExportWrapper("iswxdigit");

/** @type {function(...*):?} */
var _wctype = Module["_wctype"] = createExportWrapper("wctype");

/** @type {function(...*):?} */
var ___iswctype_l = Module["___iswctype_l"] = createExportWrapper("__iswctype_l");

/** @type {function(...*):?} */
var ___wctype_l = Module["___wctype_l"] = createExportWrapper("__wctype_l");

/** @type {function(...*):?} */
var _iswctype_l = Module["_iswctype_l"] = createExportWrapper("iswctype_l");

/** @type {function(...*):?} */
var _wctype_l = Module["_wctype_l"] = createExportWrapper("wctype_l");

/** @type {function(...*):?} */
var ___iswdigit_l = Module["___iswdigit_l"] = createExportWrapper("__iswdigit_l");

/** @type {function(...*):?} */
var _iswdigit_l = Module["_iswdigit_l"] = createExportWrapper("iswdigit_l");

/** @type {function(...*):?} */
var ___iswgraph_l = Module["___iswgraph_l"] = createExportWrapper("__iswgraph_l");

/** @type {function(...*):?} */
var _iswgraph_l = Module["_iswgraph_l"] = createExportWrapper("iswgraph_l");

/** @type {function(...*):?} */
var _towupper = Module["_towupper"] = createExportWrapper("towupper");

/** @type {function(...*):?} */
var ___iswlower_l = Module["___iswlower_l"] = createExportWrapper("__iswlower_l");

/** @type {function(...*):?} */
var _iswlower_l = Module["_iswlower_l"] = createExportWrapper("iswlower_l");

/** @type {function(...*):?} */
var ___iswprint_l = Module["___iswprint_l"] = createExportWrapper("__iswprint_l");

/** @type {function(...*):?} */
var _iswprint_l = Module["_iswprint_l"] = createExportWrapper("iswprint_l");

/** @type {function(...*):?} */
var ___iswpunct_l = Module["___iswpunct_l"] = createExportWrapper("__iswpunct_l");

/** @type {function(...*):?} */
var _iswpunct_l = Module["_iswpunct_l"] = createExportWrapper("iswpunct_l");

/** @type {function(...*):?} */
var _wcschr = Module["_wcschr"] = createExportWrapper("wcschr");

/** @type {function(...*):?} */
var ___iswspace_l = Module["___iswspace_l"] = createExportWrapper("__iswspace_l");

/** @type {function(...*):?} */
var _iswspace_l = Module["_iswspace_l"] = createExportWrapper("iswspace_l");

/** @type {function(...*):?} */
var _towlower = Module["_towlower"] = createExportWrapper("towlower");

/** @type {function(...*):?} */
var ___iswupper_l = Module["___iswupper_l"] = createExportWrapper("__iswupper_l");

/** @type {function(...*):?} */
var _iswupper_l = Module["_iswupper_l"] = createExportWrapper("iswupper_l");

/** @type {function(...*):?} */
var ___iswxdigit_l = Module["___iswxdigit_l"] = createExportWrapper("__iswxdigit_l");

/** @type {function(...*):?} */
var _iswxdigit_l = Module["_iswxdigit_l"] = createExportWrapper("iswxdigit_l");

/** @type {function(...*):?} */
var _isxdigit = Module["_isxdigit"] = createExportWrapper("isxdigit");

/** @type {function(...*):?} */
var ___isxdigit_l = Module["___isxdigit_l"] = createExportWrapper("__isxdigit_l");

/** @type {function(...*):?} */
var _isxdigit_l = Module["_isxdigit_l"] = createExportWrapper("isxdigit_l");

/** @type {function(...*):?} */
var _toascii = Module["_toascii"] = createExportWrapper("toascii");

/** @type {function(...*):?} */
var ___tolower_l = Module["___tolower_l"] = createExportWrapper("__tolower_l");

/** @type {function(...*):?} */
var _tolower_l = Module["_tolower_l"] = createExportWrapper("tolower_l");

/** @type {function(...*):?} */
var ___toupper_l = Module["___toupper_l"] = createExportWrapper("__toupper_l");

/** @type {function(...*):?} */
var _toupper_l = Module["_toupper_l"] = createExportWrapper("toupper_l");

/** @type {function(...*):?} */
var ___towupper_l = Module["___towupper_l"] = createExportWrapper("__towupper_l");

/** @type {function(...*):?} */
var ___towlower_l = Module["___towlower_l"] = createExportWrapper("__towlower_l");

/** @type {function(...*):?} */
var _towupper_l = Module["_towupper_l"] = createExportWrapper("towupper_l");

/** @type {function(...*):?} */
var _towlower_l = Module["_towlower_l"] = createExportWrapper("towlower_l");

/** @type {function(...*):?} */
var _wcswidth = Module["_wcswidth"] = createExportWrapper("wcswidth");

/** @type {function(...*):?} */
var _wcwidth = Module["_wcwidth"] = createExportWrapper("wcwidth");

/** @type {function(...*):?} */
var _wctrans = Module["_wctrans"] = createExportWrapper("wctrans");

/** @type {function(...*):?} */
var _towctrans = Module["_towctrans"] = createExportWrapper("towctrans");

/** @type {function(...*):?} */
var ___wctrans_l = Module["___wctrans_l"] = createExportWrapper("__wctrans_l");

/** @type {function(...*):?} */
var ___towctrans_l = Module["___towctrans_l"] = createExportWrapper("__towctrans_l");

/** @type {function(...*):?} */
var _wctrans_l = Module["_wctrans_l"] = createExportWrapper("wctrans_l");

/** @type {function(...*):?} */
var _towctrans_l = Module["_towctrans_l"] = createExportWrapper("towctrans_l");

/** @type {function(...*):?} */
var ___getdents = Module["___getdents"] = createExportWrapper("__getdents");

/** @type {function(...*):?} */
var ___syscall_ret = Module["___syscall_ret"] = createExportWrapper("__syscall_ret");

/** @type {function(...*):?} */
var _getdents = Module["_getdents"] = createExportWrapper("getdents");

/** @type {function(...*):?} */
var _getdents64 = Module["_getdents64"] = createExportWrapper("getdents64");

/** @type {function(...*):?} */
var _alphasort = Module["_alphasort"] = createExportWrapper("alphasort");

/** @type {function(...*):?} */
var _strcoll = Module["_strcoll"] = createExportWrapper("strcoll");

/** @type {function(...*):?} */
var _alphasort64 = Module["_alphasort64"] = createExportWrapper("alphasort64");

/** @type {function(...*):?} */
var _closedir = Module["_closedir"] = createExportWrapper("closedir");

/** @type {function(...*):?} */
var _close = Module["_close"] = createExportWrapper("close");

/** @type {function(...*):?} */
var _dirfd = Module["_dirfd"] = createExportWrapper("dirfd");

/** @type {function(...*):?} */
var _fdopendir = Module["_fdopendir"] = createExportWrapper("fdopendir");

/** @type {function(...*):?} */
var _fstat = Module["_fstat"] = createExportWrapper("fstat");

/** @type {function(...*):?} */
var ___errno_location = Module["___errno_location"] = createExportWrapper("__errno_location");

/** @type {function(...*):?} */
var _fcntl = Module["_fcntl"] = createExportWrapper("fcntl");

/** @type {function(...*):?} */
var _opendir = Module["_opendir"] = createExportWrapper("opendir");

/** @type {function(...*):?} */
var _open = Module["_open"] = createExportWrapper("open");

/** @type {function(...*):?} */
var _readdir = Module["_readdir"] = createExportWrapper("readdir");

/** @type {function(...*):?} */
var _readdir64 = Module["_readdir64"] = createExportWrapper("readdir64");

/** @type {function(...*):?} */
var _readdir_r = Module["_readdir_r"] = createExportWrapper("readdir_r");

/** @type {function(...*):?} */
var ___lock = Module["___lock"] = createExportWrapper("__lock");

/** @type {function(...*):?} */
var ___unlock = Module["___unlock"] = createExportWrapper("__unlock");

/** @type {function(...*):?} */
var _readdir64_r = Module["_readdir64_r"] = createExportWrapper("readdir64_r");

/** @type {function(...*):?} */
var _rewinddir = Module["_rewinddir"] = createExportWrapper("rewinddir");

/** @type {function(...*):?} */
var _lseek = Module["_lseek"] = createExportWrapper("lseek");

/** @type {function(...*):?} */
var _scandir = Module["_scandir"] = createExportWrapper("scandir");

/** @type {function(...*):?} */
var _scandir64 = Module["_scandir64"] = createExportWrapper("scandir64");

/** @type {function(...*):?} */
var _seekdir = Module["_seekdir"] = createExportWrapper("seekdir");

/** @type {function(...*):?} */
var _telldir = Module["_telldir"] = createExportWrapper("telldir");

/** @type {function(...*):?} */
var _versionsort = Module["_versionsort"] = createExportWrapper("versionsort");

/** @type {function(...*):?} */
var _strverscmp = Module["_strverscmp"] = createExportWrapper("strverscmp");

/** @type {function(...*):?} */
var _versionsort64 = Module["_versionsort64"] = createExportWrapper("versionsort64");

/** @type {function(...*):?} */
var ___strerror_l = Module["___strerror_l"] = createExportWrapper("__strerror_l");

/** @type {function(...*):?} */
var ___lctrans = Module["___lctrans"] = createExportWrapper("__lctrans");

/** @type {function(...*):?} */
var _strerror = Module["_strerror"] = createExportWrapper("strerror");

/** @type {function(...*):?} */
var _strerror_l = Module["_strerror_l"] = createExportWrapper("strerror_l");

/** @type {function(...*):?} */
var _creat = Module["_creat"] = createExportWrapper("creat");

/** @type {function(...*):?} */
var _creat64 = Module["_creat64"] = createExportWrapper("creat64");

/** @type {function(...*):?} */
var _open64 = Module["_open64"] = createExportWrapper("open64");

/** @type {function(...*):?} */
var _openat = Module["_openat"] = createExportWrapper("openat");

/** @type {function(...*):?} */
var _openat64 = Module["_openat64"] = createExportWrapper("openat64");

/** @type {function(...*):?} */
var _posix_fadvise = Module["_posix_fadvise"] = createExportWrapper("posix_fadvise");

/** @type {function(...*):?} */
var _posix_fadvise64 = Module["_posix_fadvise64"] = createExportWrapper("posix_fadvise64");

/** @type {function(...*):?} */
var _posix_fallocate = Module["_posix_fallocate"] = createExportWrapper("posix_fallocate");

/** @type {function(...*):?} */
var _posix_fallocate64 = Module["_posix_fallocate64"] = createExportWrapper("posix_fallocate64");

/** @type {function(...*):?} */
var ___flt_rounds = Module["___flt_rounds"] = createExportWrapper("__flt_rounds");

/** @type {function(...*):?} */
var _fegetround = Module["_fegetround"] = createExportWrapper("fegetround");

/** @type {function(...*):?} */
var _fegetexceptflag = Module["_fegetexceptflag"] = createExportWrapper("fegetexceptflag");

/** @type {function(...*):?} */
var _fetestexcept = Module["_fetestexcept"] = createExportWrapper("fetestexcept");

/** @type {function(...*):?} */
var _feholdexcept = Module["_feholdexcept"] = createExportWrapper("feholdexcept");

/** @type {function(...*):?} */
var _fegetenv = Module["_fegetenv"] = createExportWrapper("fegetenv");

/** @type {function(...*):?} */
var _feclearexcept = Module["_feclearexcept"] = createExportWrapper("feclearexcept");

/** @type {function(...*):?} */
var _feraiseexcept = Module["_feraiseexcept"] = createExportWrapper("feraiseexcept");

/** @type {function(...*):?} */
var ___fesetround = Module["___fesetround"] = createExportWrapper("__fesetround");

/** @type {function(...*):?} */
var _fesetenv = Module["_fesetenv"] = createExportWrapper("fesetenv");

/** @type {function(...*):?} */
var _fesetexceptflag = Module["_fesetexceptflag"] = createExportWrapper("fesetexceptflag");

/** @type {function(...*):?} */
var _fesetround = Module["_fesetround"] = createExportWrapper("fesetround");

/** @type {function(...*):?} */
var _feupdateenv = Module["_feupdateenv"] = createExportWrapper("feupdateenv");

/** @type {function(...*):?} */
var ___floatscan = Module["___floatscan"] = createExportWrapper("__floatscan");

/** @type {function(...*):?} */
var ___shgetc = Module["___shgetc"] = createExportWrapper("__shgetc");

/** @type {function(...*):?} */
var ___extendsftf2 = Module["___extendsftf2"] = createExportWrapper("__extendsftf2");

/** @type {function(...*):?} */
var ___shlim = Module["___shlim"] = createExportWrapper("__shlim");

/** @type {function(...*):?} */
var _scalbn = Module["_scalbn"] = createExportWrapper("scalbn");

/** @type {function(...*):?} */
var ___floatunsitf = Module["___floatunsitf"] = createExportWrapper("__floatunsitf");

/** @type {function(...*):?} */
var _scalbnl = Module["_scalbnl"] = createExportWrapper("scalbnl");

/** @type {function(...*):?} */
var _fmodl = Module["_fmodl"] = createExportWrapper("fmodl");

/** @type {function(...*):?} */
var _fabsl = Module["_fabsl"] = createExportWrapper("fabsl");

/** @type {function(...*):?} */
var ___intscan = Module["___intscan"] = createExportWrapper("__intscan");

/** @type {function(...*):?} */
var ___multi3 = Module["___multi3"] = createExportWrapper("__multi3");

/** @type {function(...*):?} */
var ___procfdname = Module["___procfdname"] = createExportWrapper("__procfdname");

/** @type {function(...*):?} */
var ___uflow = Module["___uflow"] = createExportWrapper("__uflow");

/** @type {function(...*):?} */
var ___libc_get_version = Module["___libc_get_version"] = createExportWrapper("__libc_get_version");

/** @type {function(...*):?} */
var ___lctrans_impl = Module["___lctrans_impl"] = createExportWrapper("__lctrans_impl");

/** @type {function(...*):?} */
var ___lctrans_cur = Module["___lctrans_cur"] = createExportWrapper("__lctrans_cur");

/** @type {function(...*):?} */
var ___mo_lookup = Module["___mo_lookup"] = createExportWrapper("__mo_lookup");

/** @type {function(...*):?} */
var _bind_textdomain_codeset = Module["_bind_textdomain_codeset"] = createExportWrapper("bind_textdomain_codeset");

/** @type {function(...*):?} */
var _strcasecmp = Module["_strcasecmp"] = createExportWrapper("strcasecmp");

/** @type {function(...*):?} */
var _catclose = Module["_catclose"] = createExportWrapper("catclose");

/** @type {function(...*):?} */
var _catgets = Module["_catgets"] = createExportWrapper("catgets");

/** @type {function(...*):?} */
var _catopen = Module["_catopen"] = createExportWrapper("catopen");

/** @type {function(...*):?} */
var _bindtextdomain = Module["_bindtextdomain"] = createExportWrapper("bindtextdomain");

/** @type {function(...*):?} */
var _dcngettext = Module["_dcngettext"] = createExportWrapper("dcngettext");

/** @type {function(...*):?} */
var ___gettextdomain = Module["___gettextdomain"] = createExportWrapper("__gettextdomain");

/** @type {function(...*):?} */
var ___munmap = Module["___munmap"] = createExportWrapper("__munmap");

/** @type {function(...*):?} */
var _strchr = Module["_strchr"] = createExportWrapper("strchr");

/** @type {function(...*):?} */
var ___pleval = Module["___pleval"] = createExportWrapper("__pleval");

/** @type {function(...*):?} */
var _dcgettext = Module["_dcgettext"] = createExportWrapper("dcgettext");

/** @type {function(...*):?} */
var _dngettext = Module["_dngettext"] = createExportWrapper("dngettext");

/** @type {function(...*):?} */
var _dgettext = Module["_dgettext"] = createExportWrapper("dgettext");

/** @type {function(...*):?} */
var ___duplocale = Module["___duplocale"] = createExportWrapper("__duplocale");

/** @type {function(...*):?} */
var _duplocale = Module["_duplocale"] = createExportWrapper("duplocale");

/** @type {function(...*):?} */
var _freelocale = Module["_freelocale"] = createExportWrapper("freelocale");

/** @type {function(...*):?} */
var ___loc_is_allocated = Module["___loc_is_allocated"] = createExportWrapper("__loc_is_allocated");

/** @type {function(...*):?} */
var ___freelocale = Module["___freelocale"] = createExportWrapper("__freelocale");

/** @type {function(...*):?} */
var _iconv_open = Module["_iconv_open"] = createExportWrapper("iconv_open");

/** @type {function(...*):?} */
var _iconv_close = Module["_iconv_close"] = createExportWrapper("iconv_close");

/** @type {function(...*):?} */
var _iconv = Module["_iconv"] = createExportWrapper("iconv");

/** @type {function(...*):?} */
var _mbrtowc = Module["_mbrtowc"] = createExportWrapper("mbrtowc");

/** @type {function(...*):?} */
var _wctomb = Module["_wctomb"] = createExportWrapper("wctomb");

/** @type {function(...*):?} */
var ___nl_langinfo_l = Module["___nl_langinfo_l"] = createExportWrapper("__nl_langinfo_l");

/** @type {function(...*):?} */
var ___nl_langinfo = Module["___nl_langinfo"] = createExportWrapper("__nl_langinfo");

/** @type {function(...*):?} */
var _nl_langinfo = Module["_nl_langinfo"] = createExportWrapper("nl_langinfo");

/** @type {function(...*):?} */
var _nl_langinfo_l = Module["_nl_langinfo_l"] = createExportWrapper("nl_langinfo_l");

/** @type {function(...*):?} */
var ___get_locale = Module["___get_locale"] = createExportWrapper("__get_locale");

/** @type {function(...*):?} */
var _getenv = Module["_getenv"] = createExportWrapper("getenv");

/** @type {function(...*):?} */
var ___strchrnul = Module["___strchrnul"] = createExportWrapper("__strchrnul");

/** @type {function(...*):?} */
var _localeconv = Module["_localeconv"] = createExportWrapper("localeconv");

/** @type {function(...*):?} */
var ___newlocale = Module["___newlocale"] = createExportWrapper("__newlocale");

/** @type {function(...*):?} */
var _newlocale = Module["_newlocale"] = createExportWrapper("newlocale");

/** @type {function(...*):?} */
var _setlocale = Module["_setlocale"] = createExportWrapper("setlocale");

/** @type {function(...*):?} */
var ___strcoll_l = Module["___strcoll_l"] = createExportWrapper("__strcoll_l");

/** @type {function(...*):?} */
var _strcoll_l = Module["_strcoll_l"] = createExportWrapper("strcoll_l");

/** @type {function(...*):?} */
var _strfmon_l = Module["_strfmon_l"] = createExportWrapper("strfmon_l");

/** @type {function(...*):?} */
var _strfmon = Module["_strfmon"] = createExportWrapper("strfmon");

/** @type {function(...*):?} */
var ___strxfrm_l = Module["___strxfrm_l"] = createExportWrapper("__strxfrm_l");

/** @type {function(...*):?} */
var _strcpy = Module["_strcpy"] = createExportWrapper("strcpy");

/** @type {function(...*):?} */
var _strxfrm = Module["_strxfrm"] = createExportWrapper("strxfrm");

/** @type {function(...*):?} */
var _strxfrm_l = Module["_strxfrm_l"] = createExportWrapper("strxfrm_l");

/** @type {function(...*):?} */
var _textdomain = Module["_textdomain"] = createExportWrapper("textdomain");

/** @type {function(...*):?} */
var _gettext = Module["_gettext"] = createExportWrapper("gettext");

/** @type {function(...*):?} */
var _ngettext = Module["_ngettext"] = createExportWrapper("ngettext");

/** @type {function(...*):?} */
var ___uselocale = Module["___uselocale"] = createExportWrapper("__uselocale");

/** @type {function(...*):?} */
var _uselocale = Module["_uselocale"] = createExportWrapper("uselocale");

/** @type {function(...*):?} */
var ___wcscoll_l = Module["___wcscoll_l"] = createExportWrapper("__wcscoll_l");

/** @type {function(...*):?} */
var _wcscmp = Module["_wcscmp"] = createExportWrapper("wcscmp");

/** @type {function(...*):?} */
var _wcscoll = Module["_wcscoll"] = createExportWrapper("wcscoll");

/** @type {function(...*):?} */
var _wcscoll_l = Module["_wcscoll_l"] = createExportWrapper("wcscoll_l");

/** @type {function(...*):?} */
var ___wcsxfrm_l = Module["___wcsxfrm_l"] = createExportWrapper("__wcsxfrm_l");

/** @type {function(...*):?} */
var _wcslen = Module["_wcslen"] = createExportWrapper("wcslen");

/** @type {function(...*):?} */
var _wmemcpy = Module["_wmemcpy"] = createExportWrapper("wmemcpy");

/** @type {function(...*):?} */
var _wcsxfrm = Module["_wcsxfrm"] = createExportWrapper("wcsxfrm");

/** @type {function(...*):?} */
var _wcsxfrm_l = Module["_wcsxfrm_l"] = createExportWrapper("wcsxfrm_l");

/** @type {function(...*):?} */
var ___cos = Module["___cos"] = createExportWrapper("__cos");

/** @type {function(...*):?} */
var ___cosdf = Module["___cosdf"] = createExportWrapper("__cosdf");

/** @type {function(...*):?} */
var ___cosl = Module["___cosl"] = createExportWrapper("__cosl");

/** @type {function(...*):?} */
var ___expo2 = Module["___expo2"] = createExportWrapper("__expo2");

/** @type {function(...*):?} */
var ___expo2f = Module["___expo2f"] = createExportWrapper("__expo2f");

/** @type {function(...*):?} */
var ___fpclassify = Module["___fpclassify"] = createExportWrapper("__fpclassify");

/** @type {function(...*):?} */
var ___fpclassifyf = Module["___fpclassifyf"] = createExportWrapper("__fpclassifyf");

/** @type {function(...*):?} */
var ___invtrigl_R = Module["___invtrigl_R"] = createExportWrapper("__invtrigl_R");

/** @type {function(...*):?} */
var ___polevll = Module["___polevll"] = createExportWrapper("__polevll");

/** @type {function(...*):?} */
var ___p1evll = Module["___p1evll"] = createExportWrapper("__p1evll");

/** @type {function(...*):?} */
var ___rem_pio2 = Module["___rem_pio2"] = createExportWrapper("__rem_pio2");

/** @type {function(...*):?} */
var ___rem_pio2_large = Module["___rem_pio2_large"] = createExportWrapper("__rem_pio2_large");

/** @type {function(...*):?} */
var _floor = Module["_floor"] = createExportWrapper("floor");

/** @type {function(...*):?} */
var ___rem_pio2f = Module["___rem_pio2f"] = createExportWrapper("__rem_pio2f");

/** @type {function(...*):?} */
var ___rem_pio2l = Module["___rem_pio2l"] = createExportWrapper("__rem_pio2l");

/** @type {function(...*):?} */
var ___fixtfdi = Module["___fixtfdi"] = createExportWrapper("__fixtfdi");

/** @type {function(...*):?} */
var ___sin = Module["___sin"] = createExportWrapper("__sin");

/** @type {function(...*):?} */
var ___sindf = Module["___sindf"] = createExportWrapper("__sindf");

/** @type {function(...*):?} */
var ___sinl = Module["___sinl"] = createExportWrapper("__sinl");

/** @type {function(...*):?} */
var ___tan = Module["___tan"] = createExportWrapper("__tan");

/** @type {function(...*):?} */
var ___tandf = Module["___tandf"] = createExportWrapper("__tandf");

/** @type {function(...*):?} */
var ___tanl = Module["___tanl"] = createExportWrapper("__tanl");

/** @type {function(...*):?} */
var ___lttf2 = Module["___lttf2"] = createExportWrapper("__lttf2");

/** @type {function(...*):?} */
var _acosh = Module["_acosh"] = createExportWrapper("acosh");

/** @type {function(...*):?} */
var _log1p = Module["_log1p"] = createExportWrapper("log1p");

/** @type {function(...*):?} */
var _acoshf = Module["_acoshf"] = createExportWrapper("acoshf");

/** @type {function(...*):?} */
var _log1pf = Module["_log1pf"] = createExportWrapper("log1pf");

/** @type {function(...*):?} */
var _acoshl = Module["_acoshl"] = createExportWrapper("acoshl");

/** @type {function(...*):?} */
var _asinh = Module["_asinh"] = createExportWrapper("asinh");

/** @type {function(...*):?} */
var _asinhf = Module["_asinhf"] = createExportWrapper("asinhf");

/** @type {function(...*):?} */
var _asinhl = Module["_asinhl"] = createExportWrapper("asinhl");

/** @type {function(...*):?} */
var _atanh = Module["_atanh"] = createExportWrapper("atanh");

/** @type {function(...*):?} */
var _atanhf = Module["_atanhf"] = createExportWrapper("atanhf");

/** @type {function(...*):?} */
var _atanhl = Module["_atanhl"] = createExportWrapper("atanhl");

/** @type {function(...*):?} */
var _log1pl = Module["_log1pl"] = createExportWrapper("log1pl");

/** @type {function(...*):?} */
var _cbrt = Module["_cbrt"] = createExportWrapper("cbrt");

/** @type {function(...*):?} */
var _cbrtf = Module["_cbrtf"] = createExportWrapper("cbrtf");

/** @type {function(...*):?} */
var _cbrtl = Module["_cbrtl"] = createExportWrapper("cbrtl");

/** @type {function(...*):?} */
var ___trunctfsf2 = Module["___trunctfsf2"] = createExportWrapper("__trunctfsf2");

/** @type {function(...*):?} */
var _ceil = Module["_ceil"] = createExportWrapper("ceil");

/** @type {function(...*):?} */
var _ceilf = Module["_ceilf"] = createExportWrapper("ceilf");

/** @type {function(...*):?} */
var _expm1 = Module["_expm1"] = createExportWrapper("expm1");

/** @type {function(...*):?} */
var _expm1f = Module["_expm1f"] = createExportWrapper("expm1f");

/** @type {function(...*):?} */
var _coshl = Module["_coshl"] = createExportWrapper("coshl");

/** @type {function(...*):?} */
var _erf = Module["_erf"] = createExportWrapper("erf");

/** @type {function(...*):?} */
var _erfc = Module["_erfc"] = createExportWrapper("erfc");

/** @type {function(...*):?} */
var _erff = Module["_erff"] = createExportWrapper("erff");

/** @type {function(...*):?} */
var _erfcf = Module["_erfcf"] = createExportWrapper("erfcf");

/** @type {function(...*):?} */
var _erfl = Module["_erfl"] = createExportWrapper("erfl");

/** @type {function(...*):?} */
var _erfcl = Module["_erfcl"] = createExportWrapper("erfcl");

/** @type {function(...*):?} */
var _exp10l = Module["_exp10l"] = createExportWrapper("exp10l");

/** @type {function(...*):?} */
var _modfl = Module["_modfl"] = createExportWrapper("modfl");

/** @type {function(...*):?} */
var _exp2l = Module["_exp2l"] = createExportWrapper("exp2l");

/** @type {function(...*):?} */
var _powl = Module["_powl"] = createExportWrapper("powl");

/** @type {function(...*):?} */
var _pow10l = Module["_pow10l"] = createExportWrapper("pow10l");

/** @type {function(...*):?} */
var ___letf2 = Module["___letf2"] = createExportWrapper("__letf2");

/** @type {function(...*):?} */
var _expm1l = Module["_expm1l"] = createExportWrapper("expm1l");

/** @type {function(...*):?} */
var _fdim = Module["_fdim"] = createExportWrapper("fdim");

/** @type {function(...*):?} */
var _fdimf = Module["_fdimf"] = createExportWrapper("fdimf");

/** @type {function(...*):?} */
var _fdiml = Module["_fdiml"] = createExportWrapper("fdiml");

/** @type {function(...*):?} */
var _finite = Module["_finite"] = createExportWrapper("finite");

/** @type {function(...*):?} */
var _finitef = Module["_finitef"] = createExportWrapper("finitef");

/** @type {function(...*):?} */
var _floorf = Module["_floorf"] = createExportWrapper("floorf");

/** @type {function(...*):?} */
var _fma = Module["_fma"] = createExportWrapper("fma");

/** @type {function(...*):?} */
var _frexp = Module["_frexp"] = createExportWrapper("frexp");

/** @type {function(...*):?} */
var _nextafter = Module["_nextafter"] = createExportWrapper("nextafter");

/** @type {function(...*):?} */
var _ilogb = Module["_ilogb"] = createExportWrapper("ilogb");

/** @type {function(...*):?} */
var _fmaf = Module["_fmaf"] = createExportWrapper("fmaf");

/** @type {function(...*):?} */
var _fmal = Module["_fmal"] = createExportWrapper("fmal");

/** @type {function(...*):?} */
var _frexpl = Module["_frexpl"] = createExportWrapper("frexpl");

/** @type {function(...*):?} */
var _nextafterl = Module["_nextafterl"] = createExportWrapper("nextafterl");

/** @type {function(...*):?} */
var _ilogbl = Module["_ilogbl"] = createExportWrapper("ilogbl");

/** @type {function(...*):?} */
var _frexpf = Module["_frexpf"] = createExportWrapper("frexpf");

/** @type {function(...*):?} */
var _sqrtl = Module["_sqrtl"] = createExportWrapper("sqrtl");

/** @type {function(...*):?} */
var _ilogbf = Module["_ilogbf"] = createExportWrapper("ilogbf");

/** @type {function(...*):?} */
var _j0 = Module["_j0"] = createExportWrapper("j0");

/** @type {function(...*):?} */
var _y0 = Module["_y0"] = createExportWrapper("y0");

/** @type {function(...*):?} */
var _j0f = Module["_j0f"] = createExportWrapper("j0f");

/** @type {function(...*):?} */
var _y0f = Module["_y0f"] = createExportWrapper("y0f");

/** @type {function(...*):?} */
var _j1 = Module["_j1"] = createExportWrapper("j1");

/** @type {function(...*):?} */
var _y1 = Module["_y1"] = createExportWrapper("y1");

/** @type {function(...*):?} */
var _j1f = Module["_j1f"] = createExportWrapper("j1f");

/** @type {function(...*):?} */
var _y1f = Module["_y1f"] = createExportWrapper("y1f");

/** @type {function(...*):?} */
var _jn = Module["_jn"] = createExportWrapper("jn");

/** @type {function(...*):?} */
var _yn = Module["_yn"] = createExportWrapper("yn");

/** @type {function(...*):?} */
var _jnf = Module["_jnf"] = createExportWrapper("jnf");

/** @type {function(...*):?} */
var _ynf = Module["_ynf"] = createExportWrapper("ynf");

/** @type {function(...*):?} */
var _ldexp = Module["_ldexp"] = createExportWrapper("ldexp");

/** @type {function(...*):?} */
var _ldexpf = Module["_ldexpf"] = createExportWrapper("ldexpf");

/** @type {function(...*):?} */
var _scalbnf = Module["_scalbnf"] = createExportWrapper("scalbnf");

/** @type {function(...*):?} */
var _ldexpl = Module["_ldexpl"] = createExportWrapper("ldexpl");

/** @type {function(...*):?} */
var _lgamma = Module["_lgamma"] = createExportWrapper("lgamma");

/** @type {function(...*):?} */
var ___lgamma_r = Module["___lgamma_r"] = createExportWrapper("__lgamma_r");

/** @type {function(...*):?} */
var _lgamma_r = Module["_lgamma_r"] = createExportWrapper("lgamma_r");

/** @type {function(...*):?} */
var _lgammaf = Module["_lgammaf"] = createExportWrapper("lgammaf");

/** @type {function(...*):?} */
var ___lgammaf_r = Module["___lgammaf_r"] = createExportWrapper("__lgammaf_r");

/** @type {function(...*):?} */
var _lgammaf_r = Module["_lgammaf_r"] = createExportWrapper("lgammaf_r");

/** @type {function(...*):?} */
var ___lgammal_r = Module["___lgammal_r"] = createExportWrapper("__lgammal_r");

/** @type {function(...*):?} */
var _lgammal = Module["_lgammal"] = createExportWrapper("lgammal");

/** @type {function(...*):?} */
var _lgammal_r = Module["_lgammal_r"] = createExportWrapper("lgammal_r");

/** @type {function(...*):?} */
var _llrint = Module["_llrint"] = createExportWrapper("llrint");

/** @type {function(...*):?} */
var _rint = Module["_rint"] = createExportWrapper("rint");

/** @type {function(...*):?} */
var _llrintf = Module["_llrintf"] = createExportWrapper("llrintf");

/** @type {function(...*):?} */
var _rintf = Module["_rintf"] = createExportWrapper("rintf");

/** @type {function(...*):?} */
var _llrintl = Module["_llrintl"] = createExportWrapper("llrintl");

/** @type {function(...*):?} */
var _rintl = Module["_rintl"] = createExportWrapper("rintl");

/** @type {function(...*):?} */
var _llround = Module["_llround"] = createExportWrapper("llround");

/** @type {function(...*):?} */
var _llroundf = Module["_llroundf"] = createExportWrapper("llroundf");

/** @type {function(...*):?} */
var _llroundl = Module["_llroundl"] = createExportWrapper("llroundl");

/** @type {function(...*):?} */
var _roundl = Module["_roundl"] = createExportWrapper("roundl");

/** @type {function(...*):?} */
var _log10l = Module["_log10l"] = createExportWrapper("log10l");

/** @type {function(...*):?} */
var _log2l = Module["_log2l"] = createExportWrapper("log2l");

/** @type {function(...*):?} */
var _log2 = Module["_log2"] = createExportWrapper("log2");

/** @type {function(...*):?} */
var _logb = Module["_logb"] = createExportWrapper("logb");

/** @type {function(...*):?} */
var _logbf = Module["_logbf"] = createExportWrapper("logbf");

/** @type {function(...*):?} */
var _logbl = Module["_logbl"] = createExportWrapper("logbl");

/** @type {function(...*):?} */
var _lrint = Module["_lrint"] = createExportWrapper("lrint");

/** @type {function(...*):?} */
var _lrintf = Module["_lrintf"] = createExportWrapper("lrintf");

/** @type {function(...*):?} */
var _lrintl = Module["_lrintl"] = createExportWrapper("lrintl");

/** @type {function(...*):?} */
var _lround = Module["_lround"] = createExportWrapper("lround");

/** @type {function(...*):?} */
var _lroundf = Module["_lroundf"] = createExportWrapper("lroundf");

/** @type {function(...*):?} */
var _lroundl = Module["_lroundl"] = createExportWrapper("lroundl");

/** @type {function(...*):?} */
var _modf = Module["_modf"] = createExportWrapper("modf");

/** @type {function(...*):?} */
var _modff = Module["_modff"] = createExportWrapper("modff");

/** @type {function(...*):?} */
var _nan = Module["_nan"] = createExportWrapper("nan");

/** @type {function(...*):?} */
var _nanf = Module["_nanf"] = createExportWrapper("nanf");

/** @type {function(...*):?} */
var _nanl = Module["_nanl"] = createExportWrapper("nanl");

/** @type {function(...*):?} */
var _nearbyint = Module["_nearbyint"] = createExportWrapper("nearbyint");

/** @type {function(...*):?} */
var _nearbyintf = Module["_nearbyintf"] = createExportWrapper("nearbyintf");

/** @type {function(...*):?} */
var _nearbyintl = Module["_nearbyintl"] = createExportWrapper("nearbyintl");

/** @type {function(...*):?} */
var _nextafterf = Module["_nextafterf"] = createExportWrapper("nextafterf");

/** @type {function(...*):?} */
var _nexttoward = Module["_nexttoward"] = createExportWrapper("nexttoward");

/** @type {function(...*):?} */
var ___signbitl = Module["___signbitl"] = createExportWrapper("__signbitl");

/** @type {function(...*):?} */
var _nexttowardf = Module["_nexttowardf"] = createExportWrapper("nexttowardf");

/** @type {function(...*):?} */
var _nexttowardl = Module["_nexttowardl"] = createExportWrapper("nexttowardl");

/** @type {function(...*):?} */
var _remainder = Module["_remainder"] = createExportWrapper("remainder");

/** @type {function(...*):?} */
var _remquo = Module["_remquo"] = createExportWrapper("remquo");

/** @type {function(...*):?} */
var _drem = Module["_drem"] = createExportWrapper("drem");

/** @type {function(...*):?} */
var _remainderf = Module["_remainderf"] = createExportWrapper("remainderf");

/** @type {function(...*):?} */
var _remquof = Module["_remquof"] = createExportWrapper("remquof");

/** @type {function(...*):?} */
var _dremf = Module["_dremf"] = createExportWrapper("dremf");

/** @type {function(...*):?} */
var _remainderl = Module["_remainderl"] = createExportWrapper("remainderl");

/** @type {function(...*):?} */
var _remquol = Module["_remquol"] = createExportWrapper("remquol");

/** @type {function(...*):?} */
var _scalb = Module["_scalb"] = createExportWrapper("scalb");

/** @type {function(...*):?} */
var _scalbf = Module["_scalbf"] = createExportWrapper("scalbf");

/** @type {function(...*):?} */
var _scalbln = Module["_scalbln"] = createExportWrapper("scalbln");

/** @type {function(...*):?} */
var _scalblnf = Module["_scalblnf"] = createExportWrapper("scalblnf");

/** @type {function(...*):?} */
var _scalblnl = Module["_scalblnl"] = createExportWrapper("scalblnl");

/** @type {function(...*):?} */
var _significand = Module["_significand"] = createExportWrapper("significand");

/** @type {function(...*):?} */
var _significandf = Module["_significandf"] = createExportWrapper("significandf");

/** @type {function(...*):?} */
var _sincos = Module["_sincos"] = createExportWrapper("sincos");

/** @type {function(...*):?} */
var _sincosf = Module["_sincosf"] = createExportWrapper("sincosf");

/** @type {function(...*):?} */
var _sincosl = Module["_sincosl"] = createExportWrapper("sincosl");

/** @type {function(...*):?} */
var _sinhl = Module["_sinhl"] = createExportWrapper("sinhl");

/** @type {function(...*):?} */
var _tanh = Module["_tanh"] = createExportWrapper("tanh");

/** @type {function(...*):?} */
var _tanhf = Module["_tanhf"] = createExportWrapper("tanhf");

/** @type {function(...*):?} */
var _tanhl = Module["_tanhl"] = createExportWrapper("tanhl");

/** @type {function(...*):?} */
var _tgamma = Module["_tgamma"] = createExportWrapper("tgamma");

/** @type {function(...*):?} */
var _tgammaf = Module["_tgammaf"] = createExportWrapper("tgammaf");

/** @type {function(...*):?} */
var _tgammal = Module["_tgammal"] = createExportWrapper("tgammal");

/** @type {function(...*):?} */
var _trunc = Module["_trunc"] = createExportWrapper("trunc");

/** @type {function(...*):?} */
var _truncf = Module["_truncf"] = createExportWrapper("truncf");

/** @type {function(...*):?} */
var _truncl = Module["_truncl"] = createExportWrapper("truncl");

/** @type {function(...*):?} */
var _a64l = Module["_a64l"] = createExportWrapper("a64l");

/** @type {function(...*):?} */
var _l64a = Module["_l64a"] = createExportWrapper("l64a");

/** @type {function(...*):?} */
var _basename = Module["_basename"] = createExportWrapper("basename");

/** @type {function(...*):?} */
var ___xpg_basename = Module["___xpg_basename"] = createExportWrapper("__xpg_basename");

/** @type {function(...*):?} */
var _dirname = Module["_dirname"] = createExportWrapper("dirname");

/** @type {function(...*):?} */
var ___emscripten_pthread_data_constructor = Module["___emscripten_pthread_data_constructor"] = createExportWrapper("__emscripten_pthread_data_constructor");

/** @type {function(...*):?} */
var _ffs = Module["_ffs"] = createExportWrapper("ffs");

/** @type {function(...*):?} */
var _ffsl = Module["_ffsl"] = createExportWrapper("ffsl");

/** @type {function(...*):?} */
var _ffsll = Module["_ffsll"] = createExportWrapper("ffsll");

/** @type {function(...*):?} */
var _fmtmsg = Module["_fmtmsg"] = createExportWrapper("fmtmsg");

/** @type {function(...*):?} */
var _dprintf = Module["_dprintf"] = createExportWrapper("dprintf");

/** @type {function(...*):?} */
var _forkpty = Module["_forkpty"] = createExportWrapper("forkpty");

/** @type {function(...*):?} */
var _openpty = Module["_openpty"] = createExportWrapper("openpty");

/** @type {function(...*):?} */
var _pipe2 = Module["_pipe2"] = createExportWrapper("pipe2");

/** @type {function(...*):?} */
var _login_tty = Module["_login_tty"] = createExportWrapper("login_tty");

/** @type {function(...*):?} */
var _read = Module["_read"] = createExportWrapper("read");

/** @type {function(...*):?} */
var _write = Module["_write"] = createExportWrapper("write");

/** @type {function(...*):?} */
var _get_current_dir_name = Module["_get_current_dir_name"] = createExportWrapper("get_current_dir_name");

/** @type {function(...*):?} */
var _stat = Module["_stat"] = createExportWrapper("stat");

/** @type {function(...*):?} */
var _strdup = Module["_strdup"] = createExportWrapper("strdup");

/** @type {function(...*):?} */
var _getcwd = Module["_getcwd"] = createExportWrapper("getcwd");

/** @type {function(...*):?} */
var _getauxval = Module["_getauxval"] = createExportWrapper("getauxval");

/** @type {function(...*):?} */
var _getdomainname = Module["_getdomainname"] = createExportWrapper("getdomainname");

/** @type {function(...*):?} */
var _uname = Module["_uname"] = createExportWrapper("uname");

/** @type {function(...*):?} */
var _gethostid = Module["_gethostid"] = createExportWrapper("gethostid");

/** @type {function(...*):?} */
var ___getopt_msg = Module["___getopt_msg"] = createExportWrapper("__getopt_msg");

/** @type {function(...*):?} */
var _flockfile = Module["_flockfile"] = createExportWrapper("flockfile");

/** @type {function(...*):?} */
var _fputs = Module["_fputs"] = createExportWrapper("fputs");

/** @type {function(...*):?} */
var _putc = Module["_putc"] = createExportWrapper("putc");

/** @type {function(...*):?} */
var _funlockfile = Module["_funlockfile"] = createExportWrapper("funlockfile");

/** @type {function(...*):?} */
var _getopt = Module["_getopt"] = createExportWrapper("getopt");

/** @type {function(...*):?} */
var _mbtowc = Module["_mbtowc"] = createExportWrapper("mbtowc");

/** @type {function(...*):?} */
var ___posix_getopt = Module["___posix_getopt"] = createExportWrapper("__posix_getopt");

/** @type {function(...*):?} */
var _getopt_long = Module["_getopt_long"] = createExportWrapper("getopt_long");

/** @type {function(...*):?} */
var _getopt_long_only = Module["_getopt_long_only"] = createExportWrapper("getopt_long_only");

/** @type {function(...*):?} */
var _getpriority = Module["_getpriority"] = createExportWrapper("getpriority");

/** @type {function(...*):?} */
var _getresgid = Module["_getresgid"] = createExportWrapper("getresgid");

/** @type {function(...*):?} */
var _getresuid = Module["_getresuid"] = createExportWrapper("getresuid");

/** @type {function(...*):?} */
var _getrlimit = Module["_getrlimit"] = createExportWrapper("getrlimit");

/** @type {function(...*):?} */
var _getrlimit64 = Module["_getrlimit64"] = createExportWrapper("getrlimit64");

/** @type {function(...*):?} */
var _getrusage = Module["_getrusage"] = createExportWrapper("getrusage");

/** @type {function(...*):?} */
var _getsubopt = Module["_getsubopt"] = createExportWrapper("getsubopt");

/** @type {function(...*):?} */
var _ioctl = Module["_ioctl"] = createExportWrapper("ioctl");

/** @type {function(...*):?} */
var _issetugid = Module["_issetugid"] = createExportWrapper("issetugid");

/** @type {function(...*):?} */
var _lockf = Module["_lockf"] = createExportWrapper("lockf");

/** @type {function(...*):?} */
var _getpid = Module["_getpid"] = createExportWrapper("getpid");

/** @type {function(...*):?} */
var _lockf64 = Module["_lockf64"] = createExportWrapper("lockf64");

/** @type {function(...*):?} */
var _setsid = Module["_setsid"] = createExportWrapper("setsid");

/** @type {function(...*):?} */
var _dup2 = Module["_dup2"] = createExportWrapper("dup2");

/** @type {function(...*):?} */
var _setmntent = Module["_setmntent"] = createExportWrapper("setmntent");

/** @type {function(...*):?} */
var _endmntent = Module["_endmntent"] = createExportWrapper("endmntent");

/** @type {function(...*):?} */
var _getmntent_r = Module["_getmntent_r"] = createExportWrapper("getmntent_r");

/** @type {function(...*):?} */
var _fgets = Module["_fgets"] = createExportWrapper("fgets");

/** @type {function(...*):?} */
var _fscanf = Module["_fscanf"] = createExportWrapper("fscanf");

/** @type {function(...*):?} */
var _getmntent = Module["_getmntent"] = createExportWrapper("getmntent");

/** @type {function(...*):?} */
var _addmntent = Module["_addmntent"] = createExportWrapper("addmntent");

/** @type {function(...*):?} */
var _fprintf = Module["_fprintf"] = createExportWrapper("fprintf");

/** @type {function(...*):?} */
var _hasmntopt = Module["_hasmntopt"] = createExportWrapper("hasmntopt");

/** @type {function(...*):?} */
var _strstr = Module["_strstr"] = createExportWrapper("strstr");

/** @type {function(...*):?} */
var _nftw = Module["_nftw"] = createExportWrapper("nftw");

/** @type {function(...*):?} */
var _lstat = Module["_lstat"] = createExportWrapper("lstat");

/** @type {function(...*):?} */
var _access = Module["_access"] = createExportWrapper("access");

/** @type {function(...*):?} */
var _strrchr = Module["_strrchr"] = createExportWrapper("strrchr");

/** @type {function(...*):?} */
var _nftw64 = Module["_nftw64"] = createExportWrapper("nftw64");

/** @type {function(...*):?} */
var _tcsetattr = Module["_tcsetattr"] = createExportWrapper("tcsetattr");

/** @type {function(...*):?} */
var _ptsname = Module["_ptsname"] = createExportWrapper("ptsname");

/** @type {function(...*):?} */
var ___ptsname_r = Module["___ptsname_r"] = createExportWrapper("__ptsname_r");

/** @type {function(...*):?} */
var _posix_openpt = Module["_posix_openpt"] = createExportWrapper("posix_openpt");

/** @type {function(...*):?} */
var _grantpt = Module["_grantpt"] = createExportWrapper("grantpt");

/** @type {function(...*):?} */
var _unlockpt = Module["_unlockpt"] = createExportWrapper("unlockpt");

/** @type {function(...*):?} */
var _ptsname_r = Module["_ptsname_r"] = createExportWrapper("ptsname_r");

/** @type {function(...*):?} */
var _realpath = Module["_realpath"] = createExportWrapper("realpath");

/** @type {function(...*):?} */
var _readlink = Module["_readlink"] = createExportWrapper("readlink");

/** @type {function(...*):?} */
var _setdomainname = Module["_setdomainname"] = createExportWrapper("setdomainname");

/** @type {function(...*):?} */
var _setpriority = Module["_setpriority"] = createExportWrapper("setpriority");

/** @type {function(...*):?} */
var ___setrlimit = Module["___setrlimit"] = createExportWrapper("__setrlimit");

/** @type {function(...*):?} */
var _setrlimit = Module["_setrlimit"] = createExportWrapper("setrlimit");

/** @type {function(...*):?} */
var _setrlimit64 = Module["_setrlimit64"] = createExportWrapper("setrlimit64");

/** @type {function(...*):?} */
var _setlogmask = Module["_setlogmask"] = createExportWrapper("setlogmask");

/** @type {function(...*):?} */
var _closelog = Module["_closelog"] = createExportWrapper("closelog");

/** @type {function(...*):?} */
var _openlog = Module["_openlog"] = createExportWrapper("openlog");

/** @type {function(...*):?} */
var ___vsyslog = Module["___vsyslog"] = createExportWrapper("__vsyslog");

/** @type {function(...*):?} */
var _vsnprintf = Module["_vsnprintf"] = createExportWrapper("vsnprintf");

/** @type {function(...*):?} */
var _send = Module["_send"] = createExportWrapper("send");

/** @type {function(...*):?} */
var _connect = Module["_connect"] = createExportWrapper("connect");

/** @type {function(...*):?} */
var _syslog = Module["_syslog"] = createExportWrapper("syslog");

/** @type {function(...*):?} */
var _socket = Module["_socket"] = createExportWrapper("socket");

/** @type {function(...*):?} */
var _vsyslog = Module["_vsyslog"] = createExportWrapper("vsyslog");

/** @type {function(...*):?} */
var ___madvise = Module["___madvise"] = createExportWrapper("__madvise");

/** @type {function(...*):?} */
var _madvise = Module["_madvise"] = createExportWrapper("madvise");

/** @type {function(...*):?} */
var _mincore = Module["_mincore"] = createExportWrapper("mincore");

/** @type {function(...*):?} */
var _mlock = Module["_mlock"] = createExportWrapper("mlock");

/** @type {function(...*):?} */
var _mlockall = Module["_mlockall"] = createExportWrapper("mlockall");

/** @type {function(...*):?} */
var ___mmap = Module["___mmap"] = createExportWrapper("__mmap");

/** @type {function(...*):?} */
var ___vm_wait = Module["___vm_wait"] = createExportWrapper("__vm_wait");

/** @type {function(...*):?} */
var _mmap = Module["_mmap"] = createExportWrapper("mmap");

/** @type {function(...*):?} */
var _mmap64 = Module["_mmap64"] = createExportWrapper("mmap64");

/** @type {function(...*):?} */
var ___mprotect = Module["___mprotect"] = createExportWrapper("__mprotect");

/** @type {function(...*):?} */
var _mprotect = Module["_mprotect"] = createExportWrapper("mprotect");

/** @type {function(...*):?} */
var ___mremap = Module["___mremap"] = createExportWrapper("__mremap");

/** @type {function(...*):?} */
var _mremap = Module["_mremap"] = createExportWrapper("mremap");

/** @type {function(...*):?} */
var _msync = Module["_msync"] = createExportWrapper("msync");

/** @type {function(...*):?} */
var _munlock = Module["_munlock"] = createExportWrapper("munlock");

/** @type {function(...*):?} */
var _munlockall = Module["_munlockall"] = createExportWrapper("munlockall");

/** @type {function(...*):?} */
var _munmap = Module["_munmap"] = createExportWrapper("munmap");

/** @type {function(...*):?} */
var _posix_madvise = Module["_posix_madvise"] = createExportWrapper("posix_madvise");

/** @type {function(...*):?} */
var ___shm_mapname = Module["___shm_mapname"] = createExportWrapper("__shm_mapname");

/** @type {function(...*):?} */
var _shm_open = Module["_shm_open"] = createExportWrapper("shm_open");

/** @type {function(...*):?} */
var _shm_unlink = Module["_shm_unlink"] = createExportWrapper("shm_unlink");

/** @type {function(...*):?} */
var _unlink = Module["_unlink"] = createExportWrapper("unlink");

/** @type {function(...*):?} */
var _btowc = Module["_btowc"] = createExportWrapper("btowc");

/** @type {function(...*):?} */
var _c16rtomb = Module["_c16rtomb"] = createExportWrapper("c16rtomb");

/** @type {function(...*):?} */
var _wcrtomb = Module["_wcrtomb"] = createExportWrapper("wcrtomb");

/** @type {function(...*):?} */
var _c32rtomb = Module["_c32rtomb"] = createExportWrapper("c32rtomb");

/** @type {function(...*):?} */
var _mblen = Module["_mblen"] = createExportWrapper("mblen");

/** @type {function(...*):?} */
var _mbrlen = Module["_mbrlen"] = createExportWrapper("mbrlen");

/** @type {function(...*):?} */
var _mbrtoc16 = Module["_mbrtoc16"] = createExportWrapper("mbrtoc16");

/** @type {function(...*):?} */
var _mbrtoc32 = Module["_mbrtoc32"] = createExportWrapper("mbrtoc32");

/** @type {function(...*):?} */
var _mbsinit = Module["_mbsinit"] = createExportWrapper("mbsinit");

/** @type {function(...*):?} */
var _mbsnrtowcs = Module["_mbsnrtowcs"] = createExportWrapper("mbsnrtowcs");

/** @type {function(...*):?} */
var _mbsrtowcs = Module["_mbsrtowcs"] = createExportWrapper("mbsrtowcs");

/** @type {function(...*):?} */
var _mbstowcs = Module["_mbstowcs"] = createExportWrapper("mbstowcs");

/** @type {function(...*):?} */
var _wcsnrtombs = Module["_wcsnrtombs"] = createExportWrapper("wcsnrtombs");

/** @type {function(...*):?} */
var _wcsrtombs = Module["_wcsrtombs"] = createExportWrapper("wcsrtombs");

/** @type {function(...*):?} */
var _wcstombs = Module["_wcstombs"] = createExportWrapper("wcstombs");

/** @type {function(...*):?} */
var _wctob = Module["_wctob"] = createExportWrapper("wctob");

/** @type {function(...*):?} */
var _accept4 = Module["_accept4"] = createExportWrapper("accept4");

/** @type {function(...*):?} */
var _accept = Module["_accept"] = createExportWrapper("accept");

/** @type {function(...*):?} */
var ___dn_comp = Module["___dn_comp"] = createExportWrapper("__dn_comp");

/** @type {function(...*):?} */
var _dn_comp = Module["_dn_comp"] = createExportWrapper("dn_comp");

/** @type {function(...*):?} */
var ___dn_expand = Module["___dn_expand"] = createExportWrapper("__dn_expand");

/** @type {function(...*):?} */
var _dn_expand = Module["_dn_expand"] = createExportWrapper("dn_expand");

/** @type {function(...*):?} */
var _dn_skipname = Module["_dn_skipname"] = createExportWrapper("dn_skipname");

/** @type {function(...*):?} */
var ___dns_parse = Module["___dns_parse"] = createExportWrapper("__dns_parse");

/** @type {function(...*):?} */
var _sethostent = Module["_sethostent"] = createExportWrapper("sethostent");

/** @type {function(...*):?} */
var _gethostent = Module["_gethostent"] = createExportWrapper("gethostent");

/** @type {function(...*):?} */
var _endhostent = Module["_endhostent"] = createExportWrapper("endhostent");

/** @type {function(...*):?} */
var _setnetent = Module["_setnetent"] = createExportWrapper("setnetent");

/** @type {function(...*):?} */
var _getnetent = Module["_getnetent"] = createExportWrapper("getnetent");

/** @type {function(...*):?} */
var _endnetent = Module["_endnetent"] = createExportWrapper("endnetent");

/** @type {function(...*):?} */
var _ether_aton_r = Module["_ether_aton_r"] = createExportWrapper("ether_aton_r");

/** @type {function(...*):?} */
var _ether_aton = Module["_ether_aton"] = createExportWrapper("ether_aton");

/** @type {function(...*):?} */
var _ether_ntoa_r = Module["_ether_ntoa_r"] = createExportWrapper("ether_ntoa_r");

/** @type {function(...*):?} */
var _ether_ntoa = Module["_ether_ntoa"] = createExportWrapper("ether_ntoa");

/** @type {function(...*):?} */
var _ether_line = Module["_ether_line"] = createExportWrapper("ether_line");

/** @type {function(...*):?} */
var _ether_ntohost = Module["_ether_ntohost"] = createExportWrapper("ether_ntohost");

/** @type {function(...*):?} */
var _ether_hostton = Module["_ether_hostton"] = createExportWrapper("ether_hostton");

/** @type {function(...*):?} */
var _freeifaddrs = Module["_freeifaddrs"] = createExportWrapper("freeifaddrs");

/** @type {function(...*):?} */
var _getifaddrs = Module["_getifaddrs"] = createExportWrapper("getifaddrs");

/** @type {function(...*):?} */
var ___rtnetlink_enumerate = Module["___rtnetlink_enumerate"] = createExportWrapper("__rtnetlink_enumerate");

/** @type {function(...*):?} */
var _getservbyname = Module["_getservbyname"] = createExportWrapper("getservbyname");

/** @type {function(...*):?} */
var _getservbyname_r = Module["_getservbyname_r"] = createExportWrapper("getservbyname_r");

/** @type {function(...*):?} */
var ___lookup_serv = Module["___lookup_serv"] = createExportWrapper("__lookup_serv");

/** @type {function(...*):?} */
var _htons = Module["_htons"] = createExportWrapper("htons");

/** @type {function(...*):?} */
var _getservbyport = Module["_getservbyport"] = createExportWrapper("getservbyport");

/** @type {function(...*):?} */
var _getservbyport_r = Module["_getservbyport_r"] = createExportWrapper("getservbyport_r");

/** @type {function(...*):?} */
var ___h_errno_location = Module["___h_errno_location"] = createExportWrapper("__h_errno_location");

/** @type {function(...*):?} */
var _herror = Module["_herror"] = createExportWrapper("herror");

/** @type {function(...*):?} */
var _hstrerror = Module["_hstrerror"] = createExportWrapper("hstrerror");

/** @type {function(...*):?} */
var _htonl = Module["_htonl"] = createExportWrapper("htonl");

/** @type {function(...*):?} */
var _if_freenameindex = Module["_if_freenameindex"] = createExportWrapper("if_freenameindex");

/** @type {function(...*):?} */
var _if_indextoname = Module["_if_indextoname"] = createExportWrapper("if_indextoname");

/** @type {function(...*):?} */
var _strncpy = Module["_strncpy"] = createExportWrapper("strncpy");

/** @type {function(...*):?} */
var _if_nameindex = Module["_if_nameindex"] = createExportWrapper("if_nameindex");

/** @type {function(...*):?} */
var _if_nametoindex = Module["_if_nametoindex"] = createExportWrapper("if_nametoindex");

/** @type {function(...*):?} */
var ___inet_aton = Module["___inet_aton"] = createExportWrapper("__inet_aton");

/** @type {function(...*):?} */
var _inet_aton = Module["_inet_aton"] = createExportWrapper("inet_aton");

/** @type {function(...*):?} */
var _inet_network = Module["_inet_network"] = createExportWrapper("inet_network");

/** @type {function(...*):?} */
var _ntohl = Module["_ntohl"] = createExportWrapper("ntohl");

/** @type {function(...*):?} */
var _inet_makeaddr = Module["_inet_makeaddr"] = createExportWrapper("inet_makeaddr");

/** @type {function(...*):?} */
var _inet_lnaof = Module["_inet_lnaof"] = createExportWrapper("inet_lnaof");

/** @type {function(...*):?} */
var _inet_netof = Module["_inet_netof"] = createExportWrapper("inet_netof");

/** @type {function(...*):?} */
var _inet_ntoa = Module["_inet_ntoa"] = createExportWrapper("inet_ntoa");

/** @type {function(...*):?} */
var _inet_ntop = Module["_inet_ntop"] = createExportWrapper("inet_ntop");

/** @type {function(...*):?} */
var _strspn = Module["_strspn"] = createExportWrapper("strspn");

/** @type {function(...*):?} */
var _inet_pton = Module["_inet_pton"] = createExportWrapper("inet_pton");

/** @type {function(...*):?} */
var ___lookup_ipliteral = Module["___lookup_ipliteral"] = createExportWrapper("__lookup_ipliteral");

/** @type {function(...*):?} */
var ___lookup_name = Module["___lookup_name"] = createExportWrapper("__lookup_name");

/** @type {function(...*):?} */
var _getsockname = Module["_getsockname"] = createExportWrapper("getsockname");

/** @type {function(...*):?} */
var ___fopen_rb_ca = Module["___fopen_rb_ca"] = createExportWrapper("__fopen_rb_ca");

/** @type {function(...*):?} */
var ___fclose_ca = Module["___fclose_ca"] = createExportWrapper("__fclose_ca");

/** @type {function(...*):?} */
var ___get_resolv_conf = Module["___get_resolv_conf"] = createExportWrapper("__get_resolv_conf");

/** @type {function(...*):?} */
var ___res_mkquery = Module["___res_mkquery"] = createExportWrapper("__res_mkquery");

/** @type {function(...*):?} */
var ___res_msend_rc = Module["___res_msend_rc"] = createExportWrapper("__res_msend_rc");

/** @type {function(...*):?} */
var _recv = Module["_recv"] = createExportWrapper("recv");

/** @type {function(...*):?} */
var _getnetbyaddr = Module["_getnetbyaddr"] = createExportWrapper("getnetbyaddr");

/** @type {function(...*):?} */
var _getnetbyname = Module["_getnetbyname"] = createExportWrapper("getnetbyname");

/** @type {function(...*):?} */
var _ns_get16 = Module["_ns_get16"] = createExportWrapper("ns_get16");

/** @type {function(...*):?} */
var _ns_get32 = Module["_ns_get32"] = createExportWrapper("ns_get32");

/** @type {function(...*):?} */
var _ns_put16 = Module["_ns_put16"] = createExportWrapper("ns_put16");

/** @type {function(...*):?} */
var _ns_put32 = Module["_ns_put32"] = createExportWrapper("ns_put32");

/** @type {function(...*):?} */
var _ns_skiprr = Module["_ns_skiprr"] = createExportWrapper("ns_skiprr");

/** @type {function(...*):?} */
var _ns_initparse = Module["_ns_initparse"] = createExportWrapper("ns_initparse");

/** @type {function(...*):?} */
var _ns_name_uncompress = Module["_ns_name_uncompress"] = createExportWrapper("ns_name_uncompress");

/** @type {function(...*):?} */
var _ns_parserr = Module["_ns_parserr"] = createExportWrapper("ns_parserr");

/** @type {function(...*):?} */
var _ntohs = Module["_ntohs"] = createExportWrapper("ntohs");

/** @type {function(...*):?} */
var _recvmmsg = Module["_recvmmsg"] = createExportWrapper("recvmmsg");

/** @type {function(...*):?} */
var _res_init = Module["_res_init"] = createExportWrapper("res_init");

/** @type {function(...*):?} */
var _res_mkquery = Module["_res_mkquery"] = createExportWrapper("res_mkquery");

/** @type {function(...*):?} */
var _bind = Module["_bind"] = createExportWrapper("bind");

/** @type {function(...*):?} */
var _setsockopt = Module["_setsockopt"] = createExportWrapper("setsockopt");

/** @type {function(...*):?} */
var _sendto = Module["_sendto"] = createExportWrapper("sendto");

/** @type {function(...*):?} */
var _poll = Module["_poll"] = createExportWrapper("poll");

/** @type {function(...*):?} */
var _recvfrom = Module["_recvfrom"] = createExportWrapper("recvfrom");

/** @type {function(...*):?} */
var ___res_msend = Module["___res_msend"] = createExportWrapper("__res_msend");

/** @type {function(...*):?} */
var ___res_send = Module["___res_send"] = createExportWrapper("__res_send");

/** @type {function(...*):?} */
var _res_send = Module["_res_send"] = createExportWrapper("res_send");

/** @type {function(...*):?} */
var ___res_state = Module["___res_state"] = createExportWrapper("__res_state");

/** @type {function(...*):?} */
var _getc = Module["_getc"] = createExportWrapper("getc");

/** @type {function(...*):?} */
var _sendmmsg = Module["_sendmmsg"] = createExportWrapper("sendmmsg");

/** @type {function(...*):?} */
var _endservent = Module["_endservent"] = createExportWrapper("endservent");

/** @type {function(...*):?} */
var _setservent = Module["_setservent"] = createExportWrapper("setservent");

/** @type {function(...*):?} */
var _getservent = Module["_getservent"] = createExportWrapper("getservent");

/** @type {function(...*):?} */
var _sockatmark = Module["_sockatmark"] = createExportWrapper("sockatmark");

/** @type {function(...*):?} */
var ___rand48_step = Module["___rand48_step"] = createExportWrapper("__rand48_step");

/** @type {function(...*):?} */
var _erand48 = Module["_erand48"] = createExportWrapper("erand48");

/** @type {function(...*):?} */
var _drand48 = Module["_drand48"] = createExportWrapper("drand48");

/** @type {function(...*):?} */
var _lcong48 = Module["_lcong48"] = createExportWrapper("lcong48");

/** @type {function(...*):?} */
var _nrand48 = Module["_nrand48"] = createExportWrapper("nrand48");

/** @type {function(...*):?} */
var _lrand48 = Module["_lrand48"] = createExportWrapper("lrand48");

/** @type {function(...*):?} */
var _jrand48 = Module["_jrand48"] = createExportWrapper("jrand48");

/** @type {function(...*):?} */
var _mrand48 = Module["_mrand48"] = createExportWrapper("mrand48");

/** @type {function(...*):?} */
var _srand = Module["_srand"] = createExportWrapper("srand");

/** @type {function(...*):?} */
var _rand = Module["_rand"] = createExportWrapper("rand");

/** @type {function(...*):?} */
var _rand_r = Module["_rand_r"] = createExportWrapper("rand_r");

/** @type {function(...*):?} */
var _srandom = Module["_srandom"] = createExportWrapper("srandom");

/** @type {function(...*):?} */
var _initstate = Module["_initstate"] = createExportWrapper("initstate");

/** @type {function(...*):?} */
var _setstate = Module["_setstate"] = createExportWrapper("setstate");

/** @type {function(...*):?} */
var _random = Module["_random"] = createExportWrapper("random");

/** @type {function(...*):?} */
var _seed48 = Module["_seed48"] = createExportWrapper("seed48");

/** @type {function(...*):?} */
var _srand48 = Module["_srand48"] = createExportWrapper("srand48");

/** @type {function(...*):?} */
var _fnmatch = Module["_fnmatch"] = createExportWrapper("fnmatch");

/** @type {function(...*):?} */
var _glob = Module["_glob"] = createExportWrapper("glob");

/** @type {function(...*):?} */
var _strcat = Module["_strcat"] = createExportWrapper("strcat");

/** @type {function(...*):?} */
var _globfree = Module["_globfree"] = createExportWrapper("globfree");

/** @type {function(...*):?} */
var _glob64 = Module["_glob64"] = createExportWrapper("glob64");

/** @type {function(...*):?} */
var _globfree64 = Module["_globfree64"] = createExportWrapper("globfree64");

/** @type {function(...*):?} */
var _regcomp = Module["_regcomp"] = createExportWrapper("regcomp");

/** @type {function(...*):?} */
var ___tre_mem_new_impl = Module["___tre_mem_new_impl"] = createExportWrapper("__tre_mem_new_impl");

/** @type {function(...*):?} */
var ___tre_mem_destroy = Module["___tre_mem_destroy"] = createExportWrapper("__tre_mem_destroy");

/** @type {function(...*):?} */
var _regfree = Module["_regfree"] = createExportWrapper("regfree");

/** @type {function(...*):?} */
var ___tre_mem_alloc_impl = Module["___tre_mem_alloc_impl"] = createExportWrapper("__tre_mem_alloc_impl");

/** @type {function(...*):?} */
var _regerror = Module["_regerror"] = createExportWrapper("regerror");

/** @type {function(...*):?} */
var _regexec = Module["_regexec"] = createExportWrapper("regexec");

/** @type {function(...*):?} */
var _pselect = Module["_pselect"] = createExportWrapper("pselect");

/** @type {function(...*):?} */
var _select = Module["_select"] = createExportWrapper("select");

/** @type {function(...*):?} */
var ___fxstat = Module["___fxstat"] = createExportWrapper("__fxstat");

/** @type {function(...*):?} */
var ___fxstatat = Module["___fxstatat"] = createExportWrapper("__fxstatat");

/** @type {function(...*):?} */
var _fstatat = Module["_fstatat"] = createExportWrapper("fstatat");

/** @type {function(...*):?} */
var ___lxstat = Module["___lxstat"] = createExportWrapper("__lxstat");

/** @type {function(...*):?} */
var ___xstat = Module["___xstat"] = createExportWrapper("__xstat");

/** @type {function(...*):?} */
var ___xmknod = Module["___xmknod"] = createExportWrapper("__xmknod");

/** @type {function(...*):?} */
var _mknod = Module["_mknod"] = createExportWrapper("mknod");

/** @type {function(...*):?} */
var ___xmknodat = Module["___xmknodat"] = createExportWrapper("__xmknodat");

/** @type {function(...*):?} */
var _mknodat = Module["_mknodat"] = createExportWrapper("mknodat");

/** @type {function(...*):?} */
var ___fxstat64 = Module["___fxstat64"] = createExportWrapper("__fxstat64");

/** @type {function(...*):?} */
var ___fxstatat64 = Module["___fxstatat64"] = createExportWrapper("__fxstatat64");

/** @type {function(...*):?} */
var ___lxstat64 = Module["___lxstat64"] = createExportWrapper("__lxstat64");

/** @type {function(...*):?} */
var ___xstat64 = Module["___xstat64"] = createExportWrapper("__xstat64");

/** @type {function(...*):?} */
var _chmod = Module["_chmod"] = createExportWrapper("chmod");

/** @type {function(...*):?} */
var _fchmod = Module["_fchmod"] = createExportWrapper("fchmod");

/** @type {function(...*):?} */
var ___wasi_fd_is_valid = Module["___wasi_fd_is_valid"] = createExportWrapper("__wasi_fd_is_valid");

/** @type {function(...*):?} */
var _fchmodat = Module["_fchmodat"] = createExportWrapper("fchmodat");

/** @type {function(...*):?} */
var _fstat64 = Module["_fstat64"] = createExportWrapper("fstat64");

/** @type {function(...*):?} */
var _fstatat64 = Module["_fstatat64"] = createExportWrapper("fstatat64");

/** @type {function(...*):?} */
var _futimens = Module["_futimens"] = createExportWrapper("futimens");

/** @type {function(...*):?} */
var _utimensat = Module["_utimensat"] = createExportWrapper("utimensat");

/** @type {function(...*):?} */
var ___futimesat = Module["___futimesat"] = createExportWrapper("__futimesat");

/** @type {function(...*):?} */
var _futimesat = Module["_futimesat"] = createExportWrapper("futimesat");

/** @type {function(...*):?} */
var _lchmod = Module["_lchmod"] = createExportWrapper("lchmod");

/** @type {function(...*):?} */
var _lstat64 = Module["_lstat64"] = createExportWrapper("lstat64");

/** @type {function(...*):?} */
var _mkdir = Module["_mkdir"] = createExportWrapper("mkdir");

/** @type {function(...*):?} */
var _mkdirat = Module["_mkdirat"] = createExportWrapper("mkdirat");

/** @type {function(...*):?} */
var _mkfifo = Module["_mkfifo"] = createExportWrapper("mkfifo");

/** @type {function(...*):?} */
var _mkfifoat = Module["_mkfifoat"] = createExportWrapper("mkfifoat");

/** @type {function(...*):?} */
var _stat64 = Module["_stat64"] = createExportWrapper("stat64");

/** @type {function(...*):?} */
var ___statfs = Module["___statfs"] = createExportWrapper("__statfs");

/** @type {function(...*):?} */
var ___fstatfs = Module["___fstatfs"] = createExportWrapper("__fstatfs");

/** @type {function(...*):?} */
var _statvfs = Module["_statvfs"] = createExportWrapper("statvfs");

/** @type {function(...*):?} */
var _fstatvfs = Module["_fstatvfs"] = createExportWrapper("fstatvfs");

/** @type {function(...*):?} */
var _statfs = Module["_statfs"] = createExportWrapper("statfs");

/** @type {function(...*):?} */
var _fstatfs = Module["_fstatfs"] = createExportWrapper("fstatfs");

/** @type {function(...*):?} */
var _statvfs64 = Module["_statvfs64"] = createExportWrapper("statvfs64");

/** @type {function(...*):?} */
var _statfs64 = Module["_statfs64"] = createExportWrapper("statfs64");

/** @type {function(...*):?} */
var _fstatvfs64 = Module["_fstatvfs64"] = createExportWrapper("fstatvfs64");

/** @type {function(...*):?} */
var _fstatfs64 = Module["_fstatfs64"] = createExportWrapper("fstatfs64");

/** @type {function(...*):?} */
var _umask = Module["_umask"] = createExportWrapper("umask");

/** @type {function(...*):?} */
var ___fdopen = Module["___fdopen"] = createExportWrapper("__fdopen");

/** @type {function(...*):?} */
var ___stdio_seek = Module["___stdio_seek"] = createExportWrapper("__stdio_seek");

/** @type {function(...*):?} */
var ___stdio_write = Module["___stdio_write"] = createExportWrapper("__stdio_write");

/** @type {function(...*):?} */
var ___stdio_read = Module["___stdio_read"] = createExportWrapper("__stdio_read");

/** @type {function(...*):?} */
var ___stdio_close = Module["___stdio_close"] = createExportWrapper("__stdio_close");

/** @type {function(...*):?} */
var ___ofl_add = Module["___ofl_add"] = createExportWrapper("__ofl_add");

/** @type {function(...*):?} */
var _fdopen = Module["_fdopen"] = createExportWrapper("fdopen");

/** @type {function(...*):?} */
var ___fmodeflags = Module["___fmodeflags"] = createExportWrapper("__fmodeflags");

/** @type {function(...*):?} */
var ___aio_close = Module["___aio_close"] = createExportWrapper("__aio_close");

/** @type {function(...*):?} */
var ___stdio_exit = Module["___stdio_exit"] = createExportWrapper("__stdio_exit");

/** @type {function(...*):?} */
var ___ofl_lock = Module["___ofl_lock"] = createExportWrapper("__ofl_lock");

/** @type {function(...*):?} */
var ___lockfile = Module["___lockfile"] = createExportWrapper("__lockfile");

/** @type {function(...*):?} */
var ___stdio_exit_needed = Module["___stdio_exit_needed"] = createExportWrapper("__stdio_exit_needed");

/** @type {function(...*):?} */
var ___wasi_syscall_ret = Module["___wasi_syscall_ret"] = createExportWrapper("__wasi_syscall_ret");

/** @type {function(...*):?} */
var ___stdout_write = Module["___stdout_write"] = createExportWrapper("__stdout_write");

/** @type {function(...*):?} */
var ___string_read = Module["___string_read"] = createExportWrapper("__string_read");

/** @type {function(...*):?} */
var _memchr = Module["_memchr"] = createExportWrapper("memchr");

/** @type {function(...*):?} */
var ___toread = Module["___toread"] = createExportWrapper("__toread");

/** @type {function(...*):?} */
var ___toread_needs_stdio_exit = Module["___toread_needs_stdio_exit"] = createExportWrapper("__toread_needs_stdio_exit");

/** @type {function(...*):?} */
var _asprintf = Module["_asprintf"] = createExportWrapper("asprintf");

/** @type {function(...*):?} */
var _vasprintf = Module["_vasprintf"] = createExportWrapper("vasprintf");

/** @type {function(...*):?} */
var _clearerr = Module["_clearerr"] = createExportWrapper("clearerr");

/** @type {function(...*):?} */
var ___unlockfile = Module["___unlockfile"] = createExportWrapper("__unlockfile");

/** @type {function(...*):?} */
var _clearerr_unlocked = Module["_clearerr_unlocked"] = createExportWrapper("clearerr_unlocked");

/** @type {function(...*):?} */
var _vdprintf = Module["_vdprintf"] = createExportWrapper("vdprintf");

/** @type {function(...*):?} */
var __flushlbf = Module["__flushlbf"] = createExportWrapper("_flushlbf");

/** @type {function(...*):?} */
var _fflush = Module["_fflush"] = createExportWrapper("fflush");

/** @type {function(...*):?} */
var ___fsetlocking = Module["___fsetlocking"] = createExportWrapper("__fsetlocking");

/** @type {function(...*):?} */
var ___fwriting = Module["___fwriting"] = createExportWrapper("__fwriting");

/** @type {function(...*):?} */
var ___freading = Module["___freading"] = createExportWrapper("__freading");

/** @type {function(...*):?} */
var ___freadable = Module["___freadable"] = createExportWrapper("__freadable");

/** @type {function(...*):?} */
var ___fwritable = Module["___fwritable"] = createExportWrapper("__fwritable");

/** @type {function(...*):?} */
var ___flbf = Module["___flbf"] = createExportWrapper("__flbf");

/** @type {function(...*):?} */
var ___fbufsize = Module["___fbufsize"] = createExportWrapper("__fbufsize");

/** @type {function(...*):?} */
var ___fpending = Module["___fpending"] = createExportWrapper("__fpending");

/** @type {function(...*):?} */
var ___fpurge = Module["___fpurge"] = createExportWrapper("__fpurge");

/** @type {function(...*):?} */
var _fpurge = Module["_fpurge"] = createExportWrapper("fpurge");

/** @type {function(...*):?} */
var ___freadahead = Module["___freadahead"] = createExportWrapper("__freadahead");

/** @type {function(...*):?} */
var ___freadptr = Module["___freadptr"] = createExportWrapper("__freadptr");

/** @type {function(...*):?} */
var ___freadptrinc = Module["___freadptrinc"] = createExportWrapper("__freadptrinc");

/** @type {function(...*):?} */
var ___fseterr = Module["___fseterr"] = createExportWrapper("__fseterr");

/** @type {function(...*):?} */
var ___unlist_locked_file = Module["___unlist_locked_file"] = createExportWrapper("__unlist_locked_file");

/** @type {function(...*):?} */
var ___ofl_unlock = Module["___ofl_unlock"] = createExportWrapper("__ofl_unlock");

/** @type {function(...*):?} */
var _feof_unlocked = Module["_feof_unlocked"] = createExportWrapper("feof_unlocked");

/** @type {function(...*):?} */
var __IO_feof_unlocked = Module["__IO_feof_unlocked"] = createExportWrapper("_IO_feof_unlocked");

/** @type {function(...*):?} */
var _ferror_unlocked = Module["_ferror_unlocked"] = createExportWrapper("ferror_unlocked");

/** @type {function(...*):?} */
var __IO_ferror_unlocked = Module["__IO_ferror_unlocked"] = createExportWrapper("_IO_ferror_unlocked");

/** @type {function(...*):?} */
var _fflush_unlocked = Module["_fflush_unlocked"] = createExportWrapper("fflush_unlocked");

/** @type {function(...*):?} */
var _fgetc = Module["_fgetc"] = createExportWrapper("fgetc");

/** @type {function(...*):?} */
var _fgetln = Module["_fgetln"] = createExportWrapper("fgetln");

/** @type {function(...*):?} */
var _ungetc = Module["_ungetc"] = createExportWrapper("ungetc");

/** @type {function(...*):?} */
var _getline = Module["_getline"] = createExportWrapper("getline");

/** @type {function(...*):?} */
var _fgetpos = Module["_fgetpos"] = createExportWrapper("fgetpos");

/** @type {function(...*):?} */
var ___ftello = Module["___ftello"] = createExportWrapper("__ftello");

/** @type {function(...*):?} */
var _fgetpos64 = Module["_fgetpos64"] = createExportWrapper("fgetpos64");

/** @type {function(...*):?} */
var _fgets_unlocked = Module["_fgets_unlocked"] = createExportWrapper("fgets_unlocked");

/** @type {function(...*):?} */
var ___fgetwc_unlocked = Module["___fgetwc_unlocked"] = createExportWrapper("__fgetwc_unlocked");

/** @type {function(...*):?} */
var _fwide = Module["_fwide"] = createExportWrapper("fwide");

/** @type {function(...*):?} */
var _fgetwc = Module["_fgetwc"] = createExportWrapper("fgetwc");

/** @type {function(...*):?} */
var _fgetwc_unlocked = Module["_fgetwc_unlocked"] = createExportWrapper("fgetwc_unlocked");

/** @type {function(...*):?} */
var _getwc_unlocked = Module["_getwc_unlocked"] = createExportWrapper("getwc_unlocked");

/** @type {function(...*):?} */
var _fgetws = Module["_fgetws"] = createExportWrapper("fgetws");

/** @type {function(...*):?} */
var _fgetws_unlocked = Module["_fgetws_unlocked"] = createExportWrapper("fgetws_unlocked");

/** @type {function(...*):?} */
var _fileno = Module["_fileno"] = createExportWrapper("fileno");

/** @type {function(...*):?} */
var _fileno_unlocked = Module["_fileno_unlocked"] = createExportWrapper("fileno_unlocked");

/** @type {function(...*):?} */
var _ftrylockfile = Module["_ftrylockfile"] = createExportWrapper("ftrylockfile");

/** @type {function(...*):?} */
var _fmemopen = Module["_fmemopen"] = createExportWrapper("fmemopen");

/** @type {function(...*):?} */
var _fopen64 = Module["_fopen64"] = createExportWrapper("fopen64");

/** @type {function(...*):?} */
var _vfprintf = Module["_vfprintf"] = createExportWrapper("vfprintf");

/** @type {function(...*):?} */
var _vfiprintf = Module["_vfiprintf"] = createExportWrapper("vfiprintf");

/** @type {function(...*):?} */
var ___small_fprintf = Module["___small_fprintf"] = createExportWrapper("__small_fprintf");

/** @type {function(...*):?} */
var ___small_vfprintf = Module["___small_vfprintf"] = createExportWrapper("__small_vfprintf");

/** @type {function(...*):?} */
var ___overflow = Module["___overflow"] = createExportWrapper("__overflow");

/** @type {function(...*):?} */
var ___fputwc_unlocked = Module["___fputwc_unlocked"] = createExportWrapper("__fputwc_unlocked");

/** @type {function(...*):?} */
var ___fwritex = Module["___fwritex"] = createExportWrapper("__fwritex");

/** @type {function(...*):?} */
var _fputwc = Module["_fputwc"] = createExportWrapper("fputwc");

/** @type {function(...*):?} */
var _fputwc_unlocked = Module["_fputwc_unlocked"] = createExportWrapper("fputwc_unlocked");

/** @type {function(...*):?} */
var _putwc_unlocked = Module["_putwc_unlocked"] = createExportWrapper("putwc_unlocked");

/** @type {function(...*):?} */
var _fputws = Module["_fputws"] = createExportWrapper("fputws");

/** @type {function(...*):?} */
var _fputws_unlocked = Module["_fputws_unlocked"] = createExportWrapper("fputws_unlocked");

/** @type {function(...*):?} */
var _fread_unlocked = Module["_fread_unlocked"] = createExportWrapper("fread_unlocked");

/** @type {function(...*):?} */
var _freopen = Module["_freopen"] = createExportWrapper("freopen");

/** @type {function(...*):?} */
var ___dup3 = Module["___dup3"] = createExportWrapper("__dup3");

/** @type {function(...*):?} */
var _freopen64 = Module["_freopen64"] = createExportWrapper("freopen64");

/** @type {function(...*):?} */
var _vfscanf = Module["_vfscanf"] = createExportWrapper("vfscanf");

/** @type {function(...*):?} */
var ___isoc99_fscanf = Module["___isoc99_fscanf"] = createExportWrapper("__isoc99_fscanf");

/** @type {function(...*):?} */
var ___fseeko_unlocked = Module["___fseeko_unlocked"] = createExportWrapper("__fseeko_unlocked");

/** @type {function(...*):?} */
var ___fseeko = Module["___fseeko"] = createExportWrapper("__fseeko");

/** @type {function(...*):?} */
var _fseeko = Module["_fseeko"] = createExportWrapper("fseeko");

/** @type {function(...*):?} */
var _fseeko64 = Module["_fseeko64"] = createExportWrapper("fseeko64");

/** @type {function(...*):?} */
var _fsetpos = Module["_fsetpos"] = createExportWrapper("fsetpos");

/** @type {function(...*):?} */
var _fsetpos64 = Module["_fsetpos64"] = createExportWrapper("fsetpos64");

/** @type {function(...*):?} */
var ___ftello_unlocked = Module["___ftello_unlocked"] = createExportWrapper("__ftello_unlocked");

/** @type {function(...*):?} */
var _ftello = Module["_ftello"] = createExportWrapper("ftello");

/** @type {function(...*):?} */
var _ftello64 = Module["_ftello64"] = createExportWrapper("ftello64");

/** @type {function(...*):?} */
var ___do_orphaned_stdio_locks = Module["___do_orphaned_stdio_locks"] = createExportWrapper("__do_orphaned_stdio_locks");

/** @type {function(...*):?} */
var _fwprintf = Module["_fwprintf"] = createExportWrapper("fwprintf");

/** @type {function(...*):?} */
var _vfwprintf = Module["_vfwprintf"] = createExportWrapper("vfwprintf");

/** @type {function(...*):?} */
var _fwscanf = Module["_fwscanf"] = createExportWrapper("fwscanf");

/** @type {function(...*):?} */
var _vfwscanf = Module["_vfwscanf"] = createExportWrapper("vfwscanf");

/** @type {function(...*):?} */
var ___isoc99_fwscanf = Module["___isoc99_fwscanf"] = createExportWrapper("__isoc99_fwscanf");

/** @type {function(...*):?} */
var __IO_getc = Module["__IO_getc"] = createExportWrapper("_IO_getc");

/** @type {function(...*):?} */
var _getc_unlocked = Module["_getc_unlocked"] = createExportWrapper("getc_unlocked");

/** @type {function(...*):?} */
var _fgetc_unlocked = Module["_fgetc_unlocked"] = createExportWrapper("fgetc_unlocked");

/** @type {function(...*):?} */
var __IO_getc_unlocked = Module["__IO_getc_unlocked"] = createExportWrapper("_IO_getc_unlocked");

/** @type {function(...*):?} */
var _getchar = Module["_getchar"] = createExportWrapper("getchar");

/** @type {function(...*):?} */
var _getchar_unlocked = Module["_getchar_unlocked"] = createExportWrapper("getchar_unlocked");

/** @type {function(...*):?} */
var _getdelim = Module["_getdelim"] = createExportWrapper("getdelim");

/** @type {function(...*):?} */
var ___getdelim = Module["___getdelim"] = createExportWrapper("__getdelim");

/** @type {function(...*):?} */
var _gets = Module["_gets"] = createExportWrapper("gets");

/** @type {function(...*):?} */
var _getw = Module["_getw"] = createExportWrapper("getw");

/** @type {function(...*):?} */
var _getwc = Module["_getwc"] = createExportWrapper("getwc");

/** @type {function(...*):?} */
var _getwchar = Module["_getwchar"] = createExportWrapper("getwchar");

/** @type {function(...*):?} */
var _getwchar_unlocked = Module["_getwchar_unlocked"] = createExportWrapper("getwchar_unlocked");

/** @type {function(...*):?} */
var _open_memstream = Module["_open_memstream"] = createExportWrapper("open_memstream");

/** @type {function(...*):?} */
var _open_wmemstream = Module["_open_wmemstream"] = createExportWrapper("open_wmemstream");

/** @type {function(...*):?} */
var _pclose = Module["_pclose"] = createExportWrapper("pclose");

/** @type {function(...*):?} */
var _perror = Module["_perror"] = createExportWrapper("perror");

/** @type {function(...*):?} */
var __IO_putc = Module["__IO_putc"] = createExportWrapper("_IO_putc");

/** @type {function(...*):?} */
var _putc_unlocked = Module["_putc_unlocked"] = createExportWrapper("putc_unlocked");

/** @type {function(...*):?} */
var _fputc_unlocked = Module["_fputc_unlocked"] = createExportWrapper("fputc_unlocked");

/** @type {function(...*):?} */
var __IO_putc_unlocked = Module["__IO_putc_unlocked"] = createExportWrapper("_IO_putc_unlocked");

/** @type {function(...*):?} */
var _putchar = Module["_putchar"] = createExportWrapper("putchar");

/** @type {function(...*):?} */
var _putchar_unlocked = Module["_putchar_unlocked"] = createExportWrapper("putchar_unlocked");

/** @type {function(...*):?} */
var _putw = Module["_putw"] = createExportWrapper("putw");

/** @type {function(...*):?} */
var _putwc = Module["_putwc"] = createExportWrapper("putwc");

/** @type {function(...*):?} */
var _putwchar = Module["_putwchar"] = createExportWrapper("putwchar");

/** @type {function(...*):?} */
var _putwchar_unlocked = Module["_putwchar_unlocked"] = createExportWrapper("putwchar_unlocked");

/** @type {function(...*):?} */
var _remove = Module["_remove"] = createExportWrapper("remove");

/** @type {function(...*):?} */
var _rename = Module["_rename"] = createExportWrapper("rename");

/** @type {function(...*):?} */
var _rewind = Module["_rewind"] = createExportWrapper("rewind");

/** @type {function(...*):?} */
var _scanf = Module["_scanf"] = createExportWrapper("scanf");

/** @type {function(...*):?} */
var _vscanf = Module["_vscanf"] = createExportWrapper("vscanf");

/** @type {function(...*):?} */
var ___isoc99_scanf = Module["___isoc99_scanf"] = createExportWrapper("__isoc99_scanf");

/** @type {function(...*):?} */
var _setbuf = Module["_setbuf"] = createExportWrapper("setbuf");

/** @type {function(...*):?} */
var _setvbuf = Module["_setvbuf"] = createExportWrapper("setvbuf");

/** @type {function(...*):?} */
var _setbuffer = Module["_setbuffer"] = createExportWrapper("setbuffer");

/** @type {function(...*):?} */
var _setlinebuf = Module["_setlinebuf"] = createExportWrapper("setlinebuf");

/** @type {function(...*):?} */
var _vsprintf = Module["_vsprintf"] = createExportWrapper("vsprintf");

/** @type {function(...*):?} */
var _siprintf = Module["_siprintf"] = createExportWrapper("siprintf");

/** @type {function(...*):?} */
var _vsiprintf = Module["_vsiprintf"] = createExportWrapper("vsiprintf");

/** @type {function(...*):?} */
var ___small_sprintf = Module["___small_sprintf"] = createExportWrapper("__small_sprintf");

/** @type {function(...*):?} */
var ___small_vsprintf = Module["___small_vsprintf"] = createExportWrapper("__small_vsprintf");

/** @type {function(...*):?} */
var _vsscanf = Module["_vsscanf"] = createExportWrapper("vsscanf");

/** @type {function(...*):?} */
var ___isoc99_sscanf = Module["___isoc99_sscanf"] = createExportWrapper("__isoc99_sscanf");

/** @type {function(...*):?} */
var _swprintf = Module["_swprintf"] = createExportWrapper("swprintf");

/** @type {function(...*):?} */
var _vswprintf = Module["_vswprintf"] = createExportWrapper("vswprintf");

/** @type {function(...*):?} */
var _swscanf = Module["_swscanf"] = createExportWrapper("swscanf");

/** @type {function(...*):?} */
var _vswscanf = Module["_vswscanf"] = createExportWrapper("vswscanf");

/** @type {function(...*):?} */
var ___isoc99_swscanf = Module["___isoc99_swscanf"] = createExportWrapper("__isoc99_swscanf");

/** @type {function(...*):?} */
var _tempnam = Module["_tempnam"] = createExportWrapper("tempnam");

/** @type {function(...*):?} */
var ___randname = Module["___randname"] = createExportWrapper("__randname");

/** @type {function(...*):?} */
var _tmpfile = Module["_tmpfile"] = createExportWrapper("tmpfile");

/** @type {function(...*):?} */
var _tmpfile64 = Module["_tmpfile64"] = createExportWrapper("tmpfile64");

/** @type {function(...*):?} */
var _tmpnam = Module["_tmpnam"] = createExportWrapper("tmpnam");

/** @type {function(...*):?} */
var _ungetwc = Module["_ungetwc"] = createExportWrapper("ungetwc");

/** @type {function(...*):?} */
var ___vfprintf_internal = Module["___vfprintf_internal"] = createExportWrapper("__vfprintf_internal");

/** @type {function(...*):?} */
var ___isoc99_vfscanf = Module["___isoc99_vfscanf"] = createExportWrapper("__isoc99_vfscanf");

/** @type {function(...*):?} */
var _wcsspn = Module["_wcsspn"] = createExportWrapper("wcsspn");

/** @type {function(...*):?} */
var _wmemchr = Module["_wmemchr"] = createExportWrapper("wmemchr");

/** @type {function(...*):?} */
var ___isoc99_vfwscanf = Module["___isoc99_vfwscanf"] = createExportWrapper("__isoc99_vfwscanf");

/** @type {function(...*):?} */
var _vprintf = Module["_vprintf"] = createExportWrapper("vprintf");

/** @type {function(...*):?} */
var ___isoc99_vscanf = Module["___isoc99_vscanf"] = createExportWrapper("__isoc99_vscanf");

/** @type {function(...*):?} */
var _vsniprintf = Module["_vsniprintf"] = createExportWrapper("vsniprintf");

/** @type {function(...*):?} */
var ___small_vsnprintf = Module["___small_vsnprintf"] = createExportWrapper("__small_vsnprintf");

/** @type {function(...*):?} */
var ___isoc99_vsscanf = Module["___isoc99_vsscanf"] = createExportWrapper("__isoc99_vsscanf");

/** @type {function(...*):?} */
var ___isoc99_vswscanf = Module["___isoc99_vswscanf"] = createExportWrapper("__isoc99_vswscanf");

/** @type {function(...*):?} */
var _vwprintf = Module["_vwprintf"] = createExportWrapper("vwprintf");

/** @type {function(...*):?} */
var _vwscanf = Module["_vwscanf"] = createExportWrapper("vwscanf");

/** @type {function(...*):?} */
var ___isoc99_vwscanf = Module["___isoc99_vwscanf"] = createExportWrapper("__isoc99_vwscanf");

/** @type {function(...*):?} */
var _wprintf = Module["_wprintf"] = createExportWrapper("wprintf");

/** @type {function(...*):?} */
var _wscanf = Module["_wscanf"] = createExportWrapper("wscanf");

/** @type {function(...*):?} */
var ___isoc99_wscanf = Module["___isoc99_wscanf"] = createExportWrapper("__isoc99_wscanf");

/** @type {function(...*):?} */
var _atof = Module["_atof"] = createExportWrapper("atof");

/** @type {function(...*):?} */
var _strtod = Module["_strtod"] = createExportWrapper("strtod");

/** @type {function(...*):?} */
var _atoi = Module["_atoi"] = createExportWrapper("atoi");

/** @type {function(...*):?} */
var _atol = Module["_atol"] = createExportWrapper("atol");

/** @type {function(...*):?} */
var _atoll = Module["_atoll"] = createExportWrapper("atoll");

/** @type {function(...*):?} */
var _div = Module["_div"] = createExportWrapper("div");

/** @type {function(...*):?} */
var _ecvt = Module["_ecvt"] = createExportWrapper("ecvt");

/** @type {function(...*):?} */
var _fcvt = Module["_fcvt"] = createExportWrapper("fcvt");

/** @type {function(...*):?} */
var _strcspn = Module["_strcspn"] = createExportWrapper("strcspn");

/** @type {function(...*):?} */
var _gcvt = Module["_gcvt"] = createExportWrapper("gcvt");

/** @type {function(...*):?} */
var _imaxabs = Module["_imaxabs"] = createExportWrapper("imaxabs");

/** @type {function(...*):?} */
var _imaxdiv = Module["_imaxdiv"] = createExportWrapper("imaxdiv");

/** @type {function(...*):?} */
var _labs = Module["_labs"] = createExportWrapper("labs");

/** @type {function(...*):?} */
var _ldiv = Module["_ldiv"] = createExportWrapper("ldiv");

/** @type {function(...*):?} */
var _llabs = Module["_llabs"] = createExportWrapper("llabs");

/** @type {function(...*):?} */
var _lldiv = Module["_lldiv"] = createExportWrapper("lldiv");

/** @type {function(...*):?} */
var _strtof = Module["_strtof"] = createExportWrapper("strtof");

/** @type {function(...*):?} */
var _strtold = Module["_strtold"] = createExportWrapper("strtold");

/** @type {function(...*):?} */
var _strtof_l = Module["_strtof_l"] = createExportWrapper("strtof_l");

/** @type {function(...*):?} */
var _strtod_l = Module["_strtod_l"] = createExportWrapper("strtod_l");

/** @type {function(...*):?} */
var _strtold_l = Module["_strtold_l"] = createExportWrapper("strtold_l");

/** @type {function(...*):?} */
var _strtoimax = Module["_strtoimax"] = createExportWrapper("strtoimax");

/** @type {function(...*):?} */
var _strtoumax = Module["_strtoumax"] = createExportWrapper("strtoumax");

/** @type {function(...*):?} */
var ___strtol_internal = Module["___strtol_internal"] = createExportWrapper("__strtol_internal");

/** @type {function(...*):?} */
var ___strtoul_internal = Module["___strtoul_internal"] = createExportWrapper("__strtoul_internal");

/** @type {function(...*):?} */
var ___strtoll_internal = Module["___strtoll_internal"] = createExportWrapper("__strtoll_internal");

/** @type {function(...*):?} */
var ___strtoull_internal = Module["___strtoull_internal"] = createExportWrapper("__strtoull_internal");

/** @type {function(...*):?} */
var ___strtoimax_internal = Module["___strtoimax_internal"] = createExportWrapper("__strtoimax_internal");

/** @type {function(...*):?} */
var ___strtoumax_internal = Module["___strtoumax_internal"] = createExportWrapper("__strtoumax_internal");

/** @type {function(...*):?} */
var _wcstof = Module["_wcstof"] = createExportWrapper("wcstof");

/** @type {function(...*):?} */
var _wcstod = Module["_wcstod"] = createExportWrapper("wcstod");

/** @type {function(...*):?} */
var _wcstold = Module["_wcstold"] = createExportWrapper("wcstold");

/** @type {function(...*):?} */
var _wcstoull = Module["_wcstoull"] = createExportWrapper("wcstoull");

/** @type {function(...*):?} */
var _wcstoll = Module["_wcstoll"] = createExportWrapper("wcstoll");

/** @type {function(...*):?} */
var _wcstoul = Module["_wcstoul"] = createExportWrapper("wcstoul");

/** @type {function(...*):?} */
var _wcstol = Module["_wcstol"] = createExportWrapper("wcstol");

/** @type {function(...*):?} */
var _wcstoimax = Module["_wcstoimax"] = createExportWrapper("wcstoimax");

/** @type {function(...*):?} */
var _wcstoumax = Module["_wcstoumax"] = createExportWrapper("wcstoumax");

/** @type {function(...*):?} */
var _bcmp = Module["_bcmp"] = createExportWrapper("bcmp");

/** @type {function(...*):?} */
var _bcopy = Module["_bcopy"] = createExportWrapper("bcopy");

/** @type {function(...*):?} */
var _bzero = Module["_bzero"] = createExportWrapper("bzero");

/** @type {function(...*):?} */
var _index = Module["_index"] = createExportWrapper("index");

/** @type {function(...*):?} */
var _memccpy = Module["_memccpy"] = createExportWrapper("memccpy");

/** @type {function(...*):?} */
var _memmem = Module["_memmem"] = createExportWrapper("memmem");

/** @type {function(...*):?} */
var _mempcpy = Module["_mempcpy"] = createExportWrapper("mempcpy");

/** @type {function(...*):?} */
var ___memrchr = Module["___memrchr"] = createExportWrapper("__memrchr");

/** @type {function(...*):?} */
var _memrchr = Module["_memrchr"] = createExportWrapper("memrchr");

/** @type {function(...*):?} */
var _rindex = Module["_rindex"] = createExportWrapper("rindex");

/** @type {function(...*):?} */
var ___stpcpy = Module["___stpcpy"] = createExportWrapper("__stpcpy");

/** @type {function(...*):?} */
var _stpcpy = Module["_stpcpy"] = createExportWrapper("stpcpy");

/** @type {function(...*):?} */
var ___stpncpy = Module["___stpncpy"] = createExportWrapper("__stpncpy");

/** @type {function(...*):?} */
var _stpncpy = Module["_stpncpy"] = createExportWrapper("stpncpy");

/** @type {function(...*):?} */
var ___strcasecmp_l = Module["___strcasecmp_l"] = createExportWrapper("__strcasecmp_l");

/** @type {function(...*):?} */
var _strcasecmp_l = Module["_strcasecmp_l"] = createExportWrapper("strcasecmp_l");

/** @type {function(...*):?} */
var _strcasestr = Module["_strcasestr"] = createExportWrapper("strcasestr");

/** @type {function(...*):?} */
var _strncasecmp = Module["_strncasecmp"] = createExportWrapper("strncasecmp");

/** @type {function(...*):?} */
var _strchrnul = Module["_strchrnul"] = createExportWrapper("strchrnul");

/** @type {function(...*):?} */
var ___strdup = Module["___strdup"] = createExportWrapper("__strdup");

/** @type {function(...*):?} */
var _strerror_r = Module["_strerror_r"] = createExportWrapper("strerror_r");

/** @type {function(...*):?} */
var ___xpg_strerror_r = Module["___xpg_strerror_r"] = createExportWrapper("__xpg_strerror_r");

/** @type {function(...*):?} */
var _strlcat = Module["_strlcat"] = createExportWrapper("strlcat");

/** @type {function(...*):?} */
var _strlcpy = Module["_strlcpy"] = createExportWrapper("strlcpy");

/** @type {function(...*):?} */
var ___strncasecmp_l = Module["___strncasecmp_l"] = createExportWrapper("__strncasecmp_l");

/** @type {function(...*):?} */
var _strncasecmp_l = Module["_strncasecmp_l"] = createExportWrapper("strncasecmp_l");

/** @type {function(...*):?} */
var _strncat = Module["_strncat"] = createExportWrapper("strncat");

/** @type {function(...*):?} */
var _strndup = Module["_strndup"] = createExportWrapper("strndup");

/** @type {function(...*):?} */
var _strpbrk = Module["_strpbrk"] = createExportWrapper("strpbrk");

/** @type {function(...*):?} */
var _strsep = Module["_strsep"] = createExportWrapper("strsep");

/** @type {function(...*):?} */
var _strsignal = Module["_strsignal"] = createExportWrapper("strsignal");

/** @type {function(...*):?} */
var _strtok = Module["_strtok"] = createExportWrapper("strtok");

/** @type {function(...*):?} */
var _strtok_r = Module["_strtok_r"] = createExportWrapper("strtok_r");

/** @type {function(...*):?} */
var _swab = Module["_swab"] = createExportWrapper("swab");

/** @type {function(...*):?} */
var _wcpcpy = Module["_wcpcpy"] = createExportWrapper("wcpcpy");

/** @type {function(...*):?} */
var _wcscpy = Module["_wcscpy"] = createExportWrapper("wcscpy");

/** @type {function(...*):?} */
var _wcpncpy = Module["_wcpncpy"] = createExportWrapper("wcpncpy");

/** @type {function(...*):?} */
var _wcsncpy = Module["_wcsncpy"] = createExportWrapper("wcsncpy");

/** @type {function(...*):?} */
var _wcsnlen = Module["_wcsnlen"] = createExportWrapper("wcsnlen");

/** @type {function(...*):?} */
var _wcscasecmp = Module["_wcscasecmp"] = createExportWrapper("wcscasecmp");

/** @type {function(...*):?} */
var _wcsncasecmp = Module["_wcsncasecmp"] = createExportWrapper("wcsncasecmp");

/** @type {function(...*):?} */
var _wcscasecmp_l = Module["_wcscasecmp_l"] = createExportWrapper("wcscasecmp_l");

/** @type {function(...*):?} */
var _wcscat = Module["_wcscat"] = createExportWrapper("wcscat");

/** @type {function(...*):?} */
var _wcscspn = Module["_wcscspn"] = createExportWrapper("wcscspn");

/** @type {function(...*):?} */
var _wcsdup = Module["_wcsdup"] = createExportWrapper("wcsdup");

/** @type {function(...*):?} */
var _wcsncasecmp_l = Module["_wcsncasecmp_l"] = createExportWrapper("wcsncasecmp_l");

/** @type {function(...*):?} */
var _wcsncat = Module["_wcsncat"] = createExportWrapper("wcsncat");

/** @type {function(...*):?} */
var _wcsncmp = Module["_wcsncmp"] = createExportWrapper("wcsncmp");

/** @type {function(...*):?} */
var _wmemset = Module["_wmemset"] = createExportWrapper("wmemset");

/** @type {function(...*):?} */
var _wcspbrk = Module["_wcspbrk"] = createExportWrapper("wcspbrk");

/** @type {function(...*):?} */
var _wcsrchr = Module["_wcsrchr"] = createExportWrapper("wcsrchr");

/** @type {function(...*):?} */
var _wcsstr = Module["_wcsstr"] = createExportWrapper("wcsstr");

/** @type {function(...*):?} */
var _wmemcmp = Module["_wmemcmp"] = createExportWrapper("wmemcmp");

/** @type {function(...*):?} */
var _wcstok = Module["_wcstok"] = createExportWrapper("wcstok");

/** @type {function(...*):?} */
var _wcswcs = Module["_wcswcs"] = createExportWrapper("wcswcs");

/** @type {function(...*):?} */
var _wmemmove = Module["_wmemmove"] = createExportWrapper("wmemmove");

/** @type {function(...*):?} */
var _mkdtemp = Module["_mkdtemp"] = createExportWrapper("mkdtemp");

/** @type {function(...*):?} */
var _mkostemp = Module["_mkostemp"] = createExportWrapper("mkostemp");

/** @type {function(...*):?} */
var ___mkostemps = Module["___mkostemps"] = createExportWrapper("__mkostemps");

/** @type {function(...*):?} */
var _mkostemp64 = Module["_mkostemp64"] = createExportWrapper("mkostemp64");

/** @type {function(...*):?} */
var _mkostemps = Module["_mkostemps"] = createExportWrapper("mkostemps");

/** @type {function(...*):?} */
var _mkostemps64 = Module["_mkostemps64"] = createExportWrapper("mkostemps64");

/** @type {function(...*):?} */
var _mkstemp = Module["_mkstemp"] = createExportWrapper("mkstemp");

/** @type {function(...*):?} */
var _mkstemp64 = Module["_mkstemp64"] = createExportWrapper("mkstemp64");

/** @type {function(...*):?} */
var _mkstemps = Module["_mkstemps"] = createExportWrapper("mkstemps");

/** @type {function(...*):?} */
var _mkstemps64 = Module["_mkstemps64"] = createExportWrapper("mkstemps64");

/** @type {function(...*):?} */
var _mktemp = Module["_mktemp"] = createExportWrapper("mktemp");

/** @type {function(...*):?} */
var _cfgetospeed = Module["_cfgetospeed"] = createExportWrapper("cfgetospeed");

/** @type {function(...*):?} */
var _cfgetispeed = Module["_cfgetispeed"] = createExportWrapper("cfgetispeed");

/** @type {function(...*):?} */
var _cfmakeraw = Module["_cfmakeraw"] = createExportWrapper("cfmakeraw");

/** @type {function(...*):?} */
var _cfsetospeed = Module["_cfsetospeed"] = createExportWrapper("cfsetospeed");

/** @type {function(...*):?} */
var _cfsetispeed = Module["_cfsetispeed"] = createExportWrapper("cfsetispeed");

/** @type {function(...*):?} */
var _cfsetspeed = Module["_cfsetspeed"] = createExportWrapper("cfsetspeed");

/** @type {function(...*):?} */
var _tcdrain = Module["_tcdrain"] = createExportWrapper("tcdrain");

/** @type {function(...*):?} */
var _tcflow = Module["_tcflow"] = createExportWrapper("tcflow");

/** @type {function(...*):?} */
var _tcflush = Module["_tcflush"] = createExportWrapper("tcflush");

/** @type {function(...*):?} */
var _tcgetattr = Module["_tcgetattr"] = createExportWrapper("tcgetattr");

/** @type {function(...*):?} */
var _tcgetsid = Module["_tcgetsid"] = createExportWrapper("tcgetsid");

/** @type {function(...*):?} */
var _tcsendbreak = Module["_tcsendbreak"] = createExportWrapper("tcsendbreak");

/** @type {function(...*):?} */
var _acct = Module["_acct"] = createExportWrapper("acct");

/** @type {function(...*):?} */
var _chdir = Module["_chdir"] = createExportWrapper("chdir");

/** @type {function(...*):?} */
var _chown = Module["_chown"] = createExportWrapper("chown");

/** @type {function(...*):?} */
var _ctermid = Module["_ctermid"] = createExportWrapper("ctermid");

/** @type {function(...*):?} */
var _dup = Module["_dup"] = createExportWrapper("dup");

/** @type {function(...*):?} */
var _dup3 = Module["_dup3"] = createExportWrapper("dup3");

/** @type {function(...*):?} */
var _fchdir = Module["_fchdir"] = createExportWrapper("fchdir");

/** @type {function(...*):?} */
var _fchown = Module["_fchown"] = createExportWrapper("fchown");

/** @type {function(...*):?} */
var _fchownat = Module["_fchownat"] = createExportWrapper("fchownat");

/** @type {function(...*):?} */
var _fdatasync = Module["_fdatasync"] = createExportWrapper("fdatasync");

/** @type {function(...*):?} */
var _fsync = Module["_fsync"] = createExportWrapper("fsync");

/** @type {function(...*):?} */
var _ftruncate = Module["_ftruncate"] = createExportWrapper("ftruncate");

/** @type {function(...*):?} */
var _ftruncate64 = Module["_ftruncate64"] = createExportWrapper("ftruncate64");

/** @type {function(...*):?} */
var _getegid = Module["_getegid"] = createExportWrapper("getegid");

/** @type {function(...*):?} */
var _geteuid = Module["_geteuid"] = createExportWrapper("geteuid");

/** @type {function(...*):?} */
var _getgid = Module["_getgid"] = createExportWrapper("getgid");

/** @type {function(...*):?} */
var _getgroups = Module["_getgroups"] = createExportWrapper("getgroups");

/** @type {function(...*):?} */
var _gethostname = Module["_gethostname"] = createExportWrapper("gethostname");

/** @type {function(...*):?} */
var _getlogin = Module["_getlogin"] = createExportWrapper("getlogin");

/** @type {function(...*):?} */
var _getlogin_r = Module["_getlogin_r"] = createExportWrapper("getlogin_r");

/** @type {function(...*):?} */
var _getpgid = Module["_getpgid"] = createExportWrapper("getpgid");

/** @type {function(...*):?} */
var _getpgrp = Module["_getpgrp"] = createExportWrapper("getpgrp");

/** @type {function(...*):?} */
var _getppid = Module["_getppid"] = createExportWrapper("getppid");

/** @type {function(...*):?} */
var _getsid = Module["_getsid"] = createExportWrapper("getsid");

/** @type {function(...*):?} */
var _getuid = Module["_getuid"] = createExportWrapper("getuid");

/** @type {function(...*):?} */
var _isatty = Module["_isatty"] = createExportWrapper("isatty");

/** @type {function(...*):?} */
var _lchown = Module["_lchown"] = createExportWrapper("lchown");

/** @type {function(...*):?} */
var _link = Module["_link"] = createExportWrapper("link");

/** @type {function(...*):?} */
var _linkat = Module["_linkat"] = createExportWrapper("linkat");

/** @type {function(...*):?} */
var _lseek64 = Module["_lseek64"] = createExportWrapper("lseek64");

/** @type {function(...*):?} */
var _nice = Module["_nice"] = createExportWrapper("nice");

/** @type {function(...*):?} */
var _pause = Module["_pause"] = createExportWrapper("pause");

/** @type {function(...*):?} */
var _pipe = Module["_pipe"] = createExportWrapper("pipe");

/** @type {function(...*):?} */
var _posix_close = Module["_posix_close"] = createExportWrapper("posix_close");

/** @type {function(...*):?} */
var _pread = Module["_pread"] = createExportWrapper("pread");

/** @type {function(...*):?} */
var _pread64 = Module["_pread64"] = createExportWrapper("pread64");

/** @type {function(...*):?} */
var _preadv = Module["_preadv"] = createExportWrapper("preadv");

/** @type {function(...*):?} */
var _preadv64 = Module["_preadv64"] = createExportWrapper("preadv64");

/** @type {function(...*):?} */
var _pwrite = Module["_pwrite"] = createExportWrapper("pwrite");

/** @type {function(...*):?} */
var _pwrite64 = Module["_pwrite64"] = createExportWrapper("pwrite64");

/** @type {function(...*):?} */
var _pwritev = Module["_pwritev"] = createExportWrapper("pwritev");

/** @type {function(...*):?} */
var _pwritev64 = Module["_pwritev64"] = createExportWrapper("pwritev64");

/** @type {function(...*):?} */
var _readlinkat = Module["_readlinkat"] = createExportWrapper("readlinkat");

/** @type {function(...*):?} */
var _readv = Module["_readv"] = createExportWrapper("readv");

/** @type {function(...*):?} */
var _renameat = Module["_renameat"] = createExportWrapper("renameat");

/** @type {function(...*):?} */
var _rmdir = Module["_rmdir"] = createExportWrapper("rmdir");

/** @type {function(...*):?} */
var _setegid = Module["_setegid"] = createExportWrapper("setegid");

/** @type {function(...*):?} */
var ___setxid = Module["___setxid"] = createExportWrapper("__setxid");

/** @type {function(...*):?} */
var _seteuid = Module["_seteuid"] = createExportWrapper("seteuid");

/** @type {function(...*):?} */
var _setgid = Module["_setgid"] = createExportWrapper("setgid");

/** @type {function(...*):?} */
var _setpgid = Module["_setpgid"] = createExportWrapper("setpgid");

/** @type {function(...*):?} */
var _setpgrp = Module["_setpgrp"] = createExportWrapper("setpgrp");

/** @type {function(...*):?} */
var _setregid = Module["_setregid"] = createExportWrapper("setregid");

/** @type {function(...*):?} */
var _setresgid = Module["_setresgid"] = createExportWrapper("setresgid");

/** @type {function(...*):?} */
var _setresuid = Module["_setresuid"] = createExportWrapper("setresuid");

/** @type {function(...*):?} */
var _setreuid = Module["_setreuid"] = createExportWrapper("setreuid");

/** @type {function(...*):?} */
var _setuid = Module["_setuid"] = createExportWrapper("setuid");

/** @type {function(...*):?} */
var _sleep = Module["_sleep"] = createExportWrapper("sleep");

/** @type {function(...*):?} */
var _symlink = Module["_symlink"] = createExportWrapper("symlink");

/** @type {function(...*):?} */
var _symlinkat = Module["_symlinkat"] = createExportWrapper("symlinkat");

/** @type {function(...*):?} */
var _sync = Module["_sync"] = createExportWrapper("sync");

/** @type {function(...*):?} */
var _tcgetpgrp = Module["_tcgetpgrp"] = createExportWrapper("tcgetpgrp");

/** @type {function(...*):?} */
var _tcsetpgrp = Module["_tcsetpgrp"] = createExportWrapper("tcsetpgrp");

/** @type {function(...*):?} */
var _truncate = Module["_truncate"] = createExportWrapper("truncate");

/** @type {function(...*):?} */
var _truncate64 = Module["_truncate64"] = createExportWrapper("truncate64");

/** @type {function(...*):?} */
var _ttyname = Module["_ttyname"] = createExportWrapper("ttyname");

/** @type {function(...*):?} */
var _ttyname_r = Module["_ttyname_r"] = createExportWrapper("ttyname_r");

/** @type {function(...*):?} */
var _ualarm = Module["_ualarm"] = createExportWrapper("ualarm");

/** @type {function(...*):?} */
var _unlinkat = Module["_unlinkat"] = createExportWrapper("unlinkat");

/** @type {function(...*):?} */
var _writev = Module["_writev"] = createExportWrapper("writev");

/** @type {function(...*):?} */
var _clock_settime = Module["_clock_settime"] = createExportWrapper("clock_settime");

/** @type {function(...*):?} */
var _getpagesize = Module["_getpagesize"] = createExportWrapper("getpagesize");

/** @type {function(...*):?} */
var ___emscripten_environ_constructor = Module["___emscripten_environ_constructor"] = createExportWrapper("__emscripten_environ_constructor");

/** @type {function(...*):?} */
var ___putenv = Module["___putenv"] = createExportWrapper("__putenv");

/** @type {function(...*):?} */
var _unsetenv = Module["_unsetenv"] = createExportWrapper("unsetenv");

/** @type {function(...*):?} */
var _putenv = Module["_putenv"] = createExportWrapper("putenv");

/** @type {function(...*):?} */
var _setenv = Module["_setenv"] = createExportWrapper("setenv");

/** @type {function(...*):?} */
var _sched_yield = Module["_sched_yield"] = createExportWrapper("sched_yield");

/** @type {function(...*):?} */
var __get_tzname = Module["__get_tzname"] = createExportWrapper("_get_tzname");

/** @type {function(...*):?} */
var __get_daylight = Module["__get_daylight"] = createExportWrapper("_get_daylight");

/** @type {function(...*):?} */
var __get_timezone = Module["__get_timezone"] = createExportWrapper("_get_timezone");

/** @type {function(...*):?} */
var ___ashlti3 = Module["___ashlti3"] = createExportWrapper("__ashlti3");

/** @type {function(...*):?} */
var ___lshrti3 = Module["___lshrti3"] = createExportWrapper("__lshrti3");

/** @type {function(...*):?} */
var ___ashldi3 = Module["___ashldi3"] = createExportWrapper("__ashldi3");

/** @type {function(...*):?} */
var ___ashrdi3 = Module["___ashrdi3"] = createExportWrapper("__ashrdi3");

/** @type {function(...*):?} */
var ___ashrti3 = Module["___ashrti3"] = createExportWrapper("__ashrti3");

/** @type {function(...*):?} */
var ___atomic_load = Module["___atomic_load"] = createExportWrapper("__atomic_load");

/** @type {function(...*):?} */
var ___atomic_store = Module["___atomic_store"] = createExportWrapper("__atomic_store");

/** @type {function(...*):?} */
var ___atomic_compare_exchange = Module["___atomic_compare_exchange"] = createExportWrapper("__atomic_compare_exchange");

/** @type {function(...*):?} */
var ___atomic_exchange = Module["___atomic_exchange"] = createExportWrapper("__atomic_exchange");

/** @type {function(...*):?} */
var ___atomic_load_1 = Module["___atomic_load_1"] = createExportWrapper("__atomic_load_1");

/** @type {function(...*):?} */
var ___atomic_load_2 = Module["___atomic_load_2"] = createExportWrapper("__atomic_load_2");

/** @type {function(...*):?} */
var ___atomic_load_4 = Module["___atomic_load_4"] = createExportWrapper("__atomic_load_4");

/** @type {function(...*):?} */
var ___atomic_load_8 = Module["___atomic_load_8"] = createExportWrapper("__atomic_load_8");

/** @type {function(...*):?} */
var ___atomic_load_16 = Module["___atomic_load_16"] = createExportWrapper("__atomic_load_16");

/** @type {function(...*):?} */
var ___atomic_store_1 = Module["___atomic_store_1"] = createExportWrapper("__atomic_store_1");

/** @type {function(...*):?} */
var ___atomic_store_2 = Module["___atomic_store_2"] = createExportWrapper("__atomic_store_2");

/** @type {function(...*):?} */
var ___atomic_store_4 = Module["___atomic_store_4"] = createExportWrapper("__atomic_store_4");

/** @type {function(...*):?} */
var ___atomic_store_8 = Module["___atomic_store_8"] = createExportWrapper("__atomic_store_8");

/** @type {function(...*):?} */
var ___atomic_store_16 = Module["___atomic_store_16"] = createExportWrapper("__atomic_store_16");

/** @type {function(...*):?} */
var ___atomic_exchange_1 = Module["___atomic_exchange_1"] = createExportWrapper("__atomic_exchange_1");

/** @type {function(...*):?} */
var ___atomic_exchange_2 = Module["___atomic_exchange_2"] = createExportWrapper("__atomic_exchange_2");

/** @type {function(...*):?} */
var ___atomic_exchange_4 = Module["___atomic_exchange_4"] = createExportWrapper("__atomic_exchange_4");

/** @type {function(...*):?} */
var ___atomic_exchange_8 = Module["___atomic_exchange_8"] = createExportWrapper("__atomic_exchange_8");

/** @type {function(...*):?} */
var ___atomic_exchange_16 = Module["___atomic_exchange_16"] = createExportWrapper("__atomic_exchange_16");

/** @type {function(...*):?} */
var ___atomic_compare_exchange_1 = Module["___atomic_compare_exchange_1"] = createExportWrapper("__atomic_compare_exchange_1");

/** @type {function(...*):?} */
var ___atomic_compare_exchange_2 = Module["___atomic_compare_exchange_2"] = createExportWrapper("__atomic_compare_exchange_2");

/** @type {function(...*):?} */
var ___atomic_compare_exchange_4 = Module["___atomic_compare_exchange_4"] = createExportWrapper("__atomic_compare_exchange_4");

/** @type {function(...*):?} */
var ___atomic_compare_exchange_8 = Module["___atomic_compare_exchange_8"] = createExportWrapper("__atomic_compare_exchange_8");

/** @type {function(...*):?} */
var ___atomic_compare_exchange_16 = Module["___atomic_compare_exchange_16"] = createExportWrapper("__atomic_compare_exchange_16");

/** @type {function(...*):?} */
var ___atomic_fetch_add_1 = Module["___atomic_fetch_add_1"] = createExportWrapper("__atomic_fetch_add_1");

/** @type {function(...*):?} */
var ___atomic_fetch_add_2 = Module["___atomic_fetch_add_2"] = createExportWrapper("__atomic_fetch_add_2");

/** @type {function(...*):?} */
var ___atomic_fetch_add_4 = Module["___atomic_fetch_add_4"] = createExportWrapper("__atomic_fetch_add_4");

/** @type {function(...*):?} */
var ___atomic_fetch_add_8 = Module["___atomic_fetch_add_8"] = createExportWrapper("__atomic_fetch_add_8");

/** @type {function(...*):?} */
var ___atomic_fetch_add_16 = Module["___atomic_fetch_add_16"] = createExportWrapper("__atomic_fetch_add_16");

/** @type {function(...*):?} */
var ___atomic_fetch_sub_1 = Module["___atomic_fetch_sub_1"] = createExportWrapper("__atomic_fetch_sub_1");

/** @type {function(...*):?} */
var ___atomic_fetch_sub_2 = Module["___atomic_fetch_sub_2"] = createExportWrapper("__atomic_fetch_sub_2");

/** @type {function(...*):?} */
var ___atomic_fetch_sub_4 = Module["___atomic_fetch_sub_4"] = createExportWrapper("__atomic_fetch_sub_4");

/** @type {function(...*):?} */
var ___atomic_fetch_sub_8 = Module["___atomic_fetch_sub_8"] = createExportWrapper("__atomic_fetch_sub_8");

/** @type {function(...*):?} */
var ___atomic_fetch_sub_16 = Module["___atomic_fetch_sub_16"] = createExportWrapper("__atomic_fetch_sub_16");

/** @type {function(...*):?} */
var ___atomic_fetch_and_1 = Module["___atomic_fetch_and_1"] = createExportWrapper("__atomic_fetch_and_1");

/** @type {function(...*):?} */
var ___atomic_fetch_and_2 = Module["___atomic_fetch_and_2"] = createExportWrapper("__atomic_fetch_and_2");

/** @type {function(...*):?} */
var ___atomic_fetch_and_4 = Module["___atomic_fetch_and_4"] = createExportWrapper("__atomic_fetch_and_4");

/** @type {function(...*):?} */
var ___atomic_fetch_and_8 = Module["___atomic_fetch_and_8"] = createExportWrapper("__atomic_fetch_and_8");

/** @type {function(...*):?} */
var ___atomic_fetch_and_16 = Module["___atomic_fetch_and_16"] = createExportWrapper("__atomic_fetch_and_16");

/** @type {function(...*):?} */
var ___atomic_fetch_or_1 = Module["___atomic_fetch_or_1"] = createExportWrapper("__atomic_fetch_or_1");

/** @type {function(...*):?} */
var ___atomic_fetch_or_2 = Module["___atomic_fetch_or_2"] = createExportWrapper("__atomic_fetch_or_2");

/** @type {function(...*):?} */
var ___atomic_fetch_or_4 = Module["___atomic_fetch_or_4"] = createExportWrapper("__atomic_fetch_or_4");

/** @type {function(...*):?} */
var ___atomic_fetch_or_8 = Module["___atomic_fetch_or_8"] = createExportWrapper("__atomic_fetch_or_8");

/** @type {function(...*):?} */
var ___atomic_fetch_or_16 = Module["___atomic_fetch_or_16"] = createExportWrapper("__atomic_fetch_or_16");

/** @type {function(...*):?} */
var ___atomic_fetch_xor_1 = Module["___atomic_fetch_xor_1"] = createExportWrapper("__atomic_fetch_xor_1");

/** @type {function(...*):?} */
var ___atomic_fetch_xor_2 = Module["___atomic_fetch_xor_2"] = createExportWrapper("__atomic_fetch_xor_2");

/** @type {function(...*):?} */
var ___atomic_fetch_xor_4 = Module["___atomic_fetch_xor_4"] = createExportWrapper("__atomic_fetch_xor_4");

/** @type {function(...*):?} */
var ___atomic_fetch_xor_8 = Module["___atomic_fetch_xor_8"] = createExportWrapper("__atomic_fetch_xor_8");

/** @type {function(...*):?} */
var ___atomic_fetch_xor_16 = Module["___atomic_fetch_xor_16"] = createExportWrapper("__atomic_fetch_xor_16");

/** @type {function(...*):?} */
var ___clzti2 = Module["___clzti2"] = createExportWrapper("__clzti2");

/** @type {function(...*):?} */
var ___divdc3 = Module["___divdc3"] = createExportWrapper("__divdc3");

/** @type {function(...*):?} */
var _fmax = Module["_fmax"] = createExportWrapper("fmax");

/** @type {function(...*):?} */
var ___divdi3 = Module["___divdi3"] = createExportWrapper("__divdi3");

/** @type {function(...*):?} */
var ___udivmoddi4 = Module["___udivmoddi4"] = createExportWrapper("__udivmoddi4");

/** @type {function(...*):?} */
var ___divmoddi4 = Module["___divmoddi4"] = createExportWrapper("__divmoddi4");

/** @type {function(...*):?} */
var ___divsc3 = Module["___divsc3"] = createExportWrapper("__divsc3");

/** @type {function(...*):?} */
var _fmaxf = Module["_fmaxf"] = createExportWrapper("fmaxf");

/** @type {function(...*):?} */
var ___divti3 = Module["___divti3"] = createExportWrapper("__divti3");

/** @type {function(...*):?} */
var ___udivmodti4 = Module["___udivmodti4"] = createExportWrapper("__udivmodti4");

/** @type {function(...*):?} */
var ___fixdfdi = Module["___fixdfdi"] = createExportWrapper("__fixdfdi");

/** @type {function(...*):?} */
var ___fixunsdfdi = Module["___fixunsdfdi"] = createExportWrapper("__fixunsdfdi");

/** @type {function(...*):?} */
var ___fixdfti = Module["___fixdfti"] = createExportWrapper("__fixdfti");

/** @type {function(...*):?} */
var ___fixsfti = Module["___fixsfti"] = createExportWrapper("__fixsfti");

/** @type {function(...*):?} */
var ___fixtfti = Module["___fixtfti"] = createExportWrapper("__fixtfti");

/** @type {function(...*):?} */
var ___fixunsdfti = Module["___fixunsdfti"] = createExportWrapper("__fixunsdfti");

/** @type {function(...*):?} */
var ___fixunssfti = Module["___fixunssfti"] = createExportWrapper("__fixunssfti");

/** @type {function(...*):?} */
var ___fixunstfdi = Module["___fixunstfdi"] = createExportWrapper("__fixunstfdi");

/** @type {function(...*):?} */
var ___fixunstfsi = Module["___fixunstfsi"] = createExportWrapper("__fixunstfsi");

/** @type {function(...*):?} */
var ___fixunstfti = Module["___fixunstfti"] = createExportWrapper("__fixunstfti");

/** @type {function(...*):?} */
var ___floatdidf = Module["___floatdidf"] = createExportWrapper("__floatdidf");

/** @type {function(...*):?} */
var ___floatditf = Module["___floatditf"] = createExportWrapper("__floatditf");

/** @type {function(...*):?} */
var ___floattidf = Module["___floattidf"] = createExportWrapper("__floattidf");

/** @type {function(...*):?} */
var ___floattisf = Module["___floattisf"] = createExportWrapper("__floattisf");

/** @type {function(...*):?} */
var ___floattitf = Module["___floattitf"] = createExportWrapper("__floattitf");

/** @type {function(...*):?} */
var ___floatunditf = Module["___floatunditf"] = createExportWrapper("__floatunditf");

/** @type {function(...*):?} */
var ___floatuntidf = Module["___floatuntidf"] = createExportWrapper("__floatuntidf");

/** @type {function(...*):?} */
var ___floatuntisf = Module["___floatuntisf"] = createExportWrapper("__floatuntisf");

/** @type {function(...*):?} */
var ___lshrdi3 = Module["___lshrdi3"] = createExportWrapper("__lshrdi3");

/** @type {function(...*):?} */
var ___moddi3 = Module["___moddi3"] = createExportWrapper("__moddi3");

/** @type {function(...*):?} */
var ___modti3 = Module["___modti3"] = createExportWrapper("__modti3");

/** @type {function(...*):?} */
var ___muldi3 = Module["___muldi3"] = createExportWrapper("__muldi3");

/** @type {function(...*):?} */
var ___powidf2 = Module["___powidf2"] = createExportWrapper("__powidf2");

/** @type {function(...*):?} */
var ___powisf2 = Module["___powisf2"] = createExportWrapper("__powisf2");

/** @type {function(...*):?} */
var ___powitf2 = Module["___powitf2"] = createExportWrapper("__powitf2");

/** @type {function(...*):?} */
var ___udivdi3 = Module["___udivdi3"] = createExportWrapper("__udivdi3");

/** @type {function(...*):?} */
var ___udivti3 = Module["___udivti3"] = createExportWrapper("__udivti3");

/** @type {function(...*):?} */
var ___umoddi3 = Module["___umoddi3"] = createExportWrapper("__umoddi3");

/** @type {function(...*):?} */
var ___umodti3 = Module["___umodti3"] = createExportWrapper("__umodti3");

/** @type {function(...*):?} */
var _setThrew = Module["_setThrew"] = createExportWrapper("setThrew");

/** @type {function(...*):?} */
var stackSave = Module["stackSave"] = createExportWrapper("stackSave");

/** @type {function(...*):?} */
var stackRestore = Module["stackRestore"] = createExportWrapper("stackRestore");

/** @type {function(...*):?} */
var stackAlloc = Module["stackAlloc"] = createExportWrapper("stackAlloc");

/** @type {function(...*):?} */
var _emscripten_stack_get_current = Module["_emscripten_stack_get_current"] = createExportWrapper("emscripten_stack_get_current");

/** @type {function(...*):?} */
var _emscripten_stack_get_free = Module["_emscripten_stack_get_free"] = createExportWrapper("emscripten_stack_get_free");

/** @type {function(...*):?} */
var _saveSetjmp = Module["_saveSetjmp"] = createExportWrapper("saveSetjmp");

/** @type {function(...*):?} */
var _testSetjmp = Module["_testSetjmp"] = createExportWrapper("testSetjmp");

/** @type {function(...*):?} */
var _cosl = Module["_cosl"] = createExportWrapper("cosl");

/** @type {function(...*):?} */
var _sinl = Module["_sinl"] = createExportWrapper("sinl");

/** @type {function(...*):?} */
var _tanl = Module["_tanl"] = createExportWrapper("tanl");

/** @type {function(...*):?} */
var _acos = Module["_acos"] = createExportWrapper("acos");

/** @type {function(...*):?} */
var _acosf = Module["_acosf"] = createExportWrapper("acosf");

/** @type {function(...*):?} */
var _acosl = Module["_acosl"] = createExportWrapper("acosl");

/** @type {function(...*):?} */
var _asin = Module["_asin"] = createExportWrapper("asin");

/** @type {function(...*):?} */
var _asinf = Module["_asinf"] = createExportWrapper("asinf");

/** @type {function(...*):?} */
var _asinl = Module["_asinl"] = createExportWrapper("asinl");

/** @type {function(...*):?} */
var _atan = Module["_atan"] = createExportWrapper("atan");

/** @type {function(...*):?} */
var _atanf = Module["_atanf"] = createExportWrapper("atanf");

/** @type {function(...*):?} */
var _atanl = Module["_atanl"] = createExportWrapper("atanl");

/** @type {function(...*):?} */
var _expl = Module["_expl"] = createExportWrapper("expl");

/** @type {function(...*):?} */
var _powf = Module["_powf"] = createExportWrapper("powf");

/** @type {function(...*):?} */
var _ceill = Module["_ceill"] = createExportWrapper("ceill");

/** @type {function(...*):?} */
var _floorl = Module["_floorl"] = createExportWrapper("floorl");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIccEEPcEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIccEEPcEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIccEEPcEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIccEclERKcS3_ = Module["__ZNKSt3__26__lessIccEclERKcS3_"] = createExportWrapper("_ZNKSt3__26__lessIccEclERKcS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIcEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIcEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIcEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIccEEPcEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIccEEPcEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIccEEPcEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIccEEPcEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIccEEPcEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIccEEPcEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIccEEPcEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIccEEPcEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIccEEPcEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIccEEPcEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIccEEPcEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIccEEPcEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIccEEPcEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIccEEPcEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIccEEPcEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRcEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRcEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRcEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIwwEEPwEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIwwEEPwEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIwwEEPwEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIwwEclERKwS3_ = Module["__ZNKSt3__26__lessIwwEclERKwS3_"] = createExportWrapper("_ZNKSt3__26__lessIwwEclERKwS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIwEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIwEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIwEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIwwEEPwEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIwwEEPwEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIwwEEPwEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIwwEEPwEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIwwEEPwEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIwwEEPwEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIwwEEPwEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIwwEEPwEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIwwEEPwEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIwwEEPwEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIwwEEPwEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIwwEEPwEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIwwEEPwEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIwwEEPwEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIwwEEPwEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRwEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRwEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRwEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIaaEEPaEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIaaEEPaEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIaaEEPaEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIaaEclERKaS3_ = Module["__ZNKSt3__26__lessIaaEclERKaS3_"] = createExportWrapper("_ZNKSt3__26__lessIaaEclERKaS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIaEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIaEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIaEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIaaEEPaEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIaaEEPaEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIaaEEPaEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIaaEEPaEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIaaEEPaEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIaaEEPaEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIaaEEPaEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIaaEEPaEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIaaEEPaEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIaaEEPaEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIaaEEPaEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIaaEEPaEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIaaEEPaEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIaaEEPaEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIaaEEPaEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRaEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRaEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRaEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIhhEEPhEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIhhEEPhEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIhhEEPhEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIhhEclERKhS3_ = Module["__ZNKSt3__26__lessIhhEclERKhS3_"] = createExportWrapper("_ZNKSt3__26__lessIhhEclERKhS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIhEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIhEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIhEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIhhEEPhEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIhhEEPhEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIhhEEPhEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIhhEEPhEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIhhEEPhEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIhhEEPhEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIhhEEPhEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIhhEEPhEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIhhEEPhEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIhhEEPhEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIhhEEPhEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIhhEEPhEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIhhEEPhEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIhhEEPhEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIhhEEPhEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRhEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRhEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRhEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIssEEPsEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIssEEPsEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIssEEPsEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIssEclERKsS3_ = Module["__ZNKSt3__26__lessIssEclERKsS3_"] = createExportWrapper("_ZNKSt3__26__lessIssEclERKsS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIsEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIsEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIsEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIssEEPsEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIssEEPsEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIssEEPsEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIssEEPsEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIssEEPsEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIssEEPsEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIssEEPsEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIssEEPsEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIssEEPsEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIssEEPsEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIssEEPsEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIssEEPsEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIssEEPsEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIssEEPsEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIssEEPsEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRsEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRsEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRsEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIttEEPtEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIttEEPtEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIttEEPtEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIttEclERKtS3_ = Module["__ZNKSt3__26__lessIttEclERKtS3_"] = createExportWrapper("_ZNKSt3__26__lessIttEclERKtS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapItEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapItEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapItEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIttEEPtEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIttEEPtEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIttEEPtEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIttEEPtEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIttEEPtEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIttEEPtEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIttEEPtEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIttEEPtEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIttEEPtEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIttEEPtEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIttEEPtEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIttEEPtEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIttEEPtEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIttEEPtEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIttEEPtEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRtEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRtEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRtEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIiiEEPiEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIiiEEPiEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIiiEEPiEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIiiEclERKiS3_ = Module["__ZNKSt3__26__lessIiiEclERKiS3_"] = createExportWrapper("_ZNKSt3__26__lessIiiEclERKiS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIiEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIiEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIiEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIiiEEPiEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIiiEEPiEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIiiEEPiEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIiiEEPiEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIiiEEPiEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIiiEEPiEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIiiEEPiEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIiiEEPiEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIiiEEPiEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIiiEEPiEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIiiEEPiEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIiiEEPiEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIiiEEPiEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIiiEEPiEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIiiEEPiEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRiEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRiEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRiEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIjjEEPjEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIjjEEPjEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIjjEEPjEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIjjEclERKjS3_ = Module["__ZNKSt3__26__lessIjjEclERKjS3_"] = createExportWrapper("_ZNKSt3__26__lessIjjEclERKjS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIjEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIjEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIjEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIjjEEPjEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIjjEEPjEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIjjEEPjEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIjjEEPjEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIjjEEPjEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIjjEEPjEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIjjEEPjEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIjjEEPjEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIjjEEPjEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIjjEEPjEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIjjEEPjEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIjjEEPjEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIjjEEPjEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIjjEEPjEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIjjEEPjEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRjEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRjEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRjEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIllEEPlEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIllEEPlEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIllEEPlEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIllEclERKlS3_ = Module["__ZNKSt3__26__lessIllEclERKlS3_"] = createExportWrapper("_ZNKSt3__26__lessIllEclERKlS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIlEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIlEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIlEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIllEEPlEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIllEEPlEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIllEEPlEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIllEEPlEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIllEEPlEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIllEEPlEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIllEEPlEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIllEEPlEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIllEEPlEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIllEEPlEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIllEEPlEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIllEEPlEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIllEEPlEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIllEEPlEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIllEEPlEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRlEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRlEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRlEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessImmEEPmEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessImmEEPmEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessImmEEPmEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessImmEclERKmS3_ = Module["__ZNKSt3__26__lessImmEclERKmS3_"] = createExportWrapper("_ZNKSt3__26__lessImmEclERKmS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapImEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapImEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapImEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessImmEEPmEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessImmEEPmEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessImmEEPmEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessImmEEPmEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessImmEEPmEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessImmEEPmEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessImmEEPmEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessImmEEPmEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessImmEEPmEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessImmEEPmEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessImmEEPmEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessImmEEPmEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessImmEEPmEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessImmEEPmEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessImmEEPmEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRmEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRmEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRmEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIxxEEPxEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIxxEEPxEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIxxEEPxEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIxxEclERKxS3_ = Module["__ZNKSt3__26__lessIxxEclERKxS3_"] = createExportWrapper("_ZNKSt3__26__lessIxxEclERKxS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIxEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIxEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIxEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIxxEEPxEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIxxEEPxEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIxxEEPxEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIxxEEPxEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIxxEEPxEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIxxEEPxEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIxxEEPxEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIxxEEPxEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIxxEEPxEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIxxEEPxEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIxxEEPxEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIxxEEPxEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIxxEEPxEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIxxEEPxEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIxxEEPxEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRxEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRxEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRxEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIyyEEPyEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIyyEEPyEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIyyEEPyEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIyyEclERKyS3_ = Module["__ZNKSt3__26__lessIyyEclERKyS3_"] = createExportWrapper("_ZNKSt3__26__lessIyyEclERKyS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIyEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIyEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIyEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIyyEEPyEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIyyEEPyEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIyyEEPyEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIyyEEPyEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIyyEEPyEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIyyEEPyEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIyyEEPyEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIyyEEPyEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIyyEEPyEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIyyEEPyEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIyyEEPyEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIyyEEPyEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIyyEEPyEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIyyEEPyEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIyyEEPyEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRyEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRyEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRyEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIffEEPfEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIffEEPfEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIffEEPfEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIffEclERKfS3_ = Module["__ZNKSt3__26__lessIffEclERKfS3_"] = createExportWrapper("_ZNKSt3__26__lessIffEclERKfS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIfEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIfEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIfEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIffEEPfEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIffEEPfEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIffEEPfEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIffEEPfEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIffEEPfEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIffEEPfEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIffEEPfEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIffEEPfEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIffEEPfEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIffEEPfEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIffEEPfEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIffEEPfEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIffEEPfEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIffEEPfEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIffEEPfEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRfEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRfEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRfEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIddEEPdEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIddEEPdEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIddEEPdEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIddEclERKdS3_ = Module["__ZNKSt3__26__lessIddEclERKdS3_"] = createExportWrapper("_ZNKSt3__26__lessIddEclERKdS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIdEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIdEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIdEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIddEEPdEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIddEEPdEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIddEEPdEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIddEEPdEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIddEEPdEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIddEEPdEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIddEEPdEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIddEEPdEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIddEEPdEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIddEEPdEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIddEEPdEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIddEEPdEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIddEEPdEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIddEEPdEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIddEEPdEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRdEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRdEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRdEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__26__sortIRNS_6__lessIeeEEPeEEvT0_S5_T_ = Module["__ZNSt3__26__sortIRNS_6__lessIeeEEPeEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__26__sortIRNS_6__lessIeeEEPeEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIeeEclERKeS3_ = Module["__ZNKSt3__26__lessIeeEclERKeS3_"] = createExportWrapper("_ZNKSt3__26__lessIeeEclERKeS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIeEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_ = Module["__ZNSt3__24swapIeEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_"] = createExportWrapper("_ZNSt3__24swapIeEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS2_EE5valueEvE4typeERS2_S5_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort4IRNS_6__lessIeeEEPeEEjT0_S5_S5_S5_T_ = Module["__ZNSt3__27__sort4IRNS_6__lessIeeEEPeEEjT0_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort4IRNS_6__lessIeeEEPeEEjT0_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort5IRNS_6__lessIeeEEPeEEjT0_S5_S5_S5_S5_T_ = Module["__ZNSt3__27__sort5IRNS_6__lessIeeEEPeEEjT0_S5_S5_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort5IRNS_6__lessIeeEEPeEEjT0_S5_S5_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__218__insertion_sort_3IRNS_6__lessIeeEEPeEEvT0_S5_T_ = Module["__ZNSt3__218__insertion_sort_3IRNS_6__lessIeeEEPeEEvT0_S5_T_"] = createExportWrapper("_ZNSt3__218__insertion_sort_3IRNS_6__lessIeeEEPeEEvT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__27__sort3IRNS_6__lessIeeEEPeEEjT0_S5_S5_T_ = Module["__ZNSt3__27__sort3IRNS_6__lessIeeEEPeEEjT0_S5_S5_T_"] = createExportWrapper("_ZNSt3__27__sort3IRNS_6__lessIeeEEPeEEjT0_S5_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIeeEEPeEEbT0_S5_T_ = Module["__ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIeeEEPeEEbT0_S5_T_"] = createExportWrapper("_ZNSt3__227__insertion_sort_incompleteIRNS_6__lessIeeEEPeEEbT0_S5_T_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIReEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIReEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIReEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__212__rs_defaultC2Ev = Module["__ZNSt3__212__rs_defaultC2Ev"] = createExportWrapper("_ZNSt3__212__rs_defaultC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__219__libcpp_mutex_lockEP15pthread_mutex_t = Module["__ZNSt3__219__libcpp_mutex_lockEP15pthread_mutex_t"] = createExportWrapper("_ZNSt3__219__libcpp_mutex_lockEP15pthread_mutex_t");

/** @type {function(...*):?} */
var _pthread_mutex_lock = Module["_pthread_mutex_lock"] = createExportWrapper("pthread_mutex_lock");

/** @type {function(...*):?} */
var __ZNSt3__212__rs_defaultC2ERKS0_ = Module["__ZNSt3__212__rs_defaultC2ERKS0_"] = createExportWrapper("_ZNSt3__212__rs_defaultC2ERKS0_");

/** @type {function(...*):?} */
var __ZNSt3__212__rs_defaultD2Ev = Module["__ZNSt3__212__rs_defaultD2Ev"] = createExportWrapper("_ZNSt3__212__rs_defaultD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__221__libcpp_mutex_unlockEP15pthread_mutex_t = Module["__ZNSt3__221__libcpp_mutex_unlockEP15pthread_mutex_t"] = createExportWrapper("_ZNSt3__221__libcpp_mutex_unlockEP15pthread_mutex_t");

/** @type {function(...*):?} */
var _pthread_mutex_unlock = Module["_pthread_mutex_unlock"] = createExportWrapper("pthread_mutex_unlock");

/** @type {function(...*):?} */
var __ZNSt3__212__rs_defaultclEv = Module["__ZNSt3__212__rs_defaultclEv"] = createExportWrapper("_ZNSt3__212__rs_defaultclEv");

/** @type {function(...*):?} */
var ___cxa_guard_acquire = Module["___cxa_guard_acquire"] = createExportWrapper("__cxa_guard_acquire");

/** @type {function(...*):?} */
var __ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EEC2Ej = Module["__ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EEC2Ej"] = createExportWrapper("_ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EEC2Ej");

/** @type {function(...*):?} */
var ___cxa_guard_release = Module["___cxa_guard_release"] = createExportWrapper("__cxa_guard_release");

/** @type {function(...*):?} */
var __ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EEclEv = Module["__ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EEclEv"] = createExportWrapper("_ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EEclEv");

/** @type {function(...*):?} */
var __ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE4seedEj = Module["__ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE4seedEj"] = createExportWrapper("_ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE4seedEj");

/** @type {function(...*):?} */
var __ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm1EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj = Module["__ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm1EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj"] = createExportWrapper("_ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm1EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj");

/** @type {function(...*):?} */
var __ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm11EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj = Module["__ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm11EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj"] = createExportWrapper("_ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm11EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj");

/** @type {function(...*):?} */
var __ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__lshiftILm7EEENS_9enable_ifIXltT_Lm32EEjE4typeEj = Module["__ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__lshiftILm7EEENS_9enable_ifIXltT_Lm32EEjE4typeEj"] = createExportWrapper("_ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__lshiftILm7EEENS_9enable_ifIXltT_Lm32EEjE4typeEj");

/** @type {function(...*):?} */
var __ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__lshiftILm15EEENS_9enable_ifIXltT_Lm32EEjE4typeEj = Module["__ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__lshiftILm15EEENS_9enable_ifIXltT_Lm32EEjE4typeEj"] = createExportWrapper("_ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__lshiftILm15EEENS_9enable_ifIXltT_Lm32EEjE4typeEj");

/** @type {function(...*):?} */
var __ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm18EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj = Module["__ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm18EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj"] = createExportWrapper("_ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm18EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj");

/** @type {function(...*):?} */
var __ZNSt3__28__rs_getEv = Module["__ZNSt3__28__rs_getEv"] = createExportWrapper("_ZNSt3__28__rs_getEv");

/** @type {function(...*):?} */
var __ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm30EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj = Module["__ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm30EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj"] = createExportWrapper("_ZNSt3__223mersenne_twister_engineIjLm32ELm624ELm397ELm31ELj2567483615ELm11ELj4294967295ELm7ELj2636928640ELm15ELj4022730752ELm18ELj1812433253EE8__rshiftILm30EEENS_9enable_ifIXltT_L_ZNS1_3_DtEEEjE4typeEj");

/** @type {function(...*):?} */
var __ZNSt3__212__rs_defaultC1Ev = Module["__ZNSt3__212__rs_defaultC1Ev"] = createExportWrapper("_ZNSt3__212__rs_defaultC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__212__rs_defaultC1ERKS0_ = Module["__ZNSt3__212__rs_defaultC1ERKS0_"] = createExportWrapper("_ZNSt3__212__rs_defaultC1ERKS0_");

/** @type {function(...*):?} */
var __ZNSt3__212__rs_defaultD1Ev = Module["__ZNSt3__212__rs_defaultD1Ev"] = createExportWrapper("_ZNSt3__212__rs_defaultD1Ev");

/** @type {function(...*):?} */
var __ZNKSt12bad_any_cast4whatEv = Module["__ZNKSt12bad_any_cast4whatEv"] = createExportWrapper("_ZNKSt12bad_any_cast4whatEv");

/** @type {function(...*):?} */
var __ZNKSt12experimental15fundamentals_v112bad_any_cast4whatEv = Module["__ZNKSt12experimental15fundamentals_v112bad_any_cast4whatEv"] = createExportWrapper("_ZNKSt12experimental15fundamentals_v112bad_any_cast4whatEv");

/** @type {function(...*):?} */
var __ZNSt12bad_any_castD0Ev = Module["__ZNSt12bad_any_castD0Ev"] = createExportWrapper("_ZNSt12bad_any_castD0Ev");

/** @type {function(...*):?} */
var __ZNSt8bad_castD2Ev = Module["__ZNSt8bad_castD2Ev"] = createExportWrapper("_ZNSt8bad_castD2Ev");

/** @type {function(...*):?} */
var __ZdlPv = Module["__ZdlPv"] = createExportWrapper("_ZdlPv");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v112bad_any_castD0Ev = Module["__ZNSt12experimental15fundamentals_v112bad_any_castD0Ev"] = createExportWrapper("_ZNSt12experimental15fundamentals_v112bad_any_castD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa8__u32toaEjPc = Module["__ZNSt3__26__itoa8__u32toaEjPc"] = createExportWrapper("_ZNSt3__26__itoa8__u32toaEjPc");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa16append8_no_zerosIjEEPcS2_T_ = Module["__ZNSt3__26__itoa16append8_no_zerosIjEEPcS2_T_"] = createExportWrapper("_ZNSt3__26__itoa16append8_no_zerosIjEEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa16append2_no_zerosIjEEPcS2_T_ = Module["__ZNSt3__26__itoa16append2_no_zerosIjEEPcS2_T_"] = createExportWrapper("_ZNSt3__26__itoa16append2_no_zerosIjEEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa7append4IjEEPcS2_T_ = Module["__ZNSt3__26__itoa7append4IjEEPcS2_T_"] = createExportWrapper("_ZNSt3__26__itoa7append4IjEEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa16append4_no_zerosIjEEPcS2_T_ = Module["__ZNSt3__26__itoa16append4_no_zerosIjEEPcS2_T_"] = createExportWrapper("_ZNSt3__26__itoa16append4_no_zerosIjEEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa7append1IjEEPcS2_T_ = Module["__ZNSt3__26__itoa7append1IjEEPcS2_T_"] = createExportWrapper("_ZNSt3__26__itoa7append1IjEEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa7append2IjEEPcS2_T_ = Module["__ZNSt3__26__itoa7append2IjEEPcS2_T_"] = createExportWrapper("_ZNSt3__26__itoa7append2IjEEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa8__u64toaEyPc = Module["__ZNSt3__26__itoa8__u64toaEyPc"] = createExportWrapper("_ZNSt3__26__itoa8__u64toaEyPc");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa7append3IjEEPcS2_T_ = Module["__ZNSt3__26__itoa7append3IjEEPcS2_T_"] = createExportWrapper("_ZNSt3__26__itoa7append3IjEEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__26chrono12system_clock3nowEv = Module["__ZNSt3__26chrono12system_clock3nowEv"] = createExportWrapper("_ZNSt3__26chrono12system_clock3nowEv");

/** @type {function(...*):?} */
var __ZNSt3__220__throw_system_errorEiPKc = Module["__ZNSt3__220__throw_system_errorEiPKc"] = createExportWrapper("_ZNSt3__220__throw_system_errorEiPKc");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__26chronoplIxNS_5ratioILx1ELx1EEExNS2_ILx1ELx1000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_ = Module["__ZNSt3__26chronoplIxNS_5ratioILx1ELx1EEExNS2_ILx1ELx1000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_"] = createExportWrapper("_ZNSt3__26chronoplIxNS_5ratioILx1ELx1EEExNS2_ILx1ELx1000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_");

/** @type {function(...*):?} */
var __ZNSt3__26chrono10time_pointINS0_12system_clockENS0_8durationIxNS_5ratioILx1ELx1000000EEEEEEC2ERKS6_ = Module["__ZNSt3__26chrono10time_pointINS0_12system_clockENS0_8durationIxNS_5ratioILx1ELx1000000EEEEEEC2ERKS6_"] = createExportWrapper("_ZNSt3__26chrono10time_pointINS0_12system_clockENS0_8durationIxNS_5ratioILx1ELx1000000EEEEEEC2ERKS6_");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEEC2IxNS2_ILx1ELx1EEEEERKNS1_IT_T0_EEPNS_9enable_ifIXaasr13__no_overflowIS8_S3_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEaaeqsr13__no_overflowIS8_S3_E4typeE3denLi1Entsr23treat_as_floating_pointIS7_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEEC2IxNS2_ILx1ELx1EEEEERKNS1_IT_T0_EEPNS_9enable_ifIXaasr13__no_overflowIS8_S3_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEaaeqsr13__no_overflowIS8_S3_E4typeE3denLi1Entsr23treat_as_floating_pointIS7_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEEC2IxNS2_ILx1ELx1EEEEERKNS1_IT_T0_EEPNS_9enable_ifIXaasr13__no_overflowIS8_S3_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEaaeqsr13__no_overflowIS8_S3_E4typeE3denLi1Entsr23treat_as_floating_pointIS7_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEE5countEv = Module["__ZNKSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEE5countEv"] = createExportWrapper("_ZNKSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEE5countEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEEC2IxEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEEC2IxEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000EEEEC2IxEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__26chrono12system_clock9to_time_tERKNS0_10time_pointIS1_NS0_8durationIxNS_5ratioILx1ELx1000000EEEEEEE = Module["__ZNSt3__26chrono12system_clock9to_time_tERKNS0_10time_pointIS1_NS0_8durationIxNS_5ratioILx1ELx1000000EEEEEEE"] = createExportWrapper("_ZNSt3__26chrono12system_clock9to_time_tERKNS0_10time_pointIS1_NS0_8durationIxNS_5ratioILx1ELx1000000EEEEEEE");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono10time_pointINS0_12system_clockENS0_8durationIxNS_5ratioILx1ELx1000000EEEEEE16time_since_epochEv = Module["__ZNKSt3__26chrono10time_pointINS0_12system_clockENS0_8durationIxNS_5ratioILx1ELx1000000EEEEEE16time_since_epochEv"] = createExportWrapper("_ZNKSt3__26chrono10time_pointINS0_12system_clockENS0_8durationIxNS_5ratioILx1ELx1000000EEEEEE16time_since_epochEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEExNS3_ILx1ELx1000000EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE = Module["__ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEExNS3_ILx1ELx1000000EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE"] = createExportWrapper("_ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEExNS3_ILx1ELx1000000EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono8durationIxNS_5ratioILx1ELx1EEEE5countEv = Module["__ZNKSt3__26chrono8durationIxNS_5ratioILx1ELx1EEEE5countEv"] = createExportWrapper("_ZNKSt3__26chrono8durationIxNS_5ratioILx1ELx1EEEE5countEv");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1000000EEEEENS2_IxNS3_ILx1ELx1EEEEES4_Lb1ELb0EEclERKS5_ = Module["__ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1000000EEEEENS2_IxNS3_ILx1ELx1EEEEES4_Lb1ELb0EEclERKS5_"] = createExportWrapper("_ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1000000EEEEENS2_IxNS3_ILx1ELx1EEEEES4_Lb1ELb0EEclERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__26chrono12system_clock11from_time_tEl = Module["__ZNSt3__26chrono12system_clock11from_time_tEl"] = createExportWrapper("_ZNSt3__26chrono12system_clock11from_time_tEl");

/** @type {function(...*):?} */
var __ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1000000EEEEExNS3_ILx1ELx1EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE = Module["__ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1000000EEEEExNS3_ILx1ELx1EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE"] = createExportWrapper("_ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1000000EEEEExNS3_ILx1ELx1EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE");

/** @type {function(...*):?} */
var __ZNSt3__26chrono12steady_clock3nowEv = Module["__ZNSt3__26chrono12steady_clock3nowEv"] = createExportWrapper("_ZNSt3__26chrono12steady_clock3nowEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__26chronoplIxNS_5ratioILx1ELx1EEExNS2_ILx1ELx1000000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_ = Module["__ZNSt3__26chronoplIxNS_5ratioILx1ELx1EEExNS2_ILx1ELx1000000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_"] = createExportWrapper("_ZNSt3__26chronoplIxNS_5ratioILx1ELx1EEExNS2_ILx1ELx1000000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_");

/** @type {function(...*):?} */
var __ZNSt3__26chrono10time_pointINS0_12steady_clockENS0_8durationIxNS_5ratioILx1ELx1000000000EEEEEEC2ERKS6_ = Module["__ZNSt3__26chrono10time_pointINS0_12steady_clockENS0_8durationIxNS_5ratioILx1ELx1000000000EEEEEEC2ERKS6_"] = createExportWrapper("_ZNSt3__26chrono10time_pointINS0_12steady_clockENS0_8durationIxNS_5ratioILx1ELx1000000000EEEEEEC2ERKS6_");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEEC2IxNS2_ILx1ELx1EEEEERKNS1_IT_T0_EEPNS_9enable_ifIXaasr13__no_overflowIS8_S3_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEaaeqsr13__no_overflowIS8_S3_E4typeE3denLi1Entsr23treat_as_floating_pointIS7_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEEC2IxNS2_ILx1ELx1EEEEERKNS1_IT_T0_EEPNS_9enable_ifIXaasr13__no_overflowIS8_S3_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEaaeqsr13__no_overflowIS8_S3_E4typeE3denLi1Entsr23treat_as_floating_pointIS7_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEEC2IxNS2_ILx1ELx1EEEEERKNS1_IT_T0_EEPNS_9enable_ifIXaasr13__no_overflowIS8_S3_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEaaeqsr13__no_overflowIS8_S3_E4typeE3denLi1Entsr23treat_as_floating_pointIS7_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEE5countEv = Module["__ZNKSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEE5countEv"] = createExportWrapper("_ZNKSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEE5countEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEEC2IxEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEEC2IxEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEEC2IxEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1EEEEC2IxEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1EEEEC2IxEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1EEEEC2IxEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_xEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEENS2_IxNS3_ILx1ELx1000000EEEEENS3_ILx1000000ELx1EEELb0ELb1EEclERKS5_ = Module["__ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEENS2_IxNS3_ILx1ELx1000000EEEEENS3_ILx1000000ELx1EEELb0ELb1EEclERKS5_"] = createExportWrapper("_ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEENS2_IxNS3_ILx1ELx1000000EEEEENS3_ILx1000000ELx1EEELb0ELb1EEclERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1000000000EEEEExNS3_ILx1ELx1EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE = Module["__ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1000000000EEEEExNS3_ILx1ELx1EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE"] = createExportWrapper("_ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1000000000EEEEExNS3_ILx1ELx1EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEENS2_IxNS3_ILx1ELx1000000000EEEEENS3_ILx1000000000ELx1EEELb0ELb1EEclERKS5_ = Module["__ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEENS2_IxNS3_ILx1ELx1000000000EEEEENS3_ILx1000000000ELx1EEELb0ELb1EEclERKS5_"] = createExportWrapper("_ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEENS2_IxNS3_ILx1ELx1000000000EEEEENS3_ILx1000000000ELx1EEELb0ELb1EEclERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__218condition_variable10notify_oneEv = Module["__ZNSt3__218condition_variable10notify_oneEv"] = createExportWrapper("_ZNSt3__218condition_variable10notify_oneEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_condvar_signalEP14pthread_cond_t = Module["__ZNSt3__223__libcpp_condvar_signalEP14pthread_cond_t"] = createExportWrapper("_ZNSt3__223__libcpp_condvar_signalEP14pthread_cond_t");

/** @type {function(...*):?} */
var _pthread_cond_signal = Module["_pthread_cond_signal"] = createExportWrapper("pthread_cond_signal");

/** @type {function(...*):?} */
var __ZNSt3__218condition_variable10notify_allEv = Module["__ZNSt3__218condition_variable10notify_allEv"] = createExportWrapper("_ZNSt3__218condition_variable10notify_allEv");

/** @type {function(...*):?} */
var __ZNSt3__226__libcpp_condvar_broadcastEP14pthread_cond_t = Module["__ZNSt3__226__libcpp_condvar_broadcastEP14pthread_cond_t"] = createExportWrapper("_ZNSt3__226__libcpp_condvar_broadcastEP14pthread_cond_t");

/** @type {function(...*):?} */
var _pthread_cond_broadcast = Module["_pthread_cond_broadcast"] = createExportWrapper("pthread_cond_broadcast");

/** @type {function(...*):?} */
var __ZNSt3__218condition_variable4waitERNS_11unique_lockINS_5mutexEEE = Module["__ZNSt3__218condition_variable4waitERNS_11unique_lockINS_5mutexEEE"] = createExportWrapper("_ZNSt3__218condition_variable4waitERNS_11unique_lockINS_5mutexEEE");

/** @type {function(...*):?} */
var __ZNKSt3__211unique_lockINS_5mutexEE9owns_lockEv = Module["__ZNKSt3__211unique_lockINS_5mutexEE9owns_lockEv"] = createExportWrapper("_ZNKSt3__211unique_lockINS_5mutexEE9owns_lockEv");

/** @type {function(...*):?} */
var __ZNKSt3__211unique_lockINS_5mutexEE5mutexEv = Module["__ZNKSt3__211unique_lockINS_5mutexEE5mutexEv"] = createExportWrapper("_ZNKSt3__211unique_lockINS_5mutexEE5mutexEv");

/** @type {function(...*):?} */
var __ZNSt3__25mutex13native_handleEv = Module["__ZNSt3__25mutex13native_handleEv"] = createExportWrapper("_ZNSt3__25mutex13native_handleEv");

/** @type {function(...*):?} */
var __ZNSt3__221__libcpp_condvar_waitEP14pthread_cond_tP15pthread_mutex_t = Module["__ZNSt3__221__libcpp_condvar_waitEP14pthread_cond_tP15pthread_mutex_t"] = createExportWrapper("_ZNSt3__221__libcpp_condvar_waitEP14pthread_cond_tP15pthread_mutex_t");

/** @type {function(...*):?} */
var _pthread_cond_wait = Module["_pthread_cond_wait"] = createExportWrapper("pthread_cond_wait");

/** @type {function(...*):?} */
var __ZNSt3__218condition_variable15__do_timed_waitERNS_11unique_lockINS_5mutexEEENS_6chrono10time_pointINS5_12system_clockENS5_8durationIxNS_5ratioILx1ELx1000000000EEEEEEE = Module["__ZNSt3__218condition_variable15__do_timed_waitERNS_11unique_lockINS_5mutexEEENS_6chrono10time_pointINS5_12system_clockENS5_8durationIxNS_5ratioILx1ELx1000000000EEEEEEE"] = createExportWrapper("_ZNSt3__218condition_variable15__do_timed_waitERNS_11unique_lockINS_5mutexEEENS_6chrono10time_pointINS5_12system_clockENS5_8durationIxNS_5ratioILx1ELx1000000000EEEEEEE");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono10time_pointINS0_12system_clockENS0_8durationIxNS_5ratioILx1ELx1000000000EEEEEE16time_since_epochEv = Module["__ZNKSt3__26chrono10time_pointINS0_12system_clockENS0_8durationIxNS_5ratioILx1ELx1000000000EEEEEE16time_since_epochEv"] = createExportWrapper("_ZNKSt3__26chrono10time_pointINS0_12system_clockENS0_8durationIxNS_5ratioILx1ELx1000000000EEEEEE16time_since_epochEv");

/** @type {function(...*):?} */
var __ZNSt3__26chronogtIxNS_5ratioILx1ELx1000000000EEExS3_EEbRKNS0_8durationIT_T0_EERKNS4_IT1_T2_EE = Module["__ZNSt3__26chronogtIxNS_5ratioILx1ELx1000000000EEExS3_EEbRKNS0_8durationIT_T0_EERKNS4_IT1_T2_EE"] = createExportWrapper("_ZNSt3__26chronogtIxNS_5ratioILx1ELx1000000000EEExS3_EEbRKNS0_8durationIT_T0_EERKNS4_IT1_T2_EE");

/** @type {function(...*):?} */
var __ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEExNS3_ILx1ELx1000000000EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE = Module["__ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEExNS3_ILx1ELx1000000000EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE"] = createExportWrapper("_ZNSt3__26chrono13duration_castINS0_8durationIxNS_5ratioILx1ELx1EEEEExNS3_ILx1ELx1000000000EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE");

/** @type {function(...*):?} */
var __ZNSt3__26chronomiIxNS_5ratioILx1ELx1000000000EEExNS2_ILx1ELx1EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_ = Module["__ZNSt3__26chronomiIxNS_5ratioILx1ELx1000000000EEExNS2_ILx1ELx1EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_"] = createExportWrapper("_ZNSt3__26chronomiIxNS_5ratioILx1ELx1000000000EEExNS2_ILx1ELx1EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_");

/** @type {function(...*):?} */
var __ZNSt3__226__libcpp_condvar_timedwaitEP14pthread_cond_tP15pthread_mutex_tP8timespec = Module["__ZNSt3__226__libcpp_condvar_timedwaitEP14pthread_cond_tP15pthread_mutex_tP8timespec"] = createExportWrapper("_ZNSt3__226__libcpp_condvar_timedwaitEP14pthread_cond_tP15pthread_mutex_tP8timespec");

/** @type {function(...*):?} */
var __ZNSt3__26chronoltIxNS_5ratioILx1ELx1000000000EEExS3_EEbRKNS0_8durationIT_T0_EERKNS4_IT1_T2_EE = Module["__ZNSt3__26chronoltIxNS_5ratioILx1ELx1000000000EEExS3_EEbRKNS0_8durationIT_T0_EERKNS4_IT1_T2_EE"] = createExportWrapper("_ZNSt3__26chronoltIxNS_5ratioILx1ELx1000000000EEExS3_EEbRKNS0_8durationIT_T0_EERKNS4_IT1_T2_EE");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1000000000EEEEENS2_IxNS3_ILx1ELx1EEEEES4_Lb1ELb0EEclERKS5_ = Module["__ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1000000000EEEEENS2_IxNS3_ILx1ELx1EEEEES4_Lb1ELb0EEclERKS5_"] = createExportWrapper("_ZNKSt3__26chrono15__duration_castINS0_8durationIxNS_5ratioILx1ELx1000000000EEEEENS2_IxNS3_ILx1ELx1EEEEES4_Lb1ELb0EEclERKS5_");

/** @type {function(...*):?} */
var _pthread_cond_timedwait = Module["_pthread_cond_timedwait"] = createExportWrapper("pthread_cond_timedwait");

/** @type {function(...*):?} */
var __ZNSt3__225notify_all_at_thread_exitERNS_18condition_variableENS_11unique_lockINS_5mutexEEE = Module["__ZNSt3__225notify_all_at_thread_exitERNS_18condition_variableENS_11unique_lockINS_5mutexEEE"] = createExportWrapper("_ZNSt3__225notify_all_at_thread_exitERNS_18condition_variableENS_11unique_lockINS_5mutexEEE");

/** @type {function(...*):?} */
var __ZNSt3__219__thread_local_dataEv = Module["__ZNSt3__219__thread_local_dataEv"] = createExportWrapper("_ZNSt3__219__thread_local_dataEv");

/** @type {function(...*):?} */
var __ZNKSt3__221__thread_specific_ptrINS_15__thread_structEE3getEv = Module["__ZNKSt3__221__thread_specific_ptrINS_15__thread_structEE3getEv"] = createExportWrapper("_ZNKSt3__221__thread_specific_ptrINS_15__thread_structEE3getEv");

/** @type {function(...*):?} */
var __Znwm = Module["__Znwm"] = createExportWrapper("_Znwm");

/** @type {function(...*):?} */
var __ZNSt3__215__thread_structC1Ev = Module["__ZNSt3__215__thread_structC1Ev"] = createExportWrapper("_ZNSt3__215__thread_structC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__221__thread_specific_ptrINS_15__thread_structEE11set_pointerEPS1_ = Module["__ZNSt3__221__thread_specific_ptrINS_15__thread_structEE11set_pointerEPS1_"] = createExportWrapper("_ZNSt3__221__thread_specific_ptrINS_15__thread_structEE11set_pointerEPS1_");

/** @type {function(...*):?} */
var __ZNKSt3__221__thread_specific_ptrINS_15__thread_structEEptEv = Module["__ZNKSt3__221__thread_specific_ptrINS_15__thread_structEEptEv"] = createExportWrapper("_ZNKSt3__221__thread_specific_ptrINS_15__thread_structEEptEv");

/** @type {function(...*):?} */
var __ZNSt3__211unique_lockINS_5mutexEE7releaseEv = Module["__ZNSt3__211unique_lockINS_5mutexEE7releaseEv"] = createExportWrapper("_ZNSt3__211unique_lockINS_5mutexEE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__215__thread_struct25notify_all_at_thread_exitEPNS_18condition_variableEPNS_5mutexE = Module["__ZNSt3__215__thread_struct25notify_all_at_thread_exitEPNS_18condition_variableEPNS_5mutexE"] = createExportWrapper("_ZNSt3__215__thread_struct25notify_all_at_thread_exitEPNS_18condition_variableEPNS_5mutexE");

/** @type {function(...*):?} */
var __ZNSt3__216__libcpp_tls_getEj = Module["__ZNSt3__216__libcpp_tls_getEj"] = createExportWrapper("_ZNSt3__216__libcpp_tls_getEj");

/** @type {function(...*):?} */
var __ZNSt3__216__libcpp_tls_setEjPv = Module["__ZNSt3__216__libcpp_tls_setEjPv"] = createExportWrapper("_ZNSt3__216__libcpp_tls_setEjPv");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono13__duration_ltINS0_8durationIxNS_5ratioILx1ELx1000000000EEEEES5_EclERKS5_S8_ = Module["__ZNKSt3__26chrono13__duration_ltINS0_8durationIxNS_5ratioILx1ELx1000000000EEEEES5_EclERKS5_S8_"] = createExportWrapper("_ZNKSt3__26chrono13__duration_ltINS0_8durationIxNS_5ratioILx1ELx1000000000EEEEES5_EclERKS5_S8_");

/** @type {function(...*):?} */
var _pthread_getspecific = Module["_pthread_getspecific"] = createExportWrapper("pthread_getspecific");

/** @type {function(...*):?} */
var _pthread_setspecific = Module["_pthread_setspecific"] = createExportWrapper("pthread_setspecific");

/** @type {function(...*):?} */
var __ZNSt3__218condition_variableD2Ev = Module["__ZNSt3__218condition_variableD2Ev"] = createExportWrapper("_ZNSt3__218condition_variableD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__224__libcpp_condvar_destroyEP14pthread_cond_t = Module["__ZNSt3__224__libcpp_condvar_destroyEP14pthread_cond_t"] = createExportWrapper("_ZNSt3__224__libcpp_condvar_destroyEP14pthread_cond_t");

/** @type {function(...*):?} */
var _pthread_cond_destroy = Module["_pthread_cond_destroy"] = createExportWrapper("pthread_cond_destroy");

/** @type {function(...*):?} */
var __ZNSt3__218condition_variableD1Ev = Module["__ZNSt3__218condition_variableD1Ev"] = createExportWrapper("_ZNSt3__218condition_variableD1Ev");

/** @type {function(...*):?} */
var __ZNKSt3__219__libcpp_debug_info4whatEv = Module["__ZNKSt3__219__libcpp_debug_info4whatEv"] = createExportWrapper("_ZNKSt3__219__libcpp_debug_info4whatEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IDnEEPKc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IDnEEPKc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IDnEEPKc");

/** @type {function(...*):?} */
var __ZNSt3__29to_stringEi = Module["__ZNSt3__29to_stringEi"] = createExportWrapper("_ZNSt3__29to_stringEi");

/** @type {function(...*):?} */
var __ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEPKS6_OS9_ = Module["__ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEPKS6_OS9_"] = createExportWrapper("_ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEPKS6_OS9_");

/** @type {function(...*):?} */
var __ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEOS9_PKS6_ = Module["__ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEOS9_PKS6_"] = createExportWrapper("_ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEOS9_PKS6_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEpLERKS5_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEpLERKS5_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEpLERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEED2Ev = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEED2Ev"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEpLEPKc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEpLEPKc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEpLEPKc");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_EC2INS_18__default_init_tagESA_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_EC2INS_18__default_init_tagESA_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_EC2INS_18__default_init_tagESA_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE6lengthEPKc = Module["__ZNSt3__211char_traitsIcE6lengthEPKc"] = createExportWrapper("_ZNSt3__211char_traitsIcE6lengthEPKc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initEPKcm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initEPKcm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initEPKcm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendEPKc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendEPKc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendEPKc");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEONS_16remove_referenceIT_E4typeEOS9_ = Module["__ZNSt3__24moveIRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEONS_16remove_referenceIT_E4typeEOS9_"] = createExportWrapper("_ZNSt3__24moveIRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEONS_16remove_referenceIT_E4typeEOS9_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2EOS5_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2EOS5_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2EOS5_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmPKc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmPKc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmPKc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendERKS5_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendERKS5_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__229__libcpp_abort_debug_functionERKNS_19__libcpp_debug_infoE = Module["__ZNSt3__229__libcpp_abort_debug_functionERKNS_19__libcpp_debug_infoE"] = createExportWrapper("_ZNSt3__229__libcpp_abort_debug_functionERKNS_19__libcpp_debug_infoE");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5c_strEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5c_strEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5c_strEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4dataEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4dataEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4dataEv");

/** @type {function(...*):?} */
var __ZNSt3__227__libcpp_set_debug_functionEPFvRKNS_19__libcpp_debug_infoEE = Module["__ZNSt3__227__libcpp_set_debug_functionEPFvRKNS_19__libcpp_debug_infoEE"] = createExportWrapper("_ZNSt3__227__libcpp_set_debug_functionEPFvRKNS_19__libcpp_debug_infoEE");

/** @type {function(...*):?} */
var __ZNSt3__28__get_dbEv = Module["__ZNSt3__28__get_dbEv"] = createExportWrapper("_ZNSt3__28__get_dbEv");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_dbC2Ev = Module["__ZNSt3__211__libcpp_dbC2Ev"] = createExportWrapper("_ZNSt3__211__libcpp_dbC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214__get_const_dbEv = Module["__ZNSt3__214__get_const_dbEv"] = createExportWrapper("_ZNSt3__214__get_const_dbEv");

/** @type {function(...*):?} */
var __ZNSt3__28__i_nodeD2Ev = Module["__ZNSt3__28__i_nodeD2Ev"] = createExportWrapper("_ZNSt3__28__i_nodeD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28__c_nodeD2Ev = Module["__ZNSt3__28__c_nodeD2Ev"] = createExportWrapper("_ZNSt3__28__c_nodeD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28__c_nodeD0Ev = Module["__ZNSt3__28__c_nodeD0Ev"] = createExportWrapper("_ZNSt3__28__c_nodeD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_dbD2Ev = Module["__ZNSt3__211__libcpp_dbD2Ev"] = createExportWrapper("_ZNSt3__211__libcpp_dbD2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__211__libcpp_db15__find_c_from_iEPv = Module["__ZNKSt3__211__libcpp_db15__find_c_from_iEPv"] = createExportWrapper("_ZNKSt3__211__libcpp_db15__find_c_from_iEPv");

/** @type {function(...*):?} */
var __ZNSt3__210lock_guardINS_5mutexEEC2ERS1_ = Module["__ZNSt3__210lock_guardINS_5mutexEEC2ERS1_"] = createExportWrapper("_ZNSt3__210lock_guardINS_5mutexEEC2ERS1_");

/** @type {function(...*):?} */
var __ZNKSt3__211__libcpp_db15__find_iteratorEPKv = Module["__ZNKSt3__211__libcpp_db15__find_iteratorEPKv"] = createExportWrapper("_ZNKSt3__211__libcpp_db15__find_iteratorEPKv");

/** @type {function(...*):?} */
var __ZNSt3__210lock_guardINS_5mutexEED2Ev = Module["__ZNSt3__210lock_guardINS_5mutexEED2Ev"] = createExportWrapper("_ZNSt3__210lock_guardINS_5mutexEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__25mutex4lockEv = Module["__ZNSt3__25mutex4lockEv"] = createExportWrapper("_ZNSt3__25mutex4lockEv");

/** @type {function(...*):?} */
var __ZNKSt3__24hashIPKvEclES2_ = Module["__ZNKSt3__24hashIPKvEclES2_"] = createExportWrapper("_ZNKSt3__24hashIPKvEclES2_");

/** @type {function(...*):?} */
var __ZNSt3__25mutex6unlockEv = Module["__ZNSt3__25mutex6unlockEv"] = createExportWrapper("_ZNSt3__25mutex6unlockEv");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_db11__insert_icEPvPKv = Module["__ZNSt3__211__libcpp_db11__insert_icEPvPKv"] = createExportWrapper("_ZNSt3__211__libcpp_db11__insert_icEPvPKv");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_db17__insert_iteratorEPv = Module["__ZNSt3__211__libcpp_db17__insert_iteratorEPv"] = createExportWrapper("_ZNSt3__211__libcpp_db17__insert_iteratorEPv");

/** @type {function(...*):?} */
var __ZNSt3__28__c_node5__addEPNS_8__i_nodeE = Module["__ZNSt3__28__c_node5__addEPNS_8__i_nodeE"] = createExportWrapper("_ZNSt3__28__c_node5__addEPNS_8__i_nodeE");

/** @type {function(...*):?} */
var __ZNSt3__221__murmur2_or_cityhashImLm32EEclEPKvm = Module["__ZNSt3__221__murmur2_or_cityhashImLm32EEclEPKvm"] = createExportWrapper("_ZNSt3__221__murmur2_or_cityhashImLm32EEclEPKvm");

/** @type {function(...*):?} */
var __ZNSt3__212__next_primeEm = Module["__ZNSt3__212__next_primeEm"] = createExportWrapper("_ZNSt3__212__next_primeEm");

/** @type {function(...*):?} */
var __ZNKSt3__24hashIPvEclES1_ = Module["__ZNKSt3__24hashIPvEclES1_"] = createExportWrapper("_ZNKSt3__24hashIPvEclES1_");

/** @type {function(...*):?} */
var __ZNSt3__28__i_nodeC2EPvPS0_PNS_8__c_nodeE = Module["__ZNSt3__28__i_nodeC2EPvPS0_PNS_8__c_nodeE"] = createExportWrapper("_ZNSt3__28__i_nodeC2EPvPS0_PNS_8__c_nodeE");

/** @type {function(...*):?} */
var __ZSt17__throw_bad_allocv = Module["__ZSt17__throw_bad_allocv"] = createExportWrapper("_ZSt17__throw_bad_allocv");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_db10__insert_cEPvPFPNS_8__c_nodeES1_S1_S3_E = Module["__ZNSt3__211__libcpp_db10__insert_cEPvPFPNS_8__c_nodeES1_S1_S3_E"] = createExportWrapper("_ZNSt3__211__libcpp_db10__insert_cEPvPFPNS_8__c_nodeES1_S1_S3_E");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_db9__erase_iEPv = Module["__ZNSt3__211__libcpp_db9__erase_iEPv"] = createExportWrapper("_ZNSt3__211__libcpp_db9__erase_iEPv");

/** @type {function(...*):?} */
var __ZNSt3__28__c_node8__removeEPNS_8__i_nodeE = Module["__ZNSt3__28__c_node8__removeEPNS_8__i_nodeE"] = createExportWrapper("_ZNSt3__28__c_node8__removeEPNS_8__i_nodeE");

/** @type {function(...*):?} */
var __ZNSt3__24findIPPNS_8__i_nodeES2_EET_S4_S4_RKT0_ = Module["__ZNSt3__24findIPPNS_8__i_nodeES2_EET_S4_S4_RKT0_"] = createExportWrapper("_ZNSt3__24findIPPNS_8__i_nodeES2_EET_S4_S4_RKT0_");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_db16__invalidate_allEPv = Module["__ZNSt3__211__libcpp_db16__invalidate_allEPv"] = createExportWrapper("_ZNSt3__211__libcpp_db16__invalidate_allEPv");

/** @type {function(...*):?} */
var __ZNKSt3__211__libcpp_db17__find_c_and_lockEPv = Module["__ZNKSt3__211__libcpp_db17__find_c_and_lockEPv"] = createExportWrapper("_ZNKSt3__211__libcpp_db17__find_c_and_lockEPv");

/** @type {function(...*):?} */
var __ZNKSt3__211__libcpp_db8__find_cEPv = Module["__ZNKSt3__211__libcpp_db8__find_cEPv"] = createExportWrapper("_ZNKSt3__211__libcpp_db8__find_cEPv");

/** @type {function(...*):?} */
var __ZNKSt3__211__libcpp_db6unlockEv = Module["__ZNKSt3__211__libcpp_db6unlockEv"] = createExportWrapper("_ZNKSt3__211__libcpp_db6unlockEv");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_db9__erase_cEPv = Module["__ZNSt3__211__libcpp_db9__erase_cEPv"] = createExportWrapper("_ZNSt3__211__libcpp_db9__erase_cEPv");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_db15__iterator_copyEPvPKv = Module["__ZNSt3__211__libcpp_db15__iterator_copyEPvPKv"] = createExportWrapper("_ZNSt3__211__libcpp_db15__iterator_copyEPvPKv");

/** @type {function(...*):?} */
var __ZNKSt3__211__libcpp_db17__dereferenceableEPKv = Module["__ZNKSt3__211__libcpp_db17__dereferenceableEPKv"] = createExportWrapper("_ZNKSt3__211__libcpp_db17__dereferenceableEPKv");

/** @type {function(...*):?} */
var __ZNKSt3__211__libcpp_db15__decrementableEPKv = Module["__ZNKSt3__211__libcpp_db15__decrementableEPKv"] = createExportWrapper("_ZNKSt3__211__libcpp_db15__decrementableEPKv");

/** @type {function(...*):?} */
var __ZNKSt3__211__libcpp_db9__addableEPKvl = Module["__ZNKSt3__211__libcpp_db9__addableEPKvl"] = createExportWrapper("_ZNKSt3__211__libcpp_db9__addableEPKvl");

/** @type {function(...*):?} */
var __ZNKSt3__211__libcpp_db15__subscriptableEPKvl = Module["__ZNKSt3__211__libcpp_db15__subscriptableEPKvl"] = createExportWrapper("_ZNKSt3__211__libcpp_db15__subscriptableEPKvl");

/** @type {function(...*):?} */
var __ZNKSt3__211__libcpp_db22__less_than_comparableEPKvS2_ = Module["__ZNKSt3__211__libcpp_db22__less_than_comparableEPKvS2_"] = createExportWrapper("_ZNKSt3__211__libcpp_db22__less_than_comparableEPKvS2_");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_db4swapEPvS1_ = Module["__ZNSt3__211__libcpp_db4swapEPvS1_"] = createExportWrapper("_ZNSt3__211__libcpp_db4swapEPvS1_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPPNS_8__i_nodeEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_ = Module["__ZNSt3__24swapIPPNS_8__i_nodeEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_"] = createExportWrapper("_ZNSt3__24swapIPPNS_8__i_nodeEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPPNS_8__i_nodeEEEONS_16remove_referenceIT_E4typeEOS6_ = Module["__ZNSt3__24moveIRPPNS_8__i_nodeEEEONS_16remove_referenceIT_E4typeEOS6_"] = createExportWrapper("_ZNSt3__24moveIRPPNS_8__i_nodeEEEONS_16remove_referenceIT_E4typeEOS6_");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_db10__insert_iEPv = Module["__ZNSt3__211__libcpp_db10__insert_iEPv"] = createExportWrapper("_ZNSt3__211__libcpp_db10__insert_iEPv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE9__is_longEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE9__is_longEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE9__is_longEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E5firstEv = Module["__ZNKSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E5firstEv = Module["__ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_18__default_init_tagEEEOT_RNS_16remove_referenceIS2_E4typeE = Module["__ZNSt3__27forwardINS_18__default_init_tagEEEOT_RNS_16remove_referenceIS2_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_18__default_init_tagEEEOT_RNS_16remove_referenceIS2_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repELi0ELb0EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repELi0ELb0EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repELi0ELb0EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIcEC2Ev = Module["__ZNSt3__29allocatorIcEC2Ev"] = createExportWrapper("_ZNSt3__29allocatorIcEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_17__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES6_EEEEONS_16remove_referenceIT_E4typeEOSC_ = Module["__ZNSt3__24moveIRNS_17__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES6_EEEEONS_16remove_referenceIT_E4typeEOSC_"] = createExportWrapper("_ZNSt3__24moveIRNS_17__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES6_EEEEONS_16remove_referenceIT_E4typeEOSC_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__zeroEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__zeroEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__zeroEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4sizeEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4sizeEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendEPKcm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendEPKcm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendEPKcm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13__get_pointerEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13__get_pointerEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13__get_pointerEv");

/** @type {function(...*):?} */
var __ZNSt3__212__to_addressIKcEEPT_S3_ = Module["__ZNSt3__212__to_addressIKcEEPT_S3_"] = createExportWrapper("_ZNSt3__212__to_addressIKcEEPT_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE15__get_long_sizeEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE15__get_long_sizeEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE15__get_long_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE16__get_short_sizeEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE16__get_short_sizeEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE16__get_short_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE18__get_long_pointerEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE18__get_long_pointerEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE18__get_long_pointerEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__get_short_pointerEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__get_short_pointerEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__get_short_pointerEv");

/** @type {function(...*):?} */
var __ZNSt3__214pointer_traitsIPKcE10pointer_toERS1_ = Module["__ZNSt3__214pointer_traitsIPKcE10pointer_toERS1_"] = createExportWrapper("_ZNSt3__214pointer_traitsIPKcE10pointer_toERS1_");

/** @type {function(...*):?} */
var __ZNSt3__29addressofIKcEEPT_RS2_ = Module["__ZNSt3__29addressofIKcEEPT_RS2_"] = createExportWrapper("_ZNSt3__29addressofIKcEEPT_RS2_");

/** @type {function(...*):?} */
var __ZNSt3__210__loadwordImEET_PKv = Module["__ZNSt3__210__loadwordImEET_PKv"] = createExportWrapper("_ZNSt3__210__loadwordImEET_PKv");

/** @type {function(...*):?} */
var ___cxa_pure_virtual = Module["___cxa_pure_virtual"] = createExportWrapper("__cxa_pure_virtual");

/** @type {function(...*):?} */
var __ZNSt3__28__i_nodeD1Ev = Module["__ZNSt3__28__i_nodeD1Ev"] = createExportWrapper("_ZNSt3__28__i_nodeD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__28__c_nodeD1Ev = Module["__ZNSt3__28__c_nodeD1Ev"] = createExportWrapper("_ZNSt3__28__c_nodeD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_dbC1Ev = Module["__ZNSt3__211__libcpp_dbC1Ev"] = createExportWrapper("_ZNSt3__211__libcpp_dbC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__211__libcpp_dbD1Ev = Module["__ZNSt3__211__libcpp_dbD1Ev"] = createExportWrapper("_ZNSt3__211__libcpp_dbD1Ev");

/** @type {function(...*):?} */
var __ZSt18uncaught_exceptionv = Module["__ZSt18uncaught_exceptionv"] = createExportWrapper("_ZSt18uncaught_exceptionv");

/** @type {function(...*):?} */
var __ZSt19uncaught_exceptionsv = Module["__ZSt19uncaught_exceptionsv"] = createExportWrapper("_ZSt19uncaught_exceptionsv");

/** @type {function(...*):?} */
var ___cxa_uncaught_exceptions = Module["___cxa_uncaught_exceptions"] = createExportWrapper("__cxa_uncaught_exceptions");

/** @type {function(...*):?} */
var __ZNSt13exception_ptrD2Ev = Module["__ZNSt13exception_ptrD2Ev"] = createExportWrapper("_ZNSt13exception_ptrD2Ev");

/** @type {function(...*):?} */
var ___cxa_decrement_exception_refcount = Module["___cxa_decrement_exception_refcount"] = createExportWrapper("__cxa_decrement_exception_refcount");

/** @type {function(...*):?} */
var __ZNSt13exception_ptrC2ERKS_ = Module["__ZNSt13exception_ptrC2ERKS_"] = createExportWrapper("_ZNSt13exception_ptrC2ERKS_");

/** @type {function(...*):?} */
var ___cxa_increment_exception_refcount = Module["___cxa_increment_exception_refcount"] = createExportWrapper("__cxa_increment_exception_refcount");

/** @type {function(...*):?} */
var __ZNSt13exception_ptraSERKS_ = Module["__ZNSt13exception_ptraSERKS_"] = createExportWrapper("_ZNSt13exception_ptraSERKS_");

/** @type {function(...*):?} */
var __ZNSt16nested_exceptionC2Ev = Module["__ZNSt16nested_exceptionC2Ev"] = createExportWrapper("_ZNSt16nested_exceptionC2Ev");

/** @type {function(...*):?} */
var __ZSt17current_exceptionv = Module["__ZSt17current_exceptionv"] = createExportWrapper("_ZSt17current_exceptionv");

/** @type {function(...*):?} */
var __ZNSt13exception_ptrC2Ev = Module["__ZNSt13exception_ptrC2Ev"] = createExportWrapper("_ZNSt13exception_ptrC2Ev");

/** @type {function(...*):?} */
var ___cxa_current_primary_exception = Module["___cxa_current_primary_exception"] = createExportWrapper("__cxa_current_primary_exception");

/** @type {function(...*):?} */
var __ZNSt16nested_exceptionD2Ev = Module["__ZNSt16nested_exceptionD2Ev"] = createExportWrapper("_ZNSt16nested_exceptionD2Ev");

/** @type {function(...*):?} */
var __ZNSt16nested_exceptionD0Ev = Module["__ZNSt16nested_exceptionD0Ev"] = createExportWrapper("_ZNSt16nested_exceptionD0Ev");

/** @type {function(...*):?} */
var __ZNKSt16nested_exception14rethrow_nestedEv = Module["__ZNKSt16nested_exception14rethrow_nestedEv"] = createExportWrapper("_ZNKSt16nested_exception14rethrow_nestedEv");

/** @type {function(...*):?} */
var __ZNSt13exception_ptrC2EDn = Module["__ZNSt13exception_ptrC2EDn"] = createExportWrapper("_ZNSt13exception_ptrC2EDn");

/** @type {function(...*):?} */
var __ZSteqRKSt13exception_ptrS1_ = Module["__ZSteqRKSt13exception_ptrS1_"] = createExportWrapper("_ZSteqRKSt13exception_ptrS1_");

/** @type {function(...*):?} */
var __ZSt9terminatev = Module["__ZSt9terminatev"] = createExportWrapper("_ZSt9terminatev");

/** @type {function(...*):?} */
var __ZSt17rethrow_exceptionSt13exception_ptr = Module["__ZSt17rethrow_exceptionSt13exception_ptr"] = createExportWrapper("_ZSt17rethrow_exceptionSt13exception_ptr");

/** @type {function(...*):?} */
var ___cxa_rethrow_primary_exception = Module["___cxa_rethrow_primary_exception"] = createExportWrapper("__cxa_rethrow_primary_exception");

/** @type {function(...*):?} */
var __ZNSt13exception_ptrD1Ev = Module["__ZNSt13exception_ptrD1Ev"] = createExportWrapper("_ZNSt13exception_ptrD1Ev");

/** @type {function(...*):?} */
var __ZNSt13exception_ptrC1ERKS_ = Module["__ZNSt13exception_ptrC1ERKS_"] = createExportWrapper("_ZNSt13exception_ptrC1ERKS_");

/** @type {function(...*):?} */
var __ZNSt16nested_exceptionC1Ev = Module["__ZNSt16nested_exceptionC1Ev"] = createExportWrapper("_ZNSt16nested_exceptionC1Ev");

/** @type {function(...*):?} */
var __ZNSt16nested_exceptionD1Ev = Module["__ZNSt16nested_exceptionD1Ev"] = createExportWrapper("_ZNSt16nested_exceptionD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__217bad_function_callD2Ev = Module["__ZNSt3__217bad_function_callD2Ev"] = createExportWrapper("_ZNSt3__217bad_function_callD2Ev");

/** @type {function(...*):?} */
var __ZNSt9exceptionD2Ev = Module["__ZNSt9exceptionD2Ev"] = createExportWrapper("_ZNSt9exceptionD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217bad_function_callD0Ev = Module["__ZNSt3__217bad_function_callD0Ev"] = createExportWrapper("_ZNSt3__217bad_function_callD0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__217bad_function_call4whatEv = Module["__ZNKSt3__217bad_function_call4whatEv"] = createExportWrapper("_ZNKSt3__217bad_function_call4whatEv");

/** @type {function(...*):?} */
var __ZNSt3__217bad_function_callD1Ev = Module["__ZNSt3__217bad_function_callD1Ev"] = createExportWrapper("_ZNSt3__217bad_function_callD1Ev");

/** @type {function(...*):?} */
var __ZNKSt3__223__future_error_category4nameEv = Module["__ZNKSt3__223__future_error_category4nameEv"] = createExportWrapper("_ZNKSt3__223__future_error_category4nameEv");

/** @type {function(...*):?} */
var __ZNKSt3__223__future_error_category7messageEi = Module["__ZNKSt3__223__future_error_category7messageEi"] = createExportWrapper("_ZNKSt3__223__future_error_category7messageEi");

/** @type {function(...*):?} */
var __ZNSt3__215future_categoryEv = Module["__ZNSt3__215future_categoryEv"] = createExportWrapper("_ZNSt3__215future_categoryEv");

/** @type {function(...*):?} */
var __ZNSt3__214error_categoryD2Ev = Module["__ZNSt3__214error_categoryD2Ev"] = createExportWrapper("_ZNSt3__214error_categoryD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__212future_errorC2ENS_10error_codeE = Module["__ZNSt3__212future_errorC2ENS_10error_codeE"] = createExportWrapper("_ZNSt3__212future_errorC2ENS_10error_codeE");

/** @type {function(...*):?} */
var __ZNKSt3__210error_code7messageEv = Module["__ZNKSt3__210error_code7messageEv"] = createExportWrapper("_ZNKSt3__210error_code7messageEv");

/** @type {function(...*):?} */
var __ZNSt11logic_errorC2ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE = Module["__ZNSt11logic_errorC2ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE"] = createExportWrapper("_ZNSt11logic_errorC2ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__212future_errorD2Ev = Module["__ZNSt3__212future_errorD2Ev"] = createExportWrapper("_ZNSt3__212future_errorD2Ev");

/** @type {function(...*):?} */
var __ZNSt11logic_errorD2Ev = Module["__ZNSt11logic_errorD2Ev"] = createExportWrapper("_ZNSt11logic_errorD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__212future_errorD0Ev = Module["__ZNSt3__212future_errorD0Ev"] = createExportWrapper("_ZNSt3__212future_errorD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_state16__on_zero_sharedEv = Module["__ZNSt3__217__assoc_sub_state16__on_zero_sharedEv"] = createExportWrapper("_ZNSt3__217__assoc_sub_state16__on_zero_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_state9set_valueEv = Module["__ZNSt3__217__assoc_sub_state9set_valueEv"] = createExportWrapper("_ZNSt3__217__assoc_sub_state9set_valueEv");

/** @type {function(...*):?} */
var __ZNSt3__211unique_lockINS_5mutexEEC2ERS1_ = Module["__ZNSt3__211unique_lockINS_5mutexEEC2ERS1_"] = createExportWrapper("_ZNSt3__211unique_lockINS_5mutexEEC2ERS1_");

/** @type {function(...*):?} */
var __ZNKSt3__217__assoc_sub_state11__has_valueEv = Module["__ZNKSt3__217__assoc_sub_state11__has_valueEv"] = createExportWrapper("_ZNKSt3__217__assoc_sub_state11__has_valueEv");

/** @type {function(...*):?} */
var __ZNSt3__220__throw_future_errorENS_11future_errcE = Module["__ZNSt3__220__throw_future_errorENS_11future_errcE"] = createExportWrapper("_ZNSt3__220__throw_future_errorENS_11future_errcE");

/** @type {function(...*):?} */
var __ZNSt3__211unique_lockINS_5mutexEED2Ev = Module["__ZNSt3__211unique_lockINS_5mutexEED2Ev"] = createExportWrapper("_ZNSt3__211unique_lockINS_5mutexEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__29addressofINS_5mutexEEEPT_RS2_ = Module["__ZNSt3__29addressofINS_5mutexEEEPT_RS2_"] = createExportWrapper("_ZNSt3__29addressofINS_5mutexEEEPT_RS2_");

/** @type {function(...*):?} */
var __ZStneRKSt13exception_ptrS1_ = Module["__ZStneRKSt13exception_ptrS1_"] = createExportWrapper("_ZStneRKSt13exception_ptrS1_");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_state24set_value_at_thread_exitEv = Module["__ZNSt3__217__assoc_sub_state24set_value_at_thread_exitEv"] = createExportWrapper("_ZNSt3__217__assoc_sub_state24set_value_at_thread_exitEv");

/** @type {function(...*):?} */
var __ZNSt3__215__thread_struct27__make_ready_at_thread_exitEPNS_17__assoc_sub_stateE = Module["__ZNSt3__215__thread_struct27__make_ready_at_thread_exitEPNS_17__assoc_sub_stateE"] = createExportWrapper("_ZNSt3__215__thread_struct27__make_ready_at_thread_exitEPNS_17__assoc_sub_stateE");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_state13set_exceptionESt13exception_ptr = Module["__ZNSt3__217__assoc_sub_state13set_exceptionESt13exception_ptr"] = createExportWrapper("_ZNSt3__217__assoc_sub_state13set_exceptionESt13exception_ptr");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_state28set_exception_at_thread_exitESt13exception_ptr = Module["__ZNSt3__217__assoc_sub_state28set_exception_at_thread_exitESt13exception_ptr"] = createExportWrapper("_ZNSt3__217__assoc_sub_state28set_exception_at_thread_exitESt13exception_ptr");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_state12__make_readyEv = Module["__ZNSt3__217__assoc_sub_state12__make_readyEv"] = createExportWrapper("_ZNSt3__217__assoc_sub_state12__make_readyEv");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_state4copyEv = Module["__ZNSt3__217__assoc_sub_state4copyEv"] = createExportWrapper("_ZNSt3__217__assoc_sub_state4copyEv");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_state10__sub_waitERNS_11unique_lockINS_5mutexEEE = Module["__ZNSt3__217__assoc_sub_state10__sub_waitERNS_11unique_lockINS_5mutexEEE"] = createExportWrapper("_ZNSt3__217__assoc_sub_state10__sub_waitERNS_11unique_lockINS_5mutexEEE");

/** @type {function(...*):?} */
var __ZNKSt3__217__assoc_sub_state10__is_readyEv = Module["__ZNKSt3__217__assoc_sub_state10__is_readyEv"] = createExportWrapper("_ZNKSt3__217__assoc_sub_state10__is_readyEv");

/** @type {function(...*):?} */
var __ZNSt3__211unique_lockINS_5mutexEE6unlockEv = Module["__ZNSt3__211unique_lockINS_5mutexEE6unlockEv"] = createExportWrapper("_ZNSt3__211unique_lockINS_5mutexEE6unlockEv");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_state4waitEv = Module["__ZNSt3__217__assoc_sub_state4waitEv"] = createExportWrapper("_ZNSt3__217__assoc_sub_state4waitEv");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_state9__executeEv = Module["__ZNSt3__217__assoc_sub_state9__executeEv"] = createExportWrapper("_ZNSt3__217__assoc_sub_state9__executeEv");

/** @type {function(...*):?} */
var __ZNSt3__26futureIvEC2EPNS_17__assoc_sub_stateE = Module["__ZNSt3__26futureIvEC2EPNS_17__assoc_sub_stateE"] = createExportWrapper("_ZNSt3__26futureIvEC2EPNS_17__assoc_sub_stateE");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_state15__attach_futureEv = Module["__ZNSt3__217__assoc_sub_state15__attach_futureEv"] = createExportWrapper("_ZNSt3__217__assoc_sub_state15__attach_futureEv");

/** @type {function(...*):?} */
var __ZNSt3__214__shared_count12__add_sharedEv = Module["__ZNSt3__214__shared_count12__add_sharedEv"] = createExportWrapper("_ZNSt3__214__shared_count12__add_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__26futureIvED2Ev = Module["__ZNSt3__26futureIvED2Ev"] = createExportWrapper("_ZNSt3__26futureIvED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214__shared_count16__release_sharedEv = Module["__ZNSt3__214__shared_count16__release_sharedEv"] = createExportWrapper("_ZNSt3__214__shared_count16__release_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__234__libcpp_atomic_refcount_decrementIlEET_RS1_ = Module["__ZNSt3__234__libcpp_atomic_refcount_decrementIlEET_RS1_"] = createExportWrapper("_ZNSt3__234__libcpp_atomic_refcount_decrementIlEET_RS1_");

/** @type {function(...*):?} */
var __ZNSt3__26futureIvE3getEv = Module["__ZNSt3__26futureIvE3getEv"] = createExportWrapper("_ZNSt3__26futureIvE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrINS_14__shared_countENS_22__release_shared_countEEC2ILb1EvEEPS1_ = Module["__ZNSt3__210unique_ptrINS_14__shared_countENS_22__release_shared_countEEC2ILb1EvEEPS1_"] = createExportWrapper("_ZNSt3__210unique_ptrINS_14__shared_countENS_22__release_shared_countEEC2ILb1EvEEPS1_");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrINS_14__shared_countENS_22__release_shared_countEED2Ev = Module["__ZNSt3__210unique_ptrINS_14__shared_countENS_22__release_shared_countEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrINS_14__shared_countENS_22__release_shared_countEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_14__shared_countENS_22__release_shared_countEEC2IRS2_NS_18__default_init_tagEEEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPNS_14__shared_countENS_22__release_shared_countEEC2IRS2_NS_18__default_init_tagEEEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_14__shared_countENS_22__release_shared_countEEC2IRS2_NS_18__default_init_tagEEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrINS_14__shared_countENS_22__release_shared_countEE5resetEPS1_ = Module["__ZNSt3__210unique_ptrINS_14__shared_countENS_22__release_shared_countEE5resetEPS1_"] = createExportWrapper("_ZNSt3__210unique_ptrINS_14__shared_countENS_22__release_shared_countEE5resetEPS1_");

/** @type {function(...*):?} */
var __ZNSt3__27promiseIvEC2Ev = Module["__ZNSt3__27promiseIvEC2Ev"] = createExportWrapper("_ZNSt3__27promiseIvEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_stateC2Ev = Module["__ZNSt3__217__assoc_sub_stateC2Ev"] = createExportWrapper("_ZNSt3__217__assoc_sub_stateC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214__shared_countC2El = Module["__ZNSt3__214__shared_countC2El"] = createExportWrapper("_ZNSt3__214__shared_countC2El");

/** @type {function(...*):?} */
var __ZNSt3__25mutexC2Ev = Module["__ZNSt3__25mutexC2Ev"] = createExportWrapper("_ZNSt3__25mutexC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__218condition_variableC2Ev = Module["__ZNSt3__218condition_variableC2Ev"] = createExportWrapper("_ZNSt3__218condition_variableC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27promiseIvED2Ev = Module["__ZNSt3__27promiseIvED2Ev"] = createExportWrapper("_ZNSt3__27promiseIvED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27promiseIvE10get_futureEv = Module["__ZNSt3__27promiseIvE10get_futureEv"] = createExportWrapper("_ZNSt3__27promiseIvE10get_futureEv");

/** @type {function(...*):?} */
var __ZNSt3__27promiseIvE9set_valueEv = Module["__ZNSt3__27promiseIvE9set_valueEv"] = createExportWrapper("_ZNSt3__27promiseIvE9set_valueEv");

/** @type {function(...*):?} */
var __ZNSt3__27promiseIvE13set_exceptionESt13exception_ptr = Module["__ZNSt3__27promiseIvE13set_exceptionESt13exception_ptr"] = createExportWrapper("_ZNSt3__27promiseIvE13set_exceptionESt13exception_ptr");

/** @type {function(...*):?} */
var __ZNSt3__27promiseIvE24set_value_at_thread_exitEv = Module["__ZNSt3__27promiseIvE24set_value_at_thread_exitEv"] = createExportWrapper("_ZNSt3__27promiseIvE24set_value_at_thread_exitEv");

/** @type {function(...*):?} */
var __ZNSt3__27promiseIvE28set_exception_at_thread_exitESt13exception_ptr = Module["__ZNSt3__27promiseIvE28set_exception_at_thread_exitESt13exception_ptr"] = createExportWrapper("_ZNSt3__27promiseIvE28set_exception_at_thread_exitESt13exception_ptr");

/** @type {function(...*):?} */
var __ZNSt3__213shared_futureIvED2Ev = Module["__ZNSt3__213shared_futureIvED2Ev"] = createExportWrapper("_ZNSt3__213shared_futureIvED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213shared_futureIvEaSERKS1_ = Module["__ZNSt3__213shared_futureIvEaSERKS1_"] = createExportWrapper("_ZNSt3__213shared_futureIvEaSERKS1_");

/** @type {function(...*):?} */
var __ZNSt3__234__libcpp_atomic_refcount_incrementIlEET_RS1_ = Module["__ZNSt3__234__libcpp_atomic_refcount_incrementIlEET_RS1_"] = createExportWrapper("_ZNSt3__234__libcpp_atomic_refcount_incrementIlEET_RS1_");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_stateD2Ev = Module["__ZNSt3__217__assoc_sub_stateD2Ev"] = createExportWrapper("_ZNSt3__217__assoc_sub_stateD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__25mutexD1Ev = Module["__ZNSt3__25mutexD1Ev"] = createExportWrapper("_ZNSt3__25mutexD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214__shared_countD2Ev = Module["__ZNSt3__214__shared_countD2Ev"] = createExportWrapper("_ZNSt3__214__shared_countD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__assoc_sub_stateD0Ev = Module["__ZNSt3__217__assoc_sub_stateD0Ev"] = createExportWrapper("_ZNSt3__217__assoc_sub_stateD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__223__future_error_categoryD0Ev = Module["__ZNSt3__223__future_error_categoryD0Ev"] = createExportWrapper("_ZNSt3__223__future_error_categoryD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPNS_14__shared_countEEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRPNS_14__shared_countEEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPNS_14__shared_countEEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_14__shared_countELi0ELb0EEC2IRS2_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPNS_14__shared_countELi0ELb0EEC2IRS2_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_14__shared_countELi0ELb0EEC2IRS2_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_22__release_shared_countELi1ELb1EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_22__release_shared_countELi1ELb1EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_22__release_shared_countELi1ELb1EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_14__shared_countENS_22__release_shared_countEE5firstEv = Module["__ZNSt3__217__compressed_pairIPNS_14__shared_countENS_22__release_shared_countEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_14__shared_countENS_22__release_shared_countEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_14__shared_countENS_22__release_shared_countEE6secondEv = Module["__ZNSt3__217__compressed_pairIPNS_14__shared_countENS_22__release_shared_countEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_14__shared_countENS_22__release_shared_countEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__222__release_shared_countclEPNS_14__shared_countE = Module["__ZNSt3__222__release_shared_countclEPNS_14__shared_countE"] = createExportWrapper("_ZNSt3__222__release_shared_countclEPNS_14__shared_countE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_14__shared_countELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPNS_14__shared_countELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_14__shared_countELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_22__release_shared_countELi1ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_22__release_shared_countELi1ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_22__release_shared_countELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__214error_category23default_error_conditionEi = Module["__ZNKSt3__214error_category23default_error_conditionEi"] = createExportWrapper("_ZNKSt3__214error_category23default_error_conditionEi");

/** @type {function(...*):?} */
var __ZNKSt3__214error_category10equivalentEiRKNS_15error_conditionE = Module["__ZNKSt3__214error_category10equivalentEiRKNS_15error_conditionE"] = createExportWrapper("_ZNKSt3__214error_category10equivalentEiRKNS_15error_conditionE");

/** @type {function(...*):?} */
var __ZNKSt3__214error_category10equivalentERKNS_10error_codeEi = Module["__ZNKSt3__214error_category10equivalentERKNS_10error_codeEi"] = createExportWrapper("_ZNKSt3__214error_category10equivalentERKNS_10error_codeEi");

/** @type {function(...*):?} */
var __ZNKSt11logic_error4whatEv = Module["__ZNKSt11logic_error4whatEv"] = createExportWrapper("_ZNKSt11logic_error4whatEv");

/** @type {function(...*):?} */
var __ZNSt3__212future_errorC1ENS_10error_codeE = Module["__ZNSt3__212future_errorC1ENS_10error_codeE"] = createExportWrapper("_ZNSt3__212future_errorC1ENS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__212future_errorD1Ev = Module["__ZNSt3__212future_errorD1Ev"] = createExportWrapper("_ZNSt3__212future_errorD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__26futureIvEC1EPNS_17__assoc_sub_stateE = Module["__ZNSt3__26futureIvEC1EPNS_17__assoc_sub_stateE"] = createExportWrapper("_ZNSt3__26futureIvEC1EPNS_17__assoc_sub_stateE");

/** @type {function(...*):?} */
var __ZNSt3__26futureIvED1Ev = Module["__ZNSt3__26futureIvED1Ev"] = createExportWrapper("_ZNSt3__26futureIvED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__27promiseIvEC1Ev = Module["__ZNSt3__27promiseIvEC1Ev"] = createExportWrapper("_ZNSt3__27promiseIvEC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__27promiseIvED1Ev = Module["__ZNSt3__27promiseIvED1Ev"] = createExportWrapper("_ZNSt3__27promiseIvED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__213shared_futureIvED1Ev = Module["__ZNSt3__213shared_futureIvED1Ev"] = createExportWrapper("_ZNSt3__213shared_futureIvED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__211lower_boundIPKjmEET_S3_S3_RKT0_ = Module["__ZNSt3__211lower_boundIPKjmEET_S3_S3_RKT0_"] = createExportWrapper("_ZNSt3__211lower_boundIPKjmEET_S3_S3_RKT0_");

/** @type {function(...*):?} */
var __ZNSt3__220__check_for_overflowILm4EEENS_9enable_ifIXeqT_Li4EEvE4typeEm = Module["__ZNSt3__220__check_for_overflowILm4EEENS_9enable_ifIXeqT_Li4EEvE4typeEm"] = createExportWrapper("_ZNSt3__220__check_for_overflowILm4EEENS_9enable_ifIXeqT_Li4EEvE4typeEm");

/** @type {function(...*):?} */
var __ZNSt3__211lower_boundIPKjmNS_6__lessIjmEEEET_S5_S5_RKT0_T1_ = Module["__ZNSt3__211lower_boundIPKjmNS_6__lessIjmEEEET_S5_S5_RKT0_T1_"] = createExportWrapper("_ZNSt3__211lower_boundIPKjmNS_6__lessIjmEEEET_S5_S5_RKT0_T1_");

/** @type {function(...*):?} */
var __ZNSt3__222__throw_overflow_errorEPKc = Module["__ZNSt3__222__throw_overflow_errorEPKc"] = createExportWrapper("_ZNSt3__222__throw_overflow_errorEPKc");

/** @type {function(...*):?} */
var __ZNSt3__213__lower_boundIRNS_6__lessIjmEEPKjmEET0_S6_S6_RKT1_T_ = Module["__ZNSt3__213__lower_boundIRNS_6__lessIjmEEPKjmEET0_S6_S6_RKT1_T_"] = createExportWrapper("_ZNSt3__213__lower_boundIRNS_6__lessIjmEEPKjmEET0_S6_S6_RKT1_T_");

/** @type {function(...*):?} */
var __ZNSt3__28distanceIPKjEENS_15iterator_traitsIT_E15difference_typeES4_S4_ = Module["__ZNSt3__28distanceIPKjEENS_15iterator_traitsIT_E15difference_typeES4_S4_"] = createExportWrapper("_ZNSt3__28distanceIPKjEENS_15iterator_traitsIT_E15difference_typeES4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__215__half_positiveIlEENS_9enable_ifIXsr11is_integralIT_EE5valueES2_E4typeES2_ = Module["__ZNSt3__215__half_positiveIlEENS_9enable_ifIXsr11is_integralIT_EE5valueES2_E4typeES2_"] = createExportWrapper("_ZNSt3__215__half_positiveIlEENS_9enable_ifIXsr11is_integralIT_EE5valueES2_E4typeES2_");

/** @type {function(...*):?} */
var __ZNSt3__27advanceIPKjEEvRT_NS_15iterator_traitsIS3_E15difference_typeE = Module["__ZNSt3__27advanceIPKjEEvRT_NS_15iterator_traitsIS3_E15difference_typeE"] = createExportWrapper("_ZNSt3__27advanceIPKjEEvRT_NS_15iterator_traitsIS3_E15difference_typeE");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIjmEclERKjRKm = Module["__ZNKSt3__26__lessIjmEclERKjRKm"] = createExportWrapper("_ZNKSt3__26__lessIjmEclERKjRKm");

/** @type {function(...*):?} */
var __ZNSt3__210__distanceIPKjEENS_15iterator_traitsIT_E15difference_typeES4_S4_NS_26random_access_iterator_tagE = Module["__ZNSt3__210__distanceIPKjEENS_15iterator_traitsIT_E15difference_typeES4_S4_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__210__distanceIPKjEENS_15iterator_traitsIT_E15difference_typeES4_S4_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__29__advanceIPKjEEvRT_NS_15iterator_traitsIS3_E15difference_typeENS_26random_access_iterator_tagE = Module["__ZNSt3__29__advanceIPKjEEvRT_NS_15iterator_traitsIS3_E15difference_typeENS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__29__advanceIPKjEEvRT_NS_15iterator_traitsIS3_E15difference_typeENS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIcNS_11char_traitsIcEEED2Ev = Module["__ZNSt3__29basic_iosIcNS_11char_traitsIcEEED2Ev"] = createExportWrapper("_ZNSt3__29basic_iosIcNS_11char_traitsIcEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28ios_baseD2Ev = Module["__ZNSt3__28ios_baseD2Ev"] = createExportWrapper("_ZNSt3__28ios_baseD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base16__call_callbacksENS0_5eventE = Module["__ZNSt3__28ios_base16__call_callbacksENS0_5eventE"] = createExportWrapper("_ZNSt3__28ios_base16__call_callbacksENS0_5eventE");

/** @type {function(...*):?} */
var __ZNSt3__26localeD1Ev = Module["__ZNSt3__26localeD1Ev"] = createExportWrapper("_ZNSt3__26localeD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIcNS_11char_traitsIcEEED0Ev = Module["__ZNSt3__29basic_iosIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZNSt3__29basic_iosIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIcNS_11char_traitsIcEEE7copyfmtERKS3_ = Module["__ZNSt3__29basic_iosIcNS_11char_traitsIcEEE7copyfmtERKS3_"] = createExportWrapper("_ZNSt3__29basic_iosIcNS_11char_traitsIcEEE7copyfmtERKS3_");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base7copyfmtERKS0_ = Module["__ZNSt3__28ios_base7copyfmtERKS0_"] = createExportWrapper("_ZNSt3__28ios_base7copyfmtERKS0_");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE10exceptionsEv = Module["__ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE10exceptionsEv"] = createExportWrapper("_ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE10exceptionsEv");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIcNS_11char_traitsIcEEE10exceptionsEj = Module["__ZNSt3__29basic_iosIcNS_11char_traitsIcEEE10exceptionsEj"] = createExportWrapper("_ZNSt3__29basic_iosIcNS_11char_traitsIcEEE10exceptionsEj");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEEC2ILb1EvEEPS5_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS8_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEEC2ILb1EvEEPS5_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS8_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEEC2ILb1EvEEPS5_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS8_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIiPFvPvEEC2ILb1EvEEPiNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrIiPFvPvEEC2ILb1EvEEPiNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrIiPFvPvEEC2ILb1EvEEPiNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIlPFvPvEEC2ILb1EvEEPlNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrIlPFvPvEEC2ILb1EvEEPlNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrIlPFvPvEEC2ILb1EvEEPlNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPvPFvS1_EEC2ILb1EvEEPS1_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrIPvPFvS1_EEC2ILb1EvEEPS1_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrIPvPFvS1_EEC2ILb1EvEEPS1_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEE5resetEPS5_ = Module["__ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEE5resetEPS5_"] = createExportWrapper("_ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEE5resetEPS5_");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEEcvbEv = Module["__ZNKSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEEcvbEv"] = createExportWrapper("_ZNKSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEEcvbEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIiPFvPvEE5resetEPi = Module["__ZNSt3__210unique_ptrIiPFvPvEE5resetEPi"] = createExportWrapper("_ZNSt3__210unique_ptrIiPFvPvEE5resetEPi");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrIiPFvPvEEcvbEv = Module["__ZNKSt3__210unique_ptrIiPFvPvEEcvbEv"] = createExportWrapper("_ZNKSt3__210unique_ptrIiPFvPvEEcvbEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIlPFvPvEE5resetEPl = Module["__ZNSt3__210unique_ptrIlPFvPvEE5resetEPl"] = createExportWrapper("_ZNSt3__210unique_ptrIlPFvPvEE5resetEPl");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrIlPFvPvEEcvbEv = Module["__ZNKSt3__210unique_ptrIlPFvPvEEcvbEv"] = createExportWrapper("_ZNKSt3__210unique_ptrIlPFvPvEEcvbEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPvPFvS1_EE5resetEPS1_ = Module["__ZNSt3__210unique_ptrIPvPFvS1_EE5resetEPS1_"] = createExportWrapper("_ZNSt3__210unique_ptrIPvPFvS1_EE5resetEPS1_");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrIPvPFvS1_EEcvbEv = Module["__ZNKSt3__210unique_ptrIPvPFvS1_EEcvbEv"] = createExportWrapper("_ZNKSt3__210unique_ptrIPvPFvS1_EEcvbEv");

/** @type {function(...*):?} */
var __ZNSt3__26localeaSERKS0_ = Module["__ZNSt3__26localeaSERKS0_"] = createExportWrapper("_ZNSt3__26localeaSERKS0_");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEE7releaseEv = Module["__ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEE7releaseEv"] = createExportWrapper("_ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIiPFvPvEE7releaseEv = Module["__ZNSt3__210unique_ptrIiPFvPvEE7releaseEv"] = createExportWrapper("_ZNSt3__210unique_ptrIiPFvPvEE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIlPFvPvEE7releaseEv = Module["__ZNSt3__210unique_ptrIlPFvPvEE7releaseEv"] = createExportWrapper("_ZNSt3__210unique_ptrIlPFvPvEE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPvPFvS1_EE7releaseEv = Module["__ZNSt3__210unique_ptrIPvPFvS1_EE7releaseEv"] = createExportWrapper("_ZNSt3__210unique_ptrIPvPFvS1_EE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPvPFvS1_EED2Ev = Module["__ZNSt3__210unique_ptrIPvPFvS1_EED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrIPvPFvS1_EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIlPFvPvEED2Ev = Module["__ZNSt3__210unique_ptrIlPFvPvEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrIlPFvPvEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIiPFvPvEED2Ev = Module["__ZNSt3__210unique_ptrIiPFvPvEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrIiPFvPvEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEED2Ev = Module["__ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrIPFvNS_8ios_base5eventERS1_iEPFvPvEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base10exceptionsEj = Module["__ZNSt3__28ios_base10exceptionsEj"] = createExportWrapper("_ZNSt3__28ios_base10exceptionsEj");

/** @type {function(...*):?} */
var __ZNKSt3__28ios_base10exceptionsEv = Module["__ZNKSt3__28ios_base10exceptionsEv"] = createExportWrapper("_ZNKSt3__28ios_base10exceptionsEv");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIwNS_11char_traitsIwEEED2Ev = Module["__ZNSt3__29basic_iosIwNS_11char_traitsIwEEED2Ev"] = createExportWrapper("_ZNSt3__29basic_iosIwNS_11char_traitsIwEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIwNS_11char_traitsIwEEED0Ev = Module["__ZNSt3__29basic_iosIwNS_11char_traitsIwEEED0Ev"] = createExportWrapper("_ZNSt3__29basic_iosIwNS_11char_traitsIwEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIwNS_11char_traitsIwEEE7copyfmtERKS3_ = Module["__ZNSt3__29basic_iosIwNS_11char_traitsIwEEE7copyfmtERKS3_"] = createExportWrapper("_ZNSt3__29basic_iosIwNS_11char_traitsIwEEE7copyfmtERKS3_");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE10exceptionsEv = Module["__ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE10exceptionsEv"] = createExportWrapper("_ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE10exceptionsEv");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIwNS_11char_traitsIwEEE10exceptionsEj = Module["__ZNSt3__29basic_iosIwNS_11char_traitsIwEEE10exceptionsEj"] = createExportWrapper("_ZNSt3__29basic_iosIwNS_11char_traitsIwEEE10exceptionsEj");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEED2Ev = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEED2Ev"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEED0Ev = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC2Ev = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC2Ev"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26localeC1Ev = Module["__ZNSt3__26localeC1Ev"] = createExportWrapper("_ZNSt3__26localeC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC2ERKS3_ = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC2ERKS3_"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC2ERKS3_");

/** @type {function(...*):?} */
var __ZNSt3__26localeC1ERKS0_ = Module["__ZNSt3__26localeC1ERKS0_"] = createExportWrapper("_ZNSt3__26localeC1ERKS0_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEaSERKS3_ = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEaSERKS3_"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEaSERKS3_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4swapERS3_ = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4swapERS3_"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4swapERS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapINS_6localeEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_ = Module["__ZNSt3__24swapINS_6localeEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_"] = createExportWrapper("_ZNSt3__24swapINS_6localeEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPcEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_ = Module["__ZNSt3__24swapIPcEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_"] = createExportWrapper("_ZNSt3__24swapIPcEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_6localeEEEONS_16remove_referenceIT_E4typeEOS4_ = Module["__ZNSt3__24moveIRNS_6localeEEEONS_16remove_referenceIT_E4typeEOS4_"] = createExportWrapper("_ZNSt3__24moveIRNS_6localeEEEONS_16remove_referenceIT_E4typeEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPcEEONS_16remove_referenceIT_E4typeEOS4_ = Module["__ZNSt3__24moveIRPcEEONS_16remove_referenceIT_E4typeEOS4_"] = createExportWrapper("_ZNSt3__24moveIRPcEEONS_16remove_referenceIT_E4typeEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5imbueERKNS_6localeE = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5imbueERKNS_6localeE"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5imbueERKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6setbufEPcl = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6setbufEPcl"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6setbufEPcl");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7seekoffExNS_8ios_base7seekdirEj = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7seekoffExNS_8ios_base7seekdirEj"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7seekoffExNS_8ios_base7seekdirEj");

/** @type {function(...*):?} */
var __ZNSt3__24fposI11__mbstate_tEC2Ex = Module["__ZNSt3__24fposI11__mbstate_tEC2Ex"] = createExportWrapper("_ZNSt3__24fposI11__mbstate_tEC2Ex");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7seekposENS_4fposI11__mbstate_tEEj = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7seekposENS_4fposI11__mbstate_tEEj"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7seekposENS_4fposI11__mbstate_tEEj");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4syncEv = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4syncEv"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4syncEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9showmanycEv = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9showmanycEv"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9showmanycEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6xsgetnEPcl = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6xsgetnEPcl"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6xsgetnEPcl");

/** @type {function(...*):?} */
var __ZNSt3__23minIlEERKT_S3_S3_ = Module["__ZNSt3__23minIlEERKT_S3_S3_"] = createExportWrapper("_ZNSt3__23minIlEERKT_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE4copyEPcPKcm = Module["__ZNSt3__211char_traitsIcE4copyEPcPKcm"] = createExportWrapper("_ZNSt3__211char_traitsIcE4copyEPcPKcm");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5gbumpEi = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5gbumpEi"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5gbumpEi");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE12to_char_typeEi = Module["__ZNSt3__211char_traitsIcE12to_char_typeEi"] = createExportWrapper("_ZNSt3__211char_traitsIcE12to_char_typeEi");

/** @type {function(...*):?} */
var __ZNSt3__23minIlNS_6__lessIllEEEERKT_S5_S5_T0_ = Module["__ZNSt3__23minIlNS_6__lessIllEEEERKT_S5_S5_T0_"] = createExportWrapper("_ZNSt3__23minIlNS_6__lessIllEEEERKT_S5_S5_T0_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9underflowEv = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9underflowEv"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9underflowEv");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE3eofEv = Module["__ZNSt3__211char_traitsIcE3eofEv"] = createExportWrapper("_ZNSt3__211char_traitsIcE3eofEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5uflowEv = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5uflowEv"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5uflowEv");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE11to_int_typeEc = Module["__ZNSt3__211char_traitsIcE11to_int_typeEc"] = createExportWrapper("_ZNSt3__211char_traitsIcE11to_int_typeEc");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9pbackfailEi = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9pbackfailEi"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9pbackfailEi");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6xsputnEPKcl = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6xsputnEPKcl"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6xsputnEPKcl");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE8overflowEi = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE8overflowEi"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE8overflowEi");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEED2Ev = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEED2Ev"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEED0Ev = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEED0Ev"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC2Ev = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC2Ev"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC2ERKS3_ = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC2ERKS3_"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC2ERKS3_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEaSERKS3_ = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEaSERKS3_"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEaSERKS3_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE4swapERS3_ = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE4swapERS3_"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE4swapERS3_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPwEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_ = Module["__ZNSt3__24swapIPwEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_"] = createExportWrapper("_ZNSt3__24swapIPwEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPwEEONS_16remove_referenceIT_E4typeEOS4_ = Module["__ZNSt3__24moveIRPwEEONS_16remove_referenceIT_E4typeEOS4_"] = createExportWrapper("_ZNSt3__24moveIRPwEEONS_16remove_referenceIT_E4typeEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5imbueERKNS_6localeE = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5imbueERKNS_6localeE"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5imbueERKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6setbufEPwl = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6setbufEPwl"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6setbufEPwl");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7seekoffExNS_8ios_base7seekdirEj = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7seekoffExNS_8ios_base7seekdirEj"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7seekoffExNS_8ios_base7seekdirEj");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7seekposENS_4fposI11__mbstate_tEEj = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7seekposENS_4fposI11__mbstate_tEEj"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7seekposENS_4fposI11__mbstate_tEEj");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE4syncEv = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE4syncEv"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE4syncEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9showmanycEv = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9showmanycEv"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9showmanycEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6xsgetnEPwl = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6xsgetnEPwl"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6xsgetnEPwl");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE4copyEPwPKwm = Module["__ZNSt3__211char_traitsIwE4copyEPwPKwm"] = createExportWrapper("_ZNSt3__211char_traitsIwE4copyEPwPKwm");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5gbumpEi = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5gbumpEi"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5gbumpEi");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE12to_char_typeEj = Module["__ZNSt3__211char_traitsIwE12to_char_typeEj"] = createExportWrapper("_ZNSt3__211char_traitsIwE12to_char_typeEj");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9underflowEv = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9underflowEv"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9underflowEv");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE3eofEv = Module["__ZNSt3__211char_traitsIwE3eofEv"] = createExportWrapper("_ZNSt3__211char_traitsIwE3eofEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5uflowEv = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5uflowEv"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5uflowEv");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE11to_int_typeEw = Module["__ZNSt3__211char_traitsIwE11to_int_typeEw"] = createExportWrapper("_ZNSt3__211char_traitsIwE11to_int_typeEw");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9pbackfailEj = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9pbackfailEj"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9pbackfailEj");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6xsputnEPKwl = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6xsputnEPKwl"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6xsputnEPKwl");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE8overflowEj = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE8overflowEj"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE8overflowEj");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEED2Ev = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEED2Ev"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEED1Ev = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__213basic_istreamIcNS_11char_traitsIcEEED1Ev = Module["__ZTv0_n12_NSt3__213basic_istreamIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZTv0_n12_NSt3__213basic_istreamIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEED0Ev = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__213basic_istreamIcNS_11char_traitsIcEEED0Ev = Module["__ZTv0_n12_NSt3__213basic_istreamIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZTv0_n12_NSt3__213basic_istreamIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE6sentryC2ERS3_b = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE6sentryC2ERS3_b"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE6sentryC2ERS3_b");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE4goodEv = Module["__ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE4goodEv"] = createExportWrapper("_ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE4goodEv");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE3tieEv = Module["__ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE3tieEv"] = createExportWrapper("_ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE3tieEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE5flushEv = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE5flushEv"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE5flushEv");

/** @type {function(...*):?} */
var __ZNKSt3__28ios_base5flagsEv = Module["__ZNKSt3__28ios_base5flagsEv"] = createExportWrapper("_ZNKSt3__28ios_base5flagsEv");

/** @type {function(...*):?} */
var __ZNKSt3__28ios_base6getlocEv = Module["__ZNKSt3__28ios_base6getlocEv"] = createExportWrapper("_ZNKSt3__28ios_base6getlocEv");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_5ctypeIcEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_5ctypeIcEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_5ctypeIcEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEC2ERNS_13basic_istreamIcS2_EE = Module["__ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEC2ERNS_13basic_istreamIcS2_EE"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEC2ERNS_13basic_istreamIcS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEC2Ev = Module["__ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEC2Ev"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__2neIcNS_11char_traitsIcEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_ = Module["__ZNSt3__2neIcNS_11char_traitsIcEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_"] = createExportWrapper("_ZNSt3__2neIcNS_11char_traitsIcEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_");

/** @type {function(...*):?} */
var __ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEdeEv = Module["__ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEdeEv"] = createExportWrapper("_ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEdeEv");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE2isEtc = Module["__ZNKSt3__25ctypeIcE2isEtc"] = createExportWrapper("_ZNKSt3__25ctypeIcE2isEtc");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEppEv = Module["__ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEppEv"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEppEv");

/** @type {function(...*):?} */
var __ZNSt3__2eqIcNS_11char_traitsIcEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_ = Module["__ZNSt3__2eqIcNS_11char_traitsIcEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_"] = createExportWrapper("_ZNSt3__2eqIcNS_11char_traitsIcEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIcNS_11char_traitsIcEEE8setstateEj = Module["__ZNSt3__29basic_iosIcNS_11char_traitsIcEEE8setstateEj"] = createExportWrapper("_ZNSt3__29basic_iosIcNS_11char_traitsIcEEE8setstateEj");

/** @type {function(...*):?} */
var __ZNKSt3__28ios_base4goodEv = Module["__ZNKSt3__28ios_base4goodEv"] = createExportWrapper("_ZNKSt3__28ios_base4goodEv");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE5rdbufEv = Module["__ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE5rdbufEv"] = createExportWrapper("_ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE5rdbufEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryC2ERS3_ = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryC2ERS3_"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryC2ERS3_");

/** @type {function(...*):?} */
var __ZNKSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentrycvbEv = Module["__ZNKSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentrycvbEv"] = createExportWrapper("_ZNKSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentrycvbEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7pubsyncEv = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7pubsyncEv"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7pubsyncEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryD2Ev = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryD2Ev"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryD2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__26locale9use_facetERNS0_2idE = Module["__ZNKSt3__26locale9use_facetERNS0_2idE"] = createExportWrapper("_ZNKSt3__26locale9use_facetERNS0_2idE");

/** @type {function(...*):?} */
var __ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE5equalERKS3_ = Module["__ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE5equalERKS3_"] = createExportWrapper("_ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE5equalERKS3_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sgetcEv = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sgetcEv"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sgetcEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6sbumpcEv = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6sbumpcEv"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE6sbumpcEv");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base8setstateEj = Module["__ZNSt3__28ios_base8setstateEj"] = createExportWrapper("_ZNSt3__28ios_base8setstateEj");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsEPNS_15basic_streambufIcS2_EE = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsEPNS_15basic_streambufIcS2_EE"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsEPNS_15basic_streambufIcS2_EE");

/** @type {function(...*):?} */
var __ZNKSt3__213basic_istreamIcNS_11char_traitsIcEEE6sentrycvbEv = Module["__ZNKSt3__213basic_istreamIcNS_11char_traitsIcEEE6sentrycvbEv"] = createExportWrapper("_ZNKSt3__213basic_istreamIcNS_11char_traitsIcEEE6sentrycvbEv");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE11eq_int_typeEii = Module["__ZNSt3__211char_traitsIcE11eq_int_typeEii"] = createExportWrapper("_ZNSt3__211char_traitsIcE11eq_int_typeEii");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sputcEc = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sputcEc"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sputcEc");

/** @type {function(...*):?} */
var __ZNKSt3__28ios_base5rdbufEv = Module["__ZNKSt3__28ios_base5rdbufEv"] = createExportWrapper("_ZNKSt3__28ios_base5rdbufEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERb = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERb"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERb");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIbcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIbcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIbcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_7num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_7num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_7num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRb = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRb"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRb");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERs = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERs"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERs");

/** @type {function(...*):?} */
var __ZNSt3__238__input_arithmetic_with_numeric_limitsIscNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__238__input_arithmetic_with_numeric_limitsIscNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__238__input_arithmetic_with_numeric_limitsIscNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRl = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRl"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRl");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIsE3minEv = Module["__ZNSt3__214numeric_limitsIsE3minEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIsE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIsE3maxEv = Module["__ZNSt3__214numeric_limitsIsE3maxEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIsE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERt = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERt"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERt");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticItcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticItcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticItcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRt = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRt"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRt");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERi = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERi"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERi");

/** @type {function(...*):?} */
var __ZNSt3__238__input_arithmetic_with_numeric_limitsIicNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__238__input_arithmetic_with_numeric_limitsIicNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__238__input_arithmetic_with_numeric_limitsIicNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIiE3minEv = Module["__ZNSt3__214numeric_limitsIiE3minEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIiE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIiE3maxEv = Module["__ZNSt3__214numeric_limitsIiE3maxEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIiE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERj = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERj"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERj");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIjcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIjcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIjcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjS8_ = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjS8_"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjS8_");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERl = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERl"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERl");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIlcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIlcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIlcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERm = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERm"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERm");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticImcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticImcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticImcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRm = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRm"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRm");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERx = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERx"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERx");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIxcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIxcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIxcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRx = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRx"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRx");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERy = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERy"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERy");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIycNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIycNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIycNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRy = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRy"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRy");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERf = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERf"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERf");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIfcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIfcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIfcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRf = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRf"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRf");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERd = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERd"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERd");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIdcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIdcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIdcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRd = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRd"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRd");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERe = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERe"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERe");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIecNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIecNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIecNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRe = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRe"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRe");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERPv = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERPv"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEErsERPv");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIPvcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES8_RT_ = Module["__ZNSt3__218__input_arithmeticIPvcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES8_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIPvcNS_11char_traitsIcEEEERNS_13basic_istreamIT0_T1_EES8_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRPv = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRPv"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjRPv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE3getEv = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE3getEv"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE3getEPclc = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE3getEPclc"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE3getEPclc");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE2eqEcc = Module["__ZNSt3__211char_traitsIcE2eqEcc"] = createExportWrapper("_ZNSt3__211char_traitsIcE2eqEcc");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE3getERNS_15basic_streambufIcS2_EEc = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE3getERNS_15basic_streambufIcS2_EEc"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE3getERNS_15basic_streambufIcS2_EEc");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE7getlineEPclc = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE7getlineEPclc"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE7getlineEPclc");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE6ignoreEli = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE6ignoreEli"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE6ignoreEli");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIlE3maxEv = Module["__ZNSt3__214numeric_limitsIlE3maxEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIlE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIlLb1EE3maxEv = Module["__ZNSt3__223__libcpp_numeric_limitsIlLb1EE3maxEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIlLb1EE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE4peekEv = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE4peekEv"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE4peekEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE4readEPcl = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE4readEPcl"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE4readEPcl");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sgetnEPcl = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sgetnEPcl"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sgetnEPcl");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE8readsomeEPcl = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE8readsomeEPcl"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE8readsomeEPcl");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE8in_availEv = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE8in_availEv"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE8in_availEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE7putbackEc = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE7putbackEc"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE7putbackEc");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE7rdstateEv = Module["__ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE7rdstateEv"] = createExportWrapper("_ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE7rdstateEv");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIcNS_11char_traitsIcEEE5clearEj = Module["__ZNSt3__29basic_iosIcNS_11char_traitsIcEEE5clearEj"] = createExportWrapper("_ZNSt3__29basic_iosIcNS_11char_traitsIcEEE5clearEj");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9sputbackcEc = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9sputbackcEc"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE9sputbackcEc");

/** @type {function(...*):?} */
var __ZNKSt3__28ios_base7rdstateEv = Module["__ZNKSt3__28ios_base7rdstateEv"] = createExportWrapper("_ZNKSt3__28ios_base7rdstateEv");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base5clearEj = Module["__ZNSt3__28ios_base5clearEj"] = createExportWrapper("_ZNSt3__28ios_base5clearEj");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5ungetEv = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5ungetEv"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5ungetEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7sungetcEv = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7sungetcEv"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7sungetcEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE4syncEv = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE4syncEv"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE4syncEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5tellgEv = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5tellgEv"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5tellgEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE10pubseekoffExNS_8ios_base7seekdirEj = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE10pubseekoffExNS_8ios_base7seekdirEj"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE10pubseekoffExNS_8ios_base7seekdirEj");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5seekgENS_4fposI11__mbstate_tEE = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5seekgENS_4fposI11__mbstate_tEE"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5seekgENS_4fposI11__mbstate_tEE");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE10pubseekposENS_4fposI11__mbstate_tEEj = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE10pubseekposENS_4fposI11__mbstate_tEEj"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE10pubseekposENS_4fposI11__mbstate_tEEj");

/** @type {function(...*):?} */
var __ZNSt3__2eqI11__mbstate_tEEbRKNS_4fposIT_EES6_ = Module["__ZNSt3__2eqI11__mbstate_tEEbRKNS_4fposIT_EES6_"] = createExportWrapper("_ZNSt3__2eqI11__mbstate_tEEbRKNS_4fposIT_EES6_");

/** @type {function(...*):?} */
var __ZNKSt3__24fposI11__mbstate_tEcvxEv = Module["__ZNKSt3__24fposI11__mbstate_tEcvxEv"] = createExportWrapper("_ZNKSt3__24fposI11__mbstate_tEcvxEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5seekgExNS_8ios_base7seekdirE = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5seekgExNS_8ios_base7seekdirE"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE5seekgExNS_8ios_base7seekdirE");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEED2Ev = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEED2Ev"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEED1Ev = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEED1Ev"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEED1Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__213basic_istreamIwNS_11char_traitsIwEEED1Ev = Module["__ZTv0_n12_NSt3__213basic_istreamIwNS_11char_traitsIwEEED1Ev"] = createExportWrapper("_ZTv0_n12_NSt3__213basic_istreamIwNS_11char_traitsIwEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEED0Ev = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEED0Ev"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEED0Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__213basic_istreamIwNS_11char_traitsIwEEED0Ev = Module["__ZTv0_n12_NSt3__213basic_istreamIwNS_11char_traitsIwEEED0Ev"] = createExportWrapper("_ZTv0_n12_NSt3__213basic_istreamIwNS_11char_traitsIwEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE6sentryC2ERS3_b = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE6sentryC2ERS3_b"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE6sentryC2ERS3_b");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE4goodEv = Module["__ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE4goodEv"] = createExportWrapper("_ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE4goodEv");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE3tieEv = Module["__ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE3tieEv"] = createExportWrapper("_ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE3tieEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE5flushEv = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE5flushEv"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE5flushEv");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_5ctypeIwEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_5ctypeIwEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_5ctypeIwEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEC2ERNS_13basic_istreamIwS2_EE = Module["__ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEC2ERNS_13basic_istreamIwS2_EE"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEC2ERNS_13basic_istreamIwS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEC2Ev = Module["__ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEC2Ev"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__2neIwNS_11char_traitsIwEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_ = Module["__ZNSt3__2neIwNS_11char_traitsIwEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_"] = createExportWrapper("_ZNSt3__2neIwNS_11char_traitsIwEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_");

/** @type {function(...*):?} */
var __ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEdeEv = Module["__ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEdeEv"] = createExportWrapper("_ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEdeEv");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE2isEtw = Module["__ZNKSt3__25ctypeIwE2isEtw"] = createExportWrapper("_ZNKSt3__25ctypeIwE2isEtw");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEppEv = Module["__ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEppEv"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEppEv");

/** @type {function(...*):?} */
var __ZNSt3__2eqIwNS_11char_traitsIwEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_ = Module["__ZNSt3__2eqIwNS_11char_traitsIwEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_"] = createExportWrapper("_ZNSt3__2eqIwNS_11char_traitsIwEEEEbRKNS_19istreambuf_iteratorIT_T0_EES8_");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIwNS_11char_traitsIwEEE8setstateEj = Module["__ZNSt3__29basic_iosIwNS_11char_traitsIwEEE8setstateEj"] = createExportWrapper("_ZNSt3__29basic_iosIwNS_11char_traitsIwEEE8setstateEj");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE5rdbufEv = Module["__ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE5rdbufEv"] = createExportWrapper("_ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE5rdbufEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryC2ERS3_ = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryC2ERS3_"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryC2ERS3_");

/** @type {function(...*):?} */
var __ZNKSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentrycvbEv = Module["__ZNKSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentrycvbEv"] = createExportWrapper("_ZNKSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentrycvbEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7pubsyncEv = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7pubsyncEv"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7pubsyncEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryD2Ev = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryD2Ev"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryD2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE5equalERKS3_ = Module["__ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE5equalERKS3_"] = createExportWrapper("_ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE5equalERKS3_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sgetcEv = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sgetcEv"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sgetcEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6sbumpcEv = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6sbumpcEv"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE6sbumpcEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsEPNS_15basic_streambufIwS2_EE = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsEPNS_15basic_streambufIwS2_EE"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsEPNS_15basic_streambufIwS2_EE");

/** @type {function(...*):?} */
var __ZNKSt3__213basic_istreamIwNS_11char_traitsIwEEE6sentrycvbEv = Module["__ZNKSt3__213basic_istreamIwNS_11char_traitsIwEEE6sentrycvbEv"] = createExportWrapper("_ZNKSt3__213basic_istreamIwNS_11char_traitsIwEEE6sentrycvbEv");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE11eq_int_typeEjj = Module["__ZNSt3__211char_traitsIwE11eq_int_typeEjj"] = createExportWrapper("_ZNSt3__211char_traitsIwE11eq_int_typeEjj");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sputcEw = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sputcEw"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sputcEw");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERb = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERb"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERb");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIbwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIbwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIbwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_7num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_7num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_7num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRb = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRb"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRb");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERs = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERs"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERs");

/** @type {function(...*):?} */
var __ZNSt3__238__input_arithmetic_with_numeric_limitsIswNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__238__input_arithmetic_with_numeric_limitsIswNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__238__input_arithmetic_with_numeric_limitsIswNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRl = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRl"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRl");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERt = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERt"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERt");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticItwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticItwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticItwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRt = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRt"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRt");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERi = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERi"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERi");

/** @type {function(...*):?} */
var __ZNSt3__238__input_arithmetic_with_numeric_limitsIiwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__238__input_arithmetic_with_numeric_limitsIiwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__238__input_arithmetic_with_numeric_limitsIiwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERj = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERj"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERj");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIjwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIjwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIjwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjS8_ = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjS8_"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjS8_");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERl = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERl"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERl");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIlwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIlwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIlwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERm = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERm"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERm");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticImwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticImwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticImwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRm = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRm"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRm");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERx = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERx"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERx");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIxwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIxwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIxwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRx = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRx"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRx");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERy = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERy"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERy");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIywNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIywNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIywNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRy = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRy"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRy");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERf = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERf"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERf");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIfwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIfwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIfwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRf = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRf"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRf");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERd = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERd"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERd");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIdwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIdwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIdwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRd = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRd"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRd");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERe = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERe"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERe");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIewNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_ = Module["__ZNSt3__218__input_arithmeticIewNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIewNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES7_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRe = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRe"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRe");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERPv = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERPv"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEErsERPv");

/** @type {function(...*):?} */
var __ZNSt3__218__input_arithmeticIPvwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES8_RT_ = Module["__ZNSt3__218__input_arithmeticIPvwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES8_RT_"] = createExportWrapper("_ZNSt3__218__input_arithmeticIPvwNS_11char_traitsIwEEEERNS_13basic_istreamIT0_T1_EES8_RT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRPv = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRPv"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjRPv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE3getEv = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE3getEv"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE3getEPwlw = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE3getEPwlw"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE3getEPwlw");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE2eqEww = Module["__ZNSt3__211char_traitsIwE2eqEww"] = createExportWrapper("_ZNSt3__211char_traitsIwE2eqEww");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE3getERNS_15basic_streambufIwS2_EEw = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE3getERNS_15basic_streambufIwS2_EEw"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE3getERNS_15basic_streambufIwS2_EEw");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE7getlineEPwlw = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE7getlineEPwlw"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE7getlineEPwlw");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE6ignoreElj = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE6ignoreElj"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE6ignoreElj");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE4peekEv = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE4peekEv"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE4peekEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE4readEPwl = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE4readEPwl"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE4readEPwl");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sgetnEPwl = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sgetnEPwl"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sgetnEPwl");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE8readsomeEPwl = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE8readsomeEPwl"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE8readsomeEPwl");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE8in_availEv = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE8in_availEv"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE8in_availEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE7putbackEw = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE7putbackEw"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE7putbackEw");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE7rdstateEv = Module["__ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE7rdstateEv"] = createExportWrapper("_ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE7rdstateEv");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIwNS_11char_traitsIwEEE5clearEj = Module["__ZNSt3__29basic_iosIwNS_11char_traitsIwEEE5clearEj"] = createExportWrapper("_ZNSt3__29basic_iosIwNS_11char_traitsIwEEE5clearEj");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9sputbackcEw = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9sputbackcEw"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE9sputbackcEw");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5ungetEv = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5ungetEv"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5ungetEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7sungetcEv = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7sungetcEv"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE7sungetcEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE4syncEv = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE4syncEv"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE4syncEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5tellgEv = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5tellgEv"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5tellgEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE10pubseekoffExNS_8ios_base7seekdirEj = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE10pubseekoffExNS_8ios_base7seekdirEj"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE10pubseekoffExNS_8ios_base7seekdirEj");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5seekgENS_4fposI11__mbstate_tEE = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5seekgENS_4fposI11__mbstate_tEE"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5seekgENS_4fposI11__mbstate_tEE");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE10pubseekposENS_4fposI11__mbstate_tEEj = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE10pubseekposENS_4fposI11__mbstate_tEEj"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE10pubseekposENS_4fposI11__mbstate_tEEj");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5seekgExNS_8ios_base7seekdirE = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5seekgExNS_8ios_base7seekdirE"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE5seekgExNS_8ios_base7seekdirE");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEED2Ev = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEED2Ev"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEED1Ev = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__213basic_ostreamIcNS_11char_traitsIcEEED1Ev = Module["__ZTv0_n12_NSt3__213basic_ostreamIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZTv0_n12_NSt3__213basic_ostreamIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEED0Ev = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__213basic_ostreamIcNS_11char_traitsIcEEED0Ev = Module["__ZTv0_n12_NSt3__213basic_ostreamIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZTv0_n12_NSt3__213basic_ostreamIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEb = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEb"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEb");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_7num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_7num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_7num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEC2ERNS_13basic_ostreamIcS2_EE = Module["__ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEC2ERNS_13basic_ostreamIcS2_EE"] = createExportWrapper("_ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEC2ERNS_13basic_ostreamIcS2_EE");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE4fillEv = Module["__ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE4fillEv"] = createExportWrapper("_ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE4fillEv");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcb = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcb"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcb");

/** @type {function(...*):?} */
var __ZNKSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEE6failedEv = Module["__ZNKSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEE6failedEv"] = createExportWrapper("_ZNKSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEE6failedEv");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE5widenEc = Module["__ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE5widenEc"] = createExportWrapper("_ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE5widenEc");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEs = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEs"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEs");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcl = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcl"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcl");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEt = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEt"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEt");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcm = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcm"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcm");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEi = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEi"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEi");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEj = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEj"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEj");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEl = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEl"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEl");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEm = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEm"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEm");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEx = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEx"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEx");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcx = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcx"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcx");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEy = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEy"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEy");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcy = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcy"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcy");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEf = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEf"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEf");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcd = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcd"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcd");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEd = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEd"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEd");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEe = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEe"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEe");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEce = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEce"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEce");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEPKv = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEPKv"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEPKv");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcPKv = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcPKv"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcPKv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEPNS_15basic_streambufIcS2_EE = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEPNS_15basic_streambufIcS2_EE"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEElsEPNS_15basic_streambufIcS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEC2EPNS_15basic_streambufIcS2_EE = Module["__ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEC2EPNS_15basic_streambufIcS2_EE"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEC2EPNS_15basic_streambufIcS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEdeEv = Module["__ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEdeEv"] = createExportWrapper("_ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEaSEc = Module["__ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEaSEc"] = createExportWrapper("_ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEaSEc");

/** @type {function(...*):?} */
var __ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEppEv = Module["__ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEppEv"] = createExportWrapper("_ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEppEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE3putEc = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE3putEc"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE3putEc");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE5writeEPKcl = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE5writeEPKcl"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE5writeEPKcl");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sputnEPKcl = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sputnEPKcl"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5sputnEPKcl");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEED2Ev = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEED2Ev"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEED1Ev = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEED1Ev"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEED1Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__213basic_ostreamIwNS_11char_traitsIwEEED1Ev = Module["__ZTv0_n12_NSt3__213basic_ostreamIwNS_11char_traitsIwEEED1Ev"] = createExportWrapper("_ZTv0_n12_NSt3__213basic_ostreamIwNS_11char_traitsIwEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEED0Ev = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEED0Ev"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEED0Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__213basic_ostreamIwNS_11char_traitsIwEEED0Ev = Module["__ZTv0_n12_NSt3__213basic_ostreamIwNS_11char_traitsIwEEED0Ev"] = createExportWrapper("_ZTv0_n12_NSt3__213basic_ostreamIwNS_11char_traitsIwEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEb = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEb"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEb");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_7num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_7num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_7num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEC2ERNS_13basic_ostreamIwS2_EE = Module["__ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEC2ERNS_13basic_ostreamIwS2_EE"] = createExportWrapper("_ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEC2ERNS_13basic_ostreamIwS2_EE");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE4fillEv = Module["__ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE4fillEv"] = createExportWrapper("_ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE4fillEv");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwb = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwb"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwb");

/** @type {function(...*):?} */
var __ZNKSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEE6failedEv = Module["__ZNKSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEE6failedEv"] = createExportWrapper("_ZNKSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEE6failedEv");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE5widenEc = Module["__ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE5widenEc"] = createExportWrapper("_ZNKSt3__29basic_iosIwNS_11char_traitsIwEEE5widenEc");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEs = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEs"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEs");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwl = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwl"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwl");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEt = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEt"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEt");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwm = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwm"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwm");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEi = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEi"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEi");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEj = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEj"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEj");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEl = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEl"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEl");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEm = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEm"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEm");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEx = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEx"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEx");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwx = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwx"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwx");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEy = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEy"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEy");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwy = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwy"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwy");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEf = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEf"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEf");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwd = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwd"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwd");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEd = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEd"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEd");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEe = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEe"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEe");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwe = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwe"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwe");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEPKv = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEPKv"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEPKv");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwPKv = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwPKv"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwPKv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEPNS_15basic_streambufIwS2_EE = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEPNS_15basic_streambufIwS2_EE"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEElsEPNS_15basic_streambufIwS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEC2EPNS_15basic_streambufIwS2_EE = Module["__ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEC2EPNS_15basic_streambufIwS2_EE"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEC2EPNS_15basic_streambufIwS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEdeEv = Module["__ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEdeEv"] = createExportWrapper("_ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEaSEw = Module["__ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEaSEw"] = createExportWrapper("_ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEaSEw");

/** @type {function(...*):?} */
var __ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEppEv = Module["__ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEppEv"] = createExportWrapper("_ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEppEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE3putEw = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE3putEw"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE3putEw");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE5writeEPKwl = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE5writeEPKwl"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE5writeEPKwl");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sputnEPKwl = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sputnEPKwl"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEE5sputnEPKwl");

/** @type {function(...*):?} */
var __ZNSt3__214basic_iostreamIcNS_11char_traitsIcEEED2Ev = Module["__ZNSt3__214basic_iostreamIcNS_11char_traitsIcEEED2Ev"] = createExportWrapper("_ZNSt3__214basic_iostreamIcNS_11char_traitsIcEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214basic_iostreamIcNS_11char_traitsIcEEED1Ev = Module["__ZNSt3__214basic_iostreamIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZNSt3__214basic_iostreamIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZThn8_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED1Ev = Module["__ZThn8_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZThn8_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED1Ev = Module["__ZTv0_n12_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZTv0_n12_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214basic_iostreamIcNS_11char_traitsIcEEED0Ev = Module["__ZNSt3__214basic_iostreamIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZNSt3__214basic_iostreamIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZThn8_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED0Ev = Module["__ZThn8_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZThn8_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED0Ev = Module["__ZTv0_n12_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZTv0_n12_NSt3__214basic_iostreamIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__219__iostream_category4nameEv = Module["__ZNKSt3__219__iostream_category4nameEv"] = createExportWrapper("_ZNKSt3__219__iostream_category4nameEv");

/** @type {function(...*):?} */
var __ZNKSt3__219__iostream_category7messageEi = Module["__ZNKSt3__219__iostream_category7messageEi"] = createExportWrapper("_ZNKSt3__219__iostream_category7messageEi");

/** @type {function(...*):?} */
var __ZNKSt3__212__do_message7messageEi = Module["__ZNKSt3__212__do_message7messageEi"] = createExportWrapper("_ZNKSt3__212__do_message7messageEi");

/** @type {function(...*):?} */
var __ZNSt3__217iostream_categoryEv = Module["__ZNSt3__217iostream_categoryEv"] = createExportWrapper("_ZNSt3__217iostream_categoryEv");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base7failureC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_10error_codeE = Module["__ZNSt3__28ios_base7failureC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_10error_codeE"] = createExportWrapper("_ZNSt3__28ios_base7failureC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC2ENS_10error_codeERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__212system_errorC2ENS_10error_codeERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__212system_errorC2ENS_10error_codeERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base7failureC2EPKcRKNS_10error_codeE = Module["__ZNSt3__28ios_base7failureC2EPKcRKNS_10error_codeE"] = createExportWrapper("_ZNSt3__28ios_base7failureC2EPKcRKNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC2ENS_10error_codeEPKc = Module["__ZNSt3__212system_errorC2ENS_10error_codeEPKc"] = createExportWrapper("_ZNSt3__212system_errorC2ENS_10error_codeEPKc");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base7failureD2Ev = Module["__ZNSt3__28ios_base7failureD2Ev"] = createExportWrapper("_ZNSt3__28ios_base7failureD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorD2Ev = Module["__ZNSt3__212system_errorD2Ev"] = createExportWrapper("_ZNSt3__212system_errorD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base7failureD0Ev = Module["__ZNSt3__28ios_base7failureD0Ev"] = createExportWrapper("_ZNSt3__28ios_base7failureD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base5imbueERKNS_6localeE = Module["__ZNSt3__28ios_base5imbueERKNS_6localeE"] = createExportWrapper("_ZNSt3__28ios_base5imbueERKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base6xallocEv = Module["__ZNSt3__28ios_base6xallocEv"] = createExportWrapper("_ZNSt3__28ios_base6xallocEv");

/** @type {function(...*):?} */
var __ZNSt3__213__atomic_baseIiLb1EEppEi = Module["__ZNSt3__213__atomic_baseIiLb1EEppEi"] = createExportWrapper("_ZNSt3__213__atomic_baseIiLb1EEppEi");

/** @type {function(...*):?} */
var __ZNSt3__213__atomic_baseIiLb1EE9fetch_addEiNS_12memory_orderE = Module["__ZNSt3__213__atomic_baseIiLb1EE9fetch_addEiNS_12memory_orderE"] = createExportWrapper("_ZNSt3__213__atomic_baseIiLb1EE9fetch_addEiNS_12memory_orderE");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base5iwordEi = Module["__ZNSt3__28ios_base5iwordEi"] = createExportWrapper("_ZNSt3__28ios_base5iwordEi");

/** @type {function(...*):?} */
var __ZNSt3__23maxImEERKT_S3_S3_ = Module["__ZNSt3__23maxImEERKT_S3_S3_"] = createExportWrapper("_ZNSt3__23maxImEERKT_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__23maxImNS_6__lessImmEEEERKT_S5_S5_T0_ = Module["__ZNSt3__23maxImNS_6__lessImmEEEERKT_S5_S5_T0_"] = createExportWrapper("_ZNSt3__23maxImNS_6__lessImmEEEERKT_S5_S5_T0_");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base5pwordEi = Module["__ZNSt3__28ios_base5pwordEi"] = createExportWrapper("_ZNSt3__28ios_base5pwordEi");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base17register_callbackEPFvNS0_5eventERS0_iEi = Module["__ZNSt3__28ios_base17register_callbackEPFvNS0_5eventERS0_iEi"] = createExportWrapper("_ZNSt3__28ios_base17register_callbackEPFvNS0_5eventERS0_iEi");

/** @type {function(...*):?} */
var __ZNSt3__28ios_baseD0Ev = Module["__ZNSt3__28ios_baseD0Ev"] = createExportWrapper("_ZNSt3__28ios_baseD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215__throw_failureEPKc = Module["__ZNSt3__215__throw_failureEPKc"] = createExportWrapper("_ZNSt3__215__throw_failureEPKc");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base4initEPv = Module["__ZNSt3__28ios_base4initEPv"] = createExportWrapper("_ZNSt3__28ios_base4initEPv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPFvPvEEEONS_16remove_referenceIT_E4typeEOS6_ = Module["__ZNSt3__24moveIRPFvPvEEEONS_16remove_referenceIT_E4typeEOS6_"] = createExportWrapper("_ZNSt3__24moveIRPFvPvEEEONS_16remove_referenceIT_E4typeEOS6_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEEC2IRS6_S9_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEEC2IRS6_S9_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEEC2IRS6_S9_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPiPFvPvEEC2IRS1_S4_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPiPFvPvEEC2IRS1_S4_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPiPFvPvEEC2IRS1_S4_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPlPFvPvEEC2IRS1_S4_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPlPFvPvEEC2IRS1_S4_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPlPFvPvEEC2IRS1_S4_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPvPFvS1_EEC2IRS2_S4_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPPvPFvS1_EEC2IRS2_S4_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPvPFvS1_EEC2IRS2_S4_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEE5firstEv = Module["__ZNSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEE6secondEv = Module["__ZNSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPPFvNS_8ios_base5eventERS1_iEPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPiPFvPvEE5firstEv = Module["__ZNSt3__217__compressed_pairIPiPFvPvEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPiPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPiPFvPvEE6secondEv = Module["__ZNSt3__217__compressed_pairIPiPFvPvEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPiPFvPvEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPiPFvPvEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPiPFvPvEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPiPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPlPFvPvEE5firstEv = Module["__ZNSt3__217__compressed_pairIPlPFvPvEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPlPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPlPFvPvEE6secondEv = Module["__ZNSt3__217__compressed_pairIPlPFvPvEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPlPFvPvEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPlPFvPvEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPlPFvPvEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPlPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPvPFvS1_EE5firstEv = Module["__ZNSt3__217__compressed_pairIPPvPFvS1_EE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPvPFvS1_EE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPvPFvS1_EE6secondEv = Module["__ZNSt3__217__compressed_pairIPPvPFvS1_EE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPvPFvS1_EE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPPvPFvS1_EE5firstEv = Module["__ZNKSt3__217__compressed_pairIPPvPFvS1_EE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPPvPFvS1_EE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base4moveERS0_ = Module["__ZNSt3__28ios_base4moveERS0_"] = createExportWrapper("_ZNSt3__28ios_base4moveERS0_");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base4swapERS0_ = Module["__ZNSt3__28ios_base4swapERS0_"] = createExportWrapper("_ZNSt3__28ios_base4swapERS0_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPPFvNS_8ios_base5eventERS1_iEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS8_EE5valueEvE4typeERS8_SB_ = Module["__ZNSt3__24swapIPPFvNS_8ios_base5eventERS1_iEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS8_EE5valueEvE4typeERS8_SB_"] = createExportWrapper("_ZNSt3__24swapIPPFvNS_8ios_base5eventERS1_iEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS8_EE5valueEvE4typeERS8_SB_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPiEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_ = Module["__ZNSt3__24swapIPiEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_"] = createExportWrapper("_ZNSt3__24swapIPiEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPlEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_ = Module["__ZNSt3__24swapIPlEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_"] = createExportWrapper("_ZNSt3__24swapIPlEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS3_EE5valueEvE4typeERS3_S6_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPPvEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS4_EE5valueEvE4typeERS4_S7_ = Module["__ZNSt3__24swapIPPvEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS4_EE5valueEvE4typeERS4_S7_"] = createExportWrapper("_ZNSt3__24swapIPPvEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS4_EE5valueEvE4typeERS4_S7_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPPFvNS_8ios_base5eventERS1_iEEEONS_16remove_referenceIT_E4typeEOS9_ = Module["__ZNSt3__24moveIRPPFvNS_8ios_base5eventERS1_iEEEONS_16remove_referenceIT_E4typeEOS9_"] = createExportWrapper("_ZNSt3__24moveIRPPFvNS_8ios_base5eventERS1_iEEEONS_16remove_referenceIT_E4typeEOS9_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPiEEONS_16remove_referenceIT_E4typeEOS4_ = Module["__ZNSt3__24moveIRPiEEONS_16remove_referenceIT_E4typeEOS4_"] = createExportWrapper("_ZNSt3__24moveIRPiEEONS_16remove_referenceIT_E4typeEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPlEEONS_16remove_referenceIT_E4typeEOS4_ = Module["__ZNSt3__24moveIRPlEEONS_16remove_referenceIT_E4typeEOS4_"] = createExportWrapper("_ZNSt3__24moveIRPlEEONS_16remove_referenceIT_E4typeEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPPvEEONS_16remove_referenceIT_E4typeEOS5_ = Module["__ZNSt3__24moveIRPPvEEONS_16remove_referenceIT_E4typeEOS5_"] = createExportWrapper("_ZNSt3__24moveIRPPvEEONS_16remove_referenceIT_E4typeEOS5_");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base33__set_badbit_and_consider_rethrowEv = Module["__ZNSt3__28ios_base33__set_badbit_and_consider_rethrowEv"] = createExportWrapper("_ZNSt3__28ios_base33__set_badbit_and_consider_rethrowEv");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base34__set_failbit_and_consider_rethrowEv = Module["__ZNSt3__28ios_base34__set_failbit_and_consider_rethrowEv"] = createExportWrapper("_ZNSt3__28ios_base34__set_failbit_and_consider_rethrowEv");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base15sync_with_stdioEb = Module["__ZNSt3__28ios_base15sync_with_stdioEb"] = createExportWrapper("_ZNSt3__28ios_base15sync_with_stdioEb");

/** @type {function(...*):?} */
var __ZNSt3__219__iostream_categoryD0Ev = Module["__ZNSt3__219__iostream_categoryD0Ev"] = createExportWrapper("_ZNSt3__219__iostream_categoryD0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE14__test_for_eofEv = Module["__ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE14__test_for_eofEv"] = createExportWrapper("_ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE14__test_for_eofEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIsLb1EE3minEv = Module["__ZNSt3__223__libcpp_numeric_limitsIsLb1EE3minEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIsLb1EE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIsLb1EE3maxEv = Module["__ZNSt3__223__libcpp_numeric_limitsIsLb1EE3maxEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIsLb1EE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIiLb1EE3minEv = Module["__ZNSt3__223__libcpp_numeric_limitsIiLb1EE3minEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIiLb1EE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIiLb1EE3maxEv = Module["__ZNSt3__223__libcpp_numeric_limitsIiLb1EE3maxEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIiLb1EE3maxEv");

/** @type {function(...*):?} */
var __ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE14__test_for_eofEv = Module["__ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE14__test_for_eofEv"] = createExportWrapper("_ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE14__test_for_eofEv");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE5widenEc = Module["__ZNKSt3__25ctypeIcE5widenEc"] = createExportWrapper("_ZNKSt3__25ctypeIcE5widenEc");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE5widenEc = Module["__ZNKSt3__25ctypeIwE5widenEc"] = createExportWrapper("_ZNKSt3__25ctypeIwE5widenEc");

/** @type {function(...*):?} */
var __ZNSt3__222__cxx_atomic_fetch_addIiEET_PNS_22__cxx_atomic_base_implIS1_EES1_NS_12memory_orderE = Module["__ZNSt3__222__cxx_atomic_fetch_addIiEET_PNS_22__cxx_atomic_base_implIS1_EES1_NS_12memory_orderE"] = createExportWrapper("_ZNSt3__222__cxx_atomic_fetch_addIiEET_PNS_22__cxx_atomic_base_implIS1_EES1_NS_12memory_orderE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPPFvNS_8ios_base5eventERS1_iEEEOT_RNS_16remove_referenceIS8_E4typeE = Module["__ZNSt3__27forwardIRPPFvNS_8ios_base5eventERS1_iEEEOT_RNS_16remove_referenceIS8_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPPFvNS_8ios_base5eventERS1_iEEEOT_RNS_16remove_referenceIS8_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPPFvNS_8ios_base5eventERS1_iELi0ELb0EEC2IRS6_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPPFvNS_8ios_base5eventERS1_iELi0ELb0EEC2IRS6_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPPFvNS_8ios_base5eventERS1_iELi0ELb0EEC2IRS6_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIPFvPvEEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIPFvPvEEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIPFvPvEEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPFvPvELi1ELb0EEC2IS3_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPFvPvELi1ELb0EEC2IS3_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPFvPvELi1ELb0EEC2IS3_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPiEEOT_RNS_16remove_referenceIS3_E4typeE = Module["__ZNSt3__27forwardIRPiEEOT_RNS_16remove_referenceIS3_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPiEEOT_RNS_16remove_referenceIS3_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPiLi0ELb0EEC2IRS1_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPiLi0ELb0EEC2IRS1_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPiLi0ELb0EEC2IRS1_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPlEEOT_RNS_16remove_referenceIS3_E4typeE = Module["__ZNSt3__27forwardIRPlEEOT_RNS_16remove_referenceIS3_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPlEEOT_RNS_16remove_referenceIS3_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPlLi0ELb0EEC2IRS1_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPlLi0ELb0EEC2IRS1_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPlLi0ELb0EEC2IRS1_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPPvEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRPPvEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPPvEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPPvLi0ELb0EEC2IRS2_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPPvLi0ELb0EEC2IRS2_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPPvLi0ELb0EEC2IRS2_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPPFvNS_8ios_base5eventERS1_iELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPPFvNS_8ios_base5eventERS1_iELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPPFvNS_8ios_base5eventERS1_iELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPFvPvELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPFvPvELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPFvPvELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPPFvNS_8ios_base5eventERS1_iELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPPFvNS_8ios_base5eventERS1_iELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPPFvNS_8ios_base5eventERS1_iELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPiLi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPiLi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPiLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPiLi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPiLi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPiLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPlLi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPlLi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPlLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPlLi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPlLi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPlLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPPvLi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPPvLi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPPvLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPPvLi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPPvLi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPPvLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt13runtime_error4whatEv = Module["__ZNKSt13runtime_error4whatEv"] = createExportWrapper("_ZNKSt13runtime_error4whatEv");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIcNS_11char_traitsIcEEED1Ev = Module["__ZNSt3__29basic_iosIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZNSt3__29basic_iosIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIwNS_11char_traitsIwEEED1Ev = Module["__ZNSt3__29basic_iosIwNS_11char_traitsIwEEED1Ev"] = createExportWrapper("_ZNSt3__29basic_iosIwNS_11char_traitsIwEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEED1Ev = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC1Ev = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC1Ev"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC1ERKS3_ = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC1ERKS3_"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEEC1ERKS3_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEED1Ev = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEED1Ev"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC1Ev = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC1Ev"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC1ERKS3_ = Module["__ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC1ERKS3_"] = createExportWrapper("_ZNSt3__215basic_streambufIwNS_11char_traitsIwEEEC1ERKS3_");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE6sentryC1ERS3_b = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE6sentryC1ERS3_b"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEE6sentryC1ERS3_b");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE6sentryC1ERS3_b = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE6sentryC1ERS3_b"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEE6sentryC1ERS3_b");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryC1ERS3_ = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryC1ERS3_"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryC1ERS3_");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryD1Ev = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryD1Ev"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEE6sentryD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryC1ERS3_ = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryC1ERS3_"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryC1ERS3_");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryD1Ev = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryD1Ev"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEE6sentryD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base7failureC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_10error_codeE = Module["__ZNSt3__28ios_base7failureC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_10error_codeE"] = createExportWrapper("_ZNSt3__28ios_base7failureC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base7failureC1EPKcRKNS_10error_codeE = Module["__ZNSt3__28ios_base7failureC1EPKcRKNS_10error_codeE"] = createExportWrapper("_ZNSt3__28ios_base7failureC1EPKcRKNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base7failureD1Ev = Module["__ZNSt3__28ios_base7failureD1Ev"] = createExportWrapper("_ZNSt3__28ios_base7failureD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__28ios_baseD1Ev = Module["__ZNSt3__28ios_baseD1Ev"] = createExportWrapper("_ZNSt3__28ios_baseD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base4InitC2Ev = Module["__ZNSt3__28ios_base4InitC2Ev"] = createExportWrapper("_ZNSt3__28ios_base4InitC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__29DoIOSInitC2Ev = Module["__ZNSt3__29DoIOSInitC2Ev"] = createExportWrapper("_ZNSt3__29DoIOSInitC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIcEC2EP8_IO_FILEP11__mbstate_t = Module["__ZNSt3__210__stdinbufIcEC2EP8_IO_FILEP11__mbstate_t"] = createExportWrapper("_ZNSt3__210__stdinbufIcEC2EP8_IO_FILEP11__mbstate_t");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEEC1EPNS_15basic_streambufIcS2_EE = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEEC1EPNS_15basic_streambufIcS2_EE"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEEC1EPNS_15basic_streambufIcS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIwEC2EP8_IO_FILEP11__mbstate_t = Module["__ZNSt3__210__stdinbufIwEC2EP8_IO_FILEP11__mbstate_t"] = createExportWrapper("_ZNSt3__210__stdinbufIwEC2EP8_IO_FILEP11__mbstate_t");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIwNS_11char_traitsIwEEEC1EPNS_15basic_streambufIwS2_EE = Module["__ZNSt3__213basic_istreamIwNS_11char_traitsIwEEEC1EPNS_15basic_streambufIwS2_EE"] = createExportWrapper("_ZNSt3__213basic_istreamIwNS_11char_traitsIwEEEC1EPNS_15basic_streambufIwS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIcEC2EP8_IO_FILEP11__mbstate_t = Module["__ZNSt3__211__stdoutbufIcEC2EP8_IO_FILEP11__mbstate_t"] = createExportWrapper("_ZNSt3__211__stdoutbufIcEC2EP8_IO_FILEP11__mbstate_t");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEEC1EPNS_15basic_streambufIcS2_EE = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEEC1EPNS_15basic_streambufIcS2_EE"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEEC1EPNS_15basic_streambufIcS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIwEC2EP8_IO_FILEP11__mbstate_t = Module["__ZNSt3__211__stdoutbufIwEC2EP8_IO_FILEP11__mbstate_t"] = createExportWrapper("_ZNSt3__211__stdoutbufIwEC2EP8_IO_FILEP11__mbstate_t");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEEC1EPNS_15basic_streambufIwS2_EE = Module["__ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEEC1EPNS_15basic_streambufIwS2_EE"] = createExportWrapper("_ZNSt3__213basic_ostreamIwNS_11char_traitsIwEEEC1EPNS_15basic_streambufIwS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIcNS_11char_traitsIcEEE3tieEPNS_13basic_ostreamIcS2_EE = Module["__ZNSt3__29basic_iosIcNS_11char_traitsIcEEE3tieEPNS_13basic_ostreamIcS2_EE"] = createExportWrapper("_ZNSt3__29basic_iosIcNS_11char_traitsIcEEE3tieEPNS_13basic_ostreamIcS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIwNS_11char_traitsIwEEE3tieEPNS_13basic_ostreamIwS2_EE = Module["__ZNSt3__29basic_iosIwNS_11char_traitsIwEEE3tieEPNS_13basic_ostreamIwS2_EE"] = createExportWrapper("_ZNSt3__29basic_iosIwNS_11char_traitsIwEEE3tieEPNS_13basic_ostreamIwS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__27unitbufERNS_8ios_baseE = Module["__ZNSt3__27unitbufERNS_8ios_baseE"] = createExportWrapper("_ZNSt3__27unitbufERNS_8ios_baseE");

/** @type {function(...*):?} */
var __ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE6getlocEv = Module["__ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE6getlocEv"] = createExportWrapper("_ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE6getlocEv");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIcNS_11char_traitsIcEEEC2Ev = Module["__ZNSt3__29basic_iosIcNS_11char_traitsIcEEEC2Ev"] = createExportWrapper("_ZNSt3__29basic_iosIcNS_11char_traitsIcEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIcNS_11char_traitsIcEEE4initEPNS_15basic_streambufIcS2_EE = Module["__ZNSt3__29basic_iosIcNS_11char_traitsIcEEE4initEPNS_15basic_streambufIcS2_EE"] = createExportWrapper("_ZNSt3__29basic_iosIcNS_11char_traitsIcEEE4initEPNS_15basic_streambufIcS2_EE");

/** @type {function(...*):?} */
var __ZNKSt3__215basic_streambufIwNS_11char_traitsIwEEE6getlocEv = Module["__ZNKSt3__215basic_streambufIwNS_11char_traitsIwEEE6getlocEv"] = createExportWrapper("_ZNKSt3__215basic_streambufIwNS_11char_traitsIwEEE6getlocEv");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIwNS_11char_traitsIwEEEC2Ev = Module["__ZNSt3__29basic_iosIwNS_11char_traitsIwEEEC2Ev"] = createExportWrapper("_ZNSt3__29basic_iosIwNS_11char_traitsIwEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__29basic_iosIwNS_11char_traitsIwEEE4initEPNS_15basic_streambufIwS2_EE = Module["__ZNSt3__29basic_iosIwNS_11char_traitsIwEEE4initEPNS_15basic_streambufIwS2_EE"] = createExportWrapper("_ZNSt3__29basic_iosIwNS_11char_traitsIwEEE4initEPNS_15basic_streambufIwS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_7codecvtIcc11__mbstate_tEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_7codecvtIcc11__mbstate_tEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_7codecvtIcc11__mbstate_tEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE13always_noconvEv = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE13always_noconvEv"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE13always_noconvEv");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_7codecvtIwc11__mbstate_tEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_7codecvtIwc11__mbstate_tEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_7codecvtIwc11__mbstate_tEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE13always_noconvEv = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE13always_noconvEv"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE13always_noconvEv");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base4setfEj = Module["__ZNSt3__28ios_base4setfEj"] = createExportWrapper("_ZNSt3__28ios_base4setfEj");

/** @type {function(...*):?} */
var __ZNSt3__29DoIOSInitD2Ev = Module["__ZNSt3__29DoIOSInitD2Ev"] = createExportWrapper("_ZNSt3__29DoIOSInitD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base4InitD2Ev = Module["__ZNSt3__28ios_base4InitD2Ev"] = createExportWrapper("_ZNSt3__28ios_base4InitD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIcED0Ev = Module["__ZNSt3__210__stdinbufIcED0Ev"] = createExportWrapper("_ZNSt3__210__stdinbufIcED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIcE5imbueERKNS_6localeE = Module["__ZNSt3__210__stdinbufIcE5imbueERKNS_6localeE"] = createExportWrapper("_ZNSt3__210__stdinbufIcE5imbueERKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE8encodingEv = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE8encodingEv"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE8encodingEv");

/** @type {function(...*):?} */
var __ZNSt3__221__throw_runtime_errorEPKc = Module["__ZNSt3__221__throw_runtime_errorEPKc"] = createExportWrapper("_ZNSt3__221__throw_runtime_errorEPKc");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIcE9underflowEv = Module["__ZNSt3__210__stdinbufIcE9underflowEv"] = createExportWrapper("_ZNSt3__210__stdinbufIcE9underflowEv");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIcE9__getcharEb = Module["__ZNSt3__210__stdinbufIcE9__getcharEb"] = createExportWrapper("_ZNSt3__210__stdinbufIcE9__getcharEb");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIcE5uflowEv = Module["__ZNSt3__210__stdinbufIcE5uflowEv"] = createExportWrapper("_ZNSt3__210__stdinbufIcE5uflowEv");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIcE9pbackfailEi = Module["__ZNSt3__210__stdinbufIcE9pbackfailEi"] = createExportWrapper("_ZNSt3__210__stdinbufIcE9pbackfailEi");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE3outERS1_PKcS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE3outERS1_PKcS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE3outERS1_PKcS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNSt3__23maxIiEERKT_S3_S3_ = Module["__ZNSt3__23maxIiEERKT_S3_S3_"] = createExportWrapper("_ZNSt3__23maxIiEERKT_S3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE2inERS1_PKcS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE2inERS1_PKcS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE2inERS1_PKcS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNSt3__23maxIiNS_6__lessIiiEEEERKT_S5_S5_T0_ = Module["__ZNSt3__23maxIiNS_6__lessIiiEEEERKT_S5_S5_T0_"] = createExportWrapper("_ZNSt3__23maxIiNS_6__lessIiiEEEERKT_S5_S5_T0_");

/** @type {function(...*):?} */
var __ZNSt3__28ios_baseC2Ev = Module["__ZNSt3__28ios_baseC2Ev"] = createExportWrapper("_ZNSt3__28ios_baseC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIwED0Ev = Module["__ZNSt3__210__stdinbufIwED0Ev"] = createExportWrapper("_ZNSt3__210__stdinbufIwED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIwE5imbueERKNS_6localeE = Module["__ZNSt3__210__stdinbufIwE5imbueERKNS_6localeE"] = createExportWrapper("_ZNSt3__210__stdinbufIwE5imbueERKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE8encodingEv = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE8encodingEv"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE8encodingEv");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIwE9underflowEv = Module["__ZNSt3__210__stdinbufIwE9underflowEv"] = createExportWrapper("_ZNSt3__210__stdinbufIwE9underflowEv");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIwE9__getcharEb = Module["__ZNSt3__210__stdinbufIwE9__getcharEb"] = createExportWrapper("_ZNSt3__210__stdinbufIwE9__getcharEb");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIwE5uflowEv = Module["__ZNSt3__210__stdinbufIwE5uflowEv"] = createExportWrapper("_ZNSt3__210__stdinbufIwE5uflowEv");

/** @type {function(...*):?} */
var __ZNSt3__210__stdinbufIwE9pbackfailEj = Module["__ZNSt3__210__stdinbufIwE9pbackfailEj"] = createExportWrapper("_ZNSt3__210__stdinbufIwE9pbackfailEj");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE3outERS1_PKwS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE3outERS1_PKwS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE3outERS1_PKwS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE2inERS1_PKcS5_RS5_PwS7_RS7_ = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE2inERS1_PKcS5_RS5_PwS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE2inERS1_PKcS5_RS5_PwS7_RS7_");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIcED0Ev = Module["__ZNSt3__211__stdoutbufIcED0Ev"] = createExportWrapper("_ZNSt3__211__stdoutbufIcED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIcE5imbueERKNS_6localeE = Module["__ZNSt3__211__stdoutbufIcE5imbueERKNS_6localeE"] = createExportWrapper("_ZNSt3__211__stdoutbufIcE5imbueERKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIcE4syncEv = Module["__ZNSt3__211__stdoutbufIcE4syncEv"] = createExportWrapper("_ZNSt3__211__stdoutbufIcE4syncEv");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE7unshiftERS1_PcS4_RS4_ = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE7unshiftERS1_PcS4_RS4_"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE7unshiftERS1_PcS4_RS4_");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIcE6xsputnEPKcl = Module["__ZNSt3__211__stdoutbufIcE6xsputnEPKcl"] = createExportWrapper("_ZNSt3__211__stdoutbufIcE6xsputnEPKcl");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIcE8overflowEi = Module["__ZNSt3__211__stdoutbufIcE8overflowEi"] = createExportWrapper("_ZNSt3__211__stdoutbufIcE8overflowEi");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE7not_eofEi = Module["__ZNSt3__211char_traitsIcE7not_eofEi"] = createExportWrapper("_ZNSt3__211char_traitsIcE7not_eofEi");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIwED0Ev = Module["__ZNSt3__211__stdoutbufIwED0Ev"] = createExportWrapper("_ZNSt3__211__stdoutbufIwED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIwE5imbueERKNS_6localeE = Module["__ZNSt3__211__stdoutbufIwE5imbueERKNS_6localeE"] = createExportWrapper("_ZNSt3__211__stdoutbufIwE5imbueERKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIwE4syncEv = Module["__ZNSt3__211__stdoutbufIwE4syncEv"] = createExportWrapper("_ZNSt3__211__stdoutbufIwE4syncEv");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE7unshiftERS1_PcS4_RS4_ = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE7unshiftERS1_PcS4_RS4_"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE7unshiftERS1_PcS4_RS4_");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIwE6xsputnEPKwl = Module["__ZNSt3__211__stdoutbufIwE6xsputnEPKwl"] = createExportWrapper("_ZNSt3__211__stdoutbufIwE6xsputnEPKwl");

/** @type {function(...*):?} */
var __ZNSt3__211__stdoutbufIwE8overflowEj = Module["__ZNSt3__211__stdoutbufIwE8overflowEj"] = createExportWrapper("_ZNSt3__211__stdoutbufIwE8overflowEj");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE7not_eofEj = Module["__ZNSt3__211char_traitsIwE7not_eofEj"] = createExportWrapper("_ZNSt3__211char_traitsIwE7not_eofEj");

/** @type {function(...*):?} */
var __ZNSt3__29DoIOSInitC1Ev = Module["__ZNSt3__29DoIOSInitC1Ev"] = createExportWrapper("_ZNSt3__29DoIOSInitC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__29DoIOSInitD1Ev = Module["__ZNSt3__29DoIOSInitD1Ev"] = createExportWrapper("_ZNSt3__29DoIOSInitD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base4InitC1Ev = Module["__ZNSt3__28ios_base4InitC1Ev"] = createExportWrapper("_ZNSt3__28ios_base4InitC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base4InitD1Ev = Module["__ZNSt3__28ios_base4InitD1Ev"] = createExportWrapper("_ZNSt3__28ios_base4InitD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__27collateIcED2Ev = Module["__ZNSt3__27collateIcED2Ev"] = createExportWrapper("_ZNSt3__27collateIcED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26locale5facetD2Ev = Module["__ZNSt3__26locale5facetD2Ev"] = createExportWrapper("_ZNSt3__26locale5facetD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27collateIcED0Ev = Module["__ZNSt3__27collateIcED0Ev"] = createExportWrapper("_ZNSt3__27collateIcED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__27collateIcE10do_compareEPKcS3_S3_S3_ = Module["__ZNKSt3__27collateIcE10do_compareEPKcS3_S3_S3_"] = createExportWrapper("_ZNKSt3__27collateIcE10do_compareEPKcS3_S3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__27collateIcE12do_transformEPKcS3_ = Module["__ZNKSt3__27collateIcE12do_transformEPKcS3_"] = createExportWrapper("_ZNKSt3__27collateIcE12do_transformEPKcS3_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPKcvEET_S9_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPKcvEET_S9_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPKcvEET_S9_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initIPKcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESA_SA_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initIPKcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESA_SA_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initIPKcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESA_SA_");

/** @type {function(...*):?} */
var __ZNKSt3__27collateIcE7do_hashEPKcS3_ = Module["__ZNKSt3__27collateIcE7do_hashEPKcS3_"] = createExportWrapper("_ZNKSt3__27collateIcE7do_hashEPKcS3_");

/** @type {function(...*):?} */
var __ZNSt3__27collateIwED2Ev = Module["__ZNSt3__27collateIwED2Ev"] = createExportWrapper("_ZNSt3__27collateIwED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27collateIwED0Ev = Module["__ZNSt3__27collateIwED0Ev"] = createExportWrapper("_ZNSt3__27collateIwED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__27collateIwE10do_compareEPKwS3_S3_S3_ = Module["__ZNKSt3__27collateIwE10do_compareEPKwS3_S3_S3_"] = createExportWrapper("_ZNKSt3__27collateIwE10do_compareEPKwS3_S3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__27collateIwE12do_transformEPKwS3_ = Module["__ZNKSt3__27collateIwE12do_transformEPKwS3_"] = createExportWrapper("_ZNKSt3__27collateIwE12do_transformEPKwS3_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IPKwvEET_S9_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IPKwvEET_S9_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IPKwvEET_S9_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_EC2INS_18__default_init_tagESA_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_EC2INS_18__default_init_tagESA_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_EC2INS_18__default_init_tagESA_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initIPKwEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESA_SA_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initIPKwEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESA_SA_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initIPKwEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESA_SA_");

/** @type {function(...*):?} */
var __ZNKSt3__27collateIwE7do_hashEPKwS3_ = Module["__ZNKSt3__27collateIwE7do_hashEPKwS3_"] = createExportWrapper("_ZNKSt3__27collateIwE7do_hashEPKwS3_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRb = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRb"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRb");

/** @type {function(...*):?} */
var __ZNSt3__26localeD2Ev = Module["__ZNSt3__26localeD2Ev"] = createExportWrapper("_ZNSt3__26localeD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_8numpunctIcEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_8numpunctIcEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_8numpunctIcEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIcE8truenameEv = Module["__ZNKSt3__28numpunctIcE8truenameEv"] = createExportWrapper("_ZNKSt3__28numpunctIcE8truenameEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIcE9falsenameEv = Module["__ZNKSt3__28numpunctIcE9falsenameEv"] = createExportWrapper("_ZNKSt3__28numpunctIcE9falsenameEv");

/** @type {function(...*):?} */
var __ZNSt3__214__scan_keywordINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEPKNS_12basic_stringIcS3_NS_9allocatorIcEEEENS_5ctypeIcEEEET0_RT_SE_SD_SD_RKT1_Rjb = Module["__ZNSt3__214__scan_keywordINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEPKNS_12basic_stringIcS3_NS_9allocatorIcEEEENS_5ctypeIcEEEET0_RT_SE_SD_SD_RKT1_Rjb"] = createExportWrapper("_ZNSt3__214__scan_keywordINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEPKNS_12basic_stringIcS3_NS_9allocatorIcEEEENS_5ctypeIcEEEET0_RT_SE_SD_SD_RKT1_Rjb");

/** @type {function(...*):?} */
var __ZNSt3__28distanceIPKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_ = Module["__ZNSt3__28distanceIPKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_"] = createExportWrapper("_ZNSt3__28distanceIPKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIhPFvPvEEC2ILb1EvEEPhNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrIhPFvPvEEC2ILb1EvEEPhNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrIhPFvPvEEC2ILb1EvEEPhNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIhPFvPvEE5resetEPh = Module["__ZNSt3__210unique_ptrIhPFvPvEE5resetEPh"] = createExportWrapper("_ZNSt3__210unique_ptrIhPFvPvEE5resetEPh");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE7toupperEc = Module["__ZNKSt3__25ctypeIcE7toupperEc"] = createExportWrapper("_ZNKSt3__25ctypeIcE7toupperEc");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEixEm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEixEm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEixEm");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIhPFvPvEED2Ev = Module["__ZNSt3__210unique_ptrIhPFvPvEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrIhPFvPvEED2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5emptyEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5emptyEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5emptyEv");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRl = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRl"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRl");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE15__do_get_signedIlEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE15__do_get_signedIlEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE15__do_get_signedIlEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNSt3__214__num_get_base10__get_baseERNS_8ios_baseE = Module["__ZNSt3__214__num_get_base10__get_baseERNS_8ios_baseE"] = createExportWrapper("_ZNSt3__214__num_get_base10__get_baseERNS_8ios_baseE");

/** @type {function(...*):?} */
var __ZNKSt3__29__num_getIcE10__do_widenERNS_8ios_baseEPc = Module["__ZNKSt3__29__num_getIcE10__do_widenERNS_8ios_baseEPc"] = createExportWrapper("_ZNKSt3__29__num_getIcE10__do_widenERNS_8ios_baseEPc");

/** @type {function(...*):?} */
var __ZNSt3__29__num_getIcE17__stage2_int_prepERNS_8ios_baseERc = Module["__ZNSt3__29__num_getIcE17__stage2_int_prepERNS_8ios_baseERc"] = createExportWrapper("_ZNSt3__29__num_getIcE17__stage2_int_prepERNS_8ios_baseERc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2Ev = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2Ev"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE8capacityEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE8capacityEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE8capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6resizeEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6resizeEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6resizeEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEixEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEixEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEixEm");

/** @type {function(...*):?} */
var __ZNSt3__29__num_getIcE17__stage2_int_loopEciPcRS2_RjcRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSD_PKc = Module["__ZNSt3__29__num_getIcE17__stage2_int_loopEciPcRS2_RjcRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSD_PKc"] = createExportWrapper("_ZNSt3__29__num_getIcE17__stage2_int_loopEciPcRS2_RjcRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSD_PKc");

/** @type {function(...*):?} */
var __ZNSt3__225__num_get_signed_integralIlEET_PKcS3_Rji = Module["__ZNSt3__225__num_get_signed_integralIlEET_PKcS3_Rji"] = createExportWrapper("_ZNSt3__225__num_get_signed_integralIlEET_PKcS3_Rji");

/** @type {function(...*):?} */
var __ZNSt3__216__check_groupingERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjS8_Rj = Module["__ZNSt3__216__check_groupingERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjS8_Rj"] = createExportWrapper("_ZNSt3__216__check_groupingERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjS8_Rj");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRx = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRx"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRx");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE15__do_get_signedIxEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE15__do_get_signedIxEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE15__do_get_signedIxEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNSt3__225__num_get_signed_integralIxEET_PKcS3_Rji = Module["__ZNSt3__225__num_get_signed_integralIxEET_PKcS3_Rji"] = createExportWrapper("_ZNSt3__225__num_get_signed_integralIxEET_PKcS3_Rji");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRt = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRt"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRt");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedItEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedItEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedItEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNSt3__227__num_get_unsigned_integralItEET_PKcS3_Rji = Module["__ZNSt3__227__num_get_unsigned_integralItEET_PKcS3_Rji"] = createExportWrapper("_ZNSt3__227__num_get_unsigned_integralItEET_PKcS3_Rji");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjS8_ = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjS8_"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjS8_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedIjEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedIjEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedIjEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNSt3__227__num_get_unsigned_integralIjEET_PKcS3_Rji = Module["__ZNSt3__227__num_get_unsigned_integralIjEET_PKcS3_Rji"] = createExportWrapper("_ZNSt3__227__num_get_unsigned_integralIjEET_PKcS3_Rji");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRm = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRm"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRm");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedImEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedImEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedImEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNSt3__227__num_get_unsigned_integralImEET_PKcS3_Rji = Module["__ZNSt3__227__num_get_unsigned_integralImEET_PKcS3_Rji"] = createExportWrapper("_ZNSt3__227__num_get_unsigned_integralImEET_PKcS3_Rji");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRy = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRy"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRy");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedIyEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedIyEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__do_get_unsignedIyEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNSt3__227__num_get_unsigned_integralIyEET_PKcS3_Rji = Module["__ZNSt3__227__num_get_unsigned_integralIyEET_PKcS3_Rji"] = createExportWrapper("_ZNSt3__227__num_get_unsigned_integralIyEET_PKcS3_Rji");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRf = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRf"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRf");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE23__do_get_floating_pointIfEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE23__do_get_floating_pointIfEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE23__do_get_floating_pointIfEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNSt3__29__num_getIcE19__stage2_float_prepERNS_8ios_baseEPcRcS5_ = Module["__ZNSt3__29__num_getIcE19__stage2_float_prepERNS_8ios_baseEPcRcS5_"] = createExportWrapper("_ZNSt3__29__num_getIcE19__stage2_float_prepERNS_8ios_baseEPcRcS5_");

/** @type {function(...*):?} */
var __ZNSt3__29__num_getIcE19__stage2_float_loopEcRbRcPcRS4_ccRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSE_RjS4_ = Module["__ZNSt3__29__num_getIcE19__stage2_float_loopEcRbRcPcRS4_ccRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSE_RjS4_"] = createExportWrapper("_ZNSt3__29__num_getIcE19__stage2_float_loopEcRbRcPcRS4_ccRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSE_RjS4_");

/** @type {function(...*):?} */
var __ZNSt3__215__num_get_floatIfEET_PKcS3_Rj = Module["__ZNSt3__215__num_get_floatIfEET_PKcS3_Rj"] = createExportWrapper("_ZNSt3__215__num_get_floatIfEET_PKcS3_Rj");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRd = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRd"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRd");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE23__do_get_floating_pointIdEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE23__do_get_floating_pointIdEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE23__do_get_floating_pointIdEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNSt3__215__num_get_floatIdEET_PKcS3_Rj = Module["__ZNSt3__215__num_get_floatIdEET_PKcS3_Rj"] = createExportWrapper("_ZNSt3__215__num_get_floatIdEET_PKcS3_Rj");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRe = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRe"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRe");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE23__do_get_floating_pointIeEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE23__do_get_floating_pointIeEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE23__do_get_floating_pointIeEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNSt3__215__num_get_floatIeEET_PKcS3_Rj = Module["__ZNSt3__215__num_get_floatIeEET_PKcS3_Rj"] = createExportWrapper("_ZNSt3__215__num_get_floatIeEET_PKcS3_Rj");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRPv = Module["__ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRPv"] = createExportWrapper("_ZNKSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjRPv");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE5widenEPKcS3_Pc = Module["__ZNKSt3__25ctypeIcE5widenEPKcS3_Pc"] = createExportWrapper("_ZNKSt3__25ctypeIcE5widenEPKcS3_Pc");

/** @type {function(...*):?} */
var __ZNSt3__26__clocEv = Module["__ZNSt3__26__clocEv"] = createExportWrapper("_ZNSt3__26__clocEv");

/** @type {function(...*):?} */
var __ZNSt3__217__libcpp_sscanf_lEPKcP15__locale_structS1_z = Module["__ZNSt3__217__libcpp_sscanf_lEPKcP15__locale_structS1_z"] = createExportWrapper("_ZNSt3__217__libcpp_sscanf_lEPKcP15__locale_structS1_z");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6resizeEmc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6resizeEmc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6resizeEmc");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE14__get_long_capEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE14__get_long_capEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE14__get_long_capEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13__get_pointerEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13__get_pointerEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13__get_pointerEv");

/** @type {function(...*):?} */
var __ZNSt3__24findIPKccEET_S3_S3_RKT0_ = Module["__ZNSt3__24findIPKccEET_S3_S3_RKT0_"] = createExportWrapper("_ZNSt3__24findIPKccEET_S3_S3_RKT0_");

/** @type {function(...*):?} */
var __ZNSt3__221__libcpp_locale_guardC2ERP15__locale_struct = Module["__ZNSt3__221__libcpp_locale_guardC2ERP15__locale_struct"] = createExportWrapper("_ZNSt3__221__libcpp_locale_guardC2ERP15__locale_struct");

/** @type {function(...*):?} */
var __ZNSt3__221__libcpp_locale_guardD2Ev = Module["__ZNSt3__221__libcpp_locale_guardD2Ev"] = createExportWrapper("_ZNSt3__221__libcpp_locale_guardD2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRb = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRb"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRb");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_8numpunctIwEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_8numpunctIwEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_8numpunctIwEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIwE8truenameEv = Module["__ZNKSt3__28numpunctIwE8truenameEv"] = createExportWrapper("_ZNKSt3__28numpunctIwE8truenameEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIwE9falsenameEv = Module["__ZNKSt3__28numpunctIwE9falsenameEv"] = createExportWrapper("_ZNKSt3__28numpunctIwE9falsenameEv");

/** @type {function(...*):?} */
var __ZNSt3__214__scan_keywordINS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEPKNS_12basic_stringIwS3_NS_9allocatorIwEEEENS_5ctypeIwEEEET0_RT_SE_SD_SD_RKT1_Rjb = Module["__ZNSt3__214__scan_keywordINS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEPKNS_12basic_stringIwS3_NS_9allocatorIwEEEENS_5ctypeIwEEEET0_RT_SE_SD_SD_RKT1_Rjb"] = createExportWrapper("_ZNSt3__214__scan_keywordINS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEPKNS_12basic_stringIwS3_NS_9allocatorIwEEEENS_5ctypeIwEEEET0_RT_SE_SD_SD_RKT1_Rjb");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEED2Ev = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEED2Ev"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28distanceIPKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_ = Module["__ZNSt3__28distanceIPKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_"] = createExportWrapper("_ZNSt3__28distanceIPKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE7toupperEw = Module["__ZNKSt3__25ctypeIwE7toupperEw"] = createExportWrapper("_ZNKSt3__25ctypeIwE7toupperEw");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4sizeEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4sizeEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEixEm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEixEm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEixEm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5emptyEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5emptyEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5emptyEv");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRl = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRl"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRl");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE15__do_get_signedIlEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE15__do_get_signedIlEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE15__do_get_signedIlEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNKSt3__29__num_getIwE10__do_widenERNS_8ios_baseEPw = Module["__ZNKSt3__29__num_getIwE10__do_widenERNS_8ios_baseEPw"] = createExportWrapper("_ZNKSt3__29__num_getIwE10__do_widenERNS_8ios_baseEPw");

/** @type {function(...*):?} */
var __ZNSt3__29__num_getIwE17__stage2_int_prepERNS_8ios_baseERw = Module["__ZNSt3__29__num_getIwE17__stage2_int_prepERNS_8ios_baseERw"] = createExportWrapper("_ZNSt3__29__num_getIwE17__stage2_int_prepERNS_8ios_baseERw");

/** @type {function(...*):?} */
var __ZNSt3__29__num_getIwE17__stage2_int_loopEwiPcRS2_RjwRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSD_PKw = Module["__ZNSt3__29__num_getIwE17__stage2_int_loopEwiPcRS2_RjwRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSD_PKw"] = createExportWrapper("_ZNSt3__29__num_getIwE17__stage2_int_loopEwiPcRS2_RjwRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSD_PKw");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRx = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRx"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRx");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE15__do_get_signedIxEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE15__do_get_signedIxEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE15__do_get_signedIxEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRt = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRt"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRt");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedItEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedItEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedItEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjS8_ = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjS8_"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjS8_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedIjEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedIjEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedIjEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRm = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRm"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRm");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedImEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedImEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedImEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRy = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRy"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRy");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedIyEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedIyEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__do_get_unsignedIyEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRf = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRf"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRf");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE23__do_get_floating_pointIfEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE23__do_get_floating_pointIfEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE23__do_get_floating_pointIfEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNSt3__29__num_getIwE19__stage2_float_prepERNS_8ios_baseEPwRwS5_ = Module["__ZNSt3__29__num_getIwE19__stage2_float_prepERNS_8ios_baseEPwRwS5_"] = createExportWrapper("_ZNSt3__29__num_getIwE19__stage2_float_prepERNS_8ios_baseEPwRwS5_");

/** @type {function(...*):?} */
var __ZNSt3__29__num_getIwE19__stage2_float_loopEwRbRcPcRS4_wwRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSE_RjPw = Module["__ZNSt3__29__num_getIwE19__stage2_float_loopEwRbRcPcRS4_wwRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSE_RjPw"] = createExportWrapper("_ZNSt3__29__num_getIwE19__stage2_float_loopEwRbRcPcRS4_wwRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPjRSE_RjPw");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRd = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRd"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRd");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE23__do_get_floating_pointIdEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE23__do_get_floating_pointIdEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE23__do_get_floating_pointIdEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRe = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRe"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRe");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE23__do_get_floating_pointIeEES4_S4_S4_RNS_8ios_baseERjRT_ = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE23__do_get_floating_pointIeEES4_S4_S4_RNS_8ios_baseERjRT_"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE23__do_get_floating_pointIeEES4_S4_S4_RNS_8ios_baseERjRT_");

/** @type {function(...*):?} */
var __ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRPv = Module["__ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRPv"] = createExportWrapper("_ZNKSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjRPv");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE5widenEPKcS3_Pw = Module["__ZNKSt3__25ctypeIwE5widenEPKcS3_Pw"] = createExportWrapper("_ZNKSt3__25ctypeIwE5widenEPKcS3_Pw");

/** @type {function(...*):?} */
var __ZNSt3__24findIPKwwEET_S3_S3_RKT0_ = Module["__ZNSt3__24findIPKwwEET_S3_S3_RKT0_"] = createExportWrapper("_ZNSt3__24findIPKwwEET_S3_S3_RKT0_");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIcE13decimal_pointEv = Module["__ZNKSt3__28numpunctIcE13decimal_pointEv"] = createExportWrapper("_ZNKSt3__28numpunctIcE13decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIcE13thousands_sepEv = Module["__ZNKSt3__28numpunctIcE13thousands_sepEv"] = createExportWrapper("_ZNKSt3__28numpunctIcE13thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIcE8groupingEv = Module["__ZNKSt3__28numpunctIcE8groupingEv"] = createExportWrapper("_ZNKSt3__28numpunctIcE8groupingEv");

/** @type {function(...*):?} */
var __ZNSt3__24findIPccEET_S2_S2_RKT0_ = Module["__ZNSt3__24findIPccEET_S2_S2_RKT0_"] = createExportWrapper("_ZNSt3__24findIPccEET_S2_S2_RKT0_");

/** @type {function(...*):?} */
var __ZNKSt3__29__num_getIcE12__do_widen_pERNS_8ios_baseEPc = Module["__ZNKSt3__29__num_getIcE12__do_widen_pERNS_8ios_baseEPc"] = createExportWrapper("_ZNKSt3__29__num_getIcE12__do_widen_pERNS_8ios_baseEPc");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIwE13decimal_pointEv = Module["__ZNKSt3__28numpunctIwE13decimal_pointEv"] = createExportWrapper("_ZNKSt3__28numpunctIwE13decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIwE13thousands_sepEv = Module["__ZNKSt3__28numpunctIwE13thousands_sepEv"] = createExportWrapper("_ZNKSt3__28numpunctIwE13thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIwE8groupingEv = Module["__ZNKSt3__28numpunctIwE8groupingEv"] = createExportWrapper("_ZNKSt3__28numpunctIwE8groupingEv");

/** @type {function(...*):?} */
var __ZNSt3__24findIPwwEET_S2_S2_RKT0_ = Module["__ZNSt3__24findIPwwEET_S2_S2_RKT0_"] = createExportWrapper("_ZNSt3__24findIPwwEET_S2_S2_RKT0_");

/** @type {function(...*):?} */
var __ZNKSt3__29__num_getIwE12__do_widen_pIwEEPKT_RNS_8ios_baseEPS3_ = Module["__ZNKSt3__29__num_getIwE12__do_widen_pIwEEPKT_RNS_8ios_baseEPS3_"] = createExportWrapper("_ZNKSt3__29__num_getIwE12__do_widen_pIwEEPKT_RNS_8ios_baseEPS3_");

/** @type {function(...*):?} */
var __ZNKSt3__29__num_getIwE12__do_widen_pERNS_8ios_baseEPc = Module["__ZNKSt3__29__num_getIwE12__do_widen_pERNS_8ios_baseEPc"] = createExportWrapper("_ZNKSt3__29__num_getIwE12__do_widen_pERNS_8ios_baseEPc");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcb = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcb"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcb");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5beginEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5beginEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5beginEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE3endEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE3endEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE3endEv");

/** @type {function(...*):?} */
var __ZNSt3__2neIPcEEbRKNS_11__wrap_iterIT_EES6_ = Module["__ZNSt3__2neIPcEEbRKNS_11__wrap_iterIT_EES6_"] = createExportWrapper("_ZNSt3__2neIPcEEbRKNS_11__wrap_iterIT_EES6_");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPcEdeEv = Module["__ZNKSt3__211__wrap_iterIPcEdeEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPcEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPcEppEv = Module["__ZNSt3__211__wrap_iterIPcEppEv"] = createExportWrapper("_ZNSt3__211__wrap_iterIPcEppEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPcEC2ES1_ = Module["__ZNSt3__211__wrap_iterIPcEC2ES1_"] = createExportWrapper("_ZNSt3__211__wrap_iterIPcEC2ES1_");

/** @type {function(...*):?} */
var __ZNSt3__2eqIPcS1_EEbRKNS_11__wrap_iterIT_EERKNS2_IT0_EE = Module["__ZNSt3__2eqIPcS1_EEbRKNS_11__wrap_iterIT_EERKNS2_IT0_EE"] = createExportWrapper("_ZNSt3__2eqIPcS1_EEbRKNS_11__wrap_iterIT_EERKNS2_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcl = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcl"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcl");

/** @type {function(...*):?} */
var __ZNSt3__214__num_put_base12__format_intEPcPKcbj = Module["__ZNSt3__214__num_put_base12__format_intEPcPKcbj"] = createExportWrapper("_ZNSt3__214__num_put_base12__format_intEPcPKcbj");

/** @type {function(...*):?} */
var __ZNSt3__219__libcpp_snprintf_lEPcmP15__locale_structPKcz = Module["__ZNSt3__219__libcpp_snprintf_lEPcmP15__locale_structPKcz"] = createExportWrapper("_ZNSt3__219__libcpp_snprintf_lEPcmP15__locale_structPKcz");

/** @type {function(...*):?} */
var __ZNSt3__214__num_put_base18__identify_paddingEPcS1_RKNS_8ios_baseE = Module["__ZNSt3__214__num_put_base18__identify_paddingEPcS1_RKNS_8ios_baseE"] = createExportWrapper("_ZNSt3__214__num_put_base18__identify_paddingEPcS1_RKNS_8ios_baseE");

/** @type {function(...*):?} */
var __ZNSt3__29__num_putIcE21__widen_and_group_intEPcS2_S2_S2_RS2_S3_RKNS_6localeE = Module["__ZNSt3__29__num_putIcE21__widen_and_group_intEPcS2_S2_S2_RS2_S3_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29__num_putIcE21__widen_and_group_intEPcS2_S2_S2_RS2_S3_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__216__pad_and_outputIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIT_T0_EES6_PKS4_S8_S8_RNS_8ios_baseES4_ = Module["__ZNSt3__216__pad_and_outputIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIT_T0_EES6_PKS4_S8_S8_RNS_8ios_baseES4_"] = createExportWrapper("_ZNSt3__216__pad_and_outputIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIT_T0_EES6_PKS4_S8_S8_RNS_8ios_baseES4_");

/** @type {function(...*):?} */
var __ZNSt3__27reverseIPcEEvT_S2_ = Module["__ZNSt3__27reverseIPcEEvT_S2_"] = createExportWrapper("_ZNSt3__27reverseIPcEEvT_S2_");

/** @type {function(...*):?} */
var __ZNKSt3__28ios_base5widthEv = Module["__ZNKSt3__28ios_base5widthEv"] = createExportWrapper("_ZNKSt3__28ios_base5widthEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2Emc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2Emc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2Emc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4dataEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4dataEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4dataEv");

/** @type {function(...*):?} */
var __ZNSt3__28ios_base5widthEl = Module["__ZNSt3__28ios_base5widthEl"] = createExportWrapper("_ZNSt3__28ios_base5widthEl");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcx = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcx"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcx");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcm = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcm"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcm");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcy = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcy"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcy");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcd = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcd"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcd");

/** @type {function(...*):?} */
var __ZNSt3__214__num_put_base14__format_floatEPcPKcj = Module["__ZNSt3__214__num_put_base14__format_floatEPcPKcj"] = createExportWrapper("_ZNSt3__214__num_put_base14__format_floatEPcPKcj");

/** @type {function(...*):?} */
var __ZNKSt3__28ios_base9precisionEv = Module["__ZNKSt3__28ios_base9precisionEv"] = createExportWrapper("_ZNKSt3__28ios_base9precisionEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIcPFvPvEEC2ILb1EvEEPcNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrIcPFvPvEEC2ILb1EvEEPcNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrIcPFvPvEEC2ILb1EvEEPcNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNSt3__219__libcpp_asprintf_lEPPcP15__locale_structPKcz = Module["__ZNSt3__219__libcpp_asprintf_lEPPcP15__locale_structPKcz"] = createExportWrapper("_ZNSt3__219__libcpp_asprintf_lEPPcP15__locale_structPKcz");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIcPFvPvEE5resetEPc = Module["__ZNSt3__210unique_ptrIcPFvPvEE5resetEPc"] = createExportWrapper("_ZNSt3__210unique_ptrIcPFvPvEE5resetEPc");

/** @type {function(...*):?} */
var __ZNSt3__29__num_putIcE23__widen_and_group_floatEPcS2_S2_S2_RS2_S3_RKNS_6localeE = Module["__ZNSt3__29__num_putIcE23__widen_and_group_floatEPcS2_S2_S2_RS2_S3_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29__num_putIcE23__widen_and_group_floatEPcS2_S2_S2_RS2_S3_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIcPFvPvEED2Ev = Module["__ZNSt3__210unique_ptrIcPFvPvEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrIcPFvPvEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPcPFvPvEEC2IRS1_S4_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPcPFvPvEEC2IRS1_S4_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPcPFvPvEEC2IRS1_S4_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPcPFvPvEE5firstEv = Module["__ZNSt3__217__compressed_pairIPcPFvPvEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPcPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPcPFvPvEE6secondEv = Module["__ZNSt3__217__compressed_pairIPcPFvPvEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPcPFvPvEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEce = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEce"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEce");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcPKv = Module["__ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcPKv"] = createExportWrapper("_ZNKSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcPKv");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwb = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwb"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwb");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5beginEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5beginEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5beginEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE3endEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE3endEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE3endEv");

/** @type {function(...*):?} */
var __ZNSt3__2neIPwEEbRKNS_11__wrap_iterIT_EES6_ = Module["__ZNSt3__2neIPwEEbRKNS_11__wrap_iterIT_EES6_"] = createExportWrapper("_ZNSt3__2neIPwEEbRKNS_11__wrap_iterIT_EES6_");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPwEdeEv = Module["__ZNKSt3__211__wrap_iterIPwEdeEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPwEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPwEppEv = Module["__ZNSt3__211__wrap_iterIPwEppEv"] = createExportWrapper("_ZNSt3__211__wrap_iterIPwEppEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13__get_pointerEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13__get_pointerEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13__get_pointerEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPwEC2ES1_ = Module["__ZNSt3__211__wrap_iterIPwEC2ES1_"] = createExportWrapper("_ZNSt3__211__wrap_iterIPwEC2ES1_");

/** @type {function(...*):?} */
var __ZNSt3__2eqIPwS1_EEbRKNS_11__wrap_iterIT_EERKNS2_IT0_EE = Module["__ZNSt3__2eqIPwS1_EEbRKNS_11__wrap_iterIT_EERKNS2_IT0_EE"] = createExportWrapper("_ZNSt3__2eqIPwS1_EEbRKNS_11__wrap_iterIT_EERKNS2_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwl = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwl"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwl");

/** @type {function(...*):?} */
var __ZNSt3__29__num_putIwE21__widen_and_group_intEPcS2_S2_PwRS3_S4_RKNS_6localeE = Module["__ZNSt3__29__num_putIwE21__widen_and_group_intEPcS2_S2_PwRS3_S4_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29__num_putIwE21__widen_and_group_intEPcS2_S2_PwRS3_S4_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__216__pad_and_outputIwNS_11char_traitsIwEEEENS_19ostreambuf_iteratorIT_T0_EES6_PKS4_S8_S8_RNS_8ios_baseES4_ = Module["__ZNSt3__216__pad_and_outputIwNS_11char_traitsIwEEEENS_19ostreambuf_iteratorIT_T0_EES6_PKS4_S8_S8_RNS_8ios_baseES4_"] = createExportWrapper("_ZNSt3__216__pad_and_outputIwNS_11char_traitsIwEEEENS_19ostreambuf_iteratorIT_T0_EES6_PKS4_S8_S8_RNS_8ios_baseES4_");

/** @type {function(...*):?} */
var __ZNSt3__27reverseIPwEEvT_S2_ = Module["__ZNSt3__27reverseIPwEEvT_S2_"] = createExportWrapper("_ZNSt3__27reverseIPwEEvT_S2_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2Emw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2Emw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2Emw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4dataEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4dataEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4dataEv");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwx = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwx"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwx");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwm = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwm"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwm");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwy = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwy"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwy");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwd = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwd"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwd");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIwPFvPvEEC2ILb1EvEEPwNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrIwPFvPvEEC2ILb1EvEEPwNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrIwPFvPvEEC2ILb1EvEEPwNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIwPFvPvEE5resetEPw = Module["__ZNSt3__210unique_ptrIwPFvPvEE5resetEPw"] = createExportWrapper("_ZNSt3__210unique_ptrIwPFvPvEE5resetEPw");

/** @type {function(...*):?} */
var __ZNSt3__29__num_putIwE23__widen_and_group_floatEPcS2_S2_PwRS3_S4_RKNS_6localeE = Module["__ZNSt3__29__num_putIwE23__widen_and_group_floatEPcS2_S2_PwRS3_S4_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29__num_putIwE23__widen_and_group_floatEPcS2_S2_PwRS3_S4_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIwPFvPvEED2Ev = Module["__ZNSt3__210unique_ptrIwPFvPvEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrIwPFvPvEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPwPFvPvEEC2IRS1_S4_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPwPFvPvEEC2IRS1_S4_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPwPFvPvEEC2IRS1_S4_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPwPFvPvEE5firstEv = Module["__ZNSt3__217__compressed_pairIPwPFvPvEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPwPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPwPFvPvEE6secondEv = Module["__ZNSt3__217__compressed_pairIPwPFvPvEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPwPFvPvEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwe = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwe"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwe");

/** @type {function(...*):?} */
var __ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwPKv = Module["__ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwPKv"] = createExportWrapper("_ZNKSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwPKv");

/** @type {function(...*):?} */
var __ZNSt3__29__reverseIPcEEvT_S2_NS_26random_access_iterator_tagE = Module["__ZNSt3__29__reverseIPcEEvT_S2_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__29__reverseIPcEEvT_S2_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__29__reverseIPwEEvT_S2_NS_26random_access_iterator_tagE = Module["__ZNSt3__29__reverseIPwEEvT_S2_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__29__reverseIPwEEvT_S2_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjP2tmPKcSC_ = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjP2tmPKcSC_"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3getES4_S4_RNS_8ios_baseERjP2tmPKcSC_");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE6narrowEcc = Module["__ZNKSt3__25ctypeIcE6narrowEcc"] = createExportWrapper("_ZNKSt3__25ctypeIcE6narrowEcc");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13do_date_orderEv = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13do_date_orderEv"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13do_date_orderEv");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11do_get_timeES4_S4_RNS_8ios_baseERjP2tm = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11do_get_timeES4_S4_RNS_8ios_baseERjP2tm"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11do_get_timeES4_S4_RNS_8ios_baseERjP2tm");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11do_get_dateES4_S4_RNS_8ios_baseERjP2tm = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11do_get_dateES4_S4_RNS_8ios_baseERjP2tm"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11do_get_dateES4_S4_RNS_8ios_baseERjP2tm");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE14do_get_weekdayES4_S4_RNS_8ios_baseERjP2tm = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE14do_get_weekdayES4_S4_RNS_8ios_baseERjP2tm"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE14do_get_weekdayES4_S4_RNS_8ios_baseERjP2tm");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__get_weekdaynameERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__get_weekdaynameERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__get_weekdaynameERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE16do_get_monthnameES4_S4_RNS_8ios_baseERjP2tm = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE16do_get_monthnameES4_S4_RNS_8ios_baseERjP2tm"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE16do_get_monthnameES4_S4_RNS_8ios_baseERjP2tm");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE15__get_monthnameERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE15__get_monthnameERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE15__get_monthnameERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11do_get_yearES4_S4_RNS_8ios_baseERjP2tm = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11do_get_yearES4_S4_RNS_8ios_baseERjP2tm"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11do_get_yearES4_S4_RNS_8ios_baseERjP2tm");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE10__get_yearERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE10__get_yearERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE10__get_yearERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNSt3__220__get_up_to_n_digitsIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEiRT0_S5_RjRKNS_5ctypeIT_EEi = Module["__ZNSt3__220__get_up_to_n_digitsIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEiRT0_S5_RjRKNS_5ctypeIT_EEi"] = createExportWrapper("_ZNSt3__220__get_up_to_n_digitsIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEiRT0_S5_RjRKNS_5ctypeIT_EEi");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjP2tmcc = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjP2tmcc"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_RNS_8ios_baseERjP2tmcc");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE9__get_dayERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE9__get_dayERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE9__get_dayERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE10__get_hourERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE10__get_hourERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE10__get_hourERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13__get_12_hourERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13__get_12_hourERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13__get_12_hourERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE18__get_day_year_numERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE18__get_day_year_numERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE18__get_day_year_numERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11__get_monthERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11__get_monthERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11__get_monthERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE12__get_minuteERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE12__get_minuteERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE12__get_minuteERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__get_white_spaceERS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__get_white_spaceERS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE17__get_white_spaceERS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11__get_am_pmERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11__get_am_pmERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11__get_am_pmERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE12__get_secondERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE12__get_secondERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE12__get_secondERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13__get_weekdayERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13__get_weekdayERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13__get_weekdayERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11__get_year4ERiRS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11__get_year4ERiRS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE11__get_year4ERiRS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13__get_percentERS4_S4_RjRKNS_5ctypeIcEE = Module["__ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13__get_percentERS4_S4_RjRKNS_5ctypeIcEE"] = createExportWrapper("_ZNKSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13__get_percentERS4_S4_RjRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjP2tmPKwSC_ = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjP2tmPKwSC_"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3getES4_S4_RNS_8ios_baseERjP2tmPKwSC_");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE6narrowEwc = Module["__ZNKSt3__25ctypeIwE6narrowEwc"] = createExportWrapper("_ZNKSt3__25ctypeIwE6narrowEwc");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13do_date_orderEv = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13do_date_orderEv"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13do_date_orderEv");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11do_get_timeES4_S4_RNS_8ios_baseERjP2tm = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11do_get_timeES4_S4_RNS_8ios_baseERjP2tm"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11do_get_timeES4_S4_RNS_8ios_baseERjP2tm");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11do_get_dateES4_S4_RNS_8ios_baseERjP2tm = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11do_get_dateES4_S4_RNS_8ios_baseERjP2tm"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11do_get_dateES4_S4_RNS_8ios_baseERjP2tm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4dataEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4dataEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4dataEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13__get_pointerEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13__get_pointerEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13__get_pointerEv");

/** @type {function(...*):?} */
var __ZNSt3__212__to_addressIKwEEPT_S3_ = Module["__ZNSt3__212__to_addressIKwEEPT_S3_"] = createExportWrapper("_ZNSt3__212__to_addressIKwEEPT_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE9__is_longEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE9__is_longEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE9__is_longEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE15__get_long_sizeEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE15__get_long_sizeEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE15__get_long_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE16__get_short_sizeEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE16__get_short_sizeEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE16__get_short_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE14do_get_weekdayES4_S4_RNS_8ios_baseERjP2tm = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE14do_get_weekdayES4_S4_RNS_8ios_baseERjP2tm"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE14do_get_weekdayES4_S4_RNS_8ios_baseERjP2tm");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__get_weekdaynameERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__get_weekdaynameERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__get_weekdaynameERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE16do_get_monthnameES4_S4_RNS_8ios_baseERjP2tm = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE16do_get_monthnameES4_S4_RNS_8ios_baseERjP2tm"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE16do_get_monthnameES4_S4_RNS_8ios_baseERjP2tm");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE15__get_monthnameERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE15__get_monthnameERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE15__get_monthnameERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11do_get_yearES4_S4_RNS_8ios_baseERjP2tm = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11do_get_yearES4_S4_RNS_8ios_baseERjP2tm"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11do_get_yearES4_S4_RNS_8ios_baseERjP2tm");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE10__get_yearERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE10__get_yearERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE10__get_yearERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNSt3__220__get_up_to_n_digitsIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEiRT0_S5_RjRKNS_5ctypeIT_EEi = Module["__ZNSt3__220__get_up_to_n_digitsIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEiRT0_S5_RjRKNS_5ctypeIT_EEi"] = createExportWrapper("_ZNSt3__220__get_up_to_n_digitsIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEiRT0_S5_RjRKNS_5ctypeIT_EEi");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjP2tmcc = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjP2tmcc"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_RNS_8ios_baseERjP2tmcc");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE9__get_dayERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE9__get_dayERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE9__get_dayERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE10__get_hourERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE10__get_hourERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE10__get_hourERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13__get_12_hourERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13__get_12_hourERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13__get_12_hourERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE18__get_day_year_numERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE18__get_day_year_numERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE18__get_day_year_numERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11__get_monthERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11__get_monthERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11__get_monthERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE12__get_minuteERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE12__get_minuteERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE12__get_minuteERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__get_white_spaceERS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__get_white_spaceERS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE17__get_white_spaceERS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11__get_am_pmERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11__get_am_pmERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11__get_am_pmERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE12__get_secondERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE12__get_secondERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE12__get_secondERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13__get_weekdayERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13__get_weekdayERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13__get_weekdayERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11__get_year4ERiRS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11__get_year4ERiRS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE11__get_year4ERiRS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13__get_percentERS4_S4_RjRKNS_5ctypeIwEE = Module["__ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13__get_percentERS4_S4_RjRKNS_5ctypeIwEE"] = createExportWrapper("_ZNKSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13__get_percentERS4_S4_RjRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcPK2tmPKcSC_ = Module["__ZNKSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcPK2tmPKcSC_"] = createExportWrapper("_ZNKSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE3putES4_RNS_8ios_baseEcPK2tmPKcSC_");

/** @type {function(...*):?} */
var __ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEppEi = Module["__ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEppEi"] = createExportWrapper("_ZNSt3__219ostreambuf_iteratorIcNS_11char_traitsIcEEEppEi");

/** @type {function(...*):?} */
var __ZNKSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcPK2tmcc = Module["__ZNKSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcPK2tmcc"] = createExportWrapper("_ZNKSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_RNS_8ios_baseEcPK2tmcc");

/** @type {function(...*):?} */
var __ZNKSt3__210__time_put8__do_putEPcRS1_PK2tmcc = Module["__ZNKSt3__210__time_put8__do_putEPcRS1_PK2tmcc"] = createExportWrapper("_ZNKSt3__210__time_put8__do_putEPcRS1_PK2tmcc");

/** @type {function(...*):?} */
var __ZNSt3__24copyIPcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET0_T_S7_S6_ = Module["__ZNSt3__24copyIPcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET0_T_S7_S6_"] = createExportWrapper("_ZNSt3__24copyIPcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET0_T_S7_S6_");

/** @type {function(...*):?} */
var __ZNSt3__213__unwrap_iterIPcEET_S2_ = Module["__ZNSt3__213__unwrap_iterIPcEET_S2_"] = createExportWrapper("_ZNSt3__213__unwrap_iterIPcEET_S2_");

/** @type {function(...*):?} */
var __ZNSt3__213__unwrap_iterINS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET_S5_ = Module["__ZNSt3__213__unwrap_iterINS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET_S5_"] = createExportWrapper("_ZNSt3__213__unwrap_iterINS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET_S5_");

/** @type {function(...*):?} */
var __ZNSt3__26__copyIPcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET0_T_S7_S6_ = Module["__ZNSt3__26__copyIPcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET0_T_S7_S6_"] = createExportWrapper("_ZNSt3__26__copyIPcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET0_T_S7_S6_");

/** @type {function(...*):?} */
var __ZNKSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwPK2tmPKwSC_ = Module["__ZNKSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwPK2tmPKwSC_"] = createExportWrapper("_ZNKSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE3putES4_RNS_8ios_baseEwPK2tmPKwSC_");

/** @type {function(...*):?} */
var __ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEppEi = Module["__ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEppEi"] = createExportWrapper("_ZNSt3__219ostreambuf_iteratorIwNS_11char_traitsIwEEEppEi");

/** @type {function(...*):?} */
var __ZNKSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwPK2tmcc = Module["__ZNKSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwPK2tmcc"] = createExportWrapper("_ZNKSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_RNS_8ios_baseEwPK2tmcc");

/** @type {function(...*):?} */
var __ZNKSt3__210__time_put8__do_putEPwRS1_PK2tmcc = Module["__ZNKSt3__210__time_put8__do_putEPwRS1_PK2tmcc"] = createExportWrapper("_ZNKSt3__210__time_put8__do_putEPwRS1_PK2tmcc");

/** @type {function(...*):?} */
var __ZNSt3__24copyIPwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET0_T_S7_S6_ = Module["__ZNSt3__24copyIPwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET0_T_S7_S6_"] = createExportWrapper("_ZNSt3__24copyIPwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET0_T_S7_S6_");

/** @type {function(...*):?} */
var __ZNSt3__220__libcpp_mbsrtowcs_lEPwPPKcmP11__mbstate_tP15__locale_struct = Module["__ZNSt3__220__libcpp_mbsrtowcs_lEPwPPKcmP11__mbstate_tP15__locale_struct"] = createExportWrapper("_ZNSt3__220__libcpp_mbsrtowcs_lEPwPPKcmP11__mbstate_tP15__locale_struct");

/** @type {function(...*):?} */
var __ZNSt3__213__unwrap_iterIPwEET_S2_ = Module["__ZNSt3__213__unwrap_iterIPwEET_S2_"] = createExportWrapper("_ZNSt3__213__unwrap_iterIPwEET_S2_");

/** @type {function(...*):?} */
var __ZNSt3__213__unwrap_iterINS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET_S5_ = Module["__ZNSt3__213__unwrap_iterINS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET_S5_"] = createExportWrapper("_ZNSt3__213__unwrap_iterINS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET_S5_");

/** @type {function(...*):?} */
var __ZNSt3__26__copyIPwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET0_T_S7_S6_ = Module["__ZNSt3__26__copyIPwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET0_T_S7_S6_"] = createExportWrapper("_ZNSt3__26__copyIPwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET0_T_S7_S6_");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE16do_decimal_pointEv = Module["__ZNKSt3__210moneypunctIcLb0EE16do_decimal_pointEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE16do_decimal_pointEv");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIcE3maxEv = Module["__ZNSt3__214numeric_limitsIcE3maxEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIcE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIcLb1EE3maxEv = Module["__ZNSt3__223__libcpp_numeric_limitsIcLb1EE3maxEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIcLb1EE3maxEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE16do_thousands_sepEv = Module["__ZNKSt3__210moneypunctIcLb0EE16do_thousands_sepEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE16do_thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE11do_groupingEv = Module["__ZNKSt3__210moneypunctIcLb0EE11do_groupingEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE11do_groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE14do_curr_symbolEv = Module["__ZNKSt3__210moneypunctIcLb0EE14do_curr_symbolEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE14do_curr_symbolEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE16do_positive_signEv = Module["__ZNKSt3__210moneypunctIcLb0EE16do_positive_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE16do_positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE16do_negative_signEv = Module["__ZNKSt3__210moneypunctIcLb0EE16do_negative_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE16do_negative_signEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initEmc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initEmc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initEmc");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE14do_frac_digitsEv = Module["__ZNKSt3__210moneypunctIcLb0EE14do_frac_digitsEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE14do_frac_digitsEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE13do_pos_formatEv = Module["__ZNKSt3__210moneypunctIcLb0EE13do_pos_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE13do_pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE13do_neg_formatEv = Module["__ZNKSt3__210moneypunctIcLb0EE13do_neg_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE13do_neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE16do_decimal_pointEv = Module["__ZNKSt3__210moneypunctIcLb1EE16do_decimal_pointEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE16do_decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE16do_thousands_sepEv = Module["__ZNKSt3__210moneypunctIcLb1EE16do_thousands_sepEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE16do_thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE11do_groupingEv = Module["__ZNKSt3__210moneypunctIcLb1EE11do_groupingEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE11do_groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE14do_curr_symbolEv = Module["__ZNKSt3__210moneypunctIcLb1EE14do_curr_symbolEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE14do_curr_symbolEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE16do_positive_signEv = Module["__ZNKSt3__210moneypunctIcLb1EE16do_positive_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE16do_positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE16do_negative_signEv = Module["__ZNKSt3__210moneypunctIcLb1EE16do_negative_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE16do_negative_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE14do_frac_digitsEv = Module["__ZNKSt3__210moneypunctIcLb1EE14do_frac_digitsEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE14do_frac_digitsEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE13do_pos_formatEv = Module["__ZNKSt3__210moneypunctIcLb1EE13do_pos_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE13do_pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE13do_neg_formatEv = Module["__ZNKSt3__210moneypunctIcLb1EE13do_neg_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE13do_neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE16do_decimal_pointEv = Module["__ZNKSt3__210moneypunctIwLb0EE16do_decimal_pointEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE16do_decimal_pointEv");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIwE3maxEv = Module["__ZNSt3__214numeric_limitsIwE3maxEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIwE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIwLb1EE3maxEv = Module["__ZNSt3__223__libcpp_numeric_limitsIwLb1EE3maxEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIwLb1EE3maxEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE16do_thousands_sepEv = Module["__ZNKSt3__210moneypunctIwLb0EE16do_thousands_sepEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE16do_thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE11do_groupingEv = Module["__ZNKSt3__210moneypunctIwLb0EE11do_groupingEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE11do_groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE14do_curr_symbolEv = Module["__ZNKSt3__210moneypunctIwLb0EE14do_curr_symbolEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE14do_curr_symbolEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2Ev = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2Ev"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__zeroEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__zeroEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__zeroEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE16do_positive_signEv = Module["__ZNKSt3__210moneypunctIwLb0EE16do_positive_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE16do_positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE16do_negative_signEv = Module["__ZNKSt3__210moneypunctIwLb0EE16do_negative_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE16do_negative_signEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initEmw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initEmw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initEmw");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE14do_frac_digitsEv = Module["__ZNKSt3__210moneypunctIwLb0EE14do_frac_digitsEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE14do_frac_digitsEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE13do_pos_formatEv = Module["__ZNKSt3__210moneypunctIwLb0EE13do_pos_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE13do_pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE13do_neg_formatEv = Module["__ZNKSt3__210moneypunctIwLb0EE13do_neg_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE13do_neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE16do_decimal_pointEv = Module["__ZNKSt3__210moneypunctIwLb1EE16do_decimal_pointEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE16do_decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE16do_thousands_sepEv = Module["__ZNKSt3__210moneypunctIwLb1EE16do_thousands_sepEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE16do_thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE11do_groupingEv = Module["__ZNKSt3__210moneypunctIwLb1EE11do_groupingEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE11do_groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE14do_curr_symbolEv = Module["__ZNKSt3__210moneypunctIwLb1EE14do_curr_symbolEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE14do_curr_symbolEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE16do_positive_signEv = Module["__ZNKSt3__210moneypunctIwLb1EE16do_positive_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE16do_positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE16do_negative_signEv = Module["__ZNKSt3__210moneypunctIwLb1EE16do_negative_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE16do_negative_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE14do_frac_digitsEv = Module["__ZNKSt3__210moneypunctIwLb1EE14do_frac_digitsEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE14do_frac_digitsEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE13do_pos_formatEv = Module["__ZNKSt3__210moneypunctIwLb1EE13do_pos_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE13do_pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE13do_neg_formatEv = Module["__ZNKSt3__210moneypunctIwLb1EE13do_neg_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE13do_neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb0EE16do_decimal_pointEv = Module["__ZNKSt3__217moneypunct_bynameIcLb0EE16do_decimal_pointEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb0EE16do_decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb0EE16do_thousands_sepEv = Module["__ZNKSt3__217moneypunct_bynameIcLb0EE16do_thousands_sepEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb0EE16do_thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb0EE11do_groupingEv = Module["__ZNKSt3__217moneypunct_bynameIcLb0EE11do_groupingEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb0EE11do_groupingEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC1ERKS5_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC1ERKS5_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC1ERKS5_");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb0EE14do_curr_symbolEv = Module["__ZNKSt3__217moneypunct_bynameIcLb0EE14do_curr_symbolEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb0EE14do_curr_symbolEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb0EE16do_positive_signEv = Module["__ZNKSt3__217moneypunct_bynameIcLb0EE16do_positive_signEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb0EE16do_positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb0EE16do_negative_signEv = Module["__ZNKSt3__217moneypunct_bynameIcLb0EE16do_negative_signEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb0EE16do_negative_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb0EE14do_frac_digitsEv = Module["__ZNKSt3__217moneypunct_bynameIcLb0EE14do_frac_digitsEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb0EE14do_frac_digitsEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb0EE13do_pos_formatEv = Module["__ZNKSt3__217moneypunct_bynameIcLb0EE13do_pos_formatEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb0EE13do_pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb0EE13do_neg_formatEv = Module["__ZNKSt3__217moneypunct_bynameIcLb0EE13do_neg_formatEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb0EE13do_neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb1EE16do_decimal_pointEv = Module["__ZNKSt3__217moneypunct_bynameIcLb1EE16do_decimal_pointEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb1EE16do_decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb1EE16do_thousands_sepEv = Module["__ZNKSt3__217moneypunct_bynameIcLb1EE16do_thousands_sepEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb1EE16do_thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb1EE11do_groupingEv = Module["__ZNKSt3__217moneypunct_bynameIcLb1EE11do_groupingEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb1EE11do_groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb1EE14do_curr_symbolEv = Module["__ZNKSt3__217moneypunct_bynameIcLb1EE14do_curr_symbolEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb1EE14do_curr_symbolEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb1EE16do_positive_signEv = Module["__ZNKSt3__217moneypunct_bynameIcLb1EE16do_positive_signEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb1EE16do_positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb1EE16do_negative_signEv = Module["__ZNKSt3__217moneypunct_bynameIcLb1EE16do_negative_signEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb1EE16do_negative_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb1EE14do_frac_digitsEv = Module["__ZNKSt3__217moneypunct_bynameIcLb1EE14do_frac_digitsEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb1EE14do_frac_digitsEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb1EE13do_pos_formatEv = Module["__ZNKSt3__217moneypunct_bynameIcLb1EE13do_pos_formatEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb1EE13do_pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIcLb1EE13do_neg_formatEv = Module["__ZNKSt3__217moneypunct_bynameIcLb1EE13do_neg_formatEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIcLb1EE13do_neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb0EE16do_decimal_pointEv = Module["__ZNKSt3__217moneypunct_bynameIwLb0EE16do_decimal_pointEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb0EE16do_decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb0EE16do_thousands_sepEv = Module["__ZNKSt3__217moneypunct_bynameIwLb0EE16do_thousands_sepEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb0EE16do_thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb0EE11do_groupingEv = Module["__ZNKSt3__217moneypunct_bynameIwLb0EE11do_groupingEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb0EE11do_groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb0EE14do_curr_symbolEv = Module["__ZNKSt3__217moneypunct_bynameIwLb0EE14do_curr_symbolEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb0EE14do_curr_symbolEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC1ERKS5_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC1ERKS5_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC1ERKS5_");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb0EE16do_positive_signEv = Module["__ZNKSt3__217moneypunct_bynameIwLb0EE16do_positive_signEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb0EE16do_positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb0EE16do_negative_signEv = Module["__ZNKSt3__217moneypunct_bynameIwLb0EE16do_negative_signEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb0EE16do_negative_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb0EE14do_frac_digitsEv = Module["__ZNKSt3__217moneypunct_bynameIwLb0EE14do_frac_digitsEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb0EE14do_frac_digitsEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb0EE13do_pos_formatEv = Module["__ZNKSt3__217moneypunct_bynameIwLb0EE13do_pos_formatEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb0EE13do_pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb0EE13do_neg_formatEv = Module["__ZNKSt3__217moneypunct_bynameIwLb0EE13do_neg_formatEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb0EE13do_neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb1EE16do_decimal_pointEv = Module["__ZNKSt3__217moneypunct_bynameIwLb1EE16do_decimal_pointEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb1EE16do_decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb1EE16do_thousands_sepEv = Module["__ZNKSt3__217moneypunct_bynameIwLb1EE16do_thousands_sepEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb1EE16do_thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb1EE11do_groupingEv = Module["__ZNKSt3__217moneypunct_bynameIwLb1EE11do_groupingEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb1EE11do_groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb1EE14do_curr_symbolEv = Module["__ZNKSt3__217moneypunct_bynameIwLb1EE14do_curr_symbolEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb1EE14do_curr_symbolEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb1EE16do_positive_signEv = Module["__ZNKSt3__217moneypunct_bynameIwLb1EE16do_positive_signEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb1EE16do_positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb1EE16do_negative_signEv = Module["__ZNKSt3__217moneypunct_bynameIwLb1EE16do_negative_signEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb1EE16do_negative_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb1EE14do_frac_digitsEv = Module["__ZNKSt3__217moneypunct_bynameIwLb1EE14do_frac_digitsEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb1EE14do_frac_digitsEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb1EE13do_pos_formatEv = Module["__ZNKSt3__217moneypunct_bynameIwLb1EE13do_pos_formatEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb1EE13do_pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__217moneypunct_bynameIwLb1EE13do_neg_formatEv = Module["__ZNKSt3__217moneypunct_bynameIwLb1EE13do_neg_formatEv"] = createExportWrapper("_ZNKSt3__217moneypunct_bynameIwLb1EE13do_neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_bRNS_8ios_baseERjRe = Module["__ZNKSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_bRNS_8ios_baseERjRe"] = createExportWrapper("_ZNKSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_bRNS_8ios_baseERjRe");

/** @type {function(...*):?} */
var __ZNSt3__212__do_nothingEPv = Module["__ZNSt3__212__do_nothingEPv"] = createExportWrapper("_ZNSt3__212__do_nothingEPv");

/** @type {function(...*):?} */
var __ZNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE8__do_getERS4_S4_bRKNS_6localeEjRjRbRKNS_5ctypeIcEERNS_10unique_ptrIcPFvPvEEERPcSM_ = Module["__ZNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE8__do_getERS4_S4_bRKNS_6localeEjRjRbRKNS_5ctypeIcEERNS_10unique_ptrIcPFvPvEEERPcSM_"] = createExportWrapper("_ZNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE8__do_getERS4_S4_bRKNS_6localeEjRjRbRKNS_5ctypeIcEERNS_10unique_ptrIcPFvPvEEERPcSM_");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrIcPFvPvEE3getEv = Module["__ZNKSt3__210unique_ptrIcPFvPvEE3getEv"] = createExportWrapper("_ZNKSt3__210unique_ptrIcPFvPvEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__23endIcLm10EEEPT_RAT0__S1_ = Module["__ZNSt3__23endIcLm10EEEPT_RAT0__S1_"] = createExportWrapper("_ZNSt3__23endIcLm10EEEPT_RAT0__S1_");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIjPFvPvEEC2ILb1EvEEPjNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrIjPFvPvEEC2ILb1EvEEPjNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrIjPFvPvEEC2ILb1EvEEPjNS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS3_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrIjPFvPvEE3getEv = Module["__ZNKSt3__210unique_ptrIjPFvPvEE3getEv"] = createExportWrapper("_ZNKSt3__210unique_ptrIjPFvPvEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__211__money_getIcE13__gather_infoEbRKNS_6localeERNS_10money_base7patternERcS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEESF_SF_SF_Ri = Module["__ZNSt3__211__money_getIcE13__gather_infoEbRKNS_6localeERNS_10money_base7patternERcS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEESF_SF_SF_Ri"] = createExportWrapper("_ZNSt3__211__money_getIcE13__gather_infoEbRKNS_6localeERNS_10money_base7patternERcS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEESF_SF_SF_Ri");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEppEi = Module["__ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEppEi"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEEppEi");

/** @type {function(...*):?} */
var __ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE7__proxydeEv = Module["__ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE7__proxydeEv"] = createExportWrapper("_ZNKSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE7__proxydeEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE9push_backEc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE9push_backEc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE9push_backEc");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPKcEC2IPcEERKNS0_IT_EEPNS_9enable_ifIXsr14is_convertibleIS6_S2_EE5valueEvE4typeE = Module["__ZNSt3__211__wrap_iterIPKcEC2IPcEERKNS0_IT_EEPNS_9enable_ifIXsr14is_convertibleIS6_S2_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__211__wrap_iterIPKcEC2IPcEERKNS0_IT_EEPNS_9enable_ifIXsr14is_convertibleIS6_S2_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__2neIPKcPcEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE = Module["__ZNSt3__2neIPKcPcEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE"] = createExportWrapper("_ZNSt3__2neIPKcPcEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPKcEdeEv = Module["__ZNKSt3__211__wrap_iterIPKcEdeEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPKcEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPKcEppEv = Module["__ZNSt3__211__wrap_iterIPKcEppEv"] = createExportWrapper("_ZNSt3__211__wrap_iterIPKcEppEv");

/** @type {function(...*):?} */
var __ZNSt3__2miIPKcPcEEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS5_IT0_EE = Module["__ZNSt3__2miIPKcPcEEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS5_IT0_EE"] = createExportWrapper("_ZNSt3__2miIPKcPcEEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS5_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPcEmiEl = Module["__ZNKSt3__211__wrap_iterIPcEmiEl"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPcEmiEl");

/** @type {function(...*):?} */
var __ZNSt3__25equalINS_11__wrap_iterIPcEES3_EEbT_S4_T0_ = Module["__ZNSt3__25equalINS_11__wrap_iterIPcEES3_EEbT_S4_T0_"] = createExportWrapper("_ZNSt3__25equalINS_11__wrap_iterIPcEES3_EEbT_S4_T0_");

/** @type {function(...*):?} */
var __ZNSt3__219__double_or_nothingIcEEvRNS_10unique_ptrIT_PFvPvEEERPS2_S9_ = Module["__ZNSt3__219__double_or_nothingIcEEvRNS_10unique_ptrIT_PFvPvEEERPS2_S9_"] = createExportWrapper("_ZNSt3__219__double_or_nothingIcEEvRNS_10unique_ptrIT_PFvPvEEERPS2_S9_");

/** @type {function(...*):?} */
var __ZNSt3__219__double_or_nothingIjEEvRNS_10unique_ptrIT_PFvPvEEERPS2_S9_ = Module["__ZNSt3__219__double_or_nothingIjEEvRNS_10unique_ptrIT_PFvPvEEERPS2_S9_"] = createExportWrapper("_ZNSt3__219__double_or_nothingIjEEvRNS_10unique_ptrIT_PFvPvEEERPS2_S9_");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIjPFvPvEED2Ev = Module["__ZNSt3__210unique_ptrIjPFvPvEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrIjPFvPvEED2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPcPFvPvEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPcPFvPvEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPcPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_bRNS_8ios_baseERjRNS_12basic_stringIcS3_NS_9allocatorIcEEEE = Module["__ZNKSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_bRNS_8ios_baseERjRNS_12basic_stringIcS3_NS_9allocatorIcEEEE"] = createExportWrapper("_ZNKSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_getES4_S4_bRNS_8ios_baseERjRNS_12basic_stringIcS3_NS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5clearEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5clearEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5clearEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendIPcEENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr38__libcpp_string_gets_noexcept_iteratorIS9_EE5valueERS5_E4typeES9_S9_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendIPcEENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr38__libcpp_string_gets_noexcept_iteratorIS9_EE5valueERS5_E4typeES9_S9_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendIPcEENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr38__libcpp_string_gets_noexcept_iteratorIS9_EE5valueERS5_E4typeES9_S9_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE26__invalidate_all_iteratorsEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE26__invalidate_all_iteratorsEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE26__invalidate_all_iteratorsEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE18__get_long_pointerEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE18__get_long_pointerEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE18__get_long_pointerEv");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE6assignERcRKc = Module["__ZNSt3__211char_traitsIcE6assignERcRKc"] = createExportWrapper("_ZNSt3__211char_traitsIcE6assignERcRKc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE15__set_long_sizeEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE15__set_long_sizeEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE15__set_long_sizeEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__get_short_pointerEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__get_short_pointerEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__get_short_pointerEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE16__set_short_sizeEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE16__set_short_sizeEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE16__set_short_sizeEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE23__append_forward_unsafeIPcEERS5_T_S9_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE23__append_forward_unsafeIPcEERS5_T_S9_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE23__append_forward_unsafeIPcEERS5_T_S9_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPjPFvPvEEC2IRS1_S4_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPjPFvPvEEC2IRS1_S4_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPjPFvPvEEC2IRS1_S4_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPjPFvPvEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPjPFvPvEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPjPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_10moneypunctIcLb1EEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_10moneypunctIcLb1EEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_10moneypunctIcLb1EEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE10neg_formatEv = Module["__ZNKSt3__210moneypunctIcLb1EE10neg_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE10neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE13negative_signEv = Module["__ZNKSt3__210moneypunctIcLb1EE13negative_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE13negative_signEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSEOS5_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSEOS5_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSEOS5_");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE13positive_signEv = Module["__ZNKSt3__210moneypunctIcLb1EE13positive_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE13positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE13decimal_pointEv = Module["__ZNKSt3__210moneypunctIcLb1EE13decimal_pointEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE13decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE13thousands_sepEv = Module["__ZNKSt3__210moneypunctIcLb1EE13thousands_sepEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE13thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE8groupingEv = Module["__ZNKSt3__210moneypunctIcLb1EE8groupingEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE8groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE11curr_symbolEv = Module["__ZNKSt3__210moneypunctIcLb1EE11curr_symbolEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE11curr_symbolEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE11frac_digitsEv = Module["__ZNKSt3__210moneypunctIcLb1EE11frac_digitsEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE11frac_digitsEv");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_10moneypunctIcLb0EEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_10moneypunctIcLb0EEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_10moneypunctIcLb0EEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE10neg_formatEv = Module["__ZNKSt3__210moneypunctIcLb0EE10neg_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE10neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE13negative_signEv = Module["__ZNKSt3__210moneypunctIcLb0EE13negative_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE13negative_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE13positive_signEv = Module["__ZNKSt3__210moneypunctIcLb0EE13positive_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE13positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE13decimal_pointEv = Module["__ZNKSt3__210moneypunctIcLb0EE13decimal_pointEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE13decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE13thousands_sepEv = Module["__ZNKSt3__210moneypunctIcLb0EE13thousands_sepEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE13thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE8groupingEv = Module["__ZNKSt3__210moneypunctIcLb0EE8groupingEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE8groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE11curr_symbolEv = Module["__ZNKSt3__210moneypunctIcLb0EE11curr_symbolEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE11curr_symbolEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE11frac_digitsEv = Module["__ZNKSt3__210moneypunctIcLb0EE11frac_digitsEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE11frac_digitsEv");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE7__proxyC2EcPNS_15basic_streambufIcS2_EE = Module["__ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE7__proxyC2EcPNS_15basic_streambufIcS2_EE"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIcNS_11char_traitsIcEEE7__proxyC2EcPNS_15basic_streambufIcS2_EE");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPcE4baseEv = Module["__ZNKSt3__211__wrap_iterIPcE4baseEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPcE4baseEv");

/** @type {function(...*):?} */
var __ZNSt3__2eqIPKcPcEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE = Module["__ZNSt3__2eqIPKcPcEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE"] = createExportWrapper("_ZNSt3__2eqIPKcPcEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPKcE4baseEv = Module["__ZNKSt3__211__wrap_iterIPKcE4baseEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPKcE4baseEv");

/** @type {function(...*):?} */
var __ZNSt3__25equalINS_11__wrap_iterIPcEES3_NS_10__equal_toIccEEEEbT_S6_T0_T1_ = Module["__ZNSt3__25equalINS_11__wrap_iterIPcEES3_NS_10__equal_toIccEEEEbT_S6_T0_T1_"] = createExportWrapper("_ZNSt3__25equalINS_11__wrap_iterIPcEES3_NS_10__equal_toIccEEEEbT_S6_T0_T1_");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPcEplEl = Module["__ZNKSt3__211__wrap_iterIPcEplEl"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPcEplEl");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIcPFvPvEE11get_deleterEv = Module["__ZNSt3__210unique_ptrIcPFvPvEE11get_deleterEv"] = createExportWrapper("_ZNSt3__210unique_ptrIcPFvPvEE11get_deleterEv");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsImE3maxEv = Module["__ZNSt3__214numeric_limitsImE3maxEv"] = createExportWrapper("_ZNSt3__214numeric_limitsImE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIcPFvPvEE7releaseEv = Module["__ZNSt3__210unique_ptrIcPFvPvEE7releaseEv"] = createExportWrapper("_ZNSt3__210unique_ptrIcPFvPvEE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIcPFvPvEEaSEOS4_ = Module["__ZNSt3__210unique_ptrIcPFvPvEEaSEOS4_"] = createExportWrapper("_ZNSt3__210unique_ptrIcPFvPvEEaSEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIjPFvPvEE11get_deleterEv = Module["__ZNSt3__210unique_ptrIjPFvPvEE11get_deleterEv"] = createExportWrapper("_ZNSt3__210unique_ptrIjPFvPvEE11get_deleterEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIjPFvPvEE7releaseEv = Module["__ZNSt3__210unique_ptrIjPFvPvEE7releaseEv"] = createExportWrapper("_ZNSt3__210unique_ptrIjPFvPvEE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIjPFvPvEEaSEOS4_ = Module["__ZNSt3__210unique_ptrIjPFvPvEEaSEOS4_"] = createExportWrapper("_ZNSt3__210unique_ptrIjPFvPvEEaSEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__27reverseIPjEEvT_S2_ = Module["__ZNSt3__27reverseIPjEEvT_S2_"] = createExportWrapper("_ZNSt3__27reverseIPjEEvT_S2_");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIjPFvPvEE5resetEPj = Module["__ZNSt3__210unique_ptrIjPFvPvEE5resetEPj"] = createExportWrapper("_ZNSt3__210unique_ptrIjPFvPvEE5resetEPj");

/** @type {function(...*):?} */
var __ZNKSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_bRNS_8ios_baseERjRe = Module["__ZNKSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_bRNS_8ios_baseERjRe"] = createExportWrapper("_ZNKSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_bRNS_8ios_baseERjRe");

/** @type {function(...*):?} */
var __ZNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE8__do_getERS4_S4_bRKNS_6localeEjRjRbRKNS_5ctypeIwEERNS_10unique_ptrIwPFvPvEEERPwSM_ = Module["__ZNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE8__do_getERS4_S4_bRKNS_6localeEjRjRbRKNS_5ctypeIwEERNS_10unique_ptrIwPFvPvEEERPwSM_"] = createExportWrapper("_ZNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE8__do_getERS4_S4_bRKNS_6localeEjRjRbRKNS_5ctypeIwEERNS_10unique_ptrIwPFvPvEEERPwSM_");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrIwPFvPvEE3getEv = Module["__ZNKSt3__210unique_ptrIwPFvPvEE3getEv"] = createExportWrapper("_ZNKSt3__210unique_ptrIwPFvPvEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__23endIwLm10EEEPT_RAT0__S1_ = Module["__ZNSt3__23endIwLm10EEEPT_RAT0__S1_"] = createExportWrapper("_ZNSt3__23endIwLm10EEEPT_RAT0__S1_");

/** @type {function(...*):?} */
var __ZNSt3__211__money_getIwE13__gather_infoEbRKNS_6localeERNS_10money_base7patternERwS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERNS9_IwNSA_IwEENSC_IwEEEESJ_SJ_Ri = Module["__ZNSt3__211__money_getIwE13__gather_infoEbRKNS_6localeERNS_10money_base7patternERwS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERNS9_IwNSA_IwEENSC_IwEEEESJ_SJ_Ri"] = createExportWrapper("_ZNSt3__211__money_getIwE13__gather_infoEbRKNS_6localeERNS_10money_base7patternERwS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERNS9_IwNSA_IwEENSC_IwEEEESJ_SJ_Ri");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEppEi = Module["__ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEppEi"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEEppEi");

/** @type {function(...*):?} */
var __ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE7__proxydeEv = Module["__ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE7__proxydeEv"] = createExportWrapper("_ZNKSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE7__proxydeEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE9push_backEw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE9push_backEw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE9push_backEw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEixEm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEixEm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEixEm");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPKwEC2IPwEERKNS0_IT_EEPNS_9enable_ifIXsr14is_convertibleIS6_S2_EE5valueEvE4typeE = Module["__ZNSt3__211__wrap_iterIPKwEC2IPwEERKNS0_IT_EEPNS_9enable_ifIXsr14is_convertibleIS6_S2_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__211__wrap_iterIPKwEC2IPwEERKNS0_IT_EEPNS_9enable_ifIXsr14is_convertibleIS6_S2_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__2neIPKwPwEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE = Module["__ZNSt3__2neIPKwPwEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE"] = createExportWrapper("_ZNSt3__2neIPKwPwEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPKwEdeEv = Module["__ZNKSt3__211__wrap_iterIPKwEdeEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPKwEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPKwEppEv = Module["__ZNSt3__211__wrap_iterIPKwEppEv"] = createExportWrapper("_ZNSt3__211__wrap_iterIPKwEppEv");

/** @type {function(...*):?} */
var __ZNSt3__2miIPKwPwEEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS5_IT0_EE = Module["__ZNSt3__2miIPKwPwEEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS5_IT0_EE"] = createExportWrapper("_ZNSt3__2miIPKwPwEEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS5_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPwEmiEl = Module["__ZNKSt3__211__wrap_iterIPwEmiEl"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPwEmiEl");

/** @type {function(...*):?} */
var __ZNSt3__25equalINS_11__wrap_iterIPwEES3_EEbT_S4_T0_ = Module["__ZNSt3__25equalINS_11__wrap_iterIPwEES3_EEbT_S4_T0_"] = createExportWrapper("_ZNSt3__25equalINS_11__wrap_iterIPwEES3_EEbT_S4_T0_");

/** @type {function(...*):?} */
var __ZNSt3__219__double_or_nothingIwEEvRNS_10unique_ptrIT_PFvPvEEERPS2_S9_ = Module["__ZNSt3__219__double_or_nothingIwEEvRNS_10unique_ptrIT_PFvPvEEERPS2_S9_"] = createExportWrapper("_ZNSt3__219__double_or_nothingIwEEvRNS_10unique_ptrIT_PFvPvEEERPS2_S9_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPwPFvPvEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPwPFvPvEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPwPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_bRNS_8ios_baseERjRNS_12basic_stringIwS3_NS_9allocatorIwEEEE = Module["__ZNKSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_bRNS_8ios_baseERjRNS_12basic_stringIwS3_NS_9allocatorIwEEEE"] = createExportWrapper("_ZNKSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_getES4_S4_bRNS_8ios_baseERjRNS_12basic_stringIwS3_NS_9allocatorIwEEEE");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5clearEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5clearEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5clearEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendIPwEENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr38__libcpp_string_gets_noexcept_iteratorIS9_EE5valueERS5_E4typeES9_S9_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendIPwEENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr38__libcpp_string_gets_noexcept_iteratorIS9_EE5valueERS5_E4typeES9_S9_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendIPwEENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr38__libcpp_string_gets_noexcept_iteratorIS9_EE5valueERS5_E4typeES9_S9_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE26__invalidate_all_iteratorsEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE26__invalidate_all_iteratorsEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE26__invalidate_all_iteratorsEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE18__get_long_pointerEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE18__get_long_pointerEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE18__get_long_pointerEv");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE6assignERwRKw = Module["__ZNSt3__211char_traitsIwE6assignERwRKw"] = createExportWrapper("_ZNSt3__211char_traitsIwE6assignERwRKw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE15__set_long_sizeEm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE15__set_long_sizeEm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE15__set_long_sizeEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__get_short_pointerEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__get_short_pointerEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__get_short_pointerEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE16__set_short_sizeEm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE16__set_short_sizeEm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE16__set_short_sizeEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE23__append_forward_unsafeIPwEERS5_T_S9_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE23__append_forward_unsafeIPwEERS5_T_S9_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE23__append_forward_unsafeIPwEERS5_T_S9_");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_10moneypunctIwLb1EEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_10moneypunctIwLb1EEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_10moneypunctIwLb1EEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE10neg_formatEv = Module["__ZNKSt3__210moneypunctIwLb1EE10neg_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE10neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE13negative_signEv = Module["__ZNKSt3__210moneypunctIwLb1EE13negative_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE13negative_signEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSEOS5_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSEOS5_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSEOS5_");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE13positive_signEv = Module["__ZNKSt3__210moneypunctIwLb1EE13positive_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE13positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE13decimal_pointEv = Module["__ZNKSt3__210moneypunctIwLb1EE13decimal_pointEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE13decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE13thousands_sepEv = Module["__ZNKSt3__210moneypunctIwLb1EE13thousands_sepEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE13thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE8groupingEv = Module["__ZNKSt3__210moneypunctIwLb1EE8groupingEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE8groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE11curr_symbolEv = Module["__ZNKSt3__210moneypunctIwLb1EE11curr_symbolEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE11curr_symbolEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE11frac_digitsEv = Module["__ZNKSt3__210moneypunctIwLb1EE11frac_digitsEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE11frac_digitsEv");

/** @type {function(...*):?} */
var __ZNSt3__29use_facetINS_10moneypunctIwLb0EEEEERKT_RKNS_6localeE = Module["__ZNSt3__29use_facetINS_10moneypunctIwLb0EEEEERKT_RKNS_6localeE"] = createExportWrapper("_ZNSt3__29use_facetINS_10moneypunctIwLb0EEEEERKT_RKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE10neg_formatEv = Module["__ZNKSt3__210moneypunctIwLb0EE10neg_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE10neg_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE13negative_signEv = Module["__ZNKSt3__210moneypunctIwLb0EE13negative_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE13negative_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE13positive_signEv = Module["__ZNKSt3__210moneypunctIwLb0EE13positive_signEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE13positive_signEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE13decimal_pointEv = Module["__ZNKSt3__210moneypunctIwLb0EE13decimal_pointEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE13decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE13thousands_sepEv = Module["__ZNKSt3__210moneypunctIwLb0EE13thousands_sepEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE13thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE8groupingEv = Module["__ZNKSt3__210moneypunctIwLb0EE8groupingEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE8groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE11curr_symbolEv = Module["__ZNKSt3__210moneypunctIwLb0EE11curr_symbolEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE11curr_symbolEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE11frac_digitsEv = Module["__ZNKSt3__210moneypunctIwLb0EE11frac_digitsEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE11frac_digitsEv");

/** @type {function(...*):?} */
var __ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE7__proxyC2EwPNS_15basic_streambufIwS2_EE = Module["__ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE7__proxyC2EwPNS_15basic_streambufIwS2_EE"] = createExportWrapper("_ZNSt3__219istreambuf_iteratorIwNS_11char_traitsIwEEE7__proxyC2EwPNS_15basic_streambufIwS2_EE");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPwE4baseEv = Module["__ZNKSt3__211__wrap_iterIPwE4baseEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPwE4baseEv");

/** @type {function(...*):?} */
var __ZNSt3__2eqIPKwPwEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE = Module["__ZNSt3__2eqIPKwPwEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE"] = createExportWrapper("_ZNSt3__2eqIPKwPwEEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPKwE4baseEv = Module["__ZNKSt3__211__wrap_iterIPKwE4baseEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPKwE4baseEv");

/** @type {function(...*):?} */
var __ZNSt3__25equalINS_11__wrap_iterIPwEES3_NS_10__equal_toIwwEEEEbT_S6_T0_T1_ = Module["__ZNSt3__25equalINS_11__wrap_iterIPwEES3_NS_10__equal_toIwwEEEEbT_S6_T0_T1_"] = createExportWrapper("_ZNSt3__25equalINS_11__wrap_iterIPwEES3_NS_10__equal_toIwwEEEEbT_S6_T0_T1_");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPwEplEl = Module["__ZNKSt3__211__wrap_iterIPwEplEl"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPwEplEl");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIwPFvPvEE11get_deleterEv = Module["__ZNSt3__210unique_ptrIwPFvPvEE11get_deleterEv"] = createExportWrapper("_ZNSt3__210unique_ptrIwPFvPvEE11get_deleterEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIwPFvPvEE7releaseEv = Module["__ZNSt3__210unique_ptrIwPFvPvEE7releaseEv"] = createExportWrapper("_ZNSt3__210unique_ptrIwPFvPvEE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIwPFvPvEEaSEOS4_ = Module["__ZNSt3__210unique_ptrIwPFvPvEEaSEOS4_"] = createExportWrapper("_ZNSt3__210unique_ptrIwPFvPvEEaSEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13__move_assignERS5_NS_17integral_constantIbLb1EEE = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13__move_assignERS5_NS_17integral_constantIbLb1EEE"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13__move_assignERS5_NS_17integral_constantIbLb1EEE");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13__move_assignERS5_NS_17integral_constantIbLb1EEE = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13__move_assignERS5_NS_17integral_constantIbLb1EEE"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13__move_assignERS5_NS_17integral_constantIbLb1EEE");

/** @type {function(...*):?} */
var __ZNKSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_bRNS_8ios_baseEce = Module["__ZNKSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_bRNS_8ios_baseEce"] = createExportWrapper("_ZNKSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_bRNS_8ios_baseEce");

/** @type {function(...*):?} */
var __ZNSt3__2eqIcPFvPvEEEbRKNS_10unique_ptrIT_T0_EEDn = Module["__ZNSt3__2eqIcPFvPvEEEbRKNS_10unique_ptrIT_T0_EEDn"] = createExportWrapper("_ZNSt3__2eqIcPFvPvEEEbRKNS_10unique_ptrIT_T0_EEDn");

/** @type {function(...*):?} */
var __ZNSt3__211__money_putIcE13__gather_infoEbbRKNS_6localeERNS_10money_base7patternERcS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEESF_SF_Ri = Module["__ZNSt3__211__money_putIcE13__gather_infoEbbRKNS_6localeERNS_10money_base7patternERcS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEESF_SF_Ri"] = createExportWrapper("_ZNSt3__211__money_putIcE13__gather_infoEbbRKNS_6localeERNS_10money_base7patternERcS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEESF_SF_Ri");

/** @type {function(...*):?} */
var __ZNSt3__211__money_putIcE8__formatEPcRS2_S3_jPKcS5_RKNS_5ctypeIcEEbRKNS_10money_base7patternEccRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEESL_SL_i = Module["__ZNSt3__211__money_putIcE8__formatEPcRS2_S3_jPKcS5_RKNS_5ctypeIcEEbRKNS_10money_base7patternEccRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEESL_SL_i"] = createExportWrapper("_ZNSt3__211__money_putIcE8__formatEPcRS2_S3_jPKcS5_RKNS_5ctypeIcEEbRKNS_10money_base7patternEccRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEESL_SL_i");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrIcPFvPvEEcvbEv = Module["__ZNKSt3__210unique_ptrIcPFvPvEEcvbEv"] = createExportWrapper("_ZNKSt3__210unique_ptrIcPFvPvEEcvbEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb1EE10pos_formatEv = Module["__ZNKSt3__210moneypunctIcLb1EE10pos_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb1EE10pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIcLb0EE10pos_formatEv = Module["__ZNKSt3__210moneypunctIcLb0EE10pos_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIcLb0EE10pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5beginEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5beginEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5beginEv");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPKcEplEl = Module["__ZNKSt3__211__wrap_iterIPKcEplEl"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPKcEplEl");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE3endEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE3endEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE3endEv");

/** @type {function(...*):?} */
var __ZNSt3__24copyINS_11__wrap_iterIPKcEEPcEET0_T_S7_S6_ = Module["__ZNSt3__24copyINS_11__wrap_iterIPKcEEPcEET0_T_S7_S6_"] = createExportWrapper("_ZNSt3__24copyINS_11__wrap_iterIPKcEEPcEET0_T_S7_S6_");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIjE3maxEv = Module["__ZNSt3__214numeric_limitsIjE3maxEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIjE3maxEv");

/** @type {function(...*):?} */
var __ZNKSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_bRNS_8ios_baseEcRKNS_12basic_stringIcS3_NS_9allocatorIcEEEE = Module["__ZNKSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_bRNS_8ios_baseEcRKNS_12basic_stringIcS3_NS_9allocatorIcEEEE"] = createExportWrapper("_ZNKSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE6do_putES4_bRNS_8ios_baseEcRKNS_12basic_stringIcS3_NS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNKSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_bRNS_8ios_baseEwe = Module["__ZNKSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_bRNS_8ios_baseEwe"] = createExportWrapper("_ZNKSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_bRNS_8ios_baseEwe");

/** @type {function(...*):?} */
var __ZNSt3__2eqIwPFvPvEEEbRKNS_10unique_ptrIT_T0_EEDn = Module["__ZNSt3__2eqIwPFvPvEEEbRKNS_10unique_ptrIT_T0_EEDn"] = createExportWrapper("_ZNSt3__2eqIwPFvPvEEEbRKNS_10unique_ptrIT_T0_EEDn");

/** @type {function(...*):?} */
var __ZNSt3__211__money_putIwE13__gather_infoEbbRKNS_6localeERNS_10money_base7patternERwS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERNS9_IwNSA_IwEENSC_IwEEEESJ_Ri = Module["__ZNSt3__211__money_putIwE13__gather_infoEbbRKNS_6localeERNS_10money_base7patternERwS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERNS9_IwNSA_IwEENSC_IwEEEESJ_Ri"] = createExportWrapper("_ZNSt3__211__money_putIwE13__gather_infoEbbRKNS_6localeERNS_10money_base7patternERwS8_RNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERNS9_IwNSA_IwEENSC_IwEEEESJ_Ri");

/** @type {function(...*):?} */
var __ZNSt3__211__money_putIwE8__formatEPwRS2_S3_jPKwS5_RKNS_5ctypeIwEEbRKNS_10money_base7patternEwwRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNSE_IwNSF_IwEENSH_IwEEEESQ_i = Module["__ZNSt3__211__money_putIwE8__formatEPwRS2_S3_jPKwS5_RKNS_5ctypeIwEEbRKNS_10money_base7patternEwwRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNSE_IwNSF_IwEENSH_IwEEEESQ_i"] = createExportWrapper("_ZNSt3__211__money_putIwE8__formatEPwRS2_S3_jPKwS5_RKNS_5ctypeIwEEbRKNS_10money_base7patternEwwRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNSE_IwNSF_IwEENSH_IwEEEESQ_i");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrIwPFvPvEEcvbEv = Module["__ZNKSt3__210unique_ptrIwPFvPvEEcvbEv"] = createExportWrapper("_ZNKSt3__210unique_ptrIwPFvPvEEcvbEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb1EE10pos_formatEv = Module["__ZNKSt3__210moneypunctIwLb1EE10pos_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb1EE10pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__210moneypunctIwLb0EE10pos_formatEv = Module["__ZNKSt3__210moneypunctIwLb0EE10pos_formatEv"] = createExportWrapper("_ZNKSt3__210moneypunctIwLb0EE10pos_formatEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5beginEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5beginEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5beginEv");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPKwEplEl = Module["__ZNKSt3__211__wrap_iterIPKwEplEl"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPKwEplEl");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE3endEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE3endEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE3endEv");

/** @type {function(...*):?} */
var __ZNSt3__24copyINS_11__wrap_iterIPKwEEPwEET0_T_S7_S6_ = Module["__ZNSt3__24copyINS_11__wrap_iterIPKwEEPwEET0_T_S7_S6_"] = createExportWrapper("_ZNSt3__24copyINS_11__wrap_iterIPKwEEPwEET0_T_S7_S6_");

/** @type {function(...*):?} */
var __ZNKSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_bRNS_8ios_baseEwRKNS_12basic_stringIwS3_NS_9allocatorIwEEEE = Module["__ZNKSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_bRNS_8ios_baseEwRKNS_12basic_stringIwS3_NS_9allocatorIwEEEE"] = createExportWrapper("_ZNKSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE6do_putES4_bRNS_8ios_baseEwRKNS_12basic_stringIwS3_NS_9allocatorIwEEEE");

/** @type {function(...*):?} */
var __ZNSt3__213__unwrap_iterIcEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPKS2_E4typeENS_11__wrap_iterIS4_EE = Module["__ZNSt3__213__unwrap_iterIcEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPKS2_E4typeENS_11__wrap_iterIS4_EE"] = createExportWrapper("_ZNSt3__213__unwrap_iterIcEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPKS2_E4typeENS_11__wrap_iterIS4_EE");

/** @type {function(...*):?} */
var __ZNSt3__26__copyIKccEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS7_EE5valueEPS7_E4typeEPS4_SB_S8_ = Module["__ZNSt3__26__copyIKccEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS7_EE5valueEPS7_E4typeEPS4_SB_S8_"] = createExportWrapper("_ZNSt3__26__copyIKccEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS7_EE5valueEPS7_E4typeEPS4_SB_S8_");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPKcEC2ES2_ = Module["__ZNSt3__211__wrap_iterIPKcEC2ES2_"] = createExportWrapper("_ZNSt3__211__wrap_iterIPKcEC2ES2_");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIjLb1EE3maxEv = Module["__ZNSt3__223__libcpp_numeric_limitsIjLb1EE3maxEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIjLb1EE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPKcEpLEl = Module["__ZNSt3__211__wrap_iterIPKcEpLEl"] = createExportWrapper("_ZNSt3__211__wrap_iterIPKcEpLEl");

/** @type {function(...*):?} */
var __ZNSt3__213__unwrap_iterIwEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPKS2_E4typeENS_11__wrap_iterIS4_EE = Module["__ZNSt3__213__unwrap_iterIwEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPKS2_E4typeENS_11__wrap_iterIS4_EE"] = createExportWrapper("_ZNSt3__213__unwrap_iterIwEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPKS2_E4typeENS_11__wrap_iterIS4_EE");

/** @type {function(...*):?} */
var __ZNSt3__26__copyIKwwEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS7_EE5valueEPS7_E4typeEPS4_SB_S8_ = Module["__ZNSt3__26__copyIKwwEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS7_EE5valueEPS7_E4typeEPS4_SB_S8_"] = createExportWrapper("_ZNSt3__26__copyIKwwEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS7_EE5valueEPS7_E4typeEPS4_SB_S8_");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPKwEC2ES2_ = Module["__ZNSt3__211__wrap_iterIPKwEC2ES2_"] = createExportWrapper("_ZNSt3__211__wrap_iterIPKwEC2ES2_");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPKwEpLEl = Module["__ZNSt3__211__wrap_iterIPKwEpLEl"] = createExportWrapper("_ZNSt3__211__wrap_iterIPKwEpLEl");

/** @type {function(...*):?} */
var __ZNKSt3__28messagesIcE7do_openERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_6localeE = Module["__ZNKSt3__28messagesIcE7do_openERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_6localeE"] = createExportWrapper("_ZNKSt3__28messagesIcE7do_openERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__28messagesIcE6do_getEliiRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNKSt3__28messagesIcE6do_getEliiRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNKSt3__28messagesIcE6do_getEliiRKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__213back_inserterINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_20back_insert_iteratorIT_EERS8_ = Module["__ZNSt3__213back_inserterINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_20back_insert_iteratorIT_EERS8_"] = createExportWrapper("_ZNSt3__213back_inserterINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_20back_insert_iteratorIT_EERS8_");

/** @type {function(...*):?} */
var __ZNKSt3__216__narrow_to_utf8ILm8EEclINS_20back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEcEET_SB_PKT0_SE_ = Module["__ZNKSt3__216__narrow_to_utf8ILm8EEclINS_20back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEcEET_SB_PKT0_SE_"] = createExportWrapper("_ZNKSt3__216__narrow_to_utf8ILm8EEclINS_20back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEcEET_SB_PKT0_SE_");

/** @type {function(...*):?} */
var __ZNKSt3__217__widen_from_utf8ILm8EEclINS_20back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEEET_SB_PKcSD_ = Module["__ZNKSt3__217__widen_from_utf8ILm8EEclINS_20back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEEET_SB_PKcSD_"] = createExportWrapper("_ZNKSt3__217__widen_from_utf8ILm8EEclINS_20back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEEET_SB_PKcSD_");

/** @type {function(...*):?} */
var __ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEdeEv = Module["__ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEdeEv"] = createExportWrapper("_ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEaSERKc = Module["__ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEaSERKc"] = createExportWrapper("_ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEaSERKc");

/** @type {function(...*):?} */
var __ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEppEv = Module["__ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEppEv"] = createExportWrapper("_ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEppEv");

/** @type {function(...*):?} */
var __ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEC2ERS6_ = Module["__ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEC2ERS6_"] = createExportWrapper("_ZNSt3__220back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEC2ERS6_");

/** @type {function(...*):?} */
var __ZNKSt3__28messagesIcE8do_closeEl = Module["__ZNKSt3__28messagesIcE8do_closeEl"] = createExportWrapper("_ZNKSt3__28messagesIcE8do_closeEl");

/** @type {function(...*):?} */
var __ZNKSt3__28messagesIwE7do_openERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_6localeE = Module["__ZNKSt3__28messagesIwE7do_openERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_6localeE"] = createExportWrapper("_ZNKSt3__28messagesIwE7do_openERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_6localeE");

/** @type {function(...*):?} */
var __ZNKSt3__28messagesIwE6do_getEliiRKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEE = Module["__ZNKSt3__28messagesIwE6do_getEliiRKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEE"] = createExportWrapper("_ZNKSt3__28messagesIwE6do_getEliiRKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEE");

/** @type {function(...*):?} */
var __ZNSt3__216__narrow_to_utf8ILm32EEC2Ev = Module["__ZNSt3__216__narrow_to_utf8ILm32EEC2Ev"] = createExportWrapper("_ZNSt3__216__narrow_to_utf8ILm32EEC2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5c_strEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5c_strEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5c_strEv");

/** @type {function(...*):?} */
var __ZNKSt3__216__narrow_to_utf8ILm32EEclINS_20back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEwEET_SB_PKT0_SE_ = Module["__ZNKSt3__216__narrow_to_utf8ILm32EEclINS_20back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEwEET_SB_PKT0_SE_"] = createExportWrapper("_ZNKSt3__216__narrow_to_utf8ILm32EEclINS_20back_insert_iteratorINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEwEET_SB_PKT0_SE_");

/** @type {function(...*):?} */
var __ZNSt3__217__widen_from_utf8ILm32EEC2Ev = Module["__ZNSt3__217__widen_from_utf8ILm32EEC2Ev"] = createExportWrapper("_ZNSt3__217__widen_from_utf8ILm32EEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213back_inserterINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_20back_insert_iteratorIT_EERS8_ = Module["__ZNSt3__213back_inserterINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_20back_insert_iteratorIT_EERS8_"] = createExportWrapper("_ZNSt3__213back_inserterINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_20back_insert_iteratorIT_EERS8_");

/** @type {function(...*):?} */
var __ZNKSt3__217__widen_from_utf8ILm32EEclINS_20back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEEEET_SB_PKcSD_ = Module["__ZNKSt3__217__widen_from_utf8ILm32EEclINS_20back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEEEET_SB_PKcSD_"] = createExportWrapper("_ZNKSt3__217__widen_from_utf8ILm32EEclINS_20back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEEEET_SB_PKcSD_");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIDic11__mbstate_tEC2Em = Module["__ZNSt3__27codecvtIDic11__mbstate_tEC2Em"] = createExportWrapper("_ZNSt3__27codecvtIDic11__mbstate_tEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEdeEv = Module["__ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEdeEv"] = createExportWrapper("_ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEaSEOw = Module["__ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEaSEOw"] = createExportWrapper("_ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEaSEOw");

/** @type {function(...*):?} */
var __ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEppEv = Module["__ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEppEv"] = createExportWrapper("_ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEppEv");

/** @type {function(...*):?} */
var __ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEC2ERS6_ = Module["__ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEC2ERS6_"] = createExportWrapper("_ZNSt3__220back_insert_iteratorINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEC2ERS6_");

/** @type {function(...*):?} */
var __ZNKSt3__28messagesIwE8do_closeEl = Module["__ZNKSt3__28messagesIwE8do_closeEl"] = createExportWrapper("_ZNKSt3__28messagesIwE8do_closeEl");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIcc11__mbstate_tED2Ev = Module["__ZNSt3__214codecvt_bynameIcc11__mbstate_tED2Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIcc11__mbstate_tED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIcc11__mbstate_tED0Ev = Module["__ZNSt3__214codecvt_bynameIcc11__mbstate_tED0Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIcc11__mbstate_tED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIwc11__mbstate_tED2Ev = Module["__ZNSt3__214codecvt_bynameIwc11__mbstate_tED2Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIwc11__mbstate_tED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIwc11__mbstate_tED2Ev = Module["__ZNSt3__27codecvtIwc11__mbstate_tED2Ev"] = createExportWrapper("_ZNSt3__27codecvtIwc11__mbstate_tED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIwc11__mbstate_tED0Ev = Module["__ZNSt3__214codecvt_bynameIwc11__mbstate_tED0Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIwc11__mbstate_tED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIDsc11__mbstate_tED2Ev = Module["__ZNSt3__214codecvt_bynameIDsc11__mbstate_tED2Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIDsc11__mbstate_tED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIDsc11__mbstate_tED0Ev = Module["__ZNSt3__214codecvt_bynameIDsc11__mbstate_tED0Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIDsc11__mbstate_tED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIDic11__mbstate_tED2Ev = Module["__ZNSt3__214codecvt_bynameIDic11__mbstate_tED2Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIDic11__mbstate_tED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIDic11__mbstate_tED0Ev = Module["__ZNSt3__214codecvt_bynameIDic11__mbstate_tED0Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIDic11__mbstate_tED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC2Em = Module["__ZNSt3__26locale5__impC2Em"] = createExportWrapper("_ZNSt3__26locale5__impC2Em");

/** @type {function(...*):?} */
var __ZNSt3__26locale5facetC2Em = Module["__ZNSt3__26locale5facetC2Em"] = createExportWrapper("_ZNSt3__26locale5facetC2Em");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEC2Em = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEC2Em"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5clearEv = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5clearEv"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5clearEv");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_7collateIcEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_7collateIcEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_7collateIcEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_7collateIwEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_7collateIwEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_7collateIwEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_5ctypeIcEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_5ctypeIcEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_5ctypeIcEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_5ctypeIwEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_5ctypeIwEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_5ctypeIwEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_7codecvtIcc11__mbstate_tEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_7codecvtIcc11__mbstate_tEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_7codecvtIcc11__mbstate_tEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_7codecvtIwc11__mbstate_tEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_7codecvtIwc11__mbstate_tEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_7codecvtIwc11__mbstate_tEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_7codecvtIDsc11__mbstate_tEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_7codecvtIDsc11__mbstate_tEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_7codecvtIDsc11__mbstate_tEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_7codecvtIDic11__mbstate_tEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_7codecvtIDic11__mbstate_tEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_7codecvtIDic11__mbstate_tEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_8numpunctIcEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_8numpunctIcEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_8numpunctIcEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_8numpunctIwEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_8numpunctIwEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_8numpunctIwEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_7num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_7num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_7num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_7num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_7num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_7num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_7num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_7num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_7num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_7num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_7num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_7num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_10moneypunctIcLb0EEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_10moneypunctIcLb0EEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_10moneypunctIcLb0EEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_10moneypunctIcLb1EEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_10moneypunctIcLb1EEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_10moneypunctIcLb1EEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_10moneypunctIwLb0EEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_10moneypunctIwLb0EEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_10moneypunctIwLb0EEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_10moneypunctIwLb1EEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_10moneypunctIwLb1EEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_10moneypunctIwLb1EEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_9money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_9money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_9money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_9money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_9money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_9money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_9money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_9money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_9money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_9money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_9money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_9money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_8time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_8time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_8time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_8time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_8time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_8time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_8time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_8time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_8time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_8time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_8time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_8time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_8messagesIcEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_8messagesIcEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_8messagesIcEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_8messagesIwEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_8messagesIwEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_8messagesIwEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEC2Ev = Module["__ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEC2Ev"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE11__vallocateEm = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE11__vallocateEm"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE11__vallocateEm");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE18__construct_at_endEm = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE18__construct_at_endEm"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE18__construct_at_endEm");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE4sizeEv = Module["__ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE4sizeEv"] = createExportWrapper("_ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE4sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5clearEv = Module["__ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5clearEv"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5clearEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__annotate_shrinkEm = Module["__ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__annotate_shrinkEm"] = createExportWrapper("_ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__annotate_shrinkEm");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE26__invalidate_all_iteratorsEv = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE26__invalidate_all_iteratorsEv"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE26__invalidate_all_iteratorsEv");

/** @type {function(...*):?} */
var __ZNSt3__26locale2id5__getEv = Module["__ZNSt3__26locale2id5__getEv"] = createExportWrapper("_ZNSt3__26locale2id5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installEPNS0_5facetEl = Module["__ZNSt3__26locale5__imp7installEPNS0_5facetEl"] = createExportWrapper("_ZNSt3__26locale5__imp7installEPNS0_5facetEl");

/** @type {function(...*):?} */
var __ZNSt3__27collateIcEC2Em = Module["__ZNSt3__27collateIcEC2Em"] = createExportWrapper("_ZNSt3__27collateIcEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__27collateIwEC2Em = Module["__ZNSt3__27collateIwEC2Em"] = createExportWrapper("_ZNSt3__27collateIwEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIcEC2EPKtbm = Module["__ZNSt3__25ctypeIcEC2EPKtbm"] = createExportWrapper("_ZNSt3__25ctypeIcEC2EPKtbm");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIwEC2Em = Module["__ZNSt3__25ctypeIwEC2Em"] = createExportWrapper("_ZNSt3__25ctypeIwEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIcc11__mbstate_tEC2Em = Module["__ZNSt3__27codecvtIcc11__mbstate_tEC2Em"] = createExportWrapper("_ZNSt3__27codecvtIcc11__mbstate_tEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIwc11__mbstate_tEC2Em = Module["__ZNSt3__27codecvtIwc11__mbstate_tEC2Em"] = createExportWrapper("_ZNSt3__27codecvtIwc11__mbstate_tEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIDsc11__mbstate_tEC2Em = Module["__ZNSt3__27codecvtIDsc11__mbstate_tEC2Em"] = createExportWrapper("_ZNSt3__27codecvtIDsc11__mbstate_tEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__28numpunctIcEC2Em = Module["__ZNSt3__28numpunctIcEC2Em"] = createExportWrapper("_ZNSt3__28numpunctIcEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__28numpunctIwEC2Em = Module["__ZNSt3__28numpunctIwEC2Em"] = createExportWrapper("_ZNSt3__28numpunctIwEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em = Module["__ZNSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em"] = createExportWrapper("_ZNSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em = Module["__ZNSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em"] = createExportWrapper("_ZNSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em = Module["__ZNSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em"] = createExportWrapper("_ZNSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em = Module["__ZNSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em"] = createExportWrapper("_ZNSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__210moneypunctIcLb0EEC2Em = Module["__ZNSt3__210moneypunctIcLb0EEC2Em"] = createExportWrapper("_ZNSt3__210moneypunctIcLb0EEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__210moneypunctIcLb1EEC2Em = Module["__ZNSt3__210moneypunctIcLb1EEC2Em"] = createExportWrapper("_ZNSt3__210moneypunctIcLb1EEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__210moneypunctIwLb0EEC2Em = Module["__ZNSt3__210moneypunctIwLb0EEC2Em"] = createExportWrapper("_ZNSt3__210moneypunctIwLb0EEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__210moneypunctIwLb1EEC2Em = Module["__ZNSt3__210moneypunctIwLb1EEC2Em"] = createExportWrapper("_ZNSt3__210moneypunctIwLb1EEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em = Module["__ZNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em"] = createExportWrapper("_ZNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em = Module["__ZNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em"] = createExportWrapper("_ZNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em = Module["__ZNSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em"] = createExportWrapper("_ZNSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em = Module["__ZNSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em"] = createExportWrapper("_ZNSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em = Module["__ZNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em"] = createExportWrapper("_ZNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em = Module["__ZNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em"] = createExportWrapper("_ZNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em = Module["__ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em"] = createExportWrapper("_ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em = Module["__ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em"] = createExportWrapper("_ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__28messagesIcEC2Em = Module["__ZNSt3__28messagesIcEC2Em"] = createExportWrapper("_ZNSt3__28messagesIcEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__28messagesIwEC2Em = Module["__ZNSt3__28messagesIwEC2Em"] = createExportWrapper("_ZNSt3__28messagesIwEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__26locale5__impC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__26locale5__impC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale7classicEv = Module["__ZNSt3__26locale7classicEv"] = createExportWrapper("_ZNSt3__26locale7classicEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEaSERKS6_ = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEaSERKS6_"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEaSERKS6_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEixEm = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEixEm"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEixEm");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__214collate_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__214collate_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_14collate_bynameIcEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_14collate_bynameIcEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_14collate_bynameIcEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__214collate_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__214collate_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_14collate_bynameIwEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_14collate_bynameIwEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_14collate_bynameIwEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__212ctype_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__212ctype_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_12ctype_bynameIcEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_12ctype_bynameIcEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_12ctype_bynameIcEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__212ctype_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__212ctype_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_12ctype_bynameIwEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_12ctype_bynameIwEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_12ctype_bynameIwEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIcc11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__214codecvt_bynameIcc11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__214codecvt_bynameIcc11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_14codecvt_bynameIcc11__mbstate_tEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_14codecvt_bynameIcc11__mbstate_tEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_14codecvt_bynameIcc11__mbstate_tEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIwc11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__214codecvt_bynameIwc11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__214codecvt_bynameIwc11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_14codecvt_bynameIwc11__mbstate_tEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_14codecvt_bynameIwc11__mbstate_tEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_14codecvt_bynameIwc11__mbstate_tEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIDsc11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__214codecvt_bynameIDsc11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__214codecvt_bynameIDsc11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_14codecvt_bynameIDsc11__mbstate_tEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_14codecvt_bynameIDsc11__mbstate_tEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_14codecvt_bynameIDsc11__mbstate_tEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIDic11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__214codecvt_bynameIDic11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__214codecvt_bynameIDic11__mbstate_tEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_14codecvt_bynameIDic11__mbstate_tEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_14codecvt_bynameIDic11__mbstate_tEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_14codecvt_bynameIDic11__mbstate_tEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__215numpunct_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__215numpunct_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_15numpunct_bynameIcEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_15numpunct_bynameIcEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_15numpunct_bynameIcEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__215numpunct_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__215numpunct_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_15numpunct_bynameIwEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_15numpunct_bynameIwEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_15numpunct_bynameIwEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIcLb0EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__217moneypunct_bynameIcLb0EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIcLb0EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIcLb0EEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIcLb0EEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIcLb0EEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIcLb1EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__217moneypunct_bynameIcLb1EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIcLb1EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIcLb1EEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIcLb1EEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIcLb1EEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIwLb0EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__217moneypunct_bynameIwLb0EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIwLb0EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIwLb0EEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIwLb0EEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIwLb0EEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIwLb1EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__217moneypunct_bynameIwLb1EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIwLb1EEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIwLb1EEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIwLb1EEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_17moneypunct_bynameIwLb1EEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2ERKNS_12basic_stringIcS3_NS_9allocatorIcEEEEm = Module["__ZNSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2ERKNS_12basic_stringIcS3_NS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEC2ERKNS_12basic_stringIcS3_NS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_15time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_15time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_15time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2ERKNS_12basic_stringIcNS2_IcEENS_9allocatorIcEEEEm = Module["__ZNSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2ERKNS_12basic_stringIcNS2_IcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEC2ERKNS_12basic_stringIcNS2_IcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_15time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_15time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_15time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__215time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2ERKNS_12basic_stringIcS3_NS_9allocatorIcEEEEm = Module["__ZNSt3__215time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2ERKNS_12basic_stringIcS3_NS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__215time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2ERKNS_12basic_stringIcS3_NS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_15time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_15time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_15time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__215time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2ERKNS_12basic_stringIcNS2_IcEENS_9allocatorIcEEEEm = Module["__ZNSt3__215time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2ERKNS_12basic_stringIcNS2_IcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__215time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2ERKNS_12basic_stringIcNS2_IcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_15time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_15time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_15time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__215messages_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__215messages_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__215messages_bynameIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_15messages_bynameIcEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_15messages_bynameIcEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_15messages_bynameIcEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__215messages_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__215messages_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__215messages_bynameIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp7installINS_15messages_bynameIwEEEEvPT_ = Module["__ZNSt3__26locale5__imp7installINS_15messages_bynameIwEEEEvPT_"] = createExportWrapper("_ZNSt3__26locale5__imp7installINS_15messages_bynameIwEEEEvPT_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12make_classicEv = Module["__ZNSt3__26locale5__imp12make_classicEv"] = createExportWrapper("_ZNSt3__26locale5__imp12make_classicEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE19__copy_assign_allocERKS6_ = Module["__ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE19__copy_assign_allocERKS6_"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE19__copy_assign_allocERKS6_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6assignIPS3_EENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr16is_constructibleIS3_NS_15iterator_traitsISA_E9referenceEEE5valueEvE4typeESA_SA_ = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6assignIPS3_EENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr16is_constructibleIS3_NS_15iterator_traitsISA_E9referenceEEE5valueEvE4typeESA_SA_"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6assignIPS3_EENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr16is_constructibleIS3_NS_15iterator_traitsISA_E9referenceEEE5valueEvE4typeESA_SA_");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIcc11__mbstate_tEC2EPKcm = Module["__ZNSt3__27codecvtIcc11__mbstate_tEC2EPKcm"] = createExportWrapper("_ZNSt3__27codecvtIcc11__mbstate_tEC2EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIwc11__mbstate_tEC2EPKcm = Module["__ZNSt3__27codecvtIwc11__mbstate_tEC2EPKcm"] = createExportWrapper("_ZNSt3__27codecvtIwc11__mbstate_tEC2EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIDsc11__mbstate_tEC2EPKcm = Module["__ZNSt3__27codecvtIDsc11__mbstate_tEC2EPKcm"] = createExportWrapper("_ZNSt3__27codecvtIDsc11__mbstate_tEC2EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIDic11__mbstate_tEC2EPKcm = Module["__ZNSt3__27codecvtIDic11__mbstate_tEC2EPKcm"] = createExportWrapper("_ZNSt3__27codecvtIDic11__mbstate_tEC2EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIcLb0EE4initEPKc = Module["__ZNSt3__217moneypunct_bynameIcLb0EE4initEPKc"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIcLb0EE4initEPKc");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIcLb1EE4initEPKc = Module["__ZNSt3__217moneypunct_bynameIcLb1EE4initEPKc"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIcLb1EE4initEPKc");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIwLb0EE4initEPKc = Module["__ZNSt3__217moneypunct_bynameIwLb0EE4initEPKc"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIwLb0EE4initEPKc");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIwLb1EE4initEPKc = Module["__ZNSt3__217moneypunct_bynameIwLb1EE4initEPKc"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIwLb1EE4initEPKc");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__218__time_get_storageIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__218__time_get_storageIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__218__time_get_storageIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__218__time_get_storageIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2ERKNS_12basic_stringIcS3_NS_9allocatorIcEEEEm = Module["__ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2ERKNS_12basic_stringIcS3_NS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEC2ERKNS_12basic_stringIcS3_NS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2ERKNS_12basic_stringIcNS2_IcEENS_9allocatorIcEEEEm = Module["__ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2ERKNS_12basic_stringIcNS2_IcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEC2ERKNS_12basic_stringIcNS2_IcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC2ERKS1_ = Module["__ZNSt3__26locale5__impC2ERKS1_"] = createExportWrapper("_ZNSt3__26locale5__impC2ERKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC2ERKS1_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi = Module["__ZNSt3__26locale5__impC2ERKS1_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi"] = createExportWrapper("_ZNSt3__26locale5__impC2ERKS1_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC2ERKS1_S3_i = Module["__ZNSt3__26locale5__impC2ERKS1_S3_i"] = createExportWrapper("_ZNSt3__26locale5__impC2ERKS1_S3_i");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_7collateIcEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_7collateIcEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_7collateIcEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_7collateIwEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_7collateIwEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_7collateIwEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_5ctypeIcEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_5ctypeIcEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_5ctypeIcEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_5ctypeIwEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_5ctypeIwEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_5ctypeIwEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_7codecvtIcc11__mbstate_tEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_7codecvtIcc11__mbstate_tEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_7codecvtIcc11__mbstate_tEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_7codecvtIDsc11__mbstate_tEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_7codecvtIDsc11__mbstate_tEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_7codecvtIDsc11__mbstate_tEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_7codecvtIDic11__mbstate_tEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_7codecvtIDic11__mbstate_tEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_7codecvtIDic11__mbstate_tEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_7codecvtIwc11__mbstate_tEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_7codecvtIwc11__mbstate_tEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_7codecvtIwc11__mbstate_tEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_10moneypunctIcLb0EEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_10moneypunctIcLb0EEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_10moneypunctIcLb0EEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_10moneypunctIcLb1EEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_10moneypunctIcLb1EEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_10moneypunctIcLb1EEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_10moneypunctIwLb0EEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_10moneypunctIwLb0EEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_10moneypunctIwLb0EEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_10moneypunctIwLb1EEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_10moneypunctIwLb1EEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_10moneypunctIwLb1EEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_9money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_9money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_9money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_9money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_9money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_9money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_9money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_9money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_9money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_9money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_9money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_9money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_8numpunctIcEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_8numpunctIcEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_8numpunctIcEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_8numpunctIwEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_8numpunctIwEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_8numpunctIwEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_7num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_7num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_7num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_7num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_7num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_7num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_7num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_7num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_7num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_7num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_7num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_7num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_8time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_8time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_8time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_8time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_8time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_8time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_8time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_8time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_8time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_8time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_8time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_8time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_8messagesIcEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_8messagesIcEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_8messagesIcEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp12install_fromINS_8messagesIwEEEEvRKS1_ = Module["__ZNSt3__26locale5__imp12install_fromINS_8messagesIwEEEEvRKS1_"] = createExportWrapper("_ZNSt3__26locale5__imp12install_fromINS_8messagesIwEEEEvRKS1_");

/** @type {function(...*):?} */
var __ZNKSt3__26locale5__imp9use_facetEl = Module["__ZNKSt3__26locale5__imp9use_facetEl"] = createExportWrapper("_ZNKSt3__26locale5__imp9use_facetEl");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC2ERKS1_PNS0_5facetEl = Module["__ZNSt3__26locale5__impC2ERKS1_PNS0_5facetEl"] = createExportWrapper("_ZNSt3__26locale5__impC2ERKS1_PNS0_5facetEl");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6resizeEm = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6resizeEm"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6resizeEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impD2Ev = Module["__ZNSt3__26locale5__impD2Ev"] = createExportWrapper("_ZNSt3__26locale5__impD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEED2Ev = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEED2Ev"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEED2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__annotate_deleteEv = Module["__ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__annotate_deleteEv"] = createExportWrapper("_ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__annotate_deleteEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEED2Ev = Module["__ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEED2Ev"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impD0Ev = Module["__ZNSt3__26locale5__impD0Ev"] = createExportWrapper("_ZNSt3__26locale5__impD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8__appendEm = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8__appendEm"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8__appendEm");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_ = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_");

/** @type {function(...*):?} */
var __ZNKSt3__26locale5__imp9has_facetEl = Module["__ZNKSt3__26locale5__imp9has_facetEl"] = createExportWrapper("_ZNKSt3__26locale5__imp9has_facetEl");

/** @type {function(...*):?} */
var __ZNSt3__216__throw_bad_castEv = Module["__ZNSt3__216__throw_bad_castEv"] = createExportWrapper("_ZNSt3__216__throw_bad_castEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEixEm = Module["__ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEixEm"] = createExportWrapper("_ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEixEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__imp11make_globalEv = Module["__ZNSt3__26locale5__imp11make_globalEv"] = createExportWrapper("_ZNSt3__26locale5__imp11make_globalEv");

/** @type {function(...*):?} */
var __ZNSt3__26localeC2ERKS0_ = Module["__ZNSt3__26localeC2ERKS0_"] = createExportWrapper("_ZNSt3__26localeC2ERKS0_");

/** @type {function(...*):?} */
var __ZNSt3__26locale8__globalEv = Module["__ZNSt3__26locale8__globalEv"] = createExportWrapper("_ZNSt3__26locale8__globalEv");

/** @type {function(...*):?} */
var __ZNSt3__26localeC2Ev = Module["__ZNSt3__26localeC2Ev"] = createExportWrapper("_ZNSt3__26localeC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26localeC2EPKc = Module["__ZNSt3__26localeC2EPKc"] = createExportWrapper("_ZNSt3__26localeC2EPKc");

/** @type {function(...*):?} */
var __ZNSt3__26localeC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__26localeC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__26localeC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__26localeC2ERKS0_PKci = Module["__ZNSt3__26localeC2ERKS0_PKci"] = createExportWrapper("_ZNSt3__26localeC2ERKS0_PKci");

/** @type {function(...*):?} */
var __ZNSt3__26localeC2ERKS0_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi = Module["__ZNSt3__26localeC2ERKS0_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi"] = createExportWrapper("_ZNSt3__26localeC2ERKS0_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi");

/** @type {function(...*):?} */
var __ZNSt3__26localeC2ERKS0_S2_i = Module["__ZNSt3__26localeC2ERKS0_S2_i"] = createExportWrapper("_ZNSt3__26localeC2ERKS0_S2_i");

/** @type {function(...*):?} */
var __ZNKSt3__26locale4nameEv = Module["__ZNKSt3__26locale4nameEv"] = createExportWrapper("_ZNKSt3__26locale4nameEv");

/** @type {function(...*):?} */
var __ZNKSt3__26locale5__imp4nameEv = Module["__ZNKSt3__26locale5__imp4nameEv"] = createExportWrapper("_ZNKSt3__26locale5__imp4nameEv");

/** @type {function(...*):?} */
var __ZNSt3__26locale14__install_ctorERKS0_PNS0_5facetEl = Module["__ZNSt3__26locale14__install_ctorERKS0_PNS0_5facetEl"] = createExportWrapper("_ZNSt3__26locale14__install_ctorERKS0_PNS0_5facetEl");

/** @type {function(...*):?} */
var __ZNSt3__26locale6globalERKS0_ = Module["__ZNSt3__26locale6globalERKS0_"] = createExportWrapper("_ZNSt3__26locale6globalERKS0_");

/** @type {function(...*):?} */
var __ZNSt3__2neIcNS_11char_traitsIcEENS_9allocatorIcEEEEbRKNS_12basic_stringIT_T0_T1_EEPKS6_ = Module["__ZNSt3__2neIcNS_11char_traitsIcEENS_9allocatorIcEEEEbRKNS_12basic_stringIT_T0_T1_EEPKS6_"] = createExportWrapper("_ZNSt3__2neIcNS_11char_traitsIcEENS_9allocatorIcEEEEbRKNS_12basic_stringIT_T0_T1_EEPKS6_");

/** @type {function(...*):?} */
var __ZNSt3__2eqIcNS_11char_traitsIcEENS_9allocatorIcEEEEbRKNS_12basic_stringIT_T0_T1_EEPKS6_ = Module["__ZNSt3__2eqIcNS_11char_traitsIcEENS_9allocatorIcEEEEbRKNS_12basic_stringIT_T0_T1_EEPKS6_"] = createExportWrapper("_ZNSt3__2eqIcNS_11char_traitsIcEENS_9allocatorIcEEEEbRKNS_12basic_stringIT_T0_T1_EEPKS6_");

/** @type {function(...*):?} */
var __ZNKSt3__26locale9has_facetERNS0_2idE = Module["__ZNKSt3__26locale9has_facetERNS0_2idE"] = createExportWrapper("_ZNKSt3__26locale9has_facetERNS0_2idE");

/** @type {function(...*):?} */
var __ZNSt3__26locale2id6__initEv = Module["__ZNSt3__26locale2id6__initEv"] = createExportWrapper("_ZNSt3__26locale2id6__initEv");

/** @type {function(...*):?} */
var __ZNKSt3__26localeeqERKS0_ = Module["__ZNKSt3__26localeeqERKS0_"] = createExportWrapper("_ZNKSt3__26localeeqERKS0_");

/** @type {function(...*):?} */
var __ZNSt3__2eqINS_9allocatorIcEEEEbRKNS_12basic_stringIcNS_11char_traitsIcEET_EES9_ = Module["__ZNSt3__2eqINS_9allocatorIcEEEEbRKNS_12basic_stringIcNS_11char_traitsIcEET_EES9_"] = createExportWrapper("_ZNSt3__2eqINS_9allocatorIcEEEEbRKNS_12basic_stringIcNS_11char_traitsIcEET_EES9_");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE7compareEPKcS3_m = Module["__ZNSt3__211char_traitsIcE7compareEPKcS3_m"] = createExportWrapper("_ZNSt3__211char_traitsIcE7compareEPKcS3_m");

/** @type {function(...*):?} */
var __ZNSt3__26locale5facetD0Ev = Module["__ZNSt3__26locale5facetD0Ev"] = createExportWrapper("_ZNSt3__26locale5facetD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__26locale5facet16__on_zero_sharedEv = Module["__ZNSt3__26locale5facet16__on_zero_sharedEv"] = createExportWrapper("_ZNSt3__26locale5facet16__on_zero_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__221__libcpp_acquire_loadImEET_PKS1_ = Module["__ZNSt3__221__libcpp_acquire_loadImEET_PKS1_"] = createExportWrapper("_ZNSt3__221__libcpp_acquire_loadImEET_PKS1_");

/** @type {function(...*):?} */
var __ZNSt3__211__call_onceERVmPvPFvS2_E = Module["__ZNSt3__211__call_onceERVmPvPFvS2_E"] = createExportWrapper("_ZNSt3__211__call_onceERVmPvPFvS2_E");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIcEC2EPKcm = Module["__ZNSt3__214collate_bynameIcEC2EPKcm"] = createExportWrapper("_ZNSt3__214collate_bynameIcEC2EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEPKS6_RKS9_ = Module["__ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEPKS6_RKS9_"] = createExportWrapper("_ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEPKS6_RKS9_");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIcED2Ev = Module["__ZNSt3__214collate_bynameIcED2Ev"] = createExportWrapper("_ZNSt3__214collate_bynameIcED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIcED0Ev = Module["__ZNSt3__214collate_bynameIcED0Ev"] = createExportWrapper("_ZNSt3__214collate_bynameIcED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__214collate_bynameIcE10do_compareEPKcS3_S3_S3_ = Module["__ZNKSt3__214collate_bynameIcE10do_compareEPKcS3_S3_S3_"] = createExportWrapper("_ZNKSt3__214collate_bynameIcE10do_compareEPKcS3_S3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__214collate_bynameIcE12do_transformEPKcS3_ = Module["__ZNKSt3__214collate_bynameIcE12do_transformEPKcS3_"] = createExportWrapper("_ZNKSt3__214collate_bynameIcE12do_transformEPKcS3_");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIwEC2EPKcm = Module["__ZNSt3__214collate_bynameIwEC2EPKcm"] = createExportWrapper("_ZNSt3__214collate_bynameIwEC2EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIwED2Ev = Module["__ZNSt3__214collate_bynameIwED2Ev"] = createExportWrapper("_ZNSt3__214collate_bynameIwED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIwED0Ev = Module["__ZNSt3__214collate_bynameIwED0Ev"] = createExportWrapper("_ZNSt3__214collate_bynameIwED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__214collate_bynameIwE10do_compareEPKwS3_S3_S3_ = Module["__ZNKSt3__214collate_bynameIwE10do_compareEPKwS3_S3_S3_"] = createExportWrapper("_ZNKSt3__214collate_bynameIwE10do_compareEPKwS3_S3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__214collate_bynameIwE12do_transformEPKwS3_ = Module["__ZNKSt3__214collate_bynameIwE12do_transformEPKwS3_"] = createExportWrapper("_ZNKSt3__214collate_bynameIwE12do_transformEPKwS3_");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIwED0Ev = Module["__ZNSt3__25ctypeIwED0Ev"] = createExportWrapper("_ZNSt3__25ctypeIwED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE5do_isEtw = Module["__ZNKSt3__25ctypeIwE5do_isEtw"] = createExportWrapper("_ZNKSt3__25ctypeIwE5do_isEtw");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIcE13classic_tableEv = Module["__ZNSt3__25ctypeIcE13classic_tableEv"] = createExportWrapper("_ZNSt3__25ctypeIcE13classic_tableEv");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE5do_isEPKwS3_Pt = Module["__ZNKSt3__25ctypeIwE5do_isEPKwS3_Pt"] = createExportWrapper("_ZNKSt3__25ctypeIwE5do_isEPKwS3_Pt");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE10do_scan_isEtPKwS3_ = Module["__ZNKSt3__25ctypeIwE10do_scan_isEtPKwS3_"] = createExportWrapper("_ZNKSt3__25ctypeIwE10do_scan_isEtPKwS3_");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE11do_scan_notEtPKwS3_ = Module["__ZNKSt3__25ctypeIwE11do_scan_notEtPKwS3_"] = createExportWrapper("_ZNKSt3__25ctypeIwE11do_scan_notEtPKwS3_");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE10do_toupperEw = Module["__ZNKSt3__25ctypeIwE10do_toupperEw"] = createExportWrapper("_ZNKSt3__25ctypeIwE10do_toupperEw");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIcE21__classic_upper_tableEv = Module["__ZNSt3__25ctypeIcE21__classic_upper_tableEv"] = createExportWrapper("_ZNSt3__25ctypeIcE21__classic_upper_tableEv");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE10do_toupperEPwPKw = Module["__ZNKSt3__25ctypeIwE10do_toupperEPwPKw"] = createExportWrapper("_ZNKSt3__25ctypeIwE10do_toupperEPwPKw");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE10do_tolowerEw = Module["__ZNKSt3__25ctypeIwE10do_tolowerEw"] = createExportWrapper("_ZNKSt3__25ctypeIwE10do_tolowerEw");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIcE21__classic_lower_tableEv = Module["__ZNSt3__25ctypeIcE21__classic_lower_tableEv"] = createExportWrapper("_ZNSt3__25ctypeIcE21__classic_lower_tableEv");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE10do_tolowerEPwPKw = Module["__ZNKSt3__25ctypeIwE10do_tolowerEPwPKw"] = createExportWrapper("_ZNKSt3__25ctypeIwE10do_tolowerEPwPKw");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE8do_widenEc = Module["__ZNKSt3__25ctypeIwE8do_widenEc"] = createExportWrapper("_ZNKSt3__25ctypeIwE8do_widenEc");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE8do_widenEPKcS3_Pw = Module["__ZNKSt3__25ctypeIwE8do_widenEPKcS3_Pw"] = createExportWrapper("_ZNKSt3__25ctypeIwE8do_widenEPKcS3_Pw");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE9do_narrowEwc = Module["__ZNKSt3__25ctypeIwE9do_narrowEwc"] = createExportWrapper("_ZNKSt3__25ctypeIwE9do_narrowEwc");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIwE9do_narrowEPKwS3_cPc = Module["__ZNKSt3__25ctypeIwE9do_narrowEPKwS3_cPc"] = createExportWrapper("_ZNKSt3__25ctypeIwE9do_narrowEPKwS3_cPc");

/** @type {function(...*):?} */
var __ZNSt3__210ctype_baseC2Ev = Module["__ZNSt3__210ctype_baseC2Ev"] = createExportWrapper("_ZNSt3__210ctype_baseC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIcED2Ev = Module["__ZNSt3__25ctypeIcED2Ev"] = createExportWrapper("_ZNSt3__25ctypeIcED2Ev");

/** @type {function(...*):?} */
var __ZdaPv = Module["__ZdaPv"] = createExportWrapper("_ZdaPv");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIcED0Ev = Module["__ZNSt3__25ctypeIcED0Ev"] = createExportWrapper("_ZNSt3__25ctypeIcED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE10do_toupperEc = Module["__ZNKSt3__25ctypeIcE10do_toupperEc"] = createExportWrapper("_ZNKSt3__25ctypeIcE10do_toupperEc");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE10do_toupperEPcPKc = Module["__ZNKSt3__25ctypeIcE10do_toupperEPcPKc"] = createExportWrapper("_ZNKSt3__25ctypeIcE10do_toupperEPcPKc");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE10do_tolowerEc = Module["__ZNKSt3__25ctypeIcE10do_tolowerEc"] = createExportWrapper("_ZNKSt3__25ctypeIcE10do_tolowerEc");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE10do_tolowerEPcPKc = Module["__ZNKSt3__25ctypeIcE10do_tolowerEPcPKc"] = createExportWrapper("_ZNKSt3__25ctypeIcE10do_tolowerEPcPKc");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE8do_widenEc = Module["__ZNKSt3__25ctypeIcE8do_widenEc"] = createExportWrapper("_ZNKSt3__25ctypeIcE8do_widenEc");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE8do_widenEPKcS3_Pc = Module["__ZNKSt3__25ctypeIcE8do_widenEPKcS3_Pc"] = createExportWrapper("_ZNKSt3__25ctypeIcE8do_widenEPKcS3_Pc");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE9do_narrowEcc = Module["__ZNKSt3__25ctypeIcE9do_narrowEcc"] = createExportWrapper("_ZNKSt3__25ctypeIcE9do_narrowEcc");

/** @type {function(...*):?} */
var __ZNKSt3__25ctypeIcE9do_narrowEPKcS3_cPc = Module["__ZNKSt3__25ctypeIcE9do_narrowEPKcS3_cPc"] = createExportWrapper("_ZNKSt3__25ctypeIcE9do_narrowEPKcS3_cPc");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIcEC2EPKcm = Module["__ZNSt3__212ctype_bynameIcEC2EPKcm"] = createExportWrapper("_ZNSt3__212ctype_bynameIcEC2EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIcED0Ev = Module["__ZNSt3__212ctype_bynameIcED0Ev"] = createExportWrapper("_ZNSt3__212ctype_bynameIcED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIcED2Ev = Module["__ZNSt3__212ctype_bynameIcED2Ev"] = createExportWrapper("_ZNSt3__212ctype_bynameIcED2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIcE10do_toupperEc = Module["__ZNKSt3__212ctype_bynameIcE10do_toupperEc"] = createExportWrapper("_ZNKSt3__212ctype_bynameIcE10do_toupperEc");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIcE10do_toupperEPcPKc = Module["__ZNKSt3__212ctype_bynameIcE10do_toupperEPcPKc"] = createExportWrapper("_ZNKSt3__212ctype_bynameIcE10do_toupperEPcPKc");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIcE10do_tolowerEc = Module["__ZNKSt3__212ctype_bynameIcE10do_tolowerEc"] = createExportWrapper("_ZNKSt3__212ctype_bynameIcE10do_tolowerEc");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIcE10do_tolowerEPcPKc = Module["__ZNKSt3__212ctype_bynameIcE10do_tolowerEPcPKc"] = createExportWrapper("_ZNKSt3__212ctype_bynameIcE10do_tolowerEPcPKc");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIwEC2EPKcm = Module["__ZNSt3__212ctype_bynameIwEC2EPKcm"] = createExportWrapper("_ZNSt3__212ctype_bynameIwEC2EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIwED0Ev = Module["__ZNSt3__212ctype_bynameIwED0Ev"] = createExportWrapper("_ZNSt3__212ctype_bynameIwED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIwED2Ev = Module["__ZNSt3__212ctype_bynameIwED2Ev"] = createExportWrapper("_ZNSt3__212ctype_bynameIwED2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE5do_isEtw = Module["__ZNKSt3__212ctype_bynameIwE5do_isEtw"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE5do_isEtw");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE5do_isEPKwS3_Pt = Module["__ZNKSt3__212ctype_bynameIwE5do_isEPKwS3_Pt"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE5do_isEPKwS3_Pt");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE10do_scan_isEtPKwS3_ = Module["__ZNKSt3__212ctype_bynameIwE10do_scan_isEtPKwS3_"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE10do_scan_isEtPKwS3_");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE11do_scan_notEtPKwS3_ = Module["__ZNKSt3__212ctype_bynameIwE11do_scan_notEtPKwS3_"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE11do_scan_notEtPKwS3_");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE10do_toupperEw = Module["__ZNKSt3__212ctype_bynameIwE10do_toupperEw"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE10do_toupperEw");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE10do_toupperEPwPKw = Module["__ZNKSt3__212ctype_bynameIwE10do_toupperEPwPKw"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE10do_toupperEPwPKw");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE10do_tolowerEw = Module["__ZNKSt3__212ctype_bynameIwE10do_tolowerEw"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE10do_tolowerEw");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE10do_tolowerEPwPKw = Module["__ZNKSt3__212ctype_bynameIwE10do_tolowerEPwPKw"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE10do_tolowerEPwPKw");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE8do_widenEc = Module["__ZNKSt3__212ctype_bynameIwE8do_widenEc"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE8do_widenEc");

/** @type {function(...*):?} */
var __ZNSt3__216__libcpp_btowc_lEiP15__locale_struct = Module["__ZNSt3__216__libcpp_btowc_lEiP15__locale_struct"] = createExportWrapper("_ZNSt3__216__libcpp_btowc_lEiP15__locale_struct");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE8do_widenEPKcS3_Pw = Module["__ZNKSt3__212ctype_bynameIwE8do_widenEPKcS3_Pw"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE8do_widenEPKcS3_Pw");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE9do_narrowEwc = Module["__ZNKSt3__212ctype_bynameIwE9do_narrowEwc"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE9do_narrowEwc");

/** @type {function(...*):?} */
var __ZNSt3__216__libcpp_wctob_lEjP15__locale_struct = Module["__ZNSt3__216__libcpp_wctob_lEjP15__locale_struct"] = createExportWrapper("_ZNSt3__216__libcpp_wctob_lEjP15__locale_struct");

/** @type {function(...*):?} */
var __ZNKSt3__212ctype_bynameIwE9do_narrowEPKwS3_cPc = Module["__ZNKSt3__212ctype_bynameIwE9do_narrowEPKwS3_cPc"] = createExportWrapper("_ZNKSt3__212ctype_bynameIwE9do_narrowEPKwS3_cPc");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIcc11__mbstate_tED0Ev = Module["__ZNSt3__27codecvtIcc11__mbstate_tED0Ev"] = createExportWrapper("_ZNSt3__27codecvtIcc11__mbstate_tED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE6do_outERS1_PKcS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE6do_outERS1_PKcS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE6do_outERS1_PKcS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE5do_inERS1_PKcS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE5do_inERS1_PKcS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE5do_inERS1_PKcS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE10do_unshiftERS1_PcS4_RS4_ = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE10do_unshiftERS1_PcS4_RS4_"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE10do_unshiftERS1_PcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE11do_encodingEv = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE11do_encodingEv"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE16do_always_noconvEv = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE9do_lengthERS1_PKcS5_m = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE9do_lengthERS1_PKcS5_m"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE9do_lengthERS1_PKcS5_m");

/** @type {function(...*):?} */
var __ZNSt3__23minImEERKT_S3_S3_ = Module["__ZNSt3__23minImEERKT_S3_S3_"] = createExportWrapper("_ZNSt3__23minImEERKT_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__23minImNS_6__lessImmEEEERKT_S5_S5_T0_ = Module["__ZNSt3__23minImNS_6__lessImmEEEERKT_S5_S5_T0_"] = createExportWrapper("_ZNSt3__23minImNS_6__lessImmEEEERKT_S5_S5_T0_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE13do_max_lengthEv = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNSt3__212codecvt_baseC2Ev = Module["__ZNSt3__212codecvt_baseC2Ev"] = createExportWrapper("_ZNSt3__212codecvt_baseC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIwc11__mbstate_tED0Ev = Module["__ZNSt3__27codecvtIwc11__mbstate_tED0Ev"] = createExportWrapper("_ZNSt3__27codecvtIwc11__mbstate_tED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE6do_outERS1_PKwS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE6do_outERS1_PKwS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE6do_outERS1_PKwS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNSt3__221__libcpp_wcsnrtombs_lEPcPPKwmmP11__mbstate_tP15__locale_struct = Module["__ZNSt3__221__libcpp_wcsnrtombs_lEPcPPKwmmP11__mbstate_tP15__locale_struct"] = createExportWrapper("_ZNSt3__221__libcpp_wcsnrtombs_lEPcPPKwmmP11__mbstate_tP15__locale_struct");

/** @type {function(...*):?} */
var __ZNSt3__218__libcpp_wcrtomb_lEPcwP11__mbstate_tP15__locale_struct = Module["__ZNSt3__218__libcpp_wcrtomb_lEPcwP11__mbstate_tP15__locale_struct"] = createExportWrapper("_ZNSt3__218__libcpp_wcrtomb_lEPcwP11__mbstate_tP15__locale_struct");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE5do_inERS1_PKcS5_RS5_PwS7_RS7_ = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE5do_inERS1_PKcS5_RS5_PwS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE5do_inERS1_PKcS5_RS5_PwS7_RS7_");

/** @type {function(...*):?} */
var __ZNSt3__221__libcpp_mbsnrtowcs_lEPwPPKcmmP11__mbstate_tP15__locale_struct = Module["__ZNSt3__221__libcpp_mbsnrtowcs_lEPwPPKcmmP11__mbstate_tP15__locale_struct"] = createExportWrapper("_ZNSt3__221__libcpp_mbsnrtowcs_lEPwPPKcmmP11__mbstate_tP15__locale_struct");

/** @type {function(...*):?} */
var __ZNSt3__218__libcpp_mbrtowc_lEPwPKcmP11__mbstate_tP15__locale_struct = Module["__ZNSt3__218__libcpp_mbrtowc_lEPwPKcmP11__mbstate_tP15__locale_struct"] = createExportWrapper("_ZNSt3__218__libcpp_mbrtowc_lEPwPKcmP11__mbstate_tP15__locale_struct");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE10do_unshiftERS1_PcS4_RS4_ = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE10do_unshiftERS1_PcS4_RS4_"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE10do_unshiftERS1_PcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE11do_encodingEv = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE11do_encodingEv"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNSt3__217__libcpp_mbtowc_lEPwPKcmP15__locale_struct = Module["__ZNSt3__217__libcpp_mbtowc_lEPwPKcmP15__locale_struct"] = createExportWrapper("_ZNSt3__217__libcpp_mbtowc_lEPwPKcmP15__locale_struct");

/** @type {function(...*):?} */
var __ZNSt3__221__libcpp_mb_cur_max_lEP15__locale_struct = Module["__ZNSt3__221__libcpp_mb_cur_max_lEP15__locale_struct"] = createExportWrapper("_ZNSt3__221__libcpp_mb_cur_max_lEP15__locale_struct");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE16do_always_noconvEv = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE9do_lengthERS1_PKcS5_m = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE9do_lengthERS1_PKcS5_m"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE9do_lengthERS1_PKcS5_m");

/** @type {function(...*):?} */
var __ZNSt3__217__libcpp_mbrlen_lEPKcmP11__mbstate_tP15__locale_struct = Module["__ZNSt3__217__libcpp_mbrlen_lEPKcmP11__mbstate_tP15__locale_struct"] = createExportWrapper("_ZNSt3__217__libcpp_mbrlen_lEPKcmP11__mbstate_tP15__locale_struct");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIwc11__mbstate_tE13do_max_lengthEv = Module["__ZNKSt3__27codecvtIwc11__mbstate_tE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__27codecvtIwc11__mbstate_tE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIDsc11__mbstate_tED0Ev = Module["__ZNSt3__27codecvtIDsc11__mbstate_tED0Ev"] = createExportWrapper("_ZNSt3__27codecvtIDsc11__mbstate_tED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDsc11__mbstate_tE6do_outERS1_PKDsS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__27codecvtIDsc11__mbstate_tE6do_outERS1_PKDsS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIDsc11__mbstate_tE6do_outERS1_PKDsS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDsc11__mbstate_tE5do_inERS1_PKcS5_RS5_PDsS7_RS7_ = Module["__ZNKSt3__27codecvtIDsc11__mbstate_tE5do_inERS1_PKcS5_RS5_PDsS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIDsc11__mbstate_tE5do_inERS1_PKcS5_RS5_PDsS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDsc11__mbstate_tE10do_unshiftERS1_PcS4_RS4_ = Module["__ZNKSt3__27codecvtIDsc11__mbstate_tE10do_unshiftERS1_PcS4_RS4_"] = createExportWrapper("_ZNKSt3__27codecvtIDsc11__mbstate_tE10do_unshiftERS1_PcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDsc11__mbstate_tE11do_encodingEv = Module["__ZNKSt3__27codecvtIDsc11__mbstate_tE11do_encodingEv"] = createExportWrapper("_ZNKSt3__27codecvtIDsc11__mbstate_tE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDsc11__mbstate_tE16do_always_noconvEv = Module["__ZNKSt3__27codecvtIDsc11__mbstate_tE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__27codecvtIDsc11__mbstate_tE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDsc11__mbstate_tE9do_lengthERS1_PKcS5_m = Module["__ZNKSt3__27codecvtIDsc11__mbstate_tE9do_lengthERS1_PKcS5_m"] = createExportWrapper("_ZNKSt3__27codecvtIDsc11__mbstate_tE9do_lengthERS1_PKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDsc11__mbstate_tE13do_max_lengthEv = Module["__ZNKSt3__27codecvtIDsc11__mbstate_tE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__27codecvtIDsc11__mbstate_tE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIDic11__mbstate_tED0Ev = Module["__ZNSt3__27codecvtIDic11__mbstate_tED0Ev"] = createExportWrapper("_ZNSt3__27codecvtIDic11__mbstate_tED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDic11__mbstate_tE6do_outERS1_PKDiS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__27codecvtIDic11__mbstate_tE6do_outERS1_PKDiS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIDic11__mbstate_tE6do_outERS1_PKDiS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDic11__mbstate_tE5do_inERS1_PKcS5_RS5_PDiS7_RS7_ = Module["__ZNKSt3__27codecvtIDic11__mbstate_tE5do_inERS1_PKcS5_RS5_PDiS7_RS7_"] = createExportWrapper("_ZNKSt3__27codecvtIDic11__mbstate_tE5do_inERS1_PKcS5_RS5_PDiS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDic11__mbstate_tE10do_unshiftERS1_PcS4_RS4_ = Module["__ZNKSt3__27codecvtIDic11__mbstate_tE10do_unshiftERS1_PcS4_RS4_"] = createExportWrapper("_ZNKSt3__27codecvtIDic11__mbstate_tE10do_unshiftERS1_PcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDic11__mbstate_tE11do_encodingEv = Module["__ZNKSt3__27codecvtIDic11__mbstate_tE11do_encodingEv"] = createExportWrapper("_ZNKSt3__27codecvtIDic11__mbstate_tE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDic11__mbstate_tE16do_always_noconvEv = Module["__ZNKSt3__27codecvtIDic11__mbstate_tE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__27codecvtIDic11__mbstate_tE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDic11__mbstate_tE9do_lengthERS1_PKcS5_m = Module["__ZNKSt3__27codecvtIDic11__mbstate_tE9do_lengthERS1_PKcS5_m"] = createExportWrapper("_ZNKSt3__27codecvtIDic11__mbstate_tE9do_lengthERS1_PKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIDic11__mbstate_tE13do_max_lengthEv = Module["__ZNKSt3__27codecvtIDic11__mbstate_tE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__27codecvtIDic11__mbstate_tE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IwE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__214__codecvt_utf8IwE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IwE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IwE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_ = Module["__ZNKSt3__214__codecvt_utf8IwE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IwE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IwE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__214__codecvt_utf8IwE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IwE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IwE11do_encodingEv = Module["__ZNKSt3__214__codecvt_utf8IwE11do_encodingEv"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IwE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IwE16do_always_noconvEv = Module["__ZNKSt3__214__codecvt_utf8IwE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IwE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IwE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__214__codecvt_utf8IwE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IwE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IwE13do_max_lengthEv = Module["__ZNKSt3__214__codecvt_utf8IwE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IwE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDsE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__214__codecvt_utf8IDsE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDsE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDsE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_ = Module["__ZNKSt3__214__codecvt_utf8IDsE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDsE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDsE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__214__codecvt_utf8IDsE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDsE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDsE11do_encodingEv = Module["__ZNKSt3__214__codecvt_utf8IDsE11do_encodingEv"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDsE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDsE16do_always_noconvEv = Module["__ZNKSt3__214__codecvt_utf8IDsE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDsE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDsE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__214__codecvt_utf8IDsE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDsE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDsE13do_max_lengthEv = Module["__ZNKSt3__214__codecvt_utf8IDsE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDsE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDiE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__214__codecvt_utf8IDiE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDiE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDiE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_ = Module["__ZNKSt3__214__codecvt_utf8IDiE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDiE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDiE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__214__codecvt_utf8IDiE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDiE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDiE11do_encodingEv = Module["__ZNKSt3__214__codecvt_utf8IDiE11do_encodingEv"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDiE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDiE16do_always_noconvEv = Module["__ZNKSt3__214__codecvt_utf8IDiE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDiE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDiE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__214__codecvt_utf8IDiE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDiE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__214__codecvt_utf8IDiE13do_max_lengthEv = Module["__ZNKSt3__214__codecvt_utf8IDiE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__214__codecvt_utf8IDiE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb0EE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IwLb0EE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb0EE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb0EE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IwLb0EE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb0EE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb0EE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__215__codecvt_utf16IwLb0EE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb0EE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb0EE11do_encodingEv = Module["__ZNKSt3__215__codecvt_utf16IwLb0EE11do_encodingEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb0EE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb0EE16do_always_noconvEv = Module["__ZNKSt3__215__codecvt_utf16IwLb0EE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb0EE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb0EE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__215__codecvt_utf16IwLb0EE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb0EE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb0EE13do_max_lengthEv = Module["__ZNKSt3__215__codecvt_utf16IwLb0EE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb0EE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb1EE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IwLb1EE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb1EE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb1EE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IwLb1EE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb1EE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb1EE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__215__codecvt_utf16IwLb1EE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb1EE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb1EE11do_encodingEv = Module["__ZNKSt3__215__codecvt_utf16IwLb1EE11do_encodingEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb1EE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb1EE16do_always_noconvEv = Module["__ZNKSt3__215__codecvt_utf16IwLb1EE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb1EE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb1EE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__215__codecvt_utf16IwLb1EE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb1EE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IwLb1EE13do_max_lengthEv = Module["__ZNKSt3__215__codecvt_utf16IwLb1EE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IwLb1EE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb0EE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IDsLb0EE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb0EE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb0EE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IDsLb0EE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb0EE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb0EE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__215__codecvt_utf16IDsLb0EE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb0EE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb0EE11do_encodingEv = Module["__ZNKSt3__215__codecvt_utf16IDsLb0EE11do_encodingEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb0EE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb0EE16do_always_noconvEv = Module["__ZNKSt3__215__codecvt_utf16IDsLb0EE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb0EE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb0EE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__215__codecvt_utf16IDsLb0EE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb0EE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb0EE13do_max_lengthEv = Module["__ZNKSt3__215__codecvt_utf16IDsLb0EE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb0EE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb1EE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IDsLb1EE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb1EE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb1EE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IDsLb1EE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb1EE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb1EE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__215__codecvt_utf16IDsLb1EE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb1EE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb1EE11do_encodingEv = Module["__ZNKSt3__215__codecvt_utf16IDsLb1EE11do_encodingEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb1EE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb1EE16do_always_noconvEv = Module["__ZNKSt3__215__codecvt_utf16IDsLb1EE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb1EE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb1EE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__215__codecvt_utf16IDsLb1EE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb1EE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDsLb1EE13do_max_lengthEv = Module["__ZNKSt3__215__codecvt_utf16IDsLb1EE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDsLb1EE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb0EE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IDiLb0EE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb0EE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb0EE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IDiLb0EE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb0EE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb0EE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__215__codecvt_utf16IDiLb0EE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb0EE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb0EE11do_encodingEv = Module["__ZNKSt3__215__codecvt_utf16IDiLb0EE11do_encodingEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb0EE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb0EE16do_always_noconvEv = Module["__ZNKSt3__215__codecvt_utf16IDiLb0EE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb0EE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb0EE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__215__codecvt_utf16IDiLb0EE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb0EE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb0EE13do_max_lengthEv = Module["__ZNKSt3__215__codecvt_utf16IDiLb0EE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb0EE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb1EE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IDiLb1EE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb1EE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb1EE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_ = Module["__ZNKSt3__215__codecvt_utf16IDiLb1EE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb1EE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb1EE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__215__codecvt_utf16IDiLb1EE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb1EE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb1EE11do_encodingEv = Module["__ZNKSt3__215__codecvt_utf16IDiLb1EE11do_encodingEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb1EE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb1EE16do_always_noconvEv = Module["__ZNKSt3__215__codecvt_utf16IDiLb1EE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb1EE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb1EE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__215__codecvt_utf16IDiLb1EE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb1EE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__215__codecvt_utf16IDiLb1EE13do_max_lengthEv = Module["__ZNKSt3__215__codecvt_utf16IDiLb1EE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__215__codecvt_utf16IDiLb1EE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IwE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__220__codecvt_utf8_utf16IwE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IwE6do_outER11__mbstate_tPKwS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IwE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_ = Module["__ZNKSt3__220__codecvt_utf8_utf16IwE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IwE5do_inER11__mbstate_tPKcS5_RS5_PwS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IwE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__220__codecvt_utf8_utf16IwE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IwE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IwE11do_encodingEv = Module["__ZNKSt3__220__codecvt_utf8_utf16IwE11do_encodingEv"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IwE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IwE16do_always_noconvEv = Module["__ZNKSt3__220__codecvt_utf8_utf16IwE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IwE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IwE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__220__codecvt_utf8_utf16IwE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IwE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IwE13do_max_lengthEv = Module["__ZNKSt3__220__codecvt_utf8_utf16IwE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IwE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDsE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__220__codecvt_utf8_utf16IDsE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDsE6do_outER11__mbstate_tPKDsS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDsE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_ = Module["__ZNKSt3__220__codecvt_utf8_utf16IDsE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDsE5do_inER11__mbstate_tPKcS5_RS5_PDsS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDsE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__220__codecvt_utf8_utf16IDsE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDsE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDsE11do_encodingEv = Module["__ZNKSt3__220__codecvt_utf8_utf16IDsE11do_encodingEv"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDsE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDsE16do_always_noconvEv = Module["__ZNKSt3__220__codecvt_utf8_utf16IDsE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDsE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDsE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__220__codecvt_utf8_utf16IDsE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDsE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDsE13do_max_lengthEv = Module["__ZNKSt3__220__codecvt_utf8_utf16IDsE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDsE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDiE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_ = Module["__ZNKSt3__220__codecvt_utf8_utf16IDiE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDiE6do_outER11__mbstate_tPKDiS5_RS5_PcS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDiE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_ = Module["__ZNKSt3__220__codecvt_utf8_utf16IDiE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDiE5do_inER11__mbstate_tPKcS5_RS5_PDiS7_RS7_");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDiE10do_unshiftER11__mbstate_tPcS4_RS4_ = Module["__ZNKSt3__220__codecvt_utf8_utf16IDiE10do_unshiftER11__mbstate_tPcS4_RS4_"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDiE10do_unshiftER11__mbstate_tPcS4_RS4_");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDiE11do_encodingEv = Module["__ZNKSt3__220__codecvt_utf8_utf16IDiE11do_encodingEv"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDiE11do_encodingEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDiE16do_always_noconvEv = Module["__ZNKSt3__220__codecvt_utf8_utf16IDiE16do_always_noconvEv"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDiE16do_always_noconvEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDiE9do_lengthER11__mbstate_tPKcS5_m = Module["__ZNKSt3__220__codecvt_utf8_utf16IDiE9do_lengthER11__mbstate_tPKcS5_m"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDiE9do_lengthER11__mbstate_tPKcS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__220__codecvt_utf8_utf16IDiE13do_max_lengthEv = Module["__ZNKSt3__220__codecvt_utf8_utf16IDiE13do_max_lengthEv"] = createExportWrapper("_ZNKSt3__220__codecvt_utf8_utf16IDiE13do_max_lengthEv");

/** @type {function(...*):?} */
var __ZNSt3__216__narrow_to_utf8ILm16EED0Ev = Module["__ZNSt3__216__narrow_to_utf8ILm16EED0Ev"] = createExportWrapper("_ZNSt3__216__narrow_to_utf8ILm16EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__216__narrow_to_utf8ILm32EED0Ev = Module["__ZNSt3__216__narrow_to_utf8ILm32EED0Ev"] = createExportWrapper("_ZNSt3__216__narrow_to_utf8ILm32EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__widen_from_utf8ILm16EED0Ev = Module["__ZNSt3__217__widen_from_utf8ILm16EED0Ev"] = createExportWrapper("_ZNSt3__217__widen_from_utf8ILm16EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__widen_from_utf8ILm32EED0Ev = Module["__ZNSt3__217__widen_from_utf8ILm32EED0Ev"] = createExportWrapper("_ZNSt3__217__widen_from_utf8ILm32EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__28numpunctIcED2Ev = Module["__ZNSt3__28numpunctIcED2Ev"] = createExportWrapper("_ZNSt3__28numpunctIcED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28numpunctIcED0Ev = Module["__ZNSt3__28numpunctIcED0Ev"] = createExportWrapper("_ZNSt3__28numpunctIcED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__28numpunctIwED2Ev = Module["__ZNSt3__28numpunctIwED2Ev"] = createExportWrapper("_ZNSt3__28numpunctIwED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28numpunctIwED0Ev = Module["__ZNSt3__28numpunctIwED0Ev"] = createExportWrapper("_ZNSt3__28numpunctIwED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIcE16do_decimal_pointEv = Module["__ZNKSt3__28numpunctIcE16do_decimal_pointEv"] = createExportWrapper("_ZNKSt3__28numpunctIcE16do_decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIwE16do_decimal_pointEv = Module["__ZNKSt3__28numpunctIwE16do_decimal_pointEv"] = createExportWrapper("_ZNKSt3__28numpunctIwE16do_decimal_pointEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIcE16do_thousands_sepEv = Module["__ZNKSt3__28numpunctIcE16do_thousands_sepEv"] = createExportWrapper("_ZNKSt3__28numpunctIcE16do_thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIwE16do_thousands_sepEv = Module["__ZNKSt3__28numpunctIwE16do_thousands_sepEv"] = createExportWrapper("_ZNKSt3__28numpunctIwE16do_thousands_sepEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIcE11do_groupingEv = Module["__ZNKSt3__28numpunctIcE11do_groupingEv"] = createExportWrapper("_ZNKSt3__28numpunctIcE11do_groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIwE11do_groupingEv = Module["__ZNKSt3__28numpunctIwE11do_groupingEv"] = createExportWrapper("_ZNKSt3__28numpunctIwE11do_groupingEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIcE11do_truenameEv = Module["__ZNKSt3__28numpunctIcE11do_truenameEv"] = createExportWrapper("_ZNKSt3__28numpunctIcE11do_truenameEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIwE11do_truenameEv = Module["__ZNKSt3__28numpunctIwE11do_truenameEv"] = createExportWrapper("_ZNKSt3__28numpunctIwE11do_truenameEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IDnEEPKw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IDnEEPKw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IDnEEPKw");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE6lengthEPKw = Module["__ZNSt3__211char_traitsIwE6lengthEPKw"] = createExportWrapper("_ZNSt3__211char_traitsIwE6lengthEPKw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initEPKwm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initEPKwm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initEPKwm");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIcE12do_falsenameEv = Module["__ZNKSt3__28numpunctIcE12do_falsenameEv"] = createExportWrapper("_ZNKSt3__28numpunctIcE12do_falsenameEv");

/** @type {function(...*):?} */
var __ZNKSt3__28numpunctIwE12do_falsenameEv = Module["__ZNKSt3__28numpunctIwE12do_falsenameEv"] = createExportWrapper("_ZNKSt3__28numpunctIwE12do_falsenameEv");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIcEC2EPKcm = Module["__ZNSt3__215numpunct_bynameIcEC2EPKcm"] = createExportWrapper("_ZNSt3__215numpunct_bynameIcEC2EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIcE6__initEPKc = Module["__ZNSt3__215numpunct_bynameIcE6__initEPKc"] = createExportWrapper("_ZNSt3__215numpunct_bynameIcE6__initEPKc");

/** @type {function(...*):?} */
var __ZNSt3__222__libcpp_unique_localeC2EPKc = Module["__ZNSt3__222__libcpp_unique_localeC2EPKc"] = createExportWrapper("_ZNSt3__222__libcpp_unique_localeC2EPKc");

/** @type {function(...*):?} */
var __ZNKSt3__222__libcpp_unique_localecvbEv = Module["__ZNKSt3__222__libcpp_unique_localecvbEv"] = createExportWrapper("_ZNKSt3__222__libcpp_unique_localecvbEv");

/** @type {function(...*):?} */
var __ZNSt3__222__libcpp_unique_locale3getEv = Module["__ZNSt3__222__libcpp_unique_locale3getEv"] = createExportWrapper("_ZNSt3__222__libcpp_unique_locale3getEv");

/** @type {function(...*):?} */
var __ZNSt3__221__libcpp_localeconv_lEP15__locale_struct = Module["__ZNSt3__221__libcpp_localeconv_lEP15__locale_struct"] = createExportWrapper("_ZNSt3__221__libcpp_localeconv_lEP15__locale_struct");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSEPKc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSEPKc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSEPKc");

/** @type {function(...*):?} */
var __ZNSt3__222__libcpp_unique_localeD2Ev = Module["__ZNSt3__222__libcpp_unique_localeD2Ev"] = createExportWrapper("_ZNSt3__222__libcpp_unique_localeD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIcED0Ev = Module["__ZNSt3__215numpunct_bynameIcED0Ev"] = createExportWrapper("_ZNSt3__215numpunct_bynameIcED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignEPKc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignEPKc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignEPKc");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIwEC2EPKcm = Module["__ZNSt3__215numpunct_bynameIwEC2EPKcm"] = createExportWrapper("_ZNSt3__215numpunct_bynameIwEC2EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIwE6__initEPKc = Module["__ZNSt3__215numpunct_bynameIwE6__initEPKc"] = createExportWrapper("_ZNSt3__215numpunct_bynameIwE6__initEPKc");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIwED0Ev = Module["__ZNSt3__215numpunct_bynameIwED0Ev"] = createExportWrapper("_ZNSt3__215numpunct_bynameIwED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__29__reverseIPjEEvT_S2_NS_26random_access_iterator_tagE = Module["__ZNSt3__29__reverseIPjEEvT_S2_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__29__reverseIPjEEvT_S2_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIcE7__weeksEv = Module["__ZNKSt3__220__time_get_c_storageIcE7__weeksEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIcE7__weeksEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIwE7__weeksEv = Module["__ZNKSt3__220__time_get_c_storageIwE7__weeksEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIwE7__weeksEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSEPKw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSEPKw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSEPKw");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIcE8__monthsEv = Module["__ZNKSt3__220__time_get_c_storageIcE8__monthsEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIcE8__monthsEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIwE8__monthsEv = Module["__ZNKSt3__220__time_get_c_storageIwE8__monthsEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIwE8__monthsEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIcE7__am_pmEv = Module["__ZNKSt3__220__time_get_c_storageIcE7__am_pmEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIcE7__am_pmEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIwE7__am_pmEv = Module["__ZNKSt3__220__time_get_c_storageIwE7__am_pmEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIwE7__am_pmEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIcE3__xEv = Module["__ZNKSt3__220__time_get_c_storageIcE3__xEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIcE3__xEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIwE3__xEv = Module["__ZNKSt3__220__time_get_c_storageIwE3__xEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIwE3__xEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIcE3__XEv = Module["__ZNKSt3__220__time_get_c_storageIcE3__XEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIcE3__XEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIwE3__XEv = Module["__ZNKSt3__220__time_get_c_storageIwE3__XEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIwE3__XEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIcE3__cEv = Module["__ZNKSt3__220__time_get_c_storageIcE3__cEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIcE3__cEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIwE3__cEv = Module["__ZNKSt3__220__time_get_c_storageIwE3__cEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIwE3__cEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIcE3__rEv = Module["__ZNKSt3__220__time_get_c_storageIcE3__rEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIcE3__rEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__time_get_c_storageIwE3__rEv = Module["__ZNKSt3__220__time_get_c_storageIwE3__rEv"] = createExportWrapper("_ZNKSt3__220__time_get_c_storageIwE3__rEv");

/** @type {function(...*):?} */
var __ZNSt3__210__time_getC2EPKc = Module["__ZNSt3__210__time_getC2EPKc"] = createExportWrapper("_ZNSt3__210__time_getC2EPKc");

/** @type {function(...*):?} */
var __ZNSt3__210__time_getC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__210__time_getC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__210__time_getC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__210__time_getD2Ev = Module["__ZNSt3__210__time_getD2Ev"] = createExportWrapper("_ZNSt3__210__time_getD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIcE9__analyzeEcRKNS_5ctypeIcEE = Module["__ZNSt3__218__time_get_storageIcE9__analyzeEcRKNS_5ctypeIcEE"] = createExportWrapper("_ZNSt3__218__time_get_storageIcE9__analyzeEcRKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNSt3__214__scan_keywordIPcPNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_5ctypeIcEEEET0_RT_SC_SB_SB_RKT1_Rjb = Module["__ZNSt3__214__scan_keywordIPcPNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_5ctypeIcEEEET0_RT_SC_SB_SB_RKT1_Rjb"] = createExportWrapper("_ZNSt3__214__scan_keywordIPcPNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_5ctypeIcEEEET0_RT_SC_SB_SB_RKT1_Rjb");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4backEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4backEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4backEv");

/** @type {function(...*):?} */
var __ZNSt3__220__get_up_to_n_digitsIcPcEEiRT0_S2_RjRKNS_5ctypeIT_EEi = Module["__ZNSt3__220__get_up_to_n_digitsIcPcEEiRT0_S2_RjRKNS_5ctypeIT_EEi"] = createExportWrapper("_ZNSt3__220__get_up_to_n_digitsIcPcEEiRT0_S2_RjRKNS_5ctypeIT_EEi");

/** @type {function(...*):?} */
var __ZNSt3__28distanceIPNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_ = Module["__ZNSt3__28distanceIPNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_"] = createExportWrapper("_ZNSt3__28distanceIPNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIwE9__analyzeEcRKNS_5ctypeIwEE = Module["__ZNSt3__218__time_get_storageIwE9__analyzeEcRKNS_5ctypeIwEE"] = createExportWrapper("_ZNSt3__218__time_get_storageIwE9__analyzeEcRKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNSt3__214__scan_keywordIPwPNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEENS_5ctypeIwEEEET0_RT_SC_SB_SB_RKT1_Rjb = Module["__ZNSt3__214__scan_keywordIPwPNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEENS_5ctypeIwEEEET0_RT_SC_SB_SB_RKT1_Rjb"] = createExportWrapper("_ZNSt3__214__scan_keywordIPwPNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEENS_5ctypeIwEEEET0_RT_SC_SB_SB_RKT1_Rjb");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4backEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4backEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4backEv");

/** @type {function(...*):?} */
var __ZNSt3__220__get_up_to_n_digitsIwPwEEiRT0_S2_RjRKNS_5ctypeIT_EEi = Module["__ZNSt3__220__get_up_to_n_digitsIwPwEEiRT0_S2_RjRKNS_5ctypeIT_EEi"] = createExportWrapper("_ZNSt3__220__get_up_to_n_digitsIwPwEEiRT0_S2_RjRKNS_5ctypeIT_EEi");

/** @type {function(...*):?} */
var __ZNSt3__28distanceIPNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_ = Module["__ZNSt3__28distanceIPNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_"] = createExportWrapper("_ZNSt3__28distanceIPNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIcE4initERKNS_5ctypeIcEE = Module["__ZNSt3__218__time_get_storageIcE4initERKNS_5ctypeIcEE"] = createExportWrapper("_ZNSt3__218__time_get_storageIcE4initERKNS_5ctypeIcEE");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIwE4initERKNS_5ctypeIwEE = Module["__ZNSt3__218__time_get_storageIwE4initERKNS_5ctypeIwEE"] = createExportWrapper("_ZNSt3__218__time_get_storageIwE4initERKNS_5ctypeIwEE");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignIPwEENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr38__libcpp_string_gets_noexcept_iteratorIS9_EE5valueERS5_E4typeES9_S9_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignIPwEENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr38__libcpp_string_gets_noexcept_iteratorIS9_EE5valueERS5_E4typeES9_S9_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignIPwEENS_9enable_ifIXaasr27__is_cpp17_forward_iteratorIT_EE5valuesr38__libcpp_string_gets_noexcept_iteratorIS9_EE5valueERS5_E4typeES9_S9_");

/** @type {function(...*):?} */
var __ZNSt3__28distanceIPwEENS_15iterator_traitsIT_E15difference_typeES3_S3_ = Module["__ZNSt3__28distanceIPwEENS_15iterator_traitsIT_E15difference_typeES3_S3_"] = createExportWrapper("_ZNSt3__28distanceIPwEENS_15iterator_traitsIT_E15difference_typeES3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE8capacityEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE8capacityEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE8capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE9__grow_byEmmmmmm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE9__grow_byEmmmmmm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE9__grow_byEmmmmmm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE27__invalidate_iterators_pastEm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE27__invalidate_iterators_pastEm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE27__invalidate_iterators_pastEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE10__set_sizeEm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE10__set_sizeEm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE10__set_sizeEm");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIcEC2EPKc = Module["__ZNSt3__218__time_get_storageIcEC2EPKc"] = createExportWrapper("_ZNSt3__218__time_get_storageIcEC2EPKc");

/** @type {function(...*):?} */
var __ZNSt3__215__time_get_tempIcEC2EPKc = Module["__ZNSt3__215__time_get_tempIcEC2EPKc"] = createExportWrapper("_ZNSt3__215__time_get_tempIcEC2EPKc");

/** @type {function(...*):?} */
var __ZNSt3__215__time_get_tempIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__215__time_get_tempIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__215__time_get_tempIcEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIwEC2EPKc = Module["__ZNSt3__218__time_get_storageIwEC2EPKc"] = createExportWrapper("_ZNSt3__218__time_get_storageIwEC2EPKc");

/** @type {function(...*):?} */
var __ZNSt3__215__time_get_tempIwEC2EPKc = Module["__ZNSt3__215__time_get_tempIwEC2EPKc"] = createExportWrapper("_ZNSt3__215__time_get_tempIwEC2EPKc");

/** @type {function(...*):?} */
var __ZNSt3__215__time_get_tempIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__215__time_get_tempIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__215__time_get_tempIwEC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNKSt3__218__time_get_storageIcE15__do_date_orderEv = Module["__ZNKSt3__218__time_get_storageIcE15__do_date_orderEv"] = createExportWrapper("_ZNKSt3__218__time_get_storageIcE15__do_date_orderEv");

/** @type {function(...*):?} */
var __ZNKSt3__218__time_get_storageIwE15__do_date_orderEv = Module["__ZNKSt3__218__time_get_storageIwE15__do_date_orderEv"] = createExportWrapper("_ZNKSt3__218__time_get_storageIwE15__do_date_orderEv");

/** @type {function(...*):?} */
var __ZNSt3__210__time_putC2EPKc = Module["__ZNSt3__210__time_putC2EPKc"] = createExportWrapper("_ZNSt3__210__time_putC2EPKc");

/** @type {function(...*):?} */
var __ZNSt3__210__time_putC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__210__time_putC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__210__time_putC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__210__time_putD2Ev = Module["__ZNSt3__210__time_putD2Ev"] = createExportWrapper("_ZNSt3__210__time_putD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26rotateINS_11__wrap_iterIPcEEEET_S4_S4_S4_ = Module["__ZNSt3__26rotateINS_11__wrap_iterIPcEEEET_S4_S4_S4_"] = createExportWrapper("_ZNSt3__26rotateINS_11__wrap_iterIPcEEEET_S4_S4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmmc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmmc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmmc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5eraseENS_11__wrap_iterIPKcEE = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5eraseENS_11__wrap_iterIPKcEE"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5eraseENS_11__wrap_iterIPKcEE");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE8pop_backEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE8pop_backEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE8pop_backEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignEPKw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignEPKw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignEPKw");

/** @type {function(...*):?} */
var __ZNSt3__26rotateINS_11__wrap_iterIPwEEEET_S4_S4_S4_ = Module["__ZNSt3__26rotateINS_11__wrap_iterIPwEEEET_S4_S4_S4_"] = createExportWrapper("_ZNSt3__26rotateINS_11__wrap_iterIPwEEEET_S4_S4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmmw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmmw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmmw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5eraseENS_11__wrap_iterIPKwEE = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5eraseENS_11__wrap_iterIPKwEE"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5eraseENS_11__wrap_iterIPKwEE");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE8pop_backEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE8pop_backEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE8pop_backEv");

/** @type {function(...*):?} */
var __ZNSt3__214__codecvt_utf8IwED0Ev = Module["__ZNSt3__214__codecvt_utf8IwED0Ev"] = createExportWrapper("_ZNSt3__214__codecvt_utf8IwED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__214__codecvt_utf8IDsED0Ev = Module["__ZNSt3__214__codecvt_utf8IDsED0Ev"] = createExportWrapper("_ZNSt3__214__codecvt_utf8IDsED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__214__codecvt_utf8IDiED0Ev = Module["__ZNSt3__214__codecvt_utf8IDiED0Ev"] = createExportWrapper("_ZNSt3__214__codecvt_utf8IDiED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215__codecvt_utf16IwLb0EED0Ev = Module["__ZNSt3__215__codecvt_utf16IwLb0EED0Ev"] = createExportWrapper("_ZNSt3__215__codecvt_utf16IwLb0EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215__codecvt_utf16IwLb1EED0Ev = Module["__ZNSt3__215__codecvt_utf16IwLb1EED0Ev"] = createExportWrapper("_ZNSt3__215__codecvt_utf16IwLb1EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215__codecvt_utf16IDsLb0EED0Ev = Module["__ZNSt3__215__codecvt_utf16IDsLb0EED0Ev"] = createExportWrapper("_ZNSt3__215__codecvt_utf16IDsLb0EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215__codecvt_utf16IDsLb1EED0Ev = Module["__ZNSt3__215__codecvt_utf16IDsLb1EED0Ev"] = createExportWrapper("_ZNSt3__215__codecvt_utf16IDsLb1EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215__codecvt_utf16IDiLb0EED0Ev = Module["__ZNSt3__215__codecvt_utf16IDiLb0EED0Ev"] = createExportWrapper("_ZNSt3__215__codecvt_utf16IDiLb0EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215__codecvt_utf16IDiLb1EED0Ev = Module["__ZNSt3__215__codecvt_utf16IDiLb1EED0Ev"] = createExportWrapper("_ZNSt3__215__codecvt_utf16IDiLb1EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__codecvt_utf8_utf16IwED0Ev = Module["__ZNSt3__220__codecvt_utf8_utf16IwED0Ev"] = createExportWrapper("_ZNSt3__220__codecvt_utf8_utf16IwED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__codecvt_utf8_utf16IDiED0Ev = Module["__ZNSt3__220__codecvt_utf8_utf16IDiED0Ev"] = createExportWrapper("_ZNSt3__220__codecvt_utf8_utf16IDiED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__codecvt_utf8_utf16IDsED0Ev = Module["__ZNSt3__220__codecvt_utf8_utf16IDsED0Ev"] = createExportWrapper("_ZNSt3__220__codecvt_utf8_utf16IDsED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev = Module["__ZNSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev"] = createExportWrapper("_ZNSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev = Module["__ZNSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev"] = createExportWrapper("_ZNSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev = Module["__ZNSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev"] = createExportWrapper("_ZNSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev = Module["__ZNSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev"] = createExportWrapper("_ZNSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED2Ev = Module["__ZNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED2Ev"] = createExportWrapper("_ZNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__time_get_c_storageIcED2Ev = Module["__ZNSt3__220__time_get_c_storageIcED2Ev"] = createExportWrapper("_ZNSt3__220__time_get_c_storageIcED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev = Module["__ZNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev"] = createExportWrapper("_ZNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED2Ev = Module["__ZNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED2Ev"] = createExportWrapper("_ZNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__time_get_c_storageIwED2Ev = Module["__ZNSt3__220__time_get_c_storageIwED2Ev"] = createExportWrapper("_ZNSt3__220__time_get_c_storageIwED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev = Module["__ZNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev"] = createExportWrapper("_ZNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED2Ev = Module["__ZNSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED2Ev"] = createExportWrapper("_ZNSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIcED2Ev = Module["__ZNSt3__218__time_get_storageIcED2Ev"] = createExportWrapper("_ZNSt3__218__time_get_storageIcED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev = Module["__ZNSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev"] = createExportWrapper("_ZNSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13do_date_orderEv = Module["__ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13do_date_orderEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE13do_date_orderEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__weeksEv = Module["__ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__weeksEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__weeksEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE8__monthsEv = Module["__ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE8__monthsEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE8__monthsEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__am_pmEv = Module["__ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__am_pmEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__am_pmEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__cEv = Module["__ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__cEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__cEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__rEv = Module["__ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__rEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__rEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__xEv = Module["__ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__xEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__xEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__XEv = Module["__ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__XEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__XEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__weeksEv = Module["__ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__weeksEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__weeksEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE8__monthsEv = Module["__ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE8__monthsEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE8__monthsEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__am_pmEv = Module["__ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__am_pmEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE7__am_pmEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__cEv = Module["__ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__cEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__cEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__rEv = Module["__ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__rEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__rEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__xEv = Module["__ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__xEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__xEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__XEv = Module["__ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__XEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE3__XEv");

/** @type {function(...*):?} */
var __ZNSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED2Ev = Module["__ZNSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED2Ev"] = createExportWrapper("_ZNSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIwED2Ev = Module["__ZNSt3__218__time_get_storageIwED2Ev"] = createExportWrapper("_ZNSt3__218__time_get_storageIwED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev = Module["__ZNSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev"] = createExportWrapper("_ZNSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13do_date_orderEv = Module["__ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13do_date_orderEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE13do_date_orderEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__weeksEv = Module["__ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__weeksEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__weeksEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE8__monthsEv = Module["__ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE8__monthsEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE8__monthsEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__am_pmEv = Module["__ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__am_pmEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__am_pmEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__cEv = Module["__ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__cEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__cEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__rEv = Module["__ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__rEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__rEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__xEv = Module["__ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__xEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__xEv");

/** @type {function(...*):?} */
var __ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__XEv = Module["__ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__XEv"] = createExportWrapper("_ZNKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__XEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__weeksEv = Module["__ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__weeksEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__weeksEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE8__monthsEv = Module["__ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE8__monthsEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE8__monthsEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__am_pmEv = Module["__ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__am_pmEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE7__am_pmEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__cEv = Module["__ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__cEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__cEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__rEv = Module["__ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__rEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__rEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__xEv = Module["__ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__xEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__xEv");

/** @type {function(...*):?} */
var __ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__XEv = Module["__ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__XEv"] = createExportWrapper("_ZThn8_NKSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE3__XEv");

/** @type {function(...*):?} */
var __ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev = Module["__ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev"] = createExportWrapper("_ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED2Ev = Module["__ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED2Ev"] = createExportWrapper("_ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev = Module["__ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev"] = createExportWrapper("_ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED2Ev = Module["__ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED2Ev"] = createExportWrapper("_ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__215time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev = Module["__ZNSt3__215time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev"] = createExportWrapper("_ZNSt3__215time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev = Module["__ZNSt3__215time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev"] = createExportWrapper("_ZNSt3__215time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__210moneypunctIcLb0EED0Ev = Module["__ZNSt3__210moneypunctIcLb0EED0Ev"] = createExportWrapper("_ZNSt3__210moneypunctIcLb0EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__210moneypunctIcLb1EED0Ev = Module["__ZNSt3__210moneypunctIcLb1EED0Ev"] = createExportWrapper("_ZNSt3__210moneypunctIcLb1EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__210moneypunctIwLb0EED0Ev = Module["__ZNSt3__210moneypunctIwLb0EED0Ev"] = createExportWrapper("_ZNSt3__210moneypunctIwLb0EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__210moneypunctIwLb1EED0Ev = Module["__ZNSt3__210moneypunctIwLb1EED0Ev"] = createExportWrapper("_ZNSt3__210moneypunctIwLb1EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIcLb0EED2Ev = Module["__ZNSt3__217moneypunct_bynameIcLb0EED2Ev"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIcLb0EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIcLb0EED0Ev = Module["__ZNSt3__217moneypunct_bynameIcLb0EED0Ev"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIcLb0EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIcLb1EED2Ev = Module["__ZNSt3__217moneypunct_bynameIcLb1EED2Ev"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIcLb1EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIcLb1EED0Ev = Module["__ZNSt3__217moneypunct_bynameIcLb1EED0Ev"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIcLb1EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIwLb0EED2Ev = Module["__ZNSt3__217moneypunct_bynameIwLb0EED2Ev"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIwLb0EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIwLb0EED0Ev = Module["__ZNSt3__217moneypunct_bynameIwLb0EED0Ev"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIwLb0EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIwLb1EED2Ev = Module["__ZNSt3__217moneypunct_bynameIwLb1EED2Ev"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIwLb1EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217moneypunct_bynameIwLb1EED0Ev = Module["__ZNSt3__217moneypunct_bynameIwLb1EED0Ev"] = createExportWrapper("_ZNSt3__217moneypunct_bynameIwLb1EED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev = Module["__ZNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev"] = createExportWrapper("_ZNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev = Module["__ZNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev"] = createExportWrapper("_ZNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev = Module["__ZNSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev"] = createExportWrapper("_ZNSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev = Module["__ZNSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev"] = createExportWrapper("_ZNSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__28messagesIcED0Ev = Module["__ZNSt3__28messagesIcED0Ev"] = createExportWrapper("_ZNSt3__28messagesIcED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__28messagesIwED0Ev = Module["__ZNSt3__28messagesIwED0Ev"] = createExportWrapper("_ZNSt3__28messagesIwED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215messages_bynameIcED0Ev = Module["__ZNSt3__215messages_bynameIcED0Ev"] = createExportWrapper("_ZNSt3__215messages_bynameIcED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215messages_bynameIwED0Ev = Module["__ZNSt3__215messages_bynameIwED0Ev"] = createExportWrapper("_ZNSt3__215messages_bynameIwED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPcEpLEl = Module["__ZNSt3__211__wrap_iterIPcEpLEl"] = createExportWrapper("_ZNSt3__211__wrap_iterIPcEpLEl");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPwEpLEl = Module["__ZNSt3__211__wrap_iterIPwEpLEl"] = createExportWrapper("_ZNSt3__211__wrap_iterIPwEpLEl");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIcEEE10deallocateERS2_Pcm = Module["__ZNSt3__216allocator_traitsINS_9allocatorIcEEE10deallocateERS2_Pcm"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIcEEE10deallocateERS2_Pcm");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIcE10deallocateEPcm = Module["__ZNSt3__29allocatorIcE10deallocateEPcm"] = createExportWrapper("_ZNSt3__29allocatorIcE10deallocateEPcm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7__allocEv = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7__allocEv"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E6secondEv = Module["__ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__219__libcpp_deallocateEPvmm = Module["__ZNSt3__219__libcpp_deallocateEPvmm"] = createExportWrapper("_ZNSt3__219__libcpp_deallocateEPvmm");

/** @type {function(...*):?} */
var __ZNSt3__217_DeallocateCaller33__do_deallocate_handle_size_alignEPvmm = Module["__ZNSt3__217_DeallocateCaller33__do_deallocate_handle_size_alignEPvmm"] = createExportWrapper("_ZNSt3__217_DeallocateCaller33__do_deallocate_handle_size_alignEPvmm");

/** @type {function(...*):?} */
var __ZNSt3__217_DeallocateCaller27__do_deallocate_handle_sizeEPvm = Module["__ZNSt3__217_DeallocateCaller27__do_deallocate_handle_sizeEPvm"] = createExportWrapper("_ZNSt3__217_DeallocateCaller27__do_deallocate_handle_sizeEPvm");

/** @type {function(...*):?} */
var __ZNSt3__217_DeallocateCaller9__do_callEPv = Module["__ZNSt3__217_DeallocateCaller9__do_callEPv"] = createExportWrapper("_ZNSt3__217_DeallocateCaller9__do_callEPv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E5firstEv = Module["__ZNKSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIwEEE10deallocateERS2_Pwm = Module["__ZNSt3__216allocator_traitsINS_9allocatorIwEEE10deallocateERS2_Pwm"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIwEEE10deallocateERS2_Pwm");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIwE10deallocateEPwm = Module["__ZNSt3__29allocatorIwE10deallocateEPwm"] = createExportWrapper("_ZNSt3__29allocatorIwE10deallocateEPwm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7__allocEv = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7__allocEv"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E6secondEv = Module["__ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E5firstEv = Module["__ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE14__get_long_capEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE14__get_long_capEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE14__get_long_capEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__220__vector_base_commonILb1EEC2Ev = Module["__ZNSt3__220__vector_base_commonILb1EEC2Ev"] = createExportWrapper("_ZNSt3__220__vector_base_commonILb1EEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEC2IDnNS_18__default_init_tagEEEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEC2IDnNS_18__default_init_tagEEEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEEC2IDnNS_18__default_init_tagEEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8max_sizeEv = Module["__ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__220__vector_base_commonILb1EE20__throw_length_errorEv = Module["__ZNKSt3__220__vector_base_commonILb1EE20__throw_length_errorEv"] = createExportWrapper("_ZNKSt3__220__vector_base_commonILb1EE20__throw_length_errorEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE7__allocEv = Module["__ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE7__allocEv"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE8allocateERS5_m = Module["__ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE8allocateERS5_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE8allocateERS5_m");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv = Module["__ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE14__annotate_newEm = Module["__ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE14__annotate_newEm"] = createExportWrapper("_ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE14__annotate_newEm");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionC2ERS6_m = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionC2ERS6_m"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionC2ERS6_m");

/** @type {function(...*):?} */
var __ZNSt3__212__to_addressIPNS_6locale5facetEEEPT_S5_ = Module["__ZNSt3__212__to_addressIPNS_6locale5facetEEEPT_S5_"] = createExportWrapper("_ZNSt3__212__to_addressIPNS_6locale5facetEEEPT_S5_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE9constructIS4_JEEEvRS5_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE9constructIS4_JEEEvRS5_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE9constructIS4_JEEEvRS5_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionD2Ev = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionD2Ev"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIDnEEOT_RNS_16remove_referenceIS1_E4typeE = Module["__ZNSt3__27forwardIDnEEOT_RNS_16remove_referenceIS1_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIDnEEOT_RNS_16remove_referenceIS1_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPPNS_6locale5facetELi0ELb0EEC2IDnvEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPPNS_6locale5facetELi0ELb0EEC2IDnvEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPPNS_6locale5facetELi0ELb0EEC2IDnvEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__215__sso_allocatorIPNS_6locale5facetELm28EEC2Ev = Module["__ZNSt3__215__sso_allocatorIPNS_6locale5facetELm28EEC2Ev"] = createExportWrapper("_ZNSt3__215__sso_allocatorIPNS_6locale5facetELm28EEC2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE7__allocEv = Module["__ZNKSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE7__allocEv"] = createExportWrapper("_ZNKSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE8max_sizeERKS5_ = Module["__ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE8max_sizeERKS5_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE8max_sizeERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__215__sso_allocatorIPNS_6locale5facetELm28EE8allocateEmPKv = Module["__ZNSt3__215__sso_allocatorIPNS_6locale5facetELm28EE8allocateEmPKv"] = createExportWrapper("_ZNSt3__215__sso_allocatorIPNS_6locale5facetELm28EE8allocateEmPKv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6secondEv = Module["__ZNSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5firstEv = Module["__ZNSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE4dataEv = Module["__ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE4dataEv"] = createExportWrapper("_ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE4dataEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8capacityEv = Module["__ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8capacityEv"] = createExportWrapper("_ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8capacityEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE31__annotate_contiguous_containerEPKvS8_S8_S8_ = Module["__ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE31__annotate_contiguous_containerEPKvS8_S8_S8_"] = createExportWrapper("_ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE31__annotate_contiguous_containerEPKvS8_S8_S8_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE10__max_sizeENS_17integral_constantIbLb1EEERKS5_ = Module["__ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE10__max_sizeENS_17integral_constantIbLb1EEERKS5_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE10__max_sizeENS_17integral_constantIbLb1EEERKS5_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6secondEv = Module["__ZNKSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6secondEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__215__sso_allocatorIPNS_6locale5facetELm28EE8max_sizeEv = Module["__ZNKSt3__215__sso_allocatorIPNS_6locale5facetELm28EE8max_sizeEv"] = createExportWrapper("_ZNKSt3__215__sso_allocatorIPNS_6locale5facetELm28EE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemINS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemINS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemINS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__217__libcpp_allocateEmm = Module["__ZNSt3__217__libcpp_allocateEmm"] = createExportWrapper("_ZNSt3__217__libcpp_allocateEmm");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPPNS_6locale5facetELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPPNS_6locale5facetELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPPNS_6locale5facetELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8capacityEv = Module["__ZNKSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8capacityEv"] = createExportWrapper("_ZNKSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE8capacityEv");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv = Module["__ZNKSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv"] = createExportWrapper("_ZNKSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPPNS_6locale5facetELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPPNS_6locale5facetELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPPNS_6locale5facetELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE11__constructIS4_JEEEvNS_17integral_constantIbLb0EEERS5_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE11__constructIS4_JEEEvNS_17integral_constantIbLb0EEERS5_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE11__constructIS4_JEEEvNS_17integral_constantIbLb0EEERS5_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE8max_sizeEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7__allocEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7__allocEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIcEEE8max_sizeERKS2_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIcEEE8max_sizeERKS2_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIcEEE8max_sizeERKS2_");

/** @type {function(...*):?} */
var __ZNSt3__214pointer_traitsIPcE10pointer_toERc = Module["__ZNSt3__214pointer_traitsIPcE10pointer_toERc"] = createExportWrapper("_ZNSt3__214pointer_traitsIPcE10pointer_toERc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE11__recommendEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE11__recommendEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE11__recommendEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE10__align_itILm16EEEmm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE10__align_itILm16EEEmm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE10__align_itILm16EEEmm");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIcEEE8allocateERS2_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorIcEEE8allocateERS2_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIcEEE8allocateERS2_m");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIcE8allocateEmPKv = Module["__ZNSt3__29allocatorIcE8allocateEmPKv"] = createExportWrapper("_ZNSt3__29allocatorIcE8allocateEmPKv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE18__set_long_pointerEPc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE18__set_long_pointerEPc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE18__set_long_pointerEPc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE14__set_long_capEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE14__set_long_capEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE14__set_long_capEm");

/** @type {function(...*):?} */
var __ZNSt3__212__to_addressIcEEPT_S2_ = Module["__ZNSt3__212__to_addressIcEEPT_S2_"] = createExportWrapper("_ZNSt3__212__to_addressIcEEPT_S2_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIcEEE10__max_sizeENS_17integral_constantIbLb1EEERKS2_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIcEEE10__max_sizeENS_17integral_constantIbLb1EEERKS2_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIcEEE10__max_sizeENS_17integral_constantIbLb1EEERKS2_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E6secondEv = Module["__ZNKSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E6secondEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_E6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__29allocatorIcE8max_sizeEv = Module["__ZNKSt3__29allocatorIcE8max_sizeEv"] = createExportWrapper("_ZNKSt3__29allocatorIcE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__29addressofIcEEPT_RS1_ = Module["__ZNSt3__29addressofIcEEPT_RS1_"] = createExportWrapper("_ZNSt3__29addressofIcEEPT_RS1_");

/** @type {function(...*):?} */
var __ZNSt3__220__throw_length_errorEPKc = Module["__ZNSt3__220__throw_length_errorEPKc"] = createExportWrapper("_ZNSt3__220__throw_length_errorEPKc");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE10deallocateERS5_PS4_m = Module["__ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE10deallocateERS5_PS4_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE10deallocateERS5_PS4_m");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_ = Module["__ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_");

/** @type {function(...*):?} */
var __ZNSt3__215__sso_allocatorIPNS_6locale5facetELm28EE10deallocateEPS3_m = Module["__ZNSt3__215__sso_allocatorIPNS_6locale5facetELm28EE10deallocateEPS3_m"] = createExportWrapper("_ZNSt3__215__sso_allocatorIPNS_6locale5facetELm28EE10deallocateEPS3_m");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE7destroyIS4_EEvRS5_PT_ = Module["__ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE7destroyIS4_EEvRS5_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE7destroyIS4_EEvRS5_PT_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE9__destroyIS4_EEvNS_17integral_constantIbLb0EEERS5_PT_ = Module["__ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE9__destroyIS4_EEvNS_17integral_constantIbLb0EEERS5_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE9__destroyIS4_EEvNS_17integral_constantIbLb0EEERS5_PT_");

/** @type {function(...*):?} */
var __ZNSt3__210money_baseC2Ev = Module["__ZNSt3__210money_baseC2Ev"] = createExportWrapper("_ZNSt3__210money_baseC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__211__money_getIcEC2Ev = Module["__ZNSt3__211__money_getIcEC2Ev"] = createExportWrapper("_ZNSt3__211__money_getIcEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__211__money_getIwEC2Ev = Module["__ZNSt3__211__money_getIwEC2Ev"] = createExportWrapper("_ZNSt3__211__money_getIwEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__211__money_putIcEC2Ev = Module["__ZNSt3__211__money_putIcEC2Ev"] = createExportWrapper("_ZNSt3__211__money_putIcEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__211__money_putIwEC2Ev = Module["__ZNSt3__211__money_putIwEC2Ev"] = createExportWrapper("_ZNSt3__211__money_putIwEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__time_get_c_storageIcEC2Ev = Module["__ZNSt3__220__time_get_c_storageIcEC2Ev"] = createExportWrapper("_ZNSt3__220__time_get_c_storageIcEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__time_get_c_storageIwEC2Ev = Module["__ZNSt3__220__time_get_c_storageIwEC2Ev"] = createExportWrapper("_ZNSt3__220__time_get_c_storageIwEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210__time_putC2Ev = Module["__ZNSt3__210__time_putC2Ev"] = createExportWrapper("_ZNSt3__210__time_putC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213messages_baseC2Ev = Module["__ZNSt3__213messages_baseC2Ev"] = createExportWrapper("_ZNSt3__213messages_baseC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE19__copy_assign_allocERKS6_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE19__copy_assign_allocERKS6_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE19__copy_assign_allocERKS6_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNSt3__28distanceIPPNS_6locale5facetEEENS_15iterator_traitsIT_E15difference_typeES6_S6_ = Module["__ZNSt3__28distanceIPPNS_6locale5facetEEENS_15iterator_traitsIT_E15difference_typeES6_S6_"] = createExportWrapper("_ZNSt3__28distanceIPPNS_6locale5facetEEENS_15iterator_traitsIT_E15difference_typeES6_S6_");

/** @type {function(...*):?} */
var __ZNSt3__27advanceIPPNS_6locale5facetEEEvRT_NS_15iterator_traitsIS5_E15difference_typeE = Module["__ZNSt3__27advanceIPPNS_6locale5facetEEEvRT_NS_15iterator_traitsIS5_E15difference_typeE"] = createExportWrapper("_ZNSt3__27advanceIPPNS_6locale5facetEEEvRT_NS_15iterator_traitsIS5_E15difference_typeE");

/** @type {function(...*):?} */
var __ZNSt3__24copyIPPNS_6locale5facetES4_EET0_T_S6_S5_ = Module["__ZNSt3__24copyIPPNS_6locale5facetES4_EET0_T_S6_S5_"] = createExportWrapper("_ZNSt3__24copyIPPNS_6locale5facetES4_EET0_T_S6_S5_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE18__construct_at_endIPS3_EENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESA_SA_m = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE18__construct_at_endIPS3_EENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESA_SA_m"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE18__construct_at_endIPS3_EENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESA_SA_m");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE13__vdeallocateEv = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE13__vdeallocateEv"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE13__vdeallocateEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE11__recommendEm = Module["__ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE11__recommendEm"] = createExportWrapper("_ZNKSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE11__recommendEm");

/** @type {function(...*):?} */
var __ZNSt3__210__distanceIPPNS_6locale5facetEEENS_15iterator_traitsIT_E15difference_typeES6_S6_NS_26random_access_iterator_tagE = Module["__ZNSt3__210__distanceIPPNS_6locale5facetEEENS_15iterator_traitsIT_E15difference_typeES6_S6_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__210__distanceIPPNS_6locale5facetEEENS_15iterator_traitsIT_E15difference_typeES6_S6_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__29__advanceIPPNS_6locale5facetEEEvRT_NS_15iterator_traitsIS5_E15difference_typeENS_26random_access_iterator_tagE = Module["__ZNSt3__29__advanceIPPNS_6locale5facetEEEvRT_NS_15iterator_traitsIS5_E15difference_typeENS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__29__advanceIPPNS_6locale5facetEEEvRT_NS_15iterator_traitsIS5_E15difference_typeENS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__213__unwrap_iterIPPNS_6locale5facetEEET_S5_ = Module["__ZNSt3__213__unwrap_iterIPPNS_6locale5facetEEET_S5_"] = createExportWrapper("_ZNSt3__213__unwrap_iterIPPNS_6locale5facetEEET_S5_");

/** @type {function(...*):?} */
var __ZNSt3__26__copyIPNS_6locale5facetES3_EENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS9_EE5valueEPS9_E4typeEPS6_SD_SA_ = Module["__ZNSt3__26__copyIPNS_6locale5facetES3_EENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS9_EE5valueEPS9_E4typeEPS6_SD_SA_"] = createExportWrapper("_ZNSt3__26__copyIPNS_6locale5facetES3_EENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS9_EE5valueEPS9_E4typeEPS6_SD_SA_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE25__construct_range_forwardIS4_S4_S4_S4_EENS_9enable_ifIXaaaasr31is_trivially_move_constructibleIT0_EE5valuesr7is_sameIT1_T2_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS5_PS9_RT_EE5valueEvE4typeERS5_PSF_SK_RSE_ = Module["__ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE25__construct_range_forwardIS4_S4_S4_S4_EENS_9enable_ifIXaaaasr31is_trivially_move_constructibleIT0_EE5valuesr7is_sameIT1_T2_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS5_PS9_RT_EE5valueEvE4typeERS5_PSF_SK_RSE_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE25__construct_range_forwardIS4_S4_S4_S4_EENS_9enable_ifIXaaaasr31is_trivially_move_constructibleIT0_EE5valuesr7is_sameIT1_T2_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS5_PS9_RT_EE5valueEvE4typeERS5_PSF_SK_RSE_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE27__invalidate_iterators_pastEPS3_ = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE27__invalidate_iterators_pastEPS3_"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE27__invalidate_iterators_pastEPS3_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPNS_6locale5facetEEEOT_RNS_16remove_referenceIS5_E4typeE = Module["__ZNSt3__27forwardIRPNS_6locale5facetEEEOT_RNS_16remove_referenceIS5_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPNS_6locale5facetEEEOT_RNS_16remove_referenceIS5_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_6locale5facetELi0ELb0EEC2IRS3_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPNS_6locale5facetELi0ELb0EEC2IRS3_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_6locale5facetELi0ELb0EEC2IRS3_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_6locale5facetELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPNS_6locale5facetELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_6locale5facetELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPNS_6locale5facetELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPNS_6locale5facetELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPNS_6locale5facetELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEEC2EmmS6_ = Module["__ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEEC2EmmS6_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEEC2EmmS6_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE18__construct_at_endEm = Module["__ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE18__construct_at_endEm"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE18__construct_at_endEm");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE26__swap_out_circular_bufferERNS_14__split_bufferIS3_RS5_EE = Module["__ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE26__swap_out_circular_bufferERNS_14__split_bufferIS3_RS5_EE"] = createExportWrapper("_ZNSt3__26vectorIPNS_6locale5facetENS_15__sso_allocatorIS3_Lm28EEEE26__swap_out_circular_bufferERNS_14__split_bufferIS3_RS5_EE");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEED2Ev = Module["__ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEED2Ev"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEEC2IDnS7_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEEC2IDnS7_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEEC2IDnS7_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE7__allocEv = Module["__ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE7__allocEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv = Module["__ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionC2EPPS3_m = Module["__ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionC2EPPS3_m"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionC2EPPS3_m");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionD2Ev = Module["__ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionD2Ev"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE21_ConstructTransactionD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE46__construct_backward_with_exception_guaranteesIS4_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS5_PT_SB_EE5valuesr31is_trivially_move_constructibleISB_EE5valueEvE4typeERS5_SC_SC_RSC_ = Module["__ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE46__construct_backward_with_exception_guaranteesIS4_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS5_PT_SB_EE5valuesr31is_trivially_move_constructibleISB_EE5valueEvE4typeERS5_SC_SC_RSC_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_15__sso_allocatorIPNS_6locale5facetELm28EEEE46__construct_backward_with_exception_guaranteesIS4_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS5_PT_SB_EE5valuesr31is_trivially_move_constructibleISB_EE5valueEvE4typeERS5_SC_SC_RSC_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPPNS_6locale5facetEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS6_EE5valueEvE4typeERS6_S9_ = Module["__ZNSt3__24swapIPPNS_6locale5facetEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS6_EE5valueEvE4typeERS6_S9_"] = createExportWrapper("_ZNSt3__24swapIPPNS_6locale5facetEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS6_EE5valueEvE4typeERS6_S9_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE5clearEv = Module["__ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE5clearEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE5clearEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE8capacityEv = Module["__ZNKSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE8capacityEv"] = createExportWrapper("_ZNKSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE8capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRNS_15__sso_allocatorIPNS_6locale5facetELm28EEEEEOT_RNS_16remove_referenceIS7_E4typeE = Module["__ZNSt3__27forwardIRNS_15__sso_allocatorIPNS_6locale5facetELm28EEEEEOT_RNS_16remove_referenceIS7_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRNS_15__sso_allocatorIPNS_6locale5facetELm28EEEEEOT_RNS_16remove_referenceIS7_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EEC2IS6_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIRNS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EEC2IS6_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EEC2IS6_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE6secondEv = Module["__ZNSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE5firstEv = Module["__ZNSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIRNS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_15__sso_allocatorIPNS_6locale5facetELm28EEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPPNS_6locale5facetEEEONS_16remove_referenceIT_E4typeEOS7_ = Module["__ZNSt3__24moveIRPPNS_6locale5facetEEEONS_16remove_referenceIT_E4typeEOS7_"] = createExportWrapper("_ZNSt3__24moveIRPPNS_6locale5facetEEEONS_16remove_referenceIT_E4typeEOS7_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_ = Module["__ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv = Module["__ZNKSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv"] = createExportWrapper("_ZNKSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE17__destruct_at_endEPS3_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPPNS_6locale5facetERNS_15__sso_allocatorIS3_Lm28EEEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEmmPKcm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEmmPKcm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEmmPKcm");

/** @type {function(...*):?} */
var __ZNSt3__28distanceIPKcEENS_15iterator_traitsIT_E15difference_typeES4_S4_ = Module["__ZNSt3__28distanceIPKcEENS_15iterator_traitsIT_E15difference_typeES4_S4_"] = createExportWrapper("_ZNSt3__28distanceIPKcEENS_15iterator_traitsIT_E15difference_typeES4_S4_");

/** @type {function(...*):?} */
var __ZNKSt3__221__basic_string_commonILb1EE20__throw_length_errorEv = Module["__ZNKSt3__221__basic_string_commonILb1EE20__throw_length_errorEv"] = createExportWrapper("_ZNKSt3__221__basic_string_commonILb1EE20__throw_length_errorEv");

/** @type {function(...*):?} */
var __ZNSt3__210__distanceIPKcEENS_15iterator_traitsIT_E15difference_typeES4_S4_NS_26random_access_iterator_tagE = Module["__ZNSt3__210__distanceIPKcEENS_15iterator_traitsIT_E15difference_typeES4_S4_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__210__distanceIPKcEENS_15iterator_traitsIT_E15difference_typeES4_S4_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repELi0ELb0EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repELi0ELb0EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repELi0ELb0EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__28distanceIPKwEENS_15iterator_traitsIT_E15difference_typeES4_S4_ = Module["__ZNSt3__28distanceIPKwEENS_15iterator_traitsIT_E15difference_typeES4_S4_"] = createExportWrapper("_ZNSt3__28distanceIPKwEENS_15iterator_traitsIT_E15difference_typeES4_S4_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE8max_sizeEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE11__recommendEm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE11__recommendEm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE11__recommendEm");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIwEEE8allocateERS2_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorIwEEE8allocateERS2_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIwEEE8allocateERS2_m");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE18__set_long_pointerEPw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE18__set_long_pointerEPw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE18__set_long_pointerEPw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE14__set_long_capEm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE14__set_long_capEm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE14__set_long_capEm");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIwEC2Ev = Module["__ZNSt3__29allocatorIwEC2Ev"] = createExportWrapper("_ZNSt3__29allocatorIwEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210__distanceIPKwEENS_15iterator_traitsIT_E15difference_typeES4_S4_NS_26random_access_iterator_tagE = Module["__ZNSt3__210__distanceIPKwEENS_15iterator_traitsIT_E15difference_typeES4_S4_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__210__distanceIPKwEENS_15iterator_traitsIT_E15difference_typeES4_S4_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7__allocEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7__allocEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIwEEE8max_sizeERKS2_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIwEEE8max_sizeERKS2_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIwEEE8max_sizeERKS2_");

/** @type {function(...*):?} */
var __ZNSt3__214pointer_traitsIPwE10pointer_toERw = Module["__ZNSt3__214pointer_traitsIPwE10pointer_toERw"] = createExportWrapper("_ZNSt3__214pointer_traitsIPwE10pointer_toERw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE10__align_itILm4EEEmm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE10__align_itILm4EEEmm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE10__align_itILm4EEEmm");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIwE8allocateEmPKv = Module["__ZNSt3__29allocatorIwE8allocateEmPKv"] = createExportWrapper("_ZNSt3__29allocatorIwE8allocateEmPKv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIwEEE10__max_sizeENS_17integral_constantIbLb1EEERKS2_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIwEEE10__max_sizeENS_17integral_constantIbLb1EEERKS2_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIwEEE10__max_sizeENS_17integral_constantIbLb1EEERKS2_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E6secondEv = Module["__ZNKSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E6secondEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_E6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__29allocatorIwE8max_sizeEv = Module["__ZNKSt3__29allocatorIwE8max_sizeEv"] = createExportWrapper("_ZNKSt3__29allocatorIwE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__29addressofIwEEPT_RS1_ = Module["__ZNSt3__29addressofIwEEPT_RS1_"] = createExportWrapper("_ZNSt3__29addressofIwEEPT_RS1_");

/** @type {function(...*):?} */
var __ZNSt3__212__to_addressIwEEPT_S2_ = Module["__ZNSt3__212__to_addressIwEEPT_S2_"] = createExportWrapper("_ZNSt3__212__to_addressIwEEPT_S2_");

/** @type {function(...*):?} */
var __ZNSt3__29iter_swapIPjS1_EEvT_T0_ = Module["__ZNSt3__29iter_swapIPjS1_EEvT_T0_"] = createExportWrapper("_ZNSt3__29iter_swapIPjS1_EEvT_T0_");

/** @type {function(...*):?} */
var __ZNSt3__210__distanceIPNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_NS_26random_access_iterator_tagE = Module["__ZNSt3__210__distanceIPNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__210__distanceIPNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPhPFvPvEEC2IRS1_S4_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPhPFvPvEEC2IRS1_S4_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPhPFvPvEEC2IRS1_S4_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPhPFvPvEE5firstEv = Module["__ZNSt3__217__compressed_pairIPhPFvPvEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPhPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPhPFvPvEE6secondEv = Module["__ZNSt3__217__compressed_pairIPhPFvPvEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPhPFvPvEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPhEEOT_RNS_16remove_referenceIS3_E4typeE = Module["__ZNSt3__27forwardIRPhEEOT_RNS_16remove_referenceIS3_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPhEEOT_RNS_16remove_referenceIS3_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPhLi0ELb0EEC2IRS1_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPhLi0ELb0EEC2IRS1_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPhLi0ELb0EEC2IRS1_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPhLi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPhLi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPhLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__210__distanceIPNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_NS_26random_access_iterator_tagE = Module["__ZNSt3__210__distanceIPNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__210__distanceIPNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__move_assign_allocERS5_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__move_assign_allocERS5_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__move_assign_allocERS5_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__move_assign_allocERS5_NS_17integral_constantIbLb1EEE = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__move_assign_allocERS5_NS_17integral_constantIbLb1EEE"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__move_assign_allocERS5_NS_17integral_constantIbLb1EEE");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_9allocatorIcEEEEONS_16remove_referenceIT_E4typeEOS5_ = Module["__ZNSt3__24moveIRNS_9allocatorIcEEEEONS_16remove_referenceIT_E4typeEOS5_"] = createExportWrapper("_ZNSt3__24moveIRNS_9allocatorIcEEEEONS_16remove_referenceIT_E4typeEOS5_");

/** @type {function(...*):?} */
var __ZNSt3__210__distanceIPwEENS_15iterator_traitsIT_E15difference_typeES3_S3_NS_26random_access_iterator_tagE = Module["__ZNSt3__210__distanceIPwEENS_15iterator_traitsIT_E15difference_typeES3_S3_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__210__distanceIPwEENS_15iterator_traitsIT_E15difference_typeES3_S3_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__move_assign_allocERS5_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__move_assign_allocERS5_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__move_assign_allocERS5_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__move_assign_allocERS5_NS_17integral_constantIbLb1EEE = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__move_assign_allocERS5_NS_17integral_constantIbLb1EEE"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__move_assign_allocERS5_NS_17integral_constantIbLb1EEE");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_9allocatorIwEEEEONS_16remove_referenceIT_E4typeEOS5_ = Module["__ZNSt3__24moveIRNS_9allocatorIwEEEEONS_16remove_referenceIT_E4typeEOS5_"] = createExportWrapper("_ZNSt3__24moveIRNS_9allocatorIwEEEEONS_16remove_referenceIT_E4typeEOS5_");

/** @type {function(...*):?} */
var __ZNSt3__215__time_get_tempIcED0Ev = Module["__ZNSt3__215__time_get_tempIcED0Ev"] = createExportWrapper("_ZNSt3__215__time_get_tempIcED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215__time_get_tempIwED0Ev = Module["__ZNSt3__215__time_get_tempIwED0Ev"] = createExportWrapper("_ZNSt3__215__time_get_tempIwED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__28__rotateINS_11__wrap_iterIPcEEEET_S4_S4_S4_NS_26random_access_iterator_tagE = Module["__ZNSt3__28__rotateINS_11__wrap_iterIPcEEEET_S4_S4_S4_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__28__rotateINS_11__wrap_iterIPcEEEET_S4_S4_S4_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5eraseEmm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5eraseEmm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5eraseEmm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE27__invalidate_iterators_pastEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE27__invalidate_iterators_pastEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE27__invalidate_iterators_pastEm");

/** @type {function(...*):?} */
var __ZNSt3__24nextINS_11__wrap_iterIPcEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE = Module["__ZNSt3__24nextINS_11__wrap_iterIPcEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE"] = createExportWrapper("_ZNSt3__24nextINS_11__wrap_iterIPcEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE");

/** @type {function(...*):?} */
var __ZNSt3__213__rotate_leftINS_11__wrap_iterIPcEEEET_S4_S4_ = Module["__ZNSt3__213__rotate_leftINS_11__wrap_iterIPcEEEET_S4_S4_"] = createExportWrapper("_ZNSt3__213__rotate_leftINS_11__wrap_iterIPcEEEET_S4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__214__rotate_rightINS_11__wrap_iterIPcEEEET_S4_S4_ = Module["__ZNSt3__214__rotate_rightINS_11__wrap_iterIPcEEEET_S4_S4_"] = createExportWrapper("_ZNSt3__214__rotate_rightINS_11__wrap_iterIPcEEEET_S4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__212__rotate_gcdINS_11__wrap_iterIPcEEEET_S4_S4_S4_ = Module["__ZNSt3__212__rotate_gcdINS_11__wrap_iterIPcEEEET_S4_S4_S4_"] = createExportWrapper("_ZNSt3__212__rotate_gcdINS_11__wrap_iterIPcEEEET_S4_S4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__27advanceINS_11__wrap_iterIPcEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeE = Module["__ZNSt3__27advanceINS_11__wrap_iterIPcEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeE"] = createExportWrapper("_ZNSt3__27advanceINS_11__wrap_iterIPcEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeE");

/** @type {function(...*):?} */
var __ZNSt3__24moveINS_11__wrap_iterIPcEES3_EET0_T_S5_S4_ = Module["__ZNSt3__24moveINS_11__wrap_iterIPcEES3_EET0_T_S5_S4_"] = createExportWrapper("_ZNSt3__24moveINS_11__wrap_iterIPcEES3_EET0_T_S5_S4_");

/** @type {function(...*):?} */
var __ZNSt3__24prevINS_11__wrap_iterIPcEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE = Module["__ZNSt3__24prevINS_11__wrap_iterIPcEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE"] = createExportWrapper("_ZNSt3__24prevINS_11__wrap_iterIPcEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE");

/** @type {function(...*):?} */
var __ZNSt3__213move_backwardINS_11__wrap_iterIPcEES3_EET0_T_S5_S4_ = Module["__ZNSt3__213move_backwardINS_11__wrap_iterIPcEES3_EET0_T_S5_S4_"] = createExportWrapper("_ZNSt3__213move_backwardINS_11__wrap_iterIPcEES3_EET0_T_S5_S4_");

/** @type {function(...*):?} */
var __ZNSt3__2miIPcS1_EEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS3_IT0_EE = Module["__ZNSt3__2miIPcS1_EEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS3_IT0_EE"] = createExportWrapper("_ZNSt3__2miIPcS1_EEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS3_IT0_EE");

/** @type {function(...*):?} */
var __ZNSt3__211swap_rangesINS_11__wrap_iterIPcEES3_EET0_T_S5_S4_ = Module["__ZNSt3__211swap_rangesINS_11__wrap_iterIPcEES3_EET0_T_S5_S4_"] = createExportWrapper("_ZNSt3__211swap_rangesINS_11__wrap_iterIPcEES3_EET0_T_S5_S4_");

/** @type {function(...*):?} */
var __ZNSt3__210__algo_gcdIlEET_S1_S1_ = Module["__ZNSt3__210__algo_gcdIlEET_S1_S1_"] = createExportWrapper("_ZNSt3__210__algo_gcdIlEET_S1_S1_");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPcEmmEv = Module["__ZNSt3__211__wrap_iterIPcEmmEv"] = createExportWrapper("_ZNSt3__211__wrap_iterIPcEmmEv");

/** @type {function(...*):?} */
var __ZNSt3__29__advanceINS_11__wrap_iterIPcEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeENS_26random_access_iterator_tagE = Module["__ZNSt3__29__advanceINS_11__wrap_iterIPcEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeENS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__29__advanceINS_11__wrap_iterIPcEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeENS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__213__unwrap_iterIcEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPS2_E4typeENS_11__wrap_iterIS3_EE = Module["__ZNSt3__213__unwrap_iterIcEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPS2_E4typeENS_11__wrap_iterIS3_EE"] = createExportWrapper("_ZNSt3__213__unwrap_iterIcEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPS2_E4typeENS_11__wrap_iterIS3_EE");

/** @type {function(...*):?} */
var __ZNSt3__26__moveIccEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_ = Module["__ZNSt3__26__moveIccEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_"] = createExportWrapper("_ZNSt3__26__moveIccEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_");

/** @type {function(...*):?} */
var __ZNSt3__215__move_backwardIccEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_ = Module["__ZNSt3__215__move_backwardIccEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_"] = createExportWrapper("_ZNSt3__215__move_backwardIccEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_");

/** @type {function(...*):?} */
var __ZNSt3__28__rotateINS_11__wrap_iterIPwEEEET_S4_S4_S4_NS_26random_access_iterator_tagE = Module["__ZNSt3__28__rotateINS_11__wrap_iterIPwEEEET_S4_S4_S4_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__28__rotateINS_11__wrap_iterIPwEEEET_S4_S4_S4_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5eraseEmm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5eraseEmm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5eraseEmm");

/** @type {function(...*):?} */
var __ZNSt3__24nextINS_11__wrap_iterIPwEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE = Module["__ZNSt3__24nextINS_11__wrap_iterIPwEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE"] = createExportWrapper("_ZNSt3__24nextINS_11__wrap_iterIPwEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE");

/** @type {function(...*):?} */
var __ZNSt3__213__rotate_leftINS_11__wrap_iterIPwEEEET_S4_S4_ = Module["__ZNSt3__213__rotate_leftINS_11__wrap_iterIPwEEEET_S4_S4_"] = createExportWrapper("_ZNSt3__213__rotate_leftINS_11__wrap_iterIPwEEEET_S4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__214__rotate_rightINS_11__wrap_iterIPwEEEET_S4_S4_ = Module["__ZNSt3__214__rotate_rightINS_11__wrap_iterIPwEEEET_S4_S4_"] = createExportWrapper("_ZNSt3__214__rotate_rightINS_11__wrap_iterIPwEEEET_S4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__212__rotate_gcdINS_11__wrap_iterIPwEEEET_S4_S4_S4_ = Module["__ZNSt3__212__rotate_gcdINS_11__wrap_iterIPwEEEET_S4_S4_S4_"] = createExportWrapper("_ZNSt3__212__rotate_gcdINS_11__wrap_iterIPwEEEET_S4_S4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__27advanceINS_11__wrap_iterIPwEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeE = Module["__ZNSt3__27advanceINS_11__wrap_iterIPwEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeE"] = createExportWrapper("_ZNSt3__27advanceINS_11__wrap_iterIPwEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeE");

/** @type {function(...*):?} */
var __ZNSt3__24moveINS_11__wrap_iterIPwEES3_EET0_T_S5_S4_ = Module["__ZNSt3__24moveINS_11__wrap_iterIPwEES3_EET0_T_S5_S4_"] = createExportWrapper("_ZNSt3__24moveINS_11__wrap_iterIPwEES3_EET0_T_S5_S4_");

/** @type {function(...*):?} */
var __ZNSt3__24prevINS_11__wrap_iterIPwEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE = Module["__ZNSt3__24prevINS_11__wrap_iterIPwEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE"] = createExportWrapper("_ZNSt3__24prevINS_11__wrap_iterIPwEEEENS_9enable_ifIXsr25__is_cpp17_input_iteratorIT_EE5valueES5_E4typeES5_NS_15iterator_traitsIS5_E15difference_typeE");

/** @type {function(...*):?} */
var __ZNSt3__213move_backwardINS_11__wrap_iterIPwEES3_EET0_T_S5_S4_ = Module["__ZNSt3__213move_backwardINS_11__wrap_iterIPwEES3_EET0_T_S5_S4_"] = createExportWrapper("_ZNSt3__213move_backwardINS_11__wrap_iterIPwEES3_EET0_T_S5_S4_");

/** @type {function(...*):?} */
var __ZNSt3__2miIPwS1_EEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS3_IT0_EE = Module["__ZNSt3__2miIPwS1_EEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS3_IT0_EE"] = createExportWrapper("_ZNSt3__2miIPwS1_EEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_11__wrap_iterIT_EERKNS3_IT0_EE");

/** @type {function(...*):?} */
var __ZNSt3__211swap_rangesINS_11__wrap_iterIPwEES3_EET0_T_S5_S4_ = Module["__ZNSt3__211swap_rangesINS_11__wrap_iterIPwEES3_EET0_T_S5_S4_"] = createExportWrapper("_ZNSt3__211swap_rangesINS_11__wrap_iterIPwEES3_EET0_T_S5_S4_");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPwEmmEv = Module["__ZNSt3__211__wrap_iterIPwEmmEv"] = createExportWrapper("_ZNSt3__211__wrap_iterIPwEmmEv");

/** @type {function(...*):?} */
var __ZNSt3__29__advanceINS_11__wrap_iterIPwEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeENS_26random_access_iterator_tagE = Module["__ZNSt3__29__advanceINS_11__wrap_iterIPwEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeENS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__29__advanceINS_11__wrap_iterIPwEEEEvRT_NS_15iterator_traitsIS4_E15difference_typeENS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__213__unwrap_iterIwEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPS2_E4typeENS_11__wrap_iterIS3_EE = Module["__ZNSt3__213__unwrap_iterIwEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPS2_E4typeENS_11__wrap_iterIS3_EE"] = createExportWrapper("_ZNSt3__213__unwrap_iterIwEENS_9enable_ifIXsr28is_trivially_copy_assignableIT_EE5valueEPS2_E4typeENS_11__wrap_iterIS3_EE");

/** @type {function(...*):?} */
var __ZNSt3__26__moveIwwEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_ = Module["__ZNSt3__26__moveIwwEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_"] = createExportWrapper("_ZNSt3__26__moveIwwEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_");

/** @type {function(...*):?} */
var __ZNSt3__215__move_backwardIwwEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_ = Module["__ZNSt3__215__move_backwardIwwEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_"] = createExportWrapper("_ZNSt3__215__move_backwardIwwEENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableIS6_EE5valueEPS6_E4typeEPS3_SA_S7_");

/** @type {function(...*):?} */
var __ZNSt3__210__distanceIPKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_NS_26random_access_iterator_tagE = Module["__ZNSt3__210__distanceIPKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__210__distanceIPKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIlE3minEv = Module["__ZNSt3__214numeric_limitsIlE3minEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIlE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIlLb1EE3minEv = Module["__ZNSt3__223__libcpp_numeric_limitsIlLb1EE3minEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIlLb1EE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIxE3minEv = Module["__ZNSt3__214numeric_limitsIxE3minEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIxE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIxE3maxEv = Module["__ZNSt3__214numeric_limitsIxE3maxEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIxE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIxLb1EE3minEv = Module["__ZNSt3__223__libcpp_numeric_limitsIxLb1EE3minEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIxLb1EE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIxLb1EE3maxEv = Module["__ZNSt3__223__libcpp_numeric_limitsIxLb1EE3maxEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIxLb1EE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsItE3maxEv = Module["__ZNSt3__214numeric_limitsItE3maxEv"] = createExportWrapper("_ZNSt3__214numeric_limitsItE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsItLb1EE3maxEv = Module["__ZNSt3__223__libcpp_numeric_limitsItLb1EE3maxEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsItLb1EE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsImLb1EE3maxEv = Module["__ZNSt3__223__libcpp_numeric_limitsImLb1EE3maxEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsImLb1EE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsIyE3maxEv = Module["__ZNSt3__214numeric_limitsIyE3maxEv"] = createExportWrapper("_ZNSt3__214numeric_limitsIyE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsIyLb1EE3maxEv = Module["__ZNSt3__223__libcpp_numeric_limitsIyLb1EE3maxEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsIyLb1EE3maxEv");

/** @type {function(...*):?} */
var __ZNSt3__211__do_strtodIfEET_PKcPPc = Module["__ZNSt3__211__do_strtodIfEET_PKcPPc"] = createExportWrapper("_ZNSt3__211__do_strtodIfEET_PKcPPc");

/** @type {function(...*):?} */
var __ZNSt3__211__do_strtodIdEET_PKcPPc = Module["__ZNSt3__211__do_strtodIdEET_PKcPPc"] = createExportWrapper("_ZNSt3__211__do_strtodIdEET_PKcPPc");

/** @type {function(...*):?} */
var __ZNSt3__211__do_strtodIeEET_PKcPPc = Module["__ZNSt3__211__do_strtodIeEET_PKcPPc"] = createExportWrapper("_ZNSt3__211__do_strtodIeEET_PKcPPc");

/** @type {function(...*):?} */
var __ZNSt3__210__distanceIPKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_NS_26random_access_iterator_tagE = Module["__ZNSt3__210__distanceIPKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__210__distanceIPKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEENS_15iterator_traitsIT_E15difference_typeESA_SA_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPcEEOT_RNS_16remove_referenceIS3_E4typeE = Module["__ZNSt3__27forwardIRPcEEOT_RNS_16remove_referenceIS3_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPcEEOT_RNS_16remove_referenceIS3_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPcLi0ELb0EEC2IRS1_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPcLi0ELb0EEC2IRS1_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPcLi0ELb0EEC2IRS1_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPcLi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPcLi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPcLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPwEEOT_RNS_16remove_referenceIS3_E4typeE = Module["__ZNSt3__27forwardIRPwEEOT_RNS_16remove_referenceIS3_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPwEEOT_RNS_16remove_referenceIS3_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPwLi0ELb0EEC2IRS1_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPwLi0ELb0EEC2IRS1_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPwLi0ELb0EEC2IRS1_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPwLi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPwLi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPwLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__29iter_swapIPcS1_EEvT_T0_ = Module["__ZNSt3__29iter_swapIPcS1_EEvT_T0_"] = createExportWrapper("_ZNSt3__29iter_swapIPcS1_EEvT_T0_");

/** @type {function(...*):?} */
var __ZNSt3__29iter_swapIPwS1_EEvT_T0_ = Module["__ZNSt3__29iter_swapIPwS1_EEvT_T0_"] = createExportWrapper("_ZNSt3__29iter_swapIPwS1_EEvT_T0_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE18__get_long_pointerEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE18__get_long_pointerEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE18__get_long_pointerEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__get_short_pointerEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__get_short_pointerEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__get_short_pointerEv");

/** @type {function(...*):?} */
var __ZNSt3__214pointer_traitsIPKwE10pointer_toERS1_ = Module["__ZNSt3__214pointer_traitsIPKwE10pointer_toERS1_"] = createExportWrapper("_ZNSt3__214pointer_traitsIPKwE10pointer_toERS1_");

/** @type {function(...*):?} */
var __ZNSt3__29addressofIKwEEPT_RS2_ = Module["__ZNSt3__29addressofIKwEEPT_RS2_"] = createExportWrapper("_ZNSt3__29addressofIKwEEPT_RS2_");

/** @type {function(...*):?} */
var __ZNSt3__216__copy_constexprIPcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET0_T_S7_S6_ = Module["__ZNSt3__216__copy_constexprIPcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET0_T_S7_S6_"] = createExportWrapper("_ZNSt3__216__copy_constexprIPcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEET0_T_S7_S6_");

/** @type {function(...*):?} */
var __ZNSt3__216__copy_constexprIPwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET0_T_S7_S6_ = Module["__ZNSt3__216__copy_constexprIPwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET0_T_S7_S6_"] = createExportWrapper("_ZNSt3__216__copy_constexprIPwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEET0_T_S7_S6_");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPcLi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPcLi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPcLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__28distanceIPcEENS_15iterator_traitsIT_E15difference_typeES3_S3_ = Module["__ZNSt3__28distanceIPcEENS_15iterator_traitsIT_E15difference_typeES3_S3_"] = createExportWrapper("_ZNSt3__28distanceIPcEENS_15iterator_traitsIT_E15difference_typeES3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__214__ptr_in_rangeIcEEbPKT_S3_S3_ = Module["__ZNSt3__214__ptr_in_rangeIcEEbPKT_S3_S3_"] = createExportWrapper("_ZNSt3__214__ptr_in_rangeIcEEbPKT_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPcvEET_S8_RKS4_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPcvEET_S8_RKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPcvEET_S8_RKS4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE9__grow_byEmmmmmm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE9__grow_byEmmmmmm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE9__grow_byEmmmmmm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE10__set_sizeEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE10__set_sizeEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE10__set_sizeEm");

/** @type {function(...*):?} */
var __ZNSt3__210__distanceIPcEENS_15iterator_traitsIT_E15difference_typeES3_S3_NS_26random_access_iterator_tagE = Module["__ZNSt3__210__distanceIPcEENS_15iterator_traitsIT_E15difference_typeES3_S3_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__210__distanceIPcEENS_15iterator_traitsIT_E15difference_typeES3_S3_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_EC2INS_18__default_init_tagERKS5_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_EC2INS_18__default_init_tagERKS5_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_EC2INS_18__default_init_tagERKS5_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initIPcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeES9_S9_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initIPcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeES9_S9_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initIPcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeES9_S9_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRKNS_9allocatorIcEEEEOT_RNS_16remove_referenceIS5_E4typeE = Module["__ZNSt3__27forwardIRKNS_9allocatorIcEEEEOT_RNS_16remove_referenceIS5_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRKNS_9allocatorIcEEEEOT_RNS_16remove_referenceIS5_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EEC2IRKS2_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EEC2IRKS2_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EEC2IRKS2_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPjEEOT_RNS_16remove_referenceIS3_E4typeE = Module["__ZNSt3__27forwardIRPjEEOT_RNS_16remove_referenceIS3_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPjEEOT_RNS_16remove_referenceIS3_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPjLi0ELb0EEC2IRS1_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPjLi0ELb0EEC2IRS1_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPjLi0ELb0EEC2IRS1_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPjPFvPvEE5firstEv = Module["__ZNSt3__217__compressed_pairIPjPFvPvEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPjPFvPvEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPjPFvPvEE6secondEv = Module["__ZNSt3__217__compressed_pairIPjPFvPvEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPjPFvPvEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPjLi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPjLi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPjLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPjLi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPjLi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPjLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__210__equal_toIccEclERKcS3_ = Module["__ZNKSt3__210__equal_toIccEclERKcS3_"] = createExportWrapper("_ZNKSt3__210__equal_toIccEclERKcS3_");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPwLi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPwLi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPwLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__214__ptr_in_rangeIwEEbPKT_S3_S3_ = Module["__ZNSt3__214__ptr_in_rangeIwEEbPKT_S3_S3_"] = createExportWrapper("_ZNSt3__214__ptr_in_rangeIwEEbPKT_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IPwvEET_S8_RKS4_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IPwvEET_S8_RKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IPwvEET_S8_RKS4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendEPKwm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendEPKwm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendEPKwm");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_EC2INS_18__default_init_tagERKS5_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_EC2INS_18__default_init_tagERKS5_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_EC2INS_18__default_init_tagERKS5_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initIPwEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeES9_S9_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initIPwEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeES9_S9_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initIPwEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeES9_S9_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRKNS_9allocatorIwEEEEOT_RNS_16remove_referenceIS5_E4typeE = Module["__ZNSt3__27forwardIRKNS_9allocatorIwEEEEOT_RNS_16remove_referenceIS5_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRKNS_9allocatorIwEEEEOT_RNS_16remove_referenceIS5_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EEC2IRKS2_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EEC2IRKS2_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EEC2IRKS2_vEEOT_");

/** @type {function(...*):?} */
var __ZNKSt3__210__equal_toIwwEclERKwS3_ = Module["__ZNKSt3__210__equal_toIwwEclERKwS3_"] = createExportWrapper("_ZNKSt3__210__equal_toIwwEclERKwS3_");

/** @type {function(...*):?} */
var __ZNSt3__29addressofINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEPT_RS7_ = Module["__ZNSt3__29addressofINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEPT_RS7_"] = createExportWrapper("_ZNSt3__29addressofINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEPT_RS7_");

/** @type {function(...*):?} */
var __ZNSt3__29addressofINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEEPT_RS7_ = Module["__ZNSt3__29addressofINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEEPT_RS7_"] = createExportWrapper("_ZNSt3__29addressofINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEEEPT_RS7_");

/** @type {function(...*):?} */
var __ZNSt3__27collateIcED1Ev = Module["__ZNSt3__27collateIcED1Ev"] = createExportWrapper("_ZNSt3__27collateIcED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__27collateIwED1Ev = Module["__ZNSt3__27collateIwED1Ev"] = createExportWrapper("_ZNSt3__27collateIwED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIcc11__mbstate_tED1Ev = Module["__ZNSt3__214codecvt_bynameIcc11__mbstate_tED1Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIcc11__mbstate_tED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIwc11__mbstate_tED1Ev = Module["__ZNSt3__214codecvt_bynameIwc11__mbstate_tED1Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIwc11__mbstate_tED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIDsc11__mbstate_tED1Ev = Module["__ZNSt3__214codecvt_bynameIDsc11__mbstate_tED1Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIDsc11__mbstate_tED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214codecvt_bynameIDic11__mbstate_tED1Ev = Module["__ZNSt3__214codecvt_bynameIDic11__mbstate_tED1Ev"] = createExportWrapper("_ZNSt3__214codecvt_bynameIDic11__mbstate_tED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC1Em = Module["__ZNSt3__26locale5__impC1Em"] = createExportWrapper("_ZNSt3__26locale5__impC1Em");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__26locale5__impC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__26locale5__impC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC1ERKS1_ = Module["__ZNSt3__26locale5__impC1ERKS1_"] = createExportWrapper("_ZNSt3__26locale5__impC1ERKS1_");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC1ERKS1_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi = Module["__ZNSt3__26locale5__impC1ERKS1_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi"] = createExportWrapper("_ZNSt3__26locale5__impC1ERKS1_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC1ERKS1_S3_i = Module["__ZNSt3__26locale5__impC1ERKS1_S3_i"] = createExportWrapper("_ZNSt3__26locale5__impC1ERKS1_S3_i");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impC1ERKS1_PNS0_5facetEl = Module["__ZNSt3__26locale5__impC1ERKS1_PNS0_5facetEl"] = createExportWrapper("_ZNSt3__26locale5__impC1ERKS1_PNS0_5facetEl");

/** @type {function(...*):?} */
var __ZNSt3__26locale5__impD1Ev = Module["__ZNSt3__26locale5__impD1Ev"] = createExportWrapper("_ZNSt3__26locale5__impD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__26localeC1EPKc = Module["__ZNSt3__26localeC1EPKc"] = createExportWrapper("_ZNSt3__26localeC1EPKc");

/** @type {function(...*):?} */
var __ZNSt3__26localeC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__26localeC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__26localeC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__26localeC1ERKS0_PKci = Module["__ZNSt3__26localeC1ERKS0_PKci"] = createExportWrapper("_ZNSt3__26localeC1ERKS0_PKci");

/** @type {function(...*):?} */
var __ZNSt3__26localeC1ERKS0_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi = Module["__ZNSt3__26localeC1ERKS0_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi"] = createExportWrapper("_ZNSt3__26localeC1ERKS0_RKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEi");

/** @type {function(...*):?} */
var __ZNSt3__26localeC1ERKS0_S2_i = Module["__ZNSt3__26localeC1ERKS0_S2_i"] = createExportWrapper("_ZNSt3__26localeC1ERKS0_S2_i");

/** @type {function(...*):?} */
var __ZNSt3__26locale5facetD1Ev = Module["__ZNSt3__26locale5facetD1Ev"] = createExportWrapper("_ZNSt3__26locale5facetD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIcEC1EPKcm = Module["__ZNSt3__214collate_bynameIcEC1EPKcm"] = createExportWrapper("_ZNSt3__214collate_bynameIcEC1EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__214collate_bynameIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__214collate_bynameIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIcED1Ev = Module["__ZNSt3__214collate_bynameIcED1Ev"] = createExportWrapper("_ZNSt3__214collate_bynameIcED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIwEC1EPKcm = Module["__ZNSt3__214collate_bynameIwEC1EPKcm"] = createExportWrapper("_ZNSt3__214collate_bynameIwEC1EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__214collate_bynameIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__214collate_bynameIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__214collate_bynameIwED1Ev = Module["__ZNSt3__214collate_bynameIwED1Ev"] = createExportWrapper("_ZNSt3__214collate_bynameIwED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIwED2Ev = Module["__ZNSt3__25ctypeIwED2Ev"] = createExportWrapper("_ZNSt3__25ctypeIwED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIwED1Ev = Module["__ZNSt3__25ctypeIwED1Ev"] = createExportWrapper("_ZNSt3__25ctypeIwED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIcEC1EPKtbm = Module["__ZNSt3__25ctypeIcEC1EPKtbm"] = createExportWrapper("_ZNSt3__25ctypeIcEC1EPKtbm");

/** @type {function(...*):?} */
var __ZNSt3__25ctypeIcED1Ev = Module["__ZNSt3__25ctypeIcED1Ev"] = createExportWrapper("_ZNSt3__25ctypeIcED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIcEC1EPKcm = Module["__ZNSt3__212ctype_bynameIcEC1EPKcm"] = createExportWrapper("_ZNSt3__212ctype_bynameIcEC1EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__212ctype_bynameIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__212ctype_bynameIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIcED1Ev = Module["__ZNSt3__212ctype_bynameIcED1Ev"] = createExportWrapper("_ZNSt3__212ctype_bynameIcED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIwEC1EPKcm = Module["__ZNSt3__212ctype_bynameIwEC1EPKcm"] = createExportWrapper("_ZNSt3__212ctype_bynameIwEC1EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__212ctype_bynameIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__212ctype_bynameIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__212ctype_bynameIwED1Ev = Module["__ZNSt3__212ctype_bynameIwED1Ev"] = createExportWrapper("_ZNSt3__212ctype_bynameIwED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIcc11__mbstate_tED2Ev = Module["__ZNSt3__27codecvtIcc11__mbstate_tED2Ev"] = createExportWrapper("_ZNSt3__27codecvtIcc11__mbstate_tED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIcc11__mbstate_tED1Ev = Module["__ZNSt3__27codecvtIcc11__mbstate_tED1Ev"] = createExportWrapper("_ZNSt3__27codecvtIcc11__mbstate_tED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIwc11__mbstate_tEC1Em = Module["__ZNSt3__27codecvtIwc11__mbstate_tEC1Em"] = createExportWrapper("_ZNSt3__27codecvtIwc11__mbstate_tEC1Em");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIwc11__mbstate_tEC1EPKcm = Module["__ZNSt3__27codecvtIwc11__mbstate_tEC1EPKcm"] = createExportWrapper("_ZNSt3__27codecvtIwc11__mbstate_tEC1EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIwc11__mbstate_tED1Ev = Module["__ZNSt3__27codecvtIwc11__mbstate_tED1Ev"] = createExportWrapper("_ZNSt3__27codecvtIwc11__mbstate_tED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIDsc11__mbstate_tED2Ev = Module["__ZNSt3__27codecvtIDsc11__mbstate_tED2Ev"] = createExportWrapper("_ZNSt3__27codecvtIDsc11__mbstate_tED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIDsc11__mbstate_tED1Ev = Module["__ZNSt3__27codecvtIDsc11__mbstate_tED1Ev"] = createExportWrapper("_ZNSt3__27codecvtIDsc11__mbstate_tED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIDic11__mbstate_tED2Ev = Module["__ZNSt3__27codecvtIDic11__mbstate_tED2Ev"] = createExportWrapper("_ZNSt3__27codecvtIDic11__mbstate_tED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27codecvtIDic11__mbstate_tED1Ev = Module["__ZNSt3__27codecvtIDic11__mbstate_tED1Ev"] = createExportWrapper("_ZNSt3__27codecvtIDic11__mbstate_tED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__216__narrow_to_utf8ILm16EED2Ev = Module["__ZNSt3__216__narrow_to_utf8ILm16EED2Ev"] = createExportWrapper("_ZNSt3__216__narrow_to_utf8ILm16EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__216__narrow_to_utf8ILm16EED1Ev = Module["__ZNSt3__216__narrow_to_utf8ILm16EED1Ev"] = createExportWrapper("_ZNSt3__216__narrow_to_utf8ILm16EED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__216__narrow_to_utf8ILm32EED2Ev = Module["__ZNSt3__216__narrow_to_utf8ILm32EED2Ev"] = createExportWrapper("_ZNSt3__216__narrow_to_utf8ILm32EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__216__narrow_to_utf8ILm32EED1Ev = Module["__ZNSt3__216__narrow_to_utf8ILm32EED1Ev"] = createExportWrapper("_ZNSt3__216__narrow_to_utf8ILm32EED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__widen_from_utf8ILm16EED2Ev = Module["__ZNSt3__217__widen_from_utf8ILm16EED2Ev"] = createExportWrapper("_ZNSt3__217__widen_from_utf8ILm16EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__widen_from_utf8ILm16EED1Ev = Module["__ZNSt3__217__widen_from_utf8ILm16EED1Ev"] = createExportWrapper("_ZNSt3__217__widen_from_utf8ILm16EED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__widen_from_utf8ILm32EED2Ev = Module["__ZNSt3__217__widen_from_utf8ILm32EED2Ev"] = createExportWrapper("_ZNSt3__217__widen_from_utf8ILm32EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__widen_from_utf8ILm32EED1Ev = Module["__ZNSt3__217__widen_from_utf8ILm32EED1Ev"] = createExportWrapper("_ZNSt3__217__widen_from_utf8ILm32EED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__28numpunctIcEC1Em = Module["__ZNSt3__28numpunctIcEC1Em"] = createExportWrapper("_ZNSt3__28numpunctIcEC1Em");

/** @type {function(...*):?} */
var __ZNSt3__28numpunctIwEC1Em = Module["__ZNSt3__28numpunctIwEC1Em"] = createExportWrapper("_ZNSt3__28numpunctIwEC1Em");

/** @type {function(...*):?} */
var __ZNSt3__28numpunctIcED1Ev = Module["__ZNSt3__28numpunctIcED1Ev"] = createExportWrapper("_ZNSt3__28numpunctIcED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__28numpunctIwED1Ev = Module["__ZNSt3__28numpunctIwED1Ev"] = createExportWrapper("_ZNSt3__28numpunctIwED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIcEC1EPKcm = Module["__ZNSt3__215numpunct_bynameIcEC1EPKcm"] = createExportWrapper("_ZNSt3__215numpunct_bynameIcEC1EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__215numpunct_bynameIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__215numpunct_bynameIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIcED2Ev = Module["__ZNSt3__215numpunct_bynameIcED2Ev"] = createExportWrapper("_ZNSt3__215numpunct_bynameIcED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIcED1Ev = Module["__ZNSt3__215numpunct_bynameIcED1Ev"] = createExportWrapper("_ZNSt3__215numpunct_bynameIcED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIwEC1EPKcm = Module["__ZNSt3__215numpunct_bynameIwEC1EPKcm"] = createExportWrapper("_ZNSt3__215numpunct_bynameIwEC1EPKcm");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm = Module["__ZNSt3__215numpunct_bynameIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm"] = createExportWrapper("_ZNSt3__215numpunct_bynameIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEm");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIwED2Ev = Module["__ZNSt3__215numpunct_bynameIwED2Ev"] = createExportWrapper("_ZNSt3__215numpunct_bynameIwED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__215numpunct_bynameIwED1Ev = Module["__ZNSt3__215numpunct_bynameIwED1Ev"] = createExportWrapper("_ZNSt3__215numpunct_bynameIwED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__210__time_getC1EPKc = Module["__ZNSt3__210__time_getC1EPKc"] = createExportWrapper("_ZNSt3__210__time_getC1EPKc");

/** @type {function(...*):?} */
var __ZNSt3__210__time_getC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__210__time_getC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__210__time_getC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__210__time_getD1Ev = Module["__ZNSt3__210__time_getD1Ev"] = createExportWrapper("_ZNSt3__210__time_getD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIcEC1EPKc = Module["__ZNSt3__218__time_get_storageIcEC1EPKc"] = createExportWrapper("_ZNSt3__218__time_get_storageIcEC1EPKc");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__218__time_get_storageIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__218__time_get_storageIcEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIwEC1EPKc = Module["__ZNSt3__218__time_get_storageIwEC1EPKc"] = createExportWrapper("_ZNSt3__218__time_get_storageIwEC1EPKc");

/** @type {function(...*):?} */
var __ZNSt3__218__time_get_storageIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__218__time_get_storageIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__218__time_get_storageIwEC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__210__time_putC1EPKc = Module["__ZNSt3__210__time_putC1EPKc"] = createExportWrapper("_ZNSt3__210__time_putC1EPKc");

/** @type {function(...*):?} */
var __ZNSt3__210__time_putC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__210__time_putC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__210__time_putC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__210__time_putD1Ev = Module["__ZNSt3__210__time_putD1Ev"] = createExportWrapper("_ZNSt3__210__time_putD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__212bad_weak_ptrD2Ev = Module["__ZNSt3__212bad_weak_ptrD2Ev"] = createExportWrapper("_ZNSt3__212bad_weak_ptrD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__212bad_weak_ptrD0Ev = Module["__ZNSt3__212bad_weak_ptrD0Ev"] = createExportWrapper("_ZNSt3__212bad_weak_ptrD0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__212bad_weak_ptr4whatEv = Module["__ZNKSt3__212bad_weak_ptr4whatEv"] = createExportWrapper("_ZNKSt3__212bad_weak_ptr4whatEv");

/** @type {function(...*):?} */
var __ZNSt3__214__shared_countD0Ev = Module["__ZNSt3__214__shared_countD0Ev"] = createExportWrapper("_ZNSt3__214__shared_countD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_weak_countD0Ev = Module["__ZNSt3__219__shared_weak_countD0Ev"] = createExportWrapper("_ZNSt3__219__shared_weak_countD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_weak_count14__release_weakEv = Module["__ZNSt3__219__shared_weak_count14__release_weakEv"] = createExportWrapper("_ZNSt3__219__shared_weak_count14__release_weakEv");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_weak_count4lockEv = Module["__ZNSt3__219__shared_weak_count4lockEv"] = createExportWrapper("_ZNSt3__219__shared_weak_count4lockEv");

/** @type {function(...*):?} */
var __ZNKSt3__219__shared_weak_count13__get_deleterERKSt9type_info = Module["__ZNKSt3__219__shared_weak_count13__get_deleterERKSt9type_info"] = createExportWrapper("_ZNKSt3__219__shared_weak_count13__get_deleterERKSt9type_info");

/** @type {function(...*):?} */
var __ZNSt3__28__sp_mut4lockEv = Module["__ZNSt3__28__sp_mut4lockEv"] = createExportWrapper("_ZNSt3__28__sp_mut4lockEv");

/** @type {function(...*):?} */
var __ZNSt3__222__libcpp_mutex_trylockEP15pthread_mutex_t = Module["__ZNSt3__222__libcpp_mutex_trylockEP15pthread_mutex_t"] = createExportWrapper("_ZNSt3__222__libcpp_mutex_trylockEP15pthread_mutex_t");

/** @type {function(...*):?} */
var __ZNSt3__211this_thread5yieldEv = Module["__ZNSt3__211this_thread5yieldEv"] = createExportWrapper("_ZNSt3__211this_thread5yieldEv");

/** @type {function(...*):?} */
var _pthread_mutex_trylock = Module["_pthread_mutex_trylock"] = createExportWrapper("pthread_mutex_trylock");

/** @type {function(...*):?} */
var __ZNSt3__221__libcpp_thread_yieldEv = Module["__ZNSt3__221__libcpp_thread_yieldEv"] = createExportWrapper("_ZNSt3__221__libcpp_thread_yieldEv");

/** @type {function(...*):?} */
var __ZNSt3__28__sp_mut6unlockEv = Module["__ZNSt3__28__sp_mut6unlockEv"] = createExportWrapper("_ZNSt3__28__sp_mut6unlockEv");

/** @type {function(...*):?} */
var __ZNSt3__212__get_sp_mutEPKv = Module["__ZNSt3__212__get_sp_mutEPKv"] = createExportWrapper("_ZNSt3__212__get_sp_mutEPKv");

/** @type {function(...*):?} */
var __ZNSt3__28__sp_mutC2EPv = Module["__ZNSt3__28__sp_mutC2EPv"] = createExportWrapper("_ZNSt3__28__sp_mutC2EPv");

/** @type {function(...*):?} */
var __ZNSt3__217declare_reachableEPv = Module["__ZNSt3__217declare_reachableEPv"] = createExportWrapper("_ZNSt3__217declare_reachableEPv");

/** @type {function(...*):?} */
var __ZNSt3__219declare_no_pointersEPcm = Module["__ZNSt3__219declare_no_pointersEPcm"] = createExportWrapper("_ZNSt3__219declare_no_pointersEPcm");

/** @type {function(...*):?} */
var __ZNSt3__221undeclare_no_pointersEPcm = Module["__ZNSt3__221undeclare_no_pointersEPcm"] = createExportWrapper("_ZNSt3__221undeclare_no_pointersEPcm");

/** @type {function(...*):?} */
var __ZNSt3__221__undeclare_reachableEPv = Module["__ZNSt3__221__undeclare_reachableEPv"] = createExportWrapper("_ZNSt3__221__undeclare_reachableEPv");

/** @type {function(...*):?} */
var __ZNSt3__25alignEmmRPvRm = Module["__ZNSt3__25alignEmmRPvRm"] = createExportWrapper("_ZNSt3__25alignEmmRPvRm");

/** @type {function(...*):?} */
var __ZNSt3__212bad_weak_ptrD1Ev = Module["__ZNSt3__212bad_weak_ptrD1Ev"] = createExportWrapper("_ZNSt3__212bad_weak_ptrD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214__shared_countD1Ev = Module["__ZNSt3__214__shared_countD1Ev"] = createExportWrapper("_ZNSt3__214__shared_countD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_weak_countD2Ev = Module["__ZNSt3__219__shared_weak_countD2Ev"] = createExportWrapper("_ZNSt3__219__shared_weak_countD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_weak_countD1Ev = Module["__ZNSt3__219__shared_weak_countD1Ev"] = createExportWrapper("_ZNSt3__219__shared_weak_countD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__25mutex8try_lockEv = Module["__ZNSt3__25mutex8try_lockEv"] = createExportWrapper("_ZNSt3__25mutex8try_lockEv");

/** @type {function(...*):?} */
var __ZNSt3__215recursive_mutexC2Ev = Module["__ZNSt3__215recursive_mutexC2Ev"] = createExportWrapper("_ZNSt3__215recursive_mutexC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__229__libcpp_recursive_mutex_initEP15pthread_mutex_t = Module["__ZNSt3__229__libcpp_recursive_mutex_initEP15pthread_mutex_t"] = createExportWrapper("_ZNSt3__229__libcpp_recursive_mutex_initEP15pthread_mutex_t");

/** @type {function(...*):?} */
var _pthread_mutex_init = Module["_pthread_mutex_init"] = createExportWrapper("pthread_mutex_init");

/** @type {function(...*):?} */
var _pthread_mutex_destroy = Module["_pthread_mutex_destroy"] = createExportWrapper("pthread_mutex_destroy");

/** @type {function(...*):?} */
var __ZNSt3__215recursive_mutexD2Ev = Module["__ZNSt3__215recursive_mutexD2Ev"] = createExportWrapper("_ZNSt3__215recursive_mutexD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__232__libcpp_recursive_mutex_destroyEP15pthread_mutex_t = Module["__ZNSt3__232__libcpp_recursive_mutex_destroyEP15pthread_mutex_t"] = createExportWrapper("_ZNSt3__232__libcpp_recursive_mutex_destroyEP15pthread_mutex_t");

/** @type {function(...*):?} */
var __ZNSt3__215recursive_mutex4lockEv = Module["__ZNSt3__215recursive_mutex4lockEv"] = createExportWrapper("_ZNSt3__215recursive_mutex4lockEv");

/** @type {function(...*):?} */
var __ZNSt3__229__libcpp_recursive_mutex_lockEP15pthread_mutex_t = Module["__ZNSt3__229__libcpp_recursive_mutex_lockEP15pthread_mutex_t"] = createExportWrapper("_ZNSt3__229__libcpp_recursive_mutex_lockEP15pthread_mutex_t");

/** @type {function(...*):?} */
var __ZNSt3__215recursive_mutex6unlockEv = Module["__ZNSt3__215recursive_mutex6unlockEv"] = createExportWrapper("_ZNSt3__215recursive_mutex6unlockEv");

/** @type {function(...*):?} */
var __ZNSt3__231__libcpp_recursive_mutex_unlockEP15pthread_mutex_t = Module["__ZNSt3__231__libcpp_recursive_mutex_unlockEP15pthread_mutex_t"] = createExportWrapper("_ZNSt3__231__libcpp_recursive_mutex_unlockEP15pthread_mutex_t");

/** @type {function(...*):?} */
var __ZNSt3__215recursive_mutex8try_lockEv = Module["__ZNSt3__215recursive_mutex8try_lockEv"] = createExportWrapper("_ZNSt3__215recursive_mutex8try_lockEv");

/** @type {function(...*):?} */
var __ZNSt3__232__libcpp_recursive_mutex_trylockEP15pthread_mutex_t = Module["__ZNSt3__232__libcpp_recursive_mutex_trylockEP15pthread_mutex_t"] = createExportWrapper("_ZNSt3__232__libcpp_recursive_mutex_trylockEP15pthread_mutex_t");

/** @type {function(...*):?} */
var __ZNSt3__211timed_mutexC2Ev = Module["__ZNSt3__211timed_mutexC2Ev"] = createExportWrapper("_ZNSt3__211timed_mutexC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__211timed_mutexD2Ev = Module["__ZNSt3__211timed_mutexD2Ev"] = createExportWrapper("_ZNSt3__211timed_mutexD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__211timed_mutex4lockEv = Module["__ZNSt3__211timed_mutex4lockEv"] = createExportWrapper("_ZNSt3__211timed_mutex4lockEv");

/** @type {function(...*):?} */
var __ZNSt3__211timed_mutex8try_lockEv = Module["__ZNSt3__211timed_mutex8try_lockEv"] = createExportWrapper("_ZNSt3__211timed_mutex8try_lockEv");

/** @type {function(...*):?} */
var __ZNSt3__211unique_lockINS_5mutexEEC2ERS1_NS_13try_to_lock_tE = Module["__ZNSt3__211unique_lockINS_5mutexEEC2ERS1_NS_13try_to_lock_tE"] = createExportWrapper("_ZNSt3__211unique_lockINS_5mutexEEC2ERS1_NS_13try_to_lock_tE");

/** @type {function(...*):?} */
var __ZNSt3__211timed_mutex6unlockEv = Module["__ZNSt3__211timed_mutex6unlockEv"] = createExportWrapper("_ZNSt3__211timed_mutex6unlockEv");

/** @type {function(...*):?} */
var __ZNSt3__221recursive_timed_mutexC2Ev = Module["__ZNSt3__221recursive_timed_mutexC2Ev"] = createExportWrapper("_ZNSt3__221recursive_timed_mutexC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__211__thread_idC2Ev = Module["__ZNSt3__211__thread_idC2Ev"] = createExportWrapper("_ZNSt3__211__thread_idC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__221recursive_timed_mutexD2Ev = Module["__ZNSt3__221recursive_timed_mutexD2Ev"] = createExportWrapper("_ZNSt3__221recursive_timed_mutexD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__221recursive_timed_mutex4lockEv = Module["__ZNSt3__221recursive_timed_mutex4lockEv"] = createExportWrapper("_ZNSt3__221recursive_timed_mutex4lockEv");

/** @type {function(...*):?} */
var __ZNSt3__211this_thread6get_idEv = Module["__ZNSt3__211this_thread6get_idEv"] = createExportWrapper("_ZNSt3__211this_thread6get_idEv");

/** @type {function(...*):?} */
var __ZNSt3__2eqENS_11__thread_idES0_ = Module["__ZNSt3__2eqENS_11__thread_idES0_"] = createExportWrapper("_ZNSt3__2eqENS_11__thread_idES0_");

/** @type {function(...*):?} */
var __ZNSt3__230__libcpp_thread_get_current_idEv = Module["__ZNSt3__230__libcpp_thread_get_current_idEv"] = createExportWrapper("_ZNSt3__230__libcpp_thread_get_current_idEv");

/** @type {function(...*):?} */
var __ZNSt3__211__thread_idC2Em = Module["__ZNSt3__211__thread_idC2Em"] = createExportWrapper("_ZNSt3__211__thread_idC2Em");

/** @type {function(...*):?} */
var __ZNSt3__224__libcpp_thread_id_equalEmm = Module["__ZNSt3__224__libcpp_thread_id_equalEmm"] = createExportWrapper("_ZNSt3__224__libcpp_thread_id_equalEmm");

/** @type {function(...*):?} */
var __ZNSt3__221recursive_timed_mutex8try_lockEv = Module["__ZNSt3__221recursive_timed_mutex8try_lockEv"] = createExportWrapper("_ZNSt3__221recursive_timed_mutex8try_lockEv");

/** @type {function(...*):?} */
var __ZNSt3__221recursive_timed_mutex6unlockEv = Module["__ZNSt3__221recursive_timed_mutex6unlockEv"] = createExportWrapper("_ZNSt3__221recursive_timed_mutex6unlockEv");

/** @type {function(...*):?} */
var __ZNSt3__211__thread_id7__resetEv = Module["__ZNSt3__211__thread_id7__resetEv"] = createExportWrapper("_ZNSt3__211__thread_id7__resetEv");

/** @type {function(...*):?} */
var _pthread_equal = Module["_pthread_equal"] = createExportWrapper("pthread_equal");

/** @type {function(...*):?} */
var __ZNSt3__215recursive_mutexC1Ev = Module["__ZNSt3__215recursive_mutexC1Ev"] = createExportWrapper("_ZNSt3__215recursive_mutexC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__215recursive_mutexD1Ev = Module["__ZNSt3__215recursive_mutexD1Ev"] = createExportWrapper("_ZNSt3__215recursive_mutexD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__211timed_mutexC1Ev = Module["__ZNSt3__211timed_mutexC1Ev"] = createExportWrapper("_ZNSt3__211timed_mutexC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__211timed_mutexD1Ev = Module["__ZNSt3__211timed_mutexD1Ev"] = createExportWrapper("_ZNSt3__211timed_mutexD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__221recursive_timed_mutexC1Ev = Module["__ZNSt3__221recursive_timed_mutexC1Ev"] = createExportWrapper("_ZNSt3__221recursive_timed_mutexC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__221recursive_timed_mutexD1Ev = Module["__ZNSt3__221recursive_timed_mutexD1Ev"] = createExportWrapper("_ZNSt3__221recursive_timed_mutexD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__25mutexD2Ev = Module["__ZNSt3__25mutexD2Ev"] = createExportWrapper("_ZNSt3__25mutexD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__222__libcpp_mutex_destroyEP15pthread_mutex_t = Module["__ZNSt3__222__libcpp_mutex_destroyEP15pthread_mutex_t"] = createExportWrapper("_ZNSt3__222__libcpp_mutex_destroyEP15pthread_mutex_t");

/** @type {function(...*):?} */
var __ZSt15get_new_handlerv = Module["__ZSt15get_new_handlerv"] = createExportWrapper("_ZSt15get_new_handlerv");

/** @type {function(...*):?} */
var __ZnwmRKSt9nothrow_t = Module["__ZnwmRKSt9nothrow_t"] = createExportWrapper("_ZnwmRKSt9nothrow_t");

/** @type {function(...*):?} */
var __Znam = Module["__Znam"] = createExportWrapper("_Znam");

/** @type {function(...*):?} */
var __ZnamRKSt9nothrow_t = Module["__ZnamRKSt9nothrow_t"] = createExportWrapper("_ZnamRKSt9nothrow_t");

/** @type {function(...*):?} */
var __ZdlPvRKSt9nothrow_t = Module["__ZdlPvRKSt9nothrow_t"] = createExportWrapper("_ZdlPvRKSt9nothrow_t");

/** @type {function(...*):?} */
var __ZdlPvm = Module["__ZdlPvm"] = createExportWrapper("_ZdlPvm");

/** @type {function(...*):?} */
var __ZdaPvRKSt9nothrow_t = Module["__ZdaPvRKSt9nothrow_t"] = createExportWrapper("_ZdaPvRKSt9nothrow_t");

/** @type {function(...*):?} */
var __ZdaPvm = Module["__ZdaPvm"] = createExportWrapper("_ZdaPvm");

/** @type {function(...*):?} */
var __ZnwmSt11align_val_t = Module["__ZnwmSt11align_val_t"] = createExportWrapper("_ZnwmSt11align_val_t");

/** @type {function(...*):?} */
var __ZnwmSt11align_val_tRKSt9nothrow_t = Module["__ZnwmSt11align_val_tRKSt9nothrow_t"] = createExportWrapper("_ZnwmSt11align_val_tRKSt9nothrow_t");

/** @type {function(...*):?} */
var __ZnamSt11align_val_t = Module["__ZnamSt11align_val_t"] = createExportWrapper("_ZnamSt11align_val_t");

/** @type {function(...*):?} */
var __ZnamSt11align_val_tRKSt9nothrow_t = Module["__ZnamSt11align_val_tRKSt9nothrow_t"] = createExportWrapper("_ZnamSt11align_val_tRKSt9nothrow_t");

/** @type {function(...*):?} */
var __ZdlPvSt11align_val_t = Module["__ZdlPvSt11align_val_t"] = createExportWrapper("_ZdlPvSt11align_val_t");

/** @type {function(...*):?} */
var __ZdlPvSt11align_val_tRKSt9nothrow_t = Module["__ZdlPvSt11align_val_tRKSt9nothrow_t"] = createExportWrapper("_ZdlPvSt11align_val_tRKSt9nothrow_t");

/** @type {function(...*):?} */
var __ZdlPvmSt11align_val_t = Module["__ZdlPvmSt11align_val_t"] = createExportWrapper("_ZdlPvmSt11align_val_t");

/** @type {function(...*):?} */
var __ZdaPvSt11align_val_t = Module["__ZdaPvSt11align_val_t"] = createExportWrapper("_ZdaPvSt11align_val_t");

/** @type {function(...*):?} */
var __ZdaPvSt11align_val_tRKSt9nothrow_t = Module["__ZdaPvSt11align_val_tRKSt9nothrow_t"] = createExportWrapper("_ZdaPvSt11align_val_tRKSt9nothrow_t");

/** @type {function(...*):?} */
var __ZdaPvmSt11align_val_t = Module["__ZdaPvmSt11align_val_t"] = createExportWrapper("_ZdaPvmSt11align_val_t");

/** @type {function(...*):?} */
var __ZNSt19bad_optional_accessD2Ev = Module["__ZNSt19bad_optional_accessD2Ev"] = createExportWrapper("_ZNSt19bad_optional_accessD2Ev");

/** @type {function(...*):?} */
var __ZNSt19bad_optional_accessD0Ev = Module["__ZNSt19bad_optional_accessD0Ev"] = createExportWrapper("_ZNSt19bad_optional_accessD0Ev");

/** @type {function(...*):?} */
var __ZNKSt19bad_optional_access4whatEv = Module["__ZNKSt19bad_optional_access4whatEv"] = createExportWrapper("_ZNKSt19bad_optional_access4whatEv");

/** @type {function(...*):?} */
var __ZNSt12experimental19bad_optional_accessD2Ev = Module["__ZNSt12experimental19bad_optional_accessD2Ev"] = createExportWrapper("_ZNSt12experimental19bad_optional_accessD2Ev");

/** @type {function(...*):?} */
var __ZNSt12experimental19bad_optional_accessD0Ev = Module["__ZNSt12experimental19bad_optional_accessD0Ev"] = createExportWrapper("_ZNSt12experimental19bad_optional_accessD0Ev");

/** @type {function(...*):?} */
var __ZNSt19bad_optional_accessD1Ev = Module["__ZNSt19bad_optional_accessD1Ev"] = createExportWrapper("_ZNSt19bad_optional_accessD1Ev");

/** @type {function(...*):?} */
var __ZNSt12experimental19bad_optional_accessD1Ev = Module["__ZNSt12experimental19bad_optional_accessD1Ev"] = createExportWrapper("_ZNSt12experimental19bad_optional_accessD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__213random_deviceC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__213random_deviceC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__213random_deviceC2ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__213random_deviceD2Ev = Module["__ZNSt3__213random_deviceD2Ev"] = createExportWrapper("_ZNSt3__213random_deviceD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213random_deviceclEv = Module["__ZNSt3__213random_deviceclEv"] = createExportWrapper("_ZNSt3__213random_deviceclEv");

/** @type {function(...*):?} */
var __ZNKSt3__213random_device7entropyEv = Module["__ZNKSt3__213random_device7entropyEv"] = createExportWrapper("_ZNKSt3__213random_device7entropyEv");

/** @type {function(...*):?} */
var __ZNSt3__213random_deviceC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__213random_deviceC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__213random_deviceC1ERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__213random_deviceD1Ev = Module["__ZNSt3__213random_deviceD1Ev"] = createExportWrapper("_ZNSt3__213random_deviceD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__211regex_errorC2ENS_15regex_constants10error_typeE = Module["__ZNSt3__211regex_errorC2ENS_15regex_constants10error_typeE"] = createExportWrapper("_ZNSt3__211regex_errorC2ENS_15regex_constants10error_typeE");

/** @type {function(...*):?} */
var __ZNSt13runtime_errorC2EPKc = Module["__ZNSt13runtime_errorC2EPKc"] = createExportWrapper("_ZNSt13runtime_errorC2EPKc");

/** @type {function(...*):?} */
var __ZNSt3__211regex_errorD2Ev = Module["__ZNSt3__211regex_errorD2Ev"] = createExportWrapper("_ZNSt3__211regex_errorD2Ev");

/** @type {function(...*):?} */
var __ZNSt13runtime_errorD2Ev = Module["__ZNSt13runtime_errorD2Ev"] = createExportWrapper("_ZNSt13runtime_errorD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__211regex_errorD0Ev = Module["__ZNSt3__211regex_errorD0Ev"] = createExportWrapper("_ZNSt3__211regex_errorD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__get_collation_nameEPKc = Module["__ZNSt3__220__get_collation_nameEPKc"] = createExportWrapper("_ZNSt3__220__get_collation_nameEPKc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSEc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSEc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSEc");

/** @type {function(...*):?} */
var __ZNSt3__215__get_classnameEPKcb = Module["__ZNSt3__215__get_classnameEPKcb"] = createExportWrapper("_ZNSt3__215__get_classnameEPKcb");

/** @type {function(...*):?} */
var __ZNKSt3__223__match_any_but_newlineIcE6__execERNS_7__stateIcEE = Module["__ZNKSt3__223__match_any_but_newlineIcE6__execERNS_7__stateIcEE"] = createExportWrapper("_ZNKSt3__223__match_any_but_newlineIcE6__execERNS_7__stateIcEE");

/** @type {function(...*):?} */
var __ZNKSt3__215__has_one_stateIcE5firstEv = Module["__ZNKSt3__215__has_one_stateIcE5firstEv"] = createExportWrapper("_ZNKSt3__215__has_one_stateIcE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__223__match_any_but_newlineIwE6__execERNS_7__stateIwEE = Module["__ZNKSt3__223__match_any_but_newlineIwE6__execERNS_7__stateIwEE"] = createExportWrapper("_ZNKSt3__223__match_any_but_newlineIwE6__execERNS_7__stateIwEE");

/** @type {function(...*):?} */
var __ZNKSt3__215__has_one_stateIwE5firstEv = Module["__ZNKSt3__215__has_one_stateIwE5firstEv"] = createExportWrapper("_ZNKSt3__215__has_one_stateIwE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__211regex_errorC1ENS_15regex_constants10error_typeE = Module["__ZNSt3__211regex_errorC1ENS_15regex_constants10error_typeE"] = createExportWrapper("_ZNSt3__211regex_errorC1ENS_15regex_constants10error_typeE");

/** @type {function(...*):?} */
var __ZNSt3__211regex_errorD1Ev = Module["__ZNSt3__211regex_errorD1Ev"] = createExportWrapper("_ZNSt3__211regex_errorD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_mutex_baseC2Ev = Module["__ZNSt3__219__shared_mutex_baseC2Ev"] = createExportWrapper("_ZNSt3__219__shared_mutex_baseC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_mutex_base4lockEv = Module["__ZNSt3__219__shared_mutex_base4lockEv"] = createExportWrapper("_ZNSt3__219__shared_mutex_base4lockEv");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_mutex_base8try_lockEv = Module["__ZNSt3__219__shared_mutex_base8try_lockEv"] = createExportWrapper("_ZNSt3__219__shared_mutex_base8try_lockEv");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_mutex_base6unlockEv = Module["__ZNSt3__219__shared_mutex_base6unlockEv"] = createExportWrapper("_ZNSt3__219__shared_mutex_base6unlockEv");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_mutex_base11lock_sharedEv = Module["__ZNSt3__219__shared_mutex_base11lock_sharedEv"] = createExportWrapper("_ZNSt3__219__shared_mutex_base11lock_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_mutex_base15try_lock_sharedEv = Module["__ZNSt3__219__shared_mutex_base15try_lock_sharedEv"] = createExportWrapper("_ZNSt3__219__shared_mutex_base15try_lock_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_mutex_base13unlock_sharedEv = Module["__ZNSt3__219__shared_mutex_base13unlock_sharedEv"] = createExportWrapper("_ZNSt3__219__shared_mutex_base13unlock_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__218shared_timed_mutexC2Ev = Module["__ZNSt3__218shared_timed_mutexC2Ev"] = createExportWrapper("_ZNSt3__218shared_timed_mutexC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__218shared_timed_mutex4lockEv = Module["__ZNSt3__218shared_timed_mutex4lockEv"] = createExportWrapper("_ZNSt3__218shared_timed_mutex4lockEv");

/** @type {function(...*):?} */
var __ZNSt3__218shared_timed_mutex8try_lockEv = Module["__ZNSt3__218shared_timed_mutex8try_lockEv"] = createExportWrapper("_ZNSt3__218shared_timed_mutex8try_lockEv");

/** @type {function(...*):?} */
var __ZNSt3__218shared_timed_mutex6unlockEv = Module["__ZNSt3__218shared_timed_mutex6unlockEv"] = createExportWrapper("_ZNSt3__218shared_timed_mutex6unlockEv");

/** @type {function(...*):?} */
var __ZNSt3__218shared_timed_mutex11lock_sharedEv = Module["__ZNSt3__218shared_timed_mutex11lock_sharedEv"] = createExportWrapper("_ZNSt3__218shared_timed_mutex11lock_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__218shared_timed_mutex15try_lock_sharedEv = Module["__ZNSt3__218shared_timed_mutex15try_lock_sharedEv"] = createExportWrapper("_ZNSt3__218shared_timed_mutex15try_lock_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__218shared_timed_mutex13unlock_sharedEv = Module["__ZNSt3__218shared_timed_mutex13unlock_sharedEv"] = createExportWrapper("_ZNSt3__218shared_timed_mutex13unlock_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_mutex_baseC1Ev = Module["__ZNSt3__219__shared_mutex_baseC1Ev"] = createExportWrapper("_ZNSt3__219__shared_mutex_baseC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__218shared_timed_mutexC1Ev = Module["__ZNSt3__218shared_timed_mutexC1Ev"] = createExportWrapper("_ZNSt3__218shared_timed_mutexC1Ev");

/** @type {function(...*):?} */
var __ZNSt9exceptionC2Ev = Module["__ZNSt9exceptionC2Ev"] = createExportWrapper("_ZNSt9exceptionC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__218__libcpp_refstringC2EPKc = Module["__ZNSt3__218__libcpp_refstringC2EPKc"] = createExportWrapper("_ZNSt3__218__libcpp_refstringC2EPKc");

/** @type {function(...*):?} */
var __ZNSt11logic_errorC2EPKc = Module["__ZNSt11logic_errorC2EPKc"] = createExportWrapper("_ZNSt11logic_errorC2EPKc");

/** @type {function(...*):?} */
var __ZNSt11logic_errorC2ERKS_ = Module["__ZNSt11logic_errorC2ERKS_"] = createExportWrapper("_ZNSt11logic_errorC2ERKS_");

/** @type {function(...*):?} */
var __ZNSt3__218__libcpp_refstringC2ERKS0_ = Module["__ZNSt3__218__libcpp_refstringC2ERKS0_"] = createExportWrapper("_ZNSt3__218__libcpp_refstringC2ERKS0_");

/** @type {function(...*):?} */
var __ZNKSt3__218__libcpp_refstring15__uses_refcountEv = Module["__ZNKSt3__218__libcpp_refstring15__uses_refcountEv"] = createExportWrapper("_ZNKSt3__218__libcpp_refstring15__uses_refcountEv");

/** @type {function(...*):?} */
var __ZNSt11logic_erroraSERKS_ = Module["__ZNSt11logic_erroraSERKS_"] = createExportWrapper("_ZNSt11logic_erroraSERKS_");

/** @type {function(...*):?} */
var __ZNSt3__218__libcpp_refstringaSERKS0_ = Module["__ZNSt3__218__libcpp_refstringaSERKS0_"] = createExportWrapper("_ZNSt3__218__libcpp_refstringaSERKS0_");

/** @type {function(...*):?} */
var __ZNSt13runtime_errorC2ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE = Module["__ZNSt13runtime_errorC2ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE"] = createExportWrapper("_ZNSt13runtime_errorC2ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt13runtime_errorC2ERKS_ = Module["__ZNSt13runtime_errorC2ERKS_"] = createExportWrapper("_ZNSt13runtime_errorC2ERKS_");

/** @type {function(...*):?} */
var __ZNSt13runtime_erroraSERKS_ = Module["__ZNSt13runtime_erroraSERKS_"] = createExportWrapper("_ZNSt13runtime_erroraSERKS_");

/** @type {function(...*):?} */
var __ZNSt11logic_errorC1ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE = Module["__ZNSt11logic_errorC1ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE"] = createExportWrapper("_ZNSt11logic_errorC1ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt11logic_errorC1EPKc = Module["__ZNSt11logic_errorC1EPKc"] = createExportWrapper("_ZNSt11logic_errorC1EPKc");

/** @type {function(...*):?} */
var __ZNSt11logic_errorC1ERKS_ = Module["__ZNSt11logic_errorC1ERKS_"] = createExportWrapper("_ZNSt11logic_errorC1ERKS_");

/** @type {function(...*):?} */
var __ZNSt13runtime_errorC1ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE = Module["__ZNSt13runtime_errorC1ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE"] = createExportWrapper("_ZNSt13runtime_errorC1ERKNSt3__212basic_stringIcNS0_11char_traitsIcEENS0_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt13runtime_errorC1EPKc = Module["__ZNSt13runtime_errorC1EPKc"] = createExportWrapper("_ZNSt13runtime_errorC1EPKc");

/** @type {function(...*):?} */
var __ZNSt13runtime_errorC1ERKS_ = Module["__ZNSt13runtime_errorC1ERKS_"] = createExportWrapper("_ZNSt13runtime_errorC1ERKS_");

/** @type {function(...*):?} */
var __ZNKSt3__221__basic_string_commonILb1EE20__throw_out_of_rangeEv = Module["__ZNKSt3__221__basic_string_commonILb1EE20__throw_out_of_rangeEv"] = createExportWrapper("_ZNKSt3__221__basic_string_commonILb1EE20__throw_out_of_rangeEv");

/** @type {function(...*):?} */
var __ZNSt3__220__throw_out_of_rangeEPKc = Module["__ZNSt3__220__throw_out_of_rangeEPKc"] = createExportWrapper("_ZNSt3__220__throw_out_of_rangeEPKc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS5_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS5_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIcEEE37select_on_container_copy_constructionERKS2_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIcEEE37select_on_container_copy_constructionERKS2_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIcEEE37select_on_container_copy_constructionERKS2_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_EC2INS_18__default_init_tagES5_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_EC2INS_18__default_init_tagES5_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5__repES5_EC2INS_18__default_init_tagES5_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIcEEE39__select_on_container_copy_constructionENS_17integral_constantIbLb0EEERKS2_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIcEEE39__select_on_container_copy_constructionENS_17integral_constantIbLb0EEERKS2_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIcEEE39__select_on_container_copy_constructionENS_17integral_constantIbLb0EEERKS2_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_9allocatorIcEEEEOT_RNS_16remove_referenceIS3_E4typeE = Module["__ZNSt3__27forwardINS_9allocatorIcEEEEOT_RNS_16remove_referenceIS3_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_9allocatorIcEEEEOT_RNS_16remove_referenceIS3_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EEC2IS2_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EEC2IS2_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorIcEELi1ELb1EEC2IS2_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS5_RKS4_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS5_RKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS5_RKS4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS5_mmRKS4_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS5_mmRKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS5_mmRKS4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSERKS5_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSERKS5_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEaSERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__copy_assign_allocERKS5_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__copy_assign_allocERKS5_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__copy_assign_allocERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignEPKcm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignEPKcm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignEPKcm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__copy_assign_allocERKS5_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__copy_assign_allocERKS5_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE19__copy_assign_allocERKS5_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE4moveEPcPKcm = Module["__ZNSt3__211char_traitsIcE4moveEPcPKcm"] = createExportWrapper("_ZNSt3__211char_traitsIcE4moveEPcPKcm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE21__grow_by_and_replaceEmmmmmmPKc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE21__grow_by_and_replaceEmmmmmmPKc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE21__grow_by_and_replaceEmmmmmmPKc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendEmc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendEmc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendEmc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE14__erase_to_endEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE14__erase_to_endEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE14__erase_to_endEm");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE6assignEPcmc = Module["__ZNSt3__211char_traitsIcE6assignEPcmc"] = createExportWrapper("_ZNSt3__211char_traitsIcE6assignEPcmc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7reserveEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7reserveEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7reserveEm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE2atEm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE2atEm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE2atEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE2atEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE2atEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE2atEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendERKS5_mm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendERKS5_mm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6appendERKS5_mm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignERKS5_mm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignERKS5_mm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignERKS5_mm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignEmc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignEmc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6assignEmc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmRKS5_mm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmRKS5_mm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmRKS5_mm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmPKcm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmPKcm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertEmPKcm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertENS_11__wrap_iterIPKcEEc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertENS_11__wrap_iterIPKcEEc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6insertENS_11__wrap_iterIPKcEEc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmRKS5_mm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmRKS5_mm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmRKS5_mm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmPKcm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmPKcm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmPKcm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmPKc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmPKc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmPKc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmmc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmmc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7replaceEmmmc");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4copyEPcmm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4copyEPcmm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4copyEPcmm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4findEPKcmm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4findEPKcmm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4findEPKcmm");

/** @type {function(...*):?} */
var __ZNSt3__210__str_findIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__210__str_findIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__210__str_findIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__218__search_substringIcNS_11char_traitsIcEEEEPKT_S5_S5_S5_S5_ = Module["__ZNSt3__218__search_substringIcNS_11char_traitsIcEEEEPKT_S5_S5_S5_S5_"] = createExportWrapper("_ZNSt3__218__search_substringIcNS_11char_traitsIcEEEEPKT_S5_S5_S5_S5_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4findEcm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4findEcm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4findEcm");

/** @type {function(...*):?} */
var __ZNSt3__210__str_findIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S4_S3_ = Module["__ZNSt3__210__str_findIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S4_S3_"] = createExportWrapper("_ZNSt3__210__str_findIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S4_S3_");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIcE4findEPKcmRS2_ = Module["__ZNSt3__211char_traitsIcE4findEPKcmRS2_"] = createExportWrapper("_ZNSt3__211char_traitsIcE4findEPKcmRS2_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5rfindEPKcmm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5rfindEPKcmm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5rfindEPKcmm");

/** @type {function(...*):?} */
var __ZNSt3__211__str_rfindIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__211__str_rfindIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__211__str_rfindIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__210__find_endIPFbccEPKcS4_EET0_S5_S5_T1_S6_T_NS_26random_access_iterator_tagES8_ = Module["__ZNSt3__210__find_endIPFbccEPKcS4_EET0_S5_S5_T1_S6_T_NS_26random_access_iterator_tagES8_"] = createExportWrapper("_ZNSt3__210__find_endIPFbccEPKcS4_EET0_S5_S5_T1_S6_T_NS_26random_access_iterator_tagES8_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5rfindEcm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5rfindEcm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE5rfindEcm");

/** @type {function(...*):?} */
var __ZNSt3__211__str_rfindIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S4_S3_ = Module["__ZNSt3__211__str_rfindIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S4_S3_"] = createExportWrapper("_ZNSt3__211__str_rfindIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S4_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13find_first_ofEPKcmm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13find_first_ofEPKcmm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13find_first_ofEPKcmm");

/** @type {function(...*):?} */
var __ZNSt3__219__str_find_first_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__219__str_find_first_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__219__str_find_first_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__218__find_first_of_ceIPKcS2_PFbccEEET_S5_S5_T0_S6_T1_ = Module["__ZNSt3__218__find_first_of_ceIPKcS2_PFbccEEET_S5_S5_T0_S6_T1_"] = createExportWrapper("_ZNSt3__218__find_first_of_ceIPKcS2_PFbccEEET_S5_S5_T0_S6_T1_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE12find_last_ofEPKcmm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE12find_last_ofEPKcmm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE12find_last_ofEPKcmm");

/** @type {function(...*):?} */
var __ZNSt3__218__str_find_last_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__218__str_find_last_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__218__str_find_last_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE17find_first_not_ofEPKcmm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE17find_first_not_ofEPKcmm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE17find_first_not_ofEPKcmm");

/** @type {function(...*):?} */
var __ZNSt3__223__str_find_first_not_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__223__str_find_first_not_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__223__str_find_first_not_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE16find_last_not_ofEPKcmm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE16find_last_not_ofEPKcmm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE16find_last_not_ofEPKcmm");

/** @type {function(...*):?} */
var __ZNSt3__222__str_find_last_not_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__222__str_find_last_not_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__222__str_find_last_not_ofIcmNS_11char_traitsIcEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEmmRKS5_mm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEmmRKS5_mm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEmmRKS5_mm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEcvNS_17basic_string_viewIcS2_EEEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEcvNS_17basic_string_viewIcS2_EEEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEcvNS_17basic_string_viewIcS2_EEEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareINS_17basic_string_viewIcS2_EEEENS_9enable_ifIXsr33__can_be_converted_to_string_viewIcS2_T_EE5valueEiE4typeEmmRKSA_mm = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareINS_17basic_string_viewIcS2_EEEENS_9enable_ifIXsr33__can_be_converted_to_string_viewIcS2_T_EE5valueEiE4typeEmmRKSA_mm"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareINS_17basic_string_viewIcS2_EEEENS_9enable_ifIXsr33__can_be_converted_to_string_viewIcS2_T_EE5valueEiE4typeEmmRKSA_mm");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE6substrEmm = Module["__ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE6substrEmm"] = createExportWrapper("_ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE6substrEmm");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE7compareES3_ = Module["__ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE7compareES3_"] = createExportWrapper("_ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE7compareES3_");

/** @type {function(...*):?} */
var __ZNSt3__217basic_string_viewIcNS_11char_traitsIcEEEC2EPKcm = Module["__ZNSt3__217basic_string_viewIcNS_11char_traitsIcEEEC2EPKcm"] = createExportWrapper("_ZNSt3__217basic_string_viewIcNS_11char_traitsIcEEEC2EPKcm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEPKc = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEPKc"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEPKc");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEmmPKc = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEmmPKc"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE7compareEmmPKc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initEPKcmm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initEPKcmm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6__initEPKcmm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2ERKS5_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2ERKS5_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2ERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIwEEE37select_on_container_copy_constructionERKS2_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIwEEE37select_on_container_copy_constructionERKS2_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIwEEE37select_on_container_copy_constructionERKS2_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_EC2INS_18__default_init_tagES5_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_EC2INS_18__default_init_tagES5_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES5_EC2INS_18__default_init_tagES5_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIwEEE39__select_on_container_copy_constructionENS_17integral_constantIbLb0EEERKS2_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIwEEE39__select_on_container_copy_constructionENS_17integral_constantIbLb0EEERKS2_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIwEEE39__select_on_container_copy_constructionENS_17integral_constantIbLb0EEERKS2_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_9allocatorIwEEEEOT_RNS_16remove_referenceIS3_E4typeE = Module["__ZNSt3__27forwardINS_9allocatorIwEEEEOT_RNS_16remove_referenceIS3_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_9allocatorIwEEEEOT_RNS_16remove_referenceIS3_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EEC2IS2_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EEC2IS2_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorIwEELi1ELb1EEC2IS2_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2ERKS5_RKS4_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2ERKS5_RKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2ERKS5_RKS4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2ERKS5_mmRKS4_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2ERKS5_mmRKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2ERKS5_mmRKS4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSERKS5_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSERKS5_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__copy_assign_allocERKS5_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__copy_assign_allocERKS5_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__copy_assign_allocERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignEPKwm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignEPKwm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignEPKwm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__copy_assign_allocERKS5_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__copy_assign_allocERKS5_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE19__copy_assign_allocERKS5_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE4moveEPwPKwm = Module["__ZNSt3__211char_traitsIwE4moveEPwPKwm"] = createExportWrapper("_ZNSt3__211char_traitsIwE4moveEPwPKwm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE21__grow_by_and_replaceEmmmmmmPKw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE21__grow_by_and_replaceEmmmmmmPKw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE21__grow_by_and_replaceEmmmmmmPKw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSEw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSEw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEaSEw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6resizeEmw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6resizeEmw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6resizeEmw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendEmw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendEmw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendEmw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE14__erase_to_endEm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE14__erase_to_endEm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE14__erase_to_endEm");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE6assignEPwmw = Module["__ZNSt3__211char_traitsIwE6assignEPwmw"] = createExportWrapper("_ZNSt3__211char_traitsIwE6assignEPwmw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7reserveEm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7reserveEm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7reserveEm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE2atEm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE2atEm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE2atEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE2atEm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE2atEm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE2atEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendERKS5_mm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendERKS5_mm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendERKS5_mm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendEPKw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendEPKw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6appendEPKw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignERKS5_mm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignERKS5_mm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignERKS5_mm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignEmw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignEmw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6assignEmw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmRKS5_mm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmRKS5_mm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmRKS5_mm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmPKwm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmPKwm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmPKwm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmPKw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmPKw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertEmPKw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertENS_11__wrap_iterIPKwEEw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertENS_11__wrap_iterIPKwEEw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6insertENS_11__wrap_iterIPKwEEw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmRKS5_mm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmRKS5_mm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmRKS5_mm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmPKwm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmPKwm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmPKwm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmPKw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmPKw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmPKw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmmw = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmmw"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7replaceEmmmw");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4copyEPwmm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4copyEPwmm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4copyEPwmm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4findEPKwmm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4findEPKwmm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4findEPKwmm");

/** @type {function(...*):?} */
var __ZNSt3__210__str_findIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__210__str_findIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__210__str_findIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__218__search_substringIwNS_11char_traitsIwEEEEPKT_S5_S5_S5_S5_ = Module["__ZNSt3__218__search_substringIwNS_11char_traitsIwEEEEPKT_S5_S5_S5_S5_"] = createExportWrapper("_ZNSt3__218__search_substringIwNS_11char_traitsIwEEEEPKT_S5_S5_S5_S5_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4findEwm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4findEwm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4findEwm");

/** @type {function(...*):?} */
var __ZNSt3__210__str_findIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S4_S3_ = Module["__ZNSt3__210__str_findIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S4_S3_"] = createExportWrapper("_ZNSt3__210__str_findIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S4_S3_");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE4findEPKwmRS2_ = Module["__ZNSt3__211char_traitsIwE4findEPKwmRS2_"] = createExportWrapper("_ZNSt3__211char_traitsIwE4findEPKwmRS2_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5rfindEPKwmm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5rfindEPKwmm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5rfindEPKwmm");

/** @type {function(...*):?} */
var __ZNSt3__211__str_rfindIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__211__str_rfindIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__211__str_rfindIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__210__find_endIPFbwwEPKwS4_EET0_S5_S5_T1_S6_T_NS_26random_access_iterator_tagES8_ = Module["__ZNSt3__210__find_endIPFbwwEPKwS4_EET0_S5_S5_T1_S6_T_NS_26random_access_iterator_tagES8_"] = createExportWrapper("_ZNSt3__210__find_endIPFbwwEPKwS4_EET0_S5_S5_T1_S6_T_NS_26random_access_iterator_tagES8_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5rfindEwm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5rfindEwm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5rfindEwm");

/** @type {function(...*):?} */
var __ZNSt3__211__str_rfindIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S4_S3_ = Module["__ZNSt3__211__str_rfindIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S4_S3_"] = createExportWrapper("_ZNSt3__211__str_rfindIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S4_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13find_first_ofEPKwmm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13find_first_ofEPKwmm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE13find_first_ofEPKwmm");

/** @type {function(...*):?} */
var __ZNSt3__219__str_find_first_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__219__str_find_first_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__219__str_find_first_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__218__find_first_of_ceIPKwS2_PFbwwEEET_S5_S5_T0_S6_T1_ = Module["__ZNSt3__218__find_first_of_ceIPKwS2_PFbwwEEET_S5_S5_T0_S6_T1_"] = createExportWrapper("_ZNSt3__218__find_first_of_ceIPKwS2_PFbwwEEET_S5_S5_T0_S6_T1_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE12find_last_ofEPKwmm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE12find_last_ofEPKwmm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE12find_last_ofEPKwmm");

/** @type {function(...*):?} */
var __ZNSt3__218__str_find_last_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__218__str_find_last_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__218__str_find_last_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE17find_first_not_ofEPKwmm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE17find_first_not_ofEPKwmm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE17find_first_not_ofEPKwmm");

/** @type {function(...*):?} */
var __ZNSt3__223__str_find_first_not_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__223__str_find_first_not_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__223__str_find_first_not_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE16find_last_not_ofEPKwmm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE16find_last_not_ofEPKwmm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE16find_last_not_ofEPKwmm");

/** @type {function(...*):?} */
var __ZNSt3__222__str_find_last_not_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_ = Module["__ZNSt3__222__str_find_last_not_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_"] = createExportWrapper("_ZNSt3__222__str_find_last_not_ofIwmNS_11char_traitsIwEELm4294967295EEET0_PKT_S3_S6_S3_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEmmRKS5_mm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEmmRKS5_mm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEmmRKS5_mm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEcvNS_17basic_string_viewIwS2_EEEv = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEcvNS_17basic_string_viewIwS2_EEEv"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEcvNS_17basic_string_viewIwS2_EEEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareINS_17basic_string_viewIwS2_EEEENS_9enable_ifIXsr33__can_be_converted_to_string_viewIwS2_T_EE5valueEiE4typeEmmRKSA_mm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareINS_17basic_string_viewIwS2_EEEENS_9enable_ifIXsr33__can_be_converted_to_string_viewIwS2_T_EE5valueEiE4typeEmmRKSA_mm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareINS_17basic_string_viewIwS2_EEEENS_9enable_ifIXsr33__can_be_converted_to_string_viewIwS2_T_EE5valueEiE4typeEmmRKSA_mm");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE6substrEmm = Module["__ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE6substrEmm"] = createExportWrapper("_ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE6substrEmm");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE7compareES3_ = Module["__ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE7compareES3_"] = createExportWrapper("_ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE7compareES3_");

/** @type {function(...*):?} */
var __ZNSt3__217basic_string_viewIwNS_11char_traitsIwEEEC2EPKwm = Module["__ZNSt3__217basic_string_viewIwNS_11char_traitsIwEEEC2EPKwm"] = createExportWrapper("_ZNSt3__217basic_string_viewIwNS_11char_traitsIwEEEC2EPKwm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEPKw = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEPKw"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEPKw");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEmmPKwm = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEmmPKwm"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEmmPKwm");

/** @type {function(...*):?} */
var __ZNSt3__211char_traitsIwE7compareEPKwS3_m = Module["__ZNSt3__211char_traitsIwE7compareEPKwS3_m"] = createExportWrapper("_ZNSt3__211char_traitsIwE7compareEPKwS3_m");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEmmPKw = Module["__ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEmmPKw"] = createExportWrapper("_ZNKSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE7compareEmmPKw");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initEPKwmm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initEPKwmm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initEPKwmm");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13get_allocatorEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13get_allocatorEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE13get_allocatorEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS4_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2ERKS4_");

/** @type {function(...*):?} */
var __ZNSt3__24stoiERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi = Module["__ZNSt3__24stoiERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi"] = createExportWrapper("_ZNSt3__24stoiERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi");

/** @type {function(...*):?} */
var __ZNSt3__24stoiERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi = Module["__ZNSt3__24stoiERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi"] = createExportWrapper("_ZNSt3__24stoiERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi");

/** @type {function(...*):?} */
var __ZNSt3__24stolERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi = Module["__ZNSt3__24stolERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi"] = createExportWrapper("_ZNSt3__24stolERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi");

/** @type {function(...*):?} */
var __ZNSt3__24stolERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi = Module["__ZNSt3__24stolERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi"] = createExportWrapper("_ZNSt3__24stolERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi");

/** @type {function(...*):?} */
var __ZNSt3__25stoulERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi = Module["__ZNSt3__25stoulERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi"] = createExportWrapper("_ZNSt3__25stoulERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi");

/** @type {function(...*):?} */
var __ZNSt3__25stoulERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi = Module["__ZNSt3__25stoulERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi"] = createExportWrapper("_ZNSt3__25stoulERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi");

/** @type {function(...*):?} */
var __ZNSt3__25stollERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi = Module["__ZNSt3__25stollERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi"] = createExportWrapper("_ZNSt3__25stollERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi");

/** @type {function(...*):?} */
var __ZNSt3__25stollERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi = Module["__ZNSt3__25stollERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi"] = createExportWrapper("_ZNSt3__25stollERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi");

/** @type {function(...*):?} */
var __ZNSt3__26stoullERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi = Module["__ZNSt3__26stoullERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi"] = createExportWrapper("_ZNSt3__26stoullERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPmi");

/** @type {function(...*):?} */
var __ZNSt3__26stoullERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi = Module["__ZNSt3__26stoullERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi"] = createExportWrapper("_ZNSt3__26stoullERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPmi");

/** @type {function(...*):?} */
var __ZNSt3__24stofERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPm = Module["__ZNSt3__24stofERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPm"] = createExportWrapper("_ZNSt3__24stofERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPm");

/** @type {function(...*):?} */
var __ZNSt3__24stofERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPm = Module["__ZNSt3__24stofERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPm"] = createExportWrapper("_ZNSt3__24stofERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPm");

/** @type {function(...*):?} */
var __ZNSt3__24stodERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPm = Module["__ZNSt3__24stodERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPm"] = createExportWrapper("_ZNSt3__24stodERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPm");

/** @type {function(...*):?} */
var __ZNSt3__24stodERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPm = Module["__ZNSt3__24stodERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPm"] = createExportWrapper("_ZNSt3__24stodERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPm");

/** @type {function(...*):?} */
var __ZNSt3__25stoldERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPm = Module["__ZNSt3__25stoldERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPm"] = createExportWrapper("_ZNSt3__25stoldERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEPm");

/** @type {function(...*):?} */
var __ZNSt3__25stoldERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPm = Module["__ZNSt3__25stoldERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPm"] = createExportWrapper("_ZNSt3__25stoldERKNS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEEPm");

/** @type {function(...*):?} */
var __ZNSt3__28to_charsIiLi0EEENS_15to_chars_resultEPcS2_T_ = Module["__ZNSt3__28to_charsIiLi0EEENS_15to_chars_resultEPcS2_T_"] = createExportWrapper("_ZNSt3__28to_charsIiLi0EEENS_15to_chars_resultEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPcvEET_S8_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPcvEET_S8_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPcvEET_S8_");

/** @type {function(...*):?} */
var __ZNSt3__29to_stringEl = Module["__ZNSt3__29to_stringEl"] = createExportWrapper("_ZNSt3__29to_stringEl");

/** @type {function(...*):?} */
var __ZNSt3__28to_charsIlLi0EEENS_15to_chars_resultEPcS2_T_ = Module["__ZNSt3__28to_charsIlLi0EEENS_15to_chars_resultEPcS2_T_"] = createExportWrapper("_ZNSt3__28to_charsIlLi0EEENS_15to_chars_resultEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__29to_stringEx = Module["__ZNSt3__29to_stringEx"] = createExportWrapper("_ZNSt3__29to_stringEx");

/** @type {function(...*):?} */
var __ZNSt3__28to_charsIxLi0EEENS_15to_chars_resultEPcS2_T_ = Module["__ZNSt3__28to_charsIxLi0EEENS_15to_chars_resultEPcS2_T_"] = createExportWrapper("_ZNSt3__28to_charsIxLi0EEENS_15to_chars_resultEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__29to_stringEj = Module["__ZNSt3__29to_stringEj"] = createExportWrapper("_ZNSt3__29to_stringEj");

/** @type {function(...*):?} */
var __ZNSt3__28to_charsIjLi0EEENS_15to_chars_resultEPcS2_T_ = Module["__ZNSt3__28to_charsIjLi0EEENS_15to_chars_resultEPcS2_T_"] = createExportWrapper("_ZNSt3__28to_charsIjLi0EEENS_15to_chars_resultEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__29to_stringEm = Module["__ZNSt3__29to_stringEm"] = createExportWrapper("_ZNSt3__29to_stringEm");

/** @type {function(...*):?} */
var __ZNSt3__28to_charsImLi0EEENS_15to_chars_resultEPcS2_T_ = Module["__ZNSt3__28to_charsImLi0EEENS_15to_chars_resultEPcS2_T_"] = createExportWrapper("_ZNSt3__28to_charsImLi0EEENS_15to_chars_resultEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__29to_stringEy = Module["__ZNSt3__29to_stringEy"] = createExportWrapper("_ZNSt3__29to_stringEy");

/** @type {function(...*):?} */
var __ZNSt3__28to_charsIyLi0EEENS_15to_chars_resultEPcS2_T_ = Module["__ZNSt3__28to_charsIyLi0EEENS_15to_chars_resultEPcS2_T_"] = createExportWrapper("_ZNSt3__28to_charsIyLi0EEENS_15to_chars_resultEPcS2_T_");

/** @type {function(...*):?} */
var __ZNSt3__210to_wstringEi = Module["__ZNSt3__210to_wstringEi"] = createExportWrapper("_ZNSt3__210to_wstringEi");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IPcvEET_S8_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IPcvEET_S8_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2IPcvEET_S8_");

/** @type {function(...*):?} */
var __ZNSt3__210to_wstringEl = Module["__ZNSt3__210to_wstringEl"] = createExportWrapper("_ZNSt3__210to_wstringEl");

/** @type {function(...*):?} */
var __ZNSt3__210to_wstringEx = Module["__ZNSt3__210to_wstringEx"] = createExportWrapper("_ZNSt3__210to_wstringEx");

/** @type {function(...*):?} */
var __ZNSt3__210to_wstringEj = Module["__ZNSt3__210to_wstringEj"] = createExportWrapper("_ZNSt3__210to_wstringEj");

/** @type {function(...*):?} */
var __ZNSt3__210to_wstringEm = Module["__ZNSt3__210to_wstringEm"] = createExportWrapper("_ZNSt3__210to_wstringEm");

/** @type {function(...*):?} */
var __ZNSt3__210to_wstringEy = Module["__ZNSt3__210to_wstringEy"] = createExportWrapper("_ZNSt3__210to_wstringEy");

/** @type {function(...*):?} */
var __ZNSt3__29to_stringEf = Module["__ZNSt3__29to_stringEf"] = createExportWrapper("_ZNSt3__29to_stringEf");

/** @type {function(...*):?} */
var __ZNSt3__29to_stringEd = Module["__ZNSt3__29to_stringEd"] = createExportWrapper("_ZNSt3__29to_stringEd");

/** @type {function(...*):?} */
var __ZNSt3__29to_stringEe = Module["__ZNSt3__29to_stringEe"] = createExportWrapper("_ZNSt3__29to_stringEe");

/** @type {function(...*):?} */
var __ZNSt3__210to_wstringEf = Module["__ZNSt3__210to_wstringEf"] = createExportWrapper("_ZNSt3__210to_wstringEf");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6resizeEm = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6resizeEm"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6resizeEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2EOS5_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2EOS5_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC2EOS5_");

/** @type {function(...*):?} */
var __ZNSt3__210to_wstringEd = Module["__ZNSt3__210to_wstringEd"] = createExportWrapper("_ZNSt3__210to_wstringEd");

/** @type {function(...*):?} */
var __ZNSt3__210to_wstringEe = Module["__ZNSt3__210to_wstringEe"] = createExportWrapper("_ZNSt3__210to_wstringEe");

/** @type {function(...*):?} */
var __ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EERKS9_PKS6_ = Module["__ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EERKS9_PKS6_"] = createExportWrapper("_ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EERKS9_PKS6_");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE4sizeEv = Module["__ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE4sizeEv"] = createExportWrapper("_ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE4sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE4dataEv = Module["__ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE4dataEv"] = createExportWrapper("_ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE4dataEv");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE4sizeEv = Module["__ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE4sizeEv"] = createExportWrapper("_ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE4sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE4dataEv = Module["__ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE4dataEv"] = createExportWrapper("_ZNKSt3__217basic_string_viewIwNS_11char_traitsIwEEE4dataEv");

/** @type {function(...*):?} */
var __ZNSt3__215__to_chars_itoaIiEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb1EEE = Module["__ZNSt3__215__to_chars_itoaIiEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb1EEE"] = createExportWrapper("_ZNSt3__215__to_chars_itoaIiEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb1EEE");

/** @type {function(...*):?} */
var __ZNSt3__213__to_unsignedIiEENS_13make_unsignedIT_E4typeES2_ = Module["__ZNSt3__213__to_unsignedIiEENS_13make_unsignedIT_E4typeES2_"] = createExportWrapper("_ZNSt3__213__to_unsignedIiEENS_13make_unsignedIT_E4typeES2_");

/** @type {function(...*):?} */
var __ZNSt3__212__complementIjEET_S1_ = Module["__ZNSt3__212__complementIjEET_S1_"] = createExportWrapper("_ZNSt3__212__complementIjEET_S1_");

/** @type {function(...*):?} */
var __ZNSt3__215__to_chars_itoaIjEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__215__to_chars_itoaIjEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__215__to_chars_itoaIjEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa13__traits_baseIjvE7__widthEj = Module["__ZNSt3__26__itoa13__traits_baseIjvE7__widthEj"] = createExportWrapper("_ZNSt3__26__itoa13__traits_baseIjvE7__widthEj");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa13__traits_baseIjvE9__convertEjPc = Module["__ZNSt3__26__itoa13__traits_baseIjvE9__convertEjPc"] = createExportWrapper("_ZNSt3__26__itoa13__traits_baseIjvE9__convertEjPc");

/** @type {function(...*):?} */
var __ZNSt3__215__to_chars_itoaIlEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb1EEE = Module["__ZNSt3__215__to_chars_itoaIlEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb1EEE"] = createExportWrapper("_ZNSt3__215__to_chars_itoaIlEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb1EEE");

/** @type {function(...*):?} */
var __ZNSt3__213__to_unsignedIlEENS_13make_unsignedIT_E4typeES2_ = Module["__ZNSt3__213__to_unsignedIlEENS_13make_unsignedIT_E4typeES2_"] = createExportWrapper("_ZNSt3__213__to_unsignedIlEENS_13make_unsignedIT_E4typeES2_");

/** @type {function(...*):?} */
var __ZNSt3__212__complementImEET_S1_ = Module["__ZNSt3__212__complementImEET_S1_"] = createExportWrapper("_ZNSt3__212__complementImEET_S1_");

/** @type {function(...*):?} */
var __ZNSt3__215__to_chars_itoaImEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__215__to_chars_itoaImEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__215__to_chars_itoaImEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa13__traits_baseImvE7__widthEm = Module["__ZNSt3__26__itoa13__traits_baseImvE7__widthEm"] = createExportWrapper("_ZNSt3__26__itoa13__traits_baseImvE7__widthEm");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa13__traits_baseImvE9__convertEmPc = Module["__ZNSt3__26__itoa13__traits_baseImvE9__convertEmPc"] = createExportWrapper("_ZNSt3__26__itoa13__traits_baseImvE9__convertEmPc");

/** @type {function(...*):?} */
var __ZNSt3__215__to_chars_itoaIxEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb1EEE = Module["__ZNSt3__215__to_chars_itoaIxEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb1EEE"] = createExportWrapper("_ZNSt3__215__to_chars_itoaIxEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb1EEE");

/** @type {function(...*):?} */
var __ZNSt3__213__to_unsignedIxEENS_13make_unsignedIT_E4typeES2_ = Module["__ZNSt3__213__to_unsignedIxEENS_13make_unsignedIT_E4typeES2_"] = createExportWrapper("_ZNSt3__213__to_unsignedIxEENS_13make_unsignedIT_E4typeES2_");

/** @type {function(...*):?} */
var __ZNSt3__212__complementIyEET_S1_ = Module["__ZNSt3__212__complementIyEET_S1_"] = createExportWrapper("_ZNSt3__212__complementIyEET_S1_");

/** @type {function(...*):?} */
var __ZNSt3__215__to_chars_itoaIyEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__215__to_chars_itoaIyEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__215__to_chars_itoaIyEENS_15to_chars_resultEPcS2_T_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa13__traits_baseIyvE7__widthEy = Module["__ZNSt3__26__itoa13__traits_baseIyvE7__widthEy"] = createExportWrapper("_ZNSt3__26__itoa13__traits_baseIyvE7__widthEy");

/** @type {function(...*):?} */
var __ZNSt3__26__itoa13__traits_baseIyvE9__convertEyPc = Module["__ZNSt3__26__itoa13__traits_baseIyvE9__convertEyPc"] = createExportWrapper("_ZNSt3__26__itoa13__traits_baseIyvE9__convertEyPc");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initIPcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeES9_S9_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initIPcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeES9_S9_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE6__initIPcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeES9_S9_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_17__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES6_EEEEONS_16remove_referenceIT_E4typeEOSC_ = Module["__ZNSt3__24moveIRNS_17__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES6_EEEEONS_16remove_referenceIT_E4typeEOSC_"] = createExportWrapper("_ZNSt3__24moveIRNS_17__compressed_pairINS_12basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE5__repES6_EEEEONS_16remove_referenceIT_E4typeEOSC_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC1ERKS5_RKS4_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC1ERKS5_RKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC1ERKS5_RKS4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC1ERKS5_mmRKS4_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC1ERKS5_mmRKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC1ERKS5_mmRKS4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEED1Ev = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEED1Ev"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC1ERKS5_RKS4_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC1ERKS5_RKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC1ERKS5_RKS4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC1ERKS5_mmRKS4_ = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC1ERKS5_mmRKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEEC1ERKS5_mmRKS4_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEED1Ev = Module["__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEED1Ev"] = createExportWrapper("_ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC2El = Module["__ZNSt3__212strstreambufC2El"] = createExportWrapper("_ZNSt3__212strstreambufC2El");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC2EPFPvmEPFvS1_E = Module["__ZNSt3__212strstreambufC2EPFPvmEPFvS1_E"] = createExportWrapper("_ZNSt3__212strstreambufC2EPFPvmEPFvS1_E");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambuf6__initEPclS1_ = Module["__ZNSt3__212strstreambuf6__initEPclS1_"] = createExportWrapper("_ZNSt3__212strstreambuf6__initEPclS1_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4setgEPcS4_S4_ = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4setgEPcS4_S4_"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4setgEPcS4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4setpEPcS4_ = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4setpEPcS4_"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE4setpEPcS4_");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC2EPclS1_ = Module["__ZNSt3__212strstreambufC2EPclS1_"] = createExportWrapper("_ZNSt3__212strstreambufC2EPclS1_");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC2EPKcl = Module["__ZNSt3__212strstreambufC2EPKcl"] = createExportWrapper("_ZNSt3__212strstreambufC2EPKcl");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC2EPalS1_ = Module["__ZNSt3__212strstreambufC2EPalS1_"] = createExportWrapper("_ZNSt3__212strstreambufC2EPalS1_");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC2EPKal = Module["__ZNSt3__212strstreambufC2EPKal"] = createExportWrapper("_ZNSt3__212strstreambufC2EPKal");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC2EPhlS1_ = Module["__ZNSt3__212strstreambufC2EPhlS1_"] = createExportWrapper("_ZNSt3__212strstreambufC2EPhlS1_");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC2EPKhl = Module["__ZNSt3__212strstreambufC2EPKhl"] = createExportWrapper("_ZNSt3__212strstreambufC2EPKhl");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufD2Ev = Module["__ZNSt3__212strstreambufD2Ev"] = createExportWrapper("_ZNSt3__212strstreambufD2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5ebackEv = Module["__ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5ebackEv"] = createExportWrapper("_ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5ebackEv");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufD0Ev = Module["__ZNSt3__212strstreambufD0Ev"] = createExportWrapper("_ZNSt3__212strstreambufD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambuf4swapERS0_ = Module["__ZNSt3__212strstreambuf4swapERS0_"] = createExportWrapper("_ZNSt3__212strstreambuf4swapERS0_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPFPvmEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_ = Module["__ZNSt3__24swapIPFPvmEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_"] = createExportWrapper("_ZNSt3__24swapIPFPvmEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPFvPvEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_ = Module["__ZNSt3__24swapIPFvPvEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_"] = createExportWrapper("_ZNSt3__24swapIPFvPvEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPFPvmEEEONS_16remove_referenceIT_E4typeEOS6_ = Module["__ZNSt3__24moveIRPFPvmEEEONS_16remove_referenceIT_E4typeEOS6_"] = createExportWrapper("_ZNSt3__24moveIRPFPvmEEEONS_16remove_referenceIT_E4typeEOS6_");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambuf6freezeEb = Module["__ZNSt3__212strstreambuf6freezeEb"] = createExportWrapper("_ZNSt3__212strstreambuf6freezeEb");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambuf3strEv = Module["__ZNSt3__212strstreambuf3strEv"] = createExportWrapper("_ZNSt3__212strstreambuf3strEv");

/** @type {function(...*):?} */
var __ZNKSt3__212strstreambuf6pcountEv = Module["__ZNKSt3__212strstreambuf6pcountEv"] = createExportWrapper("_ZNKSt3__212strstreambuf6pcountEv");

/** @type {function(...*):?} */
var __ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE4pptrEv = Module["__ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE4pptrEv"] = createExportWrapper("_ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE4pptrEv");

/** @type {function(...*):?} */
var __ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5pbaseEv = Module["__ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5pbaseEv"] = createExportWrapper("_ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5pbaseEv");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambuf8overflowEi = Module["__ZNSt3__212strstreambuf8overflowEi"] = createExportWrapper("_ZNSt3__212strstreambuf8overflowEi");

/** @type {function(...*):?} */
var __ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5epptrEv = Module["__ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5epptrEv"] = createExportWrapper("_ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5epptrEv");

/** @type {function(...*):?} */
var __ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5egptrEv = Module["__ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5egptrEv"] = createExportWrapper("_ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE5egptrEv");

/** @type {function(...*):?} */
var __ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE4gptrEv = Module["__ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE4gptrEv"] = createExportWrapper("_ZNKSt3__215basic_streambufIcNS_11char_traitsIcEEE4gptrEv");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7__pbumpEl = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7__pbumpEl"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE7__pbumpEl");

/** @type {function(...*):?} */
var __ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5pbumpEi = Module["__ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5pbumpEi"] = createExportWrapper("_ZNSt3__215basic_streambufIcNS_11char_traitsIcEEE5pbumpEi");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambuf9pbackfailEi = Module["__ZNSt3__212strstreambuf9pbackfailEi"] = createExportWrapper("_ZNSt3__212strstreambuf9pbackfailEi");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambuf9underflowEv = Module["__ZNSt3__212strstreambuf9underflowEv"] = createExportWrapper("_ZNSt3__212strstreambuf9underflowEv");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambuf7seekoffExNS_8ios_base7seekdirEj = Module["__ZNSt3__212strstreambuf7seekoffExNS_8ios_base7seekdirEj"] = createExportWrapper("_ZNSt3__212strstreambuf7seekoffExNS_8ios_base7seekdirEj");

/** @type {function(...*):?} */
var __ZNSt3__23maxIPcEERKT_S4_S4_ = Module["__ZNSt3__23maxIPcEERKT_S4_S4_"] = createExportWrapper("_ZNSt3__23maxIPcEERKT_S4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__23minIPcEERKT_S4_S4_ = Module["__ZNSt3__23minIPcEERKT_S4_S4_"] = createExportWrapper("_ZNSt3__23minIPcEERKT_S4_S4_");

/** @type {function(...*):?} */
var __ZNSt3__23maxIPcNS_6__lessIS1_S1_EEEERKT_S6_S6_T0_ = Module["__ZNSt3__23maxIPcNS_6__lessIS1_S1_EEEERKT_S6_S6_T0_"] = createExportWrapper("_ZNSt3__23maxIPcNS_6__lessIS1_S1_EEEERKT_S6_S6_T0_");

/** @type {function(...*):?} */
var __ZNSt3__23minIPcNS_6__lessIS1_S1_EEEERKT_S6_S6_T0_ = Module["__ZNSt3__23minIPcNS_6__lessIS1_S1_EEEERKT_S6_S6_T0_"] = createExportWrapper("_ZNSt3__23minIPcNS_6__lessIS1_S1_EEEERKT_S6_S6_T0_");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambuf7seekposENS_4fposI11__mbstate_tEEj = Module["__ZNSt3__212strstreambuf7seekposENS_4fposI11__mbstate_tEEj"] = createExportWrapper("_ZNSt3__212strstreambuf7seekposENS_4fposI11__mbstate_tEEj");

/** @type {function(...*):?} */
var __ZNSt3__210istrstreamD2Ev = Module["__ZNSt3__210istrstreamD2Ev"] = createExportWrapper("_ZNSt3__210istrstreamD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210istrstreamD1Ev = Module["__ZNSt3__210istrstreamD1Ev"] = createExportWrapper("_ZNSt3__210istrstreamD1Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__210istrstreamD1Ev = Module["__ZTv0_n12_NSt3__210istrstreamD1Ev"] = createExportWrapper("_ZTv0_n12_NSt3__210istrstreamD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__210istrstreamD0Ev = Module["__ZNSt3__210istrstreamD0Ev"] = createExportWrapper("_ZNSt3__210istrstreamD0Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__210istrstreamD0Ev = Module["__ZTv0_n12_NSt3__210istrstreamD0Ev"] = createExportWrapper("_ZTv0_n12_NSt3__210istrstreamD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__210ostrstreamD2Ev = Module["__ZNSt3__210ostrstreamD2Ev"] = createExportWrapper("_ZNSt3__210ostrstreamD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210ostrstreamD1Ev = Module["__ZNSt3__210ostrstreamD1Ev"] = createExportWrapper("_ZNSt3__210ostrstreamD1Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__210ostrstreamD1Ev = Module["__ZTv0_n12_NSt3__210ostrstreamD1Ev"] = createExportWrapper("_ZTv0_n12_NSt3__210ostrstreamD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__210ostrstreamD0Ev = Module["__ZNSt3__210ostrstreamD0Ev"] = createExportWrapper("_ZNSt3__210ostrstreamD0Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__210ostrstreamD0Ev = Module["__ZTv0_n12_NSt3__210ostrstreamD0Ev"] = createExportWrapper("_ZTv0_n12_NSt3__210ostrstreamD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__29strstreamD2Ev = Module["__ZNSt3__29strstreamD2Ev"] = createExportWrapper("_ZNSt3__29strstreamD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__29strstreamD1Ev = Module["__ZNSt3__29strstreamD1Ev"] = createExportWrapper("_ZNSt3__29strstreamD1Ev");

/** @type {function(...*):?} */
var __ZThn8_NSt3__29strstreamD1Ev = Module["__ZThn8_NSt3__29strstreamD1Ev"] = createExportWrapper("_ZThn8_NSt3__29strstreamD1Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__29strstreamD1Ev = Module["__ZTv0_n12_NSt3__29strstreamD1Ev"] = createExportWrapper("_ZTv0_n12_NSt3__29strstreamD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__29strstreamD0Ev = Module["__ZNSt3__29strstreamD0Ev"] = createExportWrapper("_ZNSt3__29strstreamD0Ev");

/** @type {function(...*):?} */
var __ZThn8_NSt3__29strstreamD0Ev = Module["__ZThn8_NSt3__29strstreamD0Ev"] = createExportWrapper("_ZThn8_NSt3__29strstreamD0Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__29strstreamD0Ev = Module["__ZTv0_n12_NSt3__29strstreamD0Ev"] = createExportWrapper("_ZTv0_n12_NSt3__29strstreamD0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__26__lessIPcS1_EclERKS1_S4_ = Module["__ZNKSt3__26__lessIPcS1_EclERKS1_S4_"] = createExportWrapper("_ZNKSt3__26__lessIPcS1_EclERKS1_S4_");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC1El = Module["__ZNSt3__212strstreambufC1El"] = createExportWrapper("_ZNSt3__212strstreambufC1El");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC1EPFPvmEPFvS1_E = Module["__ZNSt3__212strstreambufC1EPFPvmEPFvS1_E"] = createExportWrapper("_ZNSt3__212strstreambufC1EPFPvmEPFvS1_E");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC1EPclS1_ = Module["__ZNSt3__212strstreambufC1EPclS1_"] = createExportWrapper("_ZNSt3__212strstreambufC1EPclS1_");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC1EPKcl = Module["__ZNSt3__212strstreambufC1EPKcl"] = createExportWrapper("_ZNSt3__212strstreambufC1EPKcl");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC1EPalS1_ = Module["__ZNSt3__212strstreambufC1EPalS1_"] = createExportWrapper("_ZNSt3__212strstreambufC1EPalS1_");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC1EPKal = Module["__ZNSt3__212strstreambufC1EPKal"] = createExportWrapper("_ZNSt3__212strstreambufC1EPKal");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC1EPhlS1_ = Module["__ZNSt3__212strstreambufC1EPhlS1_"] = createExportWrapper("_ZNSt3__212strstreambufC1EPhlS1_");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufC1EPKhl = Module["__ZNSt3__212strstreambufC1EPKhl"] = createExportWrapper("_ZNSt3__212strstreambufC1EPKhl");

/** @type {function(...*):?} */
var __ZNSt3__212strstreambufD1Ev = Module["__ZNSt3__212strstreambufD1Ev"] = createExportWrapper("_ZNSt3__212strstreambufD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214error_categoryD0Ev = Module["__ZNSt3__214error_categoryD0Ev"] = createExportWrapper("_ZNSt3__214error_categoryD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__215error_conditionC2EiRKNS_14error_categoryE = Module["__ZNSt3__215error_conditionC2EiRKNS_14error_categoryE"] = createExportWrapper("_ZNSt3__215error_conditionC2EiRKNS_14error_categoryE");

/** @type {function(...*):?} */
var __ZNSt3__2eqERKNS_15error_conditionES2_ = Module["__ZNSt3__2eqERKNS_15error_conditionES2_"] = createExportWrapper("_ZNSt3__2eqERKNS_15error_conditionES2_");

/** @type {function(...*):?} */
var __ZNKSt3__215error_condition8categoryEv = Module["__ZNKSt3__215error_condition8categoryEv"] = createExportWrapper("_ZNKSt3__215error_condition8categoryEv");

/** @type {function(...*):?} */
var __ZNKSt3__214error_categoryeqERKS0_ = Module["__ZNKSt3__214error_categoryeqERKS0_"] = createExportWrapper("_ZNKSt3__214error_categoryeqERKS0_");

/** @type {function(...*):?} */
var __ZNKSt3__215error_condition5valueEv = Module["__ZNKSt3__215error_condition5valueEv"] = createExportWrapper("_ZNKSt3__215error_condition5valueEv");

/** @type {function(...*):?} */
var __ZNKSt3__210error_code8categoryEv = Module["__ZNKSt3__210error_code8categoryEv"] = createExportWrapper("_ZNKSt3__210error_code8categoryEv");

/** @type {function(...*):?} */
var __ZNKSt3__210error_code5valueEv = Module["__ZNKSt3__210error_code5valueEv"] = createExportWrapper("_ZNKSt3__210error_code5valueEv");

/** @type {function(...*):?} */
var __ZNKSt3__224__generic_error_category4nameEv = Module["__ZNKSt3__224__generic_error_category4nameEv"] = createExportWrapper("_ZNKSt3__224__generic_error_category4nameEv");

/** @type {function(...*):?} */
var __ZNKSt3__224__generic_error_category7messageEi = Module["__ZNKSt3__224__generic_error_category7messageEi"] = createExportWrapper("_ZNKSt3__224__generic_error_category7messageEi");

/** @type {function(...*):?} */
var __ZNSt3__216generic_categoryEv = Module["__ZNSt3__216generic_categoryEv"] = createExportWrapper("_ZNSt3__216generic_categoryEv");

/** @type {function(...*):?} */
var __ZNKSt3__223__system_error_category4nameEv = Module["__ZNKSt3__223__system_error_category4nameEv"] = createExportWrapper("_ZNKSt3__223__system_error_category4nameEv");

/** @type {function(...*):?} */
var __ZNKSt3__223__system_error_category7messageEi = Module["__ZNKSt3__223__system_error_category7messageEi"] = createExportWrapper("_ZNKSt3__223__system_error_category7messageEi");

/** @type {function(...*):?} */
var __ZNKSt3__223__system_error_category23default_error_conditionEi = Module["__ZNKSt3__223__system_error_category23default_error_conditionEi"] = createExportWrapper("_ZNKSt3__223__system_error_category23default_error_conditionEi");

/** @type {function(...*):?} */
var __ZNSt3__215system_categoryEv = Module["__ZNSt3__215system_categoryEv"] = createExportWrapper("_ZNSt3__215system_categoryEv");

/** @type {function(...*):?} */
var __ZNKSt3__215error_condition7messageEv = Module["__ZNKSt3__215error_condition7messageEv"] = createExportWrapper("_ZNKSt3__215error_condition7messageEv");

/** @type {function(...*):?} */
var __ZNSt3__212system_error6__initERKNS_10error_codeENS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__212system_error6__initERKNS_10error_codeENS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__212system_error6__initERKNS_10error_codeENS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNKSt3__210error_codecvbEv = Module["__ZNKSt3__210error_codecvbEv"] = createExportWrapper("_ZNKSt3__210error_codecvbEv");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC2ENS_10error_codeE = Module["__ZNSt3__212system_errorC2ENS_10error_codeE"] = createExportWrapper("_ZNSt3__212system_errorC2ENS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC2EiRKNS_14error_categoryERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__212system_errorC2EiRKNS_14error_categoryERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__212system_errorC2EiRKNS_14error_categoryERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__210error_codeC2EiRKNS_14error_categoryE = Module["__ZNSt3__210error_codeC2EiRKNS_14error_categoryE"] = createExportWrapper("_ZNSt3__210error_codeC2EiRKNS_14error_categoryE");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC2EiRKNS_14error_categoryEPKc = Module["__ZNSt3__212system_errorC2EiRKNS_14error_categoryEPKc"] = createExportWrapper("_ZNSt3__212system_errorC2EiRKNS_14error_categoryEPKc");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC2EiRKNS_14error_categoryE = Module["__ZNSt3__212system_errorC2EiRKNS_14error_categoryE"] = createExportWrapper("_ZNSt3__212system_errorC2EiRKNS_14error_categoryE");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorD0Ev = Module["__ZNSt3__212system_errorD0Ev"] = createExportWrapper("_ZNSt3__212system_errorD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__212__do_messageD0Ev = Module["__ZNSt3__212__do_messageD0Ev"] = createExportWrapper("_ZNSt3__212__do_messageD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__224__generic_error_categoryD0Ev = Module["__ZNSt3__224__generic_error_categoryD0Ev"] = createExportWrapper("_ZNSt3__224__generic_error_categoryD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__223__system_error_categoryD0Ev = Module["__ZNSt3__223__system_error_categoryD0Ev"] = createExportWrapper("_ZNSt3__223__system_error_categoryD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__214error_categoryD1Ev = Module["__ZNSt3__214error_categoryD1Ev"] = createExportWrapper("_ZNSt3__214error_categoryD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC1ENS_10error_codeERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__212system_errorC1ENS_10error_codeERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__212system_errorC1ENS_10error_codeERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC1ENS_10error_codeEPKc = Module["__ZNSt3__212system_errorC1ENS_10error_codeEPKc"] = createExportWrapper("_ZNSt3__212system_errorC1ENS_10error_codeEPKc");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC1ENS_10error_codeE = Module["__ZNSt3__212system_errorC1ENS_10error_codeE"] = createExportWrapper("_ZNSt3__212system_errorC1ENS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC1EiRKNS_14error_categoryERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE = Module["__ZNSt3__212system_errorC1EiRKNS_14error_categoryERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE"] = createExportWrapper("_ZNSt3__212system_errorC1EiRKNS_14error_categoryERKNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC1EiRKNS_14error_categoryEPKc = Module["__ZNSt3__212system_errorC1EiRKNS_14error_categoryEPKc"] = createExportWrapper("_ZNSt3__212system_errorC1EiRKNS_14error_categoryEPKc");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorC1EiRKNS_14error_categoryE = Module["__ZNSt3__212system_errorC1EiRKNS_14error_categoryE"] = createExportWrapper("_ZNSt3__212system_errorC1EiRKNS_14error_categoryE");

/** @type {function(...*):?} */
var __ZNSt3__212system_errorD1Ev = Module["__ZNSt3__212system_errorD1Ev"] = createExportWrapper("_ZNSt3__212system_errorD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__26threadD2Ev = Module["__ZNSt3__26threadD2Ev"] = createExportWrapper("_ZNSt3__26threadD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__222__libcpp_thread_isnullEPKm = Module["__ZNSt3__222__libcpp_thread_isnullEPKm"] = createExportWrapper("_ZNSt3__222__libcpp_thread_isnullEPKm");

/** @type {function(...*):?} */
var __ZNSt3__26thread4joinEv = Module["__ZNSt3__26thread4joinEv"] = createExportWrapper("_ZNSt3__26thread4joinEv");

/** @type {function(...*):?} */
var __ZNSt3__220__libcpp_thread_joinEPm = Module["__ZNSt3__220__libcpp_thread_joinEPm"] = createExportWrapper("_ZNSt3__220__libcpp_thread_joinEPm");

/** @type {function(...*):?} */
var __ZNSt3__26thread6detachEv = Module["__ZNSt3__26thread6detachEv"] = createExportWrapper("_ZNSt3__26thread6detachEv");

/** @type {function(...*):?} */
var __ZNSt3__222__libcpp_thread_detachEPm = Module["__ZNSt3__222__libcpp_thread_detachEPm"] = createExportWrapper("_ZNSt3__222__libcpp_thread_detachEPm");

/** @type {function(...*):?} */
var __ZNSt3__26thread20hardware_concurrencyEv = Module["__ZNSt3__26thread20hardware_concurrencyEv"] = createExportWrapper("_ZNSt3__26thread20hardware_concurrencyEv");

/** @type {function(...*):?} */
var __ZNSt3__211this_thread9sleep_forERKNS_6chrono8durationIxNS_5ratioILx1ELx1000000000EEEEE = Module["__ZNSt3__211this_thread9sleep_forERKNS_6chrono8durationIxNS_5ratioILx1ELx1000000000EEEEE"] = createExportWrapper("_ZNSt3__211this_thread9sleep_forERKNS_6chrono8durationIxNS_5ratioILx1ELx1000000000EEEEE");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEE4zeroEv = Module["__ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEE4zeroEv"] = createExportWrapper("_ZNSt3__26chrono8durationIxNS_5ratioILx1ELx1000000000EEEE4zeroEv");

/** @type {function(...*):?} */
var __ZNSt3__225__libcpp_thread_sleep_forERKNS_6chrono8durationIxNS_5ratioILx1ELx1000000000EEEEE = Module["__ZNSt3__225__libcpp_thread_sleep_forERKNS_6chrono8durationIxNS_5ratioILx1ELx1000000000EEEEE"] = createExportWrapper("_ZNSt3__225__libcpp_thread_sleep_forERKNS_6chrono8durationIxNS_5ratioILx1ELx1000000000EEEEE");

/** @type {function(...*):?} */
var __ZNSt3__26chrono15duration_valuesIxE4zeroEv = Module["__ZNSt3__26chrono15duration_valuesIxE4zeroEv"] = createExportWrapper("_ZNSt3__26chrono15duration_valuesIxE4zeroEv");

/** @type {function(...*):?} */
var __ZNSt3__215__thread_detail21__convert_to_timespecERKNS_6chrono8durationIxNS_5ratioILx1ELx1000000000EEEEE = Module["__ZNSt3__215__thread_detail21__convert_to_timespecERKNS_6chrono8durationIxNS_5ratioILx1ELx1000000000EEEEE"] = createExportWrapper("_ZNSt3__215__thread_detail21__convert_to_timespecERKNS_6chrono8durationIxNS_5ratioILx1ELx1000000000EEEEE");

/** @type {function(...*):?} */
var __ZNSt3__221__thread_specific_ptrINS_15__thread_structEEC2Ev = Module["__ZNSt3__221__thread_specific_ptrINS_15__thread_structEEC2Ev"] = createExportWrapper("_ZNSt3__221__thread_specific_ptrINS_15__thread_structEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__221__thread_specific_ptrINS_15__thread_structEE16__at_thread_exitEPv = Module["__ZNSt3__221__thread_specific_ptrINS_15__thread_structEE16__at_thread_exitEPv"] = createExportWrapper("_ZNSt3__221__thread_specific_ptrINS_15__thread_structEE16__at_thread_exitEPv");

/** @type {function(...*):?} */
var __ZNSt3__219__libcpp_tls_createEPjPFvPvE = Module["__ZNSt3__219__libcpp_tls_createEPjPFvPvE"] = createExportWrapper("_ZNSt3__219__libcpp_tls_createEPjPFvPvE");

/** @type {function(...*):?} */
var __ZNSt3__221__thread_specific_ptrINS_15__thread_structEED2Ev = Module["__ZNSt3__221__thread_specific_ptrINS_15__thread_structEED2Ev"] = createExportWrapper("_ZNSt3__221__thread_specific_ptrINS_15__thread_structEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__219__thread_struct_impD2Ev = Module["__ZNSt3__219__thread_struct_impD2Ev"] = createExportWrapper("_ZNSt3__219__thread_struct_impD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5beginEv = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5beginEv"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5beginEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE3endEv = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE3endEv"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE3endEv");

/** @type {function(...*):?} */
var __ZNSt3__2neIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEbRKNS_11__wrap_iterIT_EESC_ = Module["__ZNSt3__2neIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEbRKNS_11__wrap_iterIT_EESC_"] = createExportWrapper("_ZNSt3__2neIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEbRKNS_11__wrap_iterIT_EESC_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5beginEv = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5beginEv"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5beginEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE3endEv = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE3endEv"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE3endEv");

/** @type {function(...*):?} */
var __ZNSt3__2neIPPNS_17__assoc_sub_stateEEEbRKNS_11__wrap_iterIT_EES8_ = Module["__ZNSt3__2neIPPNS_17__assoc_sub_stateEEEbRKNS_11__wrap_iterIT_EES8_"] = createExportWrapper("_ZNSt3__2neIPPNS_17__assoc_sub_stateEEEbRKNS_11__wrap_iterIT_EES8_");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEEdeEv = Module["__ZNKSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEEdeEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEEppEv = Module["__ZNSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEEppEv"] = createExportWrapper("_ZNSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEEppEv");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEptEv = Module["__ZNKSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEptEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEptEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEppEv = Module["__ZNSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEppEv"] = createExportWrapper("_ZNSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEppEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEED2Ev = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEED2Ev"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEED2Ev = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEED2Ev"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE11__make_iterEPS6_ = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE11__make_iterEPS6_"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE11__make_iterEPS6_");

/** @type {function(...*):?} */
var __ZNSt3__2eqIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEES7_EEbRKNS_11__wrap_iterIT_EERKNS8_IT0_EE = Module["__ZNSt3__2eqIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEES7_EEbRKNS_11__wrap_iterIT_EERKNS8_IT0_EE"] = createExportWrapper("_ZNSt3__2eqIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEES7_EEbRKNS_11__wrap_iterIT_EERKNS8_IT0_EE");

/** @type {function(...*):?} */
var __ZNSt3__29addressofINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEPT_RS7_ = Module["__ZNSt3__29addressofINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEPT_RS7_"] = createExportWrapper("_ZNSt3__29addressofINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEPT_RS7_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE11__make_iterEPS2_ = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE11__make_iterEPS2_"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE11__make_iterEPS2_");

/** @type {function(...*):?} */
var __ZNSt3__2eqIPPNS_17__assoc_sub_stateES3_EEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE = Module["__ZNSt3__2eqIPPNS_17__assoc_sub_stateES3_EEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE"] = createExportWrapper("_ZNSt3__2eqIPPNS_17__assoc_sub_stateES3_EEbRKNS_11__wrap_iterIT_EERKNS4_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE17__annotate_deleteEv = Module["__ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE17__annotate_deleteEv"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE17__annotate_deleteEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEED2Ev = Module["__ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEED2Ev"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEED2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE17__annotate_deleteEv = Module["__ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE17__annotate_deleteEv"] = createExportWrapper("_ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE17__annotate_deleteEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEED2Ev = Module["__ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEED2Ev"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__219__thread_struct_imp25notify_all_at_thread_exitEPNS_18condition_variableEPNS_5mutexE = Module["__ZNSt3__219__thread_struct_imp25notify_all_at_thread_exitEPNS_18condition_variableEPNS_5mutexE"] = createExportWrapper("_ZNSt3__219__thread_struct_imp25notify_all_at_thread_exitEPNS_18condition_variableEPNS_5mutexE");

/** @type {function(...*):?} */
var __ZNSt3__24pairIPNS_18condition_variableEPNS_5mutexEEC2IRS2_RS4_Lb0EEEOT_OT0_ = Module["__ZNSt3__24pairIPNS_18condition_variableEPNS_5mutexEEC2IRS2_RS4_Lb0EEEOT_OT0_"] = createExportWrapper("_ZNSt3__24pairIPNS_18condition_variableEPNS_5mutexEEC2IRS2_RS4_Lb0EEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE9push_backEOS6_ = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE9push_backEOS6_"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE9push_backEOS6_");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE9__end_capEv = Module["__ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE9__end_capEv"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEONS_16remove_referenceIT_E4typeEOS9_ = Module["__ZNSt3__24moveIRNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEONS_16remove_referenceIT_E4typeEOS9_"] = createExportWrapper("_ZNSt3__24moveIRNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEONS_16remove_referenceIT_E4typeEOS9_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE22__construct_one_at_endIJS6_EEEvDpOT_ = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE22__construct_one_at_endIJS6_EEEvDpOT_"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE22__construct_one_at_endIJS6_EEEvDpOT_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE21__push_back_slow_pathIS6_EEvOT_ = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE21__push_back_slow_pathIS6_EEvOT_"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE21__push_back_slow_pathIS6_EEvOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPNS_18condition_variableEEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRPNS_18condition_variableEEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPNS_18condition_variableEEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPNS_5mutexEEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRPNS_5mutexEEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPNS_5mutexEEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__219__thread_struct_imp27__make_ready_at_thread_exitEPNS_17__assoc_sub_stateE = Module["__ZNSt3__219__thread_struct_imp27__make_ready_at_thread_exitEPNS_17__assoc_sub_stateE"] = createExportWrapper("_ZNSt3__219__thread_struct_imp27__make_ready_at_thread_exitEPNS_17__assoc_sub_stateE");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE9push_backERKS2_ = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE9push_backERKS2_"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE9push_backERKS2_");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE9__end_capEv = Module["__ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE9__end_capEv"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE22__construct_one_at_endIJRKS2_EEEvDpOT_ = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE22__construct_one_at_endIJRKS2_EEEvDpOT_"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE22__construct_one_at_endIJRKS2_EEEvDpOT_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE21__push_back_slow_pathIRKS2_EEvOT_ = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE21__push_back_slow_pathIRKS2_EEvOT_"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE21__push_back_slow_pathIRKS2_EEvOT_");

/** @type {function(...*):?} */
var __ZNSt3__215__thread_structC2Ev = Module["__ZNSt3__215__thread_structC2Ev"] = createExportWrapper("_ZNSt3__215__thread_structC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__219__thread_struct_impC2Ev = Module["__ZNSt3__219__thread_struct_impC2Ev"] = createExportWrapper("_ZNSt3__219__thread_struct_impC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEEC2Ev = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEEC2Ev"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEEC2Ev = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEEC2Ev"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__215__thread_structD2Ev = Module["__ZNSt3__215__thread_structD2Ev"] = createExportWrapper("_ZNSt3__215__thread_structD2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEE4baseEv = Module["__ZNKSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEE4baseEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEE4baseEv");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEE4baseEv = Module["__ZNKSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEE4baseEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEE4baseEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEEC2Ev = Module["__ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEEC2Ev"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEEC2Ev = Module["__ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEEC2Ev"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPPNS_17__assoc_sub_stateELi0ELb0EEC2IDnvEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPPNS_17__assoc_sub_stateELi0ELb0EEC2IDnvEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPPNS_17__assoc_sub_stateELi0ELb0EEC2IDnvEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb1EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb1EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb1EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEELi0ELb0EEC2IDnvEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEELi0ELb0EEC2IDnvEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEELi0ELb0EEC2IDnvEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb1EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb1EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb1EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var _pthread_key_create = Module["_pthread_key_create"] = createExportWrapper("pthread_key_create");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE4dataEv = Module["__ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE4dataEv"] = createExportWrapper("_ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE4dataEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE8capacityEv = Module["__ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE4sizeEv = Module["__ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE4sizeEv"] = createExportWrapper("_ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE4sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE31__annotate_contiguous_containerEPKvS7_S7_S7_ = Module["__ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE31__annotate_contiguous_containerEPKvS7_S7_S7_"] = createExportWrapper("_ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE31__annotate_contiguous_containerEPKvS7_S7_S7_");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5clearEv = Module["__ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5clearEv"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5clearEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE7__allocEv = Module["__ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE7__allocEv"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE8capacityEv = Module["__ZNKSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE10deallocateERS4_PS3_m = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE10deallocateERS4_PS3_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE10deallocateERS4_PS3_m");

/** @type {function(...*):?} */
var __ZNSt3__212__to_addressIPNS_17__assoc_sub_stateEEEPT_S4_ = Module["__ZNSt3__212__to_addressIPNS_17__assoc_sub_stateEEEPT_S4_"] = createExportWrapper("_ZNSt3__212__to_addressIPNS_17__assoc_sub_stateEEEPT_S4_");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE9__end_capEv = Module["__ZNKSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE9__end_capEv"] = createExportWrapper("_ZNKSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPPNS_17__assoc_sub_stateELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPPNS_17__assoc_sub_stateELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPPNS_17__assoc_sub_stateELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE17__destruct_at_endEPS2_ = Module["__ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE17__destruct_at_endEPS2_"] = createExportWrapper("_ZNSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE17__destruct_at_endEPS2_");

/** @type {function(...*):?} */
var __ZNSt3__218__hidden_allocatorIPNS_17__assoc_sub_stateEE10deallocateEPS2_m = Module["__ZNSt3__218__hidden_allocatorIPNS_17__assoc_sub_stateEE10deallocateEPS2_m"] = createExportWrapper("_ZNSt3__218__hidden_allocatorIPNS_17__assoc_sub_stateEE10deallocateEPS2_m");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE6secondEv = Module["__ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE7destroyIS3_EEvRS4_PT_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE7destroyIS3_EEvRS4_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE7destroyIS3_EEvRS4_PT_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE9__destroyIS3_EEvNS_17integral_constantIbLb0EEERS4_PT_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE9__destroyIS3_EEvNS_17integral_constantIbLb0EEERS4_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE9__destroyIS3_EEvNS_17integral_constantIbLb0EEERS4_PT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE4dataEv = Module["__ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE4dataEv"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE4dataEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE8capacityEv = Module["__ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE4sizeEv = Module["__ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE4sizeEv"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE4sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE31__annotate_contiguous_containerEPKvSB_SB_SB_ = Module["__ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE31__annotate_contiguous_containerEPKvSB_SB_SB_"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE31__annotate_contiguous_containerEPKvSB_SB_SB_");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5clearEv = Module["__ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5clearEv"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5clearEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE7__allocEv = Module["__ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE7__allocEv"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE8capacityEv = Module["__ZNKSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE10deallocateERS8_PS7_m = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE10deallocateERS8_PS7_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE10deallocateERS8_PS7_m");

/** @type {function(...*):?} */
var __ZNSt3__212__to_addressINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEPT_S8_ = Module["__ZNSt3__212__to_addressINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEPT_S8_"] = createExportWrapper("_ZNSt3__212__to_addressINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEPT_S8_");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE9__end_capEv = Module["__ZNKSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE9__end_capEv"] = createExportWrapper("_ZNKSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE17__destruct_at_endEPS6_ = Module["__ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE17__destruct_at_endEPS6_"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE17__destruct_at_endEPS6_");

/** @type {function(...*):?} */
var __ZNSt3__218__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEE10deallocateEPS6_m = Module["__ZNSt3__218__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEE10deallocateEPS6_m"] = createExportWrapper("_ZNSt3__218__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEE10deallocateEPS6_m");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE6secondEv = Module["__ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE7destroyIS7_EEvRS8_PT_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE7destroyIS7_EEvRS8_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE7destroyIS7_EEvRS8_PT_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE9__destroyIS7_EEvNS_17integral_constantIbLb0EEERS8_PT_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE9__destroyIS7_EEvNS_17integral_constantIbLb0EEERS8_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE9__destroyIS7_EEvNS_17integral_constantIbLb0EEERS8_PT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEC2ES7_ = Module["__ZNSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEC2ES7_"] = createExportWrapper("_ZNSt3__211__wrap_iterIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEC2ES7_");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEEC2ES3_ = Module["__ZNSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEEC2ES3_"] = createExportWrapper("_ZNSt3__211__wrap_iterIPPNS_17__assoc_sub_stateEEC2ES3_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5firstEv = Module["__ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE21_ConstructTransactionC2ERS9_m = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE21_ConstructTransactionC2ERS9_m"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE21_ConstructTransactionC2ERS9_m");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEOT_RNS_16remove_referenceIS7_E4typeE = Module["__ZNSt3__27forwardINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEOT_RNS_16remove_referenceIS7_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEOT_RNS_16remove_referenceIS7_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE9constructIS7_JS7_EEEvRS8_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE9constructIS7_JS7_EEEvRS8_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE9constructIS7_JS7_EEEvRS8_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE21_ConstructTransactionD2Ev = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE21_ConstructTransactionD2Ev"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE21_ConstructTransactionD2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE11__recommendEm = Module["__ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE11__recommendEm"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE11__recommendEm");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEEC2EmmS9_ = Module["__ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEEC2EmmS9_"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEEC2EmmS9_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS6_RS8_EE = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS6_RS8_EE"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS6_RS8_EE");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEED2Ev = Module["__ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEED2Ev"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE11__constructIS7_JS7_EEEvNS_17integral_constantIbLb0EEERS8_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE11__constructIS7_JS7_EEEvNS_17integral_constantIbLb0EEERS8_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE11__constructIS7_JS7_EEEvNS_17integral_constantIbLb0EEERS8_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE8max_sizeEv = Module["__ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEEC2IDnSA_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEEC2IDnSA_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEEC2IDnSA_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE7__allocEv = Module["__ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE7__allocEv"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE8allocateERS8_m = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE8allocateERS8_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE8allocateERS8_m");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE9__end_capEv = Module["__ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE9__end_capEv"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE46__construct_backward_with_exception_guaranteesIS7_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS8_PT_SE_EE5valuesr31is_trivially_move_constructibleISE_EE5valueEvE4typeERS8_SF_SF_RSF_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE46__construct_backward_with_exception_guaranteesIS7_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS8_PT_SE_EE5valuesr31is_trivially_move_constructibleISE_EE5valueEvE4typeERS8_SF_SF_RSF_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE46__construct_backward_with_exception_guaranteesIS7_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS8_PT_SE_EE5valuesr31is_trivially_move_constructibleISE_EE5valueEvE4typeERS8_SF_SF_RSF_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS9_EE5valueEvE4typeERS9_SC_ = Module["__ZNSt3__24swapIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS9_EE5valueEvE4typeERS9_SC_"] = createExportWrapper("_ZNSt3__24swapIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS9_EE5valueEvE4typeERS9_SC_");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE14__annotate_newEm = Module["__ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE14__annotate_newEm"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE14__annotate_newEm");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE26__invalidate_all_iteratorsEv = Module["__ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE26__invalidate_all_iteratorsEv"] = createExportWrapper("_ZNSt3__26vectorINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE26__invalidate_all_iteratorsEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE5clearEv = Module["__ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE5clearEv"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE5clearEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE8capacityEv = Module["__ZNKSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE7__allocEv = Module["__ZNKSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE7__allocEv"] = createExportWrapper("_ZNKSt3__213__vector_baseINS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE8max_sizeERKS8_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE8max_sizeERKS8_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE8max_sizeERKS8_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE10__max_sizeENS_17integral_constantIbLb1EEERKS8_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE10__max_sizeENS_17integral_constantIbLb1EEERKS8_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEE10__max_sizeENS_17integral_constantIbLb1EEERKS8_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE6secondEv = Module["__ZNKSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE6secondEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEENS_18__hidden_allocatorIS6_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__218__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEE8max_sizeEv = Module["__ZNKSt3__218__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__218__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb1EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemINS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRNS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEEEOT_RNS_16remove_referenceISA_E4typeE = Module["__ZNSt3__27forwardIRNS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEEEOT_RNS_16remove_referenceISA_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRNS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEEEOT_RNS_16remove_referenceISA_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb0EEC2IS9_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb0EEC2IS9_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb0EEC2IS9_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__218__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEE8allocateEm = Module["__ZNSt3__218__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEE8allocateEm"] = createExportWrapper("_ZNSt3__218__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEE8allocateEm");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE6secondEv = Module["__ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE5firstEv = Module["__ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorINS_4pairIPNS_18condition_variableEPNS_5mutexEEEEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEONS_16remove_referenceIT_E4typeEOSA_ = Module["__ZNSt3__24moveIRPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEONS_16remove_referenceIT_E4typeEOSA_"] = createExportWrapper("_ZNSt3__24moveIRPNS_4pairIPNS_18condition_variableEPNS_5mutexEEEEEONS_16remove_referenceIT_E4typeEOSA_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE17__destruct_at_endEPS6_ = Module["__ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE17__destruct_at_endEPS6_"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE17__destruct_at_endEPS6_");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE9__end_capEv = Module["__ZNKSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE9__end_capEv"] = createExportWrapper("_ZNKSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE17__destruct_at_endEPS6_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE17__destruct_at_endEPS6_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE17__destruct_at_endEPS6_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_4pairIPNS_18condition_variableEPNS_5mutexEEERNS_18__hidden_allocatorIS6_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5firstEv = Module["__ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE21_ConstructTransactionC2ERS5_m = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE21_ConstructTransactionC2ERS5_m"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE21_ConstructTransactionC2ERS5_m");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRKPNS_17__assoc_sub_stateEEEOT_RNS_16remove_referenceIS5_E4typeE = Module["__ZNSt3__27forwardIRKPNS_17__assoc_sub_stateEEEOT_RNS_16remove_referenceIS5_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRKPNS_17__assoc_sub_stateEEEOT_RNS_16remove_referenceIS5_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE9constructIS3_JRKS3_EEEvRS4_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE9constructIS3_JRKS3_EEEvRS4_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE9constructIS3_JRKS3_EEEvRS4_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE21_ConstructTransactionD2Ev = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE21_ConstructTransactionD2Ev"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE21_ConstructTransactionD2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE11__recommendEm = Module["__ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE11__recommendEm"] = createExportWrapper("_ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE11__recommendEm");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEEC2EmmS5_ = Module["__ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEEC2EmmS5_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEEC2EmmS5_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS2_RS4_EE = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS2_RS4_EE"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS2_RS4_EE");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEED2Ev = Module["__ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEED2Ev"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPPNS_17__assoc_sub_stateELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPPNS_17__assoc_sub_stateELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPPNS_17__assoc_sub_stateELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE11__constructIS3_JRKS3_EEEvNS_17integral_constantIbLb0EEERS4_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE11__constructIS3_JRKS3_EEEvNS_17integral_constantIbLb0EEERS4_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE11__constructIS3_JRKS3_EEEvNS_17integral_constantIbLb0EEERS4_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE8max_sizeEv = Module["__ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEEC2IDnS6_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEEC2IDnS6_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEEC2IDnS6_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE7__allocEv = Module["__ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE7__allocEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE8allocateERS4_m = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE8allocateERS4_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE8allocateERS4_m");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE9__end_capEv = Module["__ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE9__end_capEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE46__construct_backward_with_exception_guaranteesIS3_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS4_PT_SA_EE5valuesr31is_trivially_move_constructibleISA_EE5valueEvE4typeERS4_SB_SB_RSB_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE46__construct_backward_with_exception_guaranteesIS3_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS4_PT_SA_EE5valuesr31is_trivially_move_constructibleISA_EE5valueEvE4typeERS4_SB_SB_RSB_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE46__construct_backward_with_exception_guaranteesIS3_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb0EE5valueEEntsr15__has_constructIS4_PT_SA_EE5valuesr31is_trivially_move_constructibleISA_EE5valueEvE4typeERS4_SB_SB_RSB_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPPNS_17__assoc_sub_stateEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_ = Module["__ZNSt3__24swapIPPNS_17__assoc_sub_stateEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_"] = createExportWrapper("_ZNSt3__24swapIPPNS_17__assoc_sub_stateEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS5_EE5valueEvE4typeERS5_S8_");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE14__annotate_newEm = Module["__ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE14__annotate_newEm"] = createExportWrapper("_ZNKSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE14__annotate_newEm");

/** @type {function(...*):?} */
var __ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE26__invalidate_all_iteratorsEv = Module["__ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE26__invalidate_all_iteratorsEv"] = createExportWrapper("_ZNSt3__26vectorIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE26__invalidate_all_iteratorsEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE5clearEv = Module["__ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE5clearEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE5clearEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE8capacityEv = Module["__ZNKSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE7__allocEv = Module["__ZNKSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE7__allocEv"] = createExportWrapper("_ZNKSt3__213__vector_baseIPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE8max_sizeERKS4_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE8max_sizeERKS4_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE8max_sizeERKS4_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE10__max_sizeENS_17integral_constantIbLb1EEERKS4_ = Module["__ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE10__max_sizeENS_17integral_constantIbLb1EEERKS4_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEE10__max_sizeENS_17integral_constantIbLb1EEERKS4_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE6secondEv = Module["__ZNKSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE6secondEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPPNS_17__assoc_sub_stateENS_18__hidden_allocatorIS2_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__218__hidden_allocatorIPNS_17__assoc_sub_stateEE8max_sizeEv = Module["__ZNKSt3__218__hidden_allocatorIPNS_17__assoc_sub_stateEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__218__hidden_allocatorIPNS_17__assoc_sub_stateEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb1EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemINS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRNS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEEEOT_RNS_16remove_referenceIS6_E4typeE = Module["__ZNSt3__27forwardIRNS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEEEOT_RNS_16remove_referenceIS6_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRNS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEEEEOT_RNS_16remove_referenceIS6_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb0EEC2IS5_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb0EEC2IS5_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb0EEC2IS5_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__218__hidden_allocatorIPNS_17__assoc_sub_stateEE8allocateEm = Module["__ZNSt3__218__hidden_allocatorIPNS_17__assoc_sub_stateEE8allocateEm"] = createExportWrapper("_ZNSt3__218__hidden_allocatorIPNS_17__assoc_sub_stateEE8allocateEm");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE6secondEv = Module["__ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE5firstEv = Module["__ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_18__hidden_allocatorIPNS_17__assoc_sub_stateEEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPPNS_17__assoc_sub_stateEEEONS_16remove_referenceIT_E4typeEOS6_ = Module["__ZNSt3__24moveIRPPNS_17__assoc_sub_stateEEEONS_16remove_referenceIT_E4typeEOS6_"] = createExportWrapper("_ZNSt3__24moveIRPPNS_17__assoc_sub_stateEEEONS_16remove_referenceIT_E4typeEOS6_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE17__destruct_at_endEPS2_ = Module["__ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE17__destruct_at_endEPS2_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE17__destruct_at_endEPS2_");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE9__end_capEv = Module["__ZNKSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE9__end_capEv"] = createExportWrapper("_ZNKSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE17__destruct_at_endEPS2_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE17__destruct_at_endEPS2_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE17__destruct_at_endEPS2_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPPNS_17__assoc_sub_stateERNS_18__hidden_allocatorIS2_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__26threadD1Ev = Module["__ZNSt3__26threadD1Ev"] = createExportWrapper("_ZNSt3__26threadD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__219__thread_struct_impD1Ev = Module["__ZNSt3__219__thread_struct_impD1Ev"] = createExportWrapper("_ZNSt3__219__thread_struct_impD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__215__thread_structD1Ev = Module["__ZNSt3__215__thread_structD1Ev"] = createExportWrapper("_ZNSt3__215__thread_structD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__28valarrayImE6resizeEmm = Module["__ZNSt3__28valarrayImE6resizeEmm"] = createExportWrapper("_ZNSt3__28valarrayImE6resizeEmm");

/** @type {function(...*):?} */
var __ZNKSt3__28valarrayImE4sizeEv = Module["__ZNKSt3__28valarrayImE4sizeEv"] = createExportWrapper("_ZNKSt3__28valarrayImE4sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__28valarrayImE7__clearEm = Module["__ZNSt3__28valarrayImE7__clearEm"] = createExportWrapper("_ZNSt3__28valarrayImE7__clearEm");

/** @type {function(...*):?} */
var __ZNSt3__26gslice6__initEm = Module["__ZNSt3__26gslice6__initEm"] = createExportWrapper("_ZNSt3__26gslice6__initEm");

/** @type {function(...*):?} */
var __ZNSt3__28valarrayImEC2Em = Module["__ZNSt3__28valarrayImEC2Em"] = createExportWrapper("_ZNSt3__28valarrayImEC2Em");

/** @type {function(...*):?} */
var __ZNSt3__28valarrayImEixEm = Module["__ZNSt3__28valarrayImEixEm"] = createExportWrapper("_ZNSt3__28valarrayImEixEm");

/** @type {function(...*):?} */
var __ZNSt3__28valarrayImED2Ev = Module["__ZNSt3__28valarrayImED2Ev"] = createExportWrapper("_ZNSt3__28valarrayImED2Ev");

/** @type {function(...*):?} */
var __ZNKSt18bad_variant_access4whatEv = Module["__ZNKSt18bad_variant_access4whatEv"] = createExportWrapper("_ZNKSt18bad_variant_access4whatEv");

/** @type {function(...*):?} */
var __ZNSt18bad_variant_accessD0Ev = Module["__ZNSt18bad_variant_accessD0Ev"] = createExportWrapper("_ZNSt18bad_variant_accessD0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__220__vector_base_commonILb1EE20__throw_out_of_rangeEv = Module["__ZNKSt3__220__vector_base_commonILb1EE20__throw_out_of_rangeEv"] = createExportWrapper("_ZNKSt3__220__vector_base_commonILb1EE20__throw_out_of_rangeEv");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v13pmr19new_delete_resourceEv = Module["__ZNSt12experimental15fundamentals_v13pmr19new_delete_resourceEv"] = createExportWrapper("_ZNSt12experimental15fundamentals_v13pmr19new_delete_resourceEv");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v13pmr20null_memory_resourceEv = Module["__ZNSt12experimental15fundamentals_v13pmr20null_memory_resourceEv"] = createExportWrapper("_ZNSt12experimental15fundamentals_v13pmr20null_memory_resourceEv");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v13pmr20get_default_resourceEv = Module["__ZNSt12experimental15fundamentals_v13pmr20get_default_resourceEv"] = createExportWrapper("_ZNSt12experimental15fundamentals_v13pmr20get_default_resourceEv");

/** @type {function(...*):?} */
var __ZNSt3__224atomic_exchange_explicitIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PNS_6atomicIS6_EES6_NS_12memory_orderE = Module["__ZNSt3__224atomic_exchange_explicitIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PNS_6atomicIS6_EES6_NS_12memory_orderE"] = createExportWrapper("_ZNSt3__224atomic_exchange_explicitIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PNS_6atomicIS6_EES6_NS_12memory_orderE");

/** @type {function(...*):?} */
var __ZNSt3__220atomic_load_explicitIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PKNS_6atomicIS6_EENS_12memory_orderE = Module["__ZNSt3__220atomic_load_explicitIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PKNS_6atomicIS6_EENS_12memory_orderE"] = createExportWrapper("_ZNSt3__220atomic_load_explicitIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PKNS_6atomicIS6_EENS_12memory_orderE");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v13pmr20set_default_resourceEPNS1_15memory_resourceE = Module["__ZNSt12experimental15fundamentals_v13pmr20set_default_resourceEPNS1_15memory_resourceE"] = createExportWrapper("_ZNSt12experimental15fundamentals_v13pmr20set_default_resourceEPNS1_15memory_resourceE");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_impD0Ev = Module["__ZNSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_impD0Ev"] = createExportWrapper("_ZNSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_impD0Ev");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v13pmr15memory_resourceD2Ev = Module["__ZNSt12experimental15fundamentals_v13pmr15memory_resourceD2Ev"] = createExportWrapper("_ZNSt12experimental15fundamentals_v13pmr15memory_resourceD2Ev");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_imp11do_allocateEmm = Module["__ZNSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_imp11do_allocateEmm"] = createExportWrapper("_ZNSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_imp11do_allocateEmm");

/** @type {function(...*):?} */
var __ZNSt3__224__is_overaligned_for_newEm = Module["__ZNSt3__224__is_overaligned_for_newEm"] = createExportWrapper("_ZNSt3__224__is_overaligned_for_newEm");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_imp13do_deallocateEPvmm = Module["__ZNSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_imp13do_deallocateEPvmm"] = createExportWrapper("_ZNSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_imp13do_deallocateEPvmm");

/** @type {function(...*):?} */
var __ZNKSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_imp11do_is_equalERKNS1_15memory_resourceE = Module["__ZNKSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_imp11do_is_equalERKNS1_15memory_resourceE"] = createExportWrapper("_ZNKSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_imp11do_is_equalERKNS1_15memory_resourceE");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v13pmr26__null_memory_resource_impD0Ev = Module["__ZNSt12experimental15fundamentals_v13pmr26__null_memory_resource_impD0Ev"] = createExportWrapper("_ZNSt12experimental15fundamentals_v13pmr26__null_memory_resource_impD0Ev");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v13pmr26__null_memory_resource_imp11do_allocateEmm = Module["__ZNSt12experimental15fundamentals_v13pmr26__null_memory_resource_imp11do_allocateEmm"] = createExportWrapper("_ZNSt12experimental15fundamentals_v13pmr26__null_memory_resource_imp11do_allocateEmm");

/** @type {function(...*):?} */
var __ZNSt12experimental15fundamentals_v13pmr26__null_memory_resource_imp13do_deallocateEPvmm = Module["__ZNSt12experimental15fundamentals_v13pmr26__null_memory_resource_imp13do_deallocateEPvmm"] = createExportWrapper("_ZNSt12experimental15fundamentals_v13pmr26__null_memory_resource_imp13do_deallocateEPvmm");

/** @type {function(...*):?} */
var __ZNKSt12experimental15fundamentals_v13pmr26__null_memory_resource_imp11do_is_equalERKNS1_15memory_resourceE = Module["__ZNKSt12experimental15fundamentals_v13pmr26__null_memory_resource_imp11do_is_equalERKNS1_15memory_resourceE"] = createExportWrapper("_ZNKSt12experimental15fundamentals_v13pmr26__null_memory_resource_imp11do_is_equalERKNS1_15memory_resourceE");

/** @type {function(...*):?} */
var __ZNSt3__213__atomic_baseIPNSt12experimental15fundamentals_v13pmr15memory_resourceELb0EE8exchangeES5_NS_12memory_orderE = Module["__ZNSt3__213__atomic_baseIPNSt12experimental15fundamentals_v13pmr15memory_resourceELb0EE8exchangeES5_NS_12memory_orderE"] = createExportWrapper("_ZNSt3__213__atomic_baseIPNSt12experimental15fundamentals_v13pmr15memory_resourceELb0EE8exchangeES5_NS_12memory_orderE");

/** @type {function(...*):?} */
var __ZNKSt3__213__atomic_baseIPNSt12experimental15fundamentals_v13pmr15memory_resourceELb0EE4loadENS_12memory_orderE = Module["__ZNKSt3__213__atomic_baseIPNSt12experimental15fundamentals_v13pmr15memory_resourceELb0EE4loadENS_12memory_orderE"] = createExportWrapper("_ZNKSt3__213__atomic_baseIPNSt12experimental15fundamentals_v13pmr15memory_resourceELb0EE4loadENS_12memory_orderE");

/** @type {function(...*):?} */
var __ZNSt3__221__cxx_atomic_exchangeIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PNS_22__cxx_atomic_base_implIS6_EES6_NS_12memory_orderE = Module["__ZNSt3__221__cxx_atomic_exchangeIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PNS_22__cxx_atomic_base_implIS6_EES6_NS_12memory_orderE"] = createExportWrapper("_ZNSt3__221__cxx_atomic_exchangeIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PNS_22__cxx_atomic_base_implIS6_EES6_NS_12memory_orderE");

/** @type {function(...*):?} */
var __ZNSt3__217__cxx_atomic_loadIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PKNS_22__cxx_atomic_base_implIS6_EENS_12memory_orderE = Module["__ZNSt3__217__cxx_atomic_loadIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PKNS_22__cxx_atomic_base_implIS6_EENS_12memory_orderE"] = createExportWrapper("_ZNSt3__217__cxx_atomic_loadIPNSt12experimental15fundamentals_v13pmr15memory_resourceEEET_PKNS_22__cxx_atomic_base_implIS6_EENS_12memory_orderE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18directory_iteratorC2ERKNS1_4pathEPNS_10error_codeENS1_17directory_optionsE = Module["__ZNSt3__24__fs10filesystem18directory_iteratorC2ERKNS1_4pathEPNS_10error_codeENS1_17directory_optionsE"] = createExportWrapper("_ZNSt3__24__fs10filesystem18directory_iteratorC2ERKNS1_4pathEPNS_10error_codeENS1_17directory_optionsE");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEC2Ev = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEC2Ev"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210error_codeC2Ev = Module["__ZNSt3__210error_codeC2Ev"] = createExportWrapper("_ZNSt3__210error_codeC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__211make_sharedINS_4__fs10filesystem12__dir_streamEJRKNS2_4pathERNS2_17directory_optionsERNS_10error_codeEEEENS_9enable_ifIXntsr8is_arrayIT_EE5valueENS_10shared_ptrISC_EEE4typeEDpOT0_ = Module["__ZNSt3__211make_sharedINS_4__fs10filesystem12__dir_streamEJRKNS2_4pathERNS2_17directory_optionsERNS_10error_codeEEEENS_9enable_ifIXntsr8is_arrayIT_EE5valueENS_10shared_ptrISC_EEE4typeEDpOT0_"] = createExportWrapper("_ZNSt3__211make_sharedINS_4__fs10filesystem12__dir_streamEJRKNS2_4pathERNS2_17directory_optionsERNS_10error_codeEEEENS_9enable_ifIXntsr8is_arrayIT_EE5valueENS_10shared_ptrISC_EEE4typeEDpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEaSEOS4_ = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEaSEOS4_"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEaSEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEED2Ev = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEED2Ev"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEED2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEptEv = Module["__ZNKSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEptEv"] = createExportWrapper("_ZNKSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEptEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem12__dir_stream4goodEv = Module["__ZNKSt3__24__fs10filesystem12__dir_stream4goodEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem12__dir_stream4goodEv");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE5resetEv = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE5resetEv"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE5resetEv");

/** @type {function(...*):?} */
var __ZNSt3__210error_code5clearEv = Module["__ZNSt3__210error_code5clearEv"] = createExportWrapper("_ZNSt3__210error_code5clearEv");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEEC2Ev = Module["__ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEEC2Ev"] = createExportWrapper("_ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEE8allocateEmPKv = Module["__ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEE8allocateEmPKv"] = createExportWrapper("_ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEE8allocateEmPKv");

/** @type {function(...*):?} */
var __ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS1_IS5_EEEEEEEC2ERS8_m = Module["__ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS1_IS5_EEEEEEEC2ERS8_m"] = createExportWrapper("_ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS1_IS5_EEEEEEEC2ERS8_m");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEEC2ILb1EvEEPS7_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeISA_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEEC2ILb1EvEEPS7_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeISA_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEEC2ILb1EvEEPS7_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeISA_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE3getEv = Module["__ZNKSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE3getEv"] = createExportWrapper("_ZNKSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEEC2INS_20__shared_ptr_emplaceIS3_S4_EEEERKNS0_IT_EE = Module["__ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEEC2INS_20__shared_ptr_emplaceIS3_S4_EEEERKNS0_IT_EE"] = createExportWrapper("_ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEEC2INS_20__shared_ptr_emplaceIS3_S4_EEEERKNS0_IT_EE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRKNS_4__fs10filesystem4pathEEEOT_RNS_16remove_referenceIS6_E4typeE = Module["__ZNSt3__27forwardIRKNS_4__fs10filesystem4pathEEEOT_RNS_16remove_referenceIS6_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRKNS_4__fs10filesystem4pathEEEOT_RNS_16remove_referenceIS6_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRNS_4__fs10filesystem17directory_optionsEEEOT_RNS_16remove_referenceIS5_E4typeE = Module["__ZNSt3__27forwardIRNS_4__fs10filesystem17directory_optionsEEEOT_RNS_16remove_referenceIS5_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRNS_4__fs10filesystem17directory_optionsEEEOT_RNS_16remove_referenceIS5_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRNS_10error_codeEEEOT_RNS_16remove_referenceIS3_E4typeE = Module["__ZNSt3__27forwardIRNS_10error_codeEEEOT_RNS_16remove_referenceIS3_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRNS_10error_codeEEEOT_RNS_16remove_referenceIS3_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEC2IJRKNS2_4pathERNS2_17directory_optionsERNS_10error_codeEEEES5_DpOT_ = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEC2IJRKNS2_4pathERNS2_17directory_optionsERNS_10error_codeEEEES5_DpOT_"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEC2IJRKNS2_4pathERNS2_17directory_optionsERNS_10error_codeEEEES5_DpOT_");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE3getEv = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE3getEv"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE7releaseEv = Module["__ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE7releaseEv"] = createExportWrapper("_ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE27__create_with_control_blockIS3_NS_20__shared_ptr_emplaceIS3_NS_9allocatorIS3_EEEEEES4_PT_PT0_ = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE27__create_with_control_blockIS3_NS_20__shared_ptr_emplaceIS3_NS_9allocatorIS3_EEEEEES4_PT_PT0_"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE27__create_with_control_blockIS3_NS_20__shared_ptr_emplaceIS3_NS_9allocatorIS3_EEEEEES4_PT_PT0_");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEED2Ev = Module["__ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_10shared_ptrINS_4__fs10filesystem12__dir_streamEEEEEONS_16remove_referenceIT_E4typeEOS8_ = Module["__ZNSt3__24moveIRNS_10shared_ptrINS_4__fs10filesystem12__dir_streamEEEEEONS_16remove_referenceIT_E4typeEOS8_"] = createExportWrapper("_ZNSt3__24moveIRNS_10shared_ptrINS_4__fs10filesystem12__dir_streamEEEEEONS_16remove_referenceIT_E4typeEOS8_");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEC2EOS4_ = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEC2EOS4_"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEEC2EOS4_");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE4swapERS4_ = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE4swapERS4_"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE4swapERS4_");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_weak_count16__release_sharedEv = Module["__ZNSt3__219__shared_weak_count16__release_sharedEv"] = createExportWrapper("_ZNSt3__219__shared_weak_count16__release_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__throw_filesystem_errorIJRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_10error_codeEEEEvDpOT_ = Module["__ZNSt3__24__fs10filesystem24__throw_filesystem_errorIJRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_10error_codeEEEEvDpOT_"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__throw_filesystem_errorIJRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS_10error_codeEEEEvDpOT_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__throw_filesystem_errorIJRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS1_4pathERKNS_10error_codeEEEEvDpOT_ = Module["__ZNSt3__24__fs10filesystem24__throw_filesystem_errorIJRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS1_4pathERKNS_10error_codeEEEEvDpOT_"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__throw_filesystem_errorIJRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS1_4pathERKNS_10error_codeEEEEvDpOT_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__throw_filesystem_errorIJRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS1_4pathESC_RKNS_10error_codeEEEEvDpOT_ = Module["__ZNSt3__24__fs10filesystem24__throw_filesystem_errorIJRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS1_4pathESC_RKNS_10error_codeEEEEvDpOT_"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__throw_filesystem_errorIJRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKNS1_4pathESC_RKNS_10error_codeEEEEvDpOT_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18directory_iterator11__incrementEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem18directory_iterator11__incrementEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem18directory_iterator11__incrementEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem12__dir_stream7advanceERNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem12__dir_stream7advanceERNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem12__dir_stream7advanceERNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_4__fs10filesystem4pathEEEONS_16remove_referenceIT_E4typeEOS6_ = Module["__ZNSt3__24moveIRNS_4__fs10filesystem4pathEEEONS_16remove_referenceIT_E4typeEOS6_"] = createExportWrapper("_ZNSt3__24moveIRNS_4__fs10filesystem4pathEEEONS_16remove_referenceIT_E4typeEOS6_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathC2EOS2_ = Module["__ZNSt3__24__fs10filesystem4pathC2EOS2_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathC2EOS2_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathD2Ev = Module["__ZNSt3__24__fs10filesystem4pathD2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217basic_string_viewIcNS_11char_traitsIcEEEC2EPKc = Module["__ZNSt3__217basic_string_viewIcNS_11char_traitsIcEEEC2EPKc"] = createExportWrapper("_ZNSt3__217basic_string_viewIcNS_11char_traitsIcEEEC2EPKc");

/** @type {function(...*):?} */
var __ZNSt3__2eqIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EENS_11common_typeIJS6_EE4typeE = Module["__ZNSt3__2eqIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EENS_11common_typeIJS6_EE4typeE"] = createExportWrapper("_ZNSt3__2eqIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EENS_11common_typeIJS6_EE4typeE");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE5emptyEv = Module["__ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE5emptyEv"] = createExportWrapper("_ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE5emptyEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem12__dir_stream5closeEv = Module["__ZNSt3__24__fs10filesystem12__dir_stream5closeEv"] = createExportWrapper("_ZNSt3__24__fs10filesystem12__dir_stream5closeEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathC2INS_17basic_string_viewIcNS_11char_traitsIcEEEEvEERKT_NS2_6formatE = Module["__ZNSt3__24__fs10filesystem4pathC2INS_17basic_string_viewIcNS_11char_traitsIcEEEEvEERKT_NS2_6formatE"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathC2INS_17basic_string_viewIcNS_11char_traitsIcEEEEvEERKT_NS2_6formatE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemdvERKNS1_4pathES4_ = Module["__ZNSt3__24__fs10filesystemdvERKNS1_4pathES4_"] = createExportWrapper("_ZNSt3__24__fs10filesystemdvERKNS1_4pathES4_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem15directory_entry20__create_iter_resultENS1_9file_typeE = Module["__ZNSt3__24__fs10filesystem15directory_entry20__create_iter_resultENS1_9file_typeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem15directory_entry20__create_iter_resultENS1_9file_typeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem15directory_entry19__assign_iter_entryEONS1_4pathENS2_13__cached_dataE = Module["__ZNSt3__24__fs10filesystem15directory_entry19__assign_iter_entryEONS1_4pathENS2_13__cached_dataE"] = createExportWrapper("_ZNSt3__24__fs10filesystem15directory_entry19__assign_iter_entryEONS1_4pathENS2_13__cached_dataE");

/** @type {function(...*):?} */
var __ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEOS9_SA_ = Module["__ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEOS9_SA_"] = createExportWrapper("_ZNSt3__2plIcNS_11char_traitsIcEENS_9allocatorIcEEEENS_12basic_stringIT_T0_T1_EEOS9_SA_");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem18directory_iterator13__dereferenceEv = Module["__ZNKSt3__24__fs10filesystem18directory_iterator13__dereferenceEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem18directory_iterator13__dereferenceEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem28recursive_directory_iteratorC2ERKNS1_4pathENS1_17directory_optionsEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem28recursive_directory_iteratorC2ERKNS1_4pathENS1_17directory_optionsEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem28recursive_directory_iteratorC2ERKNS1_4pathENS1_17directory_optionsEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2EDn = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2EDn"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2EDn");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem12__dir_streamC2ERKNS1_4pathENS1_17directory_optionsERNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem12__dir_streamC2ERKNS1_4pathENS1_17directory_optionsERNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem12__dir_streamC2ERKNS1_4pathENS1_17directory_optionsERNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__211make_sharedINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEJEEENS_9enable_ifIXntsr8is_arrayIT_EE5valueENS_10shared_ptrIS6_EEE4typeEDpOT0_ = Module["__ZNSt3__211make_sharedINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEJEEENS_9enable_ifIXntsr8is_arrayIT_EE5valueENS_10shared_ptrIS6_EEE4typeEDpOT0_"] = createExportWrapper("_ZNSt3__211make_sharedINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEJEEENS_9enable_ifIXntsr8is_arrayIT_EE5valueENS_10shared_ptrIS6_EEE4typeEDpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEaSEOS5_ = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEaSEOS5_"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEaSEOS5_");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEED2Ev = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEED2Ev"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEED2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEptEv = Module["__ZNKSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEptEv"] = createExportWrapper("_ZNKSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEptEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_4__fs10filesystem12__dir_streamEEEONS_16remove_referenceIT_E4typeEOS6_ = Module["__ZNSt3__24moveIRNS_4__fs10filesystem12__dir_streamEEEONS_16remove_referenceIT_E4typeEOS6_"] = createExportWrapper("_ZNSt3__24moveIRNS_4__fs10filesystem12__dir_streamEEEONS_16remove_referenceIT_E4typeEOS6_");

/** @type {function(...*):?} */
var __ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE4pushEOS3_ = Module["__ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE4pushEOS3_"] = createExportWrapper("_ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE4pushEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem12__dir_streamD2Ev = Module["__ZNSt3__24__fs10filesystem12__dir_streamD2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem12__dir_streamD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathC2ERKS2_ = Module["__ZNSt3__24__fs10filesystem4pathC2ERKS2_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathC2ERKS2_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem15directory_entryC2Ev = Module["__ZNSt3__24__fs10filesystem15directory_entryC2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem15directory_entryC2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path5c_strEv = Module["__ZNKSt3__24__fs10filesystem4path5c_strEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path5c_strEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemanENS1_17directory_optionsES2_ = Module["__ZNSt3__24__fs10filesystemanENS1_17directory_optionsES2_"] = createExportWrapper("_ZNSt3__24__fs10filesystemanENS1_17directory_optionsES2_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEEC2Ev = Module["__ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEEC2Ev"] = createExportWrapper("_ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEE8allocateEmPKv = Module["__ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEE8allocateEmPKv"] = createExportWrapper("_ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEE8allocateEmPKv");

/** @type {function(...*):?} */
var __ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS1_IS6_EEEEEEEC2ERS9_m = Module["__ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS1_IS6_EEEEEEEC2ERS9_m"] = createExportWrapper("_ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS1_IS6_EEEEEEEC2ERS9_m");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEEC2ILb1EvEEPS8_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeISB_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEEC2ILb1EvEEPS8_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeISB_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEEC2ILb1EvEEPS8_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeISB_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE3getEv = Module["__ZNKSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE3getEv"] = createExportWrapper("_ZNKSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2INS_20__shared_ptr_emplaceIS4_S5_EEEERKNS0_IT_EE = Module["__ZNSt3__29allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2INS_20__shared_ptr_emplaceIS4_S5_EEEERKNS0_IT_EE"] = createExportWrapper("_ZNSt3__29allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2INS_20__shared_ptr_emplaceIS4_S5_EEEERKNS0_IT_EE");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEEC2ES6_ = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEEC2ES6_"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEEC2ES6_");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEE3getEv = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEE3getEv"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE7releaseEv = Module["__ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE7releaseEv"] = createExportWrapper("_ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE27__create_with_control_blockIS4_NS_20__shared_ptr_emplaceIS4_NS_9allocatorIS4_EEEEEES5_PT_PT0_ = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE27__create_with_control_blockIS4_NS_20__shared_ptr_emplaceIS4_NS_9allocatorIS4_EEEEEES5_PT_PT0_"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE27__create_with_control_blockIS4_NS_20__shared_ptr_emplaceIS4_NS_9allocatorIS4_EEEEEES5_PT_PT0_");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEED2Ev = Module["__ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_10shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEEEONS_16remove_referenceIT_E4typeEOS9_ = Module["__ZNSt3__24moveIRNS_10shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEEEONS_16remove_referenceIT_E4typeEOS9_"] = createExportWrapper("_ZNSt3__24moveIRNS_10shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEEEONS_16remove_referenceIT_E4typeEOS9_");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2EOS5_ = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2EOS5_"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2EOS5_");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE4swapERS5_ = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE4swapERS5_"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE4swapERS5_");

/** @type {function(...*):?} */
var __ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE9push_backEOS3_ = Module["__ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE9push_backEOS3_"] = createExportWrapper("_ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE9push_backEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem15directory_entryD2Ev = Module["__ZNSt3__24__fs10filesystem15directory_entryD2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem15directory_entryD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem28recursive_directory_iterator5__popEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem28recursive_directory_iterator5__popEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem28recursive_directory_iterator5__popEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE3popEv = Module["__ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE3popEv"] = createExportWrapper("_ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE3popEv");

/** @type {function(...*):?} */
var __ZNKSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE4sizeEv = Module["__ZNKSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE4sizeEv"] = createExportWrapper("_ZNKSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE4sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE5resetEv = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE5resetEv"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE5resetEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem28recursive_directory_iterator9__advanceEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem28recursive_directory_iterator9__advanceEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem28recursive_directory_iterator9__advanceEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE8pop_backEv = Module["__ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE8pop_backEv"] = createExportWrapper("_ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE8pop_backEv");

/** @type {function(...*):?} */
var __ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4sizeEv = Module["__ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4sizeEv"] = createExportWrapper("_ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2Ev = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2Ev"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18directory_iteratorC2Ev = Module["__ZNSt3__24__fs10filesystem18directory_iteratorC2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem18directory_iteratorC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE3topEv = Module["__ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE3topEv"] = createExportWrapper("_ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEE3topEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18directory_iteratorD2Ev = Module["__ZNSt3__24__fs10filesystem18directory_iteratorD2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem18directory_iteratorD2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem28recursive_directory_iterator7optionsEv = Module["__ZNKSt3__24__fs10filesystem28recursive_directory_iterator7optionsEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem28recursive_directory_iterator7optionsEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem28recursive_directory_iterator5depthEv = Module["__ZNKSt3__24__fs10filesystem28recursive_directory_iterator5depthEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem28recursive_directory_iterator5depthEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem28recursive_directory_iterator13__dereferenceEv = Module["__ZNKSt3__24__fs10filesystem28recursive_directory_iterator13__dereferenceEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem28recursive_directory_iterator13__dereferenceEv");

/** @type {function(...*):?} */
var __ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4backEv = Module["__ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4backEv"] = createExportWrapper("_ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4backEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem28recursive_directory_iterator11__incrementEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem28recursive_directory_iterator11__incrementEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem28recursive_directory_iterator11__incrementEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem28recursive_directory_iterator17recursion_pendingEv = Module["__ZNKSt3__24__fs10filesystem28recursive_directory_iterator17recursion_pendingEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem28recursive_directory_iterator17recursion_pendingEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem28recursive_directory_iterator15__try_recursionEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem28recursive_directory_iterator15__try_recursionEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem28recursive_directory_iterator15__try_recursionEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem15directory_entry12__get_sym_ftEPNS_10error_codeE = Module["__ZNKSt3__24__fs10filesystem15directory_entry12__get_sym_ftEPNS_10error_codeE"] = createExportWrapper("_ZNKSt3__24__fs10filesystem15directory_entry12__get_sym_ftEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem11file_statusC2ENS1_9file_typeENS1_5permsE = Module["__ZNSt3__24__fs10filesystem11file_statusC2ENS1_9file_typeENS1_5permsE"] = createExportWrapper("_ZNSt3__24__fs10filesystem11file_statusC2ENS1_9file_typeENS1_5permsE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem12status_knownENS1_11file_statusE = Module["__ZNSt3__24__fs10filesystem12status_knownENS1_11file_statusE"] = createExportWrapper("_ZNSt3__24__fs10filesystem12status_knownENS1_11file_statusE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem11file_statusD2Ev = Module["__ZNSt3__24__fs10filesystem11file_statusD2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem11file_statusD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem10is_symlinkENS1_11file_statusE = Module["__ZNSt3__24__fs10filesystem10is_symlinkENS1_11file_statusE"] = createExportWrapper("_ZNSt3__24__fs10filesystem10is_symlinkENS1_11file_statusE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem12is_directoryENS1_11file_statusE = Module["__ZNSt3__24__fs10filesystem12is_directoryENS1_11file_statusE"] = createExportWrapper("_ZNSt3__24__fs10filesystem12is_directoryENS1_11file_statusE");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem15directory_entry8__get_ftEPNS_10error_codeE = Module["__ZNKSt3__24__fs10filesystem15directory_entry8__get_ftEPNS_10error_codeE"] = createExportWrapper("_ZNKSt3__24__fs10filesystem15directory_entry8__get_ftEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem15directory_entry4pathEv = Module["__ZNKSt3__24__fs10filesystem15directory_entry4pathEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem15directory_entry4pathEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem16__symlink_statusERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem16__symlink_statusERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem16__symlink_statusERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem11file_status4typeEv = Module["__ZNKSt3__24__fs10filesystem11file_status4typeEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem11file_status4typeEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem6existsENS1_11file_statusE = Module["__ZNSt3__24__fs10filesystem6existsENS1_11file_statusE"] = createExportWrapper("_ZNSt3__24__fs10filesystem6existsENS1_11file_statusE");

/** @type {function(...*):?} */
var __ZNSt3__215make_error_codeENS_4errcE = Module["__ZNSt3__215make_error_codeENS_4errcE"] = createExportWrapper("_ZNSt3__215make_error_codeENS_4errcE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8__statusERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem8__statusERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem8__statusERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem9file_typeEEC2ILb1ELb0EEEv = Module["__ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem9file_typeEEC2ILb1ELb0EEEv"] = createExportWrapper("_ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem9file_typeEEC2ILb1ELb0EEEv");

/** @type {function(...*):?} */
var __ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem9file_typeEEC2IRA256_cS7_Lb0EEEOT_OT0_ = Module["__ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem9file_typeEEC2IRA256_cS7_Lb0EEEOT_OT0_"] = createExportWrapper("_ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem9file_typeEEC2IRA256_cS7_Lb0EEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__228__char_traits_length_checkedINS_11char_traitsIcEEEEmPKNT_9char_typeE = Module["__ZNSt3__228__char_traits_length_checkedINS_11char_traitsIcEEEEmPKNT_9char_typeE"] = createExportWrapper("_ZNSt3__228__char_traits_length_checkedINS_11char_traitsIcEEEEmPKNT_9char_typeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathaSEOS2_ = Module["__ZNSt3__24__fs10filesystem4pathaSEOS2_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathaSEOS2_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathdVERKS2_ = Module["__ZNSt3__24__fs10filesystem4pathdVERKS2_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathdVERKS2_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEvRNS_12basic_stringIcS7_NS_9allocatorIcEEEERKT_ = Module["__ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEvRNS_12basic_stringIcS7_NS_9allocatorIcEEEERKT_"] = createExportWrapper("_ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEvRNS_12basic_stringIcS7_NS_9allocatorIcEEEERKT_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem15directory_entry13__cached_dataC2Ev = Module["__ZNSt3__24__fs10filesystem15directory_entry13__cached_dataC2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem15directory_entry13__cached_dataC2Ev");

/** @type {function(...*):?} */
var __ZZNSt3__24__fs10filesystem15directory_entry20__create_iter_resultENS1_9file_typeEENKUlvE_clEv = Module["__ZZNSt3__24__fs10filesystem15directory_entry20__create_iter_resultENS1_9file_typeEENKUlvE_clEv"] = createExportWrapper("_ZZNSt3__24__fs10filesystem15directory_entry20__create_iter_resultENS1_9file_typeEENKUlvE_clEv");

/** @type {function(...*):?} */
var __ZNSt3__217basic_string_viewIcNS_11char_traitsIcEEEC2Ev = Module["__ZNSt3__217basic_string_viewIcNS_11char_traitsIcEEEC2Ev"] = createExportWrapper("_ZNSt3__217basic_string_viewIcNS_11char_traitsIcEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA256_cEEOT_RNS_16remove_referenceIS3_E4typeE = Module["__ZNSt3__27forwardIRA256_cEEOT_RNS_16remove_referenceIS3_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA256_cEEOT_RNS_16remove_referenceIS3_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_4__fs10filesystem9file_typeEEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardINS_4__fs10filesystem9file_typeEEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_4__fs10filesystem9file_typeEEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path11is_absoluteEv = Module["__ZNKSt3__24__fs10filesystem4path11is_absoluteEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path11is_absoluteEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path12has_filenameEv = Module["__ZNKSt3__24__fs10filesystem4path12has_filenameEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path12has_filenameEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEpLEc = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEpLEc"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEpLEc");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path6nativeEv = Module["__ZNKSt3__24__fs10filesystem4path6nativeEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path6nativeEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path18has_root_directoryEv = Module["__ZNKSt3__24__fs10filesystem4path18has_root_directoryEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path18has_root_directoryEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path10__filenameEv = Module["__ZNKSt3__24__fs10filesystem4path10__filenameEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path10__filenameEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path16__root_directoryEv = Module["__ZNKSt3__24__fs10filesystem4path16__root_directoryEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path16__root_directoryEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem20__is_pathable_stringINS_17basic_string_viewIcNS_11char_traitsIcEEEEvE13__range_beginERKS6_ = Module["__ZNSt3__24__fs10filesystem20__is_pathable_stringINS_17basic_string_viewIcNS_11char_traitsIcEEEEvE13__range_beginERKS6_"] = createExportWrapper("_ZNSt3__24__fs10filesystem20__is_pathable_stringINS_17basic_string_viewIcNS_11char_traitsIcEEEEvE13__range_beginERKS6_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem20__is_pathable_stringINS_17basic_string_viewIcNS_11char_traitsIcEEEEvE11__range_endERKS6_ = Module["__ZNSt3__24__fs10filesystem20__is_pathable_stringINS_17basic_string_viewIcNS_11char_traitsIcEEEEvE11__range_endERKS6_"] = createExportWrapper("_ZNSt3__24__fs10filesystem20__is_pathable_stringINS_17basic_string_viewIcNS_11char_traitsIcEEEEvE11__range_endERKS6_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8_PathCVTIcE14__append_rangeIPKcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeERNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEES8_S8_ = Module["__ZNSt3__24__fs10filesystem8_PathCVTIcE14__append_rangeIPKcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeERNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEES8_S8_"] = createExportWrapper("_ZNSt3__24__fs10filesystem8_PathCVTIcE14__append_rangeIPKcEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeERNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEES8_S8_");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE23__append_forward_unsafeIPKcEERS5_T_SA_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE23__append_forward_unsafeIPKcEERS5_T_SA_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE23__append_forward_unsafeIPKcEERS5_T_SA_");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE6lengthEv = Module["__ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE6lengthEv"] = createExportWrapper("_ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE6lengthEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPKcvEET_S9_RKS4_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPKcvEET_S9_RKS4_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2IPKcvEET_S9_RKS4_");

/** @type {function(...*):?} */
var __ZNSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEEC2Ev = Module["__ZNSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEEC2Ev"] = createExportWrapper("_ZNSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem15directory_entry13__cached_data7__resetEv = Module["__ZNSt3__24__fs10filesystem15directory_entry13__cached_data7__resetEv"] = createExportWrapper("_ZNSt3__24__fs10filesystem15directory_entry13__cached_data7__resetEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEE4zeroEv = Module["__ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEE4zeroEv"] = createExportWrapper("_ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEE4zeroEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEE3minEv = Module["__ZNSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEE3minEv"] = createExportWrapper("_ZNSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono15duration_valuesInE4zeroEv = Module["__ZNSt3__26chrono15duration_valuesInE4zeroEv"] = createExportWrapper("_ZNSt3__26chrono15duration_valuesInE4zeroEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEEC2InEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEEC2InEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEEC2InEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEE3minEv = Module["__ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEE3minEv"] = createExportWrapper("_ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEEC2ERKS8_ = Module["__ZNSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEEC2ERKS8_"] = createExportWrapper("_ZNSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEEC2ERKS8_");

/** @type {function(...*):?} */
var __ZNSt3__26chrono15duration_valuesInE3minEv = Module["__ZNSt3__26chrono15duration_valuesInE3minEv"] = createExportWrapper("_ZNSt3__26chrono15duration_valuesInE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__214numeric_limitsInE6lowestEv = Module["__ZNSt3__214numeric_limitsInE6lowestEv"] = createExportWrapper("_ZNSt3__214numeric_limitsInE6lowestEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsInLb1EE6lowestEv = Module["__ZNSt3__223__libcpp_numeric_limitsInLb1EE6lowestEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsInLb1EE6lowestEv");

/** @type {function(...*):?} */
var __ZNSt3__223__libcpp_numeric_limitsInLb1EE3minEv = Module["__ZNSt3__223__libcpp_numeric_limitsInLb1EE3minEv"] = createExportWrapper("_ZNSt3__223__libcpp_numeric_limitsInLb1EE3minEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathC2Ev = Module["__ZNSt3__24__fs10filesystem4pathC2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPNS_4__fs10filesystem12__dir_streamEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS6_EE5valueEvE4typeERS6_S9_ = Module["__ZNSt3__24swapIPNS_4__fs10filesystem12__dir_streamEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS6_EE5valueEvE4typeERS6_S9_"] = createExportWrapper("_ZNSt3__24swapIPNS_4__fs10filesystem12__dir_streamEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS6_EE5valueEvE4typeERS6_S9_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPNS_19__shared_weak_countEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS4_EE5valueEvE4typeERS4_S7_ = Module["__ZNSt3__24swapIPNS_19__shared_weak_countEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS4_EE5valueEvE4typeERS4_S7_"] = createExportWrapper("_ZNSt3__24swapIPNS_19__shared_weak_countEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS4_EE5valueEvE4typeERS4_S7_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPNS_4__fs10filesystem12__dir_streamEEEONS_16remove_referenceIT_E4typeEOS7_ = Module["__ZNSt3__24moveIRPNS_4__fs10filesystem12__dir_streamEEEONS_16remove_referenceIT_E4typeEOS7_"] = createExportWrapper("_ZNSt3__24moveIRPNS_4__fs10filesystem12__dir_streamEEEONS_16remove_referenceIT_E4typeEOS7_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPNS_19__shared_weak_countEEEONS_16remove_referenceIT_E4typeEOS5_ = Module["__ZNSt3__24moveIRPNS_19__shared_weak_countEEEONS_16remove_referenceIT_E4typeEOS5_"] = createExportWrapper("_ZNSt3__24moveIRPNS_19__shared_weak_countEEEONS_16remove_referenceIT_E4typeEOS5_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPNS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS7_EE5valueEvE4typeERS7_SA_ = Module["__ZNSt3__24swapIPNS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS7_EE5valueEvE4typeERS7_SA_"] = createExportWrapper("_ZNSt3__24swapIPNS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS7_EE5valueEvE4typeERS7_SA_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPNS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEONS_16remove_referenceIT_E4typeEOS8_ = Module["__ZNSt3__24moveIRPNS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEONS_16remove_referenceIT_E4typeEOS8_"] = createExportWrapper("_ZNSt3__24moveIRPNS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEONS_16remove_referenceIT_E4typeEOS8_");

/** @type {function(...*):?} */
var __ZNKSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEE8max_sizeEv = Module["__ZNKSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEEEEONS_16remove_referenceIT_E4typeEOSD_ = Module["__ZNSt3__24moveIRNS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEEEEONS_16remove_referenceIT_E4typeEOSD_"] = createExportWrapper("_ZNSt3__24moveIRNS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEEEEONS_16remove_referenceIT_E4typeEOSD_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEEC2IRS8_SB_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEEC2IRS8_SB_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEEC2IRS8_SB_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__219__shared_weak_countC2El = Module["__ZNSt3__219__shared_weak_countC2El"] = createExportWrapper("_ZNSt3__219__shared_weak_countC2El");

/** @type {function(...*):?} */
var __ZNSt3__216forward_as_tupleIJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEENS_5tupleIJDpOT_EEESA_ = Module["__ZNSt3__216forward_as_tupleIJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEENS_5tupleIJDpOT_EEESA_"] = createExportWrapper("_ZNSt3__216forward_as_tupleIJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEENS_5tupleIJDpOT_EEESA_");

/** @type {function(...*):?} */
var __ZNSt3__216forward_as_tupleIJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEENS_5tupleIJDpOT_EEESD_ = Module["__ZNSt3__216forward_as_tupleIJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEENS_5tupleIJDpOT_EEESD_"] = createExportWrapper("_ZNSt3__216forward_as_tupleIJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEENS_5tupleIJDpOT_EEESD_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem12__dir_streamEEES4_EC2IJRS5_EJRKNS3_4pathERNS3_17directory_optionsERNS_10error_codeEEEENS_21piecewise_construct_tENS_5tupleIJDpT_EEENSH_IJDpT0_EEE = Module["__ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem12__dir_streamEEES4_EC2IJRS5_EJRKNS3_4pathERNS3_17directory_optionsERNS_10error_codeEEEENS_21piecewise_construct_tENS_5tupleIJDpT_EEENSH_IJDpT0_EEE"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem12__dir_streamEEES4_EC2IJRS5_EJRKNS3_4pathERNS3_17directory_optionsERNS_10error_codeEEEENS_21piecewise_construct_tENS_5tupleIJDpT_EEENSH_IJDpT0_EEE");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem12__dir_streamEEES4_E6secondEv = Module["__ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem12__dir_streamEEES4_E6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem12__dir_streamEEES4_E6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__29addressofINS_4__fs10filesystem12__dir_streamEEEPT_RS4_ = Module["__ZNSt3__29addressofINS_4__fs10filesystem12__dir_streamEEEPT_RS4_"] = createExportWrapper("_ZNSt3__29addressofINS_4__fs10filesystem12__dir_streamEEEPT_RS4_");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE18__enable_weak_thisEz = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE18__enable_weak_thisEz"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE18__enable_weak_thisEz");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE5firstEv = Module["__ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE5resetEPS7_ = Module["__ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE5resetEPS7_"] = createExportWrapper("_ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE5resetEPS7_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEEEEOT_RNS_16remove_referenceISA_E4typeE = Module["__ZNSt3__27forwardIRPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEEEEOT_RNS_16remove_referenceISA_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEEEEOT_RNS_16remove_referenceISA_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEELi0ELb0EEC2IRS8_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEELi0ELb0EEC2IRS8_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEELi0ELb0EEC2IRS8_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEEEEOT_RNS_16remove_referenceISB_E4typeE = Module["__ZNSt3__27forwardINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEEEEOT_RNS_16remove_referenceISB_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEEEEOT_RNS_16remove_referenceISB_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEELi1ELb0EEC2ISA_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEELi1ELb0EEC2ISA_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEELi1ELb0EEC2ISA_vEEOT_");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEOT_RNS_16remove_referenceIS7_E4typeE = Module["__ZNSt3__27forwardIRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEOT_RNS_16remove_referenceIS7_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEOT_RNS_16remove_referenceIS7_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__25tupleIJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEC2ILb1ELb0EEES6_ = Module["__ZNSt3__25tupleIJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEC2ILb1ELb0EEES6_"] = createExportWrapper("_ZNSt3__25tupleIJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEC2ILb1ELb0EEES6_");

/** @type {function(...*):?} */
var __ZNSt3__25tupleIJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEC2ILb1ELb0EEES5_S7_S9_ = Module["__ZNSt3__25tupleIJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEC2ILb1ELb0EEES5_S7_S9_"] = createExportWrapper("_ZNSt3__25tupleIJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEC2ILb1ELb0EEES5_S7_S9_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_5tupleIJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEEEEONS_16remove_referenceIT_E4typeEOSB_ = Module["__ZNSt3__24moveIRNS_5tupleIJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEEEEONS_16remove_referenceIT_E4typeEOSB_"] = createExportWrapper("_ZNSt3__24moveIRNS_5tupleIJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEEEEONS_16remove_referenceIT_E4typeEOSB_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi0ELb1EEC2IJRS5_EJLm0EEEENS_21piecewise_construct_tENS_5tupleIJDpT_EEENS_15__tuple_indicesIJXspT0_EEEE = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi0ELb1EEC2IJRS5_EJLm0EEEENS_21piecewise_construct_tENS_5tupleIJDpT_EEENS_15__tuple_indicesIJXspT0_EEEE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi0ELb1EEC2IJRS5_EJLm0EEEENS_21piecewise_construct_tENS_5tupleIJDpT_EEENS_15__tuple_indicesIJXspT0_EEEE");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_5tupleIJRKNS_4__fs10filesystem4pathERNS3_17directory_optionsERNS_10error_codeEEEEEEONS_16remove_referenceIT_E4typeEOSE_ = Module["__ZNSt3__24moveIRNS_5tupleIJRKNS_4__fs10filesystem4pathERNS3_17directory_optionsERNS_10error_codeEEEEEEONS_16remove_referenceIT_E4typeEOSE_"] = createExportWrapper("_ZNSt3__24moveIRNS_5tupleIJRKNS_4__fs10filesystem4pathERNS3_17directory_optionsERNS_10error_codeEEEEEEONS_16remove_referenceIT_E4typeEOSE_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem12__dir_streamELi1ELb0EEC2IJRKNS2_4pathERNS2_17directory_optionsERNS_10error_codeEEJLm0ELm1ELm2EEEENS_21piecewise_construct_tENS_5tupleIJDpT_EEENS_15__tuple_indicesIJXspT0_EEEE = Module["__ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem12__dir_streamELi1ELb0EEC2IJRKNS2_4pathERNS2_17directory_optionsERNS_10error_codeEEJLm0ELm1ELm2EEEENS_21piecewise_construct_tENS_5tupleIJDpT_EEENS_15__tuple_indicesIJXspT0_EEEE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem12__dir_streamELi1ELb0EEC2IJRKNS2_4pathERNS2_17directory_optionsERNS_10error_codeEEJLm0ELm1ELm2EEEENS_21piecewise_construct_tENS_5tupleIJDpT_EEENS_15__tuple_indicesIJXspT0_EEEE");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEED2Ev = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEED2Ev"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem12__dir_streamELi1ELb0EED2Ev = Module["__ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem12__dir_streamELi1ELb0EED2Ev"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem12__dir_streamELi1ELb0EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEED0Ev = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEED0Ev"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE16__on_zero_sharedEv = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE16__on_zero_sharedEv"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE16__on_zero_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE21__on_zero_shared_weakEv = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE21__on_zero_shared_weakEv"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE21__on_zero_shared_weakEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem12__dir_streamEEES4_E5firstEv = Module["__ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem12__dir_streamEEES4_E5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem12__dir_streamEEES4_E5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEEC2IS4_EERKNS0_IT_EE = Module["__ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEEC2IS4_EERKNS0_IT_EE"] = createExportWrapper("_ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEEC2IS4_EERKNS0_IT_EE");

/** @type {function(...*):?} */
var __ZNSt3__214pointer_traitsIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEEE10pointer_toERS7_ = Module["__ZNSt3__214pointer_traitsIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEEE10pointer_toERS7_"] = createExportWrapper("_ZNSt3__214pointer_traitsIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEEE10pointer_toERS7_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEE10deallocateEPS6_m = Module["__ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEE10deallocateEPS6_m"] = createExportWrapper("_ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS0_IS4_EEEEE10deallocateEPS6_m");

/** @type {function(...*):?} */
var __ZNSt3__212__tuple_implINS_15__tuple_indicesIJLm0EEEEJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEC2IJLm0EEJS8_EJEJEJS8_EEENS1_IJXspT_EEEENS_13__tuple_typesIJDpT0_EEENS1_IJXspT1_EEEENSC_IJDpT2_EEEDpOT3_ = Module["__ZNSt3__212__tuple_implINS_15__tuple_indicesIJLm0EEEEJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEC2IJLm0EEJS8_EJEJEJS8_EEENS1_IJXspT_EEEENS_13__tuple_typesIJDpT0_EEENS1_IJXspT1_EEEENSC_IJDpT2_EEEDpOT3_"] = createExportWrapper("_ZNSt3__212__tuple_implINS_15__tuple_indicesIJLm0EEEEJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEC2IJLm0EEJS8_EJEJEJS8_EEENS1_IJXspT_EEEENS_13__tuple_typesIJDpT0_EEENS1_IJXspT1_EEEENSC_IJDpT2_EEEDpOT3_");

/** @type {function(...*):?} */
var __ZNSt3__212__tuple_leafILm0ERNS_9allocatorINS_4__fs10filesystem12__dir_streamEEELb0EEC2IS6_vEEOT_ = Module["__ZNSt3__212__tuple_leafILm0ERNS_9allocatorINS_4__fs10filesystem12__dir_streamEEELb0EEC2IS6_vEEOT_"] = createExportWrapper("_ZNSt3__212__tuple_leafILm0ERNS_9allocatorINS_4__fs10filesystem12__dir_streamEEELb0EEC2IS6_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__212__tuple_implINS_15__tuple_indicesIJLm0ELm1ELm2EEEEJRKNS_4__fs10filesystem4pathERNS4_17directory_optionsERNS_10error_codeEEEC2IJLm0ELm1ELm2EEJS7_S9_SB_EJEJEJS7_S9_SB_EEENS1_IJXspT_EEEENS_13__tuple_typesIJDpT0_EEENS1_IJXspT1_EEEENSF_IJDpT2_EEEDpOT3_ = Module["__ZNSt3__212__tuple_implINS_15__tuple_indicesIJLm0ELm1ELm2EEEEJRKNS_4__fs10filesystem4pathERNS4_17directory_optionsERNS_10error_codeEEEC2IJLm0ELm1ELm2EEJS7_S9_SB_EJEJEJS7_S9_SB_EEENS1_IJXspT_EEEENS_13__tuple_typesIJDpT0_EEENS1_IJXspT1_EEEENSF_IJDpT2_EEEDpOT3_"] = createExportWrapper("_ZNSt3__212__tuple_implINS_15__tuple_indicesIJLm0ELm1ELm2EEEEJRKNS_4__fs10filesystem4pathERNS4_17directory_optionsERNS_10error_codeEEEC2IJLm0ELm1ELm2EEJS7_S9_SB_EJEJEJS7_S9_SB_EEENS1_IJXspT_EEEENS_13__tuple_typesIJDpT0_EEENS1_IJXspT1_EEEENSF_IJDpT2_EEEDpOT3_");

/** @type {function(...*):?} */
var __ZNSt3__212__tuple_leafILm0ERKNS_4__fs10filesystem4pathELb0EEC2IS5_vEEOT_ = Module["__ZNSt3__212__tuple_leafILm0ERKNS_4__fs10filesystem4pathELb0EEC2IS5_vEEOT_"] = createExportWrapper("_ZNSt3__212__tuple_leafILm0ERKNS_4__fs10filesystem4pathELb0EEC2IS5_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__212__tuple_leafILm1ERNS_4__fs10filesystem17directory_optionsELb0EEC2IS4_vEEOT_ = Module["__ZNSt3__212__tuple_leafILm1ERNS_4__fs10filesystem17directory_optionsELb0EEC2IS4_vEEOT_"] = createExportWrapper("_ZNSt3__212__tuple_leafILm1ERNS_4__fs10filesystem17directory_optionsELb0EEC2IS4_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__212__tuple_leafILm2ERNS_10error_codeELb0EEC2IS2_vEEOT_ = Module["__ZNSt3__212__tuple_leafILm2ERNS_10error_codeELb0EEC2IS2_vEEOT_"] = createExportWrapper("_ZNSt3__212__tuple_leafILm2ERNS_10error_codeELb0EEC2IS2_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__23getILm0EJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSB_ = Module["__ZNSt3__23getILm0EJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSB_"] = createExportWrapper("_ZNSt3__23getILm0EJRNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSB_");

/** @type {function(...*):?} */
var __ZNSt3__23getILm0EJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSE_ = Module["__ZNSt3__23getILm0EJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSE_"] = createExportWrapper("_ZNSt3__23getILm0EJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSE_");

/** @type {function(...*):?} */
var __ZNSt3__23getILm1EJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSE_ = Module["__ZNSt3__23getILm1EJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSE_"] = createExportWrapper("_ZNSt3__23getILm1EJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSE_");

/** @type {function(...*):?} */
var __ZNSt3__23getILm2EJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSE_ = Module["__ZNSt3__23getILm2EJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSE_"] = createExportWrapper("_ZNSt3__23getILm2EJRKNS_4__fs10filesystem4pathERNS2_17directory_optionsERNS_10error_codeEEEERNS_13tuple_elementIXT_ENS_5tupleIJDpT0_EEEE4typeERSE_");

/** @type {function(...*):?} */
var __ZNSt3__212__tuple_leafILm0ERNS_9allocatorINS_4__fs10filesystem12__dir_streamEEELb0EE3getEv = Module["__ZNSt3__212__tuple_leafILm0ERNS_9allocatorINS_4__fs10filesystem12__dir_streamEEELb0EE3getEv"] = createExportWrapper("_ZNSt3__212__tuple_leafILm0ERNS_9allocatorINS_4__fs10filesystem12__dir_streamEEELb0EE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__212__tuple_leafILm0ERKNS_4__fs10filesystem4pathELb0EE3getEv = Module["__ZNSt3__212__tuple_leafILm0ERKNS_4__fs10filesystem4pathELb0EE3getEv"] = createExportWrapper("_ZNSt3__212__tuple_leafILm0ERKNS_4__fs10filesystem4pathELb0EE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__212__tuple_leafILm1ERNS_4__fs10filesystem17directory_optionsELb0EE3getEv = Module["__ZNSt3__212__tuple_leafILm1ERNS_4__fs10filesystem17directory_optionsELb0EE3getEv"] = createExportWrapper("_ZNSt3__212__tuple_leafILm1ERNS_4__fs10filesystem17directory_optionsELb0EE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__212__tuple_leafILm2ERNS_10error_codeELb0EE3getEv = Module["__ZNSt3__212__tuple_leafILm2ERNS_10error_codeELb0EE3getEv"] = createExportWrapper("_ZNSt3__212__tuple_leafILm2ERNS_10error_codeELb0EE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem12__dir_streamELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem12__dir_streamELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem12__dir_streamELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi0ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi0ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi0ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__29addressofINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEEEEPT_RS8_ = Module["__ZNSt3__29addressofINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEEEEPT_RS8_"] = createExportWrapper("_ZNSt3__29addressofINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEEEEPT_RS8_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE6secondEv = Module["__ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEENS_22__allocator_destructorINS5_IS7_EEEEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS1_IS5_EEEEEEEclEPS7_ = Module["__ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS1_IS5_EEEEEEEclEPS7_"] = createExportWrapper("_ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS1_IS5_EEEEEEEclEPS7_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS2_IS6_EEEEEEEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS1_IS5_EEEEEEE10deallocateERS8_PS7_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS1_IS5_EEEEEEE10deallocateERS8_PS7_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS1_IS5_EEEEEEE10deallocateERS8_PS7_m");

/** @type {function(...*):?} */
var __ZNKSt3__25arrayIcLm256EE4sizeEv = Module["__ZNKSt3__25arrayIcLm256EE4sizeEv"] = createExportWrapper("_ZNKSt3__25arrayIcLm256EE4sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__25arrayIcLm256EE4dataEv = Module["__ZNSt3__25arrayIcLm256EE4dataEv"] = createExportWrapper("_ZNSt3__25arrayIcLm256EE4dataEv");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE21__resize_default_initEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE21__resize_default_initEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE21__resize_default_initEm");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE21__append_default_initEm = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE21__append_default_initEm"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE21__append_default_initEm");

/** @type {function(...*):?} */
var __ZNKSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEE8max_sizeEv = Module["__ZNKSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEEEEONS_16remove_referenceIT_E4typeEOSE_ = Module["__ZNSt3__24moveIRNS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEEEEONS_16remove_referenceIT_E4typeEOSE_"] = createExportWrapper("_ZNSt3__24moveIRNS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEEEEONS_16remove_referenceIT_E4typeEOSE_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEEC2IRS9_SC_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEEC2IRS9_SC_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEEC2IRS9_SC_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEEEONS_16remove_referenceIT_E4typeEOS9_ = Module["__ZNSt3__24moveIRNS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEEEONS_16remove_referenceIT_E4typeEOS9_"] = createExportWrapper("_ZNSt3__24moveIRNS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEEEONS_16remove_referenceIT_E4typeEOS9_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEES5_EC2IS6_NS_16__value_init_tagEEEOT_OT0_ = Module["__ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEES5_EC2IS6_NS_16__value_init_tagEEEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEES5_EC2IS6_NS_16__value_init_tagEEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEES5_E6secondEv = Module["__ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEES5_E6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEES5_E6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__29addressofINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEPT_RS5_ = Module["__ZNSt3__29addressofINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEPT_RS5_"] = createExportWrapper("_ZNSt3__29addressofINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEPT_RS5_");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE18__enable_weak_thisEz = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE18__enable_weak_thisEz"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEE18__enable_weak_thisEz");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE5firstEv = Module["__ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE5resetEPS8_ = Module["__ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE5resetEPS8_"] = createExportWrapper("_ZNSt3__210unique_ptrINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE5resetEPS8_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEEEEOT_RNS_16remove_referenceISB_E4typeE = Module["__ZNSt3__27forwardIRPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEEEEOT_RNS_16remove_referenceISB_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEEEEOT_RNS_16remove_referenceISB_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEELi0ELb0EEC2IRS9_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEELi0ELb0EEC2IRS9_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEELi0ELb0EEC2IRS9_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEEEEOT_RNS_16remove_referenceISC_E4typeE = Module["__ZNSt3__27forwardINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEEEEOT_RNS_16remove_referenceISC_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEEEEOT_RNS_16remove_referenceISC_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEELi1ELb0EEC2ISB_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEELi1ELb0EEC2ISB_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEELi1ELb0EEC2ISB_vEEOT_");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEEEOT_RNS_16remove_referenceIS7_E4typeE = Module["__ZNSt3__27forwardINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEEEOT_RNS_16remove_referenceIS7_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEEEEOT_RNS_16remove_referenceIS7_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEELi0ELb1EEC2IS6_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEELi0ELb1EEC2IS6_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEELi0ELb1EEC2IS6_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_16__value_init_tagEEEOT_RNS_16remove_referenceIS2_E4typeE = Module["__ZNSt3__27forwardINS_16__value_init_tagEEEOT_RNS_16remove_referenceIS2_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_16__value_init_tagEEEOT_RNS_16remove_referenceIS2_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem28recursive_directory_iterator12__shared_impELi1ELb0EEC2ENS_16__value_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem28recursive_directory_iterator12__shared_impELi1ELb0EEC2ENS_16__value_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem28recursive_directory_iterator12__shared_impELi1ELb0EEC2ENS_16__value_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEED2Ev = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEED2Ev"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem28recursive_directory_iterator12__shared_impELi1ELb0EED2Ev = Module["__ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem28recursive_directory_iterator12__shared_impELi1ELb0EED2Ev"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem28recursive_directory_iterator12__shared_impELi1ELb0EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEED0Ev = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEED0Ev"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEE16__on_zero_sharedEv = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEE16__on_zero_sharedEv"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEE16__on_zero_sharedEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem28recursive_directory_iterator12__shared_impD2Ev = Module["__ZNSt3__24__fs10filesystem28recursive_directory_iterator12__shared_impD2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem28recursive_directory_iterator12__shared_impD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEE21__on_zero_shared_weakEv = Module["__ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEE21__on_zero_shared_weakEv"] = createExportWrapper("_ZNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEE21__on_zero_shared_weakEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEES5_E5firstEv = Module["__ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEES5_E5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEES5_E5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEEC2IS5_EERKNS0_IT_EE = Module["__ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEEC2IS5_EERKNS0_IT_EE"] = createExportWrapper("_ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEEC2IS5_EERKNS0_IT_EE");

/** @type {function(...*):?} */
var __ZNSt3__214pointer_traitsIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEEE10pointer_toERS8_ = Module["__ZNSt3__214pointer_traitsIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEEE10pointer_toERS8_"] = createExportWrapper("_ZNSt3__214pointer_traitsIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEEE10pointer_toERS8_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEE10deallocateEPS7_m = Module["__ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEE10deallocateEPS7_m"] = createExportWrapper("_ZNSt3__29allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS0_IS5_EEEEE10deallocateEPS7_m");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem28recursive_directory_iterator12__shared_impC2Ev = Module["__ZNSt3__24__fs10filesystem28recursive_directory_iterator12__shared_impC2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem28recursive_directory_iterator12__shared_impC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEEC2Ev = Module["__ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEEC2Ev"] = createExportWrapper("_ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEC2Ev = Module["__ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEC2Ev"] = createExportWrapper("_ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEC2Ev = Module["__ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEC2Ev"] = createExportWrapper("_ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEC2Ev = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEC2Ev"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEC2IiNS_18__default_init_tagEEEOT_OT0_ = Module["__ZNSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEC2IiNS_18__default_init_tagEEEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEC2IiNS_18__default_init_tagEEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIiEEOT_RNS_16remove_referenceIS1_E4typeE = Module["__ZNSt3__27forwardIiEEOT_RNS_16remove_referenceIS1_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIiEEOT_RNS_16remove_referenceIS1_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemImLi0ELb0EEC2IivEEOT_ = Module["__ZNSt3__222__compressed_pair_elemImLi0ELb0EEC2IivEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemImLi0ELb0EEC2IivEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi1ELb1EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi1ELb1EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi1ELb1EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPPNS_4__fs10filesystem12__dir_streamELi0ELb0EEC2IDnvEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPPNS_4__fs10filesystem12__dir_streamELi0ELb0EEC2IDnvEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPPNS_4__fs10filesystem12__dir_streamELi0ELb0EEC2IDnvEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb1EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb1EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb1EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEEC2Ev = Module["__ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEEC2Ev"] = createExportWrapper("_ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEEC2Ev = Module["__ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEEC2Ev"] = createExportWrapper("_ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEED2Ev = Module["__ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEED2Ev"] = createExportWrapper("_ZNSt3__25stackINS_4__fs10filesystem12__dir_streamENS_5dequeIS3_NS_9allocatorIS3_EEEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEED2Ev = Module["__ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEED2Ev"] = createExportWrapper("_ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE5clearEv = Module["__ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE5clearEv"] = createExportWrapper("_ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE5clearEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5beginEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5beginEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5beginEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE3endEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE3endEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE3endEv");

/** @type {function(...*):?} */
var __ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE7__allocEv = Module["__ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE7__allocEv"] = createExportWrapper("_ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE10deallocateERS5_PS4_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE10deallocateERS5_PS4_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE10deallocateERS5_PS4_m");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEED2Ev = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEED2Ev"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE5beginEv = Module["__ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE5beginEv"] = createExportWrapper("_ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE5beginEv");

/** @type {function(...*):?} */
var __ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE3endEv = Module["__ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE3endEv"] = createExportWrapper("_ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE3endEv");

/** @type {function(...*):?} */
var __ZNSt3__2neERKNS_16__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEES9_ = Module["__ZNSt3__2neERKNS_16__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEES9_"] = createExportWrapper("_ZNSt3__2neERKNS_16__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEES9_");

/** @type {function(...*):?} */
var __ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4sizeEv = Module["__ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4sizeEv"] = createExportWrapper("_ZNSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE4sizeEv = Module["__ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE4sizeEv"] = createExportWrapper("_ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE4sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5frontEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5frontEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5frontEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9pop_frontEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9pop_frontEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9pop_frontEv");

/** @type {function(...*):?} */
var __ZNKSt3__216__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEdeEv = Module["__ZNKSt3__216__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEdeEv"] = createExportWrapper("_ZNKSt3__216__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE7destroyIS4_EEvRS5_PT_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE7destroyIS4_EEvRS5_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE7destroyIS4_EEvRS5_PT_");

/** @type {function(...*):?} */
var __ZNSt3__216__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEppEv = Module["__ZNSt3__216__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEppEv"] = createExportWrapper("_ZNSt3__216__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEppEv");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE10deallocateEPS3_m = Module["__ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE10deallocateEPS3_m"] = createExportWrapper("_ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE10deallocateEPS3_m");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE6secondEv = Module["__ZNSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5clearEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5clearEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5clearEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE7__allocEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE7__allocEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE8capacityEv = Module["__ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE10deallocateERS6_PS5_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE10deallocateERS6_PS5_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE10deallocateERS6_PS5_m");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5emptyEv = Module["__ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5emptyEv"] = createExportWrapper("_ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5emptyEv");

/** @type {function(...*):?} */
var __ZNSt3__216__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEC2ES6_S4_ = Module["__ZNSt3__216__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEC2ES6_S4_"] = createExportWrapper("_ZNSt3__216__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEC2ES6_S4_");

/** @type {function(...*):?} */
var __ZNSt3__2eqERKNS_16__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEES9_ = Module["__ZNSt3__2eqERKNS_16__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEES9_"] = createExportWrapper("_ZNSt3__2eqERKNS_16__deque_iteratorINS_4__fs10filesystem12__dir_streamEPS3_RS3_PS4_lLl0EEES9_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE9__destroyIS4_EEvNS_17integral_constantIbLb1EEERS5_PT_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE9__destroyIS4_EEvNS_17integral_constantIbLb1EEERS5_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE9__destroyIS4_EEvNS_17integral_constantIbLb1EEERS5_PT_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE5firstEv = Module["__ZNSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE19__destruct_at_beginEPS4_ = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE19__destruct_at_beginEPS4_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE19__destruct_at_beginEPS4_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE7destroyEPS3_ = Module["__ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE7destroyEPS3_"] = createExportWrapper("_ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE7destroyEPS3_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemImLi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemImLi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemImLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE19__destruct_at_beginEPS4_NS_17integral_constantIbLb1EEE = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE19__destruct_at_beginEPS4_NS_17integral_constantIbLb1EEE"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE19__destruct_at_beginEPS4_NS_17integral_constantIbLb1EEE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi1ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem12__dir_streamEEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE17__destruct_at_endEPS4_ = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE17__destruct_at_endEPS4_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE17__destruct_at_endEPS4_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE10deallocateEPS4_m = Module["__ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE10deallocateEPS4_m"] = createExportWrapper("_ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE10deallocateEPS4_m");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE6secondEv = Module["__ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9__end_capEv = Module["__ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9__end_capEv"] = createExportWrapper("_ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE17__destruct_at_endEPS4_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE17__destruct_at_endEPS4_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE17__destruct_at_endEPS4_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNSt3__212__to_addressIPNS_4__fs10filesystem12__dir_streamEEEPT_S6_ = Module["__ZNSt3__212__to_addressIPNS_4__fs10filesystem12__dir_streamEEEPT_S6_"] = createExportWrapper("_ZNSt3__212__to_addressIPNS_4__fs10filesystem12__dir_streamEEEPT_S6_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE7destroyIS5_EEvRS6_PT_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE7destroyIS5_EEvRS6_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE7destroyIS5_EEvRS6_PT_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE9__destroyIS5_EEvNS_17integral_constantIbLb1EEERS6_PT_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE9__destroyIS5_EEvNS_17integral_constantIbLb1EEERS6_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE9__destroyIS5_EEvNS_17integral_constantIbLb1EEERS6_PT_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE7destroyEPS4_ = Module["__ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE7destroyEPS4_"] = createExportWrapper("_ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE7destroyEPS4_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem28recursive_directory_iterator12__shared_impELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem28recursive_directory_iterator12__shared_impELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_4__fs10filesystem28recursive_directory_iterator12__shared_impELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEELi0ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEELi0ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4__fs10filesystem28recursive_directory_iterator12__shared_impEEELi0ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__29addressofINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEEEEPT_RS9_ = Module["__ZNSt3__29addressofINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEEEEPT_RS9_"] = createExportWrapper("_ZNSt3__29addressofINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEEEEPT_RS9_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE6secondEv = Module["__ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS5_EEEENS_22__allocator_destructorINS6_IS8_EEEEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS1_IS6_EEEEEEEclEPS8_ = Module["__ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS1_IS6_EEEEEEEclEPS8_"] = createExportWrapper("_ZNSt3__222__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS1_IS6_EEEEEEEclEPS8_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS2_IS7_EEEEEEEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS1_IS6_EEEEEEE10deallocateERS9_PS8_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS1_IS6_EEEEEEE10deallocateERS9_PS8_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_20__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS1_IS6_EEEEEEE10deallocateERS9_PS8_m");

/** @type {function(...*):?} */
var __ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE12__back_spareEv = Module["__ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE12__back_spareEv"] = createExportWrapper("_ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE12__back_spareEv");

/** @type {function(...*):?} */
var __ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE19__add_back_capacityEv = Module["__ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE19__add_back_capacityEv"] = createExportWrapper("_ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE19__add_back_capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE9constructIS4_JS4_EEEvRS5_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE9constructIS4_JS4_EEEvRS5_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE9constructIS4_JS4_EEEvRS5_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE10__capacityEv = Module["__ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE10__capacityEv"] = createExportWrapper("_ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE10__capacityEv");

/** @type {function(...*):?} */
var __ZNKSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4sizeEv = Module["__ZNKSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4sizeEv"] = createExportWrapper("_ZNKSt3__212__deque_baseINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE4sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE13__front_spareEv = Module["__ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE13__front_spareEv"] = createExportWrapper("_ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE13__front_spareEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9push_backERKS4_ = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9push_backERKS4_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9push_backERKS4_");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE12__back_spareEv = Module["__ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE12__back_spareEv"] = createExportWrapper("_ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE12__back_spareEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE8allocateERS5_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE8allocateERS5_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE8allocateERS5_m");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9push_backEOS4_ = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9push_backEOS4_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9push_backEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEEC2EmmS7_ = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEEC2EmmS7_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEEC2EmmS7_");

/** @type {function(...*):?} */
var __ZNSt3__222__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEC2ERS5_m = Module["__ZNSt3__222__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEC2ERS5_m"] = createExportWrapper("_ZNSt3__222__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEC2ERS5_m");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEEC2ILb1EvEES4_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS8_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEEC2ILb1EvEES4_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS8_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEEC2ILb1EvEES4_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS8_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE3getEv = Module["__ZNKSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE3getEv"] = createExportWrapper("_ZNKSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE9push_backEOS4_ = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE9push_backEOS4_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE9push_backEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE7releaseEv = Module["__ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE7releaseEv"] = createExportWrapper("_ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPPNS_4__fs10filesystem12__dir_streamEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS7_EE5valueEvE4typeERS7_SA_ = Module["__ZNSt3__24swapIPPNS_4__fs10filesystem12__dir_streamEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS7_EE5valueEvE4typeERS7_SA_"] = createExportWrapper("_ZNSt3__24swapIPPNS_4__fs10filesystem12__dir_streamEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS7_EE5valueEvE4typeERS7_SA_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9__end_capEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9__end_capEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE9__end_capEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE9__end_capEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEED2Ev = Module["__ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEED2Ev = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEED2Ev"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE10push_frontERKS4_ = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE10push_frontERKS4_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE10push_frontERKS4_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE10push_frontEOS4_ = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE10push_frontEOS4_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE10push_frontEOS4_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardINS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE11__constructIS4_JS4_EEEvNS_17integral_constantIbLb1EEERS5_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE11__constructIS4_JS4_EEEvNS_17integral_constantIbLb1EEERS5_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE11__constructIS4_JS4_EEEvNS_17integral_constantIbLb1EEERS5_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE5firstEv = Module["__ZNKSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairImNS_9allocatorINS_4__fs10filesystem12__dir_streamEEEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemImLi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemImLi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemImLi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIPPNS_4__fs10filesystem12__dir_streamES5_EET0_T_S7_S6_ = Module["__ZNSt3__24moveIPPNS_4__fs10filesystem12__dir_streamES5_EET0_T_S7_S6_"] = createExportWrapper("_ZNSt3__24moveIPPNS_4__fs10filesystem12__dir_streamES5_EET0_T_S7_S6_");

/** @type {function(...*):?} */
var __ZNSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEC2ES5_ = Module["__ZNSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEC2ES5_"] = createExportWrapper("_ZNSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEC2ES5_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE18__construct_at_endINS_13move_iteratorIPS4_EEEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESE_SE_ = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE18__construct_at_endINS_13move_iteratorIPS4_EEEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESE_SE_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE18__construct_at_endINS_13move_iteratorIPS4_EEEENS_9enable_ifIXsr27__is_cpp17_forward_iteratorIT_EE5valueEvE4typeESE_SE_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE9constructIS5_JRKS5_EEEvRS6_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE9constructIS5_JRKS5_EEEvRS6_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE9constructIS5_JRKS5_EEEvRS6_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE9constructIS5_JS5_EEEvRS6_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE9constructIS5_JS5_EEEvRS6_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE9constructIS5_JS5_EEEvRS6_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE8allocateEmPKv = Module["__ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE8allocateEmPKv"] = createExportWrapper("_ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE8allocateEmPKv");

/** @type {function(...*):?} */
var __ZNSt3__213move_backwardIPPNS_4__fs10filesystem12__dir_streamES5_EET0_T_S7_S6_ = Module["__ZNSt3__213move_backwardIPPNS_4__fs10filesystem12__dir_streamES5_EET0_T_S7_S6_"] = createExportWrapper("_ZNSt3__213move_backwardIPPNS_4__fs10filesystem12__dir_streamES5_EET0_T_S7_S6_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEEC2IDnS8_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEEC2IDnS8_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEEC2IDnS8_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE7__allocEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE7__allocEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE8allocateERS6_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE8allocateERS6_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE8allocateERS6_m");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEEEONS_16remove_referenceIT_E4typeEOSA_ = Module["__ZNSt3__24moveIRNS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEEEONS_16remove_referenceIT_E4typeEOSA_"] = createExportWrapper("_ZNSt3__24moveIRNS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEEEONS_16remove_referenceIT_E4typeEOSA_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEEC2IRS4_S8_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEEC2IRS4_S8_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEEC2IRS4_S8_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE5firstEv = Module["__ZNSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPPNS_4__fs10filesystem12__dir_streamEEEONS_16remove_referenceIT_E4typeEOS8_ = Module["__ZNSt3__24moveIRPPNS_4__fs10filesystem12__dir_streamEEEONS_16remove_referenceIT_E4typeEOS8_"] = createExportWrapper("_ZNSt3__24moveIRPPNS_4__fs10filesystem12__dir_streamEEEONS_16remove_referenceIT_E4typeEOS8_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5firstEv = Module["__ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE5firstEv = Module["__ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE5resetES4_ = Module["__ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE5resetES4_"] = createExportWrapper("_ZNSt3__210unique_ptrIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE5resetES4_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE5clearEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE5clearEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE5clearEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE8capacityEv = Module["__ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__213__unwrap_iterIPPNS_4__fs10filesystem12__dir_streamEEET_S6_ = Module["__ZNSt3__213__unwrap_iterIPPNS_4__fs10filesystem12__dir_streamEEET_S6_"] = createExportWrapper("_ZNSt3__213__unwrap_iterIPPNS_4__fs10filesystem12__dir_streamEEET_S6_");

/** @type {function(...*):?} */
var __ZNSt3__26__moveIPNS_4__fs10filesystem12__dir_streamES4_EENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableISA_EE5valueEPSA_E4typeEPS7_SE_SB_ = Module["__ZNSt3__26__moveIPNS_4__fs10filesystem12__dir_streamES4_EENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableISA_EE5valueEPSA_E4typeEPS7_SE_SB_"] = createExportWrapper("_ZNSt3__26__moveIPNS_4__fs10filesystem12__dir_streamES4_EENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableISA_EE5valueEPSA_E4typeEPS7_SE_SB_");

/** @type {function(...*):?} */
var __ZNSt3__28distanceINS_13move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_ = Module["__ZNSt3__28distanceINS_13move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_"] = createExportWrapper("_ZNSt3__28distanceINS_13move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE21_ConstructTransactionC2EPPS4_m = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE21_ConstructTransactionC2EPPS4_m"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE21_ConstructTransactionC2EPPS4_m");

/** @type {function(...*):?} */
var __ZNKSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEdeEv = Module["__ZNKSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEdeEv"] = createExportWrapper("_ZNKSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEppEv = Module["__ZNSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEppEv"] = createExportWrapper("_ZNSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEppEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE21_ConstructTransactionD2Ev = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE21_ConstructTransactionD2Ev"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE21_ConstructTransactionD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRKPNS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS7_E4typeE = Module["__ZNSt3__27forwardIRKPNS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS7_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRKPNS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS7_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE11__constructIS5_JRKS5_EEEvNS_17integral_constantIbLb1EEERS6_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE11__constructIS5_JRKS5_EEEvNS_17integral_constantIbLb1EEERS6_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE11__constructIS5_JRKS5_EEEvNS_17integral_constantIbLb1EEERS6_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__210__distanceINS_13move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_NS_26random_access_iterator_tagE = Module["__ZNSt3__210__distanceINS_13move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_NS_26random_access_iterator_tagE"] = createExportWrapper("_ZNSt3__210__distanceINS_13move_iteratorIPPNS_4__fs10filesystem12__dir_streamEEEEENS_15iterator_traitsIT_E15difference_typeES9_S9_NS_26random_access_iterator_tagE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIPNS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS5_E4typeE = Module["__ZNSt3__27forwardIPNS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS5_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIPNS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS5_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE11__constructIS5_JS5_EEEvNS_17integral_constantIbLb1EEERS6_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE11__constructIS5_JS5_EEEvNS_17integral_constantIbLb1EEERS6_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEE11__constructIS5_JS5_EEEvNS_17integral_constantIbLb1EEERS6_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE6secondEv = Module["__ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__2miIPPNS_4__fs10filesystem12__dir_streamES5_EEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_13move_iteratorIT_EERKNS7_IT0_EE = Module["__ZNSt3__2miIPPNS_4__fs10filesystem12__dir_streamES5_EEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_13move_iteratorIT_EERKNS7_IT0_EE"] = createExportWrapper("_ZNSt3__2miIPPNS_4__fs10filesystem12__dir_streamES5_EEDTmicldtfp_4baseEcldtfp0_4baseEERKNS_13move_iteratorIT_EERKNS7_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEE4baseEv = Module["__ZNKSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEE4baseEv"] = createExportWrapper("_ZNKSt3__213move_iteratorIPPNS_4__fs10filesystem12__dir_streamEE4baseEv");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE9constructIS4_JS4_EEEvPT_DpOT0_ = Module["__ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE9constructIS4_JS4_EEEvPT_DpOT0_"] = createExportWrapper("_ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE9constructIS4_JS4_EEEvPT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIRNS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE9constructIS4_JRKS4_EEEvPT_DpOT0_ = Module["__ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE9constructIS4_JRKS4_EEEvPT_DpOT0_"] = createExportWrapper("_ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE9constructIS4_JRKS4_EEEvPT_DpOT0_");

/** @type {function(...*):?} */
var __ZNKSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE8max_sizeEv = Module["__ZNKSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__215__move_backwardIPNS_4__fs10filesystem12__dir_streamES4_EENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableISA_EE5valueEPSA_E4typeEPS7_SE_SB_ = Module["__ZNSt3__215__move_backwardIPNS_4__fs10filesystem12__dir_streamES4_EENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableISA_EE5valueEPSA_E4typeEPS7_SE_SB_"] = createExportWrapper("_ZNSt3__215__move_backwardIPNS_4__fs10filesystem12__dir_streamES4_EENS_9enable_ifIXaasr7is_sameINS_12remove_constIT_E4typeET0_EE5valuesr28is_trivially_copy_assignableISA_EE5valueEPSA_E4typeEPS7_SE_SB_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRNS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEEEOT_RNS_16remove_referenceIS8_E4typeE = Module["__ZNSt3__27forwardIRNS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEEEOT_RNS_16remove_referenceIS8_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRNS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEEEEOT_RNS_16remove_referenceIS8_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb0EEC2IS7_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIRNS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb0EEC2IS7_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_9allocatorIPNS_4__fs10filesystem12__dir_streamEEELi1ELb0EEC2IS7_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE8allocateEmPKv = Module["__ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE8allocateEmPKv"] = createExportWrapper("_ZNSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE8allocateEmPKv");

/** @type {function(...*):?} */
var __ZNKSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE8max_sizeEv = Module["__ZNKSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__29allocatorIPNS_4__fs10filesystem12__dir_streamEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRPNS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS6_E4typeE = Module["__ZNSt3__27forwardIRPNS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS6_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRPNS_4__fs10filesystem12__dir_streamEEEOT_RNS_16remove_referenceIS6_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_4__fs10filesystem12__dir_streamELi0ELb0EEC2IRS4_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPNS_4__fs10filesystem12__dir_streamELi0ELb0EEC2IRS4_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_4__fs10filesystem12__dir_streamELi0ELb0EEC2IRS4_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEEEOT_RNS_16remove_referenceIS8_E4typeE = Module["__ZNSt3__27forwardINS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEEEOT_RNS_16remove_referenceIS8_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEEEEOT_RNS_16remove_referenceIS8_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEELi1ELb0EEC2IS7_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEELi1ELb0EEC2IS7_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEELi1ELb0EEC2IS7_vEEOT_");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPPNS_4__fs10filesystem12__dir_streamELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE6secondEv = Module["__ZNSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4__fs10filesystem12__dir_streamENS_22__allocator_destructorINS_9allocatorIS3_EEEEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__222__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEclEPS4_ = Module["__ZNSt3__222__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEclEPS4_"] = createExportWrapper("_ZNSt3__222__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEclEPS4_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_22__allocator_destructorINS_9allocatorINS_4__fs10filesystem12__dir_streamEEEEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_ = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE9__end_capEv = Module["__ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE9__end_capEv"] = createExportWrapper("_ZNKSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPPNS_4__fs10filesystem12__dir_streamERNS_9allocatorIS4_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE9constructIS3_JS3_EEEvPT_DpOT0_ = Module["__ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE9constructIS3_JS3_EEEvPT_DpOT0_"] = createExportWrapper("_ZNSt3__29allocatorINS_4__fs10filesystem12__dir_streamEE9constructIS3_JS3_EEEvPT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem12__dir_streamC2EOS2_ = Module["__ZNSt3__24__fs10filesystem12__dir_streamC2EOS2_"] = createExportWrapper("_ZNSt3__24__fs10filesystem12__dir_streamC2EOS2_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_4__fs10filesystem15directory_entryEEEONS_16remove_referenceIT_E4typeEOS6_ = Module["__ZNSt3__24moveIRNS_4__fs10filesystem15directory_entryEEEONS_16remove_referenceIT_E4typeEOS6_"] = createExportWrapper("_ZNSt3__24moveIRNS_4__fs10filesystem15directory_entryEEEONS_16remove_referenceIT_E4typeEOS6_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem15directory_entryC2EOS2_ = Module["__ZNSt3__24__fs10filesystem15directory_entryC2EOS2_"] = createExportWrapper("_ZNSt3__24__fs10filesystem15directory_entryC2EOS2_");

/** @type {function(...*):?} */
var __ZNSt3__212__to_addressINS_4__fs10filesystem12__dir_streamEEEPT_S5_ = Module["__ZNSt3__212__to_addressINS_4__fs10filesystem12__dir_streamEEEPT_S5_"] = createExportWrapper("_ZNSt3__212__to_addressINS_4__fs10filesystem12__dir_streamEEEPT_S5_");

/** @type {function(...*):?} */
var __ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE25__maybe_remove_back_spareEb = Module["__ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE25__maybe_remove_back_spareEb"] = createExportWrapper("_ZNSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE25__maybe_remove_back_spareEb");

/** @type {function(...*):?} */
var __ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE19__back_spare_blocksEv = Module["__ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE19__back_spare_blocksEv"] = createExportWrapper("_ZNKSt3__25dequeINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEE19__back_spare_blocksEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE4backEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE4backEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE4backEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE8pop_backEv = Module["__ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE8pop_backEv"] = createExportWrapper("_ZNSt3__214__split_bufferIPNS_4__fs10filesystem12__dir_streamENS_9allocatorIS4_EEE8pop_backEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18directory_iteratorC1ERKNS1_4pathEPNS_10error_codeENS1_17directory_optionsE = Module["__ZNSt3__24__fs10filesystem18directory_iteratorC1ERKNS1_4pathEPNS_10error_codeENS1_17directory_optionsE"] = createExportWrapper("_ZNSt3__24__fs10filesystem18directory_iteratorC1ERKNS1_4pathEPNS_10error_codeENS1_17directory_optionsE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem28recursive_directory_iteratorC1ERKNS1_4pathENS1_17directory_optionsEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem28recursive_directory_iteratorC1ERKNS1_4pathENS1_17directory_optionsEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem28recursive_directory_iteratorC1ERKNS1_4pathENS1_17directory_optionsEPNS_10error_codeE");

/** @type {function(...*):?} */
var ___muloti4 = Module["___muloti4"] = createExportWrapper("__muloti4");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem16_FilesystemClock3nowEv = Module["__ZNSt3__24__fs10filesystem16_FilesystemClock3nowEv"] = createExportWrapper("_ZNSt3__24__fs10filesystem16_FilesystemClock3nowEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationInNS_5ratioILx1ELx1EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationInNS_5ratioILx1ELx1EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationInNS_5ratioILx1ELx1EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEEC2IlEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__26chrono13duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEEnS4_EENS_9enable_ifIXsr13__is_durationIT_EE5valueES7_E4typeERKNS2_IT0_T1_EE = Module["__ZNSt3__26chrono13duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEEnS4_EENS_9enable_ifIXsr13__is_durationIT_EE5valueES7_E4typeERKNS2_IT0_T1_EE"] = createExportWrapper("_ZNSt3__26chrono13duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEEnS4_EENS_9enable_ifIXsr13__is_durationIT_EE5valueES7_E4typeERKNS2_IT0_T1_EE");

/** @type {function(...*):?} */
var __ZNSt3__26chronoplInNS_5ratioILx1ELx1EEEnNS2_ILx1ELx1000000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_ = Module["__ZNSt3__26chronoplInNS_5ratioILx1ELx1EEEnNS2_ILx1ELx1000000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_"] = createExportWrapper("_ZNSt3__26chronoplInNS_5ratioILx1ELx1EEEnNS2_ILx1ELx1000000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEEC2InNS2_ILx1ELx1EEEEERKNS1_IT_T0_EEPNS_9enable_ifIXaasr13__no_overflowIS8_S3_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEaaeqsr13__no_overflowIS8_S3_E4typeE3denLi1Entsr23treat_as_floating_pointIS7_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEEC2InNS2_ILx1ELx1EEEEERKNS1_IT_T0_EEPNS_9enable_ifIXaasr13__no_overflowIS8_S3_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEaaeqsr13__no_overflowIS8_S3_E4typeE3denLi1Entsr23treat_as_floating_pointIS7_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEEC2InNS2_ILx1ELx1EEEEERKNS1_IT_T0_EEPNS_9enable_ifIXaasr13__no_overflowIS8_S3_EE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEaaeqsr13__no_overflowIS8_S3_E4typeE3denLi1Entsr23treat_as_floating_pointIS7_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEE5countEv = Module["__ZNKSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEE5countEv"] = createExportWrapper("_ZNKSt3__26chrono8durationInNS_5ratioILx1ELx1000000000EEEE5countEv");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono15__duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEES5_NS3_ILx1ELx1EEELb1ELb1EEclERKS5_ = Module["__ZNKSt3__26chrono15__duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEES5_NS3_ILx1ELx1EEELb1ELb1EEclERKS5_"] = createExportWrapper("_ZNKSt3__26chrono15__duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEES5_NS3_ILx1ELx1EEELb1ELb1EEclERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem16filesystem_errorD2Ev = Module["__ZNSt3__24__fs10filesystem16filesystem_errorD2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem16filesystem_errorD2Ev");

/** @type {function(...*):?} */
var __ZNSt3__210shared_ptrINS_4__fs10filesystem16filesystem_error8_StorageEED2Ev = Module["__ZNSt3__210shared_ptrINS_4__fs10filesystem16filesystem_error8_StorageEED2Ev"] = createExportWrapper("_ZNSt3__210shared_ptrINS_4__fs10filesystem16filesystem_error8_StorageEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem16filesystem_errorD0Ev = Module["__ZNSt3__24__fs10filesystem16filesystem_errorD0Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem16filesystem_errorD0Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem16filesystem_error13__create_whatEi = Module["__ZNSt3__24__fs10filesystem16filesystem_error13__create_whatEi"] = createExportWrapper("_ZNSt3__24__fs10filesystem16filesystem_error13__create_whatEi");

/** @type {function(...*):?} */
var __ZNKSt3__210shared_ptrINS_4__fs10filesystem16filesystem_error8_StorageEEptEv = Module["__ZNKSt3__210shared_ptrINS_4__fs10filesystem16filesystem_error8_StorageEEptEv"] = createExportWrapper("_ZNKSt3__210shared_ptrINS_4__fs10filesystem16filesystem_error8_StorageEEptEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem16filesystem_error5path1Ev = Module["__ZNKSt3__24__fs10filesystem16filesystem_error5path1Ev"] = createExportWrapper("_ZNKSt3__24__fs10filesystem16filesystem_error5path1Ev");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem16filesystem_error5path2Ev = Module["__ZNKSt3__24__fs10filesystem16filesystem_error5path2Ev"] = createExportWrapper("_ZNKSt3__24__fs10filesystem16filesystem_error5path2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem10__absoluteERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem10__absoluteERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem10__absoluteERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem14__current_pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem14__current_pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem14__current_pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem11__canonicalERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem11__canonicalERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem11__canonicalERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathC2IPcvEERKT_NS2_6formatE = Module["__ZNSt3__24__fs10filesystem4pathC2IPcvEERKT_NS2_6formatE"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathC2IPcvEERKT_NS2_6formatE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIPcEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_ = Module["__ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIPcEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_"] = createExportWrapper("_ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIPcEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem6__copyERKNS1_4pathES4_NS1_12copy_optionsEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem6__copyERKNS1_4pathES4_NS1_12copy_optionsEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem6__copyERKNS1_4pathES4_NS1_12copy_optionsEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemorENS1_12copy_optionsES2_ = Module["__ZNSt3__24__fs10filesystemorENS1_12copy_optionsES2_"] = createExportWrapper("_ZNSt3__24__fs10filesystemorENS1_12copy_optionsES2_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemanENS1_12copy_optionsES2_ = Module["__ZNSt3__24__fs10filesystemanENS1_12copy_optionsES2_"] = createExportWrapper("_ZNSt3__24__fs10filesystemanENS1_12copy_optionsES2_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8is_otherENS1_11file_statusE = Module["__ZNSt3__24__fs10filesystem8is_otherENS1_11file_statusE"] = createExportWrapper("_ZNSt3__24__fs10filesystem8is_otherENS1_11file_statusE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem15is_regular_fileENS1_11file_statusE = Module["__ZNSt3__24__fs10filesystem15is_regular_fileENS1_11file_statusE"] = createExportWrapper("_ZNSt3__24__fs10filesystem15is_regular_fileENS1_11file_statusE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem14__copy_symlinkERKNS1_4pathES4_PNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem14__copy_symlinkERKNS1_4pathES4_PNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem14__copy_symlinkERKNS1_4pathES4_PNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem16__create_symlinkERKNS1_4pathES4_PNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem16__create_symlinkERKNS1_4pathES4_PNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem16__create_symlinkERKNS1_4pathES4_PNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18__create_hard_linkERKNS1_4pathES4_PNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem18__create_hard_linkERKNS1_4pathES4_PNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem18__create_hard_linkERKNS1_4pathES4_PNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path8filenameEv = Module["__ZNKSt3__24__fs10filesystem4path8filenameEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path8filenameEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem11__copy_fileERKNS1_4pathES4_NS1_12copy_optionsEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem11__copy_fileERKNS1_4pathES4_NS1_12copy_optionsEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem11__copy_fileERKNS1_4pathES4_NS1_12copy_optionsEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18__create_directoryERKNS1_4pathES4_PNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem18__create_directoryERKNS1_4pathES4_PNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem18__create_directoryERKNS1_4pathES4_PNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18directory_iteratorC2ERKNS1_4pathE = Module["__ZNSt3__24__fs10filesystem18directory_iteratorC2ERKNS1_4pathE"] = createExportWrapper("_ZNSt3__24__fs10filesystem18directory_iteratorC2ERKNS1_4pathE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18directory_iteratorC2ERKNS1_4pathERNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem18directory_iteratorC2ERKNS1_4pathERNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem18directory_iteratorC2ERKNS1_4pathERNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemneERKNS1_18directory_iteratorES4_ = Module["__ZNSt3__24__fs10filesystemneERKNS1_18directory_iteratorES4_"] = createExportWrapper("_ZNSt3__24__fs10filesystemneERKNS1_18directory_iteratorES4_");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem18directory_iteratorptEv = Module["__ZNKSt3__24__fs10filesystem18directory_iteratorptEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem18directory_iteratorptEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18directory_iterator9incrementERNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem18directory_iterator9incrementERNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem18directory_iterator9incrementERNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem14__read_symlinkERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem14__read_symlinkERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem14__read_symlinkERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2INS_17basic_string_viewIcS2_EEvEERKT_ = Module["__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2INS_17basic_string_viewIcS2_EEvEERKT_"] = createExportWrapper("_ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEC2INS_17basic_string_viewIcS2_EEvEERKT_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathC2EONS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEENS2_6formatE = Module["__ZNSt3__24__fs10filesystem4pathC2EONS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEENS2_6formatE"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathC2EONS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEENS2_6formatE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemeqERKNS1_18directory_iteratorES4_ = Module["__ZNSt3__24__fs10filesystemeqERKNS1_18directory_iteratorES4_"] = createExportWrapper("_ZNSt3__24__fs10filesystemeqERKNS1_18directory_iteratorES4_");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem18directory_iteratordeEv = Module["__ZNKSt3__24__fs10filesystem18directory_iteratordeEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem18directory_iteratordeEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem20__create_directoriesERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem20__create_directoriesERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem20__create_directoriesERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path11parent_pathEv = Module["__ZNKSt3__24__fs10filesystem4path11parent_pathEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path11parent_pathEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path5emptyEv = Module["__ZNKSt3__24__fs10filesystem4path5emptyEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path5emptyEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem6statusERKNS1_4pathERNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem6statusERKNS1_4pathERNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem6statusERKNS1_4pathERNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18__create_directoryERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem18__create_directoryERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem18__create_directoryERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path13__parent_pathEv = Module["__ZNKSt3__24__fs10filesystem4path13__parent_pathEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path13__parent_pathEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem26__create_directory_symlinkERKNS1_4pathES4_PNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem26__create_directory_symlinkERKNS1_4pathES4_PNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem26__create_directory_symlinkERKNS1_4pathES4_PNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEEC2IPcLb1EvvEET_ = Module["__ZNSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEEC2IPcLb1EvvEET_"] = createExportWrapper("_ZNSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEEC2IPcLb1EvvEET_");

/** @type {function(...*):?} */
var __ZNKSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEE3getEv = Module["__ZNKSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEE3getEv"] = createExportWrapper("_ZNKSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEED2Ev = Module["__ZNSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEEC2IRS1_NS_18__default_init_tagEEEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEEC2IRS1_NS_18__default_init_tagEEEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEEC2IRS1_NS_18__default_init_tagEEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEE5resetEDn = Module["__ZNSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEE5resetEDn"] = createExportWrapper("_ZNSt3__210unique_ptrIA_cNS_14default_deleteIS1_EEE5resetEDn");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem14__current_pathERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem14__current_pathERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem14__current_pathERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem12__equivalentERKNS1_4pathES4_PNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem12__equivalentERKNS1_4pathES4_PNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem12__equivalentERKNS1_4pathES4_PNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathC2INS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEvEERKT_NS2_6formatE = Module["__ZNSt3__24__fs10filesystem4pathC2INS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEvEERKT_NS2_6formatE"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathC2INS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEvEERKT_NS2_6formatE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEvRSA_RKT_ = Module["__ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEvRSA_RKT_"] = createExportWrapper("_ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEEEvRSA_RKT_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem11__file_sizeERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem11__file_sizeERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem11__file_sizeERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem17__hard_link_countERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem17__hard_link_countERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem17__hard_link_countERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem13__fs_is_emptyERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem13__fs_is_emptyERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem13__fs_is_emptyERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__2eqINS_4__fs10filesystem12__dir_streamES3_EEbRKNS_10shared_ptrIT_EERKNS4_IT0_EE = Module["__ZNSt3__2eqINS_4__fs10filesystem12__dir_streamES3_EEbRKNS_10shared_ptrIT_EERKNS4_IT0_EE"] = createExportWrapper("_ZNSt3__2eqINS_4__fs10filesystem12__dir_streamES3_EEbRKNS_10shared_ptrIT_EERKNS4_IT0_EE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem17__last_write_timeERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem17__last_write_timeERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem17__last_write_timeERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem17__last_write_timeERKNS1_4pathENS_6chrono10time_pointINS1_16_FilesystemClockENS5_8durationInNS_5ratioILx1ELx1000000000EEEEEEEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem17__last_write_timeERKNS1_4pathENS_6chrono10time_pointINS1_16_FilesystemClockENS5_8durationInNS_5ratioILx1ELx1000000000EEEEEEEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem17__last_write_timeERKNS1_4pathENS_6chrono10time_pointINS1_16_FilesystemClockENS5_8durationInNS_5ratioILx1ELx1000000000EEEEEEEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__25arrayI8timespecLm2EEixEm = Module["__ZNSt3__25arrayI8timespecLm2EEixEm"] = createExportWrapper("_ZNSt3__25arrayI8timespecLm2EEixEm");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem13__permissionsERKNS1_4pathENS1_5permsENS1_12perm_optionsEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem13__permissionsERKNS1_4pathENS1_5permsENS1_12perm_optionsEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem13__permissionsERKNS1_4pathENS1_5permsENS1_12perm_optionsEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemaNERNS1_5permsES2_ = Module["__ZNSt3__24__fs10filesystemaNERNS1_5permsES2_"] = createExportWrapper("_ZNSt3__24__fs10filesystemaNERNS1_5permsES2_");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem11file_status11permissionsEv = Module["__ZNKSt3__24__fs10filesystem11file_status11permissionsEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem11file_status11permissionsEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemoRERNS1_5permsES2_ = Module["__ZNSt3__24__fs10filesystemoRERNS1_5permsES2_"] = createExportWrapper("_ZNSt3__24__fs10filesystemoRERNS1_5permsES2_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemcoENS1_5permsE = Module["__ZNSt3__24__fs10filesystemcoENS1_5permsE"] = createExportWrapper("_ZNSt3__24__fs10filesystemcoENS1_5permsE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemanENS1_5permsES2_ = Module["__ZNSt3__24__fs10filesystemanENS1_5permsES2_"] = createExportWrapper("_ZNSt3__24__fs10filesystemanENS1_5permsES2_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemanENS1_12perm_optionsES2_ = Module["__ZNSt3__24__fs10filesystemanENS1_12perm_optionsES2_"] = createExportWrapper("_ZNSt3__24__fs10filesystemanENS1_12perm_optionsES2_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystemorENS1_5permsES2_ = Module["__ZNSt3__24__fs10filesystemorENS1_5permsES2_"] = createExportWrapper("_ZNSt3__24__fs10filesystemorENS1_5permsES2_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8__removeERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem8__removeERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem8__removeERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem12__remove_allERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem12__remove_allERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem12__remove_allERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__215error_conditionC2INS_4errcEEET_PNS_9enable_ifIXsr23is_error_condition_enumIS3_EE5valueEvE4typeE = Module["__ZNSt3__215error_conditionC2INS_4errcEEET_PNS_9enable_ifIXsr23is_error_condition_enumIS3_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__215error_conditionC2INS_4errcEEET_PNS_9enable_ifIXsr23is_error_condition_enumIS3_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__2eqERKNS_10error_codeERKNS_15error_conditionE = Module["__ZNSt3__2eqERKNS_10error_codeERKNS_15error_conditionE"] = createExportWrapper("_ZNSt3__2eqERKNS_10error_codeERKNS_15error_conditionE");

/** @type {function(...*):?} */
var __ZNSt3__220make_error_conditionENS_4errcE = Module["__ZNSt3__220make_error_conditionENS_4errcE"] = createExportWrapper("_ZNSt3__220make_error_conditionENS_4errcE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8__renameERKNS1_4pathES4_PNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem8__renameERKNS1_4pathES4_PNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem8__renameERKNS1_4pathES4_PNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem13__resize_fileERKNS1_4pathEyPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem13__resize_fileERKNS1_4pathEyPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem13__resize_fileERKNS1_4pathEyPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem7__spaceERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem7__spaceERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem7__spaceERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem21__temp_directory_pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem21__temp_directory_pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem21__temp_directory_pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathC2IPKcvEERKT_NS2_6formatE = Module["__ZNSt3__24__fs10filesystem4pathC2IPKcvEERKT_NS2_6formatE"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathC2IPKcvEERKT_NS2_6formatE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIPKcEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_ = Module["__ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIPKcEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_"] = createExportWrapper("_ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIPKcEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem18__weakly_canonicalERKNS1_4pathEPNS_10error_codeE = Module["__ZNSt3__24__fs10filesystem18__weakly_canonicalERKNS1_4pathEPNS_10error_codeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem18__weakly_canonicalERKNS1_4pathEPNS_10error_codeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathC2IA1_cvEERKT_NS2_6formatE = Module["__ZNSt3__24__fs10filesystem4pathC2IA1_cvEERKT_NS2_6formatE"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathC2IA1_cvEERKT_NS2_6formatE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4path9__reserveEm = Module["__ZNSt3__24__fs10filesystem4path9__reserveEm"] = createExportWrapper("_ZNSt3__24__fs10filesystem4path9__reserveEm");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEEC2Ev = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEEC2Ev"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEEC2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE4backEv = Module["__ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE4backEv"] = createExportWrapper("_ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE4backEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4path6assignINS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS9_ = Module["__ZNSt3__24__fs10filesystem4path6assignINS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS9_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4path6assignINS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS9_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE9push_backEOS4_ = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE9push_backEOS4_"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE9push_backEOS4_");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5emptyEv = Module["__ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5emptyEv"] = createExportWrapper("_ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5emptyEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE6rbeginEv = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE6rbeginEv"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE6rbeginEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE4rendEv = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE4rendEv"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE4rendEv");

/** @type {function(...*):?} */
var __ZNSt3__2neINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEES7_EEbRKNS_16reverse_iteratorIT_EERKNS8_IT0_EE = Module["__ZNSt3__2neINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEES7_EEbRKNS_16reverse_iteratorIT_EERKNS8_IT0_EE"] = createExportWrapper("_ZNSt3__2neINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEES7_EEbRKNS_16reverse_iteratorIT_EERKNS8_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path16lexically_normalEv = Module["__ZNKSt3__24__fs10filesystem4path16lexically_normalEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path16lexically_normalEv");

/** @type {function(...*):?} */
var __ZNKSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEdeEv = Module["__ZNKSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEdeEv"] = createExportWrapper("_ZNKSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathdVINS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS9_ = Module["__ZNSt3__24__fs10filesystem4pathdVINS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS9_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathdVINS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS9_");

/** @type {function(...*):?} */
var __ZNSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEppEv = Module["__ZNSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEppEv"] = createExportWrapper("_ZNSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEppEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEED2Ev = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEED2Ev"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIA1_cEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_ = Module["__ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIA1_cEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_"] = createExportWrapper("_ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIA1_cEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEEC2Ev = Module["__ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEEC2Ev"] = createExportWrapper("_ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE9__end_capEv = Module["__ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE9__end_capEv"] = createExportWrapper("_ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEONS_16remove_referenceIT_E4typeEOS7_ = Module["__ZNSt3__24moveIRNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEONS_16remove_referenceIT_E4typeEOS7_"] = createExportWrapper("_ZNSt3__24moveIRNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEONS_16remove_referenceIT_E4typeEOS7_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE22__construct_one_at_endIJS4_EEEvDpOT_ = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE22__construct_one_at_endIJS4_EEEvDpOT_"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE22__construct_one_at_endIJS4_EEEvDpOT_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE21__push_back_slow_pathIS4_EEvOT_ = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE21__push_back_slow_pathIS4_EEvOT_"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE21__push_back_slow_pathIS4_EEvOT_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE3endEv = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE3endEv"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE3endEv");

/** @type {function(...*):?} */
var __ZNSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEC2ES7_ = Module["__ZNSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEC2ES7_"] = createExportWrapper("_ZNSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEC2ES7_");

/** @type {function(...*):?} */
var __ZNKSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE4baseEv = Module["__ZNKSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE4baseEv"] = createExportWrapper("_ZNKSt3__216reverse_iteratorINS_11__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE4baseEv");

/** @type {function(...*):?} */
var __ZNSt3__2neIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEbRKNS_11__wrap_iterIT_EESA_ = Module["__ZNSt3__2neIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEbRKNS_11__wrap_iterIT_EESA_"] = createExportWrapper("_ZNSt3__2neIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEbRKNS_11__wrap_iterIT_EESA_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5beginEv = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5beginEv"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5beginEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEmmEv = Module["__ZNSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEmmEv"] = createExportWrapper("_ZNSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEmmEv");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEdeEv = Module["__ZNKSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEdeEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4path6appendINS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS9_ = Module["__ZNSt3__24__fs10filesystem4path6appendINS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS9_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4path6appendINS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS9_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEEC2Ev = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEEC2Ev"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE7reserveEm = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE7reserveEm"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE7reserveEm");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5emptyEv = Module["__ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5emptyEv"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5emptyEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathC2IA2_cvEERKT_NS2_6formatE = Module["__ZNSt3__24__fs10filesystem4pathC2IA2_cvEERKT_NS2_6formatE"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathC2IA2_cvEERKT_NS2_6formatE");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE4backEv = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE4backEv"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE4backEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8pop_backEv = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8pop_backEv"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8pop_backEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE4sizeEv = Module["__ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE4sizeEv"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE4sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5beginEv = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5beginEv"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5beginEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE3endEv = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE3endEv"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE3endEv");

/** @type {function(...*):?} */
var __ZNSt3__2neIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEbRKNS_11__wrap_iterIT_EESF_ = Module["__ZNSt3__2neIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEbRKNS_11__wrap_iterIT_EESF_"] = createExportWrapper("_ZNSt3__2neIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEbRKNS_11__wrap_iterIT_EESF_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathdVIA1_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_ = Module["__ZNSt3__24__fs10filesystem4pathdVIA1_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathdVIA1_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEdeEv = Module["__ZNKSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEdeEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEdeEv");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEppEv = Module["__ZNSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEppEv"] = createExportWrapper("_ZNSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEppEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEED2Ev = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEED2Ev"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEED2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE17__annotate_deleteEv = Module["__ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE17__annotate_deleteEv"] = createExportWrapper("_ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE17__annotate_deleteEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEED2Ev = Module["__ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEED2Ev"] = createExportWrapper("_ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4path17replace_extensionERKS2_ = Module["__ZNSt3__24__fs10filesystem4path17replace_extensionERKS2_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4path17replace_extensionERKS2_");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path9extensionEv = Module["__ZNKSt3__24__fs10filesystem4path9extensionEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path9extensionEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path11__extensionEv = Module["__ZNKSt3__24__fs10filesystem4path11__extensionEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path11__extensionEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path11__root_nameEv = Module["__ZNKSt3__24__fs10filesystem4path11__root_nameEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path11__root_nameEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path15__root_path_rawEv = Module["__ZNKSt3__24__fs10filesystem4path15__root_path_rawEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path15__root_path_rawEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path15__relative_pathEv = Module["__ZNKSt3__24__fs10filesystem4path15__relative_pathEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path15__relative_pathEv");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4backEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4backEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4backEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path6__stemEv = Module["__ZNKSt3__24__fs10filesystem4path6__stemEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path6__stemEv");

/** @type {function(...*):?} */
var __ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEES4_EC2IRKS4_RA1_KcLb0EEEOT_OT0_ = Module["__ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEES4_EC2IRKS4_RA1_KcLb0EEEOT_OT0_"] = createExportWrapper("_ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEES4_EC2IRKS4_RA1_KcLb0EEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE12find_last_ofEcm = Module["__ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE12find_last_ofEcm"] = createExportWrapper("_ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE12find_last_ofEcm");

/** @type {function(...*):?} */
var __ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEES4_EC2IRKS4_S4_Lb0EEEOT_OT0_ = Module["__ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEES4_EC2IRKS4_S4_Lb0EEEOT_OT0_"] = createExportWrapper("_ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEES4_EC2IRKS4_S4_Lb0EEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEES4_EC2IS4_S4_Lb0EEEOT_OT0_ = Module["__ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEES4_EC2IS4_S4_Lb0EEEOT_OT0_"] = createExportWrapper("_ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEES4_EC2IS4_S4_Lb0EEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEEC2Ev = Module["__ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEEC2Ev"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEEC2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8capacityEv = Module["__ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE7__allocEv = Module["__ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE7__allocEv"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEEC2EmmSC_ = Module["__ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEEC2EmmSC_"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEEC2EmmSC_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS9_RSB_EE = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS9_RSB_EE"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS9_RSB_EE");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEED2Ev = Module["__ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEED2Ev"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE12emplace_backIJRS5_RS8_EEEvDpOT_ = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE12emplace_backIJRS5_RS8_EEEvDpOT_"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE12emplace_backIJRS5_RS8_EEEvDpOT_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__destruct_at_endEPS9_ = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__destruct_at_endEPS9_"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__destruct_at_endEPS9_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIA2_cEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_ = Module["__ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIA2_cEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_"] = createExportWrapper("_ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIA2_cEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE11__make_iterEPS9_ = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE11__make_iterEPS9_"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE11__make_iterEPS9_");

/** @type {function(...*):?} */
var __ZNSt3__2eqIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEESA_EEbRKNS_11__wrap_iterIT_EERKNSB_IT0_EE = Module["__ZNSt3__2eqIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEESA_EEbRKNS_11__wrap_iterIT_EERKNSB_IT0_EE"] = createExportWrapper("_ZNSt3__2eqIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEESA_EEbRKNS_11__wrap_iterIT_EERKNSB_IT0_EE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4path6appendIA1_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_ = Module["__ZNSt3__24__fs10filesystem4path6appendIA1_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4path6appendIA1_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__annotate_deleteEv = Module["__ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__annotate_deleteEv"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__annotate_deleteEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEED2Ev = Module["__ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEED2Ev"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEED2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path18lexically_relativeERKS2_ = Module["__ZNKSt3__24__fs10filesystem4path18lexically_relativeERKS2_"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path18lexically_relativeERKS2_");

/** @type {function(...*):?} */
var __ZNSt3__2neIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EES6_ = Module["__ZNSt3__2neIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EES6_"] = createExportWrapper("_ZNSt3__2neIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EES6_");

/** @type {function(...*):?} */
var __ZNSt3__2eqIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EES6_ = Module["__ZNSt3__2eqIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EES6_"] = createExportWrapper("_ZNSt3__2eqIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EES6_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4pathdVIA3_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_ = Module["__ZNSt3__24__fs10filesystem4pathdVIA3_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4pathdVIA3_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_");

/** @type {function(...*):?} */
var __ZNSt3__2neIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EENS_11common_typeIJS6_EE4typeE = Module["__ZNSt3__2neIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EENS_11common_typeIJS6_EE4typeE"] = createExportWrapper("_ZNSt3__2neIcNS_11char_traitsIcEEEEbNS_17basic_string_viewIT_T0_EENS_11common_typeIJS6_EE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4path6appendIA3_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_ = Module["__ZNSt3__24__fs10filesystem4path6appendIA3_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4path6appendIA3_cEENS_9enable_ifIXsr13__is_pathableIT_EE5valueERS2_E4typeERKS6_");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path9__compareENS_17basic_string_viewIcNS_11char_traitsIcEEEE = Module["__ZNKSt3__24__fs10filesystem4path9__compareENS_17basic_string_viewIcNS_11char_traitsIcEEEE"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path9__compareENS_17basic_string_viewIcNS_11char_traitsIcEEEE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem10hash_valueERKNS1_4pathE = Module["__ZNSt3__24__fs10filesystem10hash_valueERKNS1_4pathE"] = createExportWrapper("_ZNSt3__24__fs10filesystem10hash_valueERKNS1_4pathE");

/** @type {function(...*):?} */
var __ZNKSt3__24hashINS_17basic_string_viewIcNS_11char_traitsIcEEEEEclES4_ = Module["__ZNKSt3__24hashINS_17basic_string_viewIcNS_11char_traitsIcEEEEEclES4_"] = createExportWrapper("_ZNKSt3__24hashINS_17basic_string_viewIcNS_11char_traitsIcEEEEEclES4_");

/** @type {function(...*):?} */
var __ZNSt3__214__hash_combineEmm = Module["__ZNSt3__214__hash_combineEmm"] = createExportWrapper("_ZNSt3__214__hash_combineEmm");

/** @type {function(...*):?} */
var __ZNKSt3__213__scalar_hashINS_6_PairTELm2EEclES1_ = Module["__ZNKSt3__213__scalar_hashINS_6_PairTELm2EEclES1_"] = createExportWrapper("_ZNKSt3__213__scalar_hashINS_6_PairTELm2EEclES1_");

/** @type {function(...*):?} */
var __ZNSt3__216__do_string_hashIPKcEEmT_S3_ = Module["__ZNSt3__216__do_string_hashIPKcEEmT_S3_"] = createExportWrapper("_ZNSt3__216__do_string_hashIPKcEEmT_S3_");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path5beginEv = Module["__ZNKSt3__24__fs10filesystem4path5beginEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path5beginEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4path8iteratorC2Ev = Module["__ZNSt3__24__fs10filesystem4path8iteratorC2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem4path8iteratorC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4path13__assign_viewERKNS_17basic_string_viewIcNS_11char_traitsIcEEEE = Module["__ZNSt3__24__fs10filesystem4path13__assign_viewERKNS_17basic_string_viewIcNS_11char_traitsIcEEEE"] = createExportWrapper("_ZNSt3__24__fs10filesystem4path13__assign_viewERKNS_17basic_string_viewIcNS_11char_traitsIcEEEE");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem4path3endEv = Module["__ZNKSt3__24__fs10filesystem4path3endEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem4path3endEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4path8iterator11__incrementEv = Module["__ZNSt3__24__fs10filesystem4path8iterator11__incrementEv"] = createExportWrapper("_ZNSt3__24__fs10filesystem4path8iterator11__incrementEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4path8iterator11__decrementEv = Module["__ZNSt3__24__fs10filesystem4path8iterator11__decrementEv"] = createExportWrapper("_ZNSt3__24__fs10filesystem4path8iterator11__decrementEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem15directory_entry12__do_refreshEv = Module["__ZNSt3__24__fs10filesystem15directory_entry12__do_refreshEv"] = createExportWrapper("_ZNSt3__24__fs10filesystem15directory_entry12__do_refreshEv");

/** @type {function(...*):?} */
var __ZNKSt3__24__fs10filesystem16filesystem_error4whatEv = Module["__ZNKSt3__24__fs10filesystem16filesystem_error4whatEv"] = createExportWrapper("_ZNKSt3__24__fs10filesystem16filesystem_error4whatEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono13duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEEnNS3_ILx1ELx1EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE = Module["__ZNSt3__26chrono13duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEEnNS3_ILx1ELx1EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE"] = createExportWrapper("_ZNSt3__26chrono13duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEEnNS3_ILx1ELx1EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono15__duration_castINS0_8durationInNS_5ratioILx1ELx1EEEEENS2_InNS3_ILx1ELx1000000000EEEEENS3_ILx1000000000ELx1EEELb0ELb1EEclERKS5_ = Module["__ZNKSt3__26chrono15__duration_castINS0_8durationInNS_5ratioILx1ELx1EEEEENS2_InNS3_ILx1ELx1000000000EEEEENS3_ILx1000000000ELx1EEELb0ELb1EEclERKS5_"] = createExportWrapper("_ZNKSt3__26chrono15__duration_castINS0_8durationInNS_5ratioILx1ELx1EEEEENS2_InNS3_ILx1ELx1000000000EEEEENS3_ILx1000000000ELx1EEELb0ELb1EEclERKS5_");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono8durationInNS_5ratioILx1ELx1EEEE5countEv = Module["__ZNKSt3__26chrono8durationInNS_5ratioILx1ELx1EEEE5countEv"] = createExportWrapper("_ZNKSt3__26chrono8durationInNS_5ratioILx1ELx1EEEE5countEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem11file_statusC2Ev = Module["__ZNSt3__24__fs10filesystem11file_statusC2Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem11file_statusC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem11file_status4typeENS1_9file_typeE = Module["__ZNSt3__24__fs10filesystem11file_status4typeENS1_9file_typeE"] = createExportWrapper("_ZNSt3__24__fs10filesystem11file_status4typeENS1_9file_typeE");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem11file_status11permissionsENS1_5permsE = Module["__ZNSt3__24__fs10filesystem11file_status11permissionsENS1_5permsE"] = createExportWrapper("_ZNSt3__24__fs10filesystem11file_status11permissionsENS1_5permsE");

/** @type {function(...*):?} */
var __ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEEC1Ev = Module["__ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEEC1Ev"] = createExportWrapper("_ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEEC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEE6__openEij = Module["__ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEE6__openEij"] = createExportWrapper("_ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEE6__openEij");

/** @type {function(...*):?} */
var __ZNKSt3__214basic_ifstreamIcNS_11char_traitsIcEEE7is_openEv = Module["__ZNKSt3__214basic_ifstreamIcNS_11char_traitsIcEEE7is_openEv"] = createExportWrapper("_ZNKSt3__214basic_ifstreamIcNS_11char_traitsIcEEE7is_openEv");

/** @type {function(...*):?} */
var __ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEEC1Ev = Module["__ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEEC1Ev"] = createExportWrapper("_ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEEC1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEE6__openEij = Module["__ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEE6__openEij"] = createExportWrapper("_ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEE6__openEij");

/** @type {function(...*):?} */
var __ZNKSt3__214basic_ofstreamIcNS_11char_traitsIcEEE7is_openEv = Module["__ZNKSt3__214basic_ofstreamIcNS_11char_traitsIcEEE7is_openEv"] = createExportWrapper("_ZNKSt3__214basic_ofstreamIcNS_11char_traitsIcEEE7is_openEv");

/** @type {function(...*):?} */
var __ZNSt3__24copyINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIcS3_EEEET0_T_S8_S7_ = Module["__ZNSt3__24copyINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIcS3_EEEET0_T_S8_S7_"] = createExportWrapper("_ZNSt3__24copyINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIcS3_EEEET0_T_S8_S7_");

/** @type {function(...*):?} */
var __ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE4failEv = Module["__ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE4failEv"] = createExportWrapper("_ZNKSt3__29basic_iosIcNS_11char_traitsIcEEE4failEv");

/** @type {function(...*):?} */
var __ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEED1Ev = Module["__ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEED1Ev = Module["__ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_istreamIcNS_11char_traitsIcEEEC2EPNS_15basic_streambufIcS2_EE = Module["__ZNSt3__213basic_istreamIcNS_11char_traitsIcEEEC2EPNS_15basic_streambufIcS2_EE"] = createExportWrapper("_ZNSt3__213basic_istreamIcNS_11char_traitsIcEEEC2EPNS_15basic_streambufIcS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEEC2Ev = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEEC2Ev"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE6__openEij = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE6__openEij"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE6__openEij");

/** @type {function(...*):?} */
var __ZNKSt3__213basic_filebufIcNS_11char_traitsIcEEE7is_openEv = Module["__ZNKSt3__213basic_filebufIcNS_11char_traitsIcEEE7is_openEv"] = createExportWrapper("_ZNKSt3__213basic_filebufIcNS_11char_traitsIcEEE7is_openEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEEC2EPNS_15basic_streambufIcS2_EE = Module["__ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEEC2EPNS_15basic_streambufIcS2_EE"] = createExportWrapper("_ZNSt3__213basic_ostreamIcNS_11char_traitsIcEEEC2EPNS_15basic_streambufIcS2_EE");

/** @type {function(...*):?} */
var __ZNSt3__213__unwrap_iterINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEET_S5_ = Module["__ZNSt3__213__unwrap_iterINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEET_S5_"] = createExportWrapper("_ZNSt3__213__unwrap_iterINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEET_S5_");

/** @type {function(...*):?} */
var __ZNSt3__26__copyINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIcS3_EEEET0_T_S8_S7_ = Module["__ZNSt3__26__copyINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIcS3_EEEET0_T_S8_S7_"] = createExportWrapper("_ZNSt3__26__copyINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIcS3_EEEET0_T_S8_S7_");

/** @type {function(...*):?} */
var __ZNKSt3__28ios_base4failEv = Module["__ZNKSt3__28ios_base4failEv"] = createExportWrapper("_ZNKSt3__28ios_base4failEv");

/** @type {function(...*):?} */
var __ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEED2Ev = Module["__ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEED2Ev"] = createExportWrapper("_ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEED2Ev = Module["__ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEED2Ev"] = createExportWrapper("_ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__29has_facetINS_7codecvtIcc11__mbstate_tEEEEbRKNS_6localeE = Module["__ZNSt3__29has_facetINS_7codecvtIcc11__mbstate_tEEEEbRKNS_6localeE"] = createExportWrapper("_ZNSt3__29has_facetINS_7codecvtIcc11__mbstate_tEEEEbRKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEED0Ev = Module["__ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZNSt3__214basic_ifstreamIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__214basic_ifstreamIcNS_11char_traitsIcEEED1Ev = Module["__ZTv0_n12_NSt3__214basic_ifstreamIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZTv0_n12_NSt3__214basic_ifstreamIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__214basic_ifstreamIcNS_11char_traitsIcEEED0Ev = Module["__ZTv0_n12_NSt3__214basic_ifstreamIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZTv0_n12_NSt3__214basic_ifstreamIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEED2Ev = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEED2Ev"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE5closeEv = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE5closeEv"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE5closeEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEED0Ev = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE5imbueERKNS_6localeE = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE5imbueERKNS_6localeE"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE5imbueERKNS_6localeE");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE6setbufEPcl = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE6setbufEPcl"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE6setbufEPcl");

/** @type {function(...*):?} */
var __ZNSt3__23maxIlEERKT_S3_S3_ = Module["__ZNSt3__23maxIlEERKT_S3_S3_"] = createExportWrapper("_ZNSt3__23maxIlEERKT_S3_S3_");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE7seekoffExNS_8ios_base7seekdirEj = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE7seekoffExNS_8ios_base7seekdirEj"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE7seekoffExNS_8ios_base7seekdirEj");

/** @type {function(...*):?} */
var __ZNSt3__24fposI11__mbstate_tE5stateES1_ = Module["__ZNSt3__24fposI11__mbstate_tE5stateES1_"] = createExportWrapper("_ZNSt3__24fposI11__mbstate_tE5stateES1_");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE7seekposENS_4fposI11__mbstate_tEEj = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE7seekposENS_4fposI11__mbstate_tEEj"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE7seekposENS_4fposI11__mbstate_tEEj");

/** @type {function(...*):?} */
var __ZNKSt3__24fposI11__mbstate_tE5stateEv = Module["__ZNKSt3__24fposI11__mbstate_tE5stateEv"] = createExportWrapper("_ZNKSt3__24fposI11__mbstate_tE5stateEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE4syncEv = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE4syncEv"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE4syncEv");

/** @type {function(...*):?} */
var __ZNKSt3__27codecvtIcc11__mbstate_tE6lengthERS1_PKcS5_m = Module["__ZNKSt3__27codecvtIcc11__mbstate_tE6lengthERS1_PKcS5_m"] = createExportWrapper("_ZNKSt3__27codecvtIcc11__mbstate_tE6lengthERS1_PKcS5_m");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE9underflowEv = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE9underflowEv"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE9underflowEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE11__read_modeEv = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE11__read_modeEv"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE11__read_modeEv");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE9pbackfailEi = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE9pbackfailEi"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE9pbackfailEi");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE8overflowEi = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE8overflowEi"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE8overflowEi");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE12__write_modeEv = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE12__write_modeEv"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE12__write_modeEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EEC2ILb1EvEES2_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS4_EEXT_EE20__good_rval_ref_typeE = Module["__ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EEC2ILb1EvEES2_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS4_EEXT_EE20__good_rval_ref_typeE"] = createExportWrapper("_ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EEC2ILb1EvEES2_NS_16__dependent_typeINS_27__unique_ptr_deleter_sfinaeIS4_EEXT_EE20__good_rval_ref_typeE");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EE7releaseEv = Module["__ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EE7releaseEv"] = createExportWrapper("_ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EE7releaseEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EED2Ev = Module["__ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EED2Ev"] = createExportWrapper("_ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPFiP8_IO_FILEEEEONS_16remove_referenceIT_E4typeEOS7_ = Module["__ZNSt3__24moveIRPFiP8_IO_FILEEEEONS_16remove_referenceIT_E4typeEOS7_"] = createExportWrapper("_ZNSt3__24moveIRPFiP8_IO_FILEEEEONS_16remove_referenceIT_E4typeEOS7_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIP8_IO_FILEPFiS2_EEC2IRS2_S4_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIP8_IO_FILEPFiS2_EEC2IRS2_S4_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIP8_IO_FILEPFiS2_EEC2IRS2_S4_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIP8_IO_FILEPFiS2_EE5firstEv = Module["__ZNSt3__217__compressed_pairIP8_IO_FILEPFiS2_EE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIP8_IO_FILEPFiS2_EE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EE5resetES2_ = Module["__ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EE5resetES2_"] = createExportWrapper("_ZNSt3__210unique_ptrI8_IO_FILEPFiPS1_EE5resetES2_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRP8_IO_FILEEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRP8_IO_FILEEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRP8_IO_FILEEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIP8_IO_FILELi0ELb0EEC2IRS2_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIP8_IO_FILELi0ELb0EEC2IRS2_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIP8_IO_FILELi0ELb0EEC2IRS2_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIPFiP8_IO_FILEEEEOT_RNS_16remove_referenceIS5_E4typeE = Module["__ZNSt3__27forwardIPFiP8_IO_FILEEEEOT_RNS_16remove_referenceIS5_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIPFiP8_IO_FILEEEEOT_RNS_16remove_referenceIS5_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPFiP8_IO_FILEELi1ELb0EEC2IS4_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPFiP8_IO_FILEELi1ELb0EEC2IS4_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPFiP8_IO_FILEELi1ELb0EEC2IS4_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIP8_IO_FILELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIP8_IO_FILELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIP8_IO_FILELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIP8_IO_FILEPFiS2_EE6secondEv = Module["__ZNSt3__217__compressed_pairIP8_IO_FILEPFiS2_EE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIP8_IO_FILEPFiS2_EE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPFiP8_IO_FILEELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPFiP8_IO_FILEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPFiP8_IO_FILEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__23maxIlNS_6__lessIllEEEERKT_S5_S5_T0_ = Module["__ZNSt3__23maxIlNS_6__lessIllEEEERKT_S5_S5_T0_"] = createExportWrapper("_ZNSt3__23maxIlNS_6__lessIllEEEERKT_S5_S5_T0_");

/** @type {function(...*):?} */
var __ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE15__make_mdstringEj = Module["__ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE15__make_mdstringEj"] = createExportWrapper("_ZNSt3__213basic_filebufIcNS_11char_traitsIcEEE15__make_mdstringEj");

/** @type {function(...*):?} */
var __ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEED0Ev = Module["__ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZNSt3__214basic_ofstreamIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__214basic_ofstreamIcNS_11char_traitsIcEEED1Ev = Module["__ZTv0_n12_NSt3__214basic_ofstreamIcNS_11char_traitsIcEEED1Ev"] = createExportWrapper("_ZTv0_n12_NSt3__214basic_ofstreamIcNS_11char_traitsIcEEED1Ev");

/** @type {function(...*):?} */
var __ZTv0_n12_NSt3__214basic_ofstreamIcNS_11char_traitsIcEEED0Ev = Module["__ZTv0_n12_NSt3__214basic_ofstreamIcNS_11char_traitsIcEEED0Ev"] = createExportWrapper("_ZTv0_n12_NSt3__214basic_ofstreamIcNS_11char_traitsIcEEED0Ev");

/** @type {function(...*):?} */
var __ZNSt3__216__copy_constexprINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIcS3_EEEET0_T_S8_S7_ = Module["__ZNSt3__216__copy_constexprINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIcS3_EEEET0_T_S8_S7_"] = createExportWrapper("_ZNSt3__216__copy_constexprINS_19istreambuf_iteratorIcNS_11char_traitsIcEEEENS_19ostreambuf_iteratorIcS3_EEEET0_T_S8_S7_");

/** @type {function(...*):?} */
var __ZNKSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE3getEv = Module["__ZNKSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE3getEv"] = createExportWrapper("_ZNKSt3__210shared_ptrINS_4__fs10filesystem12__dir_streamEE3getEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationInNS_5ratioILx1ELx1EEEEC2IiEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationInNS_5ratioILx1ELx1EEEEC2IiEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationInNS_5ratioILx1ELx1EEEEC2IiEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNSt3__26chronomiInNS_5ratioILx1ELx1EEEnNS2_ILx1ELx1000000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_ = Module["__ZNSt3__26chronomiInNS_5ratioILx1ELx1EEEnNS2_ILx1ELx1000000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_"] = createExportWrapper("_ZNSt3__26chronomiInNS_5ratioILx1ELx1EEEnNS2_ILx1ELx1000000000EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEE16time_since_epochEv = Module["__ZNKSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEE16time_since_epochEv"] = createExportWrapper("_ZNKSt3__26chrono10time_pointINS_4__fs10filesystem16_FilesystemClockENS0_8durationInNS_5ratioILx1ELx1000000000EEEEEE16time_since_epochEv");

/** @type {function(...*):?} */
var __ZNSt3__26chrono13duration_castINS0_8durationInNS_5ratioILx1ELx1EEEEEnNS3_ILx1ELx1000000000EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE = Module["__ZNSt3__26chrono13duration_castINS0_8durationInNS_5ratioILx1ELx1EEEEEnNS3_ILx1ELx1000000000EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE"] = createExportWrapper("_ZNSt3__26chrono13duration_castINS0_8durationInNS_5ratioILx1ELx1EEEEEnNS3_ILx1ELx1000000000EEEEENS_9enable_ifIXsr13__is_durationIT_EE5valueES8_E4typeERKNS2_IT0_T1_EE");

/** @type {function(...*):?} */
var __ZNSt3__26chronomiInNS_5ratioILx1ELx1000000000EEEnNS2_ILx1ELx1EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_ = Module["__ZNSt3__26chronomiInNS_5ratioILx1ELx1000000000EEEnNS2_ILx1ELx1EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_"] = createExportWrapper("_ZNSt3__26chronomiInNS_5ratioILx1ELx1000000000EEEnNS2_ILx1ELx1EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_");

/** @type {function(...*):?} */
var __ZNSt3__26chronoplInNS_5ratioILx1ELx1EEEnS3_EENS_11common_typeIJNS0_8durationIT_T0_EENS5_IT1_T2_EEEE4typeERKS8_RKSB_ = Module["__ZNSt3__26chronoplInNS_5ratioILx1ELx1EEEnS3_EENS_11common_typeIJNS0_8durationIT_T0_EENS5_IT1_T2_EEEE4typeERKS8_RKSB_"] = createExportWrapper("_ZNSt3__26chronoplInNS_5ratioILx1ELx1EEEnS3_EENS_11common_typeIJNS0_8durationIT_T0_EENS5_IT1_T2_EEEE4typeERKS8_RKSB_");

/** @type {function(...*):?} */
var __ZNSt3__26chronoplInNS_5ratioILx1ELx1000000000EEEnNS2_ILx1ELx1EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_ = Module["__ZNSt3__26chronoplInNS_5ratioILx1ELx1000000000EEEnNS2_ILx1ELx1EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_"] = createExportWrapper("_ZNSt3__26chronoplInNS_5ratioILx1ELx1000000000EEEnNS2_ILx1ELx1EEEEENS_11common_typeIJNS0_8durationIT_T0_EENS6_IT1_T2_EEEE4typeERKS9_RKSC_");

/** @type {function(...*):?} */
var __ZNSt3__26chronomiInNS_5ratioILx1ELx1EEEnS3_EENS_11common_typeIJNS0_8durationIT_T0_EENS5_IT1_T2_EEEE4typeERKS8_RKSB_ = Module["__ZNSt3__26chronomiInNS_5ratioILx1ELx1EEEnS3_EENS_11common_typeIJNS0_8durationIT_T0_EENS5_IT1_T2_EEEE4typeERKS8_RKSB_"] = createExportWrapper("_ZNSt3__26chronomiInNS_5ratioILx1ELx1EEEnS3_EENS_11common_typeIJNS0_8durationIT_T0_EENS5_IT1_T2_EEEE4typeERKS8_RKSB_");

/** @type {function(...*):?} */
var __ZNKSt3__26chrono15__duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEENS2_InNS3_ILx1ELx1EEEEES4_Lb1ELb0EEclERKS5_ = Module["__ZNKSt3__26chrono15__duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEENS2_InNS3_ILx1ELx1EEEEES4_Lb1ELb0EEclERKS5_"] = createExportWrapper("_ZNKSt3__26chrono15__duration_castINS0_8durationInNS_5ratioILx1ELx1000000000EEEEENS2_InNS3_ILx1ELx1EEEEES4_Lb1ELb0EEclERKS5_");

/** @type {function(...*):?} */
var __ZNSt3__26chrono8durationInNS_5ratioILx1ELx1EEEEC2InEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE = Module["__ZNSt3__26chrono8durationInNS_5ratioILx1ELx1EEEEC2InEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE"] = createExportWrapper("_ZNSt3__26chrono8durationInNS_5ratioILx1ELx1EEEEC2InEERKT_PNS_9enable_ifIXaasr14is_convertibleIS6_nEE5valueooL_ZNS_17integral_constantIbLb0EE5valueEEntsr23treat_as_floating_pointIS6_EE5valueEvE4typeE");

/** @type {function(...*):?} */
var __ZNKSt3__25arrayI8timespecLm2EE4dataEv = Module["__ZNKSt3__25arrayI8timespecLm2EE4dataEv"] = createExportWrapper("_ZNKSt3__25arrayI8timespecLm2EE4dataEv");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE5frontEv = Module["__ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE5frontEv"] = createExportWrapper("_ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE5frontEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRKNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEOT_RNS_16remove_referenceIS7_E4typeE = Module["__ZNSt3__27forwardIRKNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEOT_RNS_16remove_referenceIS7_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRKNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEOT_RNS_16remove_referenceIS7_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA1_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA1_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA1_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE5rfindEcm = Module["__ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE5rfindEcm"] = createExportWrapper("_ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEE5rfindEcm");

/** @type {function(...*):?} */
var __ZNSt3__27forwardINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEOT_RNS_16remove_referenceIS5_E4typeE = Module["__ZNSt3__27forwardINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEOT_RNS_16remove_referenceIS5_E4typeE"] = createExportWrapper("_ZNSt3__27forwardINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEOT_RNS_16remove_referenceIS5_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE9__end_capEv = Module["__ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE9__end_capEv"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEOT_RNS_16remove_referenceIS6_E4typeE = Module["__ZNSt3__27forwardIRNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEOT_RNS_16remove_referenceIS6_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEOT_RNS_16remove_referenceIS6_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRNS_4__fs10filesystem12PathPartKindEEEOT_RNS_16remove_referenceIS5_E4typeE = Module["__ZNSt3__27forwardIRNS_4__fs10filesystem12PathPartKindEEEOT_RNS_16remove_referenceIS5_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRNS_4__fs10filesystem12PathPartKindEEEOT_RNS_16remove_referenceIS5_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE22__construct_one_at_endIJRS5_RS8_EEEvDpOT_ = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE22__construct_one_at_endIJRS5_RS8_EEEvDpOT_"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE22__construct_one_at_endIJRS5_RS8_EEEvDpOT_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE24__emplace_back_slow_pathIJRS5_RS8_EEEvDpOT_ = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE24__emplace_back_slow_pathIJRS5_RS8_EEEvDpOT_"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE24__emplace_back_slow_pathIJRS5_RS8_EEEvDpOT_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5firstEv = Module["__ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE21_ConstructTransactionC2ERSC_m = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE21_ConstructTransactionC2ERSC_m"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE21_ConstructTransactionC2ERSC_m");

/** @type {function(...*):?} */
var __ZNSt3__212__to_addressINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEPT_SB_ = Module["__ZNSt3__212__to_addressINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEPT_SB_"] = createExportWrapper("_ZNSt3__212__to_addressINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEPT_SB_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE9constructISA_JRS6_RS9_EEEvRSB_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE9constructISA_JRS6_RS9_EEEvRSB_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE9constructISA_JRS6_RS9_EEEvRSB_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE21_ConstructTransactionD2Ev = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE21_ConstructTransactionD2Ev"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE21_ConstructTransactionD2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE11__recommendEm = Module["__ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE11__recommendEm"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE11__recommendEm");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE11__constructISA_JRS6_RS9_EEEvNS_17integral_constantIbLb1EEERSB_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE11__constructISA_JRS6_RS9_EEEvNS_17integral_constantIbLb1EEERSB_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE11__constructISA_JRS6_RS9_EEEvNS_17integral_constantIbLb1EEERSB_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE6secondEv = Module["__ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE9constructIS9_JRS5_RS8_EEEvPT_DpOT0_ = Module["__ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE9constructIS9_JRS5_RS8_EEEvPT_DpOT0_"] = createExportWrapper("_ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE9constructIS9_JRS5_RS8_EEEvPT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEC2IRS4_RS7_Lb0EEEOT_OT0_ = Module["__ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEC2IRS4_RS7_Lb0EEEOT_OT0_"] = createExportWrapper("_ZNSt3__24pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEC2IRS4_RS7_Lb0EEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8max_sizeEv = Module["__ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEEC2IDnSD_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEEC2IDnSD_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEEC2IDnSD_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE7__allocEv = Module["__ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE7__allocEv"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE8allocateERSB_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE8allocateERSB_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE8allocateERSB_m");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE9__end_capEv = Module["__ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE9__end_capEv"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE46__construct_backward_with_exception_guaranteesISA_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb1EE5valueEEntsr15__has_constructISB_PT_SH_EE5valuesr31is_trivially_move_constructibleISH_EE5valueEvE4typeERSB_SI_SI_RSI_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE46__construct_backward_with_exception_guaranteesISA_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb1EE5valueEEntsr15__has_constructISB_PT_SH_EE5valuesr31is_trivially_move_constructibleISH_EE5valueEvE4typeERSB_SI_SI_RSI_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE46__construct_backward_with_exception_guaranteesISA_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb1EE5valueEEntsr15__has_constructISB_PT_SH_EE5valuesr31is_trivially_move_constructibleISH_EE5valueEvE4typeERSB_SI_SI_RSI_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableISC_EE5valueEvE4typeERSC_SF_ = Module["__ZNSt3__24swapIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableISC_EE5valueEvE4typeERSC_SF_"] = createExportWrapper("_ZNSt3__24swapIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableISC_EE5valueEvE4typeERSC_SF_");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE14__annotate_newEm = Module["__ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE14__annotate_newEm"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE14__annotate_newEm");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE26__invalidate_all_iteratorsEv = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE26__invalidate_all_iteratorsEv"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE26__invalidate_all_iteratorsEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE5clearEv = Module["__ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE5clearEv"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE5clearEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE8capacityEv = Module["__ZNKSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE10deallocateERSB_PSA_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE10deallocateERSB_PSA_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE10deallocateERSB_PSA_m");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE7__allocEv = Module["__ZNKSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE7__allocEv"] = createExportWrapper("_ZNKSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE8max_sizeERKSB_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE8max_sizeERKSB_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE8max_sizeERKSB_");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8capacityEv = Module["__ZNKSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE10__max_sizeENS_17integral_constantIbLb1EEERKSB_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE10__max_sizeENS_17integral_constantIbLb1EEERKSB_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE10__max_sizeENS_17integral_constantIbLb1EEERKSB_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE6secondEv = Module["__ZNKSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE6secondEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE8max_sizeEv = Module["__ZNKSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb1EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE9__end_capEv = Module["__ZNKSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE9__end_capEv"] = createExportWrapper("_ZNKSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEELi0ELb0EEC2IDnvEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEELi0ELb0EEC2IDnvEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEELi0ELb0EEC2IDnvEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRNS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEEEOT_RNS_16remove_referenceISD_E4typeE = Module["__ZNSt3__27forwardIRNS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEEEOT_RNS_16remove_referenceISD_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRNS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEEEOT_RNS_16remove_referenceISD_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb0EEC2ISC_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb0EEC2ISC_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb0EEC2ISC_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE8allocateEmPKv = Module["__ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE8allocateEmPKv"] = createExportWrapper("_ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE8allocateEmPKv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE6secondEv = Module["__ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE5firstEv = Module["__ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE4dataEv = Module["__ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE4dataEv"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE4dataEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE31__annotate_contiguous_containerEPKvSE_SE_SE_ = Module["__ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE31__annotate_contiguous_containerEPKvSE_SE_SE_"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE31__annotate_contiguous_containerEPKvSE_SE_SE_");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEONS_16remove_referenceIT_E4typeEOSD_ = Module["__ZNSt3__24moveIRPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEONS_16remove_referenceIT_E4typeEOSD_"] = createExportWrapper("_ZNSt3__24moveIRPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEONS_16remove_referenceIT_E4typeEOSD_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE17__destruct_at_endEPS9_ = Module["__ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE17__destruct_at_endEPS9_"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE17__destruct_at_endEPS9_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE10deallocateEPS9_m = Module["__ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE10deallocateEPS9_m"] = createExportWrapper("_ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE10deallocateEPS9_m");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE9__end_capEv = Module["__ZNKSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE9__end_capEv"] = createExportWrapper("_ZNKSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE17__destruct_at_endEPS9_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE17__destruct_at_endEPS9_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__214__split_bufferINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE17__destruct_at_endEPS9_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE7destroyISA_EEvRSB_PT_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE7destroyISA_EEvRSB_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE7destroyISA_EEvRSB_PT_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE9__destroyISA_EEvNS_17integral_constantIbLb1EEERSB_PT_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE9__destroyISA_EEvNS_17integral_constantIbLb1EEERSB_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEEE9__destroyISA_EEvNS_17integral_constantIbLb1EEERSB_PT_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE7destroyEPS9_ = Module["__ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE7destroyEPS9_"] = createExportWrapper("_ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE7destroyEPS9_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEERNS_9allocatorIS9_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE4baseEv = Module["__ZNKSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE4baseEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEE4baseEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPcS3_cLb1EE13__range_beginEPKc = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPcS3_cLb1EE13__range_beginEPKc"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPcS3_cLb1EE13__range_beginEPKc");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPcS3_cLb1EE11__range_endEPKc = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPcS3_cLb1EE11__range_endEPKc"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPcS3_cLb1EE11__range_endEPKc");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_14default_deleteIA_cEELi1ELb1EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_14default_deleteIA_cEELi1ELb1EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_14default_deleteIA_cEELi1ELb1EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEE5firstEv = Module["__ZNSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEE6secondEv = Module["__ZNSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPcNS_14default_deleteIA_cEEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__214default_deleteIA_cEclIcEENS2_20_EnableIfConvertibleIT_E4typeEPS5_ = Module["__ZNKSt3__214default_deleteIA_cEclIcEENS2_20_EnableIfConvertibleIT_E4typeEPS5_"] = createExportWrapper("_ZNKSt3__214default_deleteIA_cEclIcEENS2_20_EnableIfConvertibleIT_E4typeEPS5_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_14default_deleteIA_cEELi1ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_14default_deleteIA_cEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_14default_deleteIA_cEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem20__is_pathable_stringINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEvE13__range_beginERKS8_ = Module["__ZNSt3__24__fs10filesystem20__is_pathable_stringINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEvE13__range_beginERKS8_"] = createExportWrapper("_ZNSt3__24__fs10filesystem20__is_pathable_stringINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEvE13__range_beginERKS8_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem20__is_pathable_stringINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEvE11__range_endERKS8_ = Module["__ZNSt3__24__fs10filesystem20__is_pathable_stringINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEvE11__range_endERKS8_"] = createExportWrapper("_ZNSt3__24__fs10filesystem20__is_pathable_stringINS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEEvE11__range_endERKS8_");

/** @type {function(...*):?} */
var __ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6lengthEv = Module["__ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6lengthEv"] = createExportWrapper("_ZNKSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE6lengthEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPKcS4_cLb1EE13__range_beginES4_ = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPKcS4_cLb1EE13__range_beginES4_"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPKcS4_cLb1EE13__range_beginES4_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPKcS4_cLb1EE11__range_endES4_ = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPKcS4_cLb1EE11__range_endES4_"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIPKcS4_cLb1EE11__range_endES4_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA1_cPccLb1EE13__range_beginEPKc = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA1_cPccLb1EE13__range_beginEPKc"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA1_cPccLb1EE13__range_beginEPKc");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA1_cPccLb1EE11__range_endEPKc = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA1_cPccLb1EE11__range_endEPKc"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA1_cPccLb1EE11__range_endEPKc");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_17basic_string_viewIcNS_11char_traitsIcEEEELi0ELb0EEC2IDnvEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIPNS_17basic_string_viewIcNS_11char_traitsIcEEEELi0ELb0EEC2IDnvEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_17basic_string_viewIcNS_11char_traitsIcEEEELi0ELb0EEC2IDnvEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb1EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb1EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb1EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEC2Ev = Module["__ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEC2Ev"] = createExportWrapper("_ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEC2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE4dataEv = Module["__ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE4dataEv"] = createExportWrapper("_ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE4dataEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE8capacityEv = Module["__ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE4sizeEv = Module["__ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE4sizeEv"] = createExportWrapper("_ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE4sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE31__annotate_contiguous_containerEPKvS9_S9_S9_ = Module["__ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE31__annotate_contiguous_containerEPKvS9_S9_S9_"] = createExportWrapper("_ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE31__annotate_contiguous_containerEPKvS9_S9_S9_");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5clearEv = Module["__ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5clearEv"] = createExportWrapper("_ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5clearEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE7__allocEv = Module["__ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE7__allocEv"] = createExportWrapper("_ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE8capacityEv = Module["__ZNKSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE10deallocateERS6_PS5_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE10deallocateERS6_PS5_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE10deallocateERS6_PS5_m");

/** @type {function(...*):?} */
var __ZNSt3__212__to_addressINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEPT_S6_ = Module["__ZNSt3__212__to_addressINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEPT_S6_"] = createExportWrapper("_ZNSt3__212__to_addressINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEPT_S6_");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE9__end_capEv = Module["__ZNKSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE9__end_capEv"] = createExportWrapper("_ZNKSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemIPNS_17basic_string_viewIcNS_11char_traitsIcEEEELi0ELb0EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemIPNS_17basic_string_viewIcNS_11char_traitsIcEEEELi0ELb0EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemIPNS_17basic_string_viewIcNS_11char_traitsIcEEEELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE17__destruct_at_endEPS4_ = Module["__ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE17__destruct_at_endEPS4_"] = createExportWrapper("_ZNSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE17__destruct_at_endEPS4_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE10deallocateEPS4_m = Module["__ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE10deallocateEPS4_m"] = createExportWrapper("_ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE10deallocateEPS4_m");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE6secondEv = Module["__ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE7destroyIS5_EEvRS6_PT_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE7destroyIS5_EEvRS6_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE7destroyIS5_EEvRS6_PT_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE9__destroyIS5_EEvNS_17integral_constantIbLb1EEERS6_PT_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE9__destroyIS5_EEvNS_17integral_constantIbLb1EEERS6_PT_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE9__destroyIS5_EEvNS_17integral_constantIbLb1EEERS6_PT_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE7destroyEPS4_ = Module["__ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE7destroyEPS4_"] = createExportWrapper("_ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE7destroyEPS4_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb1EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5firstEv = Module["__ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE21_ConstructTransactionC2ERS7_m = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE21_ConstructTransactionC2ERS7_m"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE21_ConstructTransactionC2ERS7_m");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE9constructIS5_JS5_EEEvRS6_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE9constructIS5_JS5_EEEvRS6_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE9constructIS5_JS5_EEEvRS6_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE21_ConstructTransactionD2Ev = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE21_ConstructTransactionD2Ev"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE21_ConstructTransactionD2Ev");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE11__recommendEm = Module["__ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE11__recommendEm"] = createExportWrapper("_ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE11__recommendEm");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEEC2EmmS7_ = Module["__ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEEC2EmmS7_"] = createExportWrapper("_ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEEC2EmmS7_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS4_RS6_EE = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS4_RS6_EE"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE26__swap_out_circular_bufferERNS_14__split_bufferIS4_RS6_EE");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEED2Ev = Module["__ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEED2Ev"] = createExportWrapper("_ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEED2Ev");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIPNS_17basic_string_viewIcNS_11char_traitsIcEEEELi0ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIPNS_17basic_string_viewIcNS_11char_traitsIcEEEELi0ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIPNS_17basic_string_viewIcNS_11char_traitsIcEEEELi0ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE11__constructIS5_JS5_EEEvNS_17integral_constantIbLb1EEERS6_PT_DpOT0_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE11__constructIS5_JS5_EEEvNS_17integral_constantIbLb1EEERS6_PT_DpOT0_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE11__constructIS5_JS5_EEEvNS_17integral_constantIbLb1EEERS6_PT_DpOT0_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE9constructIS4_JS4_EEEvPT_DpOT0_ = Module["__ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE9constructIS4_JS4_EEEvPT_DpOT0_"] = createExportWrapper("_ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE9constructIS4_JS4_EEEvPT_DpOT0_");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE8max_sizeEv = Module["__ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEEC2IDnS8_EEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEEC2IDnS8_EEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEEC2IDnS8_EEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE7__allocEv = Module["__ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE7__allocEv"] = createExportWrapper("_ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE8allocateERS6_m = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE8allocateERS6_m"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE8allocateERS6_m");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE9__end_capEv = Module["__ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE9__end_capEv"] = createExportWrapper("_ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE46__construct_backward_with_exception_guaranteesIS5_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb1EE5valueEEntsr15__has_constructIS6_PT_SC_EE5valuesr31is_trivially_move_constructibleISC_EE5valueEvE4typeERS6_SD_SD_RSD_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE46__construct_backward_with_exception_guaranteesIS5_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb1EE5valueEEntsr15__has_constructIS6_PT_SC_EE5valuesr31is_trivially_move_constructibleISC_EE5valueEvE4typeERS6_SD_SD_RSD_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE46__construct_backward_with_exception_guaranteesIS5_EENS_9enable_ifIXaaooL_ZNS_17integral_constantIbLb1EE5valueEEntsr15__has_constructIS6_PT_SC_EE5valuesr31is_trivially_move_constructibleISC_EE5valueEvE4typeERS6_SD_SD_RSD_");

/** @type {function(...*):?} */
var __ZNSt3__24swapIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS7_EE5valueEvE4typeERS7_SA_ = Module["__ZNSt3__24swapIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS7_EE5valueEvE4typeERS7_SA_"] = createExportWrapper("_ZNSt3__24swapIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEENS_9enable_ifIXaasr21is_move_constructibleIT_EE5valuesr18is_move_assignableIS7_EE5valueEvE4typeERS7_SA_");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE14__annotate_newEm = Module["__ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE14__annotate_newEm"] = createExportWrapper("_ZNKSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE14__annotate_newEm");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE26__invalidate_all_iteratorsEv = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE26__invalidate_all_iteratorsEv"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE26__invalidate_all_iteratorsEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE5clearEv = Module["__ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE5clearEv"] = createExportWrapper("_ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE5clearEv");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE8capacityEv = Module["__ZNKSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE8capacityEv"] = createExportWrapper("_ZNKSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE8capacityEv");

/** @type {function(...*):?} */
var __ZNKSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE7__allocEv = Module["__ZNKSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE7__allocEv"] = createExportWrapper("_ZNKSt3__213__vector_baseINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE7__allocEv");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE8max_sizeERKS6_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE8max_sizeERKS6_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE8max_sizeERKS6_");

/** @type {function(...*):?} */
var __ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE10__max_sizeENS_17integral_constantIbLb1EEERKS6_ = Module["__ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE10__max_sizeENS_17integral_constantIbLb1EEERKS6_"] = createExportWrapper("_ZNSt3__216allocator_traitsINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEE10__max_sizeENS_17integral_constantIbLb1EEERKS6_");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE6secondEv = Module["__ZNKSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE6secondEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNKSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE8max_sizeEv = Module["__ZNKSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE8max_sizeEv"] = createExportWrapper("_ZNKSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE8max_sizeEv");

/** @type {function(...*):?} */
var __ZNKSt3__222__compressed_pair_elemINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb1EE5__getEv = Module["__ZNKSt3__222__compressed_pair_elemINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb1EE5__getEv"] = createExportWrapper("_ZNKSt3__222__compressed_pair_elemINS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb1EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRNS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEEOT_RNS_16remove_referenceIS8_E4typeE = Module["__ZNSt3__27forwardIRNS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEEOT_RNS_16remove_referenceIS8_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRNS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEEEEOT_RNS_16remove_referenceIS8_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb0EEC2IS7_vEEOT_ = Module["__ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb0EEC2IS7_vEEOT_"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb0EEC2IS7_vEEOT_");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE8allocateEmPKv = Module["__ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE8allocateEmPKv"] = createExportWrapper("_ZNSt3__29allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEE8allocateEmPKv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE6secondEv = Module["__ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE6secondEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE6secondEv");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE5firstEv = Module["__ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE5firstEv"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb0EE5__getEv = Module["__ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb0EE5__getEv"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemIRNS_9allocatorINS_17basic_string_viewIcNS_11char_traitsIcEEEEEELi1ELb0EE5__getEv");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEONS_16remove_referenceIT_E4typeEOS8_ = Module["__ZNSt3__24moveIRPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEONS_16remove_referenceIT_E4typeEOS8_"] = createExportWrapper("_ZNSt3__24moveIRPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEEONS_16remove_referenceIT_E4typeEOS8_");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_ = Module["__ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_"] = createExportWrapper("_ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_");

/** @type {function(...*):?} */
var __ZNKSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE9__end_capEv = Module["__ZNKSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE9__end_capEv"] = createExportWrapper("_ZNKSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE9__end_capEv");

/** @type {function(...*):?} */
var __ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_NS_17integral_constantIbLb0EEE = Module["__ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_NS_17integral_constantIbLb0EEE"] = createExportWrapper("_ZNSt3__214__split_bufferINS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE17__destruct_at_endEPS4_NS_17integral_constantIbLb0EEE");

/** @type {function(...*):?} */
var __ZNKSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE5firstEv = Module["__ZNKSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE5firstEv"] = createExportWrapper("_ZNKSt3__217__compressed_pairIPNS_17basic_string_viewIcNS_11char_traitsIcEEEERNS_9allocatorIS4_EEE5firstEv");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE11__make_iterEPS4_ = Module["__ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE11__make_iterEPS4_"] = createExportWrapper("_ZNSt3__26vectorINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_9allocatorIS4_EEE11__make_iterEPS4_");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEC2ES5_ = Module["__ZNSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEC2ES5_"] = createExportWrapper("_ZNSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEEC2ES5_");

/** @type {function(...*):?} */
var __ZNSt3__2eqIPNS_17basic_string_viewIcNS_11char_traitsIcEEEES5_EEbRKNS_11__wrap_iterIT_EERKNS6_IT0_EE = Module["__ZNSt3__2eqIPNS_17basic_string_viewIcNS_11char_traitsIcEEEES5_EEbRKNS_11__wrap_iterIT_EERKNS6_IT0_EE"] = createExportWrapper("_ZNSt3__2eqIPNS_17basic_string_viewIcNS_11char_traitsIcEEEES5_EEbRKNS_11__wrap_iterIT_EERKNS6_IT0_EE");

/** @type {function(...*):?} */
var __ZNKSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEE4baseEv = Module["__ZNKSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEE4baseEv"] = createExportWrapper("_ZNKSt3__211__wrap_iterIPNS_17basic_string_viewIcNS_11char_traitsIcEEEEE4baseEv");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem20__is_pathable_stringINS_17basic_string_viewIcNS_11char_traitsIcEEEEvE15__first_or_nullERKS6_ = Module["__ZNSt3__24__fs10filesystem20__is_pathable_stringINS_17basic_string_viewIcNS_11char_traitsIcEEEEvE15__first_or_nullERKS6_"] = createExportWrapper("_ZNSt3__24__fs10filesystem20__is_pathable_stringINS_17basic_string_viewIcNS_11char_traitsIcEEEEvE15__first_or_nullERKS6_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem4path20__source_is_absoluteIcEEbT_ = Module["__ZNSt3__24__fs10filesystem4path20__source_is_absoluteIcEEbT_"] = createExportWrapper("_ZNSt3__24__fs10filesystem4path20__source_is_absoluteIcEEbT_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem14__is_separatorIcEENS_9enable_ifIXsr18__can_convert_charIT_EE5valueEbE4typeES4_ = Module["__ZNSt3__24__fs10filesystem14__is_separatorIcEENS_9enable_ifIXsr18__can_convert_charIT_EE5valueEbE4typeES4_"] = createExportWrapper("_ZNSt3__24__fs10filesystem14__is_separatorIcEENS_9enable_ifIXsr18__can_convert_charIT_EE5valueEbE4typeES4_");

/** @type {function(...*):?} */
var __ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEEixEm = Module["__ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEEixEm"] = createExportWrapper("_ZNKSt3__217basic_string_viewIcNS_11char_traitsIcEEEixEm");

/** @type {function(...*):?} */
var __ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_ = Module["__ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_"] = createExportWrapper("_ZNSt3__217__compressed_pairIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEEC2IDnNS_18__default_init_tagEEEOT_OT0_");

/** @type {function(...*):?} */
var __ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb1EEC2ENS_18__default_init_tagE = Module["__ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb1EEC2ENS_18__default_init_tagE"] = createExportWrapper("_ZNSt3__222__compressed_pair_elemINS_9allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEELi1ELb1EEC2ENS_18__default_init_tagE");

/** @type {function(...*):?} */
var __ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEC2Ev = Module["__ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEC2Ev"] = createExportWrapper("_ZNSt3__29allocatorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEC2Ev");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5clearEv = Module["__ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5clearEv"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE5clearEv");

/** @type {function(...*):?} */
var __ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__destruct_at_endEPS9_ = Module["__ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__destruct_at_endEPS9_"] = createExportWrapper("_ZNSt3__213__vector_baseINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__destruct_at_endEPS9_");

/** @type {function(...*):?} */
var __ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE27__invalidate_iterators_pastEPS9_ = Module["__ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE27__invalidate_iterators_pastEPS9_"] = createExportWrapper("_ZNSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE27__invalidate_iterators_pastEPS9_");

/** @type {function(...*):?} */
var __ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__annotate_shrinkEm = Module["__ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__annotate_shrinkEm"] = createExportWrapper("_ZNKSt3__26vectorINS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEENS_9allocatorIS9_EEE17__annotate_shrinkEm");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA2_cPccLb1EE13__range_beginEPKc = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA2_cPccLb1EE13__range_beginEPKc"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA2_cPccLb1EE13__range_beginEPKc");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA2_cPccLb1EE11__range_endEPKc = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA2_cPccLb1EE11__range_endEPKc"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA2_cPccLb1EE11__range_endEPKc");

/** @type {function(...*):?} */
var __ZNSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEC2ESA_ = Module["__ZNSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEC2ESA_"] = createExportWrapper("_ZNSt3__211__wrap_iterIPNS_4pairINS_17basic_string_viewIcNS_11char_traitsIcEEEENS_4__fs10filesystem12PathPartKindEEEEC2ESA_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA1_cPccLb1EE15__first_or_nullEPKc = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA1_cPccLb1EE15__first_or_nullEPKc"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA1_cPccLb1EE15__first_or_nullEPKc");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA3_cPccLb1EE15__first_or_nullEPKc = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA3_cPccLb1EE15__first_or_nullEPKc"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA3_cPccLb1EE15__first_or_nullEPKc");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIA3_cEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_ = Module["__ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIA3_cEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_"] = createExportWrapper("_ZNSt3__24__fs10filesystem8_PathCVTIcE15__append_sourceIA3_cEEvRNS_12basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEEERKT_");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA3_cPccLb1EE13__range_beginEPKc = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA3_cPccLb1EE13__range_beginEPKc"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA3_cPccLb1EE13__range_beginEPKc");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA3_cPccLb1EE11__range_endEPKc = Module["__ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA3_cPccLb1EE11__range_endEPKc"] = createExportWrapper("_ZNSt3__24__fs10filesystem24__is_pathable_char_arrayIA3_cPccLb1EE11__range_endEPKc");

/** @type {function(...*):?} */
var __ZNSt3__24__fs10filesystem16filesystem_errorD1Ev = Module["__ZNSt3__24__fs10filesystem16filesystem_errorD1Ev"] = createExportWrapper("_ZNSt3__24__fs10filesystem16filesystem_errorD1Ev");

/** @type {function(...*):?} */
var _abort_message = Module["_abort_message"] = createExportWrapper("abort_message");

/** @type {function(...*):?} */
var ___cxa_bad_cast = Module["___cxa_bad_cast"] = createExportWrapper("__cxa_bad_cast");

/** @type {function(...*):?} */
var ___cxa_bad_typeid = Module["___cxa_bad_typeid"] = createExportWrapper("__cxa_bad_typeid");

/** @type {function(...*):?} */
var ___cxa_throw_bad_array_new_length = Module["___cxa_throw_bad_array_new_length"] = createExportWrapper("__cxa_throw_bad_array_new_length");

/** @type {function(...*):?} */
var __ZSt14set_unexpectedPFvvE = Module["__ZSt14set_unexpectedPFvvE"] = createExportWrapper("_ZSt14set_unexpectedPFvvE");

/** @type {function(...*):?} */
var __ZSt13set_terminatePFvvE = Module["__ZSt13set_terminatePFvvE"] = createExportWrapper("_ZSt13set_terminatePFvvE");

/** @type {function(...*):?} */
var ___cxa_demangle = Module["___cxa_demangle"] = createExportWrapper("__cxa_demangle");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA34_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA34_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA34_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__25equalIPKcS2_EEbT_S3_T0_ = Module["__ZNSt3__25equalIPKcS2_EEbT_S3_T0_"] = createExportWrapper("_ZNSt3__25equalIPKcS2_EEbT_S3_T0_");

/** @type {function(...*):?} */
var __ZNSt3__25equalIPKcS2_NS_10__equal_toIccEEEEbT_S5_T0_T1_ = Module["__ZNSt3__25equalIPKcS2_NS_10__equal_toIccEEEEbT_S5_T0_T1_"] = createExportWrapper("_ZNSt3__25equalIPKcS2_NS_10__equal_toIccEEEEbT_S5_T0_T1_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA12_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA12_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA12_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA9_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA9_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA9_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA14_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA14_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA14_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA19_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA19_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA19_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA27_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA27_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA27_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA41_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA41_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA41_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA18_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA18_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA18_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA22_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA22_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA22_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA20_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA20_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA20_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA25_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA25_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA25_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA4_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA4_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA4_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRmEEOT_RNS_16remove_referenceIS2_E4typeE = Module["__ZNSt3__27forwardIRmEEOT_RNS_16remove_referenceIS2_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRmEEOT_RNS_16remove_referenceIS2_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA5_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA5_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA5_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRbEEONS_16remove_referenceIT_E4typeEOS3_ = Module["__ZNSt3__24moveIRbEEONS_16remove_referenceIT_E4typeEOS3_"] = createExportWrapper("_ZNSt3__24moveIRbEEONS_16remove_referenceIT_E4typeEOS3_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA10_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA10_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA10_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA2_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA2_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA2_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA11_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA11_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA11_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRbEEOT_RNS_16remove_referenceIS2_E4typeE = Module["__ZNSt3__27forwardIRbEEOT_RNS_16remove_referenceIS2_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRbEEOT_RNS_16remove_referenceIS2_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIbEEOT_RNS_16remove_referenceIS1_E4typeE = Module["__ZNSt3__27forwardIbEEOT_RNS_16remove_referenceIS1_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIbEEOT_RNS_16remove_referenceIS1_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA13_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA13_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA13_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA3_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA3_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA3_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA17_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA17_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA17_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA6_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA6_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA6_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA8_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA8_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA8_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __Z6memchrUa9enable_ifIXLb1EEEPKvim = Module["__Z6memchrUa9enable_ifIXLb1EEEPKvim"] = createExportWrapper("_Z6memchrUa9enable_ifIXLb1EEEPKvim");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA16_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA16_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA16_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __Z15__libcpp_memchrPKvim = Module["__Z15__libcpp_memchrPKvim"] = createExportWrapper("_Z15__libcpp_memchrPKvim");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRjEEOT_RNS_16remove_referenceIS2_E4typeE = Module["__ZNSt3__27forwardIRjEEOT_RNS_16remove_referenceIS2_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRjEEOT_RNS_16remove_referenceIS2_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__23endIcLm21EEEPT_RAT0__S1_ = Module["__ZNSt3__23endIcLm21EEEPT_RAT0__S1_"] = createExportWrapper("_ZNSt3__23endIcLm21EEEPT_RAT0__S1_");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA15_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA15_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA15_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRiEEOT_RNS_16remove_referenceIS2_E4typeE = Module["__ZNSt3__27forwardIRiEEOT_RNS_16remove_referenceIS2_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRiEEOT_RNS_16remove_referenceIS2_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__27forwardIRA7_KcEEOT_RNS_16remove_referenceIS4_E4typeE = Module["__ZNSt3__27forwardIRA7_KcEEOT_RNS_16remove_referenceIS4_E4typeE"] = createExportWrapper("_ZNSt3__27forwardIRA7_KcEEOT_RNS_16remove_referenceIS4_E4typeE");

/** @type {function(...*):?} */
var __ZNSt3__24moveIRPKcEEONS_16remove_referenceIT_E4typeEOS5_ = Module["__ZNSt3__24moveIRPKcEEONS_16remove_referenceIT_E4typeEOS5_"] = createExportWrapper("_ZNSt3__24moveIRPKcEEONS_16remove_referenceIT_E4typeEOS5_");

/** @type {function(...*):?} */
var ___cxa_get_globals = Module["___cxa_get_globals"] = createExportWrapper("__cxa_get_globals");

/** @type {function(...*):?} */
var ___cxa_get_globals_fast = Module["___cxa_get_globals_fast"] = createExportWrapper("__cxa_get_globals_fast");

/** @type {function(...*):?} */
var ___cxa_guard_abort = Module["___cxa_guard_abort"] = createExportWrapper("__cxa_guard_abort");

/** @type {function(...*):?} */
var __ZSt14get_unexpectedv = Module["__ZSt14get_unexpectedv"] = createExportWrapper("_ZSt14get_unexpectedv");

/** @type {function(...*):?} */
var __ZSt12__unexpectedPFvvE = Module["__ZSt12__unexpectedPFvvE"] = createExportWrapper("_ZSt12__unexpectedPFvvE");

/** @type {function(...*):?} */
var __ZSt10unexpectedv = Module["__ZSt10unexpectedv"] = createExportWrapper("_ZSt10unexpectedv");

/** @type {function(...*):?} */
var __ZSt13get_terminatev = Module["__ZSt13get_terminatev"] = createExportWrapper("_ZSt13get_terminatev");

/** @type {function(...*):?} */
var __ZSt11__terminatePFvvE = Module["__ZSt11__terminatePFvvE"] = createExportWrapper("_ZSt11__terminatePFvvE");

/** @type {function(...*):?} */
var __ZSt15set_new_handlerPFvvE = Module["__ZSt15set_new_handlerPFvvE"] = createExportWrapper("_ZSt15set_new_handlerPFvvE");

/** @type {function(...*):?} */
var ___cxa_deleted_virtual = Module["___cxa_deleted_virtual"] = createExportWrapper("__cxa_deleted_virtual");

/** @type {function(...*):?} */
var __ZN10__cxxabiv130__aligned_malloc_with_fallbackEm = Module["__ZN10__cxxabiv130__aligned_malloc_with_fallbackEm"] = createExportWrapper("_ZN10__cxxabiv130__aligned_malloc_with_fallbackEm");

/** @type {function(...*):?} */
var __ZN10__cxxabiv122__calloc_with_fallbackEmm = Module["__ZN10__cxxabiv122__calloc_with_fallbackEmm"] = createExportWrapper("_ZN10__cxxabiv122__calloc_with_fallbackEmm");

/** @type {function(...*):?} */
var __ZN10__cxxabiv128__aligned_free_with_fallbackEPv = Module["__ZN10__cxxabiv128__aligned_free_with_fallbackEPv"] = createExportWrapper("_ZN10__cxxabiv128__aligned_free_with_fallbackEPv");

/** @type {function(...*):?} */
var __ZN10__cxxabiv120__free_with_fallbackEPv = Module["__ZN10__cxxabiv120__free_with_fallbackEPv"] = createExportWrapper("_ZN10__cxxabiv120__free_with_fallbackEPv");

/** @type {function(...*):?} */
var __ZNSt9exceptionD0Ev = Module["__ZNSt9exceptionD0Ev"] = createExportWrapper("_ZNSt9exceptionD0Ev");

/** @type {function(...*):?} */
var __ZNKSt9exception4whatEv = Module["__ZNKSt9exception4whatEv"] = createExportWrapper("_ZNKSt9exception4whatEv");

/** @type {function(...*):?} */
var __ZNSt13bad_exceptionD0Ev = Module["__ZNSt13bad_exceptionD0Ev"] = createExportWrapper("_ZNSt13bad_exceptionD0Ev");

/** @type {function(...*):?} */
var __ZNKSt13bad_exception4whatEv = Module["__ZNKSt13bad_exception4whatEv"] = createExportWrapper("_ZNKSt13bad_exception4whatEv");

/** @type {function(...*):?} */
var __ZNSt9bad_allocC2Ev = Module["__ZNSt9bad_allocC2Ev"] = createExportWrapper("_ZNSt9bad_allocC2Ev");

/** @type {function(...*):?} */
var __ZNSt9bad_allocD0Ev = Module["__ZNSt9bad_allocD0Ev"] = createExportWrapper("_ZNSt9bad_allocD0Ev");

/** @type {function(...*):?} */
var __ZNKSt9bad_alloc4whatEv = Module["__ZNKSt9bad_alloc4whatEv"] = createExportWrapper("_ZNKSt9bad_alloc4whatEv");

/** @type {function(...*):?} */
var __ZNSt20bad_array_new_lengthC2Ev = Module["__ZNSt20bad_array_new_lengthC2Ev"] = createExportWrapper("_ZNSt20bad_array_new_lengthC2Ev");

/** @type {function(...*):?} */
var __ZNSt20bad_array_new_lengthD0Ev = Module["__ZNSt20bad_array_new_lengthD0Ev"] = createExportWrapper("_ZNSt20bad_array_new_lengthD0Ev");

/** @type {function(...*):?} */
var __ZNKSt20bad_array_new_length4whatEv = Module["__ZNKSt20bad_array_new_length4whatEv"] = createExportWrapper("_ZNKSt20bad_array_new_length4whatEv");

/** @type {function(...*):?} */
var __ZNSt9exceptionD1Ev = Module["__ZNSt9exceptionD1Ev"] = createExportWrapper("_ZNSt9exceptionD1Ev");

/** @type {function(...*):?} */
var __ZNSt13bad_exceptionD2Ev = Module["__ZNSt13bad_exceptionD2Ev"] = createExportWrapper("_ZNSt13bad_exceptionD2Ev");

/** @type {function(...*):?} */
var __ZNSt13bad_exceptionD1Ev = Module["__ZNSt13bad_exceptionD1Ev"] = createExportWrapper("_ZNSt13bad_exceptionD1Ev");

/** @type {function(...*):?} */
var __ZNSt9bad_allocC1Ev = Module["__ZNSt9bad_allocC1Ev"] = createExportWrapper("_ZNSt9bad_allocC1Ev");

/** @type {function(...*):?} */
var __ZNSt9bad_allocD2Ev = Module["__ZNSt9bad_allocD2Ev"] = createExportWrapper("_ZNSt9bad_allocD2Ev");

/** @type {function(...*):?} */
var __ZNSt9bad_allocD1Ev = Module["__ZNSt9bad_allocD1Ev"] = createExportWrapper("_ZNSt9bad_allocD1Ev");

/** @type {function(...*):?} */
var __ZNSt20bad_array_new_lengthC1Ev = Module["__ZNSt20bad_array_new_lengthC1Ev"] = createExportWrapper("_ZNSt20bad_array_new_lengthC1Ev");

/** @type {function(...*):?} */
var __ZNSt20bad_array_new_lengthD2Ev = Module["__ZNSt20bad_array_new_lengthD2Ev"] = createExportWrapper("_ZNSt20bad_array_new_lengthD2Ev");

/** @type {function(...*):?} */
var __ZNSt20bad_array_new_lengthD1Ev = Module["__ZNSt20bad_array_new_lengthD1Ev"] = createExportWrapper("_ZNSt20bad_array_new_lengthD1Ev");

/** @type {function(...*):?} */
var __ZNSt3__218__libcpp_refstringD2Ev = Module["__ZNSt3__218__libcpp_refstringD2Ev"] = createExportWrapper("_ZNSt3__218__libcpp_refstringD2Ev");

/** @type {function(...*):?} */
var __ZNSt11logic_errorD0Ev = Module["__ZNSt11logic_errorD0Ev"] = createExportWrapper("_ZNSt11logic_errorD0Ev");

/** @type {function(...*):?} */
var __ZNKSt3__218__libcpp_refstring5c_strEv = Module["__ZNKSt3__218__libcpp_refstring5c_strEv"] = createExportWrapper("_ZNKSt3__218__libcpp_refstring5c_strEv");

/** @type {function(...*):?} */
var __ZNSt13runtime_errorD0Ev = Module["__ZNSt13runtime_errorD0Ev"] = createExportWrapper("_ZNSt13runtime_errorD0Ev");

/** @type {function(...*):?} */
var __ZNSt12domain_errorD0Ev = Module["__ZNSt12domain_errorD0Ev"] = createExportWrapper("_ZNSt12domain_errorD0Ev");

/** @type {function(...*):?} */
var __ZNSt16invalid_argumentD0Ev = Module["__ZNSt16invalid_argumentD0Ev"] = createExportWrapper("_ZNSt16invalid_argumentD0Ev");

/** @type {function(...*):?} */
var __ZNSt12length_errorD0Ev = Module["__ZNSt12length_errorD0Ev"] = createExportWrapper("_ZNSt12length_errorD0Ev");

/** @type {function(...*):?} */
var __ZNSt12out_of_rangeD0Ev = Module["__ZNSt12out_of_rangeD0Ev"] = createExportWrapper("_ZNSt12out_of_rangeD0Ev");

/** @type {function(...*):?} */
var __ZNSt11range_errorD0Ev = Module["__ZNSt11range_errorD0Ev"] = createExportWrapper("_ZNSt11range_errorD0Ev");

/** @type {function(...*):?} */
var __ZNSt14overflow_errorD0Ev = Module["__ZNSt14overflow_errorD0Ev"] = createExportWrapper("_ZNSt14overflow_errorD0Ev");

/** @type {function(...*):?} */
var __ZNSt15underflow_errorD0Ev = Module["__ZNSt15underflow_errorD0Ev"] = createExportWrapper("_ZNSt15underflow_errorD0Ev");

/** @type {function(...*):?} */
var __ZNSt11logic_errorD1Ev = Module["__ZNSt11logic_errorD1Ev"] = createExportWrapper("_ZNSt11logic_errorD1Ev");

/** @type {function(...*):?} */
var __ZNSt13runtime_errorD1Ev = Module["__ZNSt13runtime_errorD1Ev"] = createExportWrapper("_ZNSt13runtime_errorD1Ev");

/** @type {function(...*):?} */
var __ZNSt12domain_errorD2Ev = Module["__ZNSt12domain_errorD2Ev"] = createExportWrapper("_ZNSt12domain_errorD2Ev");

/** @type {function(...*):?} */
var __ZNSt12domain_errorD1Ev = Module["__ZNSt12domain_errorD1Ev"] = createExportWrapper("_ZNSt12domain_errorD1Ev");

/** @type {function(...*):?} */
var __ZNSt16invalid_argumentD2Ev = Module["__ZNSt16invalid_argumentD2Ev"] = createExportWrapper("_ZNSt16invalid_argumentD2Ev");

/** @type {function(...*):?} */
var __ZNSt16invalid_argumentD1Ev = Module["__ZNSt16invalid_argumentD1Ev"] = createExportWrapper("_ZNSt16invalid_argumentD1Ev");

/** @type {function(...*):?} */
var __ZNSt12length_errorD2Ev = Module["__ZNSt12length_errorD2Ev"] = createExportWrapper("_ZNSt12length_errorD2Ev");

/** @type {function(...*):?} */
var __ZNSt12length_errorD1Ev = Module["__ZNSt12length_errorD1Ev"] = createExportWrapper("_ZNSt12length_errorD1Ev");

/** @type {function(...*):?} */
var __ZNSt12out_of_rangeD2Ev = Module["__ZNSt12out_of_rangeD2Ev"] = createExportWrapper("_ZNSt12out_of_rangeD2Ev");

/** @type {function(...*):?} */
var __ZNSt12out_of_rangeD1Ev = Module["__ZNSt12out_of_rangeD1Ev"] = createExportWrapper("_ZNSt12out_of_rangeD1Ev");

/** @type {function(...*):?} */
var __ZNSt11range_errorD2Ev = Module["__ZNSt11range_errorD2Ev"] = createExportWrapper("_ZNSt11range_errorD2Ev");

/** @type {function(...*):?} */
var __ZNSt11range_errorD1Ev = Module["__ZNSt11range_errorD1Ev"] = createExportWrapper("_ZNSt11range_errorD1Ev");

/** @type {function(...*):?} */
var __ZNSt14overflow_errorD2Ev = Module["__ZNSt14overflow_errorD2Ev"] = createExportWrapper("_ZNSt14overflow_errorD2Ev");

/** @type {function(...*):?} */
var __ZNSt14overflow_errorD1Ev = Module["__ZNSt14overflow_errorD1Ev"] = createExportWrapper("_ZNSt14overflow_errorD1Ev");

/** @type {function(...*):?} */
var __ZNSt15underflow_errorD2Ev = Module["__ZNSt15underflow_errorD2Ev"] = createExportWrapper("_ZNSt15underflow_errorD2Ev");

/** @type {function(...*):?} */
var __ZNSt15underflow_errorD1Ev = Module["__ZNSt15underflow_errorD1Ev"] = createExportWrapper("_ZNSt15underflow_errorD1Ev");

/** @type {function(...*):?} */
var __ZNSt9type_infoD2Ev = Module["__ZNSt9type_infoD2Ev"] = createExportWrapper("_ZNSt9type_infoD2Ev");

/** @type {function(...*):?} */
var __ZNSt9type_infoD0Ev = Module["__ZNSt9type_infoD0Ev"] = createExportWrapper("_ZNSt9type_infoD0Ev");

/** @type {function(...*):?} */
var __ZNSt8bad_castC2Ev = Module["__ZNSt8bad_castC2Ev"] = createExportWrapper("_ZNSt8bad_castC2Ev");

/** @type {function(...*):?} */
var __ZNSt8bad_castD0Ev = Module["__ZNSt8bad_castD0Ev"] = createExportWrapper("_ZNSt8bad_castD0Ev");

/** @type {function(...*):?} */
var __ZNKSt8bad_cast4whatEv = Module["__ZNKSt8bad_cast4whatEv"] = createExportWrapper("_ZNKSt8bad_cast4whatEv");

/** @type {function(...*):?} */
var __ZNSt10bad_typeidC2Ev = Module["__ZNSt10bad_typeidC2Ev"] = createExportWrapper("_ZNSt10bad_typeidC2Ev");

/** @type {function(...*):?} */
var __ZNSt10bad_typeidD2Ev = Module["__ZNSt10bad_typeidD2Ev"] = createExportWrapper("_ZNSt10bad_typeidD2Ev");

/** @type {function(...*):?} */
var __ZNSt10bad_typeidD0Ev = Module["__ZNSt10bad_typeidD0Ev"] = createExportWrapper("_ZNSt10bad_typeidD0Ev");

/** @type {function(...*):?} */
var __ZNKSt10bad_typeid4whatEv = Module["__ZNKSt10bad_typeid4whatEv"] = createExportWrapper("_ZNKSt10bad_typeid4whatEv");

/** @type {function(...*):?} */
var __ZNSt9type_infoD1Ev = Module["__ZNSt9type_infoD1Ev"] = createExportWrapper("_ZNSt9type_infoD1Ev");

/** @type {function(...*):?} */
var __ZNSt8bad_castC1Ev = Module["__ZNSt8bad_castC1Ev"] = createExportWrapper("_ZNSt8bad_castC1Ev");

/** @type {function(...*):?} */
var __ZNSt8bad_castD1Ev = Module["__ZNSt8bad_castD1Ev"] = createExportWrapper("_ZNSt8bad_castD1Ev");

/** @type {function(...*):?} */
var __ZNSt10bad_typeidC1Ev = Module["__ZNSt10bad_typeidC1Ev"] = createExportWrapper("_ZNSt10bad_typeidC1Ev");

/** @type {function(...*):?} */
var __ZNSt10bad_typeidD1Ev = Module["__ZNSt10bad_typeidD1Ev"] = createExportWrapper("_ZNSt10bad_typeidD1Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv116__shim_type_infoD2Ev = Module["__ZN10__cxxabiv116__shim_type_infoD2Ev"] = createExportWrapper("_ZN10__cxxabiv116__shim_type_infoD2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv116__shim_type_infoD0Ev = Module["__ZN10__cxxabiv116__shim_type_infoD0Ev"] = createExportWrapper("_ZN10__cxxabiv116__shim_type_infoD0Ev");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv116__shim_type_info5noop1Ev = Module["__ZNK10__cxxabiv116__shim_type_info5noop1Ev"] = createExportWrapper("_ZNK10__cxxabiv116__shim_type_info5noop1Ev");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv116__shim_type_info5noop2Ev = Module["__ZNK10__cxxabiv116__shim_type_info5noop2Ev"] = createExportWrapper("_ZNK10__cxxabiv116__shim_type_info5noop2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv123__fundamental_type_infoD0Ev = Module["__ZN10__cxxabiv123__fundamental_type_infoD0Ev"] = createExportWrapper("_ZN10__cxxabiv123__fundamental_type_infoD0Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv117__array_type_infoD0Ev = Module["__ZN10__cxxabiv117__array_type_infoD0Ev"] = createExportWrapper("_ZN10__cxxabiv117__array_type_infoD0Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv120__function_type_infoD0Ev = Module["__ZN10__cxxabiv120__function_type_infoD0Ev"] = createExportWrapper("_ZN10__cxxabiv120__function_type_infoD0Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv116__enum_type_infoD0Ev = Module["__ZN10__cxxabiv116__enum_type_infoD0Ev"] = createExportWrapper("_ZN10__cxxabiv116__enum_type_infoD0Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv117__class_type_infoD0Ev = Module["__ZN10__cxxabiv117__class_type_infoD0Ev"] = createExportWrapper("_ZN10__cxxabiv117__class_type_infoD0Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv120__si_class_type_infoD0Ev = Module["__ZN10__cxxabiv120__si_class_type_infoD0Ev"] = createExportWrapper("_ZN10__cxxabiv120__si_class_type_infoD0Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv121__vmi_class_type_infoD0Ev = Module["__ZN10__cxxabiv121__vmi_class_type_infoD0Ev"] = createExportWrapper("_ZN10__cxxabiv121__vmi_class_type_infoD0Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv117__pbase_type_infoD0Ev = Module["__ZN10__cxxabiv117__pbase_type_infoD0Ev"] = createExportWrapper("_ZN10__cxxabiv117__pbase_type_infoD0Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv119__pointer_type_infoD0Ev = Module["__ZN10__cxxabiv119__pointer_type_infoD0Ev"] = createExportWrapper("_ZN10__cxxabiv119__pointer_type_infoD0Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv129__pointer_to_member_type_infoD0Ev = Module["__ZN10__cxxabiv129__pointer_to_member_type_infoD0Ev"] = createExportWrapper("_ZN10__cxxabiv129__pointer_to_member_type_infoD0Ev");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv123__fundamental_type_info9can_catchEPKNS_16__shim_type_infoERPv = Module["__ZNK10__cxxabiv123__fundamental_type_info9can_catchEPKNS_16__shim_type_infoERPv"] = createExportWrapper("_ZNK10__cxxabiv123__fundamental_type_info9can_catchEPKNS_16__shim_type_infoERPv");

/** @type {function(...*):?} */
var __ZNKSt9type_infoeqERKS_ = Module["__ZNKSt9type_infoeqERKS_"] = createExportWrapper("_ZNKSt9type_infoeqERKS_");

/** @type {function(...*):?} */
var __ZNKSt9type_info4nameEv = Module["__ZNKSt9type_info4nameEv"] = createExportWrapper("_ZNKSt9type_info4nameEv");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv117__array_type_info9can_catchEPKNS_16__shim_type_infoERPv = Module["__ZNK10__cxxabiv117__array_type_info9can_catchEPKNS_16__shim_type_infoERPv"] = createExportWrapper("_ZNK10__cxxabiv117__array_type_info9can_catchEPKNS_16__shim_type_infoERPv");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv120__function_type_info9can_catchEPKNS_16__shim_type_infoERPv = Module["__ZNK10__cxxabiv120__function_type_info9can_catchEPKNS_16__shim_type_infoERPv"] = createExportWrapper("_ZNK10__cxxabiv120__function_type_info9can_catchEPKNS_16__shim_type_infoERPv");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv116__enum_type_info9can_catchEPKNS_16__shim_type_infoERPv = Module["__ZNK10__cxxabiv116__enum_type_info9can_catchEPKNS_16__shim_type_infoERPv"] = createExportWrapper("_ZNK10__cxxabiv116__enum_type_info9can_catchEPKNS_16__shim_type_infoERPv");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv117__class_type_info9can_catchEPKNS_16__shim_type_infoERPv = Module["__ZNK10__cxxabiv117__class_type_info9can_catchEPKNS_16__shim_type_infoERPv"] = createExportWrapper("_ZNK10__cxxabiv117__class_type_info9can_catchEPKNS_16__shim_type_infoERPv");

/** @type {function(...*):?} */
var ___dynamic_cast = Module["___dynamic_cast"] = createExportWrapper("__dynamic_cast");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv117__class_type_info24process_found_base_classEPNS_19__dynamic_cast_infoEPvi = Module["__ZNK10__cxxabiv117__class_type_info24process_found_base_classEPNS_19__dynamic_cast_infoEPvi"] = createExportWrapper("_ZNK10__cxxabiv117__class_type_info24process_found_base_classEPNS_19__dynamic_cast_infoEPvi");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv117__class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi = Module["__ZNK10__cxxabiv117__class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi"] = createExportWrapper("_ZNK10__cxxabiv117__class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv120__si_class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi = Module["__ZNK10__cxxabiv120__si_class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi"] = createExportWrapper("_ZNK10__cxxabiv120__si_class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv122__base_class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi = Module["__ZNK10__cxxabiv122__base_class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi"] = createExportWrapper("_ZNK10__cxxabiv122__base_class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv121__vmi_class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi = Module["__ZNK10__cxxabiv121__vmi_class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi"] = createExportWrapper("_ZNK10__cxxabiv121__vmi_class_type_info27has_unambiguous_public_baseEPNS_19__dynamic_cast_infoEPvi");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv117__pbase_type_info9can_catchEPKNS_16__shim_type_infoERPv = Module["__ZNK10__cxxabiv117__pbase_type_info9can_catchEPKNS_16__shim_type_infoERPv"] = createExportWrapper("_ZNK10__cxxabiv117__pbase_type_info9can_catchEPKNS_16__shim_type_infoERPv");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv119__pointer_type_info9can_catchEPKNS_16__shim_type_infoERPv = Module["__ZNK10__cxxabiv119__pointer_type_info9can_catchEPKNS_16__shim_type_infoERPv"] = createExportWrapper("_ZNK10__cxxabiv119__pointer_type_info9can_catchEPKNS_16__shim_type_infoERPv");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv119__pointer_type_info16can_catch_nestedEPKNS_16__shim_type_infoE = Module["__ZNK10__cxxabiv119__pointer_type_info16can_catch_nestedEPKNS_16__shim_type_infoE"] = createExportWrapper("_ZNK10__cxxabiv119__pointer_type_info16can_catch_nestedEPKNS_16__shim_type_infoE");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv129__pointer_to_member_type_info16can_catch_nestedEPKNS_16__shim_type_infoE = Module["__ZNK10__cxxabiv129__pointer_to_member_type_info16can_catch_nestedEPKNS_16__shim_type_infoE"] = createExportWrapper("_ZNK10__cxxabiv129__pointer_to_member_type_info16can_catch_nestedEPKNS_16__shim_type_infoE");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv129__pointer_to_member_type_info9can_catchEPKNS_16__shim_type_infoERPv = Module["__ZNK10__cxxabiv129__pointer_to_member_type_info9can_catchEPKNS_16__shim_type_infoERPv"] = createExportWrapper("_ZNK10__cxxabiv129__pointer_to_member_type_info9can_catchEPKNS_16__shim_type_infoERPv");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv117__class_type_info29process_static_type_above_dstEPNS_19__dynamic_cast_infoEPKvS4_i = Module["__ZNK10__cxxabiv117__class_type_info29process_static_type_above_dstEPNS_19__dynamic_cast_infoEPKvS4_i"] = createExportWrapper("_ZNK10__cxxabiv117__class_type_info29process_static_type_above_dstEPNS_19__dynamic_cast_infoEPKvS4_i");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv117__class_type_info29process_static_type_below_dstEPNS_19__dynamic_cast_infoEPKvi = Module["__ZNK10__cxxabiv117__class_type_info29process_static_type_below_dstEPNS_19__dynamic_cast_infoEPKvi"] = createExportWrapper("_ZNK10__cxxabiv117__class_type_info29process_static_type_below_dstEPNS_19__dynamic_cast_infoEPKvi");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv121__vmi_class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib = Module["__ZNK10__cxxabiv121__vmi_class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib"] = createExportWrapper("_ZNK10__cxxabiv121__vmi_class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv122__base_class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib = Module["__ZNK10__cxxabiv122__base_class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib"] = createExportWrapper("_ZNK10__cxxabiv122__base_class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv122__base_class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib = Module["__ZNK10__cxxabiv122__base_class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib"] = createExportWrapper("_ZNK10__cxxabiv122__base_class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv120__si_class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib = Module["__ZNK10__cxxabiv120__si_class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib"] = createExportWrapper("_ZNK10__cxxabiv120__si_class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv117__class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib = Module["__ZNK10__cxxabiv117__class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib"] = createExportWrapper("_ZNK10__cxxabiv117__class_type_info16search_below_dstEPNS_19__dynamic_cast_infoEPKvib");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv121__vmi_class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib = Module["__ZNK10__cxxabiv121__vmi_class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib"] = createExportWrapper("_ZNK10__cxxabiv121__vmi_class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv120__si_class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib = Module["__ZNK10__cxxabiv120__si_class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib"] = createExportWrapper("_ZNK10__cxxabiv120__si_class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib");

/** @type {function(...*):?} */
var __ZNK10__cxxabiv117__class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib = Module["__ZNK10__cxxabiv117__class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib"] = createExportWrapper("_ZNK10__cxxabiv117__class_type_info16search_above_dstEPNS_19__dynamic_cast_infoEPKvS4_ib");

/** @type {function(...*):?} */
var __ZN10__cxxabiv116__shim_type_infoD1Ev = Module["__ZN10__cxxabiv116__shim_type_infoD1Ev"] = createExportWrapper("_ZN10__cxxabiv116__shim_type_infoD1Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv123__fundamental_type_infoD2Ev = Module["__ZN10__cxxabiv123__fundamental_type_infoD2Ev"] = createExportWrapper("_ZN10__cxxabiv123__fundamental_type_infoD2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv123__fundamental_type_infoD1Ev = Module["__ZN10__cxxabiv123__fundamental_type_infoD1Ev"] = createExportWrapper("_ZN10__cxxabiv123__fundamental_type_infoD1Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv117__array_type_infoD2Ev = Module["__ZN10__cxxabiv117__array_type_infoD2Ev"] = createExportWrapper("_ZN10__cxxabiv117__array_type_infoD2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv117__array_type_infoD1Ev = Module["__ZN10__cxxabiv117__array_type_infoD1Ev"] = createExportWrapper("_ZN10__cxxabiv117__array_type_infoD1Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv120__function_type_infoD2Ev = Module["__ZN10__cxxabiv120__function_type_infoD2Ev"] = createExportWrapper("_ZN10__cxxabiv120__function_type_infoD2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv120__function_type_infoD1Ev = Module["__ZN10__cxxabiv120__function_type_infoD1Ev"] = createExportWrapper("_ZN10__cxxabiv120__function_type_infoD1Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv116__enum_type_infoD2Ev = Module["__ZN10__cxxabiv116__enum_type_infoD2Ev"] = createExportWrapper("_ZN10__cxxabiv116__enum_type_infoD2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv116__enum_type_infoD1Ev = Module["__ZN10__cxxabiv116__enum_type_infoD1Ev"] = createExportWrapper("_ZN10__cxxabiv116__enum_type_infoD1Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv117__class_type_infoD2Ev = Module["__ZN10__cxxabiv117__class_type_infoD2Ev"] = createExportWrapper("_ZN10__cxxabiv117__class_type_infoD2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv117__class_type_infoD1Ev = Module["__ZN10__cxxabiv117__class_type_infoD1Ev"] = createExportWrapper("_ZN10__cxxabiv117__class_type_infoD1Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv120__si_class_type_infoD2Ev = Module["__ZN10__cxxabiv120__si_class_type_infoD2Ev"] = createExportWrapper("_ZN10__cxxabiv120__si_class_type_infoD2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv120__si_class_type_infoD1Ev = Module["__ZN10__cxxabiv120__si_class_type_infoD1Ev"] = createExportWrapper("_ZN10__cxxabiv120__si_class_type_infoD1Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv121__vmi_class_type_infoD2Ev = Module["__ZN10__cxxabiv121__vmi_class_type_infoD2Ev"] = createExportWrapper("_ZN10__cxxabiv121__vmi_class_type_infoD2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv121__vmi_class_type_infoD1Ev = Module["__ZN10__cxxabiv121__vmi_class_type_infoD1Ev"] = createExportWrapper("_ZN10__cxxabiv121__vmi_class_type_infoD1Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv117__pbase_type_infoD2Ev = Module["__ZN10__cxxabiv117__pbase_type_infoD2Ev"] = createExportWrapper("_ZN10__cxxabiv117__pbase_type_infoD2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv117__pbase_type_infoD1Ev = Module["__ZN10__cxxabiv117__pbase_type_infoD1Ev"] = createExportWrapper("_ZN10__cxxabiv117__pbase_type_infoD1Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv119__pointer_type_infoD2Ev = Module["__ZN10__cxxabiv119__pointer_type_infoD2Ev"] = createExportWrapper("_ZN10__cxxabiv119__pointer_type_infoD2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv119__pointer_type_infoD1Ev = Module["__ZN10__cxxabiv119__pointer_type_infoD1Ev"] = createExportWrapper("_ZN10__cxxabiv119__pointer_type_infoD1Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv129__pointer_to_member_type_infoD2Ev = Module["__ZN10__cxxabiv129__pointer_to_member_type_infoD2Ev"] = createExportWrapper("_ZN10__cxxabiv129__pointer_to_member_type_infoD2Ev");

/** @type {function(...*):?} */
var __ZN10__cxxabiv129__pointer_to_member_type_infoD1Ev = Module["__ZN10__cxxabiv129__pointer_to_member_type_infoD1Ev"] = createExportWrapper("_ZN10__cxxabiv129__pointer_to_member_type_infoD1Ev");

/** @type {function(...*):?} */
var ___cxa_uncaught_exception = Module["___cxa_uncaught_exception"] = createExportWrapper("__cxa_uncaught_exception");

/** @type {function(...*):?} */
var __ZN10__cxxabiv119__getExceptionClassEPK17_Unwind_Exception = Module["__ZN10__cxxabiv119__getExceptionClassEPK17_Unwind_Exception"] = createExportWrapper("_ZN10__cxxabiv119__getExceptionClassEPK17_Unwind_Exception");

/** @type {function(...*):?} */
var __ZN10__cxxabiv119__setExceptionClassEP17_Unwind_Exceptiony = Module["__ZN10__cxxabiv119__setExceptionClassEP17_Unwind_Exceptiony"] = createExportWrapper("_ZN10__cxxabiv119__setExceptionClassEP17_Unwind_Exceptiony");

/** @type {function(...*):?} */
var __ZN10__cxxabiv121__isOurExceptionClassEPK17_Unwind_Exception = Module["__ZN10__cxxabiv121__isOurExceptionClassEPK17_Unwind_Exception"] = createExportWrapper("_ZN10__cxxabiv121__isOurExceptionClassEPK17_Unwind_Exception");

/** @type {function(...*):?} */
var _sbrk = Module["_sbrk"] = createExportWrapper("sbrk");

/** @type {function(...*):?} */
var _realloc_in_place = Module["_realloc_in_place"] = createExportWrapper("realloc_in_place");

/** @type {function(...*):?} */
var _memalign = Module["_memalign"] = createExportWrapper("memalign");

/** @type {function(...*):?} */
var _valloc = Module["_valloc"] = createExportWrapper("valloc");

/** @type {function(...*):?} */
var _pvalloc = Module["_pvalloc"] = createExportWrapper("pvalloc");

/** @type {function(...*):?} */
var _mallinfo = Module["_mallinfo"] = createExportWrapper("mallinfo");

/** @type {function(...*):?} */
var _mallopt = Module["_mallopt"] = createExportWrapper("mallopt");

/** @type {function(...*):?} */
var _malloc_trim = Module["_malloc_trim"] = createExportWrapper("malloc_trim");

/** @type {function(...*):?} */
var _malloc_usable_size = Module["_malloc_usable_size"] = createExportWrapper("malloc_usable_size");

/** @type {function(...*):?} */
var _malloc_footprint = Module["_malloc_footprint"] = createExportWrapper("malloc_footprint");

/** @type {function(...*):?} */
var _malloc_max_footprint = Module["_malloc_max_footprint"] = createExportWrapper("malloc_max_footprint");

/** @type {function(...*):?} */
var _malloc_footprint_limit = Module["_malloc_footprint_limit"] = createExportWrapper("malloc_footprint_limit");

/** @type {function(...*):?} */
var _malloc_set_footprint_limit = Module["_malloc_set_footprint_limit"] = createExportWrapper("malloc_set_footprint_limit");

/** @type {function(...*):?} */
var _independent_calloc = Module["_independent_calloc"] = createExportWrapper("independent_calloc");

/** @type {function(...*):?} */
var _independent_comalloc = Module["_independent_comalloc"] = createExportWrapper("independent_comalloc");

/** @type {function(...*):?} */
var _bulk_free = Module["_bulk_free"] = createExportWrapper("bulk_free");

/** @type {function(...*):?} */
var _emscripten_builtin_malloc = Module["_emscripten_builtin_malloc"] = createExportWrapper("emscripten_builtin_malloc");

/** @type {function(...*):?} */
var _emscripten_builtin_free = Module["_emscripten_builtin_free"] = createExportWrapper("emscripten_builtin_free");

/** @type {function(...*):?} */
var _emscripten_builtin_memalign = Module["_emscripten_builtin_memalign"] = createExportWrapper("emscripten_builtin_memalign");

/** @type {function(...*):?} */
var _brk = Module["_brk"] = createExportWrapper("brk");

/** @type {function(...*):?} */
var _emscripten_has_threading_support = Module["_emscripten_has_threading_support"] = createExportWrapper("emscripten_has_threading_support");

/** @type {function(...*):?} */
var _emscripten_num_logical_cores = Module["_emscripten_num_logical_cores"] = createExportWrapper("emscripten_num_logical_cores");

/** @type {function(...*):?} */
var _emscripten_force_num_logical_cores = Module["_emscripten_force_num_logical_cores"] = createExportWrapper("emscripten_force_num_logical_cores");

/** @type {function(...*):?} */
var _emscripten_atomic_exchange_u8 = Module["_emscripten_atomic_exchange_u8"] = createExportWrapper("emscripten_atomic_exchange_u8");

/** @type {function(...*):?} */
var _emscripten_atomic_exchange_u16 = Module["_emscripten_atomic_exchange_u16"] = createExportWrapper("emscripten_atomic_exchange_u16");

/** @type {function(...*):?} */
var _emscripten_atomic_exchange_u32 = Module["_emscripten_atomic_exchange_u32"] = createExportWrapper("emscripten_atomic_exchange_u32");

/** @type {function(...*):?} */
var _emscripten_atomic_exchange_u64 = Module["_emscripten_atomic_exchange_u64"] = createExportWrapper("emscripten_atomic_exchange_u64");

/** @type {function(...*):?} */
var _emscripten_atomic_cas_u8 = Module["_emscripten_atomic_cas_u8"] = createExportWrapper("emscripten_atomic_cas_u8");

/** @type {function(...*):?} */
var _emscripten_atomic_cas_u16 = Module["_emscripten_atomic_cas_u16"] = createExportWrapper("emscripten_atomic_cas_u16");

/** @type {function(...*):?} */
var _emscripten_atomic_cas_u32 = Module["_emscripten_atomic_cas_u32"] = createExportWrapper("emscripten_atomic_cas_u32");

/** @type {function(...*):?} */
var _emscripten_atomic_cas_u64 = Module["_emscripten_atomic_cas_u64"] = createExportWrapper("emscripten_atomic_cas_u64");

/** @type {function(...*):?} */
var _emscripten_atomic_load_u8 = Module["_emscripten_atomic_load_u8"] = createExportWrapper("emscripten_atomic_load_u8");

/** @type {function(...*):?} */
var _emscripten_atomic_load_u16 = Module["_emscripten_atomic_load_u16"] = createExportWrapper("emscripten_atomic_load_u16");

/** @type {function(...*):?} */
var _emscripten_atomic_load_u32 = Module["_emscripten_atomic_load_u32"] = createExportWrapper("emscripten_atomic_load_u32");

/** @type {function(...*):?} */
var _emscripten_atomic_load_f32 = Module["_emscripten_atomic_load_f32"] = createExportWrapper("emscripten_atomic_load_f32");

/** @type {function(...*):?} */
var _emscripten_atomic_load_u64 = Module["_emscripten_atomic_load_u64"] = createExportWrapper("emscripten_atomic_load_u64");

/** @type {function(...*):?} */
var _emscripten_atomic_load_f64 = Module["_emscripten_atomic_load_f64"] = createExportWrapper("emscripten_atomic_load_f64");

/** @type {function(...*):?} */
var _emscripten_atomic_store_u8 = Module["_emscripten_atomic_store_u8"] = createExportWrapper("emscripten_atomic_store_u8");

/** @type {function(...*):?} */
var _emscripten_atomic_store_u16 = Module["_emscripten_atomic_store_u16"] = createExportWrapper("emscripten_atomic_store_u16");

/** @type {function(...*):?} */
var _emscripten_atomic_store_u32 = Module["_emscripten_atomic_store_u32"] = createExportWrapper("emscripten_atomic_store_u32");

/** @type {function(...*):?} */
var _emscripten_atomic_store_f32 = Module["_emscripten_atomic_store_f32"] = createExportWrapper("emscripten_atomic_store_f32");

/** @type {function(...*):?} */
var _emscripten_atomic_store_u64 = Module["_emscripten_atomic_store_u64"] = createExportWrapper("emscripten_atomic_store_u64");

/** @type {function(...*):?} */
var _emscripten_atomic_store_f64 = Module["_emscripten_atomic_store_f64"] = createExportWrapper("emscripten_atomic_store_f64");

/** @type {function(...*):?} */
var _emscripten_atomic_fence = Module["_emscripten_atomic_fence"] = createExportWrapper("emscripten_atomic_fence");

/** @type {function(...*):?} */
var _emscripten_atomic_add_u8 = Module["_emscripten_atomic_add_u8"] = createExportWrapper("emscripten_atomic_add_u8");

/** @type {function(...*):?} */
var _emscripten_atomic_add_u16 = Module["_emscripten_atomic_add_u16"] = createExportWrapper("emscripten_atomic_add_u16");

/** @type {function(...*):?} */
var _emscripten_atomic_add_u32 = Module["_emscripten_atomic_add_u32"] = createExportWrapper("emscripten_atomic_add_u32");

/** @type {function(...*):?} */
var _emscripten_atomic_add_u64 = Module["_emscripten_atomic_add_u64"] = createExportWrapper("emscripten_atomic_add_u64");

/** @type {function(...*):?} */
var _emscripten_atomic_sub_u8 = Module["_emscripten_atomic_sub_u8"] = createExportWrapper("emscripten_atomic_sub_u8");

/** @type {function(...*):?} */
var _emscripten_atomic_sub_u16 = Module["_emscripten_atomic_sub_u16"] = createExportWrapper("emscripten_atomic_sub_u16");

/** @type {function(...*):?} */
var _emscripten_atomic_sub_u32 = Module["_emscripten_atomic_sub_u32"] = createExportWrapper("emscripten_atomic_sub_u32");

/** @type {function(...*):?} */
var _emscripten_atomic_sub_u64 = Module["_emscripten_atomic_sub_u64"] = createExportWrapper("emscripten_atomic_sub_u64");

/** @type {function(...*):?} */
var _emscripten_atomic_and_u8 = Module["_emscripten_atomic_and_u8"] = createExportWrapper("emscripten_atomic_and_u8");

/** @type {function(...*):?} */
var _emscripten_atomic_and_u16 = Module["_emscripten_atomic_and_u16"] = createExportWrapper("emscripten_atomic_and_u16");

/** @type {function(...*):?} */
var _emscripten_atomic_and_u32 = Module["_emscripten_atomic_and_u32"] = createExportWrapper("emscripten_atomic_and_u32");

/** @type {function(...*):?} */
var _emscripten_atomic_and_u64 = Module["_emscripten_atomic_and_u64"] = createExportWrapper("emscripten_atomic_and_u64");

/** @type {function(...*):?} */
var _emscripten_atomic_or_u8 = Module["_emscripten_atomic_or_u8"] = createExportWrapper("emscripten_atomic_or_u8");

/** @type {function(...*):?} */
var _emscripten_atomic_or_u16 = Module["_emscripten_atomic_or_u16"] = createExportWrapper("emscripten_atomic_or_u16");

/** @type {function(...*):?} */
var _emscripten_atomic_or_u32 = Module["_emscripten_atomic_or_u32"] = createExportWrapper("emscripten_atomic_or_u32");

/** @type {function(...*):?} */
var _emscripten_atomic_or_u64 = Module["_emscripten_atomic_or_u64"] = createExportWrapper("emscripten_atomic_or_u64");

/** @type {function(...*):?} */
var _emscripten_atomic_xor_u8 = Module["_emscripten_atomic_xor_u8"] = createExportWrapper("emscripten_atomic_xor_u8");

/** @type {function(...*):?} */
var _emscripten_atomic_xor_u16 = Module["_emscripten_atomic_xor_u16"] = createExportWrapper("emscripten_atomic_xor_u16");

/** @type {function(...*):?} */
var _emscripten_atomic_xor_u32 = Module["_emscripten_atomic_xor_u32"] = createExportWrapper("emscripten_atomic_xor_u32");

/** @type {function(...*):?} */
var _emscripten_atomic_xor_u64 = Module["_emscripten_atomic_xor_u64"] = createExportWrapper("emscripten_atomic_xor_u64");

/** @type {function(...*):?} */
var __emscripten_atomic_fetch_and_add_u64 = Module["__emscripten_atomic_fetch_and_add_u64"] = createExportWrapper("_emscripten_atomic_fetch_and_add_u64");

/** @type {function(...*):?} */
var __emscripten_atomic_fetch_and_sub_u64 = Module["__emscripten_atomic_fetch_and_sub_u64"] = createExportWrapper("_emscripten_atomic_fetch_and_sub_u64");

/** @type {function(...*):?} */
var __emscripten_atomic_fetch_and_and_u64 = Module["__emscripten_atomic_fetch_and_and_u64"] = createExportWrapper("_emscripten_atomic_fetch_and_and_u64");

/** @type {function(...*):?} */
var __emscripten_atomic_fetch_and_or_u64 = Module["__emscripten_atomic_fetch_and_or_u64"] = createExportWrapper("_emscripten_atomic_fetch_and_or_u64");

/** @type {function(...*):?} */
var __emscripten_atomic_fetch_and_xor_u64 = Module["__emscripten_atomic_fetch_and_xor_u64"] = createExportWrapper("_emscripten_atomic_fetch_and_xor_u64");

/** @type {function(...*):?} */
var _emscripten_futex_wait = Module["_emscripten_futex_wait"] = createExportWrapper("emscripten_futex_wait");

/** @type {function(...*):?} */
var _emscripten_futex_wake = Module["_emscripten_futex_wake"] = createExportWrapper("emscripten_futex_wake");

/** @type {function(...*):?} */
var _emscripten_is_main_runtime_thread = Module["_emscripten_is_main_runtime_thread"] = createExportWrapper("emscripten_is_main_runtime_thread");

/** @type {function(...*):?} */
var _emscripten_main_thread_process_queued_calls = Module["_emscripten_main_thread_process_queued_calls"] = createExportWrapper("emscripten_main_thread_process_queued_calls");

/** @type {function(...*):?} */
var _emscripten_current_thread_process_queued_calls = Module["_emscripten_current_thread_process_queued_calls"] = createExportWrapper("emscripten_current_thread_process_queued_calls");

/** @type {function(...*):?} */
var _pthread_mutex_timedlock = Module["_pthread_mutex_timedlock"] = createExportWrapper("pthread_mutex_timedlock");

/** @type {function(...*):?} */
var _pthread_mutex_consistent = Module["_pthread_mutex_consistent"] = createExportWrapper("pthread_mutex_consistent");

/** @type {function(...*):?} */
var _pthread_barrier_init = Module["_pthread_barrier_init"] = createExportWrapper("pthread_barrier_init");

/** @type {function(...*):?} */
var _pthread_barrier_destroy = Module["_pthread_barrier_destroy"] = createExportWrapper("pthread_barrier_destroy");

/** @type {function(...*):?} */
var _pthread_barrier_wait = Module["_pthread_barrier_wait"] = createExportWrapper("pthread_barrier_wait");

/** @type {function(...*):?} */
var _pthread_key_delete = Module["_pthread_key_delete"] = createExportWrapper("pthread_key_delete");

/** @type {function(...*):?} */
var _pthread_once = Module["_pthread_once"] = createExportWrapper("pthread_once");

/** @type {function(...*):?} */
var _pthread_cond_init = Module["_pthread_cond_init"] = createExportWrapper("pthread_cond_init");

/** @type {function(...*):?} */
var _pthread_atfork = Module["_pthread_atfork"] = createExportWrapper("pthread_atfork");

/** @type {function(...*):?} */
var _fmin = Module["_fmin"] = createExportWrapper("fmin");

/** @type {function(...*):?} */
var _fminf = Module["_fminf"] = createExportWrapper("fminf");

/** @type {function(...*):?} */
var _fminl = Module["_fminl"] = createExportWrapper("fminl");

/** @type {function(...*):?} */
var _fmaxl = Module["_fmaxl"] = createExportWrapper("fmaxl");

/** @type {function(...*):?} */
var _fmod = Module["_fmod"] = createExportWrapper("fmod");

/** @type {function(...*):?} */
var _fmodf = Module["_fmodf"] = createExportWrapper("fmodf");

/** @type {function(...*):?} */
var _log2f = Module["_log2f"] = createExportWrapper("log2f");

/** @type {function(...*):?} */
var _log10f = Module["_log10f"] = createExportWrapper("log10f");

/** @type {function(...*):?} */
var _exp2 = Module["_exp2"] = createExportWrapper("exp2");

/** @type {function(...*):?} */
var _exp2f = Module["_exp2f"] = createExportWrapper("exp2f");

/** @type {function(...*):?} */
var _exp10 = Module["_exp10"] = createExportWrapper("exp10");

/** @type {function(...*):?} */
var _pow10 = Module["_pow10"] = createExportWrapper("pow10");

/** @type {function(...*):?} */
var _exp10f = Module["_exp10f"] = createExportWrapper("exp10f");

/** @type {function(...*):?} */
var _pow10f = Module["_pow10f"] = createExportWrapper("pow10f");

/** @type {function(...*):?} */
var ___signbitf = Module["___signbitf"] = createExportWrapper("__signbitf");

/** @type {function(...*):?} */
var ___signbit = Module["___signbit"] = createExportWrapper("__signbit");

/** @type {function(...*):?} */
var ___towrite = Module["___towrite"] = createExportWrapper("__towrite");

/** @type {function(...*):?} */
var ___towrite_needs_stdio_exit = Module["___towrite_needs_stdio_exit"] = createExportWrapper("__towrite_needs_stdio_exit");

/** @type {function(...*):?} */
var _fwrite_unlocked = Module["_fwrite_unlocked"] = createExportWrapper("fwrite_unlocked");

/** @type {function(...*):?} */
var _fputs_unlocked = Module["_fputs_unlocked"] = createExportWrapper("fputs_unlocked");

/** @type {function(...*):?} */
var _printf = Module["_printf"] = createExportWrapper("printf");

/** @type {function(...*):?} */
var _iprintf = Module["_iprintf"] = createExportWrapper("iprintf");

/** @type {function(...*):?} */
var ___small_printf = Module["___small_printf"] = createExportWrapper("__small_printf");

/** @type {function(...*):?} */
var _puts = Module["_puts"] = createExportWrapper("puts");

/** @type {function(...*):?} */
var _socketpair = Module["_socketpair"] = createExportWrapper("socketpair");

/** @type {function(...*):?} */
var _shutdown = Module["_shutdown"] = createExportWrapper("shutdown");

/** @type {function(...*):?} */
var _listen = Module["_listen"] = createExportWrapper("listen");

/** @type {function(...*):?} */
var _getpeername = Module["_getpeername"] = createExportWrapper("getpeername");

/** @type {function(...*):?} */
var _sendmsg = Module["_sendmsg"] = createExportWrapper("sendmsg");

/** @type {function(...*):?} */
var _recvmsg = Module["_recvmsg"] = createExportWrapper("recvmsg");

/** @type {function(...*):?} */
var _getsockopt = Module["_getsockopt"] = createExportWrapper("getsockopt");

/** @type {function(...*):?} */
var _freeaddrinfo = Module["_freeaddrinfo"] = createExportWrapper("freeaddrinfo");

/** @type {function(...*):?} */
var ___set_stack_limit = Module["___set_stack_limit"] = createExportWrapper("__set_stack_limit");

/** @type {function(...*):?} */
var __growWasmMemory = Module["__growWasmMemory"] = createExportWrapper("__growWasmMemory");

/** @type {function(...*):?} */
var dynCall_iiiiii = Module["dynCall_iiiiii"] = createExportWrapper("dynCall_iiiiii");

/** @type {function(...*):?} */
var dynCall_iii = Module["dynCall_iii"] = createExportWrapper("dynCall_iii");

/** @type {function(...*):?} */
var dynCall_vi = Module["dynCall_vi"] = createExportWrapper("dynCall_vi");

/** @type {function(...*):?} */
var dynCall_ii = Module["dynCall_ii"] = createExportWrapper("dynCall_ii");

/** @type {function(...*):?} */
var dynCall_iiii = Module["dynCall_iiii"] = createExportWrapper("dynCall_iiii");

/** @type {function(...*):?} */
var dynCall_iiiiiii = Module["dynCall_iiiiiii"] = createExportWrapper("dynCall_iiiiiii");

/** @type {function(...*):?} */
var dynCall_vii = Module["dynCall_vii"] = createExportWrapper("dynCall_vii");

/** @type {function(...*):?} */
var dynCall_viii = Module["dynCall_viii"] = createExportWrapper("dynCall_viii");

/** @type {function(...*):?} */
var dynCall_viiii = Module["dynCall_viiii"] = createExportWrapper("dynCall_viiii");

/** @type {function(...*):?} */
var dynCall_viiiiii = Module["dynCall_viiiiii"] = createExportWrapper("dynCall_viiiiii");

/** @type {function(...*):?} */
var dynCall_viiiii = Module["dynCall_viiiii"] = createExportWrapper("dynCall_viiiii");

/** @type {function(...*):?} */
var dynCall_viiiiiii = Module["dynCall_viiiiiii"] = createExportWrapper("dynCall_viiiiiii");

/** @type {function(...*):?} */
var dynCall_fi = Module["dynCall_fi"] = createExportWrapper("dynCall_fi");

/** @type {function(...*):?} */
var dynCall_dii = Module["dynCall_dii"] = createExportWrapper("dynCall_dii");

/** @type {function(...*):?} */
var dynCall_diii = Module["dynCall_diii"] = createExportWrapper("dynCall_diii");

/** @type {function(...*):?} */
var dynCall_fii = Module["dynCall_fii"] = createExportWrapper("dynCall_fii");

/** @type {function(...*):?} */
var dynCall_diiii = Module["dynCall_diiii"] = createExportWrapper("dynCall_diiii");

/** @type {function(...*):?} */
var dynCall_diiiiiiii = Module["dynCall_diiiiiiii"] = createExportWrapper("dynCall_diiiiiiii");

/** @type {function(...*):?} */
var dynCall_viiiiiiiii = Module["dynCall_viiiiiiiii"] = createExportWrapper("dynCall_viiiiiiiii");

/** @type {function(...*):?} */
var dynCall_jiiii = Module["dynCall_jiiii"] = createExportWrapper("dynCall_jiiii");

/** @type {function(...*):?} */
var dynCall_diiiiii = Module["dynCall_diiiiii"] = createExportWrapper("dynCall_diiiiii");

/** @type {function(...*):?} */
var dynCall_jiji = Module["dynCall_jiji"] = createExportWrapper("dynCall_jiji");

/** @type {function(...*):?} */
var dynCall_iidiiii = Module["dynCall_iidiiii"] = createExportWrapper("dynCall_iidiiii");

/** @type {function(...*):?} */
var dynCall_v = Module["dynCall_v"] = createExportWrapper("dynCall_v");

/** @type {function(...*):?} */
var dynCall_viijii = Module["dynCall_viijii"] = createExportWrapper("dynCall_viijii");

/** @type {function(...*):?} */
var dynCall_iiiii = Module["dynCall_iiiii"] = createExportWrapper("dynCall_iiiii");

/** @type {function(...*):?} */
var dynCall_iiiiiiiii = Module["dynCall_iiiiiiiii"] = createExportWrapper("dynCall_iiiiiiiii");

/** @type {function(...*):?} */
var dynCall_iiiiij = Module["dynCall_iiiiij"] = createExportWrapper("dynCall_iiiiij");

/** @type {function(...*):?} */
var dynCall_iiiiid = Module["dynCall_iiiiid"] = createExportWrapper("dynCall_iiiiid");

/** @type {function(...*):?} */
var dynCall_iiiiijj = Module["dynCall_iiiiijj"] = createExportWrapper("dynCall_iiiiijj");

/** @type {function(...*):?} */
var dynCall_iiiiiiii = Module["dynCall_iiiiiiii"] = createExportWrapper("dynCall_iiiiiiii");

/** @type {function(...*):?} */
var dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = createExportWrapper("dynCall_iiiiiijj");

Module['_stderr'] = 218464;
Module['_stdout'] = 218472;
Module['_stdin'] = 218468;
Module['_WebPUnfilters'] = 264304;
Module['_VP8PredLuma4'] = 263280;
Module['_VP8Transform'] = 263356;
Module['_VP8TransformAC3'] = 263360;
Module['_VP8TransformDC'] = 263368;
Module['_VP8PredLuma16'] = 263248;
Module['_VP8PredChroma8'] = 263328;
Module['_VP8TransformUV'] = 263364;
Module['_VP8TransformDCUV'] = 263372;
Module['_VP8SimpleHFilter16'] = 263412;
Module['_VP8SimpleHFilter16i'] = 263420;
Module['_VP8SimpleVFilter16'] = 263408;
Module['_VP8SimpleVFilter16i'] = 263416;
Module['_VP8HFilter16'] = 263380;
Module['_VP8HFilter8'] = 263388;
Module['_VP8HFilter16i'] = 263396;
Module['_VP8HFilter8i'] = 263404;
Module['_VP8VFilter16'] = 263376;
Module['_VP8VFilter8'] = 263384;
Module['_VP8VFilter16i'] = 263392;
Module['_VP8VFilter8i'] = 263400;
Module['_VP8DitherCombine8x8'] = 263424;
Module['_WebPSamplers'] = 264976;
Module['_WebPUpsamplers'] = 264848;
Module['_WebPApplyAlphaMultiply4444'] = 263200;
Module['_WebPDispatchAlpha'] = 263204;
Module['_WebPApplyAlphaMultiply'] = 263196;
Module['_WebPYUV444Converters'] = 264912;
Module['_VP8GetCPUInfo'] = 263240;
Module['_VP8TransformWHT'] = 263244;
Module['_kVP8Log2Range'] = 48544;
Module['_kVP8NewRange'] = 48672;
Module['_WebPExtractGreen'] = 263216;
Module['_WebPMultARGBRow'] = 263188;
Module['_WebPConvertARGBToY'] = 265040;
Module['_WebPConvertARGBToUV'] = 265044;
Module['_WebPExtractAlpha'] = 263212;
Module['_WebPMultRow'] = 263192;
Module['_WebPPackRGB'] = 263220;
Module['_WebPDispatchAlphaToGreen'] = 263208;
Module['_WebPHasAlpha8b'] = 263224;
Module['_WebPHasAlpha32b'] = 263228;
Module['_VP8SetResidualCoeffs'] = 263236;
Module['_VP8GetResidualCost'] = 263232;
Module['_VP8EntropyCost'] = 12496;
Module['_VP8LevelFixedCosts'] = 13008;
Module['_VP8EncBands'] = 17104;
Module['_VP8kclip1'] = 20320;
Module['_VP8ksclip2'] = 19540;
Module['_VP8ksclip1'] = 19308;
Module['_VP8kabs0'] = 20848;
Module['_VP8FTransform'] = 263436;
Module['_VP8ITransform'] = 263432;
Module['_VP8FTransformWHT'] = 263444;
Module['_VP8TDisto4x4'] = 263476;
Module['_VP8TDisto16x16'] = 263480;
Module['_VP8CollectHistogram'] = 263428;
Module['_VP8SSE16x16'] = 263460;
Module['_VP8SSE16x8'] = 263468;
Module['_VP8SSE8x8'] = 263464;
Module['_VP8SSE4x4'] = 263472;
Module['_VP8EncQuantizeBlock'] = 263488;
Module['_VP8EncQuantize2Blocks'] = 263492;
Module['_VP8FTransform2'] = 263440;
Module['_VP8EncPredLuma4'] = 263448;
Module['_VP8EncPredLuma16'] = 263452;
Module['_VP8EncPredChroma8'] = 263456;
Module['_VP8Mean16x4'] = 263484;
Module['_VP8EncQuantizeBlockWHT'] = 263496;
Module['_VP8Copy4x4'] = 263500;
Module['_VP8Copy16x8'] = 263504;
Module['_VP8DspScan'] = 20864;
Module['_WebPFilters'] = 264288;
Module['_VP8LMapColor8b'] = 264320;
Module['_VP8LAddGreenToBlueAndRed'] = 264324;
Module['_VP8LPredictorsAdd'] = 264352;
Module['_VP8LTransformColorInverse'] = 264608;
Module['_VP8LMapColor32b'] = 264612;
Module['_VP8LConvertBGRAToRGBA'] = 264332;
Module['_VP8LConvertBGRAToBGR'] = 264336;
Module['_VP8LConvertBGRAToRGBA4444'] = 264340;
Module['_VP8LConvertBGRAToRGB565'] = 264344;
Module['_VP8LConvertBGRAToRGB'] = 264328;
Module['_VP8LPredictors'] = 264416;
Module['_VP8LPredictors_C'] = 264544;
Module['_VP8LPredictorsAdd_C'] = 264480;
Module['_kSLog2Table'] = 22560;
Module['_VP8LFastSLog2Slow'] = 264644;
Module['_VP8LAddVector'] = 264616;
Module['_VP8LAddVectorEq'] = 264620;
Module['_VP8LTransformColor'] = 264628;
Module['_VP8LSubtractGreenFromBlueAndRed'] = 264624;
Module['_VP8LCollectColorBlueTransforms'] = 264632;
Module['_VP8LCollectColorRedTransforms'] = 264636;
Module['_VP8LFastLog2Slow'] = 264640;
Module['_VP8LExtraCost'] = 264648;
Module['_VP8LExtraCostCombined'] = 264652;
Module['_VP8LCombinedShannonEntropy'] = 264656;
Module['_VP8LGetEntropyUnrefined'] = 264660;
Module['_VP8LGetCombinedEntropyUnrefined'] = 264664;
Module['_VP8LVectorMismatch'] = 264668;
Module['_VP8LBundleColorMap'] = 264672;
Module['_VP8LPredictorsSub'] = 264688;
Module['_VP8LPredictorsSub_C'] = 264752;
Module['_kLog2Table'] = 21536;
Module['_kPrefixEncodeCode'] = 23584;
Module['_kPrefixEncodeExtraBitsValue'] = 24608;
Module['_WebPRescalerImportRowShrink'] = 264816;
Module['_WebPRescalerImportRowExpand'] = 264820;
Module['_WebPRescalerExportRowExpand'] = 264824;
Module['_WebPRescalerExportRowShrink'] = 264828;
Module['_VP8SSIMGet'] = 264832;
Module['_VP8SSIMGetClipped'] = 264836;
Module['_VP8AccumulateSSE'] = 264840;
Module['_WebPConvertRGB24ToY'] = 265028;
Module['_WebPConvertBGR24ToY'] = 265032;
Module['_WebPConvertRGBA32ToUV'] = 265036;
Module['_WebPSharpYUVUpdateY'] = 265048;
Module['_WebPSharpYUVUpdateRGB'] = 265052;
Module['_WebPSharpYUVFilterRow'] = 265056;
Module['_VP8UVModeOffsets'] = 38590;
Module['_VP8I16ModeOffsets'] = 38582;
Module['_VP8LevelCodes'] = 28848;
Module['_VP8FixedCostsUV'] = 29116;
Module['_VP8FixedCostsI16'] = 29124;
Module['_VP8FixedCostsI4'] = 29136;
Module['_VP8CoeffsProba0'] = 39968;
Module['_VP8CoeffsUpdateProba'] = 41936;
Module['_VP8Cat3'] = 31776;
Module['_VP8Cat4'] = 31779;
Module['_VP8Cat5'] = 31783;
Module['_VP8Cat6'] = 31788;
Module['_VP8Scan'] = 38640;
Module['_VP8I4ModeOffsets'] = 38608;
Module['_kChunks'] = 47200;
Module['___progname'] = 270228;
Module['___progname_full'] = 270232;
Module['___libc'] = 270236;
Module['___hwcap'] = 270300;
Module['___sysinfo'] = 270304;
Module['_program_invocation_short_name'] = 270228;
Module['_program_invocation_name'] = 270232;
Module['___c_dot_utf8'] = 81700;
Module['___c_locale'] = 81728;
Module['___c_dot_utf8_locale'] = 81752;
Module['___pio2_hi'] = 207728;
Module['___pio2_lo'] = 207744;
Module['___signgam'] = 270452;
Module['_signgam'] = 270452;
Module['_optind'] = 262500;
Module['___optreset'] = 270464;
Module['___optpos'] = 270468;
Module['_optarg'] = 270472;
Module['_optopt'] = 270476;
Module['_opterr'] = 262504;
Module['_optreset'] = 270464;
Module['___fsmu8'] = 216992;
Module['_h_errno'] = 270960;
Module['_in6addr_any'] = 217332;
Module['_in6addr_loopback'] = 217348;
Module['__ns_flagdata'] = 217680;
Module['___seed48'] = 262520;
Module['___stdin_used'] = 262984;
Module['___stdout_used'] = 263136;
Module['___stderr_used'] = 262832;
Module['___environ'] = 273728;
Module['____environ'] = 273728;
Module['__environ'] = 273728;
Module['_environ'] = 273728;
Module['___env_map'] = 273736;
Module['_tzname'] = 273740;
Module['_daylight'] = 273748;
Module['_timezone'] = 273752;
Module['___THREW__'] = 277856;
Module['___threwValue'] = 277860;
Module['_atanlo'] = 220864;
Module['_atanhi'] = 220800;
Module['_aT'] = 220928;
Module['__ZNSt3__212__rs_default4__c_E'] = 277868;
Module['__ZTVSt12bad_any_cast'] = 221528;
Module['__ZTISt12bad_any_cast'] = 221568;
Module['__ZTSSt12bad_any_cast'] = 221548;
Module['__ZTVN10__cxxabiv120__si_class_type_infoE'] = 257376;
Module['__ZTISt8bad_cast'] = 255372;
Module['__ZTVNSt12experimental15fundamentals_v112bad_any_castE'] = 221580;
Module['__ZTINSt12experimental15fundamentals_v112bad_any_castE'] = 221652;
Module['__ZTSNSt12experimental15fundamentals_v112bad_any_castE'] = 221600;
Module['__ZNSt3__212placeholders2_1E'] = 221664;
Module['__ZNSt3__212placeholders2_2E'] = 221665;
Module['__ZNSt3__212placeholders2_3E'] = 221666;
Module['__ZNSt3__212placeholders2_4E'] = 221667;
Module['__ZNSt3__212placeholders2_5E'] = 221668;
Module['__ZNSt3__212placeholders2_6E'] = 221669;
Module['__ZNSt3__212placeholders2_7E'] = 221670;
Module['__ZNSt3__212placeholders2_8E'] = 221671;
Module['__ZNSt3__212placeholders2_9E'] = 221672;
Module['__ZNSt3__212placeholders3_10E'] = 221673;
Module['__ZNSt3__26chrono12system_clock9is_steadyE'] = 221880;
Module['__ZNSt3__26chrono12steady_clock9is_steadyE'] = 221918;
Module['__ZNSt3__223__libcpp_debug_functionE'] = 263140;
Module['__ZTVNSt3__28__c_nodeE'] = 222156;
Module['__ZTINSt3__28__c_nodeE'] = 222208;
Module['__ZTSNSt3__28__c_nodeE'] = 222188;
Module['__ZTVN10__cxxabiv117__class_type_infoE'] = 257336;
Module['__ZTVSt16nested_exception'] = 222216;
Module['__ZTISt16nested_exception'] = 222256;
Module['__ZTSSt16nested_exception'] = 222232;
Module['__ZTVNSt3__217bad_function_callE'] = 222288;
Module['__ZTINSt3__217bad_function_callE'] = 222336;
Module['__ZTSNSt3__217bad_function_callE'] = 222308;
Module['__ZTISt9exception'] = 254656;
Module['___dso_handle'] = 1024;
Module['__ZTVNSt3__212future_errorE'] = 222700;
Module['__ZTVNSt3__217__assoc_sub_stateE'] = 222720;
Module['__ZTVNSt3__214__shared_countE'] = 236024;
Module['__ZTVNSt3__223__future_error_categoryE'] = 222664;
Module['__ZTINSt3__223__future_error_categoryE'] = 222820;
Module['__ZTINSt3__212future_errorE'] = 222856;
Module['__ZTINSt3__217__assoc_sub_stateE'] = 222772;
Module['__ZTSNSt3__217__assoc_sub_stateE'] = 222744;
Module['__ZTINSt3__214__shared_countE'] = 236072;
Module['__ZTSNSt3__223__future_error_categoryE'] = 222784;
Module['__ZTINSt3__212__do_messageE'] = 240924;
Module['__ZTSNSt3__212future_errorE'] = 222832;
Module['__ZTISt11logic_error'] = 254880;
Module['__ZTVNSt3__28ios_baseE'] = 223960;
Module['__ZTVNSt3__215basic_streambufIcNS_11char_traitsIcEEEE'] = 223336;
Module['__ZTVNSt3__215basic_streambufIwNS_11char_traitsIwEEEE'] = 223400;
Module['__ZTTNSt3__213basic_istreamIcNS_11char_traitsIcEEEE'] = 223504;
Module['__ZNSt3__25ctypeIcE2idE'] = 281728;
Module['__ZTTNSt3__213basic_istreamIwNS_11char_traitsIwEEEE'] = 223552;
Module['__ZNSt3__25ctypeIwE2idE'] = 281720;
Module['__ZTTNSt3__213basic_ostreamIcNS_11char_traitsIcEEEE'] = 223600;
Module['__ZNSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE2idE'] = 281556;
Module['__ZTTNSt3__213basic_ostreamIwNS_11char_traitsIwEEEE'] = 223648;
Module['__ZNSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE2idE'] = 281564;
Module['__ZTTNSt3__214basic_iostreamIcNS_11char_traitsIcEEEE'] = 223716;
Module['__ZTVNSt3__28ios_base7failureE'] = 223828;
Module['__ZNSt3__28ios_base9__xindex_E'] = 280468;
Module['__ZNSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE2idE'] = 281540;
Module['__ZNSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE2idE'] = 281548;
Module['__ZTINSt3__215basic_streambufIcNS_11char_traitsIcEEEE'] = 224216;
Module['__ZTINSt3__215basic_streambufIwNS_11char_traitsIwEEEE'] = 224276;
Module['__ZTVNSt3__213basic_istreamIcNS_11char_traitsIcEEEE'] = 223464;
Module['__ZTINSt3__213basic_istreamIcNS_11char_traitsIcEEEE'] = 224332;
Module['__ZTVNSt3__213basic_istreamIwNS_11char_traitsIwEEEE'] = 223512;
Module['__ZTINSt3__213basic_istreamIwNS_11char_traitsIwEEEE'] = 224404;
Module['__ZTVNSt3__213basic_ostreamIcNS_11char_traitsIcEEEE'] = 223560;
Module['__ZTINSt3__213basic_ostreamIcNS_11char_traitsIcEEEE'] = 224476;
Module['__ZTVNSt3__213basic_ostreamIwNS_11char_traitsIwEEEE'] = 223608;
Module['__ZTINSt3__213basic_ostreamIwNS_11char_traitsIwEEEE'] = 224548;
Module['__ZTVNSt3__214basic_iostreamIcNS_11char_traitsIcEEEE'] = 223656;
Module['__ZTINSt3__214basic_iostreamIcNS_11char_traitsIcEEEE'] = 224700;
Module['__ZTCNSt3__214basic_iostreamIcNS_11char_traitsIcEEEE0_NS_13basic_istreamIcS2_EE'] = 224572;
Module['__ZTCNSt3__214basic_iostreamIcNS_11char_traitsIcEEEE8_NS_13basic_ostreamIcS2_EE'] = 224612;
Module['__ZTVNSt3__219__iostream_categoryE'] = 223792;
Module['__ZTINSt3__219__iostream_categoryE'] = 224764;
Module['__ZTINSt3__28ios_base7failureE'] = 224804;
Module['__ZNSt3__28ios_base9boolalphaE'] = 223848;
Module['__ZNSt3__28ios_base3decE'] = 223852;
Module['__ZNSt3__28ios_base5fixedE'] = 223856;
Module['__ZNSt3__28ios_base3hexE'] = 223860;
Module['__ZNSt3__28ios_base8internalE'] = 223864;
Module['__ZNSt3__28ios_base4leftE'] = 223868;
Module['__ZNSt3__28ios_base3octE'] = 223872;
Module['__ZNSt3__28ios_base5rightE'] = 223876;
Module['__ZNSt3__28ios_base10scientificE'] = 223880;
Module['__ZNSt3__28ios_base8showbaseE'] = 223884;
Module['__ZNSt3__28ios_base9showpointE'] = 223888;
Module['__ZNSt3__28ios_base7showposE'] = 223892;
Module['__ZNSt3__28ios_base6skipwsE'] = 223896;
Module['__ZNSt3__28ios_base7unitbufE'] = 223900;
Module['__ZNSt3__28ios_base9uppercaseE'] = 223904;
Module['__ZNSt3__28ios_base11adjustfieldE'] = 223908;
Module['__ZNSt3__28ios_base9basefieldE'] = 223912;
Module['__ZNSt3__28ios_base10floatfieldE'] = 223916;
Module['__ZNSt3__28ios_base6badbitE'] = 223920;
Module['__ZNSt3__28ios_base6eofbitE'] = 223924;
Module['__ZNSt3__28ios_base7failbitE'] = 223928;
Module['__ZNSt3__28ios_base7goodbitE'] = 223932;
Module['__ZNSt3__28ios_base3appE'] = 223936;
Module['__ZNSt3__28ios_base3ateE'] = 223940;
Module['__ZNSt3__28ios_base6binaryE'] = 223944;
Module['__ZNSt3__28ios_base2inE'] = 223948;
Module['__ZNSt3__28ios_base3outE'] = 223952;
Module['__ZNSt3__28ios_base5truncE'] = 223956;
Module['__ZTINSt3__28ios_baseE'] = 224012;
Module['__ZTSNSt3__28ios_baseE'] = 223992;
Module['__ZTVNSt3__29basic_iosIcNS_11char_traitsIcEEEE'] = 224020;
Module['__ZTINSt3__29basic_iosIcNS_11char_traitsIcEEEE'] = 224080;
Module['__ZTSNSt3__29basic_iosIcNS_11char_traitsIcEEEE'] = 224036;
Module['__ZTVNSt3__29basic_iosIwNS_11char_traitsIwEEEE'] = 224092;
Module['__ZTINSt3__29basic_iosIwNS_11char_traitsIwEEEE'] = 224152;
Module['__ZTSNSt3__29basic_iosIwNS_11char_traitsIwEEEE'] = 224108;
Module['__ZTSNSt3__215basic_streambufIcNS_11char_traitsIcEEEE'] = 224164;
Module['__ZTSNSt3__215basic_streambufIwNS_11char_traitsIwEEEE'] = 224224;
Module['__ZTSNSt3__213basic_istreamIcNS_11char_traitsIcEEEE'] = 224284;
Module['__ZTVN10__cxxabiv121__vmi_class_type_infoE'] = 257468;
Module['__ZTSNSt3__213basic_istreamIwNS_11char_traitsIwEEEE'] = 224356;
Module['__ZTSNSt3__213basic_ostreamIcNS_11char_traitsIcEEEE'] = 224428;
Module['__ZTSNSt3__213basic_ostreamIwNS_11char_traitsIwEEEE'] = 224500;
Module['__ZTSNSt3__214basic_iostreamIcNS_11char_traitsIcEEEE'] = 224652;
Module['__ZTSNSt3__219__iostream_categoryE'] = 224732;
Module['__ZTSNSt3__28ios_base7failureE'] = 224776;
Module['__ZTINSt3__212system_errorE'] = 241056;
Module['__ZNSt3__219__start_std_streamsE'] = 281160;
Module['__ZNSt3__23cinE'] = 280480;
Module['__ZNSt3__24wcinE'] = 280568;
Module['__ZNSt3__24coutE'] = 280656;
Module['__ZNSt3__25wcoutE'] = 280740;
Module['__ZNSt3__24cerrE'] = 280824;
Module['__ZNSt3__24clogE'] = 280992;
Module['__ZNSt3__25wcerrE'] = 280908;
Module['__ZNSt3__25wclogE'] = 281076;
Module['__ZTVNSt3__210__stdinbufIcEE'] = 224816;
Module['__ZTVNSt3__210__stdinbufIwEE'] = 224956;
Module['__ZTVNSt3__211__stdoutbufIcEE'] = 225056;
Module['__ZTVNSt3__211__stdoutbufIwEE'] = 225160;
Module['__ZNSt3__27codecvtIcc11__mbstate_tE2idE'] = 281736;
Module['__ZNSt3__27codecvtIwc11__mbstate_tE2idE'] = 281744;
Module['__ZTINSt3__210__stdinbufIcEE'] = 224904;
Module['__ZTSNSt3__210__stdinbufIcEE'] = 224880;
Module['__ZTINSt3__210__stdinbufIwEE'] = 225044;
Module['__ZTSNSt3__210__stdinbufIwEE'] = 225020;
Module['__ZTINSt3__211__stdoutbufIcEE'] = 225148;
Module['__ZTSNSt3__211__stdoutbufIcEE'] = 225120;
Module['__ZTINSt3__211__stdoutbufIwEE'] = 225252;
Module['__ZTSNSt3__211__stdoutbufIwEE'] = 225224;
Module['__ZNSt3__28numpunctIcE2idE'] = 281768;
Module['__ZNSt3__214__num_get_base5__srcE'] = 225264;
Module['__ZNSt3__28numpunctIwE2idE'] = 281776;
Module['__ZNSt3__210moneypunctIcLb1EE2idE'] = 281612;
Module['__ZNSt3__210moneypunctIcLb0EE2idE'] = 281604;
Module['__ZNSt3__210moneypunctIwLb1EE2idE'] = 281628;
Module['__ZNSt3__210moneypunctIwLb0EE2idE'] = 281620;
Module['__ZTVNSt3__216__narrow_to_utf8ILm32EEE'] = 227708;
Module['__ZTVNSt3__217__widen_from_utf8ILm32EEE'] = 227900;
Module['__ZTVNSt3__26locale5__impE'] = 225580;
Module['__ZTVNSt3__26locale5facetE'] = 227028;
Module['__ZNSt3__27collateIcE2idE'] = 281524;
Module['__ZNSt3__27collateIwE2idE'] = 281532;
Module['__ZNSt3__27codecvtIDsc11__mbstate_tE2idE'] = 281752;
Module['__ZNSt3__27codecvtIDic11__mbstate_tE2idE'] = 281760;
Module['__ZNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE2idE'] = 281636;
Module['__ZNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE2idE'] = 281644;
Module['__ZNSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE2idE'] = 281652;
Module['__ZNSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE2idE'] = 281660;
Module['__ZNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEE2idE'] = 281572;
Module['__ZNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEE2idE'] = 281580;
Module['__ZNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEE2idE'] = 281588;
Module['__ZNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEE2idE'] = 281596;
Module['__ZNSt3__28messagesIcE2idE'] = 281668;
Module['__ZNSt3__28messagesIwE2idE'] = 281676;
Module['__ZTVNSt3__214codecvt_bynameIcc11__mbstate_tEE'] = 234132;
Module['__ZTVNSt3__214codecvt_bynameIwc11__mbstate_tEE'] = 234236;
Module['__ZTVNSt3__214codecvt_bynameIDsc11__mbstate_tEE'] = 234340;
Module['__ZTVNSt3__214codecvt_bynameIDic11__mbstate_tEE'] = 234444;
Module['__ZTVNSt3__217moneypunct_bynameIcLb0EEE'] = 232700;
Module['__ZTVNSt3__217moneypunct_bynameIcLb1EEE'] = 232804;
Module['__ZTVNSt3__217moneypunct_bynameIwLb0EEE'] = 232908;
Module['__ZTVNSt3__217moneypunct_bynameIwLb1EEE'] = 233012;
Module['__ZTVNSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 231124;
Module['__ZTVNSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 231420;
Module['__ZTVNSt3__215time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 231972;
Module['__ZTVNSt3__215time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 232088;
Module['__ZTVNSt3__215messages_bynameIcEE'] = 233980;
Module['__ZTVNSt3__215messages_bynameIwEE'] = 234056;
Module['__ZNSt3__26locale2id9__next_idE'] = 281716;
Module['__ZTVNSt3__214collate_bynameIcEE'] = 225604;
Module['__ZTVNSt3__214collate_bynameIwEE'] = 225700;
Module['__ZTVNSt3__25ctypeIcEE'] = 225836;
Module['__ZTVNSt3__212ctype_bynameIcEE'] = 225888;
Module['__ZTVNSt3__212ctype_bynameIwEE'] = 226000;
Module['__ZTVNSt3__27codecvtIwc11__mbstate_tEE'] = 226132;
Module['__ZTVNSt3__28numpunctIcEE'] = 226264;
Module['__ZTVNSt3__28numpunctIwEE'] = 226304;
Module['__ZTVNSt3__215numpunct_bynameIcEE'] = 226404;
Module['__ZTVNSt3__215numpunct_bynameIwEE'] = 226508;
Module['__ZTVNSt3__215__time_get_tempIcEE'] = 235800;
Module['__ZTVNSt3__215__time_get_tempIwEE'] = 235896;
Module['__ZTVNSt3__27collateIcEE'] = 229672;
Module['__ZTVNSt3__27collateIwEE'] = 229704;
Module['__ZTVNSt3__25ctypeIwEE'] = 227084;
Module['__ZTVNSt3__27codecvtIcc11__mbstate_tEE'] = 227232;
Module['__ZTVNSt3__27codecvtIDsc11__mbstate_tEE'] = 227380;
Module['__ZTVNSt3__27codecvtIDic11__mbstate_tEE'] = 227496;
Module['__ZTVNSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 229736;
Module['__ZTVNSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 229980;
Module['__ZTVNSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 230192;
Module['__ZTVNSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 230424;
Module['__ZTVNSt3__210moneypunctIcLb0EEE'] = 232204;
Module['__ZTVNSt3__210moneypunctIcLb1EEE'] = 232352;
Module['__ZTVNSt3__210moneypunctIwLb0EEE'] = 232468;
Module['__ZTVNSt3__210moneypunctIwLb1EEE'] = 232584;
Module['__ZTVNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 233116;
Module['__ZTVNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 233280;
Module['__ZTVNSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 233444;
Module['__ZTVNSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 233608;
Module['__ZTVNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 230624;
Module['__ZTVNSt3__220__time_get_c_storageIcEE'] = 235728;
Module['__ZTVNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 230888;
Module['__ZTVNSt3__220__time_get_c_storageIwEE'] = 235764;
Module['__ZTVNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 231688;
Module['__ZTVNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 231844;
Module['__ZTVNSt3__28messagesIcEE'] = 233772;
Module['__ZTVNSt3__28messagesIwEE'] = 233892;
Module['__ZNSt3__210moneypunctIcLb0EE4intlE'] = 225520;
Module['__ZNSt3__210moneypunctIcLb1EE4intlE'] = 225521;
Module['__ZNSt3__210moneypunctIwLb0EE4intlE'] = 225522;
Module['__ZNSt3__210moneypunctIwLb1EE4intlE'] = 225523;
Module['__ZNSt3__26locale4noneE'] = 225548;
Module['__ZNSt3__26locale7collateE'] = 225552;
Module['__ZNSt3__26locale5ctypeE'] = 225556;
Module['__ZNSt3__26locale8monetaryE'] = 225560;
Module['__ZNSt3__26locale7numericE'] = 225564;
Module['__ZNSt3__26locale4timeE'] = 225568;
Module['__ZNSt3__26locale8messagesE'] = 225572;
Module['__ZNSt3__26locale3allE'] = 225576;
Module['__ZTINSt3__26locale5__impE'] = 229224;
Module['__ZTINSt3__214collate_bynameIcEE'] = 229296;
Module['__ZTINSt3__214collate_bynameIwEE'] = 229368;
Module['__ZNSt3__210ctype_base5spaceE'] = 225810;
Module['__ZNSt3__210ctype_base5printE'] = 225812;
Module['__ZNSt3__210ctype_base5cntrlE'] = 225814;
Module['__ZNSt3__210ctype_base5upperE'] = 225816;
Module['__ZNSt3__210ctype_base5lowerE'] = 225818;
Module['__ZNSt3__210ctype_base5alphaE'] = 225820;
Module['__ZNSt3__210ctype_base5digitE'] = 225822;
Module['__ZNSt3__210ctype_base5punctE'] = 225824;
Module['__ZNSt3__210ctype_base6xdigitE'] = 225826;
Module['__ZNSt3__210ctype_base5blankE'] = 225828;
Module['__ZNSt3__210ctype_base5alnumE'] = 225830;
Module['__ZNSt3__210ctype_base5graphE'] = 225832;
Module['__ZTINSt3__25ctypeIcEE'] = 229400;
Module['__ZTINSt3__212ctype_bynameIcEE'] = 229460;
Module['__ZTINSt3__212ctype_bynameIwEE'] = 229500;
Module['__ZTINSt3__27codecvtIwc11__mbstate_tEE'] = 228108;
Module['__ZTINSt3__28numpunctIcEE'] = 229536;
Module['__ZTINSt3__28numpunctIwEE'] = 229572;
Module['__ZTINSt3__215numpunct_bynameIcEE'] = 229616;
Module['__ZTINSt3__215numpunct_bynameIwEE'] = 229660;
Module['__ZTINSt3__26locale5facetE'] = 227072;
Module['__ZTSNSt3__26locale5facetE'] = 227048;
Module['__ZTINSt3__25ctypeIwEE'] = 227200;
Module['__ZTSNSt3__25ctypeIwEE'] = 227152;
Module['__ZTSNSt3__210ctype_baseE'] = 227170;
Module['__ZTINSt3__210ctype_baseE'] = 227192;
Module['__ZTINSt3__27codecvtIcc11__mbstate_tEE'] = 227348;
Module['__ZTSNSt3__27codecvtIcc11__mbstate_tEE'] = 227280;
Module['__ZTSNSt3__212codecvt_baseE'] = 227314;
Module['__ZTINSt3__212codecvt_baseE'] = 227340;
Module['__ZTINSt3__27codecvtIDsc11__mbstate_tEE'] = 227464;
Module['__ZTSNSt3__27codecvtIDsc11__mbstate_tEE'] = 227428;
Module['__ZTINSt3__27codecvtIDic11__mbstate_tEE'] = 227580;
Module['__ZTSNSt3__27codecvtIDic11__mbstate_tEE'] = 227544;
Module['__ZTVNSt3__216__narrow_to_utf8ILm16EEE'] = 227612;
Module['__ZTINSt3__216__narrow_to_utf8ILm16EEE'] = 227696;
Module['__ZTSNSt3__216__narrow_to_utf8ILm16EEE'] = 227660;
Module['__ZTINSt3__216__narrow_to_utf8ILm32EEE'] = 227792;
Module['__ZTSNSt3__216__narrow_to_utf8ILm32EEE'] = 227756;
Module['__ZTVNSt3__217__widen_from_utf8ILm16EEE'] = 227804;
Module['__ZTINSt3__217__widen_from_utf8ILm16EEE'] = 227888;
Module['__ZTSNSt3__217__widen_from_utf8ILm16EEE'] = 227852;
Module['__ZTINSt3__217__widen_from_utf8ILm32EEE'] = 227984;
Module['__ZTSNSt3__217__widen_from_utf8ILm32EEE'] = 227948;
Module['__ZTVNSt3__214__codecvt_utf8IwEE'] = 227996;
Module['__ZTINSt3__214__codecvt_utf8IwEE'] = 228140;
Module['__ZTSNSt3__214__codecvt_utf8IwEE'] = 228044;
Module['__ZTSNSt3__27codecvtIwc11__mbstate_tEE'] = 228072;
Module['__ZTVNSt3__214__codecvt_utf8IDsEE'] = 228152;
Module['__ZTINSt3__214__codecvt_utf8IDsEE'] = 228232;
Module['__ZTSNSt3__214__codecvt_utf8IDsEE'] = 228200;
Module['__ZTVNSt3__214__codecvt_utf8IDiEE'] = 228244;
Module['__ZTINSt3__214__codecvt_utf8IDiEE'] = 228324;
Module['__ZTSNSt3__214__codecvt_utf8IDiEE'] = 228292;
Module['__ZTVNSt3__215__codecvt_utf16IwLb0EEE'] = 228336;
Module['__ZTINSt3__215__codecvt_utf16IwLb0EEE'] = 228420;
Module['__ZTSNSt3__215__codecvt_utf16IwLb0EEE'] = 228384;
Module['__ZTVNSt3__215__codecvt_utf16IwLb1EEE'] = 228432;
Module['__ZTINSt3__215__codecvt_utf16IwLb1EEE'] = 228516;
Module['__ZTSNSt3__215__codecvt_utf16IwLb1EEE'] = 228480;
Module['__ZTVNSt3__215__codecvt_utf16IDsLb0EEE'] = 228528;
Module['__ZTINSt3__215__codecvt_utf16IDsLb0EEE'] = 228612;
Module['__ZTSNSt3__215__codecvt_utf16IDsLb0EEE'] = 228576;
Module['__ZTVNSt3__215__codecvt_utf16IDsLb1EEE'] = 228624;
Module['__ZTINSt3__215__codecvt_utf16IDsLb1EEE'] = 228708;
Module['__ZTSNSt3__215__codecvt_utf16IDsLb1EEE'] = 228672;
Module['__ZTVNSt3__215__codecvt_utf16IDiLb0EEE'] = 228720;
Module['__ZTINSt3__215__codecvt_utf16IDiLb0EEE'] = 228804;
Module['__ZTSNSt3__215__codecvt_utf16IDiLb0EEE'] = 228768;
Module['__ZTVNSt3__215__codecvt_utf16IDiLb1EEE'] = 228816;
Module['__ZTINSt3__215__codecvt_utf16IDiLb1EEE'] = 228900;
Module['__ZTSNSt3__215__codecvt_utf16IDiLb1EEE'] = 228864;
Module['__ZTVNSt3__220__codecvt_utf8_utf16IwEE'] = 228912;
Module['__ZTINSt3__220__codecvt_utf8_utf16IwEE'] = 228996;
Module['__ZTSNSt3__220__codecvt_utf8_utf16IwEE'] = 228960;
Module['__ZTVNSt3__220__codecvt_utf8_utf16IDiEE'] = 229008;
Module['__ZTINSt3__220__codecvt_utf8_utf16IDiEE'] = 229092;
Module['__ZTSNSt3__220__codecvt_utf8_utf16IDiEE'] = 229056;
Module['__ZTVNSt3__220__codecvt_utf8_utf16IDsEE'] = 229104;
Module['__ZTINSt3__220__codecvt_utf8_utf16IDsEE'] = 229188;
Module['__ZTSNSt3__220__codecvt_utf8_utf16IDsEE'] = 229152;
Module['__ZTSNSt3__26locale5__impE'] = 229200;
Module['__ZTSNSt3__214collate_bynameIcEE'] = 229236;
Module['__ZTSNSt3__27collateIcEE'] = 229264;
Module['__ZTINSt3__27collateIcEE'] = 229284;
Module['__ZTSNSt3__214collate_bynameIwEE'] = 229308;
Module['__ZTSNSt3__27collateIwEE'] = 229336;
Module['__ZTINSt3__27collateIwEE'] = 229356;
Module['__ZTSNSt3__25ctypeIcEE'] = 229380;
Module['__ZTSNSt3__212ctype_bynameIcEE'] = 229432;
Module['__ZTSNSt3__212ctype_bynameIwEE'] = 229472;
Module['__ZTSNSt3__28numpunctIcEE'] = 229512;
Module['__ZTSNSt3__28numpunctIwEE'] = 229548;
Module['__ZTSNSt3__215numpunct_bynameIcEE'] = 229584;
Module['__ZTSNSt3__215numpunct_bynameIwEE'] = 229628;
Module['__ZTINSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 229948;
Module['__ZTSNSt3__27num_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 229800;
Module['__ZTSNSt3__29__num_getIcEE'] = 229868;
Module['__ZTSNSt3__214__num_get_baseE'] = 229890;
Module['__ZTINSt3__214__num_get_baseE'] = 229916;
Module['__ZTINSt3__29__num_getIcEE'] = 229924;
Module['__ZTINSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 230160;
Module['__ZTSNSt3__27num_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 230044;
Module['__ZTSNSt3__29__num_getIwEE'] = 230112;
Module['__ZTINSt3__29__num_getIwEE'] = 230136;
Module['__ZTINSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 230392;
Module['__ZTSNSt3__27num_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 230244;
Module['__ZTSNSt3__29__num_putIcEE'] = 230312;
Module['__ZTSNSt3__214__num_put_baseE'] = 230334;
Module['__ZTINSt3__214__num_put_baseE'] = 230360;
Module['__ZTINSt3__29__num_putIcEE'] = 230368;
Module['__ZTINSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 230592;
Module['__ZTSNSt3__27num_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 230476;
Module['__ZTSNSt3__29__num_putIwEE'] = 230544;
Module['__ZTINSt3__29__num_putIwEE'] = 230568;
Module['__ZTINSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 230848;
Module['__ZTSNSt3__28time_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 230708;
Module['__ZTSNSt3__29time_baseE'] = 230777;
Module['__ZTINSt3__29time_baseE'] = 230796;
Module['__ZTSNSt3__220__time_get_c_storageIcEE'] = 230804;
Module['__ZTINSt3__220__time_get_c_storageIcEE'] = 230840;
Module['__ZTINSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 231084;
Module['__ZTSNSt3__28time_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 230972;
Module['__ZTSNSt3__220__time_get_c_storageIwEE'] = 231041;
Module['__ZTINSt3__220__time_get_c_storageIwEE'] = 231076;
Module['__ZTINSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 231388;
Module['__ZTSNSt3__215time_get_bynameIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 231236;
Module['__ZTSNSt3__218__time_get_storageIcEE'] = 231313;
Module['__ZTSNSt3__210__time_getE'] = 231345;
Module['__ZTINSt3__210__time_getE'] = 231368;
Module['__ZTINSt3__218__time_get_storageIcEE'] = 231376;
Module['__ZTINSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 231656;
Module['__ZTSNSt3__215time_get_bynameIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 231532;
Module['__ZTSNSt3__218__time_get_storageIwEE'] = 231609;
Module['__ZTINSt3__218__time_get_storageIwEE'] = 231644;
Module['__ZTINSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 231812;
Module['__ZTSNSt3__28time_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 231712;
Module['__ZTSNSt3__210__time_putE'] = 231781;
Module['__ZTINSt3__210__time_putE'] = 231804;
Module['__ZTINSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 231940;
Module['__ZTSNSt3__28time_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 231868;
Module['__ZTINSt3__215time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 232076;
Module['__ZTSNSt3__215time_put_bynameIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 231996;
Module['__ZTINSt3__215time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 232192;
Module['__ZTSNSt3__215time_put_bynameIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 232112;
Module['__ZTINSt3__210moneypunctIcLb0EEE'] = 232320;
Module['__ZTSNSt3__210moneypunctIcLb0EEE'] = 232260;
Module['__ZTSNSt3__210money_baseE'] = 232288;
Module['__ZTINSt3__210money_baseE'] = 232312;
Module['__ZTINSt3__210moneypunctIcLb1EEE'] = 232436;
Module['__ZTSNSt3__210moneypunctIcLb1EEE'] = 232408;
Module['__ZTINSt3__210moneypunctIwLb0EEE'] = 232552;
Module['__ZTSNSt3__210moneypunctIwLb0EEE'] = 232524;
Module['__ZTINSt3__210moneypunctIwLb1EEE'] = 232668;
Module['__ZTSNSt3__210moneypunctIwLb1EEE'] = 232640;
Module['__ZTINSt3__217moneypunct_bynameIcLb0EEE'] = 232792;
Module['__ZTSNSt3__217moneypunct_bynameIcLb0EEE'] = 232756;
Module['__ZTINSt3__217moneypunct_bynameIcLb1EEE'] = 232896;
Module['__ZTSNSt3__217moneypunct_bynameIcLb1EEE'] = 232860;
Module['__ZTINSt3__217moneypunct_bynameIwLb0EEE'] = 233000;
Module['__ZTSNSt3__217moneypunct_bynameIwLb0EEE'] = 232964;
Module['__ZTINSt3__217moneypunct_bynameIwLb1EEE'] = 233104;
Module['__ZTSNSt3__217moneypunct_bynameIwLb1EEE'] = 233068;
Module['__ZTINSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 233248;
Module['__ZTSNSt3__29money_getIcNS_19istreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 233144;
Module['__ZTSNSt3__211__money_getIcEE'] = 233214;
Module['__ZTINSt3__211__money_getIcEE'] = 233240;
Module['__ZTINSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 233412;
Module['__ZTSNSt3__29money_getIwNS_19istreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 233308;
Module['__ZTSNSt3__211__money_getIwEE'] = 233378;
Module['__ZTINSt3__211__money_getIwEE'] = 233404;
Module['__ZTINSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 233576;
Module['__ZTSNSt3__29money_putIcNS_19ostreambuf_iteratorIcNS_11char_traitsIcEEEEEE'] = 233472;
Module['__ZTSNSt3__211__money_putIcEE'] = 233542;
Module['__ZTINSt3__211__money_putIcEE'] = 233568;
Module['__ZTINSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 233740;
Module['__ZTSNSt3__29money_putIwNS_19ostreambuf_iteratorIwNS_11char_traitsIwEEEEEE'] = 233636;
Module['__ZTSNSt3__211__money_putIwEE'] = 233706;
Module['__ZTINSt3__211__money_putIwEE'] = 233732;
Module['__ZTINSt3__28messagesIcEE'] = 233860;
Module['__ZTSNSt3__28messagesIcEE'] = 233804;
Module['__ZTSNSt3__213messages_baseE'] = 233825;
Module['__ZTINSt3__213messages_baseE'] = 233852;
Module['__ZTINSt3__28messagesIwEE'] = 233948;
Module['__ZTSNSt3__28messagesIwEE'] = 233924;
Module['__ZTINSt3__215messages_bynameIcEE'] = 234044;
Module['__ZTSNSt3__215messages_bynameIcEE'] = 234012;
Module['__ZTINSt3__215messages_bynameIwEE'] = 234120;
Module['__ZTSNSt3__215messages_bynameIwEE'] = 234088;
Module['__ZTINSt3__214codecvt_bynameIcc11__mbstate_tEE'] = 234224;
Module['__ZTSNSt3__214codecvt_bynameIcc11__mbstate_tEE'] = 234180;
Module['__ZTINSt3__214codecvt_bynameIwc11__mbstate_tEE'] = 234328;
Module['__ZTSNSt3__214codecvt_bynameIwc11__mbstate_tEE'] = 234284;
Module['__ZTINSt3__214codecvt_bynameIDsc11__mbstate_tEE'] = 234432;
Module['__ZTSNSt3__214codecvt_bynameIDsc11__mbstate_tEE'] = 234388;
Module['__ZTINSt3__214codecvt_bynameIDic11__mbstate_tEE'] = 234536;
Module['__ZTSNSt3__214codecvt_bynameIDic11__mbstate_tEE'] = 234492;
Module['__ZTINSt3__215__time_get_tempIcEE'] = 235884;
Module['__ZTSNSt3__215__time_get_tempIcEE'] = 235852;
Module['__ZTINSt3__215__time_get_tempIwEE'] = 235996;
Module['__ZTSNSt3__215__time_get_tempIwEE'] = 235964;
Module['__ZNSt3__213allocator_argE'] = 236008;
Module['__ZTSNSt3__214__shared_countE'] = 236044;
Module['__ZTVNSt3__219__shared_weak_countE'] = 236080;
Module['__ZTINSt3__219__shared_weak_countE'] = 236140;
Module['__ZTSNSt3__219__shared_weak_countE'] = 236108;
Module['__ZTVNSt3__212bad_weak_ptrE'] = 236164;
Module['__ZTINSt3__212bad_weak_ptrE'] = 236208;
Module['__ZTSNSt3__212bad_weak_ptrE'] = 236184;
Module['__ZNSt3__210defer_lockE'] = 236220;
Module['__ZNSt3__211try_to_lockE'] = 236221;
Module['__ZNSt3__210adopt_lockE'] = 236222;
Module['__ZSt7nothrow'] = 236345;
Module['__ZTVSt19bad_optional_access'] = 236368;
Module['__ZTISt19bad_optional_access'] = 236412;
Module['__ZTSSt19bad_optional_access'] = 236388;
Module['__ZTVNSt12experimental19bad_optional_accessE'] = 236424;
Module['__ZTINSt12experimental19bad_optional_accessE'] = 236484;
Module['__ZTSNSt12experimental19bad_optional_accessE'] = 236444;
Module['__ZTVNSt3__211regex_errorE'] = 236588;
Module['__ZTINSt3__211regex_errorE'] = 237648;
Module['__ZTSNSt3__211regex_errorE'] = 237624;
Module['__ZTISt13runtime_error'] = 255120;
Module['__ZTVSt11logic_error'] = 254784;
Module['__ZTVSt9exception'] = 254620;
Module['__ZTVSt13runtime_error'] = 254804;
Module['__ZNSt3__212basic_stringIcNS_11char_traitsIcEENS_9allocatorIcEEE4nposE'] = 239604;
Module['__ZNSt3__212basic_stringIwNS_11char_traitsIwEENS_9allocatorIwEEE4nposE'] = 239608;
Module['__ZTVNSt3__212strstreambufE'] = 239968;
Module['__ZTTNSt3__210istrstreamE'] = 240072;
Module['__ZTTNSt3__210ostrstreamE'] = 240128;
Module['__ZTTNSt3__29strstreamE'] = 240204;
Module['__ZTINSt3__212strstreambufE'] = 240268;
Module['__ZTVNSt3__210istrstreamE'] = 240032;
Module['__ZTINSt3__210istrstreamE'] = 240344;
Module['__ZTCNSt3__210istrstreamE0_NS_13basic_istreamIcNS_11char_traitsIcEEEE'] = 240280;
Module['__ZTVNSt3__210ostrstreamE'] = 240088;
Module['__ZTINSt3__210ostrstreamE'] = 240420;
Module['__ZTCNSt3__210ostrstreamE0_NS_13basic_ostreamIcNS_11char_traitsIcEEEE'] = 240356;
Module['__ZTVNSt3__29strstreamE'] = 240144;
Module['__ZTINSt3__29strstreamE'] = 240592;
Module['__ZTCNSt3__29strstreamE0_NS_14basic_iostreamIcNS_11char_traitsIcEEEE'] = 240432;
Module['__ZTCNSt3__29strstreamE0_NS_13basic_istreamIcNS_11char_traitsIcEEEE'] = 240492;
Module['__ZTCNSt3__29strstreamE8_NS_13basic_ostreamIcNS_11char_traitsIcEEEE'] = 240532;
Module['__ZTSNSt3__212strstreambufE'] = 240244;
Module['__ZTSNSt3__210istrstreamE'] = 240320;
Module['__ZTSNSt3__210ostrstreamE'] = 240396;
Module['__ZTSNSt3__29strstreamE'] = 240572;
Module['__ZTVNSt3__212system_errorE'] = 240768;
Module['__ZTVNSt3__224__generic_error_categoryE'] = 240648;
Module['__ZTINSt3__224__generic_error_categoryE'] = 240972;
Module['__ZTVNSt3__223__system_error_categoryE'] = 240728;
Module['__ZTINSt3__223__system_error_categoryE'] = 241020;
Module['__ZTVNSt3__214error_categoryE'] = 240792;
Module['__ZTINSt3__214error_categoryE'] = 240856;
Module['__ZTSNSt3__214error_categoryE'] = 240828;
Module['__ZTVNSt3__212__do_messageE'] = 240864;
Module['__ZTSNSt3__212__do_messageE'] = 240900;
Module['__ZTSNSt3__224__generic_error_categoryE'] = 240936;
Module['__ZTSNSt3__223__system_error_categoryE'] = 240984;
Module['__ZTSNSt3__212system_errorE'] = 241032;
Module['__ZNSt3__219piecewise_constructE'] = 241169;
Module['__ZTVSt18bad_variant_access'] = 241192;
Module['__ZTISt18bad_variant_access'] = 241236;
Module['__ZTSSt18bad_variant_access'] = 241212;
Module['__ZTVNSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_impE'] = 241256;
Module['__ZTINSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_impE'] = 241452;
Module['__ZTVNSt12experimental15fundamentals_v13pmr26__null_memory_resource_impE'] = 241284;
Module['__ZTINSt12experimental15fundamentals_v13pmr26__null_memory_resource_impE'] = 241532;
Module['__ZTSNSt12experimental15fundamentals_v13pmr32__new_delete_memory_resource_impE'] = 241312;
Module['__ZTSNSt12experimental15fundamentals_v13pmr15memory_resourceE'] = 241386;
Module['__ZTINSt12experimental15fundamentals_v13pmr15memory_resourceE'] = 241444;
Module['__ZTSNSt12experimental15fundamentals_v13pmr26__null_memory_resource_impE'] = 241464;
Module['__ZTVNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEE'] = 241812;
Module['__ZTVNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEEE'] = 241948;
Module['__ZTINSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEE'] = 241928;
Module['__ZTSNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem12__dir_streamENS_9allocatorIS3_EEEE'] = 241840;
Module['__ZTINSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEEE'] = 242096;
Module['__ZTSNSt3__220__shared_ptr_emplaceINS_4__fs10filesystem28recursive_directory_iterator12__shared_impENS_9allocatorIS4_EEEE'] = 241976;
Module['__ZTVNSt3__24__fs10filesystem16filesystem_errorE'] = 242148;
Module['__ZTVNSt3__214basic_ifstreamIcNS_11char_traitsIcEEEE'] = 242920;
Module['__ZTTNSt3__214basic_ifstreamIcNS_11char_traitsIcEEEE'] = 242960;
Module['__ZTVNSt3__214basic_ofstreamIcNS_11char_traitsIcEEEE'] = 243236;
Module['__ZTTNSt3__214basic_ofstreamIcNS_11char_traitsIcEEEE'] = 243276;
Module['__ZTVNSt3__213basic_filebufIcNS_11char_traitsIcEEEE'] = 243076;
Module['__ZNSt3__24__fs10filesystem16_FilesystemClock9is_steadyE'] = 242108;
Module['__ZTINSt3__24__fs10filesystem16filesystem_errorE'] = 242684;
Module['__ZNSt3__24__fs10filesystem4path19preferred_separatorE'] = 242636;
Module['__ZTSNSt3__24__fs10filesystem16filesystem_errorE'] = 242640;
Module['__ZTINSt3__214basic_ifstreamIcNS_11char_traitsIcEEEE'] = 243064;
Module['__ZTCNSt3__214basic_ifstreamIcNS_11char_traitsIcEEEE0_NS_13basic_istreamIcS2_EE'] = 242976;
Module['__ZTSNSt3__214basic_ifstreamIcNS_11char_traitsIcEEEE'] = 243016;
Module['__ZTINSt3__213basic_filebufIcNS_11char_traitsIcEEEE'] = 243188;
Module['__ZTSNSt3__213basic_filebufIcNS_11char_traitsIcEEEE'] = 243140;
Module['__ZTINSt3__214basic_ofstreamIcNS_11char_traitsIcEEEE'] = 243380;
Module['__ZTCNSt3__214basic_ofstreamIcNS_11char_traitsIcEEEE0_NS_13basic_ostreamIcS2_EE'] = 243292;
Module['__ZTSNSt3__214basic_ofstreamIcNS_11char_traitsIcEEEE'] = 243332;
Module['___cxa_unexpected_handler'] = 263180;
Module['___cxa_terminate_handler'] = 263176;
Module['___cxa_new_handler'] = 284132;
Module['__ZTVSt9bad_alloc'] = 254540;
Module['__ZTVSt20bad_array_new_length'] = 254576;
Module['__ZTISt9bad_alloc'] = 254732;
Module['__ZTISt20bad_array_new_length'] = 254772;
Module['__ZTSSt9exception'] = 254640;
Module['__ZTVSt13bad_exception'] = 254664;
Module['__ZTISt13bad_exception'] = 254704;
Module['__ZTSSt13bad_exception'] = 254684;
Module['__ZTSSt9bad_alloc'] = 254716;
Module['__ZTSSt20bad_array_new_length'] = 254744;
Module['__ZTVSt12domain_error'] = 254824;
Module['__ZTISt12domain_error'] = 254892;
Module['__ZTSSt12domain_error'] = 254844;
Module['__ZTSSt11logic_error'] = 254861;
Module['__ZTVSt16invalid_argument'] = 254904;
Module['__ZTISt16invalid_argument'] = 254948;
Module['__ZTSSt16invalid_argument'] = 254924;
Module['__ZTVSt12length_error'] = 254960;
Module['__ZTISt12length_error'] = 255000;
Module['__ZTSSt12length_error'] = 254980;
Module['__ZTVSt12out_of_range'] = 255012;
Module['__ZTISt12out_of_range'] = 255052;
Module['__ZTSSt12out_of_range'] = 255032;
Module['__ZTVSt11range_error'] = 255064;
Module['__ZTISt11range_error'] = 255132;
Module['__ZTSSt11range_error'] = 255084;
Module['__ZTSSt13runtime_error'] = 255100;
Module['__ZTVSt14overflow_error'] = 255144;
Module['__ZTISt14overflow_error'] = 255184;
Module['__ZTSSt14overflow_error'] = 255164;
Module['__ZTVSt15underflow_error'] = 255196;
Module['__ZTISt15underflow_error'] = 255236;
Module['__ZTSSt15underflow_error'] = 255216;
Module['__ZTVSt8bad_cast'] = 255248;
Module['__ZTVSt10bad_typeid'] = 255284;
Module['__ZTISt10bad_typeid'] = 255400;
Module['__ZTVSt9type_info'] = 255320;
Module['__ZTISt9type_info'] = 255352;
Module['__ZTSSt9type_info'] = 255336;
Module['__ZTSSt8bad_cast'] = 255360;
Module['__ZTSSt10bad_typeid'] = 255384;
Module['__ZTIN10__cxxabiv116__shim_type_infoE'] = 255448;
Module['__ZTIN10__cxxabiv117__class_type_infoE'] = 255496;
Module['__ZTIN10__cxxabiv117__pbase_type_infoE'] = 255544;
Module['__ZTIDn'] = 255892;
Module['__ZTIN10__cxxabiv119__pointer_type_infoE'] = 255592;
Module['__ZTIv'] = 255840;
Module['__ZTIN10__cxxabiv120__function_type_infoE'] = 255644;
Module['__ZTIN10__cxxabiv129__pointer_to_member_type_infoE'] = 255704;
Module['__ZTSN10__cxxabiv116__shim_type_infoE'] = 255412;
Module['__ZTSN10__cxxabiv117__class_type_infoE'] = 255460;
Module['__ZTSN10__cxxabiv117__pbase_type_infoE'] = 255508;
Module['__ZTSN10__cxxabiv119__pointer_type_infoE'] = 255556;
Module['__ZTSN10__cxxabiv120__function_type_infoE'] = 255604;
Module['__ZTSN10__cxxabiv129__pointer_to_member_type_infoE'] = 255656;
Module['__ZTVN10__cxxabiv116__shim_type_infoE'] = 255728;
Module['__ZTVN10__cxxabiv123__fundamental_type_infoE'] = 255756;
Module['__ZTIN10__cxxabiv123__fundamental_type_infoE'] = 255824;
Module['__ZTSN10__cxxabiv123__fundamental_type_infoE'] = 255784;
Module['__ZTSv'] = 255836;
Module['__ZTSPv'] = 255848;
Module['__ZTIPv'] = 255852;
Module['__ZTVN10__cxxabiv119__pointer_type_infoE'] = 257588;
Module['__ZTSPKv'] = 255868;
Module['__ZTIPKv'] = 255872;
Module['__ZTSDn'] = 255888;
Module['__ZTSPDn'] = 255900;
Module['__ZTIPDn'] = 255904;
Module['__ZTSPKDn'] = 255920;
Module['__ZTIPKDn'] = 255928;
Module['__ZTSb'] = 255944;
Module['__ZTIb'] = 255948;
Module['__ZTSPb'] = 255956;
Module['__ZTIPb'] = 255960;
Module['__ZTSPKb'] = 255976;
Module['__ZTIPKb'] = 255980;
Module['__ZTSw'] = 255996;
Module['__ZTIw'] = 256000;
Module['__ZTSPw'] = 256008;
Module['__ZTIPw'] = 256012;
Module['__ZTSPKw'] = 256028;
Module['__ZTIPKw'] = 256032;
Module['__ZTSc'] = 256048;
Module['__ZTIc'] = 256052;
Module['__ZTSPc'] = 256060;
Module['__ZTIPc'] = 256064;
Module['__ZTSPKc'] = 256080;
Module['__ZTIPKc'] = 256084;
Module['__ZTSh'] = 256100;
Module['__ZTIh'] = 256104;
Module['__ZTSPh'] = 256112;
Module['__ZTIPh'] = 256116;
Module['__ZTSPKh'] = 256132;
Module['__ZTIPKh'] = 256136;
Module['__ZTSa'] = 256152;
Module['__ZTIa'] = 256156;
Module['__ZTSPa'] = 256164;
Module['__ZTIPa'] = 256168;
Module['__ZTSPKa'] = 256184;
Module['__ZTIPKa'] = 256188;
Module['__ZTSs'] = 256204;
Module['__ZTIs'] = 256208;
Module['__ZTSPs'] = 256216;
Module['__ZTIPs'] = 256220;
Module['__ZTSPKs'] = 256236;
Module['__ZTIPKs'] = 256240;
Module['__ZTSt'] = 256256;
Module['__ZTIt'] = 256260;
Module['__ZTSPt'] = 256268;
Module['__ZTIPt'] = 256272;
Module['__ZTSPKt'] = 256288;
Module['__ZTIPKt'] = 256292;
Module['__ZTSi'] = 256308;
Module['__ZTIi'] = 256312;
Module['__ZTSPi'] = 256320;
Module['__ZTIPi'] = 256324;
Module['__ZTSPKi'] = 256340;
Module['__ZTIPKi'] = 256344;
Module['__ZTSj'] = 256360;
Module['__ZTIj'] = 256364;
Module['__ZTSPj'] = 256372;
Module['__ZTIPj'] = 256376;
Module['__ZTSPKj'] = 256392;
Module['__ZTIPKj'] = 256396;
Module['__ZTSl'] = 256412;
Module['__ZTIl'] = 256416;
Module['__ZTSPl'] = 256424;
Module['__ZTIPl'] = 256428;
Module['__ZTSPKl'] = 256444;
Module['__ZTIPKl'] = 256448;
Module['__ZTSm'] = 256464;
Module['__ZTIm'] = 256468;
Module['__ZTSPm'] = 256476;
Module['__ZTIPm'] = 256480;
Module['__ZTSPKm'] = 256496;
Module['__ZTIPKm'] = 256500;
Module['__ZTSx'] = 256516;
Module['__ZTIx'] = 256520;
Module['__ZTSPx'] = 256528;
Module['__ZTIPx'] = 256532;
Module['__ZTSPKx'] = 256548;
Module['__ZTIPKx'] = 256552;
Module['__ZTSy'] = 256568;
Module['__ZTIy'] = 256572;
Module['__ZTSPy'] = 256580;
Module['__ZTIPy'] = 256584;
Module['__ZTSPKy'] = 256600;
Module['__ZTIPKy'] = 256604;
Module['__ZTSn'] = 256620;
Module['__ZTIn'] = 256624;
Module['__ZTSPn'] = 256632;
Module['__ZTIPn'] = 256636;
Module['__ZTSPKn'] = 256652;
Module['__ZTIPKn'] = 256656;
Module['__ZTSo'] = 256672;
Module['__ZTIo'] = 256676;
Module['__ZTSPo'] = 256684;
Module['__ZTIPo'] = 256688;
Module['__ZTSPKo'] = 256704;
Module['__ZTIPKo'] = 256708;
Module['__ZTSDh'] = 256724;
Module['__ZTIDh'] = 256728;
Module['__ZTSPDh'] = 256736;
Module['__ZTIPDh'] = 256740;
Module['__ZTSPKDh'] = 256756;
Module['__ZTIPKDh'] = 256764;
Module['__ZTSf'] = 256780;
Module['__ZTIf'] = 256784;
Module['__ZTSPf'] = 256792;
Module['__ZTIPf'] = 256796;
Module['__ZTSPKf'] = 256812;
Module['__ZTIPKf'] = 256816;
Module['__ZTSd'] = 256832;
Module['__ZTId'] = 256836;
Module['__ZTSPd'] = 256844;
Module['__ZTIPd'] = 256848;
Module['__ZTSPKd'] = 256864;
Module['__ZTIPKd'] = 256868;
Module['__ZTSe'] = 256884;
Module['__ZTIe'] = 256888;
Module['__ZTSPe'] = 256896;
Module['__ZTIPe'] = 256900;
Module['__ZTSPKe'] = 256916;
Module['__ZTIPKe'] = 256920;
Module['__ZTSg'] = 256936;
Module['__ZTIg'] = 256940;
Module['__ZTSPg'] = 256948;
Module['__ZTIPg'] = 256952;
Module['__ZTSPKg'] = 256968;
Module['__ZTIPKg'] = 256972;
Module['__ZTSDu'] = 256988;
Module['__ZTIDu'] = 256992;
Module['__ZTSPDu'] = 257000;
Module['__ZTIPDu'] = 257004;
Module['__ZTSPKDu'] = 257020;
Module['__ZTIPKDu'] = 257028;
Module['__ZTSDs'] = 257044;
Module['__ZTIDs'] = 257048;
Module['__ZTSPDs'] = 257056;
Module['__ZTIPDs'] = 257060;
Module['__ZTSPKDs'] = 257076;
Module['__ZTIPKDs'] = 257084;
Module['__ZTSDi'] = 257100;
Module['__ZTIDi'] = 257104;
Module['__ZTSPDi'] = 257112;
Module['__ZTIPDi'] = 257116;
Module['__ZTSPKDi'] = 257132;
Module['__ZTIPKDi'] = 257140;
Module['__ZTVN10__cxxabiv117__array_type_infoE'] = 257156;
Module['__ZTIN10__cxxabiv117__array_type_infoE'] = 257220;
Module['__ZTSN10__cxxabiv117__array_type_infoE'] = 257184;
Module['__ZTVN10__cxxabiv120__function_type_infoE'] = 257232;
Module['__ZTVN10__cxxabiv116__enum_type_infoE'] = 257260;
Module['__ZTIN10__cxxabiv116__enum_type_infoE'] = 257324;
Module['__ZTSN10__cxxabiv116__enum_type_infoE'] = 257288;
Module['__ZTIN10__cxxabiv120__si_class_type_infoE'] = 257456;
Module['__ZTSN10__cxxabiv120__si_class_type_infoE'] = 257416;
Module['__ZTIN10__cxxabiv121__vmi_class_type_infoE'] = 257548;
Module['__ZTSN10__cxxabiv121__vmi_class_type_infoE'] = 257508;
Module['__ZTVN10__cxxabiv117__pbase_type_infoE'] = 257560;
Module['__ZTVN10__cxxabiv129__pointer_to_member_type_infoE'] = 257616;
Module['___global_base'] = 1024;
Module['___heap_base'] = 5528032;
Module['___memory_base'] = 0;
Module['___table_base'] = 1;



// === Auto-generated postamble setup entry stuff ===


if (!Object.getOwnPropertyDescriptor(Module, "intArrayFromString")) Module["intArrayFromString"] = function() { abort("'intArrayFromString' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "intArrayToString")) Module["intArrayToString"] = function() { abort("'intArrayToString' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "ccall")) Module["ccall"] = function() { abort("'ccall' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
Module["cwrap"] = cwrap;
Module["setValue"] = setValue;
Module["getValue"] = getValue;
if (!Object.getOwnPropertyDescriptor(Module, "allocate")) Module["allocate"] = function() { abort("'allocate' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "getMemory")) Module["getMemory"] = function() { abort("'getMemory' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you") };
if (!Object.getOwnPropertyDescriptor(Module, "UTF8ArrayToString")) Module["UTF8ArrayToString"] = function() { abort("'UTF8ArrayToString' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "UTF8ToString")) Module["UTF8ToString"] = function() { abort("'UTF8ToString' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "stringToUTF8Array")) Module["stringToUTF8Array"] = function() { abort("'stringToUTF8Array' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "stringToUTF8")) Module["stringToUTF8"] = function() { abort("'stringToUTF8' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "lengthBytesUTF8")) Module["lengthBytesUTF8"] = function() { abort("'lengthBytesUTF8' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "stackTrace")) Module["stackTrace"] = function() { abort("'stackTrace' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "addOnPreRun")) Module["addOnPreRun"] = function() { abort("'addOnPreRun' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "addOnInit")) Module["addOnInit"] = function() { abort("'addOnInit' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "addOnPreMain")) Module["addOnPreMain"] = function() { abort("'addOnPreMain' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "addOnExit")) Module["addOnExit"] = function() { abort("'addOnExit' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "addOnPostRun")) Module["addOnPostRun"] = function() { abort("'addOnPostRun' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "writeStringToMemory")) Module["writeStringToMemory"] = function() { abort("'writeStringToMemory' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "writeArrayToMemory")) Module["writeArrayToMemory"] = function() { abort("'writeArrayToMemory' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "writeAsciiToMemory")) Module["writeAsciiToMemory"] = function() { abort("'writeAsciiToMemory' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "addRunDependency")) Module["addRunDependency"] = function() { abort("'addRunDependency' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you") };
if (!Object.getOwnPropertyDescriptor(Module, "removeRunDependency")) Module["removeRunDependency"] = function() { abort("'removeRunDependency' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you") };
if (!Object.getOwnPropertyDescriptor(Module, "FS_createFolder")) Module["FS_createFolder"] = function() { abort("'FS_createFolder' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you") };
if (!Object.getOwnPropertyDescriptor(Module, "FS_createPath")) Module["FS_createPath"] = function() { abort("'FS_createPath' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you") };
if (!Object.getOwnPropertyDescriptor(Module, "FS_createDataFile")) Module["FS_createDataFile"] = function() { abort("'FS_createDataFile' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you") };
if (!Object.getOwnPropertyDescriptor(Module, "FS_createPreloadedFile")) Module["FS_createPreloadedFile"] = function() { abort("'FS_createPreloadedFile' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you") };
if (!Object.getOwnPropertyDescriptor(Module, "FS_createLazyFile")) Module["FS_createLazyFile"] = function() { abort("'FS_createLazyFile' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you") };
if (!Object.getOwnPropertyDescriptor(Module, "FS_createLink")) Module["FS_createLink"] = function() { abort("'FS_createLink' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you") };
if (!Object.getOwnPropertyDescriptor(Module, "FS_createDevice")) Module["FS_createDevice"] = function() { abort("'FS_createDevice' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you") };
if (!Object.getOwnPropertyDescriptor(Module, "FS_unlink")) Module["FS_unlink"] = function() { abort("'FS_unlink' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you") };
if (!Object.getOwnPropertyDescriptor(Module, "dynamicAlloc")) Module["dynamicAlloc"] = function() { abort("'dynamicAlloc' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "loadDynamicLibrary")) Module["loadDynamicLibrary"] = function() { abort("'loadDynamicLibrary' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "loadWebAssemblyModule")) Module["loadWebAssemblyModule"] = function() { abort("'loadWebAssemblyModule' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "getLEB")) Module["getLEB"] = function() { abort("'getLEB' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "getFunctionTables")) Module["getFunctionTables"] = function() { abort("'getFunctionTables' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "alignFunctionTables")) Module["alignFunctionTables"] = function() { abort("'alignFunctionTables' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "registerFunctions")) Module["registerFunctions"] = function() { abort("'registerFunctions' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "addFunction")) Module["addFunction"] = function() { abort("'addFunction' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "removeFunction")) Module["removeFunction"] = function() { abort("'removeFunction' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "getFuncWrapper")) Module["getFuncWrapper"] = function() { abort("'getFuncWrapper' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "prettyPrint")) Module["prettyPrint"] = function() { abort("'prettyPrint' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "makeBigInt")) Module["makeBigInt"] = function() { abort("'makeBigInt' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "dynCall")) Module["dynCall"] = function() { abort("'dynCall' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "getCompilerSetting")) Module["getCompilerSetting"] = function() { abort("'getCompilerSetting' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "print")) Module["print"] = function() { abort("'print' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "printErr")) Module["printErr"] = function() { abort("'printErr' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "getTempRet0")) Module["getTempRet0"] = function() { abort("'getTempRet0' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "setTempRet0")) Module["setTempRet0"] = function() { abort("'setTempRet0' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "callMain")) Module["callMain"] = function() { abort("'callMain' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "abort")) Module["abort"] = function() { abort("'abort' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "stringToNewUTF8")) Module["stringToNewUTF8"] = function() { abort("'stringToNewUTF8' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "emscripten_realloc_buffer")) Module["emscripten_realloc_buffer"] = function() { abort("'emscripten_realloc_buffer' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "ENV")) Module["ENV"] = function() { abort("'ENV' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "ERRNO_CODES")) Module["ERRNO_CODES"] = function() { abort("'ERRNO_CODES' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "ERRNO_MESSAGES")) Module["ERRNO_MESSAGES"] = function() { abort("'ERRNO_MESSAGES' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "setErrNo")) Module["setErrNo"] = function() { abort("'setErrNo' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "DNS")) Module["DNS"] = function() { abort("'DNS' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "GAI_ERRNO_MESSAGES")) Module["GAI_ERRNO_MESSAGES"] = function() { abort("'GAI_ERRNO_MESSAGES' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "Protocols")) Module["Protocols"] = function() { abort("'Protocols' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "Sockets")) Module["Sockets"] = function() { abort("'Sockets' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "UNWIND_CACHE")) Module["UNWIND_CACHE"] = function() { abort("'UNWIND_CACHE' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "readAsmConstArgs")) Module["readAsmConstArgs"] = function() { abort("'readAsmConstArgs' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "jstoi_q")) Module["jstoi_q"] = function() { abort("'jstoi_q' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "jstoi_s")) Module["jstoi_s"] = function() { abort("'jstoi_s' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "listenOnce")) Module["listenOnce"] = function() { abort("'listenOnce' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "autoResumeAudioContext")) Module["autoResumeAudioContext"] = function() { abort("'autoResumeAudioContext' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "abortStackOverflow")) Module["abortStackOverflow"] = function() { abort("'abortStackOverflow' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "reallyNegative")) Module["reallyNegative"] = function() { abort("'reallyNegative' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "formatString")) Module["formatString"] = function() { abort("'formatString' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "PATH")) Module["PATH"] = function() { abort("'PATH' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "PATH_FS")) Module["PATH_FS"] = function() { abort("'PATH_FS' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "SYSCALLS")) Module["SYSCALLS"] = function() { abort("'SYSCALLS' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "syscallMmap2")) Module["syscallMmap2"] = function() { abort("'syscallMmap2' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "syscallMunmap")) Module["syscallMunmap"] = function() { abort("'syscallMunmap' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "JSEvents")) Module["JSEvents"] = function() { abort("'JSEvents' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "specialHTMLTargets")) Module["specialHTMLTargets"] = function() { abort("'specialHTMLTargets' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "demangle")) Module["demangle"] = function() { abort("'demangle' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "demangleAll")) Module["demangleAll"] = function() { abort("'demangleAll' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "jsStackTrace")) Module["jsStackTrace"] = function() { abort("'jsStackTrace' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "stackTrace")) Module["stackTrace"] = function() { abort("'stackTrace' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "getEnvStrings")) Module["getEnvStrings"] = function() { abort("'getEnvStrings' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "checkWasiClock")) Module["checkWasiClock"] = function() { abort("'checkWasiClock' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "writeI53ToI64")) Module["writeI53ToI64"] = function() { abort("'writeI53ToI64' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "writeI53ToI64Clamped")) Module["writeI53ToI64Clamped"] = function() { abort("'writeI53ToI64Clamped' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "writeI53ToI64Signaling")) Module["writeI53ToI64Signaling"] = function() { abort("'writeI53ToI64Signaling' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "writeI53ToU64Clamped")) Module["writeI53ToU64Clamped"] = function() { abort("'writeI53ToU64Clamped' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "writeI53ToU64Signaling")) Module["writeI53ToU64Signaling"] = function() { abort("'writeI53ToU64Signaling' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "readI53FromI64")) Module["readI53FromI64"] = function() { abort("'readI53FromI64' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "readI53FromU64")) Module["readI53FromU64"] = function() { abort("'readI53FromU64' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "convertI32PairToI53")) Module["convertI32PairToI53"] = function() { abort("'convertI32PairToI53' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "convertU32PairToI53")) Module["convertU32PairToI53"] = function() { abort("'convertU32PairToI53' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "Browser")) Module["Browser"] = function() { abort("'Browser' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "FS")) Module["FS"] = function() { abort("'FS' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "MEMFS")) Module["MEMFS"] = function() { abort("'MEMFS' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "TTY")) Module["TTY"] = function() { abort("'TTY' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "PIPEFS")) Module["PIPEFS"] = function() { abort("'PIPEFS' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "SOCKFS")) Module["SOCKFS"] = function() { abort("'SOCKFS' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "GL")) Module["GL"] = function() { abort("'GL' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "emscriptenWebGLGet")) Module["emscriptenWebGLGet"] = function() { abort("'emscriptenWebGLGet' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "emscriptenWebGLGetTexPixelData")) Module["emscriptenWebGLGetTexPixelData"] = function() { abort("'emscriptenWebGLGetTexPixelData' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "emscriptenWebGLGetUniform")) Module["emscriptenWebGLGetUniform"] = function() { abort("'emscriptenWebGLGetUniform' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "emscriptenWebGLGetVertexAttrib")) Module["emscriptenWebGLGetVertexAttrib"] = function() { abort("'emscriptenWebGLGetVertexAttrib' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "writeGLArray")) Module["writeGLArray"] = function() { abort("'writeGLArray' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "AL")) Module["AL"] = function() { abort("'AL' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "SDL_unicode")) Module["SDL_unicode"] = function() { abort("'SDL_unicode' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "SDL_ttfContext")) Module["SDL_ttfContext"] = function() { abort("'SDL_ttfContext' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "SDL_audio")) Module["SDL_audio"] = function() { abort("'SDL_audio' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "SDL")) Module["SDL"] = function() { abort("'SDL' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "SDL_gfx")) Module["SDL_gfx"] = function() { abort("'SDL_gfx' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "GLUT")) Module["GLUT"] = function() { abort("'GLUT' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "EGL")) Module["EGL"] = function() { abort("'EGL' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "GLFW_Window")) Module["GLFW_Window"] = function() { abort("'GLFW_Window' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "GLFW")) Module["GLFW"] = function() { abort("'GLFW' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "GLEW")) Module["GLEW"] = function() { abort("'GLEW' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "IDBStore")) Module["IDBStore"] = function() { abort("'IDBStore' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "runAndAbortIfError")) Module["runAndAbortIfError"] = function() { abort("'runAndAbortIfError' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "warnOnce")) Module["warnOnce"] = function() { abort("'warnOnce' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "stackSave")) Module["stackSave"] = function() { abort("'stackSave' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "stackRestore")) Module["stackRestore"] = function() { abort("'stackRestore' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "stackAlloc")) Module["stackAlloc"] = function() { abort("'stackAlloc' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "AsciiToString")) Module["AsciiToString"] = function() { abort("'AsciiToString' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "stringToAscii")) Module["stringToAscii"] = function() { abort("'stringToAscii' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "UTF16ToString")) Module["UTF16ToString"] = function() { abort("'UTF16ToString' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "stringToUTF16")) Module["stringToUTF16"] = function() { abort("'stringToUTF16' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "lengthBytesUTF16")) Module["lengthBytesUTF16"] = function() { abort("'lengthBytesUTF16' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "UTF32ToString")) Module["UTF32ToString"] = function() { abort("'UTF32ToString' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "stringToUTF32")) Module["stringToUTF32"] = function() { abort("'stringToUTF32' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "lengthBytesUTF32")) Module["lengthBytesUTF32"] = function() { abort("'lengthBytesUTF32' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "allocateUTF8")) Module["allocateUTF8"] = function() { abort("'allocateUTF8' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
if (!Object.getOwnPropertyDescriptor(Module, "allocateUTF8OnStack")) Module["allocateUTF8OnStack"] = function() { abort("'allocateUTF8OnStack' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") };
Module["writeStackCookie"] = writeStackCookie;
Module["checkStackCookie"] = checkStackCookie;if (!Object.getOwnPropertyDescriptor(Module, "ALLOC_NORMAL")) Object.defineProperty(Module, "ALLOC_NORMAL", { configurable: true, get: function() { abort("'ALLOC_NORMAL' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") } });
if (!Object.getOwnPropertyDescriptor(Module, "ALLOC_STACK")) Object.defineProperty(Module, "ALLOC_STACK", { configurable: true, get: function() { abort("'ALLOC_STACK' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") } });
if (!Object.getOwnPropertyDescriptor(Module, "ALLOC_DYNAMIC")) Object.defineProperty(Module, "ALLOC_DYNAMIC", { configurable: true, get: function() { abort("'ALLOC_DYNAMIC' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") } });
if (!Object.getOwnPropertyDescriptor(Module, "ALLOC_NONE")) Object.defineProperty(Module, "ALLOC_NONE", { configurable: true, get: function() { abort("'ALLOC_NONE' was not exported. add it to EXTRA_EXPORTED_RUNTIME_METHODS (see the FAQ)") } });



var calledRun;

/**
 * @constructor
 * @this {ExitStatus}
 */
function ExitStatus(status) {
  this.name = "ExitStatus";
  this.message = "Program terminated with exit(" + status + ")";
  this.status = status;
}

var calledMain = false;


dependenciesFulfilled = function runCaller() {
  // If run has never been called, and we should call run (INVOKE_RUN is true, and Module.noInitialRun is not false)
  if (!calledRun) run();
  if (!calledRun) dependenciesFulfilled = runCaller; // try this again later, after new deps are fulfilled
};





/** @type {function(Array=)} */
function run(args) {
  args = args || arguments_;

  if (runDependencies > 0) {
    return;
  }

  writeStackCookie();

  preRun();

  if (runDependencies > 0) return; // a preRun added a dependency, run will be called later

  function doRun() {
    // run may have just been called through dependencies being fulfilled just in this very frame,
    // or while the async setStatus time below was happening
    if (calledRun) return;
    calledRun = true;
    Module['calledRun'] = true;

    if (ABORT) return;

    initRuntime();

    preMain();

    readyPromiseResolve(Module);
    if (Module['onRuntimeInitialized']) Module['onRuntimeInitialized']();

    assert(!Module['_main'], 'compiled without a main, but one is present. if you added it from JS, use Module["onRuntimeInitialized"]');

    postRun();
  }

  if (Module['setStatus']) {
    Module['setStatus']('Running...');
    setTimeout(function() {
      setTimeout(function() {
        Module['setStatus']('');
      }, 1);
      doRun();
    }, 1);
  } else
  {
    doRun();
  }
  checkStackCookie();
}
Module['run'] = run;

function checkUnflushedContent() {
  // Compiler settings do not allow exiting the runtime, so flushing
  // the streams is not possible. but in ASSERTIONS mode we check
  // if there was something to flush, and if so tell the user they
  // should request that the runtime be exitable.
  // Normally we would not even include flush() at all, but in ASSERTIONS
  // builds we do so just for this check, and here we see if there is any
  // content to flush, that is, we check if there would have been
  // something a non-ASSERTIONS build would have not seen.
  // How we flush the streams depends on whether we are in SYSCALLS_REQUIRE_FILESYSTEM=0
  // mode (which has its own special function for this; otherwise, all
  // the code is inside libc)
  var print = out;
  var printErr = err;
  var has = false;
  out = err = function(x) {
    has = true;
  }
  try { // it doesn't matter if it fails
    var flush = Module['_fflush'];
    if (flush) flush(0);
    // also flush in the JS FS layer
    ['stdout', 'stderr'].forEach(function(name) {
      var info = FS.analyzePath('/dev/' + name);
      if (!info) return;
      var stream = info.object;
      var rdev = stream.rdev;
      var tty = TTY.ttys[rdev];
      if (tty && tty.output && tty.output.length) {
        has = true;
      }
    });
  } catch(e) {}
  out = print;
  err = printErr;
  if (has) {
    warnOnce('stdio streams had content in them that was not flushed. you should set EXIT_RUNTIME to 1 (see the FAQ), or make sure to emit a newline when you printf etc.');
  }
}

/** @param {boolean|number=} implicit */
function exit(status, implicit) {
  checkUnflushedContent();

  // if this is just main exit-ing implicitly, and the status is 0, then we
  // don't need to do anything here and can just leave. if the status is
  // non-zero, though, then we need to report it.
  // (we may have warned about this earlier, if a situation justifies doing so)
  if (implicit && noExitRuntime && status === 0) {
    return;
  }

  if (noExitRuntime) {
    // if exit() was called, we may warn the user if the runtime isn't actually being shut down
    if (!implicit) {
      var msg = 'program exited (with status: ' + status + '), but EXIT_RUNTIME is not set, so halting execution but not exiting the runtime or preventing further async execution (build with EXIT_RUNTIME=1, if you want a true shutdown)';
      readyPromiseReject(msg);
    }
  } else {

    ABORT = true;
    EXITSTATUS = status;

    exitRuntime();

    if (Module['onExit']) Module['onExit'](status);
  }

  quit_(status, new ExitStatus(status));
}

if (Module['preInit']) {
  if (typeof Module['preInit'] == 'function') Module['preInit'] = [Module['preInit']];
  while (Module['preInit'].length > 0) {
    Module['preInit'].pop()();
  }
}


  noExitRuntime = true;

run();






// {{MODULE_ADDITIONS}}





  return Module.ready
}
);
})();
if (typeof exports === 'object' && typeof module === 'object')
      module.exports = Module;
    else if (typeof define === 'function' && define['amd'])
      define([], function() { return Module; });
    else if (typeof exports === 'object')
      exports["Module"] = Module;
    